import { defineComponent as ge, reactive as ro, provide as qr, toRef as oo, computed as y, openBlock as c, createElementBlock as p, normalizeClass as S, renderSlot as be, useId as Ke, ref as N, watch as we, nextTick as Pe, onBeforeUnmount as Bt, Fragment as Z, createElementVNode as g, mergeProps as Je, withKeys as je, unref as T, createBlock as te, Teleport as cn, createVNode as ae, Transition as ot, withCtx as pe, toDisplayString as $, createTextVNode as Ze, createCommentVNode as w, useAttrs as ad, withModifiers as Ie, inject as un, onMounted as Qe, resolveDynamicComponent as Wt, createStaticVNode as mo, normalizeStyle as Ae, onUnmounted as nt, renderList as ke, useSlots as ur, Comment as Lf, shallowRef as ld, h as xa, getCurrentInstance as Mf, watchEffect as Ef, markRaw as cg, customRef as fg, withDirectives as Ar, vModelText as dl, createSlots as zn, vModelDynamic as hg, vShow as Af, TransitionGroup as ta, toValue as yt, isRef as Qa, toRefs as vu, resolveComponent as bg } from "vue";
const Df = Symbol("AccordionContext"), _N = /* @__PURE__ */ ge({
  __name: "Accordion",
  props: {
    variant: { default: "default" },
    size: { default: "md" },
    multiple: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ro(/* @__PURE__ */ new Set());
    function r(a) {
      n.has(a) ? n.delete(a) : (t.multiple || n.clear(), n.add(a));
    }
    qr(Df, {
      variant: oo(t, "variant"),
      size: oo(t, "size"),
      openItems: n,
      toggleItem: r
    });
    const o = y(() => {
      switch (t.variant) {
        case "flush":
          return "";
        case "separate-cards":
          return "flex flex-col gap-3";
        default:
          return "border border-(--colors-border-base-soft) rounded-xl overflow-hidden";
      }
    });
    return (a, l) => (c(), p("div", {
      class: S(o.value),
      "data-testid": "accordion"
    }, [
      be(a.$slots, "default")
    ], 2));
  }
}), sd = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"/></svg>', Rf = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"/></svg>', pg = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"/></svg>';
var Nt = "top", tn = "bottom", nn = "right", Vt = "left", id = "auto", ya = [Nt, tn, nn, Vt], ao = "start", na = "end", gg = "clippingParents", Bf = "viewport", wo = "popper", mg = "reference", xu = /* @__PURE__ */ ya.reduce(function(e, t) {
  return e.concat([t + "-" + ao, t + "-" + na]);
}, []), Of = /* @__PURE__ */ [].concat(ya, [id]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ao, t + "-" + na]);
}, []), vg = "beforeRead", xg = "read", yg = "afterRead", kg = "beforeMain", wg = "main", Cg = "afterMain", Sg = "beforeWrite", $g = "write", Ig = "afterWrite", Tg = [vg, xg, yg, kg, wg, Cg, Sg, $g, Ig];
function wn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Gt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Dr(e) {
  var t = Gt(e).Element;
  return e instanceof t || e instanceof Element;
}
function Qt(e) {
  var t = Gt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function dd(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Gt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Lg(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !Qt(a) || !wn(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(l) {
      var s = o[l];
      s === !1 ? a.removeAttribute(l) : a.setAttribute(l, s === !0 ? "" : s);
    }));
  });
}
function Mg(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], a = t.attributes[r] || {}, l = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = l.reduce(function(i, d) {
        return i[d] = "", i;
      }, {});
      !Qt(o) || !wn(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(i) {
        o.removeAttribute(i);
      }));
    });
  };
}
const Eg = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Lg,
  effect: Mg,
  requires: ["computeStyles"]
};
function yn(e) {
  return e.split("-")[0];
}
var Sr = Math.max, ul = Math.min, lo = Math.round;
function hi() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Pf() {
  return !/^((?!chrome|android).)*safari/i.test(hi());
}
function so(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, a = 1;
  t && Qt(e) && (o = e.offsetWidth > 0 && lo(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && lo(r.height) / e.offsetHeight || 1);
  var l = Dr(e) ? Gt(e) : window, s = l.visualViewport, i = !Pf() && n, d = (r.left + (i && s ? s.offsetLeft : 0)) / o, u = (r.top + (i && s ? s.offsetTop : 0)) / a, f = r.width / o, h = r.height / a;
  return {
    width: f,
    height: h,
    top: u,
    right: d + f,
    bottom: u + h,
    left: d,
    x: d,
    y: u
  };
}
function ud(e) {
  var t = so(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function zf(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && dd(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Nn(e) {
  return Gt(e).getComputedStyle(e);
}
function Ag(e) {
  return ["table", "td", "th"].indexOf(wn(e)) >= 0;
}
function cr(e) {
  return ((Dr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ls(e) {
  return wn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (dd(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    cr(e)
  );
}
function yu(e) {
  return !Qt(e) || // https://github.com/popperjs/popper-core/issues/837
  Nn(e).position === "fixed" ? null : e.offsetParent;
}
function Dg(e) {
  var t = /firefox/i.test(hi()), n = /Trident/i.test(hi());
  if (n && Qt(e)) {
    var r = Nn(e);
    if (r.position === "fixed")
      return null;
  }
  var o = ls(e);
  for (dd(o) && (o = o.host); Qt(o) && ["html", "body"].indexOf(wn(o)) < 0; ) {
    var a = Nn(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function ka(e) {
  for (var t = Gt(e), n = yu(e); n && Ag(n) && Nn(n).position === "static"; )
    n = yu(n);
  return n && (wn(n) === "html" || wn(n) === "body" && Nn(n).position === "static") ? t : n || Dg(e) || t;
}
function cd(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Vo(e, t, n) {
  return Sr(e, ul(t, n));
}
function Rg(e, t, n) {
  var r = Vo(e, t, n);
  return r > n ? n : r;
}
function Nf() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Vf(e) {
  return Object.assign({}, Nf(), e);
}
function Ff(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var Bg = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Vf(typeof t != "number" ? t : Ff(t, ya));
};
function Og(e) {
  var t, n = e.state, r = e.name, o = e.options, a = n.elements.arrow, l = n.modifiersData.popperOffsets, s = yn(n.placement), i = cd(s), d = [Vt, nn].indexOf(s) >= 0, u = d ? "height" : "width";
  if (!(!a || !l)) {
    var f = Bg(o.padding, n), h = ud(a), b = i === "y" ? Nt : Vt, m = i === "y" ? tn : nn, v = n.rects.reference[u] + n.rects.reference[i] - l[i] - n.rects.popper[u], x = l[i] - n.rects.reference[i], k = ka(a), L = k ? i === "y" ? k.clientHeight || 0 : k.clientWidth || 0 : 0, P = v / 2 - x / 2, E = f[b], O = L - h[u] - f[m], R = L / 2 - h[u] / 2 + P, V = Vo(E, R, O), J = i;
    n.modifiersData[r] = (t = {}, t[J] = V, t.centerOffset = V - R, t);
  }
}
function Pg(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || zf(t.elements.popper, o) && (t.elements.arrow = o));
}
const zg = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Og,
  effect: Pg,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function io(e) {
  return e.split("-")[1];
}
var Ng = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Vg(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: lo(n * o) / o || 0,
    y: lo(r * o) / o || 0
  };
}
function ku(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, a = e.variation, l = e.offsets, s = e.position, i = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, f = e.isFixed, h = l.x, b = h === void 0 ? 0 : h, m = l.y, v = m === void 0 ? 0 : m, x = typeof u == "function" ? u({
    x: b,
    y: v
  }) : {
    x: b,
    y: v
  };
  b = x.x, v = x.y;
  var k = l.hasOwnProperty("x"), L = l.hasOwnProperty("y"), P = Vt, E = Nt, O = window;
  if (d) {
    var R = ka(n), V = "clientHeight", J = "clientWidth";
    if (R === Gt(n) && (R = cr(n), Nn(R).position !== "static" && s === "absolute" && (V = "scrollHeight", J = "scrollWidth")), R = R, o === Nt || (o === Vt || o === nn) && a === na) {
      E = tn;
      var F = f && R === O && O.visualViewport ? O.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        R[V]
      );
      v -= F - r.height, v *= i ? 1 : -1;
    }
    if (o === Vt || (o === Nt || o === tn) && a === na) {
      P = nn;
      var A = f && R === O && O.visualViewport ? O.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        R[J]
      );
      b -= A - r.width, b *= i ? 1 : -1;
    }
  }
  var j = Object.assign({
    position: s
  }, d && Ng), _ = u === !0 ? Vg({
    x: b,
    y: v
  }, Gt(n)) : {
    x: b,
    y: v
  };
  if (b = _.x, v = _.y, i) {
    var U;
    return Object.assign({}, j, (U = {}, U[E] = L ? "0" : "", U[P] = k ? "0" : "", U.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + v + "px)" : "translate3d(" + b + "px, " + v + "px, 0)", U));
  }
  return Object.assign({}, j, (t = {}, t[E] = L ? v + "px" : "", t[P] = k ? b + "px" : "", t.transform = "", t));
}
function Fg(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, l = a === void 0 ? !0 : a, s = n.roundOffsets, i = s === void 0 ? !0 : s, d = {
    placement: yn(t.placement),
    variation: io(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ku(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: i
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ku(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Hg = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Fg,
  data: {}
};
var Ma = {
  passive: !0
};
function Wg(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, a = o === void 0 ? !0 : o, l = r.resize, s = l === void 0 ? !0 : l, i = Gt(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && d.forEach(function(u) {
    u.addEventListener("scroll", n.update, Ma);
  }), s && i.addEventListener("resize", n.update, Ma), function() {
    a && d.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Ma);
    }), s && i.removeEventListener("resize", n.update, Ma);
  };
}
const jg = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Wg,
  data: {}
};
var Ug = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function _a(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Ug[t];
  });
}
var Gg = {
  start: "end",
  end: "start"
};
function wu(e) {
  return e.replace(/start|end/g, function(t) {
    return Gg[t];
  });
}
function fd(e) {
  var t = Gt(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function hd(e) {
  return so(cr(e)).left + fd(e).scrollLeft;
}
function qg(e, t) {
  var n = Gt(e), r = cr(e), o = n.visualViewport, a = r.clientWidth, l = r.clientHeight, s = 0, i = 0;
  if (o) {
    a = o.width, l = o.height;
    var d = Pf();
    (d || !d && t === "fixed") && (s = o.offsetLeft, i = o.offsetTop);
  }
  return {
    width: a,
    height: l,
    x: s + hd(e),
    y: i
  };
}
function Kg(e) {
  var t, n = cr(e), r = fd(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = Sr(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = Sr(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + hd(e), i = -r.scrollTop;
  return Nn(o || n).direction === "rtl" && (s += Sr(n.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: l,
    x: s,
    y: i
  };
}
function bd(e) {
  var t = Nn(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Hf(e) {
  return ["html", "body", "#document"].indexOf(wn(e)) >= 0 ? e.ownerDocument.body : Qt(e) && bd(e) ? e : Hf(ls(e));
}
function Fo(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Hf(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = Gt(r), l = o ? [a].concat(a.visualViewport || [], bd(r) ? r : []) : r, s = t.concat(l);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Fo(ls(l)))
  );
}
function bi(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Jg(e, t) {
  var n = so(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Cu(e, t, n) {
  return t === Bf ? bi(qg(e, n)) : Dr(t) ? Jg(t, n) : bi(Kg(cr(e)));
}
function Zg(e) {
  var t = Fo(ls(e)), n = ["absolute", "fixed"].indexOf(Nn(e).position) >= 0, r = n && Qt(e) ? ka(e) : e;
  return Dr(r) ? t.filter(function(o) {
    return Dr(o) && zf(o, r) && wn(o) !== "body";
  }) : [];
}
function Yg(e, t, n, r) {
  var o = t === "clippingParents" ? Zg(e) : [].concat(t), a = [].concat(o, [n]), l = a[0], s = a.reduce(function(i, d) {
    var u = Cu(e, d, r);
    return i.top = Sr(u.top, i.top), i.right = ul(u.right, i.right), i.bottom = ul(u.bottom, i.bottom), i.left = Sr(u.left, i.left), i;
  }, Cu(e, l, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Wf(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? yn(r) : null, a = r ? io(r) : null, l = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, i;
  switch (o) {
    case Nt:
      i = {
        x: l,
        y: t.y - n.height
      };
      break;
    case tn:
      i = {
        x: l,
        y: t.y + t.height
      };
      break;
    case nn:
      i = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Vt:
      i = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      i = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? cd(o) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (a) {
      case ao:
        i[d] = i[d] - (t[u] / 2 - n[u] / 2);
        break;
      case na:
        i[d] = i[d] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return i;
}
function ra(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, a = n.strategy, l = a === void 0 ? e.strategy : a, s = n.boundary, i = s === void 0 ? gg : s, d = n.rootBoundary, u = d === void 0 ? Bf : d, f = n.elementContext, h = f === void 0 ? wo : f, b = n.altBoundary, m = b === void 0 ? !1 : b, v = n.padding, x = v === void 0 ? 0 : v, k = Vf(typeof x != "number" ? x : Ff(x, ya)), L = h === wo ? mg : wo, P = e.rects.popper, E = e.elements[m ? L : h], O = Yg(Dr(E) ? E : E.contextElement || cr(e.elements.popper), i, u, l), R = so(e.elements.reference), V = Wf({
    reference: R,
    element: P,
    placement: o
  }), J = bi(Object.assign({}, P, V)), F = h === wo ? J : R, A = {
    top: O.top - F.top + k.top,
    bottom: F.bottom - O.bottom + k.bottom,
    left: O.left - F.left + k.left,
    right: F.right - O.right + k.right
  }, j = e.modifiersData.offset;
  if (h === wo && j) {
    var _ = j[o];
    Object.keys(A).forEach(function(U) {
      var W = [nn, tn].indexOf(U) >= 0 ? 1 : -1, K = [Nt, tn].indexOf(U) >= 0 ? "y" : "x";
      A[U] += _[K] * W;
    });
  }
  return A;
}
function Xg(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, a = n.rootBoundary, l = n.padding, s = n.flipVariations, i = n.allowedAutoPlacements, d = i === void 0 ? Of : i, u = io(r), f = u ? s ? xu : xu.filter(function(m) {
    return io(m) === u;
  }) : ya, h = f.filter(function(m) {
    return d.indexOf(m) >= 0;
  });
  h.length === 0 && (h = f);
  var b = h.reduce(function(m, v) {
    return m[v] = ra(e, {
      placement: v,
      boundary: o,
      rootBoundary: a,
      padding: l
    })[yn(v)], m;
  }, {});
  return Object.keys(b).sort(function(m, v) {
    return b[m] - b[v];
  });
}
function Qg(e) {
  if (yn(e) === id)
    return [];
  var t = _a(e);
  return [wu(e), t, wu(t)];
}
function _g(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, l = n.altAxis, s = l === void 0 ? !0 : l, i = n.fallbackPlacements, d = n.padding, u = n.boundary, f = n.rootBoundary, h = n.altBoundary, b = n.flipVariations, m = b === void 0 ? !0 : b, v = n.allowedAutoPlacements, x = t.options.placement, k = yn(x), L = k === x, P = i || (L || !m ? [_a(x)] : Qg(x)), E = [x].concat(P).reduce(function(de, fe) {
      return de.concat(yn(fe) === id ? Xg(t, {
        placement: fe,
        boundary: u,
        rootBoundary: f,
        padding: d,
        flipVariations: m,
        allowedAutoPlacements: v
      }) : fe);
    }, []), O = t.rects.reference, R = t.rects.popper, V = /* @__PURE__ */ new Map(), J = !0, F = E[0], A = 0; A < E.length; A++) {
      var j = E[A], _ = yn(j), U = io(j) === ao, W = [Nt, tn].indexOf(_) >= 0, K = W ? "width" : "height", le = ra(t, {
        placement: j,
        boundary: u,
        rootBoundary: f,
        altBoundary: h,
        padding: d
      }), C = W ? U ? nn : Vt : U ? tn : Nt;
      O[K] > R[K] && (C = _a(C));
      var B = _a(C), I = [];
      if (a && I.push(le[_] <= 0), s && I.push(le[C] <= 0, le[B] <= 0), I.every(function(de) {
        return de;
      })) {
        F = j, J = !1;
        break;
      }
      V.set(j, I);
    }
    if (J)
      for (var M = m ? 3 : 1, D = function(fe) {
        var q = E.find(function(oe) {
          var ue = V.get(oe);
          if (ue)
            return ue.slice(0, fe).every(function(G) {
              return G;
            });
        });
        if (q)
          return F = q, "break";
      }, re = M; re > 0; re--) {
        var se = D(re);
        if (se === "break") break;
      }
    t.placement !== F && (t.modifiersData[r]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const em = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: _g,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Su(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function $u(e) {
  return [Nt, nn, tn, Vt].some(function(t) {
    return e[t] >= 0;
  });
}
function tm(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, l = ra(t, {
    elementContext: "reference"
  }), s = ra(t, {
    altBoundary: !0
  }), i = Su(l, r), d = Su(s, o, a), u = $u(i), f = $u(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const nm = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: tm
};
function rm(e, t, n) {
  var r = yn(e), o = [Vt, Nt].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, l = a[0], s = a[1];
  return l = l || 0, s = (s || 0) * o, [Vt, nn].indexOf(r) >= 0 ? {
    x: s,
    y: l
  } : {
    x: l,
    y: s
  };
}
function om(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, l = Of.reduce(function(u, f) {
    return u[f] = rm(f, t.rects, a), u;
  }, {}), s = l[t.placement], i = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += i, t.modifiersData.popperOffsets.y += d), t.modifiersData[r] = l;
}
const am = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: om
};
function lm(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Wf({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const sm = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: lm,
  data: {}
};
function im(e) {
  return e === "x" ? "y" : "x";
}
function dm(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, l = n.altAxis, s = l === void 0 ? !1 : l, i = n.boundary, d = n.rootBoundary, u = n.altBoundary, f = n.padding, h = n.tether, b = h === void 0 ? !0 : h, m = n.tetherOffset, v = m === void 0 ? 0 : m, x = ra(t, {
    boundary: i,
    rootBoundary: d,
    padding: f,
    altBoundary: u
  }), k = yn(t.placement), L = io(t.placement), P = !L, E = cd(k), O = im(E), R = t.modifiersData.popperOffsets, V = t.rects.reference, J = t.rects.popper, F = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, A = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), j = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, _ = {
    x: 0,
    y: 0
  };
  if (R) {
    if (a) {
      var U, W = E === "y" ? Nt : Vt, K = E === "y" ? tn : nn, le = E === "y" ? "height" : "width", C = R[E], B = C + x[W], I = C - x[K], M = b ? -J[le] / 2 : 0, D = L === ao ? V[le] : J[le], re = L === ao ? -J[le] : -V[le], se = t.elements.arrow, de = b && se ? ud(se) : {
        width: 0,
        height: 0
      }, fe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Nf(), q = fe[W], oe = fe[K], ue = Vo(0, V[le], de[le]), G = P ? V[le] / 2 - M - ue - q - A.mainAxis : D - ue - q - A.mainAxis, H = P ? -V[le] / 2 + M + ue + oe + A.mainAxis : re + ue + oe + A.mainAxis, z = t.elements.arrow && ka(t.elements.arrow), X = z ? E === "y" ? z.clientTop || 0 : z.clientLeft || 0 : 0, Y = (U = j == null ? void 0 : j[E]) != null ? U : 0, ce = C + G - Y - X, ne = C + H - Y, ye = Vo(b ? ul(B, ce) : B, C, b ? Sr(I, ne) : I);
      R[E] = ye, _[E] = ye - C;
    }
    if (s) {
      var he, ie = E === "x" ? Nt : Vt, me = E === "x" ? tn : nn, Q = R[O], ee = O === "y" ? "height" : "width", ve = Q + x[ie], Le = Q - x[me], We = [Nt, Vt].indexOf(k) !== -1, qe = (he = j == null ? void 0 : j[O]) != null ? he : 0, fn = We ? ve : Q - V[ee] - J[ee] - qe + A.altAxis, hn = We ? Q + V[ee] + J[ee] - qe - A.altAxis : Le, Et = b && We ? Rg(fn, Q, hn) : Vo(b ? fn : ve, Q, b ? hn : Le);
      R[O] = Et, _[O] = Et - Q;
    }
    t.modifiersData[r] = _;
  }
}
const um = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: dm,
  requiresIfExists: ["offset"]
};
function cm(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function fm(e) {
  return e === Gt(e) || !Qt(e) ? fd(e) : cm(e);
}
function hm(e) {
  var t = e.getBoundingClientRect(), n = lo(t.width) / e.offsetWidth || 1, r = lo(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function bm(e, t, n) {
  n === void 0 && (n = !1);
  var r = Qt(t), o = Qt(t) && hm(t), a = cr(t), l = so(e, o, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((wn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  bd(a)) && (s = fm(t)), Qt(t) ? (i = so(t, !0), i.x += t.clientLeft, i.y += t.clientTop) : a && (i.x = hd(a))), {
    x: l.left + s.scrollLeft - i.x,
    y: l.top + s.scrollTop - i.y,
    width: l.width,
    height: l.height
  };
}
function pm(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var l = [].concat(a.requires || [], a.requiresIfExists || []);
    l.forEach(function(s) {
      if (!n.has(s)) {
        var i = t.get(s);
        i && o(i);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function gm(e) {
  var t = pm(e);
  return Tg.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function mm(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function vm(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Iu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Tu() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function xm(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? Iu : o;
  return function(s, i, d) {
    d === void 0 && (d = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Iu, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: i
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, b = {
      state: u,
      setOptions: function(k) {
        var L = typeof k == "function" ? k(u.options) : k;
        v(), u.options = Object.assign({}, a, u.options, L), u.scrollParents = {
          reference: Dr(s) ? Fo(s) : s.contextElement ? Fo(s.contextElement) : [],
          popper: Fo(i)
        };
        var P = gm(vm([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = P.filter(function(E) {
          return E.enabled;
        }), m(), b.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var k = u.elements, L = k.reference, P = k.popper;
          if (Tu(L, P)) {
            u.rects = {
              reference: bm(L, ka(P), u.options.strategy === "fixed"),
              popper: ud(P)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(A) {
              return u.modifiersData[A.name] = Object.assign({}, A.data);
            });
            for (var E = 0; E < u.orderedModifiers.length; E++) {
              if (u.reset === !0) {
                u.reset = !1, E = -1;
                continue;
              }
              var O = u.orderedModifiers[E], R = O.fn, V = O.options, J = V === void 0 ? {} : V, F = O.name;
              typeof R == "function" && (u = R({
                state: u,
                options: J,
                name: F,
                instance: b
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: mm(function() {
        return new Promise(function(x) {
          b.forceUpdate(), x(u);
        });
      }),
      destroy: function() {
        v(), h = !0;
      }
    };
    if (!Tu(s, i))
      return b;
    b.setOptions(d).then(function(x) {
      !h && d.onFirstUpdate && d.onFirstUpdate(x);
    });
    function m() {
      u.orderedModifiers.forEach(function(x) {
        var k = x.name, L = x.options, P = L === void 0 ? {} : L, E = x.effect;
        if (typeof E == "function") {
          var O = E({
            state: u,
            name: k,
            instance: b,
            options: P
          }), R = function() {
          };
          f.push(O || R);
        }
      });
    }
    function v() {
      f.forEach(function(x) {
        return x();
      }), f = [];
    }
    return b;
  };
}
var ym = [jg, sm, Hg, Eg, am, em, um, zg, nm], vo = /* @__PURE__ */ xm({
  defaultModifiers: ym
});
const km = ["aria-describedby"], wm = ["id"], Cm = { class: "w-full rounded-xl overflow-hidden border border-(--colors-border-base-soft)" }, Sm = { class: "px-3 py-1.5 text-sm font-medium border-b border-(--colors-border-base-soft) bg-(--colors-background-white-secondary) text-(--colors-text-heading)" }, $m = { class: "px-3 py-2 text-sm bg-(--colors-white-50-opacity-bold) text-(--colors-text-body)" }, Im = 100, Tm = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    text: {},
    header: {},
    position: { default: "top" },
    delay: { default: 300 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 }
  },
  setup(e, { expose: t }) {
    const n = e, r = Ke(), o = N(null), a = N(null), l = N(!1), s = y(() => n.disabled ? !1 : n.open !== void 0 ? n.open : l.value);
    let i = null, d = null, u = null;
    we(s, async (x) => {
      x ? (await Pe(), o.value && a.value && (i = vo(o.value, a.value, {
        // Fixed keeps the tooltip in the viewport layer so it does not expand
        // document scroll width/height (avoids double scrollbars with nested overflow:auto regions).
        strategy: "fixed",
        placement: n.position,
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, n.header ? 10 : 8] }
          },
          {
            name: "arrow",
            options: { element: "[data-popper-arrow]" }
          }
        ]
      }))) : (i == null || i.destroy(), i = null);
    });
    const f = () => {
      u && (clearTimeout(u), u = null);
    }, h = () => {
      n.disabled || (f(), !(d || l.value) && (d = setTimeout(() => {
        l.value = !0, d = null;
      }, n.delay)));
    }, b = () => {
      d && (clearTimeout(d), d = null), f(), l.value = !1;
    }, m = () => {
      d && (clearTimeout(d), d = null), l.value && (f(), u = setTimeout(() => {
        l.value = !1, u = null;
      }, Im));
    }, v = (x) => {
      n.open !== void 0 || !s.value || (x.stopPropagation(), x.preventDefault(), b());
    };
    return t({ isVisible: s, hide: b }), Bt(() => {
      d && clearTimeout(d), u && clearTimeout(u), i == null || i.destroy();
    }), (x, k) => (c(), p(Z, null, [
      g("div", Je({
        ref_key: "triggerRef",
        ref: o,
        class: "inline-flex"
      }, x.$attrs, {
        "aria-describedby": s.value ? T(r) : void 0,
        onMouseenter: h,
        onMouseleave: m,
        onFocusin: h,
        onFocusout: b,
        onKeydown: je(v, ["escape"])
      }), [
        be(x.$slots, "default", {}, void 0, !0)
      ], 16, km),
      (c(), te(cn, { to: "body" }, [
        ae(ot, { name: "tooltip" }, {
          default: pe(() => [
            s.value ? (c(), p("div", {
              key: 0,
              id: T(r),
              ref_key: "bubbleRef",
              ref: a,
              role: "tooltip",
              class: S(["fixed z-9999 rounded-xl", e.header ? "tooltip-bubble--structured w-[255px]" : "tooltip-bubble min-w-33.5 max-w-50 py-2 px-3 text-sm font-medium leading-5 wrap-break-word"]),
              onMouseenter: f,
              onMouseleave: m
            }, [
              e.header ? (c(), p(Z, { key: 0 }, [
                g("div", Cm, [
                  g("div", Sm, $(e.header), 1),
                  g("div", $m, $(e.text), 1)
                ]),
                k[0] || (k[0] = g("div", {
                  class: "tooltip-structured-arrow",
                  "aria-hidden": "true"
                }, [
                  g("svg", {
                    width: "40",
                    height: "10",
                    viewBox: "0 0 23 9",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    g("path", {
                      d: "M19.4536 0.5C19.2954 0.627794 19.1445 0.76614 19.0034 0.916016L13.689 6.5625C12.307 8.0308 9.97324 8.0308 8.59131 6.5625L3.27685 0.916016C3.1358 0.76614 2.98489 0.627794 2.82666 0.5H19.4536Z",
                      fill: "var(--colors-white-50-opacity-bold)",
                      stroke: "var(--colors-border-base-soft)"
                    })
                  ])
                ], -1))
              ], 64)) : (c(), p(Z, { key: 1 }, [
                Ze($(e.text) + " ", 1),
                k[1] || (k[1] = g("div", {
                  "data-popper-arrow": "",
                  class: "tooltip-arrow",
                  "aria-hidden": "true"
                }, null, -1))
              ], 64))
            ], 42, wm)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), He = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Ye = /* @__PURE__ */ He(Tm, [["__scopeId", "data-v-52659d13"]]), Lm = ["aria-label"], Mm = {
  key: 0,
  class: "badge-dot-gradient shrink-0",
  "aria-hidden": "true"
}, Em = ["src", "alt"], Am = ["innerHTML"], Dm = {
  key: 0,
  class: "inline-flex items-center gap-1.5"
}, Rm = ["aria-label", "innerHTML"], Bm = ["innerHTML"], Om = "text-[6px] leading-none", Pm = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "Badge",
  props: {
    label: { default: "" },
    theme: { default: "disabled" },
    size: { default: "sm" },
    type: { default: "default" },
    badgeStyle: { default: "rounded" },
    showLeftIcon: { type: Boolean, default: !0 },
    showCloseIcon: { type: Boolean, default: !0 },
    showText: { type: Boolean, default: !0 },
    dropdownIcon: { type: Boolean, default: !1 },
    secondaryText: { default: "" },
    avatarSrc: { default: void 0 },
    avatarAlt: { default: void 0 },
    iconOnly: { type: Boolean, default: !1 },
    textOnly: { type: Boolean, default: !1 },
    value: { default: void 0 },
    truncate: { type: Boolean, default: !1 },
    tooltipText: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = ad(), r = y(() => {
      const { class: F, ...A } = n;
      return A;
    }), o = e, a = t, l = {
      disabled: {
        bg: "bg-(--components-badges-background-badge-disabled-bg)",
        border: "border-transparent",
        text: "text-(--text-text-disabled-strong)",
        separator: "bg-(--text-text-disabled-strong)",
        dot: "text-(--components-badges-dot-disabled)",
        dotText: "text-(--text-text-disabled-strong)"
      },
      red: {
        bg: "bg-(--components-badges-background-badge-error-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-error)",
        dotText: "text-(--text-text-black-default)"
      },
      orange: {
        bg: "bg-(--components-badges-background-badge-orange-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-orange)",
        dotText: "text-(--text-text-black-default)"
      },
      yellow: {
        bg: "bg-(--components-badges-background-badge-yellow-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-yellow)",
        dotText: "text-(--text-text-black-default)"
      },
      green: {
        bg: "bg-(--components-badges-background-badge-green-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-success)",
        dotText: "text-(--text-text-black-default)"
      },
      indigo: {
        bg: "bg-(--components-badges-background-badge-indigo-soft-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-indigo)",
        dotText: "text-(--text-text-black-default)"
      },
      // Figma "Active" theme, filled anatomy (node 4342:42359): semi-transparent
      // accent background (badge-accent-bg) with indigo-colored text — distinct
      // from Indigo's black text. The with-dot anatomy (node 5758-87076) is its
      // OWN Figma variant, not just "filled minus the fill": its Text node binds
      // to badge-black-default-text, not the indigo text the filled anatomy
      // uses — confirmed via the MCP variable defs on both nodes, so `dotText`
      // deliberately differs from `text` here, unlike every other theme where
      // they match. Its dot is bound to badge-indigo-strong-bg, NOT
      // --components-badges-dot-blue — that token is hand-maintained (main.css,
      // not the Figma-generated colors-{light,dark}.css) and only correct in
      // dark mode by coincidence (#615fff matches dark's badge-indigo-strong-bg
      // but not light's #4f39f6).
      active: {
        bg: "bg-(--components-badges-background-badge-accent-bg)",
        border: "border-transparent",
        text: "text-(--components-badges-text-badge-indigo-text)",
        separator: "bg-(--components-badges-text-badge-indigo-text)",
        dot: "text-(--components-badges-background-badge-indigo-strong-bg)",
        dotText: "text-(--components-badges-text-badge-black-default-text)"
      },
      violet: {
        bg: "bg-(--components-badges-background-badge-violet-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-violet)",
        dotText: "text-(--text-text-black-default)"
      },
      purple: {
        bg: "bg-(--components-badges-background-badge-purple-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-purple)",
        dotText: "text-(--text-text-black-default)"
      },
      grey: {
        bg: "bg-(--components-badges-background-badge-neutral-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-neutral)",
        dotText: "text-(--text-text-black-default)"
      },
      // Only theme with a dark fill, so it is also the only one needing light text — and the only
      // one whose with-dot form has to switch back to dark text, the fill being gone.
      dark: {
        bg: "bg-(--components-badges-background-badge-dark-bg)",
        border: "border-transparent",
        text: "text-(--text-text-white-default)",
        separator: "bg-(--text-text-white-default)",
        dot: "text-(--components-badges-dot-dark)",
        dotText: "text-(--text-text-black-default)"
      },
      cyan: {
        bg: "bg-(--components-badges-background-badge-cyan-bg)",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-cyan)",
        dotText: "text-(--text-text-black-default)"
      },
      white: {
        bg: "bg-(--components-badges-background-badge-white-bg)",
        border: "border-(--border-border-base-soft)",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "text-(--components-badges-dot-white)",
        dotText: "text-(--text-text-black-default)"
      },
      "gradient-light": {
        bg: "badge-gradient-light",
        border: "border-transparent",
        text: "text-(--text-text-black-default)",
        separator: "bg-(--text-text-black-default)",
        dot: "",
        dotText: "text-(--text-text-black-default)"
      }
    }, s = y(() => l[o.theme]), i = y(() => o.iconOnly || o.textOnly), d = y(() => o.badgeStyle === "circle" ? "rounded-full" : "rounded"), u = y(() => o.type === "with-dot" && !i.value), f = {
      xs: {
        compactCircle: "w-[18px] h-[18px] overflow-hidden",
        compact: "gap-0 px-1 min-w-[18px] h-[18px]",
        withDot: "gap-1 px-1 py-0",
        padding: "gap-1 px-1 py-0.5",
        text: "text-[10px] leading-[14px]",
        icon: "h-2.5 w-2.5",
        avatar: "h-3 w-3",
        svgPx: 10
      },
      sm: {
        compactCircle: "min-w-[22px] h-5 overflow-hidden",
        compact: "gap-0 px-1 min-w-[22px] h-5",
        withDot: "gap-1 px-1 py-0",
        padding: "gap-1 px-1 py-0.5",
        text: "text-xs leading-5",
        icon: "h-3 w-3",
        avatar: "h-3.5 w-3.5",
        svgPx: 12
      },
      lg: {
        compactCircle: "w-6 h-6 overflow-hidden",
        compact: "gap-0 px-1 min-w-[22px] h-6",
        withDot: "gap-1.5 px-1.5 py-px",
        padding: "gap-1.5 px-1.5 py-1",
        text: "text-sm leading-5",
        icon: "h-3.5 w-3.5",
        avatar: "h-4 w-4",
        svgPx: 14
      }
    }, h = y(() => f[o.size]), b = y(() => {
      const F = [
        "inline-flex items-center justify-center font-inter",
        "border-solid border-[1px]",
        d.value,
        u.value ? "bg-transparent" : s.value.bg,
        u.value ? "border-transparent" : s.value.border,
        u.value ? s.value.dotText : s.value.text
      ];
      return i.value ? F.push(o.badgeStyle === "circle" ? h.value.compactCircle : h.value.compact) : F.push(u.value ? h.value.withDot : h.value.padding), F;
    }), m = y(() => `${h.value.text} font-medium text-center`), v = y(() => `${h.value.text} font-normal text-center`), x = y(() => h.value.icon), k = y(() => h.value.avatar), L = (F) => {
      const A = h.value.svgPx;
      return F.replace("<svg", `<svg width="${A}" height="${A}" style="display:block;"`);
    }, P = y(() => L(sd)), E = y(() => L(Rf)), O = y(() => L(pg)), R = y(() => {
      var F;
      return o.truncate && (((F = o.label) == null ? void 0 : F.length) ?? 0) > 14;
    }), V = y(
      () => R.value && o.label ? `${o.label.slice(0, 14)}…` : o.label ?? ""
    ), J = () => {
      a("close");
    };
    return (F, A) => (c(), te(Ye, {
      text: e.tooltipText ?? e.label ?? "",
      disabled: e.tooltipText ? !1 : !R.value,
      position: "top"
    }, {
      default: pe(() => [
        g("span", Je(r.value, {
          class: [b.value, T(n).class],
          role: "status",
          "aria-label": e.textOnly ? String(e.value ?? e.label) : e.label
        }), [
          e.type === "with-dot" && !e.iconOnly && !e.textOnly && e.theme === "gradient-light" ? (c(), p("span", Mm)) : e.type === "with-dot" && !e.iconOnly && !e.textOnly ? (c(), p("i", {
            key: 1,
            class: S(["ri-circle-fill shrink-0", [Om, s.value.dot]]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          e.type === "with-avatar" && !e.iconOnly && !e.textOnly ? (c(), p("img", {
            key: 2,
            src: e.avatarSrc,
            alt: e.avatarAlt || "",
            class: S([
              k.value,
              "rounded-full object-cover shrink-0",
              { "opacity-60": e.theme === "disabled" }
            ])
          }, null, 10, Em)) : w("", !0),
          e.type === "with-loader" && !e.iconOnly && !e.textOnly ? (c(), p("span", {
            key: 3,
            class: S([x.value, "shrink-0 animate-spin inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            innerHTML: E.value
          }, null, 10, Am)) : w("", !0),
          (e.type === "default" || e.type === "with-secondary-text") && e.showLeftIcon && !e.textOnly ? be(F.$slots, "left-icon", { key: 4 }, void 0, !0) : w("", !0),
          e.type === "with-dot" && e.showLeftIcon && !e.iconOnly && !e.textOnly ? be(F.$slots, "left-icon", { key: 5 }, void 0, !0) : w("", !0),
          e.iconOnly ? be(F.$slots, "icon", { key: 6 }, () => [
            be(F.$slots, "left-icon", {}, void 0, !0)
          ], !0) : w("", !0),
          e.textOnly ? (c(), p("span", {
            key: 7,
            class: S(m.value)
          }, $(e.value ?? e.label), 3)) : w("", !0),
          !e.iconOnly && !e.textOnly && e.showText ? (c(), p(Z, { key: 8 }, [
            e.type === "with-secondary-text" ? (c(), p("span", Dm, [
              g("span", {
                class: S(m.value)
              }, $(V.value), 3),
              g("span", {
                class: S(["w-px h-3 shrink-0", s.value.separator]),
                "aria-hidden": "true"
              }, null, 2),
              g("span", {
                class: S(v.value)
              }, $(e.secondaryText), 3)
            ])) : (c(), p("span", {
              key: 1,
              class: S(m.value)
            }, $(V.value), 3))
          ], 64)) : w("", !0),
          e.showCloseIcon && !e.iconOnly && !e.textOnly && e.type !== "with-dot" ? (c(), p("button", {
            key: 9,
            type: "button",
            class: S([
              x.value,
              "shrink-0 inline-flex items-center justify-center cursor-pointer bg-transparent border-none p-0 hover:opacity-70 transition-opacity"
            ]),
            "aria-label": `Remove ${e.label}`,
            onClick: Ie(J, ["stop"]),
            innerHTML: P.value
          }, null, 10, Rm)) : w("", !0),
          e.dropdownIcon && !e.iconOnly && !e.textOnly ? (c(), p("span", {
            key: 10,
            class: S([x.value, "shrink-0 inline-flex items-center justify-center"]),
            "aria-hidden": "true",
            innerHTML: O.value
          }, null, 10, Bm)) : w("", !0)
        ], 16, Lm)
      ]),
      _: 3
    }, 8, ["text", "disabled"]));
  }
}), pt = /* @__PURE__ */ He(Pm, [["__scopeId", "data-v-b4eef781"]]), zm = ["aria-expanded", "aria-controls", "aria-pressed", "aria-disabled", "disabled"], Nm = {
  key: 0,
  class: "flex-shrink-0",
  "aria-hidden": "true"
}, Vm = {
  key: 2,
  class: "flex-1 min-w-0"
}, Fm = { class: "text-base font-bold leading-6 text-(--colors-text-heading)" }, Hm = {
  key: 0,
  class: "text-sm font-medium leading-5 text-(--colors-text-body) mt-0.5 truncate"
}, Wm = {
  key: 3,
  class: "flex-shrink-0 ml-auto",
  "aria-hidden": "true"
}, jm = ["id", "aria-hidden", "inert"], Um = { class: "accordion-content-inner" }, Gm = /* @__PURE__ */ ge({
  __name: "AccordionItem",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    defaultOpen: { type: Boolean, default: !1 },
    type: { default: "default" },
    badgeLabel: { default: void 0 },
    badgeTheme: { default: "active" },
    expandable: { type: Boolean, default: !0 },
    selected: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 }
  },
  emits: ["toggle", "select", "update:open"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = {
      variant: N("default"),
      size: N("md"),
      openItems: /* @__PURE__ */ new Set(),
      toggleItem: () => {
      }
    }, a = un(Df, o), l = Ke(), s = y(() => `${l}-content`), i = N(!1), d = a === o, u = y(() => n.open !== void 0), f = y(() => u.value ? n.open : d ? i.value : a.openItems.has(l));
    Qe(() => {
      u.value || n.defaultOpen && n.expandable && !f.value && (d ? i.value = !0 : a.toggleItem(l));
    });
    const h = N(!1);
    we(f, (I) => {
      I || (h.value = !1);
    });
    const b = (I) => {
      I.propertyName === "grid-template-rows" && f.value && (h.value = !0);
    }, m = () => {
      if (n.disabled) return;
      if (!U.value) {
        r("select");
        return;
      }
      const I = !f.value;
      u.value ? r("update:open", I) : d ? i.value = I : a.toggleItem(l), r("toggle", I);
    }, v = (I) => {
      var de, fe, q, oe;
      if (!U.value && ["Enter", " "].includes(I.key)) {
        I.preventDefault(), m();
        return;
      }
      if (!["ArrowUp", "ArrowDown", "Home", "End"].includes(I.key)) return;
      const M = I.currentTarget, D = M.closest('[data-testid="accordion"]');
      if (!D) return;
      const re = Array.from(
        D.querySelectorAll(
          '[data-testid="accordion-item-trigger"]:not([disabled])'
        )
      ), se = re.indexOf(M);
      switch (I.preventDefault(), I.key) {
        case "ArrowDown":
          (de = re[(se + 1) % re.length]) == null || de.focus();
          break;
        case "ArrowUp":
          (fe = re[(se - 1 + re.length) % re.length]) == null || fe.focus();
          break;
        case "Home":
          (q = re[0]) == null || q.focus();
          break;
        case "End":
          (oe = re[re.length - 1]) == null || oe.focus();
          break;
      }
    }, x = a.variant, k = a.size, L = y(() => _.value ? [`group [&:not(:last-child)]:mb-4 ${W.value ? "overflow-visible" : "overflow-hidden"} rounded-xl`, K.value].join(" ") : x.value === "separate-cards" ? "group border border-(--colors-border-base-soft) rounded-xl overflow-hidden shadow-[0_1px_2px_0_rgba(29,41,61,0.05)]" : "group"), P = y(() => _.value ? U.value && f.value ? "rounded-t-xl" : "rounded-xl" : "group-first:rounded-t-xl group-last:rounded-b-xl"), E = y(() => _.value ? "p-3" : x.value === "with-sub-header" ? k.value === "sm" ? "py-2 px-6" : "py-5 px-6" : k.value === "sm" ? "py-1 px-6" : "py-5 px-6"), O = y(() => _.value ? "gap-2.5" : "gap-6"), R = y(
      () => _.value ? "" : "border-b border-(--colors-border-base-soft)"
    ), V = y(() => _.value ? "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-info-strong)" : x.value === "flush" ? "" : "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-hover)"), J = y(() => _.value ? n.disabled ? "cursor-not-allowed" : "cursor-pointer" : n.disabled ? "cursor-not-allowed opacity-60" : x.value === "flush" ? f.value ? "cursor-pointer" : "cursor-pointer hover:text-(--colors-text-hover)" : [
      "cursor-pointer",
      f.value ? "bg-(--colors-background-selected)" : "hover:bg-(--colors-background-hover)"
    ].join(" ")), F = y(() => x.value === "with-sub-header"), A = y(() => k.value === "sm" ? "w-6 h-6" : "w-9 h-9"), j = y(() => k.value === "sm" ? "text-base" : "text-xl"), _ = y(() => n.type === "time-slot"), U = y(() => n.expandable), W = y(() => !n.disabled && U.value && f.value), K = y(() => _.value ? n.disabled || !U.value && n.selected ? "border border-(--border-border-base-medium)" : W.value ? "relative border border-transparent accordion-time-slot-gradient-border" : "border border-(--border-border-info) hover:border-(--border-border-info-strong)" : ""), le = y(() => _.value ? n.disabled ? "bg-(--background-background-disabled-subtle)" : !U.value && n.selected ? "bg-(--components-badges-background-badge-indigo-strong-bg)" : "bg-(--background-background-info)" : ""), C = y(() => _.value ? n.disabled ? "font-medium text-(--text-text-disabled-strong) line-through" : !U.value && n.selected ? "font-bold text-(--colors-text-white-default)" : "font-medium text-(--text-text-link)" : ""), B = y(() => _.value ? "flex flex-col gap-1 px-2 py-1.5 rounded-b-xl bg-white dark:bg-(--colors-background-black-default)" : k.value === "sm" ? "flex flex-col gap-3 px-6 py-3 bg-white dark:bg-(--colors-background-black-default) border-b border-(--colors-border-base-soft)" : "flex flex-col gap-3 px-6 py-5 bg-white dark:bg-(--colors-background-black-default) border-b border-(--colors-border-base-soft)");
    return (I, M) => (c(), p("div", {
      class: S(L.value),
      "data-testid": "accordion-item"
    }, [
      g("button", {
        type: "button",
        class: S(["flex w-full items-center text-left transition-colors", [
          P.value,
          O.value,
          R.value,
          E.value,
          J.value,
          le.value,
          V.value,
          _.value && !U.value ? "justify-center" : ""
        ]]),
        "aria-expanded": U.value ? f.value : void 0,
        "aria-controls": U.value ? s.value : void 0,
        "aria-pressed": _.value && !U.value ? e.selected : void 0,
        "aria-disabled": _.value && e.disabled ? "true" : void 0,
        disabled: _.value ? !1 : e.disabled,
        "data-testid": "accordion-item-trigger",
        onClick: m,
        onKeydown: v
      }, [
        e.icon && (!_.value || U.value) ? (c(), p("div", Nm, [
          F.value ? (c(), p("div", {
            key: 0,
            class: S([
              A.value,
              "rounded-full border border-(--colors-border-base-soft) flex items-center justify-center"
            ])
          }, [
            g("i", {
              class: S([e.icon, j.value, "text-(--colors-text-heading)"])
            }, null, 2)
          ], 2)) : (c(), p("i", {
            key: 1,
            class: S([
              e.icon,
              _.value ? "text-[16px]" : "text-[20px]",
              _.value ? e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)" : "text-(--colors-text-body)"
            ])
          }, null, 2))
        ])) : w("", !0),
        _.value ? (c(), p("div", {
          key: 1,
          class: S(["flex flex-1 min-w-0 flex-wrap items-center gap-2", U.value ? "" : "justify-center"]),
          "data-testid": "accordion-item-time-wrapper"
        }, [
          g("span", {
            "data-testid": "accordion-item-time",
            class: S(["text-base leading-6", C.value])
          }, $(e.title), 3),
          e.badgeLabel && U.value ? (c(), te(pt, {
            key: 0,
            "data-testid": "accordion-item-badge",
            label: e.badgeLabel,
            theme: e.disabled ? "disabled" : e.badgeTheme,
            size: "sm",
            "show-left-icon": !1,
            "show-close-icon": !1
          }, null, 8, ["label", "theme"])) : w("", !0)
        ], 2)) : (c(), p("div", Vm, [
          g("div", Fm, $(e.title), 1),
          e.subtitle ? (c(), p("div", Hm, $(e.subtitle), 1)) : w("", !0)
        ])),
        U.value ? (c(), p("div", Wm, [
          g("i", {
            class: S(["ri-arrow-down-s-line text-2xl transition-transform duration-300", [
              _.value ? e.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-link)" : "text-(--colors-text-body)",
              f.value ? "rotate-180" : ""
            ]])
          }, null, 2)
        ])) : w("", !0)
      ], 42, zm),
      U.value ? (c(), p("div", {
        key: 0,
        id: s.value,
        class: S(["accordion-content", {
          "accordion-content--expanded": f.value,
          "accordion-content--open": h.value
        }]),
        role: "region",
        "aria-hidden": !f.value,
        inert: !f.value || void 0,
        onTransitionend: b
      }, [
        g("div", Um, [
          g("div", {
            class: S(B.value)
          }, [
            be(I.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 42, jm)) : w("", !0)
    ], 2));
  }
}), eV = /* @__PURE__ */ He(Gm, [["__scopeId", "data-v-f4066267"]]), qm = {
  primary: "rounded-[9999px] bg-(--components-button-primary-button-primary) border-[var(--border-border-primary-button)] text-[var(--text-text-white-secondary)] dark:text-[var(--text-text-white-default)] dark:hover:enabled:text-[var(--text-text-black-default)] disabled:bg-background-disabled dark:disabled:bg-[var(--components-button-button-disabled)] disabled:border-[var(--border-border-disabled)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:bg-background-disabled dark:aria-disabled:bg-[var(--components-button-button-disabled)] aria-disabled:border-[var(--border-border-disabled)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)] hover:enabled:border-[var(--border-border-primary-button-hover)] focus:enabled:border-(--border-border-accent) focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] before:[background:linear-gradient(90deg,_#2d2d32,_#48485f)] dark:before:[background:linear-gradient(90deg,_var(--text-text-white-default),_var(--colors-indigo-100))] hover:enabled:before:opacity-100",
  secondary: "rounded-[9999px] bg-[var(--components-button-secondary-button-secondary)] border-[var(--border-border-secondary-button)] text-[var(--text-text-black-default)] disabled:bg-background-disabled dark:disabled:bg-[var(--components-button-button-disabled)] disabled:border-[var(--border-border-disabled)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:bg-background-disabled dark:aria-disabled:bg-[var(--components-button-button-disabled)] aria-disabled:border-[var(--border-border-disabled)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)] hover:enabled:border-[var(--border-border-secondary-button-hover)] dark:hover:enabled:bg-(--components-button-secondary-button-secondary-hover) dark:hover:enabled:text-(--text-text-white-secondary) focus:enabled:text-(--text-text-accent) focus:enabled:border-(--border-border-accent) focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] before:[background:linear-gradient(90deg,_rgba(174,_173,_255,_0.06)_30%,_rgba(162,_161,_241,_0.3))] hover:enabled:before:opacity-100",
  tertiary: "rounded-3xl border-transparent text-[var(--text-text-black-default)] dark:text-[var(--text-text-white-secondary)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)] hover:enabled:bg-(--components-button-tertiary-button-tertiary-hover) dark:hover:enabled:text-[var(--text-text-white-secondary)] hover:enabled:border-[var(--border-border-tertiary-hover)] dark:hover:enabled:border-[var(--components-button-tertiary-button-tertiary-hover)] hover:enabled:overflow-hidden focus:enabled:bg-white dark:focus:enabled:bg-[var(--components-button-tertiary-button-tertiary-focused)] focus:enabled:overflow-visible focus:enabled:before:opacity-100 focus:enabled:after:opacity-100 before:[background:var(--gradient-brand-horizontal)] before:inset-[-1px] before:rounded-3xl after:rounded-3xl after:bg-white dark:after:bg-[var(--components-button-tertiary-button-tertiary-focused)]",
  error: "rounded-[9999px] bg-(--components-button-functional-desctructive-error-button-error) border-transparent text-[var(--text-text-white-secondary)] dark:text-(--text-text-black-default) hover:enabled:bg-(--components-button-functional-desctructive-error-button-error-hover) focus:enabled:bg-(--components-button-functional-desctructive-error-button-error-focused) focus:enabled:border-(--border-border-error) dark:focus:enabled:border-(--border-border-error-subtle) focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:bg-background-disabled disabled:border-(--border-border-disabled-subtle) disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:bg-background-disabled aria-disabled:border-(--border-border-disabled) aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  success: "rounded-[9999px] bg-(--components-button-functional-success-button-success) border-transparent text-[var(--text-text-white-secondary)] dark:text-(--text-text-black-default) hover:enabled:bg-(--components-button-functional-success-button-success-hover) focus:enabled:bg-(--components-button-functional-success-button-success-focused) focus:enabled:border-(--border-border-success) dark:focus:enabled:border-(--border-border-success-sublte) focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:bg-background-disabled disabled:border-(--border-border-disabled-subtle) disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:bg-background-disabled aria-disabled:border-(--border-border-disabled) aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  tab: "rounded-t-lg rounded-b-none bg-(--components-button-tab-button-tab-default) border-[var(--border-border-tab)] border-t-[1px] border-r-[1px] border-l-[1px] border-b-0 text-[var(--text-text-black-default)] disabled:rounded-t-xl disabled:bg-[var(--colors-white-50-opacity-light)] dark:disabled:bg-(--components-button-button-disabled) disabled:border-[var(--border-border-disabled-subtle)] dark:disabled:border-[var(--border-border-disabled)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:rounded-t-xl aria-disabled:bg-[var(--colors-white-50-opacity-light)] dark:aria-disabled:bg-(--components-button-button-disabled) aria-disabled:border-[var(--border-border-disabled-subtle)] dark:aria-disabled:border-[var(--border-border-disabled)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)] hover:enabled:rounded-t-xl hover:enabled:bg-(--components-button-tab-button-tab) hover:enabled:border-[var(--border-border-hover)] focus:enabled:rounded-t-xl focus:enabled:bg-white dark:focus:enabled:bg-[var(--components-button-tab-button-tab-active)] focus:enabled:border-transparent focus:enabled:overflow-visible focus:enabled:before:opacity-100 focus:enabled:after:opacity-100 before:[background:var(--gradient-brand-horizontal)] before:[clip-path:inset(0_0_1px_0)] before:inset-[-1px] before:rounded-t-xl before:rounded-b-none after:rounded-t-xl after:rounded-b-none after:bg-white dark:after:bg-[var(--components-button-tab-button-tab-active)]",
  ghost: "rounded-[9999px] bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:enabled:bg-(--components-button-ghost-button-ghost-hover) focus:enabled:border-[var(--colors-text-white-default)] focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  text: "rounded-[9999px] bg-transparent border-transparent text-(--components-button-text-button-text) dark:text-(--text-text-white-default) hover:enabled:text-(--text-text-hover) dark:hover:enabled:text-(--text-text-link) focus:enabled:border-[var(--text-text-white-default)] focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  "success-secondary": "rounded-[9999px] bg-transparent border-(--components-button-functional-success-button-success) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:enabled:border-(--components-button-functional-success-button-success) focus:enabled:border-(--components-button-functional-success-button-success-focused) focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:border-(--border-border-disabled) dark:disabled:border-(--border-border-base) disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:border-(--border-border-base) aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  "error-secondary": "rounded-[9999px] bg-transparent border-(--components-button-functional-desctructive-error-button-error) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:enabled:border-(--components-button-functional-desctructive-error-button-error-hover) focus:enabled:border-(--components-button-functional-desctructive-error-button-error-focused) focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:border-(--border-border-disabled) dark:disabled:border-(--border-border-base) disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:border-(--border-border-base) aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  // Borderless destructive text/icon button — no background or border, default
  // neutral colour, icon/label turn error-red on hover. Mirrors `text` but with the
  // functional error hover colour (campaign-assistant design retour #10: delete icon
  // button = "secondary error non outlined", red icon on hover, no background).
  "text-error": "rounded-[9999px] bg-transparent border-transparent text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:enabled:text-(--components-button-functional-desctructive-error-button-error-hover) focus:enabled:border-[var(--text-text-white-default)] focus:enabled:shadow-[0px_0px_2px_0px_var(--background-background-hover)] disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]",
  // Always-red destructive text/icon button (Figma "Button / Error text", node
  // 4043-34679 light / 13037-34477 dark) — unlike `text-error` above (neutral by
  // default, red only on hover), this variant is red at rest. Hover/focus reuse
  // the same functional error tokens as the filled `error` variant — each is a
  // single token reference so it auto-resolves the (genuinely different)
  // light/dark value per state, no separate dark: overrides needed.
  "error-text": "rounded-[9999px] bg-transparent border-transparent text-[var(--components-button-functional-desctructive-error-button-error)] hover:enabled:text-(--components-button-functional-desctructive-error-button-error-hover) focus:enabled:text-(--components-button-functional-desctructive-error-button-error-focused) focus:enabled:border-(--components-button-functional-desctructive-error-button-error-focused) disabled:text-[var(--text-text-disabled-light)] dark:disabled:text-[var(--text-text-disabled-strong)] aria-disabled:text-[var(--text-text-disabled-light)] dark:aria-disabled:text-[var(--text-text-disabled-strong)]"
}, Km = {
  primary: "hover:border-[var(--border-border-primary-button-hover)] hover:before:opacity-100 dark:hover:text-[var(--text-text-black-default)] focus:border-(--border-border-accent) focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  secondary: "hover:border-[var(--border-border-secondary-button-hover)] dark:hover:bg-(--components-button-secondary-button-secondary-hover) hover:before:opacity-100 dark:hover:text-(--text-text-white-secondary) focus:text-(--text-text-accent) focus:border-(--border-border-accent) focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  tertiary: "hover:bg-(--components-button-tertiary-button-tertiary-hover) dark:hover:text-[var(--text-text-white-secondary)] hover:border-[var(--border-border-tertiary-hover)] dark:hover:border-[var(--components-button-tertiary-button-tertiary-hover)] hover:overflow-hidden focus:bg-white dark:focus:bg-[var(--components-button-tertiary-button-tertiary-focused)] focus:overflow-visible focus:before:opacity-100 focus:after:opacity-100",
  error: "hover:bg-(--components-button-functional-desctructive-error-button-error-hover) focus:bg-(--components-button-functional-desctructive-error-button-error-focused) focus:border-(--border-border-error) dark:focus:border-(--border-border-error-subtle) focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  success: "hover:bg-(--components-button-functional-success-button-success-hover) focus:bg-(--components-button-functional-success-button-success-focused) focus:border-(--border-border-success) dark:focus:border-(--border-border-success-sublte) focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  tab: "hover:rounded-t-xl hover:bg-(--components-button-tab-button-tab) hover:border-[var(--border-border-hover)] focus:rounded-t-xl focus:bg-white dark:focus:bg-[var(--components-button-tab-button-tab-active)] focus:border-transparent focus:overflow-visible focus:before:opacity-100 focus:after:opacity-100",
  ghost: "hover:bg-(--components-button-ghost-button-ghost-hover) focus:border-[var(--colors-text-white-default)] focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  text: "hover:text-(--text-text-hover) dark:hover:text-(--text-text-link) focus:border-[var(--text-text-white-default)] focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  "success-secondary": "hover:border-(--components-button-functional-success-button-success) focus:border-(--components-button-functional-success-button-success-focused) focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  "error-secondary": "hover:border-(--components-button-functional-desctructive-error-button-error-hover) focus:border-(--components-button-functional-desctructive-error-button-error-focused) focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  "text-error": "hover:text-(--components-button-functional-desctructive-error-button-error-hover) focus:border-[var(--text-text-white-default)] focus:shadow-[0px_0px_2px_0px_var(--background-background-hover)]",
  "error-text": "hover:text-(--components-button-functional-desctructive-error-button-error-hover) focus:text-(--components-button-functional-desctructive-error-button-error-focused) focus:border-(--components-button-functional-desctructive-error-button-error-focused)"
}, Jm = ["innerHTML"], Zm = ["src", "alt"], Ym = ["src", "alt"], Xm = ["src"], Qm = "relative border-solid border-[1px] box-border inline-flex items-center text-left font-inter overflow-hidden disabled:cursor-not-allowed disabled:shadow-none aria-disabled:cursor-not-allowed aria-disabled:shadow-none transition-[border-color,background-color,border-radius,box-shadow,color,opacity] duration-300 cursor-pointer focus-visible:shadow-[0px_0px_2px_#7c86ff] focus-visible:border-royalblue focus-visible:aria-disabled:shadow-[0px_0px_2px_#7c86ff] focus-visible:aria-disabled:border-royalblue focus:outline-none before:content-[''] before:absolute before:inset-0 before:rounded-[9999px] before:opacity-0 before:transition-opacity before:duration-300 before:z-0 after:content-[''] after:absolute after:inset-0 after:opacity-0 after:transition-opacity after:duration-300 after:z-[1]", _m = /* @__PURE__ */ ge({
  __name: "Button",
  props: {
    as: { default: "button" },
    variant: { default: "primary" },
    label: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    ariaDisabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    active: { type: Boolean, default: !1 },
    type: { default: "button" },
    iconAlt: { default: void 0 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = {
      // xxs: compact pill — 20px line-height (leading-5) + 1px border ×2 + 3px
      // padding ×2 (py-0.75) = 28px total height (Figma-verified).
      // Used in dense dark-surface contexts such as the Float Action Bar (OP-5300).
      xxs: {
        button: "py-0.75 px-3 gap-1.5 text-sm",
        text: "leading-5",
        icon: "h-4 w-4"
      },
      xs: {
        button: "py-1.5 px-3 gap-1.5 text-xs",
        text: "leading-5",
        icon: "h-3.5 w-3.5"
      },
      sm: {
        button: "py-2 px-3 gap-1.5 text-sm",
        text: "leading-5",
        icon: "h-4 w-4"
      },
      md: {
        button: "h-10 py-2.5 px-4 gap-1.5 text-sm",
        text: "leading-5",
        icon: "h-4 w-4"
      },
      lg: {
        button: "py-3 px-5 gap-1.5 text-base",
        text: "leading-6",
        icon: "h-4 w-4"
      },
      xl: {
        button: "py-3.5 px-6 gap-1.5 text-base",
        text: "leading-6",
        icon: "h-5 w-5"
      }
    }, a = {
      // xxs: 28×28px icon-only — matches the regular xxs button's total height (border-box),
      // for compact dark-surface toolbars (e.g. Float Action Bar, OP-5300)
      xxs: "h-7! w-7! p-1! justify-center! px-1! py-1!",
      xs: "h-8! w-8! p-2! justify-center! px-2! py-2!",
      sm: "h-9! w-9! p-2.5! justify-center! px-2.5! py-2.5!",
      md: "h-10! w-10! p-2.5! justify-center! px-2.5! py-2.5!",
      lg: "h-12! w-12! p-3.5! justify-center! px-3.5! py-3.5!",
      xl: "h-[52px]! w-[52px]! p-4! justify-center! px-4! py-4!"
    }, l = y(() => o[n.size]), s = y(() => n.disabled || n.loading), i = y(() => n.as !== "a" || n.ariaDisabled || s.value ? "" : Km[n.variant]), d = y(() => {
      const k = n.iconOnly && n.iconAlt || void 0;
      return n.as === "button" ? {
        type: n.type,
        disabled: s.value,
        "aria-disabled": n.ariaDisabled ? "true" : void 0,
        "aria-label": k
      } : {
        "aria-disabled": n.ariaDisabled || s.value ? "true" : void 0,
        "aria-label": k
      };
    }), u = y(() => n.active ? n.variant === "tertiary" ? "active outline-none bg-white dark:bg-[var(--colors-background-black-default)] overflow-visible before:opacity-100 after:opacity-100" : n.variant === "tab" ? "rounded-t-xl bg-white dark:bg-[var(--colors-background-black-default)] border-transparent overflow-visible before:opacity-100 after:opacity-100" : "" : ""), f = y(() => {
      const k = [Qm, qm[n.variant], l.value.button];
      return i.value && k.push(i.value), n.fullWidth && k.push("w-full justify-center"), n.iconOnly && k.push(a[n.size]), u.value && k.push(u.value), k;
    }), h = y(() => {
      const k = ["relative z-10", l.value.icon], L = s.value || n.ariaDisabled;
      return !L && n.variant !== "error" && n.variant !== "success" && n.variant !== "error-text" && k.push("dark:invert"), L && k.push("grayscale", "opacity-60"), k;
    });
    function b(k) {
      return !!k && !k.includes("/");
    }
    const m = y(() => ["relative z-10 leading-none"]), v = y(() => n.iconOnly ? `${n.variant}-icon-button` : `${n.variant}-button`);
    function x(k) {
      if (n.ariaDisabled) {
        n.as === "a" && k.preventDefault();
        return;
      }
      if (n.as === "a" && s.value) {
        k.preventDefault();
        return;
      }
      r("click", k);
    }
    return (k, L) => (c(), te(Wt(e.as), Je({ "data-testid": v.value }, d.value, {
      class: f.value,
      onClick: x
    }), {
      default: pe(() => [
        e.loading ? (c(), p("span", {
          key: 0,
          class: S(["relative z-10 animate-spin", l.value.icon]),
          innerHTML: T(Rf)
        }, null, 10, Jm)) : w("", !0),
        !e.loading && e.iconOnly && (e.iconLeft || e.iconRight) ? (c(), p(Z, { key: 1 }, [
          b(e.iconLeft || e.iconRight) ? (c(), p("i", {
            key: 0,
            class: S([e.iconLeft || e.iconRight, m.value]),
            "aria-hidden": "true"
          }, null, 2)) : (c(), p("img", {
            key: 1,
            src: e.iconLeft || e.iconRight,
            class: S(h.value),
            alt: e.iconAlt || ""
          }, null, 10, Zm))
        ], 64)) : w("", !0),
        e.iconOnly ? w("", !0) : (c(), p(Z, { key: 2 }, [
          !e.loading && e.iconLeft ? (c(), p(Z, { key: 0 }, [
            b(e.iconLeft) ? (c(), p("i", {
              key: 0,
              class: S([e.iconLeft, m.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), p("img", {
              key: 1,
              src: e.iconLeft,
              class: S(h.value),
              alt: e.iconAlt || ""
            }, null, 10, Ym))
          ], 64)) : w("", !0),
          e.label || k.$slots.default ? (c(), p("div", {
            key: 1,
            class: S(["relative z-10 font-medium", l.value.text])
          }, [
            be(k.$slots, "default", {}, () => [
              Ze($(e.label), 1)
            ], !0)
          ], 2)) : w("", !0),
          !e.loading && e.iconRight ? (c(), p(Z, { key: 2 }, [
            b(e.iconRight) ? (c(), p("i", {
              key: 0,
              class: S([e.iconRight, m.value]),
              "aria-hidden": "true"
            }, null, 2)) : (c(), p("img", {
              key: 1,
              src: e.iconRight,
              class: S(h.value),
              alt: ""
            }, null, 10, Xm))
          ], 64)) : w("", !0)
        ], 64))
      ]),
      _: 3
    }, 16, ["data-testid", "class"]));
  }
}), $e = /* @__PURE__ */ He(_m, [["__scopeId", "data-v-b827c18d"]]), tV = /* @__PURE__ */ ge({
  __name: "WeekNavigator",
  props: {
    weekStartDate: {},
    weekEndDate: {},
    locale: { default: "en" },
    previousLabel: { default: "Previous week" },
    nextLabel: { default: "Next week" },
    todayLabel: { default: "Today" },
    previousDisabled: { type: Boolean, default: !1 },
    todayDisabled: { type: Boolean, default: !1 },
    previousDisabledReason: { default: void 0 },
    todayDisabledReason: { default: void 0 },
    showToday: { type: Boolean, default: !0 },
    fullWidth: { type: Boolean, default: !1 }
  },
  emits: ["previous-week", "next-week", "today-week"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => {
      const a = new Intl.DateTimeFormat(n.locale, {
        day: "numeric",
        month: "long",
        timeZone: "UTC"
      }), l = new Intl.DateTimeFormat(n.locale, {
        day: "numeric",
        month: "long",
        ...n.fullWidth ? { year: "numeric" } : {},
        timeZone: "UTC"
      }), s = a.format(/* @__PURE__ */ new Date(`${n.weekStartDate}T00:00:00Z`)), i = l.format(/* @__PURE__ */ new Date(`${n.weekEndDate}T00:00:00Z`));
      return `${s} - ${i}`;
    });
    return (a, l) => (c(), p("div", {
      class: S(["flex flex-wrap items-center gap-(--spacing-2)", e.fullWidth ? "w-full" : void 0])
    }, [
      e.showToday ? (c(), te(Ye, {
        key: 0,
        text: e.todayDisabledReason ?? "",
        disabled: !e.todayDisabled || !e.todayDisabledReason,
        tabindex: e.todayDisabled && e.todayDisabledReason ? 0 : void 0
      }, {
        default: pe(() => [
          ae($e, {
            variant: "secondary",
            size: "sm",
            label: e.todayLabel,
            disabled: e.todayDisabled,
            "data-testid": "week-navigator-today",
            onClick: l[0] || (l[0] = (s) => r("today-week"))
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }, 8, ["text", "disabled", "tabindex"])) : w("", !0),
      g("div", {
        class: S(["flex items-center gap-(--spacing-2)", e.fullWidth ? "w-full justify-between" : void 0])
      }, [
        ae(Ye, {
          text: e.previousDisabledReason ?? "",
          disabled: !e.previousDisabled || !e.previousDisabledReason,
          tabindex: e.previousDisabled && e.previousDisabledReason ? 0 : void 0
        }, {
          default: pe(() => [
            ae($e, {
              variant: "ghost",
              size: e.fullWidth ? "md" : "sm",
              "icon-only": "",
              "icon-left": "ri-arrow-left-line",
              "icon-alt": e.previousLabel,
              disabled: e.previousDisabled,
              onClick: l[1] || (l[1] = (s) => r("previous-week"))
            }, null, 8, ["size", "icon-alt", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"]),
        g("p", {
          "aria-live": "polite",
          class: S([
            "font-(--weight-semi-bold)",
            e.fullWidth ? "flex-1 text-center text-(length:--size-xl) leading-(--line-height-xl)" : "text-(length:--size-m)"
          ])
        }, $(o.value), 3),
        ae($e, {
          variant: "ghost",
          size: e.fullWidth ? "md" : "sm",
          "icon-only": "",
          "icon-right": "ri-arrow-right-line",
          "icon-alt": e.nextLabel,
          onClick: l[2] || (l[2] = (s) => r("next-week"))
        }, null, 8, ["size", "icon-alt"])
      ], 2)
    ], 2));
  }
}), ev = {
  "data-testid": "metric-card-simple",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-2"
}, tv = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, nv = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, rv = /* @__PURE__ */ ge({
  __name: "MetricCardSimple",
  props: {
    value: { default: "" },
    label: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", ev, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        n[0] || (n[0] = g("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        n[1] || (n[1] = g("div", { class: "skeleton h-6 w-40" }, null, -1))
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("b", tv, $(e.value), 1),
        g("div", nv, $(e.label), 1)
      ], 64))
    ]));
  }
}), ov = {
  "data-testid": "metric-card-with-icon",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border gap-3.5"
}, av = { class: "h-16 w-[63.9px] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border box-border flex items-center justify-center" }, lv = ["src", "alt"], sv = { class: "flex flex-col items-start gap-2" }, iv = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, dv = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, uv = /* @__PURE__ */ ge({
  __name: "MetricCardWithIcon",
  props: {
    value: { default: "" },
    label: { default: "" },
    icon: { default: void 0 },
    iconAlt: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", ov, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        n[0] || (n[0] = g("div", { class: "skeleton h-16 w-[63.9px] rounded-num-12" }, null, -1)),
        n[1] || (n[1] = g("div", { class: "flex flex-col items-start gap-2 flex-1" }, [
          g("div", { class: "skeleton h-[29px] w-24" }),
          g("div", { class: "skeleton h-6 w-40" })
        ], -1))
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("div", av, [
          be(t.$slots, "icon", {}, () => [
            e.icon ? (c(), p("img", {
              key: 0,
              src: e.icon,
              alt: e.iconAlt,
              class: "h-9 w-9 relative"
            }, null, 8, lv)) : w("", !0)
          ])
        ]),
        g("div", sv, [
          g("b", iv, $(e.value), 1),
          g("div", dv, $(e.label), 1)
        ])
      ], 64))
    ]));
  }
}), cv = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-center p-num-24 box-border gap-3" }, fv = { class: "flex flex-col items-center gap-2" }, hv = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, bv = { class: "relative text-num-16 leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, pv = { class: "rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 gap-1 text-center text-[12px]" }, gv = ["src"], mv = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, vv = /* @__PURE__ */ ge({
  __name: "MetricCardWithTrend",
  props: {
    value: { default: "" },
    label: { default: "" },
    trendText: { default: "" },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", cv, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        n[0] || (n[0] = g("div", { class: "flex flex-col items-center gap-2" }, [
          g("div", { class: "skeleton h-[29px] w-24" }),
          g("div", { class: "skeleton h-6 w-40" })
        ], -1)),
        n[1] || (n[1] = g("div", { class: "skeleton h-5 w-32 rounded-sm" }, null, -1))
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("div", fv, [
          g("b", hv, $(e.value), 1),
          g("div", bv, $(e.label), 1)
        ]),
        g("div", pv, [
          be(t.$slots, "trend-icon", {}, () => [
            e.trendIcon ? (c(), p("img", {
              key: 0,
              src: e.trendIcon,
              alt: "trend",
              class: "h-3 w-3 relative"
            }, null, 8, gv)) : w("", !0)
          ]),
          g("div", mv, $(e.trendText), 1)
        ])
      ], 64))
    ]));
  }
}), xv = {
  "data-testid": "metric-card-with-badge",
  class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start justify-center p-num-24 box-border gap-2 relative"
}, yv = { class: "relative leading-num-29 text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter z-0" }, kv = { class: "relative text-num-16 leading-6 text-slategray dark:text-[var(--colors-text-white-secondary)] z-1" }, wv = {
  key: 0,
  class: "absolute top-[10px] right-[11px] rounded-sm bg-honeydew dark:bg-[var(--colors-background-success)] flex items-center justify-center py-0.5 px-1 z-2 text-center text-[12px]"
}, Cv = { class: "relative leading-num-20 font-medium dark:text-[var(--colors-text-success-strong)]" }, Sv = /* @__PURE__ */ ge({
  __name: "MetricCardWithBadge",
  props: {
    value: { default: "" },
    label: { default: "" },
    badgeText: { default: "" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", xv, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        n[0] || (n[0] = g("div", { class: "skeleton h-[29px] w-24" }, null, -1)),
        n[1] || (n[1] = g("div", { class: "skeleton h-6 w-40" }, null, -1)),
        n[2] || (n[2] = g("div", { class: "skeleton h-5 w-12 rounded-sm absolute top-[10px] right-[11px]" }, null, -1))
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("b", yv, $(e.value), 1),
        g("div", kv, $(e.label), 1),
        e.badgeText ? (c(), p("div", wv, [
          g("div", Cv, $(e.badgeText), 1)
        ])) : w("", !0)
      ], 64))
    ]));
  }
}), $v = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex items-center p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, Iv = {
  key: 0,
  class: "flex-1 flex flex-col items-start gap-3"
}, Tv = {
  key: 1,
  class: "flex-1 flex flex-col items-start gap-3"
}, Lv = { class: "flex items-center gap-2" }, Mv = ["src"], Ev = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, Av = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, Dv = { class: "flex items-center gap-2 text-[14px] text-text-success dark:text-[var(--colors-text-success-subtle)]" }, Rv = { class: "flex items-center justify-end" }, Bv = ["src"], Ov = { class: "relative leading-num-20 font-medium" }, Pv = { class: "relative leading-num-20 text-dimgray dark:text-[var(--colors-text-white-secondary)]" }, zv = /* @__PURE__ */ ge({
  __name: "MetricCardWithChart",
  props: {
    title: { default: "" },
    value: { default: "" },
    trendValue: { default: "" },
    trendLabel: { default: "" },
    chartIcon: { default: void 0 },
    trendIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", $v, [
      e.loading ? (c(), p("div", Iv, [...n[0] || (n[0] = [
        mo('<div class="flex items-center gap-2"><div class="skeleton h-5 w-5 rounded"></div><div class="skeleton h-6 w-28"></div></div><div class="skeleton h-[29px] w-32"></div><div class="flex items-center gap-2"><div class="skeleton h-5 w-16"></div><div class="skeleton h-5 w-24"></div></div>', 3)
      ])])) : (c(), p("div", Tv, [
        g("div", Lv, [
          be(t.$slots, "chart-icon", {}, () => [
            e.chartIcon ? (c(), p("img", {
              key: 0,
              src: e.chartIcon,
              alt: "chart",
              class: "h-5 w-5 relative"
            }, null, 8, Mv)) : w("", !0)
          ]),
          g("div", Ev, $(e.title), 1)
        ]),
        g("b", Av, $(e.value), 1),
        g("div", Dv, [
          g("div", Rv, [
            be(t.$slots, "trend-icon", {}, () => [
              e.trendIcon ? (c(), p("img", {
                key: 0,
                src: e.trendIcon,
                alt: "trend",
                class: "h-4 w-4 relative"
              }, null, 8, Bv)) : w("", !0)
            ]),
            g("div", Ov, $(e.trendValue), 1)
          ]),
          g("div", Pv, $(e.trendLabel), 1)
        ])
      ]))
    ]));
  }
}), Nv = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start justify-center p-num-24 box-border gap-3 text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, Vv = { class: "self-stretch flex flex-col items-start gap-2" }, Fv = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, Hv = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, Wv = { class: "self-stretch flex flex-col items-start gap-1.5 text-[12px] text-gray-300 dark:text-[var(--colors-text-white-secondary)]" }, jv = { class: "self-stretch flex flex-col items-center relative gap-1" }, Uv = { class: "self-stretch flex items-center" }, Gv = { class: "flex-1 relative leading-num-20 font-medium" }, Is = /* @__PURE__ */ ge({
  __name: "MetricCardProgress",
  props: {
    title: { default: "" },
    value: { default: "" },
    used: { default: 0 },
    total: { default: 0 },
    unit: { default: "" },
    loading: { type: Boolean, default: !1 },
    progressFormat: { type: Function, default: void 0 }
  },
  setup(e) {
    const t = e, n = y(() => t.total <= 0 ? 0 : Math.min(t.used / t.total * 100, 100)), r = y(() => t.total <= 0 || !t.progressFormat ? "" : t.progressFormat(t.used, t.total, t.unit));
    return (o, a) => (c(), p("div", Nv, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        a[0] || (a[0] = mo('<div class="self-stretch flex flex-col items-start gap-2"><div class="skeleton h-6 w-32"></div><div class="skeleton h-[29px] w-24"></div></div><div class="self-stretch flex flex-col items-start gap-1.5"><div class="skeleton self-stretch h-1.5 rounded-num-12"></div><div class="skeleton h-5 w-40"></div></div>', 2))
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("div", Vv, [
          g("div", Fv, $(e.title), 1),
          g("b", Hv, $(e.value), 1)
        ]),
        g("div", Wv, [
          g("div", jv, [
            a[1] || (a[1] = g("div", { class: "self-stretch h-1.5 relative rounded-num-12 bg-gainsboro dark:bg-[var(--colors-background-gray)] z-0" }, null, -1)),
            g("div", {
              style: Ae({ width: `${n.value}%`, left: "0%" }),
              class: "h-1.5 absolute right-0 bottom-0 rounded-num-12 bg-linear-to-r from-[#716ff2] to-[#52dbf5] z-1"
            }, null, 4)
          ]),
          g("div", Uv, [
            g("div", Gv, $(r.value), 1)
          ])
        ])
      ], 64))
    ]));
  }
}), qv = { class: "group-hover:underline group-focus:underline" }, $r = /* @__PURE__ */ ge({
  __name: "ButtonLink",
  props: {
    as: { default: "button" },
    iconLeft: {},
    iconRight: {},
    size: {},
    ariaLabel: {}
  },
  setup(e) {
    return (t, n) => (c(), te(Wt(e.as), Je(e.as === "button" ? { type: "button" } : {}, {
      "aria-label": e.ariaLabel,
      class: [
        "cursor-pointer flex items-center gap-2 py-0.5 leading-5 font-medium text-indigo-700 focus:font-bold focus:text-indigo-600 hover:text-indigo-500 disabled:text-gray-400 group",
        e.size === "s" ? "text-xs" : e.size === "l" ? "text-num-16" : "text-sm"
      ]
    }), {
      default: pe(() => [
        e.iconLeft ? (c(), p("i", {
          key: 0,
          class: S(["text-num-16", e.iconLeft]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0),
        g("span", qv, [
          be(t.$slots, "default")
        ]),
        e.iconRight ? (c(), p("i", {
          key: 1,
          class: S(["text-num-16", e.iconRight]),
          "aria-hidden": "true"
        }, null, 2)) : w("", !0)
      ]),
      _: 3
    }, 16, ["aria-label", "class"]));
  }
}), Kv = { class: "shadow-[0px_0px_4px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-num-12 bg-white dark:bg-[var(--colors-background-black-default)] w-num-301.5 flex flex-col items-start p-num-24 box-border text-num-16 text-slategray dark:text-[var(--colors-text-white-secondary)]" }, Jv = {
  key: 0,
  class: "self-stretch flex flex-col items-start gap-2"
}, Zv = {
  key: 1,
  class: "self-stretch flex flex-col items-start gap-2"
}, Yv = { class: "self-stretch flex items-center justify-between gap-5" }, Xv = { class: "flex items-center gap-1.5" }, Qv = { class: "relative leading-6 dark:text-[var(--colors-text-white-secondary)]" }, _v = ["src"], ex = { class: "relative text-[24px] leading-num-29 text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter" }, tx = { class: "relative leading-6 text-text-body dark:text-[var(--colors-text-white-secondary)]" }, nx = /* @__PURE__ */ ge({
  __name: "MetricCardAction",
  props: {
    title: { default: "" },
    value: { default: "" },
    subtitle: { default: "" },
    actionText: { default: "" },
    dropdownIcon: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["action"],
  setup(e) {
    return (t, n) => (c(), p("div", Kv, [
      e.loading ? (c(), p("div", Jv, [...n[1] || (n[1] = [
        mo('<div class="self-stretch flex items-center justify-between gap-5"><div class="skeleton h-6 w-24"></div><div class="skeleton h-8 w-16 rounded"></div></div><div class="skeleton h-[29px] w-32"></div><div class="skeleton h-6 w-40"></div>', 3)
      ])])) : (c(), p("div", Zv, [
        g("div", Yv, [
          g("div", Xv, [
            g("div", Qv, $(e.title), 1),
            be(t.$slots, "dropdown-icon", {}, () => [
              e.dropdownIcon ? (c(), p("img", {
                key: 0,
                src: e.dropdownIcon,
                alt: "dropdown",
                class: "h-[18px] w-[18px] relative"
              }, null, 8, _v)) : w("", !0)
            ])
          ]),
          e.actionText ? (c(), te(T($e), {
            key: 0,
            variant: "secondary",
            label: e.actionText,
            size: "sm",
            onClick: n[0] || (n[0] = (r) => t.$emit("action"))
          }, null, 8, ["label"])) : w("", !0)
        ]),
        g("b", ex, $(e.value), 1),
        g("div", tx, $(e.subtitle), 1)
      ]))
    ]));
  }
}), rx = { class: "w-full h-full relative rounded-num-12 bg-gray-100 dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-4 box-border overflow-hidden text-left text-[24px] text-gray-300 dark:text-[var(--colors-text-white-default)] font-inter p-5" }, ox = { class: "flex flex-wrap gap-4" }, nV = /* @__PURE__ */ ge({
  __name: "MetricCardsDemo",
  setup(e) {
    const t = () => {
    }, n = (a, l, s) => `${a} ${s} of ${l} ${s} used`, r = (a, l) => `${a} of ${l}`, o = (a, l) => `${a.toLocaleString("fr-FR")} sur ${l.toLocaleString("fr-FR")} envoyés`;
    return (a, l) => (c(), p("div", rx, [
      g("div", ox, [
        ae(T(rv), {
          value: "163.4k",
          label: "Last 7 days website visits"
        }),
        ae(T(vv), {
          value: "163.4k",
          label: "Last 7 days website visits",
          "trend-text": "+10% vs last week"
        }),
        ae(T(uv), {
          value: "163.4k",
          label: "Last 7 days website visits"
        }, {
          icon: pe(() => [...l[0] || (l[0] = [
            g("div", { class: "h-9 w-9 bg-gray-200 rounded-sm" }, null, -1)
          ])]),
          _: 1
        }),
        ae(T(Sv), {
          value: "163.4k",
          label: "Last 7 days website visits",
          "badge-text": "+10%"
        }),
        ae(T(zv), {
          title: "Website visits",
          value: "163.4k",
          "trend-value": "10%",
          "trend-label": "vs last 3 months"
        }, {
          "chart-icon": pe(() => [...l[1] || (l[1] = [
            g("div", { class: "h-5 w-5 bg-gray-200 rounded-sm" }, null, -1)
          ])]),
          "trend-icon": pe(() => [...l[2] || (l[2] = [
            g("div", { class: "h-4 w-4 bg-border-success-strong rounded-sm" }, null, -1)
          ])]),
          _: 1
        }),
        ae(T(Is), {
          title: "Space remaining",
          value: "768.2GB",
          used: 232,
          total: 1e3,
          unit: "GB",
          "progress-format": n
        }),
        ae(T(Is), {
          title: "Delivered",
          value: "4,200",
          used: 4200,
          total: 5e3,
          "progress-format": r
        }),
        ae(T(Is), {
          title: "Envoyés",
          value: "1 234",
          used: 1234,
          total: 5e3,
          "progress-format": o
        }),
        ae(T(nx), {
          title: "USD Balance",
          value: "$768.99",
          subtitle: "Available to payout",
          "action-text": "View",
          onAction: t
        })
      ])
    ]));
  }
}), ax = ["src", "alt"], lx = /* @__PURE__ */ ge({
  __name: "Avatar",
  props: {
    img: { default: void 0 },
    name: {},
    email: { default: void 0 },
    size: { default: "md" },
    entity: { default: "contact" },
    avatarStyle: { default: "circle" },
    logo: { type: Boolean, default: !1 },
    presentational: { type: Boolean, default: !1 },
    as: { default: "div" }
  },
  setup(e) {
    const t = e, n = N(!1), r = () => {
      n.value = !0;
    };
    we(
      () => t.img,
      () => {
        n.value = !1;
      }
    );
    const o = {
      xs: { container: "h-[18px] w-[18px]", text: "text-[8px]" },
      sm: { container: "h-6 w-6", text: "text-xs" },
      md: { container: "h-9 w-9", text: "text-sm" },
      lg: { container: "h-11 w-11", text: "text-lg" },
      xl: { container: "h-14 w-14", text: "text-xl" },
      "2xl": { container: "h-16 w-16", text: "text-2xl" }
    }, a = y(() => o[t.size]), l = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-xs)",
      md: "rounded-(--border-border-radius-rounded-sm)",
      lg: "rounded-(--border-border-radius-rounded-l)",
      xl: "rounded-(--border-border-radius-rounded-l)",
      "2xl": "rounded-(--border-border-radius-rounded-l)"
    }, s = y(
      () => t.avatarStyle === "square" ? l[t.size] : "rounded-full"
    ), i = (u) => u.normalize("NFD").replace(/[\u0300-\u036f]/g, "").charAt(0).toUpperCase(), d = y(() => {
      var b;
      const u = (b = t.name) == null ? void 0 : b.trim();
      if (!u)
        return "?";
      const f = u.split(/\s+/), h = t.entity === "organisation" ? 1 : 2;
      return f.slice(0, h).map(i).join("");
    });
    return (u, f) => (c(), te(Wt(t.as), {
      class: S(["avatar-container flex shrink-0 items-center justify-center overflow-hidden", [a.value.container, s.value, { "avatar-container--logo": t.logo && !!t.img && !n.value }]]),
      role: e.presentational ? void 0 : "img",
      "aria-hidden": e.presentational ? "true" : void 0,
      "aria-label": e.presentational ? void 0 : t.name
    }, {
      default: pe(() => [
        t.img && !n.value ? (c(), p("img", {
          key: 0,
          src: t.img,
          alt: e.presentational ? "" : t.name,
          class: S(["h-full w-full", t.logo ? "object-contain" : "object-cover"]),
          loading: "lazy",
          onError: r
        }, null, 42, ax)) : (c(), p("span", {
          key: 1,
          class: S(["font-medium text-(--text-text-body-subtle)", a.value.text])
        }, $(d.value), 3))
      ]),
      _: 1
    }, 8, ["class", "role", "aria-hidden", "aria-label"]));
  }
}), Cn = /* @__PURE__ */ He(lx, [["__scopeId", "data-v-1b476914"]]), sx = ["data-testid", "disabled", "aria-disabled"], ix = {
  key: 0,
  class: "dropdown-icon ri-loader-4-line animate-spin text-base leading-none shrink-0",
  "aria-hidden": "true"
}, dx = ["src"], ux = {
  key: 0,
  class: "flex shrink-0 items-center"
}, Hr = /* @__PURE__ */ ge({
  __name: "DropdownItemButton",
  props: {
    item: {},
    variant: { default: "default" },
    fallbackTestId: { default: "dropdown-item" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => !!(n.item.disabled || n.item.loading)), a = y(() => o.value && !!n.item.tooltip);
    function l() {
      o.value || r("click", n.item);
    }
    function s(i) {
      return i.startsWith("ri-");
    }
    return (i, d) => (c(), p("button", {
      type: "button",
      role: "menuitem",
      "data-testid": e.item.testId || e.fallbackTestId,
      disabled: a.value ? void 0 : o.value,
      "aria-disabled": a.value ? "true" : void 0,
      class: S(["group inline-flex w-full items-center text-left rounded-(--border-border-radius-rounded-sm) transition-colors disabled:opacity-50 disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:cursor-not-allowed", [
        o.value ? "cursor-not-allowed" : "cursor-pointer",
        e.variant === "nav" ? ["py-1 px-0", e.item.active ? "text-(--colors-text-link)" : "text-(--colors-text-body)", "hover:text-(--colors-text-link)"] : ["px-2 py-1.5 min-h-8 hover:bg-background-hover dark:hover:bg-white/8 text-(--colors-text-black-default)", e.item.active && "bg-background-hover dark:text-(--colors-text-black-default)"]
      ]]),
      onClick: l
    }, [
      g("div", {
        class: S(["me-auto flex items-center gap-1.5 font-medium leading-5", e.variant === "default" && [
          "text-(length:--size-m) group-hover:text-text-black-default dark:group-hover:text-text-black-default dark:text-(--colors-text-white-default)",
          e.item.active ? "text-(--colors-text-heading)" : "text-(--colors-text-body)"
        ]])
      }, [
        e.item.loading ? (c(), p("i", ix)) : e.item.icon ? (c(), p(Z, { key: 1 }, [
          s(e.item.icon) ? (c(), p("i", {
            key: 0,
            class: S([
              e.item.icon,
              "dropdown-icon text-base leading-none shrink-0",
              e.item.danger && "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)"
            ]),
            "aria-hidden": "true"
          }, null, 2)) : (c(), p("img", {
            key: 1,
            class: S(["dropdown-icon relative h-4 w-4 transition dark:invert dark:filter dark:group-hover:invert-0", e.item.active && "dark:invert-0"]),
            src: e.item.icon,
            alt: ""
          }, null, 10, dx))
        ], 64)) : w("", !0),
        g("span", {
          class: S(["relative me-1.5 leading-5 font-medium", !e.item.icon && e.item.danger && "text-(--text-text-error-strong) group-hover:text-(--text-text-error-strong)"])
        }, $(e.item.label), 3)
      ], 2),
      e.item.hasSwitch ? (c(), p("div", ux, [
        g("div", {
          class: S(["relative h-5 w-9 rounded-full border transition-colors duration-200", e.item.switchChecked ? "border-(--colors-border-black-default) bg-(--colors-background-black-default) dark:border-(--colors-border-white-default) dark:bg-white" : "border-(--colors-border-secondary-button) bg-(--colors-background-white-secondary) dark:bg-white/10"])
        }, [
          g("div", {
            class: S(["absolute top-px h-4 w-4 rounded-full shadow-sm transition-transform duration-200", e.item.switchChecked ? "start-4.5 bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-black-default)" : "start-px bg-(--colors-background-black-default) dark:bg-white"])
          }, null, 2)
        ], 2)
      ])) : w("", !0)
    ], 10, sx));
  }
}), cx = {
  key: 0,
  class: "flex items-center"
}, fx = { class: "flex items-center gap-0.5" }, hx = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)" }, bx = {
  key: 0,
  class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)"
}, px = ["aria-expanded", "aria-label"], gx = ["src"], mx = {
  key: 1,
  class: "relative leading-[20px] font-medium dark:text-(--colors-text-white-default)"
}, vx = ["title"], xx = ["src"], yx = ["src"], kx = ["role", "aria-labelledby"], wx = {
  key: 0,
  class: "flex w-full items-center space-x-1.5 rounded-(--border-border-radius-rounded-sm) bg-(--colors-background-white-secondary) p-2 px-2.5"
}, Cx = { class: "flex-1 min-w-0 text-(length:--size-m)" }, Sx = { class: "truncate font-semibold text-(--colors-text-heading)" }, $x = { class: "truncate text-(--colors-text-body)" }, Ix = {
  key: 0,
  class: "background-background-success ms-auto rounded-md bg-(--colors-background-success) px-1 py-0.5 text-(length:--size-sm) text-(--colors-text-black-default)"
}, Tx = {
  key: 1,
  class: "absolute top-3 right-3"
}, Lx = {
  key: 2,
  role: "presentation",
  "data-testid": "dropdown-menu-header",
  class: "w-full px-2 pt-0.5 pb-1 leading-5 font-medium text-(length:--size-sm) text-(--colors-text-body-subtle)"
}, Mx = ["id"], Ex = { class: "overflow-y-auto flex-1 min-h-0 pr-6" }, Ax = {
  key: 0,
  "data-testid": "dropdown-megamenu-col-header",
  role: "presentation",
  class: "leading-5 font-semibold text-(length:--size-sm) text-(--colors-text-body-subtle)"
}, Dx = {
  key: 1,
  class: "flex flex-col gap-3 sm:flex-row sm:items-start"
}, Rx = {
  key: 2,
  class: "mt-1.5 border-t border-(--color-border-base-soft)"
}, Bx = /* @__PURE__ */ ge({
  __name: "Dropdown",
  props: {
    label: { default: "Dropdown" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    triggerIconInfo: { default: void 0 },
    triggerIconInfoTooltip: { default: void 0 },
    items: { default: () => [] },
    groups: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    menuWidth: { default: "auto" },
    fullWidth: { type: Boolean, default: !1 },
    menuAlign: { default: "left" },
    fieldLabel: { default: void 0 },
    required: { type: Boolean, default: !1 },
    avatar: { default: void 0 },
    ghost: { type: Boolean, default: !1 },
    tab: { type: Boolean, default: !1 },
    profileType: {},
    ariaLabel: { default: void 0 },
    menuHeader: { default: void 0 },
    bare: { type: Boolean, default: !1 },
    menuItemVariant: { default: "default" },
    columns: { default: void 0 },
    closeable: { type: Boolean, default: !1 },
    closeLabel: { default: void 0 },
    menuOffset: { default: 6 }
  },
  setup(e, { expose: t }) {
    const n = e, r = y(() => {
      var C;
      if (n.ariaLabel) return n.ariaLabel;
      if (n.avatar) {
        const B = (C = n.avatar.name) == null ? void 0 : C.trim();
        return B ? `Open account menu, ${B}` : "Open account menu";
      }
    }), o = (C) => {
      !a.value && (C.key === "ArrowDown" || C.key === "ArrowUp") && (C.preventDefault(), a.value = !0);
    }, a = N(n.defaultOpen), l = N(null), s = N(null), i = N(null), d = Ke(), u = () => {
      a.value = !a.value;
    }, f = () => {
      a.value = !1;
    }, h = (C) => {
      var D, re;
      const B = C.target, I = ((D = i.value) == null ? void 0 : D.contains(B)) ?? !1, M = ((re = l.value) == null ? void 0 : re.contains(B)) ?? !1;
      !I && !M && f();
    };
    Qe(() => document.addEventListener("mousedown", h)), nt(() => document.removeEventListener("mousedown", h));
    let b = null;
    const m = () => {
      const C = s.value ?? i.value;
      !C || !l.value || (b == null || b.destroy(), b = vo(C, l.value, {
        strategy: "fixed",
        placement: n.menuAlign === "right" ? "bottom-end" : "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, n.menuOffset] } },
          { name: "flip", options: { fallbackPlacements: n.menuAlign === "right" ? ["top-end", "top-start"] : ["top-start", "top-end"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          // Disable GPU acceleration so Popper uses top/left instead of transform,
          // avoiding conflict with the Vue Transition's transform: scale(...)
          { name: "computeStyles", options: { gpuAcceleration: !1 } }
        ]
      }));
    }, v = () => {
      b == null || b.destroy(), b = null;
    };
    we(a, async (C) => {
      C ? (await Pe(), m(), k()) : v();
    }), nt(() => v());
    const x = () => l.value ? Array.from(l.value.querySelectorAll('[role="menuitem"]')) : [], k = () => {
      Pe(() => {
        var C;
        return (C = x()[0]) == null ? void 0 : C.focus();
      });
    }, L = (C) => {
      var I;
      const B = x();
      (I = B[Math.max(0, Math.min(C, B.length - 1))]) == null || I.focus();
    }, P = (C) => {
      const B = x(), I = document.activeElement, M = B.indexOf(I);
      switch (C.key) {
        case "ArrowDown":
          C.preventDefault(), L(M < B.length - 1 ? M + 1 : 0);
          break;
        case "ArrowUp":
          C.preventDefault(), L(M > 0 ? M - 1 : B.length - 1);
          break;
        case "Home":
          C.preventDefault(), L(0);
          break;
        case "End":
          C.preventDefault(), L(B.length - 1);
          break;
        case "Escape":
          V(C);
          break;
        case "Tab":
          W(), f();
          break;
      }
    }, E = /* @__PURE__ */ new Map(), O = (C) => (B) => {
      B ? E.set(C, B) : E.delete(C);
    }, R = () => {
      for (const C of E.values())
        if (C.isVisible) return C;
    }, V = (C) => {
      C.stopPropagation(), C.preventDefault();
      const B = R();
      if (B) {
        B.hide();
        return;
      }
      f(), Pe(() => W());
    }, J = (C) => {
      a.value && V(C);
    }, F = y(() => {
      var B;
      if (!n.columns || !((B = n.groups) != null && B.length)) return null;
      const C = n.groups.filter((I) => I.items.length > 0);
      return C.length > 0 ? C : null;
    }), A = y(
      () => F.value ? Math.min(F.value.length, n.columns ?? F.value.length) : 0
    ), j = y(() => {
      if (!n.columns || F.value) return null;
      const C = Math.ceil(n.items.length / n.columns), B = Array.from({ length: n.columns }, () => []);
      return n.items.forEach((I, M) => {
        const D = Math.floor(M / C);
        B[D] && B[D].push(I);
      }), B.filter((I) => I.length > 0);
    }), _ = y(() => !!(F.value || j.value)), U = (C) => {
      C.disabled || C.loading || (C.onClick && C.onClick(), C.hasSwitch || (f(), Pe(() => W())));
    }, W = () => {
      var B;
      const C = s.value ?? ((B = i.value) == null ? void 0 : B.querySelector(
        'button, [tabindex="0"], [tabindex]:not([tabindex="-1"])'
      ));
      C == null || C.focus();
    }, K = y(() => {
      var C;
      return n.fullWidth ? { width: `${((C = i.value) == null ? void 0 : C.offsetWidth) ?? 0}px` } : n.menuWidth !== "auto" ? { width: n.menuWidth } : n.columns || n.bare ? {} : { minWidth: "208px", maxWidth: "320px" };
    }), le = (C) => !!C && C.startsWith("ri-");
    return t({ isOpen: a }), (C, B) => (c(), p("div", {
      class: S(["text-text-black-default relative text-left dark:text-(--colors-text-white-default)", [e.tab ? "flex h-full items-stretch" : "inline-block", { "w-full": e.fullWidth }]]),
      onKeydown: je(J, ["escape"])
    }, [
      e.fieldLabel ? (c(), p("div", cx, [
        g("div", fx, [
          g("div", hx, $(e.fieldLabel), 1),
          e.required ? (c(), p("div", bx, " * ")) : w("", !0)
        ])
      ])) : w("", !0),
      g("div", {
        class: S(["text-text-black-default relative flex flex-col items-start text-left dark:text-(--colors-text-white-default)", { "w-full": e.fullWidth, "h-full": e.tab }])
      }, [
        g("div", {
          ref_key: "triggerWrapperRef",
          ref: i,
          class: S({ "w-full": e.fullWidth, "h-full": e.tab })
        }, [
          be(C.$slots, "trigger", {
            toggle: u,
            isOpen: a.value
          }, () => [
            g("button", {
              ref_key: "triggerRef",
              ref: s,
              type: "button",
              "data-testid": "dropdown-trigger",
              class: S(["focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2 z-0 cursor-pointer transition-colors", [
                e.tab ? "shrink-0 h-full flex items-center rounded-tl-md rounded-tr-md border-t border-r border-b border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10 duration-200" : [
                  "rounded-[9999px] border border-solid duration-300",
                  e.ghost ? "border-transparent bg-transparent hover:bg-whitesmoke dark:hover:bg-white/10" : "border-border-secondary-button hover:border-royalblue bg-white dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
                ],
                {
                  "w-full justify-between": e.fullWidth,
                  "justify-center": !e.fullWidth && !e.tab
                }
              ]]),
              "aria-expanded": a.value,
              "aria-haspopup": "menu",
              "aria-label": r.value,
              onClick: u,
              onKeydown: o
            }, [
              n.avatar ? (c(), te(Cn, {
                key: 0,
                presentational: "",
                name: n.avatar.name,
                img: n.avatar.img
              }, null, 8, ["name", "img"])) : (c(), p("div", {
                key: 1,
                class: S(["flex items-center gap-1.5 px-3 text-(length:--size-m)", e.tab ? "py-1" : "py-2"])
              }, [
                e.triggerIconLeft ? (c(), p(Z, { key: 0 }, [
                  le(e.triggerIconLeft) ? (c(), p("i", {
                    key: 0,
                    class: S([e.triggerIconLeft, "dropdown-icon text-base leading-none"])
                  }, null, 2)) : (c(), p("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4",
                    src: e.triggerIconLeft,
                    alt: ""
                  }, null, 8, gx))
                ], 64)) : w("", !0),
                e.label ? (c(), p("div", mx, $(e.label), 1)) : w("", !0),
                e.triggerIconInfo ? (c(), p("span", {
                  key: 2,
                  class: "inline-flex items-center",
                  title: e.triggerIconInfoTooltip,
                  onClick: B[0] || (B[0] = Ie(() => {
                  }, ["stop"]))
                }, [
                  le(e.triggerIconInfo) ? (c(), p("i", {
                    key: 0,
                    class: S([e.triggerIconInfo, "dropdown-icon text-lg leading-none"])
                  }, null, 2)) : (c(), p("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4.5 w-4.5",
                    src: e.triggerIconInfo,
                    alt: ""
                  }, null, 8, xx))
                ], 8, vx)) : w("", !0),
                e.triggerIcon ? (c(), p(Z, { key: 3 }, [
                  le(e.triggerIcon) ? (c(), p("i", {
                    key: 0,
                    class: S([
                      e.triggerIcon,
                      "dropdown-icon text-base leading-none transition-transform duration-200 ease-in-out"
                    ]),
                    style: Ae({ transform: a.value ? "rotate(180deg)" : "rotate(0deg)" })
                  }, null, 6)) : (c(), p("img", {
                    key: 1,
                    class: "dropdown-icon relative h-4 w-4 transition-transform duration-200 ease-in-out",
                    style: Ae({ transform: a.value ? "rotate(180deg)" : "rotate(0deg)" }),
                    src: e.triggerIcon,
                    alt: ""
                  }, null, 12, yx))
                ], 64)) : e.label ? (c(), p("svg", {
                  key: 4,
                  class: "relative h-4 w-4 transition-transform duration-200 ease-in-out",
                  style: Ae({ transform: a.value ? "rotate(180deg)" : "rotate(0deg)" }),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [...B[1] || (B[1] = [
                  g("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 4)) : w("", !0)
              ], 2))
            ], 42, px)
          ], !0)
        ], 2),
        (c(), te(cn, { to: "body" }, [
          ae(ot, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: pe(() => [
              a.value ? (c(), p("div", {
                key: 0,
                ref_key: "menuRef",
                ref: l,
                role: e.bare ? void 0 : "menu",
                "aria-labelledby": _.value ? T(d) : void 0,
                "data-testid": "dropdown-menu",
                "data-focus-trap-allow-outside": "",
                class: S(["fixed z-50 bg-white-50-opacity-bold border-border-base-soft border border-solid rounded-(--border-border-radius-rounded-l) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)", [
                  e.menuAlign === "right" ? "origin-top-right" : "origin-top-left",
                  _.value && "relative flex flex-col pt-6 pb-6 pl-6 max-h-[calc(100vh-90px)] max-w-[calc(100vw-32px)]",
                  !e.bare && !_.value && "text-body box-border flex max-h-[min(400px,calc(100vh-24px))] flex-col items-start gap-1.5 overflow-y-auto p-2",
                  e.bare && "max-h-[calc(100vh-90px)] overflow-y-auto"
                ]]),
                style: Ae(K.value),
                onKeydown: P
              }, [
                n.avatar ? (c(), p("div", wx, [
                  ae(Cn, {
                    name: n.avatar.name,
                    img: n.avatar.img
                  }, null, 8, ["name", "img"]),
                  g("div", Cx, [
                    g("div", Sx, $(n.avatar.name), 1),
                    g("div", $x, $(n.avatar.email), 1)
                  ]),
                  n.profileType ? (c(), p("span", Ix, $(n.profileType), 1)) : w("", !0)
                ])) : w("", !0),
                e.closeable ? (c(), p("div", Tx, [
                  ae($e, {
                    "data-testid": "dropdown-close",
                    variant: "ghost",
                    "icon-only": "",
                    size: "sm",
                    "icon-left": "ri-close-line",
                    "icon-alt": e.closeLabel,
                    onClick: f
                  }, null, 8, ["icon-alt"])
                ])) : w("", !0),
                e.menuHeader && !n.avatar && !_.value ? (c(), p("div", Lx, $(e.menuHeader), 1)) : w("", !0),
                be(C.$slots, "menu", { close: f }, () => [
                  _.value ? (c(), p(Z, { key: 0 }, [
                    g("div", {
                      class: S(["mb-3", e.closeable ? "pr-12" : "pr-6"])
                    }, [
                      g("h5", {
                        id: T(d),
                        class: "text-lg font-semibold",
                        style: { color: "var(--text-text-black-default)", "line-height": "var(--line-height-xl)" }
                      }, $(e.menuHeader), 9, Mx)
                    ], 2),
                    g("div", Ex, [
                      F.value ? (c(), p("div", {
                        key: 0,
                        "data-testid": "dropdown-megamenu-groups",
                        class: "dropdown-megamenu-groups",
                        style: Ae({ "--dropdown-megamenu-cols": A.value })
                      }, [
                        (c(!0), p(Z, null, ke(F.value, (I) => (c(), p("div", {
                          key: I.key,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3.5 min-w-0"
                        }, [
                          I.label ? (c(), p("div", Ax, $(I.label), 1)) : w("", !0),
                          (c(!0), p(Z, null, ke(I.items, (M, D) => (c(), p(Z, { key: D }, [
                            M.tooltip ? (c(), te(Ye, {
                              key: 0,
                              ref_for: !0,
                              ref: O(`${I.key}-${D}`),
                              text: M.tooltip,
                              class: "w-full"
                            }, {
                              default: pe(() => [
                                ae(Hr, {
                                  item: M,
                                  variant: e.menuItemVariant,
                                  "fallback-test-id": "dropdown-megamenu-item",
                                  onClick: (re) => U(M)
                                }, null, 8, ["item", "variant", "onClick"])
                              ]),
                              _: 2
                            }, 1032, ["text"])) : (c(), te(Hr, {
                              key: 1,
                              item: M,
                              variant: e.menuItemVariant,
                              "fallback-test-id": "dropdown-megamenu-item",
                              onClick: (re) => U(M)
                            }, null, 8, ["item", "variant", "onClick"]))
                          ], 64))), 128))
                        ]))), 128))
                      ], 4)) : (c(), p("div", Dx, [
                        (c(!0), p(Z, null, ke(j.value, (I, M) => (c(), p("div", {
                          key: M,
                          "data-testid": "dropdown-megamenu-col",
                          class: "flex flex-col items-start gap-3.5 w-full sm:w-52 shrink-0"
                        }, [
                          (c(!0), p(Z, null, ke(I, (D, re) => (c(), p(Z, { key: re }, [
                            D.tooltip ? (c(), te(Ye, {
                              key: 0,
                              ref_for: !0,
                              ref: O(`col-${M}-${re}`),
                              text: D.tooltip,
                              class: "w-full"
                            }, {
                              default: pe(() => [
                                ae(Hr, {
                                  item: D,
                                  variant: e.menuItemVariant,
                                  "fallback-test-id": "dropdown-megamenu-item",
                                  onClick: (se) => U(D)
                                }, null, 8, ["item", "variant", "onClick"])
                              ]),
                              _: 2
                            }, 1032, ["text"])) : (c(), te(Hr, {
                              key: 1,
                              item: D,
                              variant: e.menuItemVariant,
                              "fallback-test-id": "dropdown-megamenu-item",
                              onClick: (se) => U(D)
                            }, null, 8, ["item", "variant", "onClick"]))
                          ], 64))), 128))
                        ]))), 128))
                      ]))
                    ])
                  ], 64)) : (c(!0), p(Z, { key: 1 }, ke(e.items, (I, M) => (c(), p("div", {
                    key: M,
                    class: "w-full"
                  }, [
                    I.tooltip ? (c(), te(Ye, {
                      key: 0,
                      ref_for: !0,
                      ref: O(`flat-${M}`),
                      text: I.tooltip,
                      class: "w-full"
                    }, {
                      default: pe(() => [
                        ae(Hr, {
                          item: I,
                          variant: e.menuItemVariant,
                          "fallback-test-id": "dropdown-item",
                          onClick: (D) => U(I)
                        }, null, 8, ["item", "variant", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["text"])) : (c(), te(Hr, {
                      key: 1,
                      item: I,
                      variant: e.menuItemVariant,
                      "fallback-test-id": "dropdown-item",
                      onClick: (D) => U(I)
                    }, null, 8, ["item", "variant", "onClick"])),
                    I.hasDividerAfter ? (c(), p("div", Rx)) : w("", !0)
                  ]))), 128))
                ], !0)
              ], 46, kx)) : w("", !0)
            ]),
            _: 3
          })
        ]))
      ], 2)
    ], 34));
  }
}), kn = /* @__PURE__ */ He(Bx, [["__scopeId", "data-v-17eb0244"]]);
function pd(e, t, n = {}) {
  const { ignoreSelectors: r, ignoreElements: o, isActive: a } = n, l = (s) => {
    if (a && !a()) return;
    const i = e.value, d = s.target;
    if (!(!i || !d || i.contains(d)) && d.isConnected && !(o != null && o().some((u) => u && u.contains(d)))) {
      if (r != null && r.length) {
        const u = d instanceof Element ? d : d.parentElement;
        if (u && r.some((f) => u.closest(f))) return;
      }
      t();
    }
  };
  Qe(() => {
    document.addEventListener("click", l, !0);
  }), nt(() => {
    document.removeEventListener("click", l, !0);
  });
}
function wa(e = {}) {
  const { defaultOpen: t = !1, onClose: n, ignoreSelectors: r } = e, o = N(t), a = N(null), l = () => {
    o.value = !o.value;
  }, s = () => {
    o.value = !0;
  }, i = () => {
    o.value = !1, n == null || n();
  };
  return pd(a, i, { ignoreSelectors: r }), {
    isOpen: o,
    dropdownRef: a,
    toggleDropdown: l,
    openDropdown: s,
    closeDropdown: i
  };
}
const Ox = new Proxy({}, { get: () => {
} });
function ht() {
  const e = ur();
  return (t) => {
    var n;
    return !!((n = e[t]) != null && n.call(e, Ox).some((r) => r.type !== Lf));
  };
}
const Px = ["id", "for"], zx = { class: "flex items-center gap-0.5" }, Nx = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)" }, Vx = {
  key: 0,
  class: "relative leading-5 font-medium"
}, Fx = { class: "flex items-end gap-3 w-full" }, Hx = ["id", "name", "type", "value", "placeholder", "disabled", "readonly", "inputmode", "autocomplete", "pattern", "maxlength", "minlength", "min", "max", "aria-labelledby", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required"], Wx = ["onKeydown"], jx = {
  key: 0,
  class: "shrink-0"
}, Ux = { class: "min-h-4.5 flex flex-col gap-px" }, Gx = ["id"], qx = ["id"], Kx = /* @__PURE__ */ ge({
  __name: "TextInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    type: { default: "text" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelInline: { type: Boolean, default: !1 },
    inputmode: { default: void 0 },
    autocomplete: { default: "off" },
    pattern: { default: void 0 },
    maxlength: { default: void 0 },
    minlength: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    valueVariant: { default: "default" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "keydown"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = N(!1), l = ur(), s = ht(), i = y(() => s("actions")), d = y(() => n.modelValue !== void 0 && n.modelValue !== null && n.modelValue.trim() !== ""), u = y(() => !!n.error), f = Ke(), h = y(() => n.id || f), b = y(() => n.label ? `${h.value}-label` : void 0), m = y(() => `${h.value}-error`), v = y(() => `${h.value}-hint`), x = y(() => {
      if (n.ariaDescribedby) return n.ariaDescribedby;
      const I = [];
      return n.hint && v.value && I.push(v.value), u.value && m.value && I.push(m.value), I.length > 0 ? I.join(" ") : void 0;
    }), k = y(() => u.value ? "true" : void 0), L = y(() => {
      const I = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (n.disabled) {
        const re = n.valueVariant === "link" ? "cursor-pointer" : "";
        return `${I} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) ${re}`.trimEnd();
      }
      if (n.readonly)
        return `${I} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-soft) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      if (u.value)
        return `${I} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (o.value)
        return `${I} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (a.value)
        return `${I} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const M = d.value ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${I} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${M} dark:text-(--text-text-white-default)`;
    }), E = {
      sm: {
        container: "h-[32px] px-2 py-1.5 gap-2",
        // Figma: 32px height, 8px horizontal, 6px vertical
        text: "text-sm leading-5"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        // Figma: 36px height, 12px horizontal, 8px vertical
        text: "text-sm leading-5"
      },
      lg: {
        container: "h-[48px] px-3.5 py-3 gap-2",
        // Figma: 48px height, 14px horizontal, 12px vertical
        text: "text-base leading-6"
      },
      xl: {
        container: "h-[52px] px-4 py-3.5 gap-2",
        // Figma: 52px height, 16px horizontal, 14px vertical
        text: "text-base leading-6"
      }
    }[n.size], O = y(() => n.valueVariant === "link" ? "text-(--text-text-link) font-semibold" : ""), R = y(() => n.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : o.value ? "text-(--border-border-accent) dark:text-(--border-border-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"), V = y(() => a.value && !o.value && !n.disabled && !n.readonly), J = y(() => o.value && d.value && !n.disabled && !n.readonly), F = y(() => n.fullWidth ? "w-full" : ""), A = y(() => n.fullWidth ? {} : { width: n.width }), j = y(() => {
      const I = "relative flex pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return n.labelInline ? `${I} flex-row items-center gap-2${n.fullWidth ? " w-full" : ""}` : `${I} flex-col items-start gap-0.5${n.fullWidth ? " w-full" : ""}`;
    }), _ = y(() => n.fullWidth || n.labelInline ? {} : { width: n.width }), U = (I) => {
      const M = I.target;
      r("update:modelValue", M.value), r("input", I);
    }, W = (I) => {
      var M;
      (!n.disabled || !n.readonly) && (o.value = !0, (M = I.target) == null || M.select()), r("focus", I);
    }, K = (I) => {
      o.value = !1, r("blur", I);
    }, le = () => {
      !n.disabled && !n.readonly && (a.value = !0);
    }, C = () => {
      a.value = !1;
    }, B = () => {
      r("update:modelValue", ""), r("clear");
    };
    return (I, M) => (c(), p("div", {
      class: S(j.value),
      style: Ae(_.value)
    }, [
      e.label ? (c(), p("label", {
        key: 0,
        id: b.value,
        for: h.value,
        class: S([
          "flex items-center text-text-black-default dark:text-(--colors-text-white-default)",
          e.labelInline ? "shrink-0" : ""
        ])
      }, [
        g("div", zx, [
          g("div", Nx, $(e.label), 1),
          e.required ? (c(), p("div", Vx, $(e.requiredIndicator), 1)) : w("", !0)
        ])
      ], 10, Px)) : w("", !0),
      g("div", Fx, [
        g("div", {
          class: S([
            L.value,
            T(E).container,
            F.value,
            i.value ? "flex-1 min-w-0" : ""
          ]),
          style: Ae(i.value ? {} : A.value),
          onMouseenter: le,
          onMouseleave: C
        }, [
          e.iconLeft ? (c(), p("i", {
            key: 0,
            class: S([e.iconLeft, T(E).text, R.value])
          }, null, 2)) : w("", !0),
          g("input", {
            id: h.value,
            name: e.name,
            type: e.type,
            value: e.modelValue,
            placeholder: e.placeholder,
            disabled: e.disabled,
            readonly: e.readonly,
            inputmode: e.inputmode,
            autocomplete: e.autocomplete,
            pattern: e.pattern,
            maxlength: e.maxlength,
            minlength: e.minlength,
            min: e.min,
            max: e.max,
            "aria-labelledby": b.value,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-invalid": k.value,
            "aria-describedby": x.value,
            "aria-required": e.required ? "true" : void 0,
            "data-testid": "text-input",
            class: S([
              "flex-1 min-w-0 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) pl-0",
              T(E).text,
              e.readonly ? "cursor-default" : "",
              O.value,
              e.valueVariant === "link" ? "pointer-events-none" : ""
            ]),
            onInput: U,
            onFocus: W,
            onBlur: K,
            onKeydown: M[0] || (M[0] = (D) => r("keydown", D))
          }, null, 42, Hx),
          be(I.$slots, "suffix", {}, void 0, !0),
          be(I.$slots, "iconRight", {}, void 0, !0),
          !T(l).iconRight && V.value ? (c(), p("i", {
            key: 1,
            class: S(["ri-pencil-line text-(--border-border-accent) dark:text-(--border-border-accent)", T(E).text])
          }, null, 2)) : !T(l).iconRight && J.value ? (c(), p("i", {
            key: 2,
            class: S(["ri-close-line cursor-pointer text-(--text-text-black-default) dark:text-(--text-text-white-default)", T(E).text]),
            role: "button",
            tabindex: "-1",
            "aria-label": "Clear input",
            onMousedown: M[1] || (M[1] = Ie(() => {
            }, ["prevent"])),
            onClick: Ie(B, ["stop"]),
            onKeydown: [
              je(B, ["enter"]),
              je(Ie(B, ["prevent"]), ["space"])
            ]
          }, null, 42, Wx)) : w("", !0)
        ], 38),
        i.value ? (c(), p("div", jx, [
          be(I.$slots, "actions", {}, void 0, !0)
        ])) : w("", !0)
      ]),
      g("div", Ux, [
        e.hint ? (c(), p("div", {
          key: 0,
          id: v.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-body)"
        }, [
          M[2] || (M[2] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
          g("span", null, $(e.hint), 1)
        ], 8, Gx)) : w("", !0),
        e.error ? (c(), p("div", {
          key: 1,
          id: m.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          M[3] || (M[3] = g("i", { class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)" }, null, -1)),
          g("span", null, $(e.error), 1)
        ], 8, qx)) : w("", !0)
      ])
    ], 6));
  }
}), er = /* @__PURE__ */ He(Kx, [["__scopeId", "data-v-e1ac6ec9"]]), Jx = ["id", "for"], Zx = { class: "leading-5 font-medium" }, Yx = {
  key: 0,
  class: "leading-5 font-medium"
}, Xx = ["id", "name", "value", "placeholder", "disabled", "readonly", "min", "max", "step", "aria-labelledby", "aria-invalid", "aria-describedby", "aria-required"], Qx = ["onKeydown"], _x = { class: "min-h-4.5 flex flex-col gap-px" }, e0 = ["id"], t0 = ["id"], n0 = /* @__PURE__ */ ge({
  __name: "NumberInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    prefix: { default: void 0 },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = N(!1), l = Ke(), s = y(() => n.id ?? l), i = y(() => n.label ? `${s.value}-label` : void 0), d = y(() => `${s.value}-error`), u = y(() => `${s.value}-hint`), f = y(() => !!n.error), h = y(
      () => n.modelValue !== void 0 && n.modelValue !== null && String(n.modelValue).trim() !== ""
    ), b = y(
      () => a.value && !o.value && !n.disabled && !n.readonly
    ), m = y(
      () => o.value && h.value && !n.disabled && !n.readonly
    ), v = y(() => {
      if (f.value) return d.value;
      if (n.hint) return u.value;
    }), x = {
      sm: { height: "h-[32px]", text: "text-sm leading-5", px: "px-2", iconPr: "pr-2" },
      md: { height: "h-[36px]", text: "text-sm leading-5", px: "px-3", iconPr: "pr-3" },
      lg: { height: "h-[48px]", text: "text-base leading-6", px: "px-3.5", iconPr: "pr-3.5" },
      xl: { height: "h-[52px]", text: "text-base leading-6", px: "px-4", iconPr: "pr-4" }
    }, k = y(() => x[n.size]), L = y(() => {
      const J = "flex items-center w-full rounded-xl border border-solid box-border overflow-hidden font-inter";
      if (n.disabled)
        return `${J} border-border-disabled-subtle bg-gainsboro-200 dark:bg-(--colors-background-disabled) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]`;
      if (n.readonly) {
        const F = o.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]";
        return `${J} cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${F}`;
      }
      return f.value ? `${J} border-(--border-border-error-strong) bg-(--background-background-white) dark:bg-(--background-background-black-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]` : o.value ? `${J} border-(--border-border-accent) bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] shadow-[0px_0px_2px_var(--border-border-accent)]` : a.value ? `${J} border-(--border-border-accent) bg-(--background-background-white) dark:bg-(--background-background-black-default)` : `${J} border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white) dark:bg-(--background-background-black-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]`;
    }), P = y(
      () => `relative flex flex-col items-start gap-0.5 pb-0.5 text-left text-sm font-inter${n.fullWidth ? " w-full" : ""}`
    );
    function E(J) {
      r("update:modelValue", J.target.value), r("input", J);
    }
    function O(J) {
      n.disabled || (o.value = !0), r("focus", J);
    }
    function R(J) {
      o.value = !1, r("blur", J);
    }
    function V() {
      r("update:modelValue", ""), r("clear");
    }
    return (J, F) => (c(), p("div", {
      class: S(P.value)
    }, [
      e.label ? (c(), p("label", {
        key: 0,
        id: i.value,
        for: s.value,
        class: "flex items-center gap-0.5 text-text-black-default dark:text-(--colors-text-white-default)"
      }, [
        g("span", Zx, $(e.label), 1),
        e.required ? (c(), p("span", Yx, "*")) : w("", !0)
      ], 8, Jx)) : w("", !0),
      g("div", {
        class: S([L.value, k.value.height]),
        onMouseenter: F[1] || (F[1] = (A) => !e.disabled && !e.readonly && (a.value = !0)),
        onMouseleave: F[2] || (F[2] = (A) => a.value = !1)
      }, [
        e.prefix ? (c(), p("span", {
          key: 0,
          class: S([
            "self-stretch flex items-center shrink-0 select-none",
            k.value.px,
            k.value.text,
            "text-(--text-text-body-subtle) border-r border-(--border-border-base-medium)",
            e.disabled ? "opacity-50" : ""
          ]),
          "aria-hidden": "true"
        }, $(e.prefix), 3)) : w("", !0),
        g("input", {
          id: s.value,
          name: e.name,
          type: "number",
          value: e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          min: e.min,
          max: e.max,
          step: e.step,
          "aria-labelledby": i.value,
          "aria-invalid": f.value ? "true" : void 0,
          "aria-describedby": v.value,
          "aria-required": e.required ? "true" : void 0,
          class: S([
            "flex-1 min-w-0 h-full bg-transparent border-0 outline-none focus:outline-none focus:ring-0",
            k.value.text,
            e.prefix ? "pl-3" : k.value.px,
            e.disabled ? "text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)",
            "placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary)"
          ]),
          onInput: E,
          onFocus: O,
          onBlur: R
        }, null, 42, Xx),
        b.value ? (c(), p("i", {
          key: 1,
          class: S(["ri-pencil-line shrink-0 text-(--border-border-accent)", k.value.text, k.value.iconPr])
        }, null, 2)) : m.value ? (c(), p("i", {
          key: 2,
          class: S([
            "ri-close-line shrink-0 cursor-pointer text-(--text-text-black-default) dark:text-(--text-text-white-default)",
            k.value.text,
            k.value.iconPr
          ]),
          role: "button",
          tabindex: "-1",
          "aria-label": "Clear input",
          onMousedown: F[0] || (F[0] = Ie(() => {
          }, ["prevent"])),
          onClick: Ie(V, ["stop"]),
          onKeydown: [
            je(V, ["enter"]),
            je(Ie(V, ["prevent"]), ["space"])
          ]
        }, null, 42, Qx)) : (c(), p("span", {
          key: 3,
          class: S(k.value.iconPr),
          "aria-hidden": "true"
        }, null, 2))
      ], 34),
      g("div", _x, [
        e.hint ? (c(), p("div", {
          key: 0,
          id: u.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-body)"
        }, [
          F[3] || (F[3] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
          g("span", null, $(e.hint), 1)
        ], 8, e0)) : w("", !0),
        e.error ? (c(), p("div", {
          key: 1,
          id: d.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          F[4] || (F[4] = g("i", { class: "ri-error-warning-fill" }, null, -1)),
          g("span", null, $(e.error), 1)
        ], 8, t0)) : w("", !0)
      ])
    ], 2));
  }
}), Lu = /* @__PURE__ */ He(n0, [["__scopeId", "data-v-a6866ae5"]]), r0 = { class: "w-full relative flex flex-col items-start gap-0.5 text-left text-sm text-text-body dark:text-(--colors-text-white-default) font-inter" }, o0 = {
  key: 0,
  class: "flex items-center gap-1 text-text-black-default dark:text-(--colors-text-white-default)"
}, a0 = { class: "flex items-center gap-0.5" }, l0 = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)" }, s0 = {
  key: 0,
  class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)"
}, i0 = ["src"], d0 = ["src"], u0 = ["id", "name", "value", "placeholder", "disabled", "aria-label", "aria-disabled"], c0 = ["src"], f0 = /* @__PURE__ */ ge({
  __name: "SearchInput",
  props: {
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    helpIcon: { default: void 0 },
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    rounded: { default: "full" }
  },
  emits: ["update:modelValue", "input", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = N(!1), l = y(() => n.rounded === "full" ? "rounded-[9999px]" : "rounded-xl"), s = y(() => {
      const E = `relative ${l.value} border-solid box-border flex items-center text-left font-inter`;
      return n.disabled ? `${E} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : o.value ? `${E} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : a.value ? `${E} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : `${E} border-[1px] shadow-(--blur-shadow-xs) bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
    }), d = {
      sm: {
        container: "h-[36px] px-2.5 gap-2",
        text: "text-sm leading-5",
        iconRight: "h-4 w-4"
      },
      md: {
        container: "h-[40px] px-3 gap-2",
        text: "text-sm leading-5",
        iconRight: "h-4 w-4"
      },
      lg: {
        container: "h-[48px] px-3.5 gap-2",
        text: "text-base leading-6",
        iconRight: "h-4 w-4"
      },
      xl: {
        container: "h-[52px] px-4 gap-2",
        text: "text-base leading-6",
        iconRight: "h-4 w-4"
      }
    }[n.size], u = y(() => ["relative", d.iconRight]), f = (E) => !!E && E.startsWith("ri-"), h = y(() => n.fullWidth ? "w-full" : ""), b = y(() => n.fullWidth ? {} : { width: n.width }), m = (E) => {
      const O = E.target;
      r("update:modelValue", O.value), r("input", E);
    }, v = (E) => {
      n.disabled || (o.value = !0), r("focus", E);
    }, x = (E) => {
      o.value = !1, r("blur", E);
    }, k = () => {
      n.disabled || (a.value = !0);
    }, L = () => {
      a.value = !1;
    }, P = y(() => n.disabled ? "text-text-body-subtle dark:text-(--colors-text-white-secondary)" : o.value ? "text-(--border-border-accent) dark:text-(--border-border-accent)" : "text-text-body-subtle dark:text-(--colors-text-white-secondary)");
    return (E, O) => (c(), p("div", r0, [
      e.label ? (c(), p("div", o0, [
        g("div", a0, [
          g("div", l0, $(e.label), 1),
          e.required ? (c(), p("div", s0, " * ")) : w("", !0)
        ]),
        e.helpIcon ? (c(), p("img", {
          key: 0,
          src: e.helpIcon,
          class: "h-3 w-3 relative search-input-icon",
          alt: ""
        }, null, 8, i0)) : w("", !0)
      ])) : w("", !0),
      g("div", {
        class: S([s.value, T(d).container, h.value]),
        style: Ae(b.value),
        onMouseenter: k,
        onMouseleave: L
      }, [
        e.iconLeft ? (c(), p(Z, { key: 0 }, [
          f(e.iconLeft) ? (c(), p("i", {
            key: 0,
            class: S([e.iconLeft, "text-base leading-none", P.value])
          }, null, 2)) : (c(), p("img", {
            key: 1,
            src: e.iconLeft,
            class: "h-4 w-4 search-input-icon",
            alt: ""
          }, null, 8, d0))
        ], 64)) : (c(), p("i", {
          key: 1,
          class: S(["ri-search-line text-base leading-none", P.value])
        }, null, 2)),
        g("input", {
          id: e.id,
          name: e.name,
          "data-testid": "search-input",
          type: "search",
          value: e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          "aria-label": e.placeholder,
          "aria-disabled": e.disabled ? "true" : "false",
          class: S([
            "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary)",
            T(d).text
          ]),
          onInput: m,
          onFocus: v,
          onBlur: x
        }, null, 42, u0),
        e.iconRight ? (c(), p("img", {
          key: 2,
          src: e.iconRight,
          class: S([...u.value, "search-input-icon"]),
          alt: ""
        }, null, 10, c0)) : w("", !0)
      ], 38)
    ]));
  }
}), Rr = /* @__PURE__ */ He(f0, [["__scopeId", "data-v-b3a3394c"]]);
function cl() {
  const e = N(0);
  function t(s, i) {
    var d;
    s && ((d = s.querySelector(`[data-listbox-index="${i}"]`)) == null || d.focus());
  }
  function n(s, i) {
    for (let d = 0; d < s; d++)
      if (!(i != null && i(d))) return d;
    return 0;
  }
  function r(s, i) {
    for (let d = s - 1; d >= 0; d--)
      if (!(i != null && i(d))) return d;
    return Math.max(0, s - 1);
  }
  function o(s, i, d, u) {
    let f = s;
    for (let h = 0; h < d; h++)
      if (f = (f + i + d) % d, !(u != null && u(f))) return f;
    return s;
  }
  function a(s, i, d, u) {
    if (i === 0) return;
    let f;
    switch (s.key) {
      case "ArrowDown":
        f = o(e.value, 1, i, u);
        break;
      case "ArrowUp":
        f = o(e.value, -1, i, u);
        break;
      case "Home":
        f = n(i, u);
        break;
      case "End":
        f = r(i, u);
        break;
      default:
        return;
    }
    s.preventDefault(), s.stopPropagation(), e.value = f, t(d, f);
  }
  function l(s) {
    e.value = Math.min(e.value, Math.max(0, s - 1));
  }
  return {
    focusedIndex: e,
    focusListboxOption: t,
    handleRovingKeydown: a,
    clampFocusedIndex: l,
    firstEnabledIndex: n,
    lastEnabledIndex: r
  };
}
function fl(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "").toLowerCase();
}
function h0(e) {
  return typeof e.getModifierState == "function" && e.getModifierState("AltGraph") ? !0 : e.ctrlKey && e.altKey;
}
function b0(e = 500) {
  const t = N("");
  let n = null;
  function r() {
    t.value = "", n && (clearTimeout(n), n = null);
  }
  function o() {
    n && clearTimeout(n), n = setTimeout(r, e);
  }
  nt(() => {
    n && clearTimeout(n);
  });
  function a(l) {
    if (l.repeat) return !1;
    if (l.key === "Backspace")
      return t.value ? (t.value = t.value.slice(0, -1), t.value ? o() : r(), !0) : !1;
    if (l.isComposing) return !1;
    const s = h0(l);
    return l.key.length !== 1 || l.metaKey || l.ctrlKey && !s || l.altKey && !s ? !1 : (t.value += l.key, o(), !0);
  }
  return { query: t, handleKey: a, reset: r };
}
const p0 = ["src"], g0 = ["id", "for"], m0 = {
  key: 0,
  class: "font-medium"
}, v0 = ["src"], x0 = ["name", "value"], y0 = ["id", "aria-expanded", "aria-labelledby", "aria-describedby", "aria-disabled", "aria-readonly", "tabindex", "onClick", "onKeydown"], k0 = ["src"], w0 = {
  key: 0,
  "aria-live": "polite",
  role: "status",
  class: "sr-only"
}, C0 = ["aria-labelledby"], S0 = ["aria-selected", "aria-disabled", "tabindex", "data-listbox-index", "data-testid", "onClick", "onKeydown", "onFocus"], $0 = {
  key: 1,
  "data-testid": "select-no-results",
  class: "px-2 py-1.5 text-sm text-text-body-subtle dark:text-(--colors-text-white-secondary)"
}, I0 = { class: "min-h-4.5 flex flex-col gap-px" }, T0 = ["id"], L0 = ["id"], Ea = -1, el = /* @__PURE__ */ ge({
  __name: "SelectInput",
  props: {
    placeholder: { default: void 0 },
    modelValue: { default: "" },
    options: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    labelInline: { type: Boolean, default: !1 },
    helpIcon: { default: void 0 },
    prefixIcon: { default: void 0 },
    iconLeft: { default: void 0 },
    error: { default: void 0 },
    hint: { default: void 0 },
    noResultsLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Ke(), a = y(() => n.id || o), l = y(() => n.label ? `${a.value}-label` : void 0), s = y(() => `${a.value}-error`), i = y(() => `${a.value}-hint`), d = y(() => !!n.error), u = y(
      () => n.options.find((M) => M.value === n.modelValue) ?? null
    ), f = y(() => {
      var M;
      return ((M = u.value) == null ? void 0 : M.label) ?? "";
    }), h = y(() => {
      if (d.value) return s.value;
      if (n.hint) return i.value;
    }), b = N(!1), m = N(null), v = {
      sm: { container: "h-[36px] px-2.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }, x = y(() => v[n.size]), k = (M) => {
      const D = "relative flex items-center w-full rounded-xl border border-solid box-border text-left font-inter transition-colors select-none focus:outline-none";
      if (n.disabled)
        return `${D} bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)`;
      if (n.readonly) {
        const re = b.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${D} cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${re} text-text-black-default dark:text-(--colors-text-white-default)`;
      }
      if (d.value) {
        const re = b.value ? " shadow-[0px_0px_2px_var(--border-border-accent)]" : "";
        return `${D} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)${re}`;
      }
      return b.value || M ? `${D} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-[rgba(255,255,255,0.05)] dark:text-(--colors-text-white-default)` : `${D} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    }, L = y(() => {
      const M = "relative flex pb-0.5 text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return n.labelInline ? `${M} flex-row items-center gap-2 ${n.fullWidth ? "w-full" : ""}` : `${M} flex-col gap-0.5 ${n.fullWidth ? "w-full" : ""}`;
    }), P = y(() => n.fullWidth ? {} : { width: n.width }), E = y(() => n.labelInline && !n.fullWidth ? { width: n.width } : n.fullWidth ? {} : { width: n.width }), O = (M) => !!M && M.startsWith("ri-"), R = (M) => {
      r("update:modelValue", M), r("change", M);
    }, V = (M, D) => {
      M.disabled || (R(M.value), W.reset(), D(), Pe(() => {
        var re;
        return (re = m.value) == null ? void 0 : re.focus();
      }));
    }, J = (M, D, re) => {
      W.query.value.length > 0 || (re.preventDefault(), re.stopPropagation(), V(M, D));
    }, F = N(null), { focusedIndex: A, focusListboxOption: j, handleRovingKeydown: _, firstEnabledIndex: U } = cl(), W = b0(), K = y(() => {
      const M = fl(W.query.value.trim());
      return n.options.filter((D) => (D.disabled, D.label, D.value, !M || fl(D.label).startsWith(M)));
    }), le = (M) => {
      var D;
      return ((D = K.value[M]) == null ? void 0 : D.disabled) === !0;
    };
    function C() {
      if (K.value.length === 0) return Ea;
      const M = U(K.value.length, le);
      return le(M) ? Ea : M;
    }
    function B(M) {
      j(F.value, M);
    }
    we(
      F,
      (M) => {
        if (!M) {
          W.reset();
          return;
        }
        const D = K.value.findIndex((se) => se.value === n.modelValue), re = D >= 0 && !le(D) ? D : C();
        A.value = re, re === Ea ? M.focus() : B(re);
      },
      { flush: "post" }
    ), we(
      K,
      () => {
        if (!F.value) return;
        if (document.activeElement !== F.value && F.value.contains(document.activeElement)) {
          const re = Number(document.activeElement.dataset.listboxIndex);
          if (!Number.isNaN(re)) {
            A.value = re;
            return;
          }
        }
        const D = Math.min(Math.max(A.value, 0), K.value.length - 1);
        A.value = le(D) ? C() : D, A.value === Ea ? F.value.focus() : B(A.value);
      },
      { flush: "post" }
    );
    function I(M) {
      if (W.handleKey(M)) {
        M.preventDefault(), M.stopPropagation();
        return;
      }
      _(M, K.value.length, F.value, le);
    }
    return (M, D) => (c(), p("div", {
      class: S(L.value),
      style: Ae(e.labelInline ? {} : P.value)
    }, [
      e.iconLeft && e.labelInline ? (c(), p("img", {
        key: 0,
        src: e.iconLeft,
        class: "h-6 w-6 rounded-full object-cover shrink-0",
        alt: ""
      }, null, 8, p0)) : w("", !0),
      e.label ? (c(), p("label", {
        key: 1,
        id: l.value,
        for: a.value,
        class: S(["flex items-center gap-1 leading-5 font-medium text-text-black-default dark:text-(--colors-text-white-default)", !e.disabled && "cursor-pointer"]),
        onClick: D[0] || (D[0] = (re) => {
          var se;
          return !e.disabled && ((se = m.value) == null ? void 0 : se.click());
        })
      }, [
        g("span", null, $(e.label), 1),
        e.required ? (c(), p("span", m0, $(e.requiredIndicator), 1)) : w("", !0),
        e.helpIcon ? (c(), p(Z, { key: 1 }, [
          O(e.helpIcon) ? (c(), p("i", {
            key: 0,
            class: S([e.helpIcon, "text-sm leading-none text-text-body-subtle ml-0.5 cursor-help"])
          }, null, 2)) : (c(), p("img", {
            key: 1,
            src: e.helpIcon,
            class: "h-3.5 w-3.5 ml-0.5 cursor-help",
            alt: "Help"
          }, null, 8, v0))
        ], 64)) : w("", !0)
      ], 10, g0)) : w("", !0),
      g("div", {
        style: Ae(E.value),
        class: S({ "w-full": e.fullWidth })
      }, [
        g("input", {
          type: "hidden",
          name: e.name,
          value: e.modelValue
        }, null, 8, x0),
        ae(T(kn), {
          "full-width": !0,
          "menu-width": E.value.width ?? "100%",
          disabled: e.disabled
        }, {
          trigger: pe(({ toggle: re, isOpen: se }) => [
            g("div", {
              id: a.value,
              ref_key: "triggerRef",
              ref: m,
              role: "combobox",
              "aria-expanded": se,
              "aria-haspopup": "listbox",
              "aria-labelledby": l.value,
              "aria-describedby": h.value,
              "aria-disabled": e.disabled ? "true" : void 0,
              "aria-readonly": e.readonly ? "true" : void 0,
              tabindex: e.disabled ? -1 : 0,
              "data-testid": "select-input",
              class: S([k(se), x.value.container]),
              onClick: (de) => !e.disabled && !e.readonly && re(),
              onKeydown: [
                je(Ie((de) => !e.disabled && !e.readonly && re(), ["prevent"]), ["enter"]),
                je(Ie((de) => !e.disabled && !e.readonly && re(), ["prevent"]), ["space"])
              ],
              onFocus: D[1] || (D[1] = (de) => {
                b.value = !0, M.$emit("focus");
              }),
              onBlur: D[2] || (D[2] = (de) => {
                b.value = !1, M.$emit("blur");
              })
            }, [
              e.prefixIcon ? (c(), p(Z, { key: 0 }, [
                O(e.prefixIcon) ? (c(), p("i", {
                  key: 0,
                  class: S([e.prefixIcon, "shrink-0 text-base leading-none", x.value.icon])
                }, null, 2)) : (c(), p("img", {
                  key: 1,
                  src: e.prefixIcon,
                  class: S(["shrink-0 object-cover", x.value.icon]),
                  alt: ""
                }, null, 10, k0))
              ], 64)) : w("", !0),
              be(M.$slots, "value", {
                value: e.modelValue,
                displayValue: f.value
              }, () => [
                g("span", {
                  class: S(["flex-1 truncate", [
                    x.value.text,
                    e.disabled ? "" : f.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-text-body-subtle dark:text-(--colors-text-white-secondary)"
                  ]])
                }, $(f.value || e.placeholder), 3)
              ]),
              g("i", {
                class: S(["ri-arrow-down-s-line shrink-0 text-base leading-none transition-transform duration-200 ease-in-out", [x.value.icon, e.disabled ? "text-text-disabled" : "text-text-body-subtle"]]),
                style: Ae({ transform: se ? "rotate(180deg)" : "rotate(0deg)" })
              }, null, 6)
            ], 42, y0)
          ]),
          menu: pe(({ close: re }) => [
            T(W).query.value ? (c(), p("span", w0, $(K.value.length), 1)) : w("", !0),
            g("ul", {
              ref_key: "listboxRef",
              ref: F,
              role: "listbox",
              "aria-labelledby": l.value,
              tabindex: "-1",
              class: "flex w-full flex-col gap-1.5",
              onKeydown: I
            }, [
              (c(!0), p(Z, null, ke(K.value, (se, de) => (c(), p("li", {
                key: se.value,
                role: "option",
                "aria-selected": se.value === e.modelValue,
                "aria-disabled": se.disabled ? "true" : void 0,
                tabindex: de === T(A) ? 0 : -1,
                "data-listbox-index": de,
                "data-testid": `select-option-${se.value}`,
                class: S(["flex w-full items-center rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-sm leading-5 text-text-black-default transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) dark:text-(--colors-text-white-default)", [
                  se.disabled ? "cursor-not-allowed opacity-40" : se.value === e.modelValue ? "cursor-pointer bg-background-hover font-medium" : "cursor-pointer hover:bg-background-hover"
                ]]),
                onClick: (fe) => V(se, re),
                onKeydown: [
                  je(Ie((fe) => V(se, re), ["prevent"]), ["enter"]),
                  je((fe) => J(se, re, fe), ["space"])
                ],
                onFocus: (fe) => !se.disabled && (A.value = de)
              }, [
                be(M.$slots, "option", {
                  option: se,
                  selected: se.value === e.modelValue
                }, () => [
                  Ze($(se.label), 1)
                ])
              ], 42, S0))), 128))
            ], 40, C0),
            K.value.length === 0 && e.noResultsLabel ? (c(), p("div", $0, $(e.noResultsLabel), 1)) : w("", !0)
          ]),
          _: 3
        }, 8, ["menu-width", "disabled"])
      ], 6),
      g("div", I0, [
        e.hint ? (c(), p("div", {
          key: 0,
          id: i.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-body)"
        }, [
          D[3] || (D[3] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
          g("span", null, $(e.hint), 1)
        ], 8, T0)) : w("", !0),
        e.error ? (c(), p("div", {
          key: 1,
          id: s.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          D[4] || (D[4] = g("i", { class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)" }, null, -1)),
          g("span", null, $(e.error), 1)
        ], 8, L0)) : w("", !0)
      ])
    ], 6));
  }
}), Mu = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"/></svg>', M0 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M5 11V13H19V11H5Z"/></svg>', E0 = ["for"], A0 = ["for"], D0 = ["src"], R0 = ["src"], B0 = ["for"], O0 = ["for"], P0 = ["id", "name", "checked", "disabled", "indeterminate", "value", "aria-label", "aria-labelledby", "aria-describedby"], z0 = /* @__PURE__ */ ge({
  __name: "Checkbox",
  props: {
    label: { default: void 0 },
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    labelPosition: { default: "right" },
    variant: { default: "default" },
    labelWrap: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, r = Ke(), o = y(() => n.id ?? r), a = t, l = (m, v) => {
      const x = m.replace('fill="currentColor"', `fill="${v}"`).replace("<svg", '<svg width="16" height="16"');
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(x)}`;
    }, s = y(() => n.variant === "light" ? l(Mu, "#242424") : l(Mu, "#FFFFFF")), i = y(() => l(M0, "#FFFFFF")), d = y(() => {
      const m = "size-4 rounded border-solid border-[1px] box-border flex flex-col items-center justify-center transition-all duration-200 group-focus-within:ring-2 group-focus-within:ring-(--border-border-accent) group-focus-within:ring-offset-1";
      return n.disabled ? n.modelValue || n.indeterminate ? `${m} bg-background-disabled dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) cursor-not-allowed` : `${m} bg-background-disabled dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) cursor-not-allowed` : n.variant === "dark" ? n.modelValue || n.indeterminate ? `${m} bg-(--background-background-black-default) border-(--text-text-white-default) cursor-pointer hover:bg-white/10 hover:border-(--text-text-white-default)` : `${m} bg-transparent border-(--text-text-white-default) cursor-pointer hover:bg-white/10 hover:border-(--text-text-white-default)` : n.modelValue || n.indeterminate ? n.variant === "light" ? `${m} bg-white dark:bg-(--colors-background-black-default) border-[#919191] dark:border-(--colors-border-base) cursor-pointer hover:border-[#6a7282]` : `${m} bg-[#242424] dark:bg-white border-[#242424] dark:border-white cursor-pointer hover:bg-[#3d3d3d] dark:hover:bg-[#e5e5e5] hover:border-[#3d3d3d] dark:hover:border-[#e5e5e5]` : `${m} bg-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) cursor-pointer hover:border-[#242424] dark:hover:border-white hover:bg-[#f5f5f5] dark:hover:bg-[#2a2a2a]`;
    }), u = y(() => {
      let m = "group relative flex text-left text-sm font-inter select-none";
      return n.labelPosition === "top" || n.labelPosition === "bottom" ? m += " flex-col items-center gap-1.5 w-auto" : m += n.labelWrap ? " flex-row items-start gap-1.5 w-full min-w-0" : " flex-row items-center gap-1.5 w-full min-w-0", n.disabled ? `${m} text-text-disabled dark:text-(--colors-text-disabled)` : n.variant === "dark" ? `${m} text-(--text-text-white-default)` : `${m} text-text-black-default dark:text-(--colors-text-white-default)`;
    }), f = y(() => {
      const v = `relative leading-5 cursor-pointer flex-1 min-w-0 ${n.variant === "dark" ? "text-(--text-text-white-default)" : "dark:text-(--colors-text-white-default)"}`;
      return n.labelWrap ? `${v} break-words` : `${v} overflow-hidden text-ellipsis whitespace-nowrap`;
    }), h = (m) => {
      if (m.preventDefault(), m.stopPropagation(), n.disabled) return;
      const v = !n.modelValue;
      a("update:modelValue", v), a("change", m);
    }, b = (m) => {
      if (n.disabled) return;
      const v = m.target;
      a("update:modelValue", v.checked), a("change", m);
    };
    return (m, v) => (c(), p("div", {
      class: S(u.value),
      "data-testid": "checkbox-container",
      onClick: Ie(h, ["stop"])
    }, [
      e.label && e.labelPosition === "top" ? (c(), p("label", {
        key: 0,
        for: o.value,
        class: "relative leading-5 cursor-pointer text-center dark:text-(--colors-text-white-default)"
      }, $(e.label), 9, E0)) : w("", !0),
      e.label && e.labelPosition === "left" ? (c(), p("label", {
        key: 1,
        for: o.value,
        class: S(f.value)
      }, $(e.label), 11, A0)) : w("", !0),
      g("div", {
        class: S(d.value),
        "data-testid": "checkbox-box",
        "aria-hidden": "true"
      }, [
        e.indeterminate ? (c(), p("img", {
          key: 0,
          src: i.value,
          class: "w-full h-full relative checkbox-check-icon",
          alt: ""
        }, null, 8, D0)) : e.modelValue ? (c(), p("img", {
          key: 1,
          src: s.value,
          class: S([
            "w-full h-full relative",
            e.variant === "light" ? "checkbox-check-icon-light" : e.variant === "dark" ? "checkbox-check-icon-dark" : "checkbox-check-icon"
          ]),
          alt: ""
        }, null, 10, R0)) : w("", !0)
      ], 2),
      e.label && e.labelPosition === "right" ? (c(), p("label", {
        key: 2,
        for: o.value,
        class: S(f.value)
      }, $(e.label), 11, B0)) : w("", !0),
      e.label && e.labelPosition === "bottom" ? (c(), p("label", {
        key: 3,
        for: o.value,
        class: "relative leading-5 cursor-pointer text-center dark:text-(--colors-text-white-default)"
      }, $(e.label), 9, O0)) : w("", !0),
      e.presentational ? w("", !0) : (c(), p("input", {
        key: 4,
        id: o.value,
        name: e.name,
        type: "checkbox",
        checked: e.modelValue,
        disabled: e.disabled,
        indeterminate: e.indeterminate || void 0,
        value: e.value,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-describedby": e.ariaDescribedby,
        class: "sr-only pointer-events-none",
        onChange: b
      }, null, 40, P0))
    ], 2));
  }
}), Xt = /* @__PURE__ */ He(z0, [["__scopeId", "data-v-d91d70ec"]]), N0 = { class: "flex items-center gap-1.5 shrink-0" }, V0 = {
  key: 0,
  class: "size-2 rounded-full bg-(--text-text-black-default) dark:bg-white"
}, F0 = ["for"], H0 = ["id", "name", "checked", "disabled", "value"], W0 = /* @__PURE__ */ ge({
  __name: "RadioButton",
  props: {
    label: { default: void 0 },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    disabled: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    value: { type: [String, Number, Boolean], default: void 0 },
    presentational: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => n.modelValue === n.value), a = Ke(), l = y(() => n.id ?? a), s = y(() => {
      const h = "relative box-border flex size-4 shrink-0 items-center justify-center rounded-full border border-solid";
      return n.disabled ? `${h} bg-(--background-background-disabled) dark:bg-(--colors-background-disabled) border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) cursor-not-allowed` : o.value ? `${h} bg-(--background-background-white) border-(--text-text-black-default) dark:bg-(--colors-background-black-default) dark:border-white cursor-pointer` : `${h} bg-(--background-background-white) border-(--border-border-base-medium) dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) cursor-pointer`;
    }), i = y(() => n.presentational ? "flex items-center justify-center" : "self-stretch min-h-8 rounded-lg flex items-center py-2 pr-2 box-border"), d = y(() => {
      const h = "relative text-sm font-medium leading-5";
      return n.disabled ? `${h} text-text-disabled dark:text-(--colors-text-disabled) cursor-not-allowed` : `${h} text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer`;
    }), u = (h) => {
      h.preventDefault(), !n.disabled && (n.value !== void 0 && r("update:modelValue", n.value), r("change", h));
    }, f = (h) => {
      if (n.disabled) return;
      h.target.checked && n.value !== void 0 && (r("update:modelValue", n.value), r("change", h));
    };
    return (h, b) => (c(), p("div", {
      "data-testid": "radio-container",
      class: S(i.value),
      onClick: u
    }, [
      g("div", N0, [
        g("div", {
          "data-testid": "radio-button",
          class: S(s.value)
        }, [
          o.value ? (c(), p("div", V0)) : w("", !0)
        ], 2),
        !e.presentational && e.label ? (c(), p("label", {
          key: 0,
          for: l.value,
          class: S(d.value)
        }, $(e.label), 11, F0)) : w("", !0)
      ]),
      e.presentational ? w("", !0) : (c(), p("input", {
        key: 0,
        id: l.value,
        name: e.name,
        type: "radio",
        checked: o.value,
        disabled: e.disabled,
        value: e.value,
        class: "sr-only",
        onChange: f,
        onClick: b[0] || (b[0] = Ie(() => {
        }, ["stop"]))
      }, null, 40, H0))
    ], 2));
  }
}), Aa = "text-(--components-icon-shape-icon-iconshape-white-icon)", j0 = "bg-(--components-icon-shape-background-iconshape-white-bg)", U0 = "border-(--components-icon-shape-border-iconshape-default-border)", G0 = "bg-(--colors-indigo-100)", q0 = /* @__PURE__ */ ge({
  __name: "IconShape",
  props: {
    size: { default: "sm" },
    shape: { default: "square" },
    variant: { default: "filled" },
    color: { default: void 0 },
    bgClass: { default: void 0 },
    bordered: { type: Boolean, default: !0 },
    content: { default: void 0 },
    contentType: { default: "icon" }
  },
  setup(e) {
    const t = e, n = ht(), r = {
      xs: "text-[10px]",
      sm: "text-base",
      md: "text-xl",
      lg: "text-[28px]",
      xl: "text-4xl",
      "2xl": "text-[56px]"
    }, o = {
      xs: "text-xs font-semibold leading-5",
      sm: "text-sm font-semibold leading-5",
      md: "text-base font-bold leading-6",
      lg: "text-lg font-semibold leading-[22px]",
      xl: "text-xl font-bold leading-6",
      "2xl": "text-4xl font-bold leading-[43px]"
    }, a = {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-9 w-9",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
      "2xl": "h-24 w-24"
    }, l = {
      xs: "rounded",
      sm: "rounded",
      md: "rounded-lg",
      lg: "rounded-lg",
      xl: "rounded-xl",
      "2xl": "rounded-xl"
    }, s = {
      black: "bg-(--components-icon-shape-background-iconshape-black-bg)",
      success: "bg-(--components-icon-shape-background-iconshape-success-bg)",
      error: "bg-(--components-icon-shape-background-iconshape-error-bg)",
      accent: "bg-(--components-icon-shape-background-iconshape-accent-bg)",
      red: "bg-(--components-icon-shape-background-iconshape-red-bg)",
      orange: "bg-(--components-icon-shape-background-iconshape-orange-bg)",
      yellow: "bg-(--components-icon-shape-background-iconshape-yellow-bg)",
      green: "bg-(--components-icon-shape-background-iconshape-green-bg)",
      indigo: "bg-(--components-icon-shape-background-iconshape-indigo-bg)",
      violet: "bg-(--components-icon-shape-background-iconshape-violet-bg)",
      purple: "bg-(--components-icon-shape-background-iconshape-purple-bg)",
      cyan: "bg-(--components-icon-shape-background-iconshape-cyan-bg)",
      disabled: "bg-(--components-icon-shape-background-iconshape-disabled-bg)"
    }, i = {
      black: Aa,
      success: Aa,
      error: Aa,
      gradient: Aa,
      white: "text-(--components-icon-shape-icon-iconshape-brand-icon)",
      // pale bg -> dark icon
      accent: "text-(--components-icon-shape-icon-iconshape-accent-icon)",
      red: "text-(--components-icon-shape-icon-iconshape-red-icon)",
      orange: "text-(--components-icon-shape-icon-iconshape-orange-icon)",
      yellow: "text-(--components-icon-shape-icon-iconshape-yellow-icon)",
      green: "text-(--components-icon-shape-icon-iconshape-green-icon)",
      indigo: "text-(--components-icon-shape-icon-iconshape-indigo-icon)",
      violet: "text-(--components-icon-shape-icon-iconshape-violet-icon)",
      purple: "text-(--components-icon-shape-icon-iconshape-purple-icon)",
      cyan: "text-(--components-icon-shape-icon-iconshape-cyan-icon)",
      disabled: "text-(--components-icon-shape-icon-iconshape-disabled-strong-icon)"
    }, d = {
      ...i,
      black: "text-(--components-icon-shape-icon-iconshape-black-icon)",
      success: "text-(--components-icon-shape-icon-iconshape-success-icon)",
      error: "text-(--components-icon-shape-icon-iconshape-error-icon)",
      gradient: "text-(--components-icon-shape-icon-iconshape-accent-icon)"
    }, u = {
      accent: "border-(--components-icon-shape-border-iconshape-accent-border)",
      disabled: "border-(--components-icon-shape-border-iconshape-disabled-border)"
    }, f = y(() => t.color === "gradient"), h = y(
      () => t.shape === "circle" ? "rounded-full" : l[t.size]
    ), b = y(() => {
      if (t.bgClass) return t.bgClass;
      if (!f.value)
        return t.variant === "outlined" ? j0 : t.color ? s[t.color] : G0;
    }), m = y(
      () => t.color && u[t.color] || U0
    ), v = y(() => t.color ? (t.variant === "outlined" ? d : i)[t.color] : void 0), x = y(() => f.value ? ["border", "border-solid", "border-transparent", "icon-shape-gradient-border"] : t.variant === "outlined" ? ["border", "border-solid", m.value] : t.color === "accent" ? ["border", "border-solid", "border-(--components-icon-shape-border-iconshape-accent-border)"] : t.color ? [] : t.bordered ? ["border", "border-solid", "border-(--border-border-base-medium)"] : []), k = y(() => {
      if (!f.value) return;
      const L = t.variant === "outlined" ? "var(--components-icon-shape-background-iconshape-white-bg)" : "var(--components-icon-shape-background-iconshape-black-default-bg)";
      return {
        backgroundImage: `linear-gradient(${L}, ${L}), var(--gradient-brand-horizontal)`
      };
    });
    return (L, P) => (c(), p("div", {
      class: S(["flex shrink-0 items-center justify-center", [a[e.size], h.value, b.value, x.value, v.value]]),
      style: Ae(k.value),
      "aria-hidden": "true",
      "data-testid": "icon-shape"
    }, [
      T(n)("default") ? be(L.$slots, "default", { key: 0 }, void 0, !0) : e.contentType === "icon" && e.content ? (c(), p("i", {
        key: 1,
        class: S([e.content, r[e.size], "leading-none"])
      }, null, 2)) : e.contentType === "text" && e.content !== void 0 ? (c(), p("span", {
        key: 2,
        class: S(["font-inter whitespace-nowrap", o[e.size]])
      }, $(e.content), 3)) : w("", !0)
    ], 6));
  }
}), vn = /* @__PURE__ */ He(q0, [["__scopeId", "data-v-a9af71b8"]]), pi = "rounded-xl border border-solid p-4", on = "shadow-[0px_1px_0.5px_0px_rgba(29,41,61,0.02)]", gi = "transition-[border-color,box-shadow,background-color]", hl = "bg-(--background-background-white) dark:bg-(--colors-background-black-default)", bl = "border-(--border-border-base-medium) dark:border-(--colors-border-base)", jf = "border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle)", Do = "bg-(--background-background-disabled) dark:bg-(--colors-background-disabled)", vr = "text-(--text-text-disabled-strong)", tl = "bg-(--background-background-selected) border-(--border-border-accent)", an = "cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-2", K0 = ["id", "role", "aria-checked", "aria-disabled", "aria-label", "aria-describedby", "data-name", "tabindex"], J0 = ["id"], Z0 = { class: "flex min-w-0 flex-1 flex-col gap-1" }, Y0 = {
  "data-testid": "radio-form-title-row",
  class: "flex flex-wrap items-start justify-between gap-2"
}, X0 = {
  key: 0,
  class: "flex flex-wrap items-center gap-1"
}, Q0 = ["id"], _0 = {
  key: 1,
  "data-testid": "radio-form-body",
  class: "flex w-full flex-col gap-3"
}, ey = {
  key: 2,
  class: "flex"
}, rV = /* @__PURE__ */ ge({
  __name: "RadioForm",
  props: {
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    value: { type: [String, Number, Boolean] },
    label: {},
    helper: { default: void 0 },
    icon: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ctaLabel: { default: void 0 },
    ctaIcon: { default: "ri-eye-line" },
    ariaLabel: { default: void 0 },
    labelTooltip: { default: void 0 },
    badges: { default: void 0 },
    indicatorPosition: { default: "right" }
  },
  emits: ["update:modelValue", "cta"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = ht(), a = y(() => n.modelValue === n.value), l = y(() => n.type === "simple"), s = Ke(), i = y(() => !!n.helper && !l.value), d = Ke(), u = y(() => {
      const B = [];
      return i.value && B.push(s), n.labelTooltip && B.push(d), B.length > 0 ? B.join(" ") : void 0;
    }), f = N(null), h = N(null), b = N(!1), m = N(!1), v = y(() => {
      if (n.labelTooltip)
        return m.value ? !1 : b.value ? !0 : void 0;
    });
    function x(B) {
      try {
        return B.matches(":focus-visible");
      } catch {
        return !0;
      }
    }
    function k(B) {
      var I;
      return B instanceof Node && !!((I = f.value) != null && I.contains(B));
    }
    function L(B) {
      n.labelTooltip && B.target === f.value && B.target instanceof Element && x(B.target) && (b.value = !0);
    }
    function P(B) {
      k(B.relatedTarget) || (b.value = !1, m.value = !1);
    }
    const E = y(
      () => n.labelTooltip ? "flex items-center gap-1" : ""
    ), O = y(
      () => n.disabled ? vr : "text-(--colors-icon-dark-default) dark:text-(--colors-text-white-default)"
    );
    function R() {
      b.value || (m.value = !1);
    }
    const V = y(() => l.value ? "items-center" : "items-start"), J = y(
      () => `flex w-full flex-wrap ${V.value} ${l.value ? "gap-3" : "gap-2"}`
    ), F = y(() => !n.readonly && !n.disabled), A = y(
      () => n.type === "card-cta" && !!n.ctaLabel && !n.readonly
    ), j = y(
      () => `flex flex-col gap-3 ${l.value ? "justify-center" : "min-w-60"} ${pi} ${on} ${gi}`
    ), _ = y(() => n.readonly ? `${j.value} ${hl} ${bl}` : n.disabled ? `${j.value} ${Do} ${jf} cursor-not-allowed` : a.value ? `${j.value} ${tl} shadow-sm ${an}` : `${j.value} ${hl} ${bl} hover:border-(--border-border-accent) hover:shadow-sm ${an}`);
    function U() {
      F.value && r("update:modelValue", n.value);
    }
    function W(B) {
      var I, M;
      if (B.key === "Escape" && n.labelTooltip) {
        (I = h.value) != null && I.isVisible && (B.stopPropagation(), B.preventDefault()), m.value = !0, (M = h.value) == null || M.hide();
        return;
      }
      F.value && (B.key === " " || B.key === "Enter") && (B.preventDefault(), r("update:modelValue", n.value));
    }
    function K() {
      n.disabled || r("cta");
    }
    function le(B) {
      return n.disabled ? "disabled" : B.theme ?? "disabled";
    }
    function C(B) {
      return B.startsWith("ri-");
    }
    return (B, I) => (c(), p("div", {
      id: e.id,
      ref_key: "cardRef",
      ref: f,
      "data-testid": "radio-form",
      role: e.readonly ? "group" : "radio",
      "aria-checked": e.readonly ? void 0 : a.value,
      "aria-disabled": e.disabled || void 0,
      "aria-label": e.ariaLabel ?? e.label,
      "aria-describedby": u.value,
      "data-name": e.name,
      tabindex: e.readonly ? void 0 : e.disabled ? -1 : 0,
      class: S(_.value),
      onClick: U,
      onKeydown: W,
      onFocusin: L,
      onFocusout: P,
      onMouseleave: R
    }, [
      e.labelTooltip ? (c(), p("span", {
        key: 0,
        id: T(d),
        class: "sr-only"
      }, $(e.labelTooltip), 9, J0)) : w("", !0),
      g("div", {
        class: S(J.value)
      }, [
        l.value ? (c(), p(Z, { key: 0 }, [
          e.icon ? (c(), p(Z, { key: 0 }, [
            C(e.icon) ? (c(), te(vn, {
              key: 0,
              size: "md",
              shape: "square",
              variant: "outlined",
              color: e.disabled ? "disabled" : "white",
              content: e.icon,
              "content-type": "icon"
            }, null, 8, ["color", "content"])) : (c(), p("span", {
              key: 1,
              class: S(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
              "aria-hidden": "true"
            }, $(e.icon), 3))
          ], 64)) : w("", !0),
          g("span", {
            class: S([
              "min-w-0 flex-1 text-sm font-semibold leading-5",
              E.value,
              e.disabled ? T(vr) : "text-(--text-text-heading) dark:text-(--colors-text-white-default)"
            ])
          }, [
            Ze($(e.label) + " ", 1),
            e.labelTooltip ? (c(), te(Ye, {
              key: 0,
              ref_key: "tooltipRef",
              ref: h,
              text: e.labelTooltip,
              open: v.value,
              class: "shrink-0"
            }, {
              default: pe(() => [
                g("i", {
                  class: S(["ri-information-line cursor-help text-sm leading-none", O.value]),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              _: 1
            }, 8, ["text", "open"])) : w("", !0)
          ], 2)
        ], 64)) : (c(), p(Z, { key: 1 }, [
          e.icon ? (c(), p(Z, { key: 0 }, [
            C(e.icon) ? (c(), te(vn, {
              key: 0,
              size: "md",
              shape: "square",
              variant: "outlined",
              color: e.disabled ? "disabled" : "white",
              content: e.icon,
              "content-type": "icon"
            }, null, 8, ["color", "content"])) : (c(), p("span", {
              key: 1,
              class: S(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
              "aria-hidden": "true"
            }, $(e.icon), 3))
          ], 64)) : w("", !0),
          g("div", Z0, [
            g("div", Y0, [
              g("span", {
                class: S([
                  "min-w-0 flex-1 text-base font-bold leading-6",
                  E.value,
                  e.disabled ? T(vr) : "text-(--text-text-heading) dark:text-(--colors-text-white-default)"
                ])
              }, [
                Ze($(e.label) + " ", 1),
                e.labelTooltip ? (c(), te(Ye, {
                  key: 0,
                  ref_key: "tooltipRef",
                  ref: h,
                  text: e.labelTooltip,
                  open: v.value,
                  class: "shrink-0"
                }, {
                  default: pe(() => [
                    g("i", {
                      class: S(["ri-information-line cursor-help text-sm leading-none", O.value]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["text", "open"])) : w("", !0)
              ], 2),
              e.badges && e.badges.length > 0 ? (c(), p("span", X0, [
                (c(!0), p(Z, null, ke(e.badges, (M, D) => (c(), te(pt, {
                  key: D,
                  label: M.label,
                  theme: le(M),
                  size: "sm",
                  "show-left-icon": !1,
                  "show-close-icon": !1
                }, null, 8, ["label", "theme"]))), 128))
              ])) : w("", !0)
            ]),
            i.value ? (c(), p("span", {
              key: 0,
              id: T(s),
              class: S([
                "text-sm font-normal leading-5",
                e.disabled ? T(vr) : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)"
              ])
            }, $(e.helper), 11, Q0)) : w("", !0)
          ])
        ], 64)),
        e.readonly ? w("", !0) : (c(), p("div", {
          key: 2,
          "data-testid": "radio-form-indicator",
          class: S(["pointer-events-none w-4 shrink-0", e.indicatorPosition === "left" ? "order-first" : void 0]),
          "aria-hidden": "true"
        }, [
          ae(W0, {
            "model-value": e.modelValue,
            value: e.value,
            disabled: e.disabled,
            presentational: ""
          }, null, 8, ["model-value", "value", "disabled"])
        ], 2))
      ], 2),
      T(o)("default") ? (c(), p("div", _0, [
        be(B.$slots, "default")
      ])) : w("", !0),
      A.value ? (c(), p("div", ey, [
        ae($e, {
          "data-testid": "radio-form-cta",
          variant: "secondary",
          size: "sm",
          "icon-left": e.ctaIcon,
          label: e.ctaLabel,
          disabled: e.disabled,
          class: "!rounded-full",
          onClick: Ie(K, ["stop"])
        }, null, 8, ["icon-left", "label", "disabled"])
      ])) : w("", !0)
    ], 42, K0));
  }
}), ty = ["id", "role", "aria-checked", "aria-disabled", "aria-label", "aria-describedby", "data-name", "tabindex"], ny = {
  key: 1,
  class: "flex min-w-0 flex-1 flex-col gap-2"
}, ry = ["src"], oy = { class: "flex w-full flex-col gap-1" }, ay = ["id"], ly = {
  key: 0,
  "data-testid": "checkbox-form-indicator",
  class: "pointer-events-none w-4 shrink-0 py-1",
  "aria-hidden": "true"
}, sy = {
  key: 0,
  class: "flex min-w-0 flex-wrap items-center gap-3"
}, iy = {
  key: 0,
  class: "flex flex-wrap items-center gap-1"
}, dy = {
  key: 1,
  class: "flex flex-wrap items-center gap-3"
}, uy = ["id"], cy = {
  key: 1,
  "data-testid": "checkbox-form-details",
  class: "mt-2 flex items-center gap-4"
}, fy = {
  key: 3,
  class: "flex shrink-0 items-center justify-end"
}, oV = /* @__PURE__ */ ge({
  __name: "CheckboxForm",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    helper: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "card" },
    ariaLabel: { default: void 0 },
    align: { default: void 0 },
    badgesAlign: { default: void 0 },
    badges: { default: void 0 },
    icons: { default: void 0 },
    avatar: { default: void 0 },
    imageSrc: { default: void 0 },
    icon: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = ht(), a = y(() => !n.readonly && !n.disabled), l = y(() => n.type === "inline"), s = Ke(), i = y(() => !!n.helper && !d.value), d = y(() => n.type === "simple" && !n.icon), u = y(
      () => !l.value && !n.avatar && !n.readonly && n.type !== "simple" && !!(n.badges && n.badges.length > 0 || n.icons && n.icons.length > 0)
    ), f = y(() => (n.align ?? (n.avatar ? "center" : void 0) ?? (n.type === "simple" && n.icon ? "center" : void 0) ?? "top") === "center" ? "items-center" : "items-start"), h = y(() => n.badgesAlign ?? (n.avatar ? "title" : "end")), b = y(() => l.value ? "flex flex-wrap items-start gap-1" : h.value === "title" ? "flex flex-wrap items-center gap-3" : "flex flex-wrap items-center justify-between gap-2"), m = y(() => "group flex flex-wrap gap-2 p-px min-w-60"), v = y(
      () => `flex flex-wrap gap-2 min-w-60 ${pi} ${gi}`
    ), x = y(() => `flex ${f.value} min-w-0 flex-1 gap-2`), k = y(() => {
      if (l.value)
        return n.readonly ? m.value : n.disabled ? `${m.value} cursor-not-allowed` : `${m.value} ${an}`;
      if (n.type === "big-card")
        return n.readonly ? `${v.value} ${on} bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base)` : n.disabled ? `${v.value} ${on} ${Do} border-(--border-border-base-medium) dark:border-(--colors-border-base) cursor-not-allowed` : n.modelValue ? `${v.value} ${tl} ${an}` : `${v.value} ${on} bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base) hover:bg-(--background-background-hover) dark:hover:bg-white/5 ${an}`;
      if (n.type === "simple") {
        if (!d.value)
          return n.readonly ? `${v.value} ${on} bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base)` : n.disabled ? `${v.value} ${on} ${Do} border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) cursor-not-allowed` : n.modelValue ? `${v.value} bg-(--background-background-selected) border-(--border-border-hover) ${an}` : `${v.value} ${on} bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base) hover:bg-(--background-background-hover) dark:hover:bg-white/5 ${an}`;
        const V = `flex items-center justify-center px-3 py-2 ${pi} ${gi} ${on}`;
        return n.readonly ? `${V} bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base)` : n.disabled ? `${V} ${Do} border-(--border-border-disabled) dark:border-(--colors-border-disabled-subtle) cursor-not-allowed` : n.modelValue ? `${V} ${tl} ${an}` : `${V} bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base) hover:bg-(--background-background-hover) ${an}`;
      }
      return n.readonly ? `${v.value} ${on} ${hl} ${bl}` : n.disabled ? `${v.value} ${on} ${Do} ${jf} cursor-not-allowed` : n.modelValue ? `${v.value} ${tl} ${an}` : `${v.value} ${on} ${hl} ${bl} hover:bg-(--background-background-hover) dark:hover:bg-white/5 ${an}`;
    }), L = y(() => {
      let V = n.disabled ? vr : "text-(--text-text-heading) dark:text-(--colors-text-white-default)";
      if (n.type === "inline" && !n.disabled && !n.readonly && (V += " group-hover:text-(--text-text-hover)"), n.type === "simple")
        return d.value ? `text-sm font-semibold leading-5 text-center ${V}` : `min-w-0 flex-1 text-sm font-semibold leading-5 ${V}`;
      const J = n.type === "big-card" ? "text-base leading-6" : "text-sm leading-5", A = `${l.value ? "min-w-0 flex-1" : "min-w-0"} font-medium ${J} ${V}`;
      return n.type === "advanced" && n.modelValue ? `${A} line-through` : A;
    });
    function P(V) {
      return n.disabled ? "disabled" : V.theme ?? "disabled";
    }
    function E() {
      a.value && r("update:modelValue", !n.modelValue);
    }
    function O(V) {
      a.value && (V.key === " " || V.key === "Enter") && (V.preventDefault(), r("update:modelValue", !n.modelValue));
    }
    function R(V) {
      return V.startsWith("ri-");
    }
    return (V, J) => (c(), p("div", {
      id: e.id,
      "data-testid": "checkbox-form",
      role: e.readonly ? "group" : "checkbox",
      "aria-checked": e.readonly ? void 0 : e.modelValue,
      "aria-disabled": e.disabled || void 0,
      "aria-label": e.ariaLabel ?? e.label,
      "aria-describedby": i.value ? T(s) : void 0,
      "data-name": e.name,
      tabindex: e.readonly ? void 0 : e.disabled ? -1 : 0,
      class: S(k.value),
      onClick: E,
      onKeydown: O
    }, [
      d.value ? (c(), p("span", {
        key: 0,
        class: S(L.value)
      }, $(e.label), 3)) : w("", !0),
      e.type === "big-card" ? (c(), p("div", ny, [
        e.imageSrc ? (c(), p("img", {
          key: 0,
          src: e.imageSrc,
          alt: "",
          class: "size-8 shrink-0 object-contain"
        }, null, 8, ry)) : w("", !0),
        g("div", oy, [
          g("span", {
            class: S(L.value)
          }, $(e.label), 3),
          i.value ? (c(), p("span", {
            key: 0,
            id: T(s),
            class: S([
              "text-sm font-normal leading-5",
              e.disabled ? T(vr) : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)"
            ])
          }, $(e.helper), 11, ay)) : w("", !0)
        ])
      ])) : w("", !0),
      !d.value && e.type !== "big-card" ? (c(), p("div", {
        key: 2,
        "data-testid": "checkbox-form-content-group",
        class: S(x.value)
      }, [
        !e.readonly && e.type !== "simple" ? (c(), p("div", ly, [
          ae(Xt, {
            "model-value": e.modelValue,
            disabled: e.disabled,
            presentational: ""
          }, null, 8, ["model-value", "disabled"])
        ])) : w("", !0),
        e.type === "simple" && e.icon ? (c(), p(Z, { key: 1 }, [
          R(e.icon) ? (c(), te(vn, {
            key: 0,
            size: "md",
            shape: "square",
            variant: "outlined",
            color: e.disabled ? "disabled" : "white",
            content: e.icon,
            "content-type": "icon"
          }, null, 8, ["color", "content"])) : (c(), p("span", {
            key: 1,
            class: S(["text-num-32 leading-none shrink-0", e.disabled ? "opacity-50" : ""]),
            "aria-hidden": "true"
          }, $(e.icon), 3))
        ], 64)) : w("", !0),
        e.type === "card" && e.avatar ? (c(), te(Cn, {
          key: 2,
          img: e.avatar.img,
          name: e.avatar.name,
          size: "md",
          presentational: ""
        }, null, 8, ["img", "name"])) : w("", !0),
        g("div", {
          class: S([
            "flex min-w-0 flex-1 flex-col gap-1",
            u.value ? "-mt-0.5" : ""
          ])
        }, [
          g("div", {
            "data-testid": "checkbox-form-title-row",
            class: S(b.value)
          }, [
            g("span", {
              class: S(L.value)
            }, $(e.label), 3),
            e.badges && e.badges.length > 0 || e.icons && e.icons.length > 0 ? (c(), p("span", sy, [
              e.badges && e.badges.length > 0 ? (c(), p("span", iy, [
                (c(!0), p(Z, null, ke(e.badges, (F, A) => (c(), te(pt, {
                  key: A,
                  label: F.label,
                  theme: P(F),
                  size: "sm",
                  "show-left-icon": !1,
                  "show-close-icon": !1
                }, null, 8, ["label", "theme"]))), 128))
              ])) : w("", !0),
              e.icons && e.icons.length > 0 ? (c(), p("span", dy, [
                (c(!0), p(Z, null, ke(e.icons, (F, A) => (c(), p("i", {
                  key: A,
                  class: S([`ri-${F}`, "text-2xl leading-none"]),
                  "aria-hidden": "true"
                }, null, 2))), 128))
              ])) : w("", !0)
            ])) : w("", !0)
          ], 2),
          i.value ? (c(), p("span", {
            key: 0,
            id: T(s),
            class: S([
              "text-sm font-normal leading-5",
              e.disabled ? T(vr) : "text-(--text-text-body) dark:text-(--colors-text-white-secondary)",
              e.type === "inline" && !e.disabled && !e.readonly ? "group-hover:text-(--text-text-hover)" : ""
            ])
          }, $(e.helper), 11, uy)) : w("", !0),
          (e.type === "advanced" || e.type === "card") && T(o)("details") ? (c(), p("div", cy, [
            be(V.$slots, "details")
          ])) : w("", !0)
        ], 2)
      ], 2)) : w("", !0),
      !d.value && e.type !== "big-card" && T(o)("trailing") ? (c(), p("div", fy, [
        be(V.$slots, "trailing")
      ])) : w("", !0)
    ], 42, ty));
  }
}), hy = { class: "w-full flex flex-col gap-2" }, by = {
  key: 0,
  class: "text-sm font-medium text-text-black-default dark:text-(--colors-text-white-default)"
}, py = { class: "flex flex-col items-center gap-2" }, gy = ["src"], my = { class: "relative text-sm leading-5 dark:text-(--colors-text-white-default)" }, vy = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, xy = { class: "flex-1 flex flex-col items-center gap-1.5" }, yy = { class: "flex-1 flex flex-col items-center gap-1.5" }, ky = { class: "flex-1 flex flex-col items-center gap-1.5" }, wy = ["id", "name", "accept", "disabled"], Cy = {
  key: 1,
  class: "text-sm text-red-600 dark:text-red-400"
}, Sy = /* @__PURE__ */ ge({
  __name: "ImageInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    browseButtonText: { default: "Browse file" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [Boolean, String], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link"],
  setup(e, { emit: t }) {
    const n = e, r = y(() => !!n.error), o = y(() => typeof n.error == "string" ? n.error : void 0), a = t, l = N(null), s = N(!1), i = N(!1), u = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[n.size], f = y(() => {
      const A = n.variant === "buttons" ? "border-border-base" : "border-border-primary-button", j = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${u.container}`;
      return n.disabled ? `${j} bg-background-disabled-subtle dark:bg-(--colors-background-disabled) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) cursor-not-allowed` : r.value ? `${j} bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] text-[#B42318] dark:text-[#B42318] cursor-pointer` : n.success ? `${j} bg-background-white dark:bg-(--colors-background-black-default) border-[#009966] dark:border-[#009966] text-text-body dark:text-(--colors-text-white-default) cursor-pointer` : s.value ? `${j} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : i.value ? `${j} shadow-[0px_0px_2px_#7c86ff] bg-background-hover dark:bg-[rgba(255,255,255,0.05)] border-[#7c86ff] dark:border-[#7c86ff] text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer` : `${j} bg-background-white dark:bg-(--colors-background-black-default) ${A} dark:border-(--colors-border-base) text-text-black-default dark:text-(--colors-text-white-default) cursor-pointer`;
    }), h = (A) => {
      if (!A || A.length === 0 || n.disabled) return;
      const j = Array.from(A);
      if (j.filter((K) => K.size > n.maxFileSize).length > 0) {
        a("error", `File size exceeds the maximum allowed size of ${n.maxFileSizeText}`);
        return;
      }
      const U = j.length === 1 ? j[0] : j;
      a("update:modelValue", U);
      const W = new Event("change", { bubbles: !0 });
      a("change", W);
    }, b = () => {
      var A;
      n.disabled || (A = l.value) == null || A.click();
    }, m = (A) => {
      var j;
      n.disabled || (a("browse", A), (j = l.value) == null || j.click());
    }, v = (A) => {
      n.disabled || a("library", A);
    }, x = (A) => {
      n.disabled || a("link", A);
    }, k = (A) => {
      const j = A.target;
      h(j.files);
    }, L = (A) => {
      A.preventDefault(), A.stopPropagation(), n.disabled || (s.value = !0);
    }, P = (A) => {
      A.preventDefault(), A.stopPropagation(), s.value = !1;
    }, E = (A) => {
      var _;
      if (A.preventDefault(), A.stopPropagation(), s.value = !1, n.disabled) return;
      const j = (_ = A.dataTransfer) == null ? void 0 : _.files;
      j && h(j);
    }, O = () => {
      var A;
      n.disabled || (A = l.value) == null || A.click();
    }, R = (A, j) => {
      try {
        if (A.startsWith("data:image/svg+xml")) {
          const _ = A.split(",")[1];
          if (!_) return A;
          const W = decodeURIComponent(_).replace(/fill=["']currentColor["']/gi, `fill="${j}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${j}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(W)}`;
        }
        return A.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${j.slice(1)}`);
      } catch {
        return A;
      }
    }, V = y(() => {
      if (n.browseIcon)
        return n.success && n.variant === "buttons" ? R(n.browseIcon, "#007A55") : n.browseIcon;
    }), J = y(() => {
      if (n.libraryIcon)
        return n.success && n.variant === "buttons" ? R(n.libraryIcon, "#007A55") : n.libraryIcon;
    }), F = y(() => {
      if (n.linkIcon)
        return n.success && n.variant === "buttons" ? R(n.linkIcon, "#007A55") : n.linkIcon;
    });
    return (A, j) => (c(), p("div", hy, [
      e.label ? (c(), p("div", by, $(e.label), 1)) : w("", !0),
      g("div", {
        class: S(f.value),
        onDragover: L,
        onDragleave: P,
        onDrop: E,
        onClick: j[0] || (j[0] = (_) => e.variant === "default" ? O() : void 0),
        onMouseenter: j[1] || (j[1] = (_) => i.value = !0),
        onMouseleave: j[2] || (j[2] = (_) => i.value = !1)
      }, [
        e.variant === "default" ? (c(), p("div", {
          key: 0,
          class: S(["flex flex-col items-center", T(u).gap])
        }, [
          g("div", py, [
            e.uploadIcon ? (c(), p("img", {
              key: 0,
              src: e.uploadIcon,
              class: S([T(u).icon, "relative", "image-input-icon"]),
              alt: ""
            }, null, 10, gy)) : w("", !0),
            g("div", my, $(e.uploadText), 1),
            g("div", {
              class: S([
                "relative text-xs! leading-4 font-medium",
                e.success ? "text-[#007A55] dark:text-[#007A55]" : !e.disabled && !e.error ? "text-text-body dark:text-(--colors-text-white-default)" : "dark:text-(--colors-text-disabled)"
              ])
            }, $(e.maxFileSizeText), 3)
          ]),
          ae(T($e), {
            variant: "primary",
            label: e.browseButtonText,
            "icon-left": e.browseButtonIcon,
            size: "xs",
            disabled: e.disabled,
            type: "button",
            onClick: Ie(b, ["stop"])
          }, null, 8, ["label", "icon-left", "disabled"])
        ], 2)) : (c(), p("div", vy, [
          g("div", {
            class: S([
              "relative leading-5 text-sm!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-text-body dark:text-(--colors-text-white-default)" : "text-text-black-default dark:text-(--colors-text-white-default)"
            ])
          }, $(e.dragDropText), 3),
          g("div", {
            class: S([
              "self-stretch flex items-start gap-6 text-xs!",
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : "text-text-body dark:text-(--colors-text-white-default)"
            ])
          }, [
            g("div", xy, [
              g("div", {
                class: S([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : r.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                V.value ? (c(), te(T($e), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": V.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  onClick: Ie(m, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              g("div", {
                class: S([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, $(e.browseLabel), 3)
            ]),
            g("div", yy, [
              g("div", {
                class: S([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : r.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                J.value ? (c(), te(T($e), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": J.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  onClick: Ie(v, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              g("div", {
                class: S([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, $(e.libraryLabel), 3)
            ]),
            g("div", ky, [
              g("div", {
                class: S([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#D1D5DC] dark:border-(--colors-border-disabled-subtle) border" : r.value ? "bg-background-white dark:bg-(--colors-background-black-default) border-[#B42318] dark:border-[#B42318] border" : e.success ? "bg-background-success dark:bg-background-success border-transparent border-0" : "bg-background-white dark:bg-(--colors-background-black-default) border-border-base-medium dark:border-(--colors-border-base) border"
                ])
              }, [
                F.value ? (c(), te(T($e), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": F.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  onClick: Ie(x, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              g("div", {
                class: S([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : r.value ? "text-[#B42318] dark:text-[#B42318]" : e.success ? "text-[#007A55] dark:text-[#007A55]" : "text-text-black-default dark:text-(--colors-text-white-default)"
                ])
              }, $(e.linkLabel), 3)
            ])
          ], 2)
        ])),
        g("input", {
          id: e.id,
          ref_key: "fileInputRef",
          ref: l,
          "data-testid": "image-input",
          name: e.name,
          type: "file",
          accept: e.accept,
          disabled: e.disabled,
          class: "sr-only",
          onChange: k
        }, null, 40, wy)
      ], 34),
      o.value ? (c(), p("div", Cy, $(o.value), 1)) : w("", !0)
    ]));
  }
}), aV = /* @__PURE__ */ He(Sy, [["__scopeId", "data-v-56dbf55a"]]), $y = { class: "w-full flex flex-col gap-2" }, Iy = {
  key: 0,
  class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, Ty = {
  key: 0,
  "aria-hidden": "true"
}, Ly = { class: "relative" }, My = ["id", "name", "accept", "disabled", "multiple"], Ey = ["disabled"], Ay = ["aria-label"], Dy = {
  key: 1,
  class: "flex items-start gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error-strong)"
}, Ry = {
  key: 2,
  class: "w-full flex flex-col gap-4"
}, By = { class: "flex flex-col gap-px" }, Oy = { class: "flex flex-col items-center gap-2" }, Py = { class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--text-text-white-default) text-center" }, zy = { class: "text-(length:--size-sm) leading-(--line-height-l) text-(--text-text-body) dark:text-(--text-text-white-default) text-center whitespace-pre-line" }, Ny = ["id", "name", "accept", "disabled", "multiple", "aria-describedby"], Vy = {
  key: 0,
  class: "flex flex-col gap-3"
}, Fy = { class: "flex flex-1 items-center gap-2.5 min-w-0" }, Hy = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  class: "shrink-0"
}, Wy = ["id"], jy = ["stroke", "stroke-dashoffset"], Uy = { class: "flex flex-col min-w-0" }, Gy = { class: "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" }, qy = { class: "flex gap-2 text-(length:--size-sm)" }, Ky = { class: "font-(--weight-medium) text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, Jy = { class: "flex items-center gap-1 shrink-0" }, Zy = {
  key: 1,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, Yy = {
  key: 2,
  class: "h-9 w-9 flex items-center justify-center shrink-0"
}, Xy = { class: "flex flex-col items-center gap-2" }, Qy = ["src"], _y = { class: "flex flex-col items-center gap-2" }, ek = ["src"], tk = {
  key: 1,
  class: "text-xs text-(--text-text-error-strong) dark:text-(--text-text-error-strong)"
}, nk = {
  key: 1,
  class: "flex flex-col items-center gap-5"
}, rk = { class: "flex-1 flex flex-col items-center gap-1.5" }, ok = { class: "flex-1 flex flex-col items-center gap-1.5" }, ak = { class: "flex-1 flex flex-col items-center gap-1.5" }, lk = ["id", "name", "accept", "disabled", "multiple"], sk = {
  key: 5,
  class: "text-sm text-(--text-text-error-strong) dark:text-(--text-text-error-strong)"
}, ik = {
  key: 6,
  class: "mt-3 space-y-1"
}, dk = { class: "flex-shrink-0" }, uk = {
  key: 0,
  class: "w-5 h-5 text-(--text-text-success-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, ck = {
  key: 1,
  class: "w-5 h-5 text-(--text-text-error-strong)",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, fk = { class: "flex-1 min-w-0" }, hk = { key: 0 }, bk = ["disabled", "onClick"], Ts = 10.2, Eu = 3.6, pk = /* @__PURE__ */ ge({
  __name: "FileUploadInput",
  props: {
    variant: { default: "default" },
    uploadText: { default: "Click to upload or drag and drop" },
    maxFileSizeText: { default: "Max. File Size: 30MB" },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    browseButtonText: { default: "Select file" },
    placeholder: { default: "Placeholder text" },
    uploadIcon: { default: void 0 },
    browseButtonIcon: { default: void 0 },
    dragDropText: { default: "Drag and drop a file here, or:" },
    browseLabel: { default: "Browse" },
    browseIcon: { default: void 0 },
    libraryLabel: { default: "Library" },
    libraryIcon: { default: void 0 },
    linkLabel: { default: "Link" },
    linkIcon: { default: void 0 },
    accept: { default: "*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    size: { default: "md" },
    success: { type: Boolean, default: !1 },
    error: { type: [Boolean, String], default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    modelValue: { default: null },
    uploadedFile: { default: null },
    uploadedFiles: { default: () => [] },
    multiple: { type: Boolean, default: !1 },
    addFilesText: { default: "Add file(s)" },
    addMoreText: { default: "Add more" },
    addMoreIcon: { default: void 0 },
    progressFiles: { default: () => [] },
    pauseLabel: { default: "Pause" },
    resumeLabel: { default: "Resume" },
    removeLabel: { default: "Remove file" },
    clearFileLabel: { default: "Clear file" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "error", "browse", "library", "link", "addMore", "fileClick", "removeFile", "pauseFile", "resumeFile", "removeProgressFile", "clear"],
  setup(e, { emit: t }) {
    const n = e, r = y(() => !!n.error), o = y(() => typeof n.error == "string" ? n.error : void 0), a = `${Ke()}-error`, l = y(() => !!n.uploadedFile), s = (de) => de ? de < 1024 ? `${de}B` : de < 1024 * 1024 ? `${(de / 1024).toFixed(0)}Ko` : `${(de / (1024 * 1024)).toFixed(1)}Mo` : "", i = y(() => {
      if (!n.uploadedFile) return "";
      const de = n.uploadedFile.name, fe = n.uploadedFile.size ? ` (${s(n.uploadedFile.size)})` : "";
      return `${de}${fe}`;
    }), d = t;
    function u() {
      f.value && (f.value.value = ""), d("update:modelValue", null), d("clear");
    }
    const f = N(null), h = N(!1), b = N(!1), m = N(/* @__PURE__ */ new Set());
    function v(de) {
      m.value.has(de) ? (m.value.delete(de), d("resumeFile", de)) : (m.value.add(de), d("pauseFile", de)), m.value = new Set(m.value);
    }
    const x = 2 * Math.PI * Ts;
    function k(de) {
      return x * (1 - Math.min(Math.max(de, 0), 100) / 100);
    }
    const P = {
      sm: {
        container: "h-[180px]",
        text: "text-xs",
        icon: "w-5 h-5",
        gap: "gap-3"
      },
      md: {
        container: "h-[228px]",
        text: "text-sm",
        icon: "w-6 h-6",
        gap: "gap-4"
      },
      lg: {
        container: "h-[280px]",
        text: "text-base",
        icon: "w-7 h-7",
        gap: "gap-5"
      },
      xl: {
        container: "h-[320px]",
        text: "text-lg",
        icon: "w-8 h-8",
        gap: "gap-6"
      }
    }[n.size], E = y(() => {
      const de = n.variant === "dropzone" ? "border-(--border-border-base)" : "border-(--border-border-primary-button)", fe = `w-full relative rounded-xl border-dashed border-[1px] box-border flex flex-col items-center justify-center text-center text-sm font-inter transition-[border-color,background-color,box-shadow,color] duration-200 ${P.container}`;
      return n.disabled ? `${fe} bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed` : r.value ? `${fe} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : n.success || l.value ? `${fe} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-success-strong) dark:border-(--border-border-success-strong) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : h.value ? `${fe} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : b.value ? `${fe} shadow-[0px_0px_2px_var(--border-border-hover)] bg-(--background-background-hover) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-hover) dark:border-(--border-border-hover) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer` : `${fe} bg-(--background-background-white) dark:bg-(--background-background-black-default) ${de} dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-pointer`;
    }), O = (de, fe) => {
      if (!fe || fe === "*" || fe === "*/*") return !0;
      const q = fe.split(",").map((G) => G.trim().toLowerCase()).filter((G) => G.length > 0);
      if (q.length === 0) return !0;
      const oe = (de.type || "").toLowerCase(), ue = (de.name || "").toLowerCase();
      return q.some((G) => G.startsWith(".") ? ue.endsWith(G) : G.endsWith("/*") ? oe.startsWith(G.slice(0, -1)) : oe === G);
    }, R = (de) => {
      if (!de || de.length === 0 || n.disabled) return;
      const fe = Array.from(de);
      if (fe.filter((H) => !O(H, n.accept)).length > 0) {
        d("error", n.fileTypeErrorText || "File type not supported.");
        return;
      }
      if (fe.filter((H) => H.size > n.maxFileSize).length > 0) {
        d(
          "error",
          n.fileSizeErrorText || `File size exceeds the maximum allowed size of ${n.maxFileSizeText}`
        );
        return;
      }
      const ue = n.multiple ? fe : fe[0];
      d("update:modelValue", ue);
      const G = new Event("change", { bubbles: !0 });
      d("change", G);
    }, V = () => {
      var de;
      n.disabled || (de = f.value) == null || de.click();
    }, J = (de) => {
      var fe;
      n.disabled || (d("browse", de), (fe = f.value) == null || fe.click());
    }, F = (de) => {
      n.disabled || d("library", de);
    }, A = (de) => {
      n.disabled || d("link", de);
    }, j = (de) => {
      var fe;
      n.disabled || (d("addMore", de), (fe = f.value) == null || fe.click());
    }, _ = () => {
      n.uploadedFile && d("fileClick", n.uploadedFile);
    }, U = (de, fe) => {
      n.disabled || d("removeFile", de, fe);
    }, W = (de) => {
      const fe = de.target;
      R(fe.files);
    }, K = (de) => {
      de.preventDefault(), de.stopPropagation(), n.disabled || (h.value = !0);
    }, le = (de) => {
      de.preventDefault(), de.stopPropagation(), h.value = !1;
    }, C = (de) => {
      var q;
      if (de.preventDefault(), de.stopPropagation(), h.value = !1, n.disabled) return;
      const fe = (q = de.dataTransfer) == null ? void 0 : q.files;
      fe && R(fe);
    }, B = () => {
      var de;
      n.disabled || l.value || (de = f.value) == null || de.click();
    }, I = (de, fe) => {
      try {
        if (de.startsWith("data:image/svg+xml")) {
          const q = de.split(",")[1];
          if (!q) return de;
          const ue = decodeURIComponent(q).replace(/fill=["']currentColor["']/gi, `fill="${fe}"`).replace(/fill=["']#[0-9A-Fa-f]{6}["']/gi, `fill="${fe}"`);
          return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(ue)}`;
        }
        return de.replace(/color=%[0-9A-Fa-f]{6}/, `color=%23${fe.slice(1)}`);
      } catch {
        return de;
      }
    }, M = {
      // --icons-icon-dark-default
      error: "#b42318",
      // --icons-icon-error
      success: "#007a55",
      // --text-text-success-strong
      disabled: "#99a1af"
      // --icons-icon-disabled-light
    }, D = y(() => {
      if (n.browseIcon)
        return n.disabled && n.variant === "dropzone" ? I(n.browseIcon, M.disabled) : r.value && n.variant === "dropzone" ? I(n.browseIcon, M.error) : (n.success || l.value) && n.variant === "dropzone" ? I(n.browseIcon, M.success) : n.browseIcon;
    }), re = y(() => {
      if (n.libraryIcon)
        return n.disabled && n.variant === "dropzone" ? I(n.libraryIcon, M.disabled) : r.value && n.variant === "dropzone" ? I(n.libraryIcon, M.error) : (n.success || l.value) && n.variant === "dropzone" ? I(n.libraryIcon, M.success) : n.libraryIcon;
    }), se = y(() => {
      if (n.linkIcon)
        return n.disabled && n.variant === "dropzone" ? I(n.linkIcon, M.disabled) : r.value && n.variant === "dropzone" ? I(n.linkIcon, M.error) : (n.success || l.value) && n.variant === "dropzone" ? I(n.linkIcon, M.success) : n.linkIcon;
    });
    return (de, fe) => (c(), p("div", $y, [
      e.label ? (c(), p("div", Iy, [
        Ze($(e.label), 1),
        e.required ? (c(), p("span", Ty, "*")) : w("", !0)
      ])) : w("", !0),
      e.variant === "basic" ? (c(), p(Z, { key: 1 }, [
        g("div", Ly, [
          g("input", {
            id: e.id,
            ref_key: "fileInputRef",
            ref: f,
            "data-testid": "file-upload-input-basic",
            name: e.name,
            type: "file",
            accept: e.accept,
            disabled: e.disabled,
            multiple: e.multiple,
            class: "absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10",
            onChange: W
          }, null, 40, My),
          g("div", {
            class: S([
              "flex items-center w-full bg-(--background-background-white) dark:bg-(--background-background-black-default) border rounded-lg shadow-xs transition-colors",
              e.disabled ? "border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) cursor-not-allowed" : r.value ? "border-(--border-border-error-strong) dark:border-(--border-border-error-strong) focus-within:ring-4 focus-within:ring-(--border-border-error-medium)" : "border-(--border-border-base-medium) dark:border-(--border-border-base) focus-within:ring-4 focus-within:ring-(--border-border-hover-medium) focus-within:border-(--border-border-hover)"
            ])
          }, [
            g("button", {
              type: "button",
              class: S([
                "flex-shrink-0 px-3 py-2 text-sm font-medium rounded-l-lg border-r transition-colors",
                e.disabled ? "bg-(--background-background-disabled-subtle) dark:bg-(--background-background-disabled) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light) cursor-not-allowed" : r.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:bg-(--background-background-hover) dark:hover:bg-[rgba(255,255,255,0.05)]"
              ]),
              disabled: e.disabled,
              onClick: Ie(V, ["stop"])
            }, $(e.browseButtonText), 11, Ey),
            g("div", {
              class: S([
                "flex-1 px-3 py-2 text-sm pointer-events-none truncate",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.modelValue ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ])
            }, $(e.modelValue ? Array.isArray(e.modelValue) ? `${e.modelValue.length} file(s) selected` : e.modelValue.name : e.placeholder), 3),
            e.modelValue && !e.disabled ? (c(), p("button", {
              key: 0,
              type: "button",
              class: "relative z-20 shrink-0 flex items-center justify-center px-2 self-stretch text-(--text-text-black-default) dark:text-(--text-text-white-default) hover:text-(--text-text-body)",
              "aria-label": e.clearFileLabel,
              onClick: Ie(u, ["stop"])
            }, [...fe[3] || (fe[3] = [
              g("i", {
                class: "ri-close-fill text-base",
                "aria-hidden": "true"
              }, null, -1)
            ])], 8, Ay)) : w("", !0)
          ], 2)
        ]),
        e.maxFileSizeText ? (c(), p("div", {
          key: 0,
          class: S([
            "flex items-start gap-1 text-xs whitespace-pre-line",
            e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
          ])
        }, [
          fe[4] || (fe[4] = g("i", {
            class: "ri-information-fill text-xs leading-5 shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          g("span", null, $(e.maxFileSizeText), 1)
        ], 2)) : w("", !0),
        o.value ? (c(), p("div", Dy, [
          fe[5] || (fe[5] = g("i", {
            class: "ri-close-circle-fill text-xs leading-5 shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          g("span", null, $(o.value), 1)
        ])) : w("", !0)
      ], 64)) : e.variant === "advanced" ? (c(), p("div", Ry, [
        g("div", By, [
          g("div", {
            class: "w-full rounded-xl border border-dashed border-(--border-border-base-medium) dark:border-(--border-border-base) bg-(--background-background-white-secondary-soft) dark:bg-(--background-background-black-default) flex h-[228px] flex-col items-center justify-center gap-4 px-5",
            onDragover: K,
            onDragleave: le,
            onDrop: C
          }, [
            g("div", Oy, [
              fe[6] || (fe[6] = g("i", {
                class: "ri-upload-2-line text-(length:--size-xl) text-(--text-text-black-default) dark:text-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1)),
              g("p", Py, $(e.uploadText), 1),
              g("p", zy, $(e.maxFileSizeText), 1)
            ]),
            ae(T($e), {
              variant: "primary",
              label: e.addFilesText,
              "icon-left": "ri-add-line",
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: Ie(V, ["stop"])
            }, null, 8, ["label", "disabled"]),
            g("input", {
              id: e.id,
              ref_key: "fileInputRef",
              ref: f,
              "data-testid": "file-upload-input",
              name: e.name,
              type: "file",
              accept: e.accept,
              disabled: e.disabled,
              multiple: e.multiple,
              "aria-describedby": o.value ? a : void 0,
              class: "sr-only",
              onChange: W
            }, null, 40, Ny)
          ], 32),
          o.value ? (c(), p("div", {
            key: 0,
            id: a,
            "data-testid": "file-upload-error",
            role: "alert",
            class: "flex items-start gap-1 text-xs leading-5 text-(--text-text-error-strong) dark:text-(--text-text-error-strong)"
          }, [
            fe[7] || (fe[7] = g("i", {
              class: "ri-close-circle-fill text-xs leading-5 shrink-0",
              "aria-hidden": "true"
            }, null, -1)),
            g("span", null, $(o.value), 1)
          ])) : w("", !0)
        ]),
        e.progressFiles.length ? (c(), p("div", Vy, [
          (c(!0), p(Z, null, ke(e.progressFiles, (q) => (c(), p("div", {
            key: q.id,
            "data-testid": "upload-progress-row",
            class: "flex w-full items-center justify-between gap-2.5"
          }, [
            g("div", Fy, [
              (c(), p("svg", Hy, [
                g("defs", null, [
                  g("linearGradient", {
                    id: `upload-ring-gradient-${q.id}`,
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "100%"
                  }, [...fe[8] || (fe[8] = [
                    g("stop", {
                      offset: "0%",
                      style: { "stop-color": "var(--gradient-brand-start)" }
                    }, null, -1),
                    g("stop", {
                      offset: "100%",
                      style: { "stop-color": "var(--gradient-brand-end)" }
                    }, null, -1)
                  ])], 8, Wy)
                ]),
                g("circle", {
                  cx: "12",
                  cy: "12",
                  r: Ts,
                  fill: "none",
                  "stroke-width": Eu,
                  class: "stroke-(--border-border-base-soft) dark:stroke-(--border-border-base-soft)"
                }),
                g("circle", {
                  "data-testid": "progress-ring-fill",
                  cx: "12",
                  cy: "12",
                  r: Ts,
                  fill: "none",
                  "stroke-width": Eu,
                  "stroke-linecap": "round",
                  transform: "rotate(-90 12 12)",
                  stroke: `url(#upload-ring-gradient-${q.id})`,
                  "stroke-dasharray": x,
                  "stroke-dashoffset": k(q.percent)
                }, null, 8, jy)
              ])),
              g("div", Uy, [
                g("p", Gy, $(q.name), 1),
                g("div", qy, [
                  g("span", Ky, $(q.percent) + "%", 1),
                  g("span", {
                    class: S(
                      q.status === "success" ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : q.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                    )
                  }, $(q.statusText), 3)
                ])
              ])
            ]),
            g("div", Jy, [
              q.status === "uploading" ? (c(), te(T($e), {
                key: 0,
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": m.value.has(q.id) ? "ri-play-line" : "ri-pause-line",
                "icon-alt": m.value.has(q.id) ? e.resumeLabel : e.pauseLabel,
                "data-testid": "pause-icon",
                onClick: (oe) => v(q.id)
              }, null, 8, ["icon-left", "icon-alt", "onClick"])) : w("", !0),
              q.status === "success" ? (c(), p("span", Zy, [...fe[9] || (fe[9] = [
                g("i", {
                  "data-testid": "progress-success-icon",
                  class: "ri-checkbox-circle-line text-(length:--size-xxl) text-(--icons-icon-success) dark:text-(--icons-icon-success)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : q.status === "error" ? (c(), p("span", Yy, [...fe[10] || (fe[10] = [
                g("i", {
                  "data-testid": "progress-error-icon",
                  class: "ri-error-warning-line text-(length:--size-xxl) text-(--icons-icon-error) dark:text-(--icons-icon-error)",
                  "aria-hidden": "true"
                }, null, -1)
              ])])) : w("", !0),
              ae(T($e), {
                variant: "text",
                "icon-only": "",
                size: "sm",
                "icon-left": "ri-close-line",
                "icon-alt": e.removeLabel,
                "data-testid": "delete-icon",
                onClick: (oe) => d("removeProgressFile", q.id)
              }, null, 8, ["icon-alt", "onClick"])
            ])
          ]))), 128))
        ])) : w("", !0)
      ])) : (c(), p("div", {
        key: 3,
        class: S(E.value),
        onDragover: K,
        onDragleave: le,
        onDrop: C,
        onClick: fe[0] || (fe[0] = (q) => e.variant === "default" ? B() : void 0),
        onMouseenter: fe[1] || (fe[1] = (q) => b.value = !0),
        onMouseleave: fe[2] || (fe[2] = (q) => b.value = !1)
      }, [
        e.variant === "default" ? (c(), p(Z, { key: 0 }, [
          l.value ? (c(), p("div", {
            key: 1,
            class: S(["flex flex-col items-center", T(P).gap])
          }, [
            g("div", _y, [
              e.uploadIcon ? (c(), p("img", {
                key: 0,
                src: e.uploadIcon,
                class: S([
                  T(P).icon,
                  "relative",
                  e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                ]),
                alt: ""
              }, null, 10, ek)) : w("", !0),
              g("div", {
                class: S([
                  "relative text-sm leading-5",
                  e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                ])
              }, $(e.uploadText), 3),
              g("button", {
                type: "button",
                class: S([
                  "relative text-sm leading-5 font-medium cursor-pointer hover:underline",
                  r.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)"
                ]),
                onClick: Ie(_, ["stop"])
              }, $(i.value), 3),
              o.value ? (c(), p("div", tk, $(o.value), 1)) : w("", !0)
            ]),
            ae(T($e), {
              variant: "secondary",
              label: `+ ${e.addMoreText}`,
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: Ie(j, ["stop"])
            }, null, 8, ["label", "disabled"])
          ], 2)) : (c(), p("div", {
            key: 0,
            class: S(["flex flex-col items-center", T(P).gap])
          }, [
            g("div", Xy, [
              e.uploadIcon ? (c(), p("img", {
                key: 0,
                src: e.uploadIcon,
                class: S([
                  T(P).icon,
                  "relative",
                  e.disabled ? "file-input-icon-disabled" : "file-input-icon"
                ]),
                alt: ""
              }, null, 10, Qy)) : w("", !0),
              g("div", {
                class: S([
                  "relative text-sm leading-5",
                  e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                ])
              }, $(e.uploadText), 3),
              g("div", {
                class: S([
                  "relative text-xs! leading-4 font-medium",
                  e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : e.success || l.value || e.error ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
                ])
              }, $(e.maxFileSizeText), 3)
            ]),
            ae(T($e), {
              variant: "primary",
              label: e.browseButtonText,
              "icon-left": e.browseButtonIcon,
              size: "xs",
              disabled: e.disabled,
              type: "button",
              onClick: Ie(V, ["stop"])
            }, null, 8, ["label", "icon-left", "disabled"])
          ], 2))
        ], 64)) : (c(), p("div", nk, [
          g("div", {
            class: S([
              "relative leading-5 text-sm!",
              e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
            ])
          }, $(e.dragDropText), 3),
          g("div", {
            class: S([
              "self-stretch flex items-start gap-6 text-xs!",
              e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
            ])
          }, [
            g("div", rk, [
              g("div", {
                class: S([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : r.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || l.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                ])
              }, [
                D.value ? (c(), te(T($e), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": D.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  onClick: Ie(J, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              g("div", {
                class: S([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : r.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || l.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                ])
              }, $(e.browseLabel), 3)
            ]),
            g("div", ok, [
              g("div", {
                class: S([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : r.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || l.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                ])
              }, [
                re.value ? (c(), te(T($e), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": re.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  onClick: Ie(F, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              g("div", {
                class: S([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : r.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || l.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                ])
              }, $(e.libraryLabel), 3)
            ]),
            g("div", ak, [
              g("div", {
                class: S([
                  "w-9 h-9 rounded-[9999px] border-solid box-border flex items-center justify-center overflow-hidden [&_button]:border-0",
                  e.disabled ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-disabled) dark:border-(--border-border-disabled-subtle) border" : r.value ? "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error-strong) border" : e.success || l.value ? "bg-(--background-background-success) dark:bg-(--background-background-success) border-transparent border-0" : "bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) border"
                ])
              }, [
                se.value ? (c(), te(T($e), {
                  key: 0,
                  variant: "secondary",
                  "icon-left": se.value,
                  "icon-only": "",
                  size: "sm",
                  disabled: e.disabled,
                  onClick: Ie(A, ["stop"])
                }, null, 8, ["icon-left", "disabled"])) : w("", !0)
              ], 2),
              g("div", {
                class: S([
                  "relative leading-5 font-medium text-sm!",
                  e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : r.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : e.success || l.value ? "text-(--text-text-success-strong) dark:text-(--text-text-success-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                ])
              }, $(e.linkLabel), 3)
            ])
          ], 2)
        ])),
        g("input", {
          id: e.id,
          ref_key: "fileInputRef",
          ref: f,
          "data-testid": "file-upload-input",
          name: e.name,
          type: "file",
          accept: e.accept,
          disabled: e.disabled,
          multiple: e.multiple,
          class: "sr-only",
          onChange: W
        }, null, 40, lk)
      ], 34)),
      e.variant === "dropzone" && e.maxFileSizeText ? (c(), p("div", {
        key: 4,
        class: S([
          "flex items-start gap-1.5 text-sm",
          r.value ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
        ])
      }, [
        fe[11] || (fe[11] = g("svg", {
          class: "w-4 h-4 mt-0.5 flex-shrink-0",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          g("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })
        ], -1)),
        g("span", null, $(e.maxFileSizeText), 1)
      ], 2)) : w("", !0),
      e.variant === "dropzone" && o.value ? (c(), p("div", sk, $(o.value), 1)) : w("", !0),
      e.variant === "dropzone" && e.uploadedFiles && e.uploadedFiles.length > 0 ? (c(), p("div", ik, [
        (c(!0), p(Z, null, ke(e.uploadedFiles, (q, oe) => (c(), p("div", {
          key: `file-${oe}-${q.name}`,
          class: "flex items-center gap-2"
        }, [
          g("div", dk, [
            q.status === "success" ? (c(), p("svg", uk, [...fe[12] || (fe[12] = [
              g("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 13l4 4L19 7"
              }, null, -1)
            ])])) : q.status === "error" ? (c(), p("svg", ck, [...fe[13] || (fe[13] = [
              g("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              }, null, -1)
            ])])) : w("", !0)
          ]),
          g("div", fk, [
            g("p", {
              class: S([
                "text-sm truncate",
                q.status === "error" ? "text-(--text-text-error-strong) dark:text-(--text-text-error-strong)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"
              ])
            }, [
              Ze($(q.name) + " ", 1),
              q.size ? (c(), p("span", hk, " (" + $(s(q.size)) + ") ", 1)) : w("", !0)
            ], 2)
          ]),
          g("button", {
            type: "button",
            class: "flex-shrink-0 p-0.5 transition-colors",
            disabled: e.disabled,
            onClick: (ue) => U(q, oe)
          }, [
            (c(), p("svg", {
              class: S([
                "w-5 h-5",
                e.disabled ? "text-(--text-text-disabled-light) dark:text-(--text-text-disabled-light)" : "text-(--text-text-body) dark:text-(--text-text-white-default)"
              ]),
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [...fe[14] || (fe[14] = [
              g("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              }, null, -1)
            ])], 2))
          ], 8, bk)
        ]))), 128))
      ])) : w("", !0)
    ]));
  }
}), gk = /* @__PURE__ */ He(pk, [["__scopeId", "data-v-aa5d4ae2"]]), mk = ["id", "for"], vk = { class: "flex items-center gap-0.5" }, xk = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)" }, yk = {
  key: 0,
  class: "relative leading-5 font-medium"
}, kk = ["src"], wk = { class: "self-stretch flex flex-1 min-h-0 p-2" }, Ck = ["id", "name", "autocomplete", "value", "placeholder", "disabled", "readonly", "maxlength", "rows", "aria-labelledby", "aria-required", "aria-invalid", "aria-disabled", "aria-describedby"], Sk = {
  key: 0,
  class: "absolute bottom-2 right-2 flex items-center justify-center"
}, $k = ["src"], Ik = {
  key: 1,
  class: "text-xs text-text-body-subtle dark:text-(--colors-text-white-secondary)"
}, Tk = {
  key: 2,
  "aria-hidden": "true",
  focusable: "false",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "textarea-icon pointer-events-none text-(--colors-icon-dark-default)"
}, Lk = { class: "min-h-4.5 flex flex-col gap-px" }, Mk = ["id"], Ek = ["src"], Ak = {
  key: 1,
  class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)",
  "aria-hidden": "true"
}, Dk = ["id"], Rk = /* @__PURE__ */ ge({
  __name: "Textarea",
  props: {
    type: { default: "Default" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    helpIcon: { default: void 0 },
    placeholder: { default: void 0 },
    showPlaceholder: { type: Boolean, default: void 0 },
    modelValue: { default: "" },
    bottomRightIcon: { default: void 0 },
    helpText: { default: void 0 },
    helpTextIcon: { default: void 0 },
    error: { default: void 0 },
    showError: { type: Boolean, default: void 0 },
    rows: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    height: { default: "204px" },
    maxLength: { default: void 0 },
    resizable: { type: Boolean, default: !1 },
    autocomplete: { default: "off" }
  },
  emits: ["update:modelValue", "input", "focus", "blur"],
  setup(e, { emit: t }) {
    var le;
    const n = e, r = t;
    typeof process < "u" && ((le = process.env) == null ? void 0 : le.NODE_ENV) !== "production" && n.type !== "Default" && console.warn(
      `[OPAL Textarea] type="${n.type}" is declared in the design system spec but not yet implemented. Falling back to "Default" rendering. See https://www.notion.so/netanswer/Text-area-Component-36d19ffae3db811d9d89c231052913a4`
    );
    const a = Ke(), l = y(() => n.id || a), s = y(() => n.label ? `${l.value}-label` : void 0), i = y(() => `${l.value}-error`), d = y(() => `${l.value}-help`), u = N(!1), f = N(!1), h = y(() => !!n.error), b = y(() => n.showError !== void 0 ? n.showError : h.value), m = y(() => h.value ? "true" : void 0), v = y(() => {
      const C = [];
      return h.value && C.push(i.value), n.helpText && C.push(d.value), C.length ? C.join(" ") : void 0;
    }), x = y(() => !!n.modelValue), k = y(() => n.showPlaceholder === !1 ? !1 : n.showPlaceholder === !0 ? !0 : !x.value), L = y(() => k.value ? n.placeholder : void 0), P = N("auto"), E = N(null), O = y(() => {
      const C = "self-stretch rounded-xl border-solid border-[1px] box-border flex flex-col items-start justify-between p-1 gap-2 font-inter";
      return n.disabled ? `${C} bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled) shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]` : n.readonly ? `${C} bg-(--background-background-white-secondary-soft) dark:bg-(--colors-background-disabled) border-(--border-border-base-soft) dark:border-(--border-border-base) text-(--text-text-black-default) dark:text-(--text-text-white-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]` : h.value ? `${C} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]` : u.value ? `${C} bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-body) dark:text-(--colors-text-white-default) shadow-[0px_0px_2px_2px_var(--colors-background-hover)]` : f.value ? `${C} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base) text-(--text-text-body) dark:text-(--colors-text-white-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]` : `${C} bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--colors-border-base) text-(--text-text-body-subtle) dark:text-(--colors-text-white-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]`;
    }), R = y(() => `${n.fullWidth ? "w-full" : "max-w-lg w-full"} relative flex flex-col items-start gap-0.5 pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter`), V = y(() => n.fullWidth ? {} : n.width ? { width: n.width } : {}), J = y(() => n.resizable ? { minHeight: n.height } : { height: n.height }), F = y(() => {
      var C;
      if (n.maxLength)
        return ((C = n.modelValue) == null ? void 0 : C.length) || 0;
    }), A = y(() => n.resizable ? "resize-y" : "resize-none"), j = (C) => {
      const B = C.target;
      r("update:modelValue", B.value), r("input", C);
    }, _ = (C) => {
      n.disabled || (u.value = !0), r("focus", C);
    }, U = (C) => {
      u.value = !1, r("blur", C);
    }, W = () => {
      if (E.value && n.resizable) {
        const C = E.value.offsetHeight;
        C > 0 && (P.value = `${C}px`);
      }
    };
    we(
      () => n.resizable,
      (C) => {
        C || (P.value = "auto");
      }
    );
    let K = null;
    return Qe(() => {
      n.resizable && E.value && (K = new ResizeObserver(() => {
        W();
      }), K.observe(E.value));
    }), nt(() => {
      K && K.disconnect();
    }), we(
      () => E.value,
      (C) => {
        K && K.disconnect(), C && n.resizable && (K = new ResizeObserver(() => {
          W();
        }), K.observe(C));
      }
    ), (C, B) => (c(), p("div", {
      class: S(R.value),
      style: Ae(V.value)
    }, [
      e.label ? (c(), p("label", {
        key: 0,
        id: s.value,
        for: l.value,
        class: "flex items-center gap-1 text-text-black-default dark:text-(--colors-text-white-default)"
      }, [
        g("div", vk, [
          g("div", xk, $(e.label), 1),
          e.required ? (c(), p("div", yk, $(e.requiredIndicator), 1)) : w("", !0)
        ]),
        e.helpIcon ? (c(), p("img", {
          key: 0,
          class: "h-3.5 w-3.5 relative textarea-icon",
          src: e.helpIcon,
          alt: ""
        }, null, 8, kk)) : w("", !0)
      ], 8, mk)) : w("", !0),
      g("div", {
        class: S([O.value, "relative"]),
        style: Ae(J.value),
        onMouseenter: B[0] || (B[0] = (I) => !e.disabled && (f.value = !0)),
        onMouseleave: B[1] || (B[1] = (I) => f.value = !1)
      }, [
        g("div", wk, [
          g("textarea", {
            id: l.value,
            ref_key: "textareaRef",
            ref: E,
            "data-testid": "textarea",
            name: e.name,
            autocomplete: e.autocomplete,
            value: e.modelValue,
            placeholder: L.value,
            disabled: e.disabled,
            readonly: e.readonly,
            maxlength: e.maxLength,
            rows: e.rows,
            "aria-labelledby": s.value,
            "aria-required": e.required ? "true" : void 0,
            "aria-invalid": m.value,
            "aria-disabled": e.disabled ? "true" : "false",
            "aria-describedby": v.value,
            style: Ae({ height: P.value }),
            class: S(["w-full relative leading-5 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 text-sm placeholder:text-(--text-text-body-subtle) dark:placeholder:text-(--colors-text-white-secondary) p-0", [
              A.value,
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : e.readonly ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : u.value || x.value ? "text-(--text-text-body) dark:text-(--colors-text-white-default)" : "text-(--text-text-body-subtle) dark:text-(--colors-text-white-default)"
            ]]),
            onInput: j,
            onFocus: _,
            onBlur: U
          }, null, 46, Ck)
        ]),
        e.bottomRightIcon || e.maxLength || e.resizable ? (c(), p("div", Sk, [
          e.bottomRightIcon ? (c(), p("img", {
            key: 0,
            class: "w-[24.2px] h-[24.2px] textarea-icon",
            src: e.bottomRightIcon,
            alt: ""
          }, null, 8, $k)) : e.maxLength ? (c(), p("div", Ik, $(F.value) + "/" + $(e.maxLength), 1)) : e.resizable ? (c(), p("svg", Tk, [...B[2] || (B[2] = [
            g("path", {
              d: "M21 11L11 21",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round"
            }, null, -1),
            g("path", {
              d: "M21 15L15 21",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round"
            }, null, -1),
            g("path", {
              d: "M21 19L19 21",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round"
            }, null, -1)
          ])])) : w("", !0)
        ])) : w("", !0)
      ], 38),
      g("div", Lk, [
        e.helpText ? (c(), p("div", {
          key: 0,
          id: d.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-body)"
        }, [
          e.helpTextIcon ? (c(), p("img", {
            key: 0,
            class: "h-3 w-3 relative textarea-icon",
            src: e.helpTextIcon,
            alt: ""
          }, null, 8, Ek)) : (c(), p("i", Ak)),
          g("span", null, $(e.helpText), 1)
        ], 8, Mk)) : w("", !0),
        b.value && e.error ? (c(), p("div", {
          key: 1,
          id: i.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          B[3] || (B[3] = g("i", {
            class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)",
            "aria-hidden": "true"
          }, null, -1)),
          g("span", null, $(e.error), 1)
        ], 8, Dk)) : w("", !0)
      ])
    ], 6));
  }
}), lV = /* @__PURE__ */ He(Rk, [["__scopeId", "data-v-c3786be5"]]);
function kt(e) {
  this.content = e;
}
kt.prototype = {
  constructor: kt,
  find: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      if (this.content[t] === e) return t;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var t = this.find(e);
    return t == -1 ? void 0 : this.content[t + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, t, n) {
    var r = n && n != e ? this.remove(n) : this, o = r.find(e), a = r.content.slice();
    return o == -1 ? a.push(n || e, t) : (a[o + 1] = t, n && (a[o] = n)), new kt(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var t = this.find(e);
    if (t == -1) return this;
    var n = this.content.slice();
    return n.splice(t, 2), new kt(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, t) {
    return new kt([e, t].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new kt(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, t, n) {
    var r = this.remove(t), o = r.content.slice(), a = r.find(e);
    return o.splice(a == -1 ? o.length : a, 0, t, n), new kt(o);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var t = 0; t < this.content.length; t += 2)
      e(this.content[t], this.content[t + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = kt.from(e), e.size ? new kt(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = kt.from(e), e.size ? new kt(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var t = this;
    e = kt.from(e);
    for (var n = 0; n < e.content.length; n += 2)
      t = t.remove(e.content[n]);
    return t;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(t, n) {
      e[t] = n;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
kt.from = function(e) {
  if (e instanceof kt) return e;
  var t = [];
  if (e) for (var n in e) t.push(n, e[n]);
  return new kt(t);
};
function Uf(e, t, n) {
  for (let r = 0; ; r++) {
    if (r == e.childCount || r == t.childCount)
      return e.childCount == t.childCount ? null : n;
    let o = e.child(r), a = t.child(r);
    if (o == a) {
      n += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(a))
      return n;
    if (o.isText && o.text != a.text) {
      for (let l = 0; o.text[l] == a.text[l]; l++)
        n++;
      return n;
    }
    if (o.content.size || a.content.size) {
      let l = Uf(o.content, a.content, n + 1);
      if (l != null)
        return l;
    }
    n += o.nodeSize;
  }
}
function Gf(e, t, n, r) {
  for (let o = e.childCount, a = t.childCount; ; ) {
    if (o == 0 || a == 0)
      return o == a ? null : { a: n, b: r };
    let l = e.child(--o), s = t.child(--a), i = l.nodeSize;
    if (l == s) {
      n -= i, r -= i;
      continue;
    }
    if (!l.sameMarkup(s))
      return { a: n, b: r };
    if (l.isText && l.text != s.text) {
      let d = 0, u = Math.min(l.text.length, s.text.length);
      for (; d < u && l.text[l.text.length - d - 1] == s.text[s.text.length - d - 1]; )
        d++, n--, r--;
      return { a: n, b: r };
    }
    if (l.content.size || s.content.size) {
      let d = Gf(l.content, s.content, n - 1, r - 1);
      if (d)
        return d;
    }
    n -= i, r -= i;
  }
}
class Ce {
  /**
  @internal
  */
  constructor(t, n) {
    if (this.content = t, this.size = n || 0, n == null)
      for (let r = 0; r < t.length; r++)
        this.size += t[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(t, n, r, o = 0, a) {
    for (let l = 0, s = 0; s < n; l++) {
      let i = this.content[l], d = s + i.nodeSize;
      if (d > t && r(i, o + s, a || null, l) !== !1 && i.content.size) {
        let u = s + 1;
        i.nodesBetween(Math.max(0, t - u), Math.min(i.content.size, n - u), r, o + u);
      }
      s = d;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(t) {
    this.nodesBetween(0, this.size, t);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(t, n, r, o) {
    let a = "", l = !0;
    return this.nodesBetween(t, n, (s, i) => {
      let d = s.isText ? s.text.slice(Math.max(t, i) - i, n - i) : s.isLeaf ? o ? typeof o == "function" ? o(s) : o : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && d || s.isTextblock) && r && (l ? l = !1 : a += r), a += d;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(t) {
    if (!t.size)
      return this;
    if (!this.size)
      return t;
    let n = this.lastChild, r = t.firstChild, o = this.content.slice(), a = 0;
    for (n.isText && n.sameMarkup(r) && (o[o.length - 1] = n.withText(n.text + r.text), a = 1); a < t.content.length; a++)
      o.push(t.content[a]);
    return new Ce(o, this.size + t.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(t, n = this.size) {
    if (t == 0 && n == this.size)
      return this;
    let r = [], o = 0;
    if (n > t)
      for (let a = 0, l = 0; l < n; a++) {
        let s = this.content[a], i = l + s.nodeSize;
        i > t && ((l < t || i > n) && (s.isText ? s = s.cut(Math.max(0, t - l), Math.min(s.text.length, n - l)) : s = s.cut(Math.max(0, t - l - 1), Math.min(s.content.size, n - l - 1))), r.push(s), o += s.nodeSize), l = i;
      }
    return new Ce(r, o);
  }
  /**
  @internal
  */
  cutByIndex(t, n) {
    return t == n ? Ce.empty : t == 0 && n == this.content.length ? this : new Ce(this.content.slice(t, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(t, n) {
    let r = this.content[t];
    if (r == n)
      return this;
    let o = this.content.slice(), a = this.size + n.nodeSize - r.nodeSize;
    return o[t] = n, new Ce(o, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(t) {
    return new Ce([t].concat(this.content), this.size + t.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(t) {
    return new Ce(this.content.concat(t), this.size + t.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(t) {
    if (this.content.length != t.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(t.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(t) {
    let n = this.content[t];
    if (!n)
      throw new RangeError("Index " + t + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content[t] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    for (let n = 0, r = 0; n < this.content.length; n++) {
      let o = this.content[n];
      t(o, r, n), r += o.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(t, n = 0) {
    return Uf(this, t, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(t, n = this.size, r = t.size) {
    return Gf(this, t, n, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(t) {
    if (t == 0)
      return Da(0, t);
    if (t == this.size)
      return Da(this.content.length, t);
    if (t > this.size || t < 0)
      throw new RangeError(`Position ${t} outside of fragment (${this})`);
    for (let n = 0, r = 0; ; n++) {
      let o = this.child(n), a = r + o.nodeSize;
      if (a >= t)
        return a == t ? Da(n + 1, a) : Da(n, r);
      r = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((t) => t.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return Ce.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return Ce.fromArray(n.map(t.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(t) {
    if (!t.length)
      return Ce.empty;
    let n, r = 0;
    for (let o = 0; o < t.length; o++) {
      let a = t[o];
      r += a.nodeSize, o && a.isText && t[o - 1].sameMarkup(a) ? (n || (n = t.slice(0, o)), n[n.length - 1] = a.withText(n[n.length - 1].text + a.text)) : n && n.push(a);
    }
    return new Ce(n || t, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(t) {
    if (!t)
      return Ce.empty;
    if (t instanceof Ce)
      return t;
    if (Array.isArray(t))
      return this.fromArray(t);
    if (t.attrs)
      return new Ce([t], t.nodeSize);
    throw new RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Ce.empty = new Ce([], 0);
const Ls = { index: 0, offset: 0 };
function Da(e, t) {
  return Ls.index = e, Ls.offset = t, Ls;
}
function pl(e, t) {
  if (e === t)
    return !0;
  if (!(e && typeof e == "object") || !(t && typeof t == "object"))
    return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n)
    return !1;
  if (n) {
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!pl(e[r], t[r]))
        return !1;
  } else {
    for (let r in e)
      if (!(r in t) || !pl(e[r], t[r]))
        return !1;
    for (let r in t)
      if (!(r in e))
        return !1;
  }
  return !0;
}
let et = class mi {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(t) {
    let n, r = !1;
    for (let o = 0; o < t.length; o++) {
      let a = t[o];
      if (this.eq(a))
        return t;
      if (this.type.excludes(a.type))
        n || (n = t.slice(0, o));
      else {
        if (a.type.excludes(this.type))
          return t;
        !r && a.type.rank > this.type.rank && (n || (n = t.slice(0, o)), n.push(this), r = !0), n && n.push(a);
      }
    }
    return n || (n = t.slice()), r || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return t.slice(0, n).concat(t.slice(n + 1));
    return t;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (this.eq(t[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(t) {
    return this == t || this.type == t.type && pl(this.attrs, t.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return t;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = t.marks[n.type];
    if (!r)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let o = r.create(n.attrs);
    return r.checkAttrs(o.attrs), o;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(t, n) {
    if (t == n)
      return !0;
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++)
      if (!t[r].eq(n[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(t) {
    if (!t || Array.isArray(t) && t.length == 0)
      return mi.none;
    if (t instanceof mi)
      return [t];
    let n = t.slice();
    return n.sort((r, o) => r.type.rank - o.type.rank), n;
  }
};
et.none = [];
class gl extends Error {
}
class Ee {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(t, n, r) {
    this.content = t, this.openStart = n, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(t, n) {
    let r = Kf(this.content, t + this.openStart, n, this.openStart + 1, this.openEnd + 1);
    return r && new Ee(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(t, n) {
    return new Ee(qf(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(t) {
    return this.content.eq(t.content) && this.openStart == t.openStart && this.openEnd == t.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let t = { content: this.content.toJSON() };
    return this.openStart > 0 && (t.openStart = this.openStart), this.openEnd > 0 && (t.openEnd = this.openEnd), t;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      return Ee.empty;
    let r = n.openStart || 0, o = n.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Ee(Ce.fromJSON(t, n.content), r, o);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(t, n = !0) {
    let r = 0, o = 0;
    for (let a = t.firstChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.firstChild)
      r++;
    for (let a = t.lastChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.lastChild)
      o++;
    return new Ee(t, r, o);
  }
}
Ee.empty = new Ee(Ce.empty, 0, 0);
function qf(e, t, n) {
  let { index: r, offset: o } = e.findIndex(t), a = e.maybeChild(r), { index: l, offset: s } = e.findIndex(n);
  if (o == t || a.isText) {
    if (s != n && !e.child(l).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (r != l)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(r, a.copy(qf(a.content, t - o - 1, n - o - 1)));
}
function Kf(e, t, n, r, o, a) {
  let { index: l, offset: s } = e.findIndex(t), i = e.maybeChild(l);
  if (s == t || i.isText)
    return a && r <= 0 && o <= 0 && !a.canReplace(l, l, n) ? null : e.cut(0, t).append(n).append(e.cut(t));
  let d = Kf(i.content, t - s - 1, n, l == 0 ? r - 1 : 0, l == e.childCount - 1 ? o - 1 : 0, i);
  return d && e.replaceChild(l, i.copy(d));
}
function Bk(e, t, n) {
  if (n.openStart > e.depth)
    throw new gl("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd)
    throw new gl("Inconsistent open depths");
  return Jf(e, t, n, 0);
}
function Jf(e, t, n, r) {
  let o = e.index(r), a = e.node(r);
  if (o == t.index(r) && r < e.depth - n.openStart) {
    let l = Jf(e, t, n, r + 1);
    return a.copy(a.content.replaceChild(o, l));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && e.depth == r && t.depth == r) {
      let l = e.parent, s = l.content;
      return Tr(l, s.cut(0, e.parentOffset).append(n.content).append(s.cut(t.parentOffset)));
    } else {
      let { start: l, end: s } = Ok(n, e);
      return Tr(a, Yf(e, l, s, t, r));
    }
  else return Tr(a, ml(e, t, r));
}
function Zf(e, t) {
  if (!t.type.compatibleContent(e.type))
    throw new gl("Cannot join " + t.type.name + " onto " + e.type.name);
}
function vi(e, t, n) {
  let r = e.node(n);
  return Zf(r, t.node(n)), r;
}
function Ir(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function Ho(e, t, n, r) {
  let o = (t || e).node(n), a = 0, l = t ? t.index(n) : o.childCount;
  e && (a = e.index(n), e.depth > n ? a++ : e.textOffset && (Ir(e.nodeAfter, r), a++));
  for (let s = a; s < l; s++)
    Ir(o.child(s), r);
  t && t.depth == n && t.textOffset && Ir(t.nodeBefore, r);
}
function Tr(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function Yf(e, t, n, r, o) {
  let a = e.depth > o && vi(e, t, o + 1), l = r.depth > o && vi(n, r, o + 1), s = [];
  return Ho(null, e, o, s), a && l && t.index(o) == n.index(o) ? (Zf(a, l), Ir(Tr(a, Yf(e, t, n, r, o + 1)), s)) : (a && Ir(Tr(a, ml(e, t, o + 1)), s), Ho(t, n, o, s), l && Ir(Tr(l, ml(n, r, o + 1)), s)), Ho(r, null, o, s), new Ce(s);
}
function ml(e, t, n) {
  let r = [];
  if (Ho(null, e, n, r), e.depth > n) {
    let o = vi(e, t, n + 1);
    Ir(Tr(o, ml(e, t, n + 1)), r);
  }
  return Ho(t, null, n, r), new Ce(r);
}
function Ok(e, t) {
  let n = t.depth - e.openStart, o = t.node(n).copy(e.content);
  for (let a = n - 1; a >= 0; a--)
    o = t.node(a).copy(Ce.from(o));
  return {
    start: o.resolveNoCache(e.openStart + n),
    end: o.resolveNoCache(o.content.size - e.openEnd - n)
  };
}
class oa {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.path = n, this.parentOffset = r, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(t) {
    return t == null ? this.depth : t < 0 ? this.depth + t : t;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(t) {
    return this.path[this.resolveDepth(t) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(t) {
    return this.path[this.resolveDepth(t) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(t) {
    return t = this.resolveDepth(t), this.index(t) + (t == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(t) {
    return t = this.resolveDepth(t), t == 0 ? 0 : this.path[t * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(t) {
    return t = this.resolveDepth(t), this.start(t) + this.node(t).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position before the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(t) {
    if (t = this.resolveDepth(t), !t)
      throw new RangeError("There is no position after the top-level node");
    return t == this.depth + 1 ? this.pos : this.path[t * 3 - 1] + this.path[t * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let t = this.parent, n = this.index(this.depth);
    if (n == t.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], o = t.child(n);
    return r ? t.child(n).cut(r) : o;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let t = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(t).cut(0, n) : t == 0 ? null : this.parent.child(t - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(t, n) {
    n = this.resolveDepth(n);
    let r = this.path[n * 3], o = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let a = 0; a < t; a++)
      o += r.child(a).nodeSize;
    return o;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let t = this.parent, n = this.index();
    if (t.content.size == 0)
      return et.none;
    if (this.textOffset)
      return t.child(n).marks;
    let r = t.maybeChild(n - 1), o = t.maybeChild(n);
    if (!r) {
      let s = r;
      r = o, o = s;
    }
    let a = r.marks;
    for (var l = 0; l < a.length; l++)
      a[l].type.spec.inclusive === !1 && (!o || !a[l].isInSet(o.marks)) && (a = a[l--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(t) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let r = n.marks, o = t.parent.maybeChild(t.index());
    for (var a = 0; a < r.length; a++)
      r[a].type.spec.inclusive === !1 && (!o || !r[a].isInSet(o.marks)) && (r = r[a--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(t) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= t && this.end(n) >= t)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(t = this, n) {
    if (t.pos < this.pos)
      return t.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == t.pos ? 1 : 0); r >= 0; r--)
      if (t.pos <= this.end(r) && (!n || n(this.node(r))))
        return new vl(this, t, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(t) {
    return this.pos - this.parentOffset == t.pos - t.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(t) {
    return t.pos > this.pos ? t : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(t) {
    return t.pos < this.pos ? t : this;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 1; n <= this.depth; n++)
      t += (t ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return t + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(t, n) {
    if (!(n >= 0 && n <= t.content.size))
      throw new RangeError("Position " + n + " out of range");
    let r = [], o = 0, a = n;
    for (let l = t; ; ) {
      let { index: s, offset: i } = l.content.findIndex(a), d = a - i;
      if (r.push(l, s, o + i), !d || (l = l.child(s), l.isText))
        break;
      a = d - 1, o += i + 1;
    }
    return new oa(n, r, a);
  }
  /**
  @internal
  */
  static resolveCached(t, n) {
    let r = Au.get(t);
    if (r)
      for (let a = 0; a < r.elts.length; a++) {
        let l = r.elts[a];
        if (l.pos == n)
          return l;
      }
    else
      Au.set(t, r = new Pk());
    let o = r.elts[r.i] = oa.resolve(t, n);
    return r.i = (r.i + 1) % zk, o;
  }
}
class Pk {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const zk = 12, Au = /* @__PURE__ */ new WeakMap();
class vl {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Nk = /* @__PURE__ */ Object.create(null);
let tr = class xi {
  /**
  @internal
  */
  constructor(t, n, r, o = et.none) {
    this.type = t, this.attrs = n, this.marks = o, this.content = r || Ce.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(t) {
    return this.content.child(t);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(t) {
    return this.content.maybeChild(t);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(t) {
    this.content.forEach(t);
  }
  /**
  Invoke a callback for all descendant nodes recursively overlapping
  the given two positions that are relative to start of this
  node's content. This includes all ancestors of the nodes
  containing the two positions. The callback is invoked with the
  node, its position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(t, n, r, o = 0) {
    this.content.nodesBetween(t, n, r, o, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(t) {
    this.nodesBetween(0, this.content.size, t);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(t, n, r, o) {
    return this.content.textBetween(t, n, r, o);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(t) {
    return this == t || this.sameMarkup(t) && this.content.eq(t.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(t) {
    return this.hasMarkup(t.type, t.attrs, t.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(t, n, r) {
    return this.type == t && pl(this.attrs, n || t.defaultAttrs || Nk) && et.sameSet(this.marks, r || et.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(t = null) {
    return t == this.content ? this : new xi(this.type, this.attrs, t, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(t) {
    return t == this.marks ? this : new xi(this.type, this.attrs, this.content, t);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(t, n = this.content.size) {
    return t == 0 && n == this.content.size ? this : this.copy(this.content.cut(t, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(t, n = this.content.size, r = !1) {
    if (t == n)
      return Ee.empty;
    let o = this.resolve(t), a = this.resolve(n), l = r ? 0 : o.sharedDepth(n), s = o.start(l), d = o.node(l).content.cut(o.pos - s, a.pos - s);
    return new Ee(d, o.depth - l, a.depth - l);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(t, n, r) {
    return Bk(this.resolve(t), this.resolve(n), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(t) {
    for (let n = this; ; ) {
      let { index: r, offset: o } = n.content.findIndex(t);
      if (n = n.maybeChild(r), !n)
        return null;
      if (o == t || n.isText)
        return n;
      t -= o + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(t) {
    let { index: n, offset: r } = this.content.findIndex(t);
    return { node: this.content.maybeChild(n), index: n, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(t) {
    if (t == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: r } = this.content.findIndex(t);
    if (r < t)
      return { node: this.content.child(n), index: n, offset: r };
    let o = this.content.child(n - 1);
    return { node: o, index: n - 1, offset: r - o.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(t) {
    return oa.resolveCached(this, t);
  }
  /**
  @internal
  */
  resolveNoCache(t) {
    return oa.resolve(this, t);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(t, n, r) {
    let o = !1;
    return n > t && this.nodesBetween(t, n, (a) => (r.isInSet(a.marks) && (o = !0), !o)), o;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let t = this.type.name;
    return this.content.size && (t += "(" + this.content.toStringInner() + ")"), Xf(this.marks, t);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(t) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, t);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(t, n, r = Ce.empty, o = 0, a = r.childCount) {
    let l = this.contentMatchAt(t).matchFragment(r, o, a), s = l && l.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let i = o; i < a; i++)
      if (!this.type.allowsMarks(r.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(t, n, r, o) {
    if (o && !this.type.allowsMarks(o))
      return !1;
    let a = this.contentMatchAt(t).matchType(r), l = a && a.matchFragment(this.content, n);
    return l ? l.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(t) {
    return t.content.size ? this.canReplace(this.childCount, this.childCount, t.content) : this.type.compatibleContent(t.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let t = et.none;
    for (let n = 0; n < this.marks.length; n++) {
      let r = this.marks[n];
      r.type.checkAttrs(r.attrs), t = r.addToSet(t);
    }
    if (!et.sameSet(t, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let t = { type: this.type.name };
    for (let n in this.attrs) {
      t.attrs = this.attrs;
      break;
    }
    return this.content.size && (t.content = this.content.toJSON()), this.marks.length && (t.marks = this.marks.map((n) => n.toJSON())), t;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(t, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = n.marks.map(t.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return t.text(n.text, r);
    }
    let o = Ce.fromJSON(t, n.content), a = t.nodeType(n.type).create(n.attrs, o, r);
    return a.type.checkAttrs(a.attrs), a;
  }
};
tr.prototype.text = void 0;
class xl extends tr {
  /**
  @internal
  */
  constructor(t, n, r, o) {
    if (super(t, n, null, o), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Xf(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(t, n) {
    return this.text.slice(t, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(t) {
    return t == this.marks ? this : new xl(this.type, this.attrs, this.text, t);
  }
  withText(t) {
    return t == this.text ? this : new xl(this.type, this.attrs, t, this.marks);
  }
  cut(t = 0, n = this.text.length) {
    return t == 0 && n == this.text.length ? this : this.withText(this.text.slice(t, n));
  }
  eq(t) {
    return this.sameMarkup(t) && this.text == t.text;
  }
  toJSON() {
    let t = super.toJSON();
    return t.text = this.text, t;
  }
}
function Xf(e, t) {
  for (let n = e.length - 1; n >= 0; n--)
    t = e[n].type.name + "(" + t + ")";
  return t;
}
class Br {
  /**
  @internal
  */
  constructor(t) {
    this.validEnd = t, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(t, n) {
    let r = new Vk(t, n);
    if (r.next == null)
      return Br.empty;
    let o = Qf(r);
    r.next && r.err("Unexpected trailing text");
    let a = qk(Gk(o));
    return Kk(a, r), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(t) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == t)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(t, n = 0, r = t.childCount) {
    let o = this;
    for (let a = n; o && a < r; a++)
      o = o.matchType(t.child(a).type);
    return o;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let t = 0; t < this.next.length; t++) {
      let { type: n } = this.next[t];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(t) {
    for (let n = 0; n < this.next.length; n++)
      for (let r = 0; r < t.next.length; r++)
        if (this.next[n].type == t.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(t, n = !1, r = 0) {
    let o = [this];
    function a(l, s) {
      let i = l.matchFragment(t, r);
      if (i && (!n || i.validEnd))
        return Ce.from(s.map((d) => d.createAndFill()));
      for (let d = 0; d < l.next.length; d++) {
        let { type: u, next: f } = l.next[d];
        if (!(u.isText || u.hasRequiredAttrs()) && o.indexOf(f) == -1) {
          o.push(f);
          let h = a(f, s.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(t) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == t)
        return this.wrapCache[r + 1];
    let n = this.computeWrapping(t);
    return this.wrapCache.push(t, n), n;
  }
  /**
  @internal
  */
  computeWrapping(t) {
    let n = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let o = r.shift(), a = o.match;
      if (a.matchType(t)) {
        let l = [];
        for (let s = o; s.type; s = s.via)
          l.push(s.type);
        return l.reverse();
      }
      for (let l = 0; l < a.next.length; l++) {
        let { type: s, next: i } = a.next[l];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!o.type || i.validEnd) && (r.push({ match: s.contentMatch, type: s, via: o }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(t) {
    if (t >= this.next.length)
      throw new RangeError(`There's no ${t}th edge in this content match`);
    return this.next[t];
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    function n(r) {
      t.push(r);
      for (let o = 0; o < r.next.length; o++)
        t.indexOf(r.next[o].next) == -1 && n(r.next[o].next);
    }
    return n(this), t.map((r, o) => {
      let a = o + (r.validEnd ? "*" : " ") + " ";
      for (let l = 0; l < r.next.length; l++)
        a += (l ? ", " : "") + r.next[l].type.name + "->" + t.indexOf(r.next[l].next);
      return a;
    }).join(`
`);
  }
}
Br.empty = new Br(!0);
class Vk {
  constructor(t, n) {
    this.string = t, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = t.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(t) {
    return this.next == t && (this.pos++ || !0);
  }
  err(t) {
    throw new SyntaxError(t + " (in content expression '" + this.string + "')");
  }
}
function Qf(e) {
  let t = [];
  do
    t.push(Fk(e));
  while (e.eat("|"));
  return t.length == 1 ? t[0] : { type: "choice", exprs: t };
}
function Fk(e) {
  let t = [];
  do
    t.push(Hk(e));
  while (e.next && e.next != ")" && e.next != "|");
  return t.length == 1 ? t[0] : { type: "seq", exprs: t };
}
function Hk(e) {
  let t = Uk(e);
  for (; ; )
    if (e.eat("+"))
      t = { type: "plus", expr: t };
    else if (e.eat("*"))
      t = { type: "star", expr: t };
    else if (e.eat("?"))
      t = { type: "opt", expr: t };
    else if (e.eat("{"))
      t = Wk(e, t);
    else
      break;
  return t;
}
function Du(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function Wk(e, t) {
  let n = Du(e), r = n;
  return e.eat(",") && (e.next != "}" ? r = Du(e) : r = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: n, max: r, expr: t };
}
function jk(e, t) {
  let n = e.nodeTypes, r = n[t];
  if (r)
    return [r];
  let o = [];
  for (let a in n) {
    let l = n[a];
    l.isInGroup(t) && o.push(l);
  }
  return o.length == 0 && e.err("No node type or group '" + t + "' found"), o;
}
function Uk(e) {
  if (e.eat("(")) {
    let t = Qf(e);
    return e.eat(")") || e.err("Missing closing paren"), t;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let t = jk(e, e.next).map((n) => (e.inline == null ? e.inline = n.isInline : e.inline != n.isInline && e.err("Mixing inline and block content"), { type: "name", value: n }));
    return e.pos++, t.length == 1 ? t[0] : { type: "choice", exprs: t };
  }
}
function Gk(e) {
  let t = [[]];
  return o(a(e, 0), n()), t;
  function n() {
    return t.push([]) - 1;
  }
  function r(l, s, i) {
    let d = { term: i, to: s };
    return t[l].push(d), d;
  }
  function o(l, s) {
    l.forEach((i) => i.to = s);
  }
  function a(l, s) {
    if (l.type == "choice")
      return l.exprs.reduce((i, d) => i.concat(a(d, s)), []);
    if (l.type == "seq")
      for (let i = 0; ; i++) {
        let d = a(l.exprs[i], s);
        if (i == l.exprs.length - 1)
          return d;
        o(d, s = n());
      }
    else if (l.type == "star") {
      let i = n();
      return r(s, i), o(a(l.expr, i), i), [r(i)];
    } else if (l.type == "plus") {
      let i = n();
      return o(a(l.expr, s), i), o(a(l.expr, i), i), [r(i)];
    } else {
      if (l.type == "opt")
        return [r(s)].concat(a(l.expr, s));
      if (l.type == "range") {
        let i = s;
        for (let d = 0; d < l.min; d++) {
          let u = n();
          o(a(l.expr, i), u), i = u;
        }
        if (l.max == -1)
          o(a(l.expr, i), i);
        else
          for (let d = l.min; d < l.max; d++) {
            let u = n();
            r(i, u), o(a(l.expr, i), u), i = u;
          }
        return [r(i)];
      } else {
        if (l.type == "name")
          return [r(s, void 0, l.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function _f(e, t) {
  return t - e;
}
function Ru(e, t) {
  let n = [];
  return r(t), n.sort(_f);
  function r(o) {
    let a = e[o];
    if (a.length == 1 && !a[0].term)
      return r(a[0].to);
    n.push(o);
    for (let l = 0; l < a.length; l++) {
      let { term: s, to: i } = a[l];
      !s && n.indexOf(i) == -1 && r(i);
    }
  }
}
function qk(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return n(Ru(e, 0));
  function n(r) {
    let o = [];
    r.forEach((l) => {
      e[l].forEach(({ term: s, to: i }) => {
        if (!s)
          return;
        let d;
        for (let u = 0; u < o.length; u++)
          o[u][0] == s && (d = o[u][1]);
        Ru(e, i).forEach((u) => {
          d || o.push([s, d = []]), d.indexOf(u) == -1 && d.push(u);
        });
      });
    });
    let a = t[r.join(",")] = new Br(r.indexOf(e.length - 1) > -1);
    for (let l = 0; l < o.length; l++) {
      let s = o[l][1].sort(_f);
      a.next.push({ type: o[l][0], next: t[s.join(",")] || n(s) });
    }
    return a;
  }
}
function Kk(e, t) {
  for (let n = 0, r = [e]; n < r.length; n++) {
    let o = r[n], a = !o.validEnd, l = [];
    for (let s = 0; s < o.next.length; s++) {
      let { type: i, next: d } = o.next[s];
      l.push(i.name), a && !(i.isText || i.hasRequiredAttrs()) && (a = !1), r.indexOf(d) == -1 && r.push(d);
    }
    a && t.err("Only non-generatable nodes (" + l.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function eh(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    if (!r.hasDefault)
      return null;
    t[n] = r.default;
  }
  return t;
}
function th(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r in e) {
    let o = t && t[r];
    if (o === void 0) {
      let a = e[r];
      if (a.hasDefault)
        o = a.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    n[r] = o;
  }
  return n;
}
function nh(e, t, n, r) {
  for (let o in t)
    if (!(o in e))
      throw new RangeError(`Unsupported attribute ${o} for ${n} of type ${o}`);
  for (let o in e) {
    let a = e[o];
    a.validate && a.validate(t[o]);
  }
}
function rh(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  if (t)
    for (let r in t)
      n[r] = new Zk(e, r, t[r]);
  return n;
}
let Bu = class oh {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.name = t, this.schema = n, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = rh(t, r.attrs), this.defaultAttrs = eh(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || t == "text"), this.isText = t == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Br.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(t) {
    return this.groups.indexOf(t) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let t in this.attrs)
      if (this.attrs[t].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(t) {
    return this == t || this.contentMatch.compatible(t.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(t) {
    return !t && this.defaultAttrs ? this.defaultAttrs : th(this.attrs, t);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(t = null, n, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new tr(this, this.computeAttrs(t), Ce.from(n), et.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(t = null, n, r) {
    return n = Ce.from(n), this.checkContent(n), new tr(this, this.computeAttrs(t), n, et.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(t = null, n, r) {
    if (t = this.computeAttrs(t), n = Ce.from(n), n.size) {
      let l = this.contentMatch.fillBefore(n);
      if (!l)
        return null;
      n = l.append(n);
    }
    let o = this.contentMatch.matchFragment(n), a = o && o.fillBefore(Ce.empty, !0);
    return a ? new tr(this, t, n.append(a), et.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(t) {
    let n = this.contentMatch.matchFragment(t);
    if (!n || !n.validEnd)
      return !1;
    for (let r = 0; r < t.childCount; r++)
      if (!this.allowsMarks(t.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(t) {
    if (!this.validContent(t))
      throw new RangeError(`Invalid content for node ${this.name}: ${t.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(t) {
    nh(this.attrs, t, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(t) {
    return this.markSet == null || this.markSet.indexOf(t) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(t) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < t.length; n++)
      if (!this.allowsMarkType(t[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(t) {
    if (this.markSet == null)
      return t;
    let n;
    for (let r = 0; r < t.length; r++)
      this.allowsMarkType(t[r].type) ? n && n.push(t[r]) : n || (n = t.slice(0, r));
    return n ? n.length ? n : et.none : t;
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null);
    t.forEach((a, l) => r[a] = new oh(a, n, l));
    let o = n.spec.topNode || "doc";
    if (!r[o])
      throw new RangeError("Schema is missing its top node type ('" + o + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function Jk(e, t, n) {
  let r = n.split("|");
  return (o) => {
    let a = o === null ? "null" : typeof o;
    if (r.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${t} on type ${e}, got ${a}`);
  };
}
class Zk {
  constructor(t, n, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? Jk(t, n, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class ss {
  /**
  @internal
  */
  constructor(t, n, r, o) {
    this.name = t, this.rank = n, this.schema = r, this.spec = o, this.attrs = rh(t, o.attrs), this.excluded = null;
    let a = eh(this.attrs);
    this.instance = a ? new et(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(t = null) {
    return !t && this.instance ? this.instance : new et(this, th(this.attrs, t));
  }
  /**
  @internal
  */
  static compile(t, n) {
    let r = /* @__PURE__ */ Object.create(null), o = 0;
    return t.forEach((a, l) => r[a] = new ss(a, o++, n, l)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(t) {
    for (var n = 0; n < t.length; n++)
      t[n].type == this && (t = t.slice(0, n).concat(t.slice(n + 1)), n--);
    return t;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(t) {
    for (let n = 0; n < t.length; n++)
      if (t[n].type == this)
        return t[n];
  }
  /**
  @internal
  */
  checkAttrs(t) {
    nh(this.attrs, t, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(t) {
    return this.excluded.indexOf(t) > -1;
  }
}
class ah {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(t) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let o in t)
      n[o] = t[o];
    n.nodes = kt.from(t.nodes), n.marks = kt.from(t.marks || {}), this.nodes = Bu.compile(this.spec.nodes, this), this.marks = ss.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let o in this.nodes) {
      if (o in this.marks)
        throw new RangeError(o + " can not be both a node and a mark");
      let a = this.nodes[o], l = a.spec.content || "", s = a.spec.marks;
      if (a.contentMatch = r[l] || (r[l] = Br.parse(l, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = s == "_" ? null : s ? Ou(this, s.split(" ")) : s == "" || !a.inlineContent ? [] : null;
    }
    for (let o in this.marks) {
      let a = this.marks[o], l = a.spec.excludes;
      a.excluded = l == null ? [a] : l == "" ? [] : Ou(this, l.split(" "));
    }
    this.nodeFromJSON = (o) => tr.fromJSON(this, o), this.markFromJSON = (o) => et.fromJSON(this, o), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(t, n = null, r, o) {
    if (typeof t == "string")
      t = this.nodeType(t);
    else if (t instanceof Bu) {
      if (t.schema != this)
        throw new RangeError("Node type from different schema used (" + t.name + ")");
    } else throw new RangeError("Invalid node type: " + t);
    return t.createChecked(n, r, o);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(t, n) {
    let r = this.nodes.text;
    return new xl(r, r.defaultAttrs, t, et.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(t, n) {
    return typeof t == "string" && (t = this.marks[t]), t.create(n);
  }
  /**
  @internal
  */
  nodeType(t) {
    let n = this.nodes[t];
    if (!n)
      throw new RangeError("Unknown node type: " + t);
    return n;
  }
}
function Ou(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let o = t[r], a = e.marks[o], l = a;
    if (a)
      n.push(a);
    else
      for (let s in e.marks) {
        let i = e.marks[s];
        (o == "_" || i.spec.group && i.spec.group.split(" ").indexOf(o) > -1) && n.push(l = i);
      }
    if (!l)
      throw new SyntaxError("Unknown mark type: '" + t[r] + "'");
  }
  return n;
}
function Yk(e) {
  return e.tag != null;
}
function Xk(e) {
  return e.style != null;
}
class nr {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(t, n) {
    this.schema = t, this.rules = n, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    n.forEach((o) => {
      if (Yk(o))
        this.tags.push(o);
      else if (Xk(o)) {
        let a = /[^=]*/.exec(o.style)[0];
        r.indexOf(a) < 0 && r.push(a), this.styles.push(o);
      }
    }), this.normalizeLists = !this.tags.some((o) => {
      if (!/^(ul|ol)\b/.test(o.tag) || !o.node)
        return !1;
      let a = t.nodes[o.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(t, n = {}) {
    let r = new zu(this, n, !1);
    return r.addAll(t, et.none, n.from, n.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(t, n = {}) {
    let r = new zu(this, n, !0);
    return r.addAll(t, et.none, n.from, n.to), Ee.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(t, n, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let a = this.tags[o];
      if (e1(t, a.tag) && (a.namespace === void 0 || t.namespaceURI == a.namespace) && (!a.context || n.matchesContext(a.context))) {
        if (a.getAttrs) {
          let l = a.getAttrs(t);
          if (l === !1)
            continue;
          a.attrs = l || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(t, n, r, o) {
    for (let a = o ? this.styles.indexOf(o) + 1 : 0; a < this.styles.length; a++) {
      let l = this.styles[a], s = l.style;
      if (!(s.indexOf(t) != 0 || l.context && !r.matchesContext(l.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > t.length && (s.charCodeAt(t.length) != 61 || s.slice(t.length + 1) != n))) {
        if (l.getAttrs) {
          let i = l.getAttrs(n);
          if (i === !1)
            continue;
          l.attrs = i || void 0;
        }
        return l;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(t) {
    let n = [];
    function r(o) {
      let a = o.priority == null ? 50 : o.priority, l = 0;
      for (; l < n.length; l++) {
        let s = n[l];
        if ((s.priority == null ? 50 : s.priority) < a)
          break;
      }
      n.splice(l, 0, o);
    }
    for (let o in t.marks) {
      let a = t.marks[o].spec.parseDOM;
      a && a.forEach((l) => {
        r(l = Nu(l)), l.mark || l.ignore || l.clearMark || (l.mark = o);
      });
    }
    for (let o in t.nodes) {
      let a = t.nodes[o].spec.parseDOM;
      a && a.forEach((l) => {
        r(l = Nu(l)), l.node || l.ignore || l.mark || (l.node = o);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(t) {
    return t.cached.domParser || (t.cached.domParser = new nr(t, nr.schemaRules(t)));
  }
}
const lh = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Qk = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, sh = { ol: !0, ul: !0 }, aa = 1, yi = 2, Wo = 4;
function Pu(e, t, n) {
  return t != null ? (t ? aa : 0) | (t === "full" ? yi : 0) : e && e.whitespace == "pre" ? aa | yi : n & ~Wo;
}
class Ra {
  constructor(t, n, r, o, a, l) {
    this.type = t, this.attrs = n, this.marks = r, this.solid = o, this.options = l, this.content = [], this.activeMarks = et.none, this.match = a || (l & Wo ? null : t.contentMatch);
  }
  findWrapping(t) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(Ce.from(t));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(t.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(t.type);
  }
  finish(t) {
    if (!(this.options & aa)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let a = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - o[0].length));
      }
    }
    let n = Ce.from(this.content);
    return !t && this.match && (n = n.append(this.match.fillBefore(Ce.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(t) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : t.parentNode && !lh.hasOwnProperty(t.parentNode.nodeName.toLowerCase());
  }
}
class zu {
  constructor(t, n, r) {
    this.parser = t, this.options = n, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let o = n.topNode, a, l = Pu(null, n.preserveWhitespace, 0) | (r ? Wo : 0);
    o ? a = new Ra(o.type, o.attrs, et.none, !0, n.topMatch || o.type.contentMatch, l) : r ? a = new Ra(null, null, et.none, !0, null, l) : a = new Ra(t.schema.topNodeType, null, et.none, !0, null, l), this.nodes = [a], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(t, n) {
    t.nodeType == 3 ? this.addTextNode(t, n) : t.nodeType == 1 && this.addElement(t, n);
  }
  addTextNode(t, n) {
    let r = t.nodeValue, o = this.top, a = o.options & yi ? "full" : this.localPreserveWS || (o.options & aa) > 0, { schema: l } = this.parser;
    if (a === "full" || o.inlineContext(t) || /[^ \t\r\n\u000c]/.test(r)) {
      if (a)
        if (a === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (l.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(l.linebreakReplacement.create())) {
          let s = r.split(/\r?\n|\r/);
          for (let i = 0; i < s.length; i++)
            i && this.insertNode(l.linebreakReplacement.create(), n, !0), s[i] && this.insertNode(l.text(s[i]), n, !/\S/.test(s[i]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let s = o.content[o.content.length - 1], i = t.previousSibling;
        (!s || i && i.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (r = r.slice(1));
      }
      r && this.insertNode(l.text(r), n, !/\S/.test(r)), this.findInText(t);
    } else
      this.findInside(t);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(t, n, r) {
    let o = this.localPreserveWS, a = this.top;
    (t.tagName == "PRE" || /pre/.test(t.style && t.style.whiteSpace)) && (this.localPreserveWS = !0);
    let l = t.nodeName.toLowerCase(), s;
    sh.hasOwnProperty(l) && this.parser.normalizeLists && _k(t);
    let i = this.options.ruleFromNode && this.options.ruleFromNode(t) || (s = this.parser.matchTag(t, this, r));
    e: if (i ? i.ignore : Qk.hasOwnProperty(l))
      this.findInside(t), this.ignoreFallback(t, n);
    else if (!i || i.skip || i.closeParent) {
      i && i.closeParent ? this.open = Math.max(0, this.open - 1) : i && i.skip.nodeType && (t = i.skip);
      let d, u = this.needsBlock;
      if (lh.hasOwnProperty(l))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), d = !0, a.type || (this.needsBlock = !0);
      else if (!t.firstChild) {
        this.leafFallback(t, n);
        break e;
      }
      let f = i && i.skip ? n : this.readStyles(t, n);
      f && this.addAll(t, f), d && this.sync(a), this.needsBlock = u;
    } else {
      let d = this.readStyles(t, n);
      d && this.addElementByRule(t, i, d, i.consuming === !1 ? s : void 0);
    }
    this.localPreserveWS = o;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(t, n) {
    t.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(t.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(t, n) {
    t.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(t, n) {
    let r = t.style;
    if (r && r.length)
      for (let o = 0; o < this.parser.matchedStyles.length; o++) {
        let a = this.parser.matchedStyles[o], l = r.getPropertyValue(a);
        if (l)
          for (let s = void 0; ; ) {
            let i = this.parser.matchStyle(a, l, this, s);
            if (!i)
              break;
            if (i.ignore)
              return null;
            if (i.clearMark ? n = n.filter((d) => !i.clearMark(d)) : n = n.concat(this.parser.schema.marks[i.mark].create(i.attrs)), i.consuming === !1)
              s = i;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(t, n, r, o) {
    let a, l;
    if (n.node)
      if (l = this.parser.schema.nodes[n.node], l.isLeaf)
        this.insertNode(l.create(n.attrs), r, t.nodeName == "BR") || this.leafFallback(t, r);
      else {
        let i = this.enter(l, n.attrs || null, r, n.preserveWhitespace);
        i && (a = !0, r = i);
      }
    else {
      let i = this.parser.schema.marks[n.mark];
      r = r.concat(i.create(n.attrs));
    }
    let s = this.top;
    if (l && l.isLeaf)
      this.findInside(t);
    else if (o)
      this.addElement(t, r, o);
    else if (n.getContent)
      this.findInside(t), n.getContent(t, this.parser.schema).forEach((i) => this.insertNode(i, r, !1));
    else {
      let i = t;
      typeof n.contentElement == "string" ? i = t.querySelector(n.contentElement) : typeof n.contentElement == "function" ? i = n.contentElement(t) : n.contentElement && (i = n.contentElement), this.findAround(t, i, !0), this.addAll(i, r), this.findAround(t, i, !1);
    }
    a && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(t, n, r, o) {
    let a = r || 0;
    for (let l = r ? t.childNodes[r] : t.firstChild, s = o == null ? null : t.childNodes[o]; l != s; l = l.nextSibling, ++a)
      this.findAtPoint(t, a), this.addDOM(l, n);
    this.findAtPoint(t, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(t, n, r) {
    let o, a;
    for (let l = this.open, s = 0; l >= 0; l--) {
      let i = this.nodes[l], d = i.findWrapping(t);
      if (d && (!o || o.length > d.length + s) && (o = d, a = i, !d.length))
        break;
      if (i.solid) {
        if (r)
          break;
        s += 2;
      }
    }
    if (!o)
      return null;
    this.sync(a);
    for (let l = 0; l < o.length; l++)
      n = this.enterInner(o[l], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(t, n, r) {
    if (t.isInline && this.needsBlock && !this.top.type) {
      let a = this.textblockFromContext();
      a && (n = this.enterInner(a, null, n));
    }
    let o = this.findPlace(t, n, r);
    if (o) {
      this.closeExtra();
      let a = this.top;
      a.match && (a.match = a.match.matchType(t.type));
      let l = et.none;
      for (let s of o.concat(t.marks))
        (a.type ? a.type.allowsMarkType(s.type) : Vu(s.type, t.type)) && (l = s.addToSet(l));
      return a.content.push(t.mark(l)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(t, n, r, o) {
    let a = this.findPlace(t.create(n), r, !1);
    return a && (a = this.enterInner(t, n, r, !0, o)), a;
  }
  // Open a node of the given type
  enterInner(t, n, r, o = !1, a) {
    this.closeExtra();
    let l = this.top;
    l.match = l.match && l.match.matchType(t);
    let s = Pu(t, a, l.options);
    l.options & Wo && l.content.length == 0 && (s |= Wo);
    let i = et.none;
    return r = r.filter((d) => (l.type ? l.type.allowsMarkType(d.type) : Vu(d.type, t)) ? (i = d.addToSet(i), !1) : !0), this.nodes.push(new Ra(t, n, i, o, null, s)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(t = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(t));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(t) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == t)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= aa);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let t = 0;
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n].content;
      for (let o = r.length - 1; o >= 0; o--)
        t += r[o].nodeSize;
      n && t++;
    }
    return t;
  }
  findAtPoint(t, n) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == t && this.find[r].offset == n && (this.find[r].pos = this.currentPos);
  }
  findInside(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && t.nodeType == 1 && t.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(t, n, r) {
    if (t != n && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && t.nodeType == 1 && t.contains(this.find[o].node) && n.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == t && (this.find[n].pos = this.currentPos - (t.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(t) {
    if (t.indexOf("|") > -1)
      return t.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = t.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), a = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), l = (s, i) => {
      for (; s >= 0; s--) {
        let d = n[s];
        if (d == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; i >= a; i--)
            if (l(s - 1, i))
              return !0;
          return !1;
        } else {
          let u = i > 0 || i == 0 && o ? this.nodes[i].type : r && i >= a ? r.node(i - a).type : null;
          if (!u || u.name != d && !u.isInGroup(d))
            return !1;
          i--;
        }
      }
      return !0;
    };
    return l(n.length - 1, this.open);
  }
  textblockFromContext() {
    let t = this.options.context;
    if (t)
      for (let n = t.depth; n >= 0; n--) {
        let r = t.node(n).contentMatchAt(t.indexAfter(n)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let n in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[n];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function _k(e) {
  for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
    let r = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
    r && sh.hasOwnProperty(r) && n ? (n.appendChild(t), t = n) : r == "li" ? n = t : r && (n = null);
  }
}
function e1(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function Nu(e) {
  let t = {};
  for (let n in e)
    t[n] = e[n];
  return t;
}
function Vu(e, t) {
  let n = t.schema.nodes;
  for (let r in n) {
    let o = n[r];
    if (!o.allowsMarkType(e))
      continue;
    let a = [], l = (s) => {
      a.push(s);
      for (let i = 0; i < s.edgeCount; i++) {
        let { type: d, next: u } = s.edge(i);
        if (d == t || a.indexOf(u) < 0 && l(u))
          return !0;
      }
    };
    if (l(o.contentMatch))
      return !0;
  }
}
class Vr {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(t, n) {
    this.nodes = t, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(t, n = {}, r) {
    r || (r = Ba(n).createDocumentFragment());
    let o = r, a = [];
    return t.forEach((l) => {
      if (a.length || l.marks.length) {
        let s = 0, i = 0;
        for (; s < a.length && i < l.marks.length; ) {
          let d = l.marks[i];
          if (!this.marks[d.type.name]) {
            i++;
            continue;
          }
          if (!d.eq(a[s][0]) || d.type.spec.spanning === !1)
            break;
          s++, i++;
        }
        for (; s < a.length; )
          o = a.pop()[1];
        for (; i < l.marks.length; ) {
          let d = l.marks[i++], u = this.serializeMark(d, l.isInline, n);
          u && (a.push([d, o]), o.appendChild(u.dom), o = u.contentDOM || u.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(l, n));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(t, n) {
    if (t.isText)
      return Ba(n).createTextNode(t.text);
    let { dom: r, contentDOM: o } = nl(Ba(n), this.nodes[t.type.name](t), null, t.attrs);
    if (o) {
      if (t.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(t.content, n, o);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(t, n = {}) {
    let r = this.serializeNodeInner(t, n);
    for (let o = t.marks.length - 1; o >= 0; o--) {
      let a = this.serializeMark(t.marks[o], t.isInline, n);
      a && ((a.contentDOM || a.dom).appendChild(r), r = a.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(t, n, r = {}) {
    let o = this.marks[t.type.name];
    return o && nl(Ba(r), o(t, n), null, t.attrs);
  }
  static renderSpec(t, n, r = null, o) {
    return typeof n == "string" ? { dom: t.createTextNode(n) } : nl(t, n, r, o);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(t) {
    return t.cached.domSerializer || (t.cached.domSerializer = new Vr(this.nodesFromSchema(t), this.marksFromSchema(t)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(t) {
    let n = Fu(t.nodes);
    return n.text || (n.text = (r) => r.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(t) {
    return Fu(t.marks);
  }
}
function Fu(e) {
  let t = {};
  for (let n in e) {
    let r = e[n].spec.toDOM;
    r && (t[n] = r);
  }
  return t;
}
function Ba(e) {
  return e.document || window.document;
}
const Hu = /* @__PURE__ */ new WeakMap();
function t1(e) {
  let t = Hu.get(e);
  return t === void 0 && Hu.set(e, t = n1(e)), t;
}
function n1(e) {
  let t = null;
  function n(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          t || (t = []), t.push(r);
        else
          for (let o = 0; o < r.length; o++)
            n(r[o]);
      else
        for (let o in r)
          n(r[o]);
  }
  return n(e), t;
}
function nl(e, t, n, r) {
  if (t.nodeType == 1)
    return { dom: t };
  if (t.dom && t.dom.nodeType == 1)
    return t;
  let o = t[0], a;
  if (typeof o != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (a = t1(r)) && a.indexOf(t) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let l = o.indexOf(" ");
  l > 0 && (n = o.slice(0, l), o = o.slice(l + 1));
  let s, i = n ? e.createElementNS(n, o) : e.createElement(o), d = t[1], u = 1;
  if (d && typeof d == "object" && d.nodeType == null && !Array.isArray(d)) {
    u = 2;
    for (let f in d)
      if (d[f] != null) {
        let h = f.indexOf(" ");
        h > 0 ? i.setAttributeNS(f.slice(0, h), f.slice(h + 1), d[f]) : f == "style" && i.style ? i.style.cssText = d[f] : i.setAttribute(f, d[f]);
      }
  }
  for (let f = u; f < t.length; f++) {
    let h = t[f];
    if (h === 0) {
      if (f < t.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: i, contentDOM: i };
    } else if (typeof h == "string")
      i.appendChild(e.createTextNode(h));
    else {
      let { dom: b, contentDOM: m } = nl(e, h, n, r);
      if (i.appendChild(b), m) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = m;
      }
    }
  }
  return { dom: i, contentDOM: s };
}
const ih = 65535, dh = Math.pow(2, 16);
function r1(e, t) {
  return e + t * dh;
}
function Wu(e) {
  return e & ih;
}
function o1(e) {
  return (e - (e & ih)) / dh;
}
const uh = 1, ch = 2, rl = 4, fh = 8;
class ki {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.pos = t, this.delInfo = n, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & fh) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (uh | rl)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (ch | rl)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & rl) > 0;
  }
}
class jt {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(t, n = !1) {
    if (this.ranges = t, this.inverted = n, !t.length && jt.empty)
      return jt.empty;
  }
  /**
  @internal
  */
  recover(t) {
    let n = 0, r = Wu(t);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        n += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + n + o1(t);
  }
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  map(t, n = 1) {
    return this._map(t, n, !0);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let o = 0, a = this.inverted ? 2 : 1, l = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let i = this.ranges[s] - (this.inverted ? o : 0);
      if (i > t)
        break;
      let d = this.ranges[s + a], u = this.ranges[s + l], f = i + d;
      if (t <= f) {
        let h = d ? t == i ? -1 : t == f ? 1 : n : n, b = i + o + (h < 0 ? 0 : u);
        if (r)
          return b;
        let m = t == (n < 0 ? i : f) ? null : r1(s / 3, t - i), v = t == i ? ch : t == f ? uh : rl;
        return (n < 0 ? t != i : t != f) && (v |= fh), new ki(b, v, m);
      }
      o += u - d;
    }
    return r ? t + o : new ki(t + o, 0, null);
  }
  /**
  @internal
  */
  touches(t, n) {
    let r = 0, o = Wu(n), a = this.inverted ? 2 : 1, l = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let i = this.ranges[s] - (this.inverted ? r : 0);
      if (i > t)
        break;
      let d = this.ranges[s + a], u = i + d;
      if (t <= u && s == o * 3)
        return !0;
      r += this.ranges[s + l] - d;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(t) {
    let n = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, a = 0; o < this.ranges.length; o += 3) {
      let l = this.ranges[o], s = l - (this.inverted ? a : 0), i = l + (this.inverted ? 0 : a), d = this.ranges[o + n], u = this.ranges[o + r];
      t(s, s + d, i, i + u), a += u - d;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new jt(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(t) {
    return t == 0 ? jt.empty : new jt(t < 0 ? [0, -t, 0] : [0, 0, t]);
  }
}
jt.empty = new jt([]);
class la {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(t, n, r = 0, o = t ? t.length : 0) {
    this.mirror = n, this.from = r, this.to = o, this._maps = t || [], this.ownData = !(t || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(t = 0, n = this.maps.length) {
    return new la(this._maps, this.mirror, t, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(t, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(t), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(t) {
    for (let n = 0, r = this._maps.length; n < t._maps.length; n++) {
      let o = t.getMirror(n);
      this.appendMap(t._maps[n], o != null && o < n ? r + o : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(t) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == t)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(t, n) {
    this.mirror || (this.mirror = []), this.mirror.push(t, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(t) {
    for (let n = t.maps.length - 1, r = this._maps.length + t._maps.length; n >= 0; n--) {
      let o = t.getMirror(n);
      this.appendMap(t._maps[n].invert(), o != null && o > n ? r - o - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let t = new la();
    return t.appendMappingInverted(this), t;
  }
  /**
  Map a position through this mapping.
  */
  map(t, n = 1) {
    if (this.mirror)
      return this._map(t, n, !0);
    for (let r = this.from; r < this.to; r++)
      t = this._maps[r].map(t, n);
    return t;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(t, n = 1) {
    return this._map(t, n, !1);
  }
  /**
  @internal
  */
  _map(t, n, r) {
    let o = 0;
    for (let a = this.from; a < this.to; a++) {
      let l = this._maps[a], s = l.mapResult(t, n);
      if (s.recover != null) {
        let i = this.getMirror(a);
        if (i != null && i > a && i < this.to) {
          a = i, t = this._maps[i].recover(s.recover);
          continue;
        }
      }
      o |= s.delInfo, t = s.pos;
    }
    return r ? t : new ki(t, o, null);
  }
}
const Ms = /* @__PURE__ */ Object.create(null);
class Mt {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return jt.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(t) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(t, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = Ms[n.stepType];
    if (!r)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(t, n) {
    if (t in Ms)
      throw new RangeError("Duplicate use of step JSON ID " + t);
    return Ms[t] = n, n.prototype.jsonID = t, n;
  }
}
class ct {
  /**
  @internal
  */
  constructor(t, n) {
    this.doc = t, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(t) {
    return new ct(t, null);
  }
  /**
  Create a failed step result.
  */
  static fail(t) {
    return new ct(null, t);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(t, n, r, o) {
    try {
      return ct.ok(t.replace(n, r, o));
    } catch (a) {
      if (a instanceof gl)
        return ct.fail(a.message);
      throw a;
    }
  }
}
function gd(e, t, n) {
  let r = [];
  for (let o = 0; o < e.childCount; o++) {
    let a = e.child(o);
    a.content.size && (a = a.copy(gd(a.content, t, a))), a.isInline && (a = t(a, n, o)), r.push(a);
  }
  return Ce.fromArray(r);
}
class Zn extends Mt {
  /**
  Create a mark step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = t.resolve(this.from), o = r.node(r.sharedDepth(this.to)), a = new Ee(gd(n.content, (l, s) => !l.isAtom || !s.type.allowsMarkType(this.mark.type) ? l : l.mark(this.mark.addToSet(l.marks)), o), n.openStart, n.openEnd);
    return ct.fromReplace(t, this.from, this.to, a);
  }
  invert() {
    return new sn(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new Zn(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof Zn && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new Zn(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Zn(n.from, n.to, t.markFromJSON(n.mark));
  }
}
Mt.jsonID("addMark", Zn);
class sn extends Mt {
  /**
  Create a mark-removing step.
  */
  constructor(t, n, r) {
    super(), this.from = t, this.to = n, this.mark = r;
  }
  apply(t) {
    let n = t.slice(this.from, this.to), r = new Ee(gd(n.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), t), n.openStart, n.openEnd);
    return ct.fromReplace(t, this.from, this.to, r);
  }
  invert() {
    return new Zn(this.from, this.to, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
    return n.deleted && r.deleted || n.pos >= r.pos ? null : new sn(n.pos, r.pos, this.mark);
  }
  merge(t) {
    return t instanceof sn && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new sn(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new sn(n.from, n.to, t.markFromJSON(n.mark));
  }
}
Mt.jsonID("removeMark", sn);
class Yn extends Mt {
  /**
  Create a node mark step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return ct.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return ct.fromReplace(t, this.pos, this.pos + 1, new Ee(Ce.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    if (n) {
      let r = this.mark.addToSet(n.marks);
      if (r.length == n.marks.length) {
        for (let o = 0; o < n.marks.length; o++)
          if (!n.marks[o].isInSet(r))
            return new Yn(this.pos, n.marks[o]);
        return new Yn(this.pos, this.mark);
      }
    }
    return new Or(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Yn(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Yn(n.pos, t.markFromJSON(n.mark));
  }
}
Mt.jsonID("addNodeMark", Yn);
class Or extends Mt {
  /**
  Create a mark-removing step.
  */
  constructor(t, n) {
    super(), this.pos = t, this.mark = n;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return ct.fail("No node at mark step's position");
    let r = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return ct.fromReplace(t, this.pos, this.pos + 1, new Ee(Ce.from(r), 0, n.isLeaf ? 0 : 1));
  }
  invert(t) {
    let n = t.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new Yn(this.pos, this.mark);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new Or(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Or(n.pos, t.markFromJSON(n.mark));
  }
}
Mt.jsonID("removeNodeMark", Or);
class ut extends Mt {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(t, n, r, o = !1) {
    super(), this.from = t, this.to = n, this.slice = r, this.structure = o;
  }
  apply(t) {
    return this.structure && wi(t, this.from, this.to) ? ct.fail("Structure replace would overwrite content") : ct.fromReplace(t, this.from, this.to, this.slice);
  }
  getMap() {
    return new jt([this.from, this.to - this.from, this.slice.size]);
  }
  invert(t) {
    return new ut(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
  }
  map(t) {
    let n = t.mapResult(this.to, -1), r = this.from == this.to && ut.MAP_BIAS < 0 ? n : t.mapResult(this.from, 1);
    return r.deletedAcross && n.deletedAcross ? null : new ut(r.pos, Math.max(r.pos, n.pos), this.slice, this.structure);
  }
  merge(t) {
    if (!(t instanceof ut) || t.structure || this.structure)
      return null;
    if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
      let n = this.slice.size + t.slice.size == 0 ? Ee.empty : new Ee(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
      return new ut(this.from, this.to + (t.to - t.from), n, this.structure);
    } else if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
      let n = this.slice.size + t.slice.size == 0 ? Ee.empty : new Ee(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
      return new ut(t.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let t = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new ut(n.from, n.to, Ee.fromJSON(t, n.slice), !!n.structure);
  }
}
ut.MAP_BIAS = 1;
Mt.jsonID("replace", ut);
class vt extends Mt {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(t, n, r, o, a, l, s = !1) {
    super(), this.from = t, this.to = n, this.gapFrom = r, this.gapTo = o, this.slice = a, this.insert = l, this.structure = s;
  }
  apply(t) {
    if (this.structure && (wi(t, this.from, this.gapFrom) || wi(t, this.gapTo, this.to)))
      return ct.fail("Structure gap-replace would overwrite content");
    let n = t.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return ct.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, n.content);
    return r ? ct.fromReplace(t, this.from, this.to, r) : ct.fail("Content does not fit in gap");
  }
  getMap() {
    return new jt([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(t) {
    let n = this.gapTo - this.gapFrom;
    return new vt(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(t) {
    let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1), o = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), a = this.to == this.gapTo ? r.pos : t.map(this.gapTo, 1);
    return n.deletedAcross && r.deletedAcross || o < n.pos || a > r.pos ? null : new vt(n.pos, r.pos, o, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let t = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (t.slice = this.slice.toJSON()), this.structure && (t.structure = !0), t;
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new vt(n.from, n.to, n.gapFrom, n.gapTo, Ee.fromJSON(t, n.slice), n.insert, !!n.structure);
  }
}
Mt.jsonID("replaceAround", vt);
function wi(e, t, n) {
  let r = e.resolve(t), o = n - t, a = r.depth;
  for (; o > 0 && a > 0 && r.indexAfter(a) == r.node(a).childCount; )
    a--, o--;
  if (o > 0) {
    let l = r.node(a).maybeChild(r.indexAfter(a));
    for (; o > 0; ) {
      if (!l || l.isLeaf)
        return !0;
      l = l.firstChild, o--;
    }
  }
  return !1;
}
function a1(e, t, n, r) {
  let o = [], a = [], l, s;
  e.doc.nodesBetween(t, n, (i, d, u) => {
    if (!i.isInline)
      return;
    let f = i.marks;
    if (!r.isInSet(f) && u.type.allowsMarkType(r.type)) {
      let h = Math.max(d, t), b = Math.min(d + i.nodeSize, n), m = r.addToSet(f);
      for (let v = 0; v < f.length; v++)
        f[v].isInSet(m) || (l && l.to == h && l.mark.eq(f[v]) ? l.to = b : o.push(l = new sn(h, b, f[v])));
      s && s.to == h ? s.to = b : a.push(s = new Zn(h, b, r));
    }
  }), o.forEach((i) => e.step(i)), a.forEach((i) => e.step(i));
}
function l1(e, t, n, r) {
  let o = [], a = 0;
  e.doc.nodesBetween(t, n, (l, s) => {
    if (!l.isInline)
      return;
    a++;
    let i = null;
    if (r instanceof ss) {
      let d = l.marks, u;
      for (; u = r.isInSet(d); )
        (i || (i = [])).push(u), d = u.removeFromSet(d);
    } else r ? r.isInSet(l.marks) && (i = [r]) : i = l.marks;
    if (i && i.length) {
      let d = Math.min(s + l.nodeSize, n);
      for (let u = 0; u < i.length; u++) {
        let f = i[u], h;
        for (let b = 0; b < o.length; b++) {
          let m = o[b];
          m.step == a - 1 && f.eq(o[b].style) && (h = m);
        }
        h ? (h.to = d, h.step = a) : o.push({ style: f, from: Math.max(s, t), to: d, step: a });
      }
    }
  }), o.forEach((l) => e.step(new sn(l.from, l.to, l.style)));
}
function md(e, t, n, r = n.contentMatch, o = !0) {
  let a = e.doc.nodeAt(t), l = [], s = t + 1;
  for (let i = 0; i < a.childCount; i++) {
    let d = a.child(i), u = s + d.nodeSize, f = r.matchType(d.type);
    if (!f)
      l.push(new ut(s, u, Ee.empty));
    else {
      r = f;
      for (let h = 0; h < d.marks.length; h++)
        n.allowsMarkType(d.marks[h].type) || e.step(new sn(s, u, d.marks[h]));
      if (o && d.isText && n.whitespace != "pre") {
        let h, b = /\r?\n|\r/g, m;
        for (; h = b.exec(d.text); )
          m || (m = new Ee(Ce.from(n.schema.text(" ", n.allowedMarks(d.marks))), 0, 0)), l.push(new ut(s + h.index, s + h.index + h[0].length, m));
      }
    }
    s = u;
  }
  if (!r.validEnd) {
    let i = r.fillBefore(Ce.empty, !0);
    e.replace(s, s, new Ee(i, 0, 0));
  }
  for (let i = l.length - 1; i >= 0; i--)
    e.step(l[i]);
}
function s1(e, t, n) {
  return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function xo(e) {
  let n = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let r = e.depth, o = 0, a = 0; ; --r) {
    let l = e.$from.node(r), s = e.$from.index(r) + o, i = e.$to.indexAfter(r) - a;
    if (r < e.depth && l.canReplace(s, i, n))
      return r;
    if (r == 0 || l.type.spec.isolating || !s1(l, s, i))
      break;
    s && (o = 1), i < l.childCount && (a = 1);
  }
  return null;
}
function i1(e, t, n) {
  let { $from: r, $to: o, depth: a } = t, l = r.before(a + 1), s = o.after(a + 1), i = l, d = s, u = Ce.empty, f = 0;
  for (let m = a, v = !1; m > n; m--)
    v || r.index(m) > 0 ? (v = !0, u = Ce.from(r.node(m).copy(u)), f++) : i--;
  let h = Ce.empty, b = 0;
  for (let m = a, v = !1; m > n; m--)
    v || o.after(m + 1) < o.end(m) ? (v = !0, h = Ce.from(o.node(m).copy(h)), b++) : d++;
  e.step(new vt(i, d, l, s, new Ee(u.append(h), f, b), u.size - f, !0));
}
function vd(e, t, n = null, r = e) {
  let o = d1(e, t), a = o && u1(r, t);
  return a ? o.map(ju).concat({ type: t, attrs: n }).concat(a.map(ju)) : null;
}
function ju(e) {
  return { type: e, attrs: null };
}
function d1(e, t) {
  let { parent: n, startIndex: r, endIndex: o } = e, a = n.contentMatchAt(r).findWrapping(t);
  if (!a)
    return null;
  let l = a.length ? a[0] : t;
  return n.canReplaceWith(r, o, l) ? a : null;
}
function u1(e, t) {
  let { parent: n, startIndex: r, endIndex: o } = e, a = n.child(r), l = t.contentMatch.findWrapping(a.type);
  if (!l)
    return null;
  let i = (l.length ? l[l.length - 1] : t).contentMatch;
  for (let d = r; i && d < o; d++)
    i = i.matchType(n.child(d).type);
  return !i || !i.validEnd ? null : l;
}
function c1(e, t, n) {
  let r = Ce.empty;
  for (let l = n.length - 1; l >= 0; l--) {
    if (r.size) {
      let s = n[l].type.contentMatch.matchFragment(r);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = Ce.from(n[l].type.create(n[l].attrs, r));
  }
  let o = t.start, a = t.end;
  e.step(new vt(o, a, o, a, new Ee(r, 0, 0), n.length, !0));
}
function f1(e, t, n, r, o) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let a = e.steps.length;
  e.doc.nodesBetween(t, n, (l, s) => {
    let i = typeof o == "function" ? o(l) : o;
    if (l.isTextblock && !l.hasMarkup(r, i) && h1(e.doc, e.mapping.slice(a).map(s), r)) {
      let d = null;
      if (r.schema.linebreakReplacement) {
        let b = r.whitespace == "pre", m = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        b && !m ? d = !1 : !b && m && (d = !0);
      }
      d === !1 && bh(e, l, s, a), md(e, e.mapping.slice(a).map(s, 1), r, void 0, d === null);
      let u = e.mapping.slice(a), f = u.map(s, 1), h = u.map(s + l.nodeSize, 1);
      return e.step(new vt(f, h, f + 1, h - 1, new Ee(Ce.from(r.create(i, null, l.marks)), 0, 0), 1, !0)), d === !0 && hh(e, l, s, a), !1;
    }
  });
}
function hh(e, t, n, r) {
  t.forEach((o, a) => {
    if (o.isText) {
      let l, s = /\r?\n|\r/g;
      for (; l = s.exec(o.text); ) {
        let i = e.mapping.slice(r).map(n + 1 + a + l.index);
        e.replaceWith(i, i + 1, t.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function bh(e, t, n, r) {
  t.forEach((o, a) => {
    if (o.type == o.type.schema.linebreakReplacement) {
      let l = e.mapping.slice(r).map(n + 1 + a);
      e.replaceWith(l, l + 1, t.type.schema.text(`
`));
    }
  });
}
function h1(e, t, n) {
  let r = e.resolve(t), o = r.index();
  return r.parent.canReplaceWith(o, o + 1, n);
}
function b1(e, t, n, r, o) {
  let a = e.doc.nodeAt(t);
  if (!a)
    throw new RangeError("No node at given position");
  n || (n = a.type);
  let l = n.create(r, null, o || a.marks);
  if (a.isLeaf)
    return e.replaceWith(t, t + a.nodeSize, l);
  if (!n.validContent(a.content))
    throw new RangeError("Invalid content for node type " + n.name);
  e.step(new vt(t, t + a.nodeSize, t + 1, t + a.nodeSize - 1, new Ee(Ce.from(l), 0, 0), 1, !0));
}
function On(e, t, n = 1, r) {
  let o = e.resolve(t), a = o.depth - n, l = r && r[r.length - 1] || o.parent;
  if (a < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !l.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount)))
    return !1;
  for (let d = o.depth - 1, u = n - 2; d > a; d--, u--) {
    let f = o.node(d), h = o.index(d);
    if (f.type.spec.isolating)
      return !1;
    let b = f.content.cutByIndex(h, f.childCount), m = r && r[u + 1];
    m && (b = b.replaceChild(0, m.type.create(m.attrs)));
    let v = r && r[u] || f;
    if (!f.canReplace(h + 1, f.childCount) || !v.type.validContent(b))
      return !1;
  }
  let s = o.indexAfter(a), i = r && r[0];
  return o.node(a).canReplaceWith(s, s, i ? i.type : o.node(a + 1).type);
}
function p1(e, t, n = 1, r) {
  let o = e.doc.resolve(t), a = Ce.empty, l = Ce.empty;
  for (let s = o.depth, i = o.depth - n, d = n - 1; s > i; s--, d--) {
    a = Ce.from(o.node(s).copy(a));
    let u = r && r[d];
    l = Ce.from(u ? u.type.create(u.attrs, l) : o.node(s).copy(l));
  }
  e.step(new ut(t, t, new Ee(a.append(l), n, n), !0));
}
function fr(e, t) {
  let n = e.resolve(t), r = n.index();
  return ph(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function g1(e, t) {
  t.content.size || e.type.compatibleContent(t.type);
  let n = e.contentMatchAt(e.childCount), { linebreakReplacement: r } = e.type.schema;
  for (let o = 0; o < t.childCount; o++) {
    let a = t.child(o), l = a.type == r ? e.type.schema.nodes.text : a.type;
    if (n = n.matchType(l), !n || !e.type.allowsMarks(a.marks))
      return !1;
  }
  return n.validEnd;
}
function ph(e, t) {
  return !!(e && t && !e.isLeaf && g1(e, t));
}
function is(e, t, n = -1) {
  let r = e.resolve(t);
  for (let o = r.depth; ; o--) {
    let a, l, s = r.index(o);
    if (o == r.depth ? (a = r.nodeBefore, l = r.nodeAfter) : n > 0 ? (a = r.node(o + 1), s++, l = r.node(o).maybeChild(s)) : (a = r.node(o).maybeChild(s - 1), l = r.node(o + 1)), a && !a.isTextblock && ph(a, l) && r.node(o).canReplace(s, s + 1))
      return t;
    if (o == 0)
      break;
    t = n < 0 ? r.before(o) : r.after(o);
  }
}
function m1(e, t, n) {
  let r = null, { linebreakReplacement: o } = e.doc.type.schema, a = e.doc.resolve(t - n), l = a.node().type;
  if (o && l.inlineContent) {
    let u = l.whitespace == "pre", f = !!l.contentMatch.matchType(o);
    u && !f ? r = !1 : !u && f && (r = !0);
  }
  let s = e.steps.length;
  if (r === !1) {
    let u = e.doc.resolve(t + n);
    bh(e, u.node(), u.before(), s);
  }
  l.inlineContent && md(e, t + n - 1, l, a.node().contentMatchAt(a.index()), r == null);
  let i = e.mapping.slice(s), d = i.map(t - n);
  if (e.step(new ut(d, i.map(t + n, -1), Ee.empty, !0)), r === !0) {
    let u = e.doc.resolve(d);
    hh(e, u.node(), u.before(), e.steps.length);
  }
  return e;
}
function v1(e, t, n) {
  let r = e.resolve(t);
  if (r.parent.canReplaceWith(r.index(), r.index(), n))
    return t;
  if (r.parentOffset == 0)
    for (let o = r.depth - 1; o >= 0; o--) {
      let a = r.index(o);
      if (r.node(o).canReplaceWith(a, a, n))
        return r.before(o + 1);
      if (a > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let o = r.depth - 1; o >= 0; o--) {
      let a = r.indexAfter(o);
      if (r.node(o).canReplaceWith(a, a, n))
        return r.after(o + 1);
      if (a < r.node(o).childCount)
        return null;
    }
  return null;
}
function gh(e, t, n) {
  let r = e.resolve(t);
  if (!n.content.size)
    return t;
  let o = n.content;
  for (let a = 0; a < n.openStart; a++)
    o = o.firstChild.content;
  for (let a = 1; a <= (n.openStart == 0 && n.size ? 2 : 1); a++)
    for (let l = r.depth; l >= 0; l--) {
      let s = l == r.depth ? 0 : r.pos <= (r.start(l + 1) + r.end(l + 1)) / 2 ? -1 : 1, i = r.index(l) + (s > 0 ? 1 : 0), d = r.node(l), u = !1;
      if (a == 1)
        u = d.canReplace(i, i, o);
      else {
        let f = d.contentMatchAt(i).findWrapping(o.firstChild.type);
        u = f && d.canReplaceWith(i, i, f[0]);
      }
      if (u)
        return s == 0 ? r.pos : s < 0 ? r.before(l + 1) : r.after(l + 1);
    }
  return null;
}
function ds(e, t, n = t, r = Ee.empty) {
  if (t == n && !r.size)
    return null;
  let o = e.resolve(t), a = e.resolve(n);
  return mh(o, a, r) ? new ut(t, n, r) : new x1(o, a, r).fit();
}
function mh(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
class x1 {
  constructor(t, n, r) {
    this.$from = t, this.$to = n, this.unplaced = r, this.frontier = [], this.placed = Ce.empty;
    for (let o = 0; o <= t.depth; o++) {
      let a = t.node(o);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(t.indexAfter(o))
      });
    }
    for (let o = t.depth; o > 0; o--)
      this.placed = Ce.from(t.node(o).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let d = this.findFittable();
      d ? this.placeNodes(d) : this.openMore() || this.dropNode();
    }
    let t = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, r = this.$from, o = this.close(t < 0 ? this.$to : r.doc.resolve(t));
    if (!o)
      return null;
    let a = this.placed, l = r.depth, s = o.depth;
    for (; l && s && a.childCount == 1; )
      a = a.firstChild.content, l--, s--;
    let i = new Ee(a, l, s);
    return t > -1 ? new vt(r.pos, t, this.$to.pos, this.$to.end(), i, n) : i.size || r.pos != this.$to.pos ? new ut(r.pos, o.pos, i) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let t = this.unplaced.openStart;
    for (let n = this.unplaced.content, r = 0, o = this.unplaced.openEnd; r < t; r++) {
      let a = n.firstChild;
      if (n.childCount > 1 && (o = 0), a.type.spec.isolating && o <= r) {
        t = r;
        break;
      }
      n = a.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let r = n == 1 ? t : this.unplaced.openStart; r >= 0; r--) {
        let o, a = null;
        r ? (a = Es(this.unplaced.content, r - 1).firstChild, o = a.content) : o = this.unplaced.content;
        let l = o.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: i, match: d } = this.frontier[s], u, f = null;
          if (n == 1 && (l ? d.matchType(l.type) || (f = d.fillBefore(Ce.from(l), !1)) : a && i.compatibleContent(a.type)))
            return { sliceDepth: r, frontierDepth: s, parent: a, inject: f };
          if (n == 2 && l && (u = d.findWrapping(l.type)))
            return { sliceDepth: r, frontierDepth: s, parent: a, wrap: u };
          if (a && d.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, o = Es(t, n);
    return !o.childCount || o.firstChild.isLeaf ? !1 : (this.unplaced = new Ee(t, n + 1, Math.max(r, o.size + n >= t.size - r ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: t, openStart: n, openEnd: r } = this.unplaced, o = Es(t, n);
    if (o.childCount <= 1 && n > 0) {
      let a = t.size - n <= n + o.size;
      this.unplaced = new Ee(Ro(t, n - 1, 1), n - 1, a ? n - 1 : r);
    } else
      this.unplaced = new Ee(Ro(t, n, 1), n, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: t, frontierDepth: n, parent: r, inject: o, wrap: a }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (a)
      for (let v = 0; v < a.length; v++)
        this.openFrontierNode(a[v]);
    let l = this.unplaced, s = r ? r.content : l.content, i = l.openStart - t, d = 0, u = [], { match: f, type: h } = this.frontier[n];
    if (o) {
      for (let v = 0; v < o.childCount; v++)
        u.push(o.child(v));
      f = f.matchFragment(o);
    }
    let b = s.size + t - (l.content.size - l.openEnd);
    for (; d < s.childCount; ) {
      let v = s.child(d), x = f.matchType(v.type);
      if (!x)
        break;
      d++, (d > 1 || i == 0 || v.content.size) && (f = x, u.push(vh(v.mark(h.allowedMarks(v.marks)), d == 1 ? i : 0, d == s.childCount ? b : -1)));
    }
    let m = d == s.childCount;
    m || (b = -1), this.placed = Bo(this.placed, n, Ce.from(u)), this.frontier[n].match = f, m && b < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let v = 0, x = s; v < b; v++) {
      let k = x.lastChild;
      this.frontier.push({ type: k.type, match: k.contentMatchAt(k.childCount) }), x = k.content;
    }
    this.unplaced = m ? t == 0 ? Ee.empty : new Ee(Ro(l.content, t - 1, 1), t - 1, b < 0 ? l.openEnd : t - 1) : new Ee(Ro(l.content, t, d), l.openStart, l.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let t = this.frontier[this.depth], n;
    if (!t.type.isTextblock || !As(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, o = this.$to.after(r);
    for (; r > 1 && o == this.$to.end(--r); )
      ++o;
    return o;
  }
  findCloseLevel(t) {
    e: for (let n = Math.min(this.depth, t.depth); n >= 0; n--) {
      let { match: r, type: o } = this.frontier[n], a = n < t.depth && t.end(n + 1) == t.pos + (t.depth - (n + 1)), l = As(t, n, o, r, a);
      if (l) {
        for (let s = n - 1; s >= 0; s--) {
          let { match: i, type: d } = this.frontier[s], u = As(t, s, d, i, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: l, move: a ? t.doc.resolve(t.after(n + 1)) : t };
      }
    }
  }
  close(t) {
    let n = this.findCloseLevel(t);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Bo(this.placed, n.depth, n.fit)), t = n.move;
    for (let r = n.depth + 1; r <= t.depth; r++) {
      let o = t.node(r), a = o.type.contentMatch.fillBefore(o.content, !0, t.index(r));
      this.openFrontierNode(o.type, o.attrs, a);
    }
    return t;
  }
  openFrontierNode(t, n = null, r) {
    let o = this.frontier[this.depth];
    o.match = o.match.matchType(t), this.placed = Bo(this.placed, this.depth, Ce.from(t.create(n, r))), this.frontier.push({ type: t, match: t.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(Ce.empty, !0);
    n.childCount && (this.placed = Bo(this.placed, this.frontier.length, n));
  }
}
function Ro(e, t, n) {
  return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(Ro(e.firstChild.content, t - 1, n)));
}
function Bo(e, t, n) {
  return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(Bo(e.lastChild.content, t - 1, n)));
}
function Es(e, t) {
  for (let n = 0; n < t; n++)
    e = e.firstChild.content;
  return e;
}
function vh(e, t, n) {
  if (t <= 0)
    return e;
  let r = e.content;
  return t > 1 && (r = r.replaceChild(0, vh(r.firstChild, t - 1, r.childCount == 1 ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(Ce.empty, !0)))), e.copy(r);
}
function As(e, t, n, r, o) {
  let a = e.node(t), l = o ? e.indexAfter(t) : e.index(t);
  if (l == a.childCount && !n.compatibleContent(a.type))
    return null;
  let s = r.fillBefore(a.content, !0, l);
  return s && !y1(n, a.content, l) ? s : null;
}
function y1(e, t, n) {
  for (let r = n; r < t.childCount; r++)
    if (!e.allowsMarks(t.child(r).marks))
      return !0;
  return !1;
}
function k1(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function w1(e, t, n, r) {
  if (!r.size)
    return e.deleteRange(t, n);
  let o = e.doc.resolve(t), a = e.doc.resolve(n);
  if (mh(o, a, r))
    return e.step(new ut(t, n, r));
  let l = yh(o, a);
  l[l.length - 1] == 0 && l.pop();
  let s = -(o.depth + 1);
  l.unshift(s);
  for (let h = o.depth, b = o.pos - 1; h > 0; h--, b--) {
    let m = o.node(h).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    l.indexOf(h) > -1 ? s = h : o.before(h) == b && l.splice(1, 0, -h);
  }
  let i = l.indexOf(s), d = [], u = r.openStart;
  for (let h = r.content, b = 0; ; b++) {
    let m = h.firstChild;
    if (d.push(m), b == r.openStart)
      break;
    h = m.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let b = d[h], m = k1(b.type);
    if (m && !b.sameMarkup(o.node(Math.abs(s) - 1)))
      u = h;
    else if (m || !b.type.isTextblock)
      break;
  }
  for (let h = r.openStart; h >= 0; h--) {
    let b = (h + u + 1) % (r.openStart + 1), m = d[b];
    if (m)
      for (let v = 0; v < l.length; v++) {
        let x = l[(v + i) % l.length], k = !0;
        x < 0 && (k = !1, x = -x);
        let L = o.node(x - 1), P = o.index(x - 1);
        if (L.canReplaceWith(P, P, m.type, m.marks))
          return e.replace(o.before(x), k ? a.after(x) : n, new Ee(xh(r.content, 0, r.openStart, b), b, r.openEnd));
      }
  }
  let f = e.steps.length;
  for (let h = l.length - 1; h >= 0 && (e.replace(t, n, r), !(e.steps.length > f)); h--) {
    let b = l[h];
    b < 0 || (t = o.before(b), n = a.after(b));
  }
}
function xh(e, t, n, r, o) {
  if (t < n) {
    let a = e.firstChild;
    e = e.replaceChild(0, a.copy(xh(a.content, t + 1, n, r, a)));
  }
  if (t > r) {
    let a = o.contentMatchAt(0), l = a.fillBefore(e).append(e);
    e = l.append(a.matchFragment(l).fillBefore(Ce.empty, !0));
  }
  return e;
}
function C1(e, t, n, r) {
  if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
    let o = v1(e.doc, t, r.type);
    o != null && (t = n = o);
  }
  e.replaceRange(t, n, new Ee(Ce.from(r), 0, 0));
}
function S1(e, t, n) {
  let r = e.doc.resolve(t), o = e.doc.resolve(n);
  if (r.parent.isTextblock && o.parent.isTextblock && r.start() != o.start() && r.parentOffset == 0 && o.parentOffset == 0) {
    let l = r.sharedDepth(n), s = !1;
    for (let i = r.depth; i > l; i--)
      r.node(i).type.spec.isolating && (s = !0);
    for (let i = o.depth; i > l; i--)
      o.node(i).type.spec.isolating && (s = !0);
    if (!s) {
      for (let i = r.depth; i > 0 && t == r.start(i); i--)
        t = r.before(i);
      for (let i = o.depth; i > 0 && n == o.start(i); i--)
        n = o.before(i);
      r = e.doc.resolve(t), o = e.doc.resolve(n);
    }
  }
  let a = yh(r, o);
  for (let l = 0; l < a.length; l++) {
    let s = a[l], i = l == a.length - 1;
    if (i && s == 0 || r.node(s).type.contentMatch.validEnd)
      return e.delete(r.start(s), o.end(s));
    if (s > 0 && (i || r.node(s - 1).canReplace(r.index(s - 1), o.indexAfter(s - 1))))
      return e.delete(r.before(s), o.after(s));
  }
  for (let l = 1; l <= r.depth && l <= o.depth; l++)
    if (t - r.start(l) == r.depth - l && n > r.end(l) && o.end(l) - n != o.depth - l && r.start(l - 1) == o.start(l - 1) && r.node(l - 1).canReplace(r.index(l - 1), o.index(l - 1)))
      return e.delete(r.before(l), n);
  e.delete(t, n);
}
function yh(e, t) {
  let n = [], r = Math.min(e.depth, t.depth);
  for (let o = r; o >= 0; o--) {
    let a = e.start(o);
    if (a < e.pos - (e.depth - o) || t.end(o) > t.pos + (t.depth - o) || e.node(o).type.spec.isolating || t.node(o).type.spec.isolating)
      break;
    (a == t.start(o) || o == e.depth && o == t.depth && e.parent.inlineContent && t.parent.inlineContent && o && t.start(o - 1) == a - 1) && n.push(o);
  }
  return n;
}
class eo extends Mt {
  /**
  Construct an attribute step.
  */
  constructor(t, n, r) {
    super(), this.pos = t, this.attr = n, this.value = r;
  }
  apply(t) {
    let n = t.nodeAt(this.pos);
    if (!n)
      return ct.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let a in n.attrs)
      r[a] = n.attrs[a];
    r[this.attr] = this.value;
    let o = n.type.create(r, null, n.marks);
    return ct.fromReplace(t, this.pos, this.pos + 1, new Ee(Ce.from(o), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return jt.empty;
  }
  invert(t) {
    return new eo(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
  }
  map(t) {
    let n = t.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new eo(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new eo(n.pos, n.attr, n.value);
  }
}
Mt.jsonID("attr", eo);
class sa extends Mt {
  /**
  Construct an attribute step.
  */
  constructor(t, n) {
    super(), this.attr = t, this.value = n;
  }
  apply(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in t.attrs)
      n[o] = t.attrs[o];
    n[this.attr] = this.value;
    let r = t.type.create(n, t.content, t.marks);
    return ct.ok(r);
  }
  getMap() {
    return jt.empty;
  }
  invert(t) {
    return new sa(this.attr, t.attrs[this.attr]);
  }
  map(t) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(t, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new sa(n.attr, n.value);
  }
}
Mt.jsonID("docAttr", sa);
let uo = class extends Error {
};
uo = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
};
uo.prototype = Object.create(Error.prototype);
uo.prototype.constructor = uo;
uo.prototype.name = "TransformError";
class kh {
  /**
  Create a transform that starts with the given document.
  */
  constructor(t) {
    this.doc = t, this.steps = [], this.docs = [], this.mapping = new la();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(t) {
    let n = this.maybeStep(t);
    if (n.failed)
      throw new uo(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(t) {
    let n = t.apply(this.doc);
    return n.failed || this.addStep(t, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let t = 1e9, n = -1e9;
    for (let r = 0; r < this.mapping.maps.length; r++) {
      let o = this.mapping.maps[r];
      r && (t = o.map(t, 1), n = o.map(n, -1)), o.forEach((a, l, s, i) => {
        t = Math.min(t, s), n = Math.max(n, i);
      });
    }
    return t == 1e9 ? null : { from: t, to: n };
  }
  /**
  @internal
  */
  addStep(t, n) {
    this.docs.push(this.doc), this.steps.push(t), this.mapping.appendMap(t.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(t, n = t, r = Ee.empty) {
    let o = ds(this.doc, t, n, r);
    return o && this.step(o), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(t, n, r) {
    return this.replace(t, n, new Ee(Ce.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(t, n) {
    return this.replace(t, n, Ee.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(t, n) {
    return this.replaceWith(t, t, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(t, n, r) {
    return w1(this, t, n, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(t, n, r) {
    return C1(this, t, n, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(t, n) {
    return S1(this, t, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(t, n) {
    return i1(this, t, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(t, n = 1) {
    return m1(this, t, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(t, n) {
    return c1(this, t, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(t, n = t, r, o = null) {
    return f1(this, t, n, r, o), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(t, n, r = null, o) {
    return b1(this, t, n, r, o), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(t, n, r) {
    return this.step(new eo(t, n, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(t, n) {
    return this.step(new sa(t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(t, n) {
    return this.step(new Yn(t, n)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(t, n) {
    let r = this.doc.nodeAt(t);
    if (!r)
      throw new RangeError("No node at position " + t);
    if (n instanceof et)
      n.isInSet(r.marks) && this.step(new Or(t, n));
    else {
      let o = r.marks, a, l = [];
      for (; a = n.isInSet(o); )
        l.push(new Or(t, a)), o = a.removeFromSet(o);
      for (let s = l.length - 1; s >= 0; s--)
        this.step(l[s]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(t, n = 1, r) {
    return p1(this, t, n, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(t, n, r) {
    return a1(this, t, n, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(t, n, r) {
    return l1(this, t, n, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(t, n, r) {
    return md(this, t, n, r), this;
  }
}
const Ds = /* @__PURE__ */ Object.create(null);
class Ue {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(t, n, r) {
    this.$anchor = t, this.$head = n, this.ranges = r || [new $1(t.min(n), t.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let t = this.ranges;
    for (let n = 0; n < t.length; n++)
      if (t[n].$from.pos != t[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(t, n = Ee.empty) {
    let r = n.content.lastChild, o = null;
    for (let s = 0; s < n.openEnd; s++)
      o = r, r = r.lastChild;
    let a = t.steps.length, l = this.ranges;
    for (let s = 0; s < l.length; s++) {
      let { $from: i, $to: d } = l[s], u = t.mapping.slice(a);
      t.replaceRange(u.map(i.pos), u.map(d.pos), s ? Ee.empty : n), s == 0 && qu(t, a, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(t, n) {
    let r = t.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: l, $to: s } = o[a], i = t.mapping.slice(r), d = i.map(l.pos), u = i.map(s.pos);
      a ? t.deleteRange(d, u) : (t.replaceRangeWith(d, u, n), qu(t, r, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(t, n, r = !1) {
    let o = t.parent.inlineContent ? new Fe(t) : Kr(t.node(0), t.parent, t.pos, t.index(), n, r);
    if (o)
      return o;
    for (let a = t.depth - 1; a >= 0; a--) {
      let l = n < 0 ? Kr(t.node(0), t.node(a), t.before(a + 1), t.index(a), n, r) : Kr(t.node(0), t.node(a), t.after(a + 1), t.index(a) + 1, n, r);
      if (l)
        return l;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(t, n = 1) {
    return this.findFrom(t, n) || this.findFrom(t, -n) || new Ut(t.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(t) {
    return Kr(t, t, 0, 0, 1) || new Ut(t);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(t) {
    return Kr(t, t, t.content.size, t.childCount, -1) || new Ut(t);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(t, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = Ds[n.type];
    if (!r)
      throw new RangeError(`No selection type ${n.type} defined`);
    return r.fromJSON(t, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(t, n) {
    if (t in Ds)
      throw new RangeError("Duplicate use of selection JSON ID " + t);
    return Ds[t] = n, n.prototype.jsonID = t, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Fe.between(this.$anchor, this.$head).getBookmark();
  }
}
Ue.prototype.visible = !0;
class $1 {
  /**
  Create a range.
  */
  constructor(t, n) {
    this.$from = t, this.$to = n;
  }
}
let Uu = !1;
function Gu(e) {
  !Uu && !e.parent.inlineContent && (Uu = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class Fe extends Ue {
  /**
  Construct a text selection between the given points.
  */
  constructor(t, n = t) {
    Gu(t), Gu(n), super(t, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    if (!r.parent.inlineContent)
      return Ue.near(r);
    let o = t.resolve(n.map(this.anchor));
    return new Fe(o.parent.inlineContent ? o : r, r);
  }
  replace(t, n = Ee.empty) {
    if (super.replace(t, n), n == Ee.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && t.ensureMarks(r);
    }
  }
  eq(t) {
    return t instanceof Fe && t.anchor == this.anchor && t.head == this.head;
  }
  getBookmark() {
    return new us(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Fe(t.resolve(n.anchor), t.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(t, n, r = n) {
    let o = t.resolve(n);
    return new this(o, r == n ? o : t.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(t, n, r) {
    let o = t.pos - n.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let a = Ue.findFrom(n, r, !0) || Ue.findFrom(n, -r, !0);
      if (a)
        n = a.$head;
      else
        return Ue.near(n, r);
    }
    return t.parent.inlineContent || (o == 0 ? t = n : (t = (Ue.findFrom(t, -r, !0) || Ue.findFrom(t, r, !0)).$anchor, t.pos < n.pos != o < 0 && (t = n))), new Fe(t, n);
  }
}
Ue.jsonID("text", Fe);
class us {
  constructor(t, n) {
    this.anchor = t, this.head = n;
  }
  map(t) {
    return new us(t.map(this.anchor), t.map(this.head));
  }
  resolve(t) {
    return Fe.between(t.resolve(this.anchor), t.resolve(this.head));
  }
}
class Oe extends Ue {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(t) {
    let n = t.nodeAfter, r = t.node(0).resolve(t.pos + n.nodeSize);
    super(t, r), this.node = n;
  }
  map(t, n) {
    let { deleted: r, pos: o } = n.mapResult(this.anchor), a = t.resolve(o);
    return r ? Ue.near(a) : new Oe(a);
  }
  content() {
    return new Ee(Ce.from(this.node), 0, 0);
  }
  eq(t) {
    return t instanceof Oe && t.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new xd(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Oe(t.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(t, n) {
    return new Oe(t.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(t) {
    return !t.isText && t.type.spec.selectable !== !1;
  }
}
Oe.prototype.visible = !1;
Ue.jsonID("node", Oe);
class xd {
  constructor(t) {
    this.anchor = t;
  }
  map(t) {
    let { deleted: n, pos: r } = t.mapResult(this.anchor);
    return n ? new us(r, r) : new xd(r);
  }
  resolve(t) {
    let n = t.resolve(this.anchor), r = n.nodeAfter;
    return r && Oe.isSelectable(r) ? new Oe(n) : Ue.near(n);
  }
}
class Ut extends Ue {
  /**
  Create an all-selection over the given document.
  */
  constructor(t) {
    super(t.resolve(0), t.resolve(t.content.size));
  }
  replace(t, n = Ee.empty) {
    if (n == Ee.empty) {
      t.delete(0, t.doc.content.size);
      let r = Ue.atStart(t.doc);
      r.eq(t.selection) || t.setSelection(r);
    } else
      super.replace(t, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(t) {
    return new Ut(t);
  }
  map(t) {
    return new Ut(t);
  }
  eq(t) {
    return t instanceof Ut;
  }
  getBookmark() {
    return I1;
  }
}
Ue.jsonID("all", Ut);
const I1 = {
  map() {
    return this;
  },
  resolve(e) {
    return new Ut(e);
  }
};
function Kr(e, t, n, r, o, a = !1) {
  if (t.inlineContent)
    return Fe.create(e, n);
  for (let l = r - (o > 0 ? 0 : 1); o > 0 ? l < t.childCount : l >= 0; l += o) {
    let s = t.child(l);
    if (s.isAtom) {
      if (!a && Oe.isSelectable(s))
        return Oe.create(e, n - (o < 0 ? s.nodeSize : 0));
    } else {
      let i = Kr(e, s, n + o, o < 0 ? s.childCount : 0, o, a);
      if (i)
        return i;
    }
    n += s.nodeSize * o;
  }
  return null;
}
function qu(e, t, n) {
  let r = e.steps.length - 1;
  if (r < t)
    return;
  let o = e.steps[r];
  if (!(o instanceof ut || o instanceof vt))
    return;
  let a = e.mapping.maps[r], l;
  a.forEach((s, i, d, u) => {
    l == null && (l = u);
  }), e.setSelection(Ue.near(e.doc.resolve(l), n));
}
const Ku = 1, Oa = 2, Ju = 4;
class T1 extends kh {
  /**
  @internal
  */
  constructor(t) {
    super(t.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = t.selection, this.storedMarks = t.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(t) {
    if (t.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = t, this.curSelectionFor = this.steps.length, this.updated = (this.updated | Ku) & ~Oa, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & Ku) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(t) {
    return this.storedMarks = t, this.updated |= Oa, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(t) {
    return et.sameSet(this.storedMarks || this.selection.$from.marks(), t) || this.setStoredMarks(t), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(t) {
    return this.ensureMarks(t.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(t) {
    return this.ensureMarks(t.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Oa) > 0;
  }
  /**
  @internal
  */
  addStep(t, n) {
    super.addStep(t, n), this.updated = this.updated & ~Oa, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(t) {
    return this.time = t, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(t) {
    return this.selection.replace(this, t), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(t, n = !0) {
    let r = this.selection;
    return n && (t = t.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || et.none))), r.replaceWith(this, t), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(t, n, r) {
    let o = this.doc.type.schema;
    if (n == null)
      return t ? this.replaceSelectionWith(o.text(t), !0) : this.deleteSelection();
    {
      if (r == null && (r = n), !t)
        return this.deleteRange(n, r);
      let a = this.storedMarks;
      if (!a) {
        let l = this.doc.resolve(n);
        a = r == n ? l.marks() : l.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(n, r, o.text(t, a)), !this.selection.empty && this.selection.to == n + t.length && this.setSelection(Ue.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(t, n) {
    return this.meta[typeof t == "string" ? t : t.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(t) {
    return this.meta[typeof t == "string" ? t : t.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let t in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= Ju, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & Ju) > 0;
  }
}
function Zu(e, t) {
  return !t || !e ? e : e.bind(t);
}
class Oo {
  constructor(t, n, r) {
    this.name = t, this.init = Zu(n.init, r), this.apply = Zu(n.apply, r);
  }
}
const L1 = [
  new Oo("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Oo("selection", {
    init(e, t) {
      return e.selection || Ue.atStart(t.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Oo("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, t, n, r) {
      return r.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Oo("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, t) {
      return e.scrolledIntoView ? t + 1 : t;
    }
  })
];
class Rs {
  constructor(t, n) {
    this.schema = t, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = L1.slice(), n && n.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Oo(r.key, r.spec.state, r));
    });
  }
}
class Yr {
  /**
  @internal
  */
  constructor(t) {
    this.config = t;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(t) {
    return this.applyTransaction(t).state;
  }
  /**
  @internal
  */
  filterTransaction(t, n = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != n) {
        let o = this.config.plugins[r];
        if (o.spec.filterTransaction && !o.spec.filterTransaction.call(o, t, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(t) {
    if (!this.filterTransaction(t))
      return { state: this, transactions: [] };
    let n = [t], r = this.applyInner(t), o = null;
    for (; ; ) {
      let a = !1;
      for (let l = 0; l < this.config.plugins.length; l++) {
        let s = this.config.plugins[l];
        if (s.spec.appendTransaction) {
          let i = o ? o[l].n : 0, d = o ? o[l].state : this, u = i < n.length && s.spec.appendTransaction.call(s, i ? n.slice(i) : n, d, r);
          if (u && r.filterTransaction(u, l)) {
            if (u.setMeta("appendedTransaction", t), !o) {
              o = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                o.push(f < l ? { state: r, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), r = r.applyInner(u), a = !0;
          }
          o && (o[l] = { state: r, n: n.length });
        }
      }
      if (!a)
        return { state: r, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(t) {
    if (!t.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new Yr(this.config), r = this.config.fields;
    for (let o = 0; o < r.length; o++) {
      let a = r[o];
      n[a.name] = a.apply(t, this[a.name], this, n);
    }
    return n;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new T1(this);
  }
  /**
  Create a new state.
  */
  static create(t) {
    let n = new Rs(t.doc ? t.doc.type.schema : t.schema, t.plugins), r = new Yr(n);
    for (let o = 0; o < n.fields.length; o++)
      r[n.fields[o].name] = n.fields[o].init(t, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(t) {
    let n = new Rs(this.schema, t.plugins), r = n.fields, o = new Yr(n);
    for (let a = 0; a < r.length; a++) {
      let l = r[a].name;
      o[l] = this.hasOwnProperty(l) ? this[l] : r[a].init(t, o);
    }
    return o;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(t) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((r) => r.toJSON())), t && typeof t == "object")
      for (let r in t) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let o = t[r], a = o.spec.state;
        a && a.toJSON && (n[r] = a.toJSON.call(o, this[o.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(t, n, r) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!t.schema)
      throw new RangeError("Required config field 'schema' missing");
    let o = new Rs(t.schema, t.plugins), a = new Yr(o);
    return o.fields.forEach((l) => {
      if (l.name == "doc")
        a.doc = tr.fromJSON(t.schema, n.doc);
      else if (l.name == "selection")
        a.selection = Ue.fromJSON(a.doc, n.selection);
      else if (l.name == "storedMarks")
        n.storedMarks && (a.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
      else {
        if (r)
          for (let s in r) {
            let i = r[s], d = i.spec.state;
            if (i.key == l.name && d && d.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              a[l.name] = d.fromJSON.call(i, t, n[s], a);
              return;
            }
          }
        a[l.name] = l.init(t, a);
      }
    }), a;
  }
}
function wh(e, t, n) {
  for (let r in e) {
    let o = e[r];
    o instanceof Function ? o = o.bind(t) : r == "handleDOMEvents" && (o = wh(o, t, {})), n[r] = o;
  }
  return n;
}
class lt {
  /**
  Create a plugin.
  */
  constructor(t) {
    this.spec = t, this.props = {}, t.props && wh(t.props, this, this.props), this.key = t.key ? t.key.key : Ch("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const Bs = /* @__PURE__ */ Object.create(null);
function Ch(e) {
  return e in Bs ? e + "$" + ++Bs[e] : (Bs[e] = 0, e + "$");
}
class gt {
  /**
  Create a plugin key.
  */
  constructor(t = "key") {
    this.key = Ch(t);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(t) {
    return t.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(t) {
    return t[this.key];
  }
}
const Sh = (e, t) => e.selection.empty ? !1 : (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function $h(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
const Ih = (e, t, n) => {
  let r = $h(e, n);
  if (!r)
    return !1;
  let o = yd(r);
  if (!o) {
    let l = r.blockRange(), s = l && xo(l);
    return s == null ? !1 : (t && t(e.tr.lift(l, s).scrollIntoView()), !0);
  }
  let a = o.nodeBefore;
  if (Oh(e, o, t, -1))
    return !0;
  if (r.parent.content.size == 0 && (co(a, "end") || Oe.isSelectable(a)))
    for (let l = r.depth; ; l--) {
      let s = ds(e.doc, r.before(l), r.after(l), Ee.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (t) {
          let i = e.tr.step(s);
          i.setSelection(co(a, "end") ? Ue.findFrom(i.doc.resolve(i.mapping.map(o.pos, -1)), -1) : Oe.create(i.doc, o.pos - a.nodeSize)), t(i.scrollIntoView());
        }
        return !0;
      }
      if (l == 1 || r.node(l - 1).childCount > 1)
        break;
    }
  return a.isAtom && o.depth == r.depth - 1 ? (t && t(e.tr.delete(o.pos - a.nodeSize, o.pos).scrollIntoView()), !0) : !1;
}, M1 = (e, t, n) => {
  let r = $h(e, n);
  if (!r)
    return !1;
  let o = yd(r);
  return o ? Th(e, o, t) : !1;
}, E1 = (e, t, n) => {
  let r = Mh(e, n);
  if (!r)
    return !1;
  let o = kd(r);
  return o ? Th(e, o, t) : !1;
};
function Th(e, t, n) {
  let r = t.nodeBefore, o = r, a = t.pos - 1;
  for (; !o.isTextblock; a--) {
    if (o.type.spec.isolating)
      return !1;
    let u = o.lastChild;
    if (!u)
      return !1;
    o = u;
  }
  let l = t.nodeAfter, s = l, i = t.pos + 1;
  for (; !s.isTextblock; i++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let d = ds(e.doc, a, i, Ee.empty);
  if (!d || d.from != a || d instanceof ut && d.slice.size >= i - a)
    return !1;
  if (n) {
    let u = e.tr.step(d);
    u.setSelection(Fe.create(u.doc, a)), n(u.scrollIntoView());
  }
  return !0;
}
function co(e, t, n = !1) {
  for (let r = e; r; r = t == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (n && r.childCount != 1)
      return !1;
  }
  return !1;
}
const Lh = (e, t, n) => {
  let { $head: r, empty: o } = e.selection, a = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0)
      return !1;
    a = yd(r);
  }
  let l = a && a.nodeBefore;
  return !l || !Oe.isSelectable(l) ? !1 : (t && t(e.tr.setSelection(Oe.create(e.doc, a.pos - l.nodeSize)).scrollIntoView()), !0);
};
function yd(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      if (e.index(t) > 0)
        return e.doc.resolve(e.before(t + 1));
      if (e.node(t).type.spec.isolating)
        break;
    }
  return null;
}
function Mh(e, t) {
  let { $cursor: n } = e.selection;
  return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
const Eh = (e, t, n) => {
  let r = Mh(e, n);
  if (!r)
    return !1;
  let o = kd(r);
  if (!o)
    return !1;
  let a = o.nodeAfter;
  if (Oh(e, o, t, 1))
    return !0;
  if (r.parent.content.size == 0 && (co(a, "start") || Oe.isSelectable(a))) {
    let l = ds(e.doc, r.before(), r.after(), Ee.empty);
    if (l && l.slice.size < l.to - l.from) {
      if (t) {
        let s = e.tr.step(l);
        s.setSelection(co(a, "start") ? Ue.findFrom(s.doc.resolve(s.mapping.map(o.pos)), 1) : Oe.create(s.doc, s.mapping.map(o.pos))), t(s.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && o.depth == r.depth - 1 ? (t && t(e.tr.delete(o.pos, o.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, Ah = (e, t, n) => {
  let { $head: r, empty: o } = e.selection, a = r;
  if (!o)
    return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size)
      return !1;
    a = kd(r);
  }
  let l = a && a.nodeAfter;
  return !l || !Oe.isSelectable(l) ? !1 : (t && t(e.tr.setSelection(Oe.create(e.doc, a.pos)).scrollIntoView()), !0);
};
function kd(e) {
  if (!e.parent.type.spec.isolating)
    for (let t = e.depth - 1; t >= 0; t--) {
      let n = e.node(t);
      if (e.index(t) + 1 < n.childCount)
        return e.doc.resolve(e.after(t + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const A1 = (e, t) => {
  let n = e.selection, r = n instanceof Oe, o;
  if (r) {
    if (n.node.isTextblock || !fr(e.doc, n.from))
      return !1;
    o = n.from;
  } else if (o = is(e.doc, n.from, -1), o == null)
    return !1;
  if (t) {
    let a = e.tr.join(o);
    r && a.setSelection(Oe.create(a.doc, o - e.doc.resolve(o).nodeBefore.nodeSize)), t(a.scrollIntoView());
  }
  return !0;
}, D1 = (e, t) => {
  let n = e.selection, r;
  if (n instanceof Oe) {
    if (n.node.isTextblock || !fr(e.doc, n.to))
      return !1;
    r = n.to;
  } else if (r = is(e.doc, n.to, 1), r == null)
    return !1;
  return t && t(e.tr.join(r).scrollIntoView()), !0;
}, R1 = (e, t) => {
  let { $from: n, $to: r } = e.selection, o = n.blockRange(r), a = o && xo(o);
  return a == null ? !1 : (t && t(e.tr.lift(o, a).scrollIntoView()), !0);
}, Dh = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (t && t(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function wd(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const B1 = (e, t) => {
  let { $head: n, $anchor: r } = e.selection;
  if (!n.parent.type.spec.code || !n.sameParent(r))
    return !1;
  let o = n.node(-1), a = n.indexAfter(-1), l = wd(o.contentMatchAt(a));
  if (!l || !o.canReplaceWith(a, a, l))
    return !1;
  if (t) {
    let s = n.after(), i = e.tr.replaceWith(s, s, l.createAndFill());
    i.setSelection(Ue.near(i.doc.resolve(s), 1)), t(i.scrollIntoView());
  }
  return !0;
}, Rh = (e, t) => {
  let n = e.selection, { $from: r, $to: o } = n;
  if (n instanceof Ut || r.parent.inlineContent || o.parent.inlineContent)
    return !1;
  let a = wd(o.parent.contentMatchAt(o.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (t) {
    let l = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos, s = e.tr.insert(l, a.createAndFill());
    s.setSelection(Fe.create(s.doc, l + 1)), t(s.scrollIntoView());
  }
  return !0;
}, Bh = (e, t) => {
  let { $cursor: n } = e.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let a = n.before();
    if (On(e.doc, a))
      return t && t(e.tr.split(a).scrollIntoView()), !0;
  }
  let r = n.blockRange(), o = r && xo(r);
  return o == null ? !1 : (t && t(e.tr.lift(r, o).scrollIntoView()), !0);
};
function O1(e) {
  return (t, n) => {
    let { $from: r, $to: o } = t.selection;
    if (t.selection instanceof Oe && t.selection.node.isBlock)
      return !r.parentOffset || !On(t.doc, r.pos) ? !1 : (n && n(t.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let a = [], l, s, i = !1, d = !1;
    for (let b = r.depth; ; b--)
      if (r.node(b).isBlock) {
        i = r.end(b) == r.pos + (r.depth - b), d = r.start(b) == r.pos - (r.depth - b), s = wd(r.node(b - 1).contentMatchAt(r.indexAfter(b - 1))), a.unshift(i && s ? { type: s } : null), l = b;
        break;
      } else {
        if (b == 1)
          return !1;
        a.unshift(null);
      }
    let u = t.tr;
    (t.selection instanceof Fe || t.selection instanceof Ut) && u.deleteSelection();
    let f = u.mapping.map(r.pos), h = On(u.doc, f, a.length, a);
    if (h || (a[0] = s ? { type: s } : null, h = On(u.doc, f, a.length, a)), !h)
      return !1;
    if (u.split(f, a.length, a), !i && d && r.node(l).type != s) {
      let b = u.mapping.map(r.before(l)), m = u.doc.resolve(b);
      s && r.node(l - 1).canReplaceWith(m.index(), m.index() + 1, s) && u.setNodeMarkup(u.mapping.map(r.before(l)), s);
    }
    return n && n(u.scrollIntoView()), !0;
  };
}
const P1 = O1(), z1 = (e, t) => {
  let { $from: n, to: r } = e.selection, o, a = n.sharedDepth(r);
  return a == 0 ? !1 : (o = n.before(a), t && t(e.tr.setSelection(Oe.create(e.doc, o))), !0);
};
function N1(e, t, n) {
  let r = t.nodeBefore, o = t.nodeAfter, a = t.index();
  return !r || !o || !r.type.compatibleContent(o.type) ? !1 : !r.content.size && t.parent.canReplace(a - 1, a) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(a, a + 1) || !(o.isTextblock || fr(e.doc, t.pos)) ? !1 : (n && n(e.tr.join(t.pos).scrollIntoView()), !0);
}
function Oh(e, t, n, r) {
  let o = t.nodeBefore, a = t.nodeAfter, l, s, i = o.type.spec.isolating || a.type.spec.isolating;
  if (!i && N1(e, t, n))
    return !0;
  let d = !i && t.parent.canReplace(t.index(), t.index() + 1);
  if (d && (l = (s = o.contentMatchAt(o.childCount)).findWrapping(a.type)) && s.matchType(l[0] || a.type).validEnd) {
    if (n) {
      let b = t.pos + a.nodeSize, m = Ce.empty;
      for (let k = l.length - 1; k >= 0; k--)
        m = Ce.from(l[k].create(null, m));
      m = Ce.from(o.copy(m));
      let v = e.tr.step(new vt(t.pos - 1, b, t.pos, b, new Ee(m, 1, 0), l.length, !0)), x = v.doc.resolve(b + 2 * l.length);
      x.nodeAfter && x.nodeAfter.type == o.type && fr(v.doc, x.pos) && v.join(x.pos), n(v.scrollIntoView());
    }
    return !0;
  }
  let u = a.type.spec.isolating || r > 0 && i ? null : Ue.findFrom(t, 1), f = u && u.$from.blockRange(u.$to), h = f && xo(f);
  if (h != null && h >= t.depth)
    return n && n(e.tr.lift(f, h).scrollIntoView()), !0;
  if (d && co(a, "start", !0) && co(o, "end")) {
    let b = o, m = [];
    for (; m.push(b), !b.isTextblock; )
      b = b.lastChild;
    let v = a, x = 1;
    for (; !v.isTextblock; v = v.firstChild)
      x++;
    if (b.canReplace(b.childCount, b.childCount, v.content)) {
      if (n) {
        let k = Ce.empty;
        for (let P = m.length - 1; P >= 0; P--)
          k = Ce.from(m[P].copy(k));
        let L = e.tr.step(new vt(t.pos - m.length, t.pos + a.nodeSize, t.pos + x, t.pos + a.nodeSize - x, new Ee(k, m.length, 0), 0, !0));
        n(L.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Ph(e) {
  return function(t, n) {
    let r = t.selection, o = e < 0 ? r.$from : r.$to, a = o.depth;
    for (; o.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return o.node(a).isTextblock ? (n && n(t.tr.setSelection(Fe.create(t.doc, e < 0 ? o.start(a) : o.end(a)))), !0) : !1;
  };
}
const V1 = Ph(-1), F1 = Ph(1);
function H1(e, t = null) {
  return function(n, r) {
    let { $from: o, $to: a } = n.selection, l = o.blockRange(a), s = l && vd(l, e, t);
    return s ? (r && r(n.tr.wrap(l, s).scrollIntoView()), !0) : !1;
  };
}
function Yu(e, t = null) {
  return function(n, r) {
    let o = !1;
    for (let a = 0; a < n.selection.ranges.length && !o; a++) {
      let { $from: { pos: l }, $to: { pos: s } } = n.selection.ranges[a];
      n.doc.nodesBetween(l, s, (i, d) => {
        if (o)
          return !1;
        if (!(!i.isTextblock || i.hasMarkup(e, t)))
          if (i.type == e)
            o = !0;
          else {
            let u = n.doc.resolve(d), f = u.index();
            o = u.parent.canReplaceWith(f, f + 1, e);
          }
      });
    }
    if (!o)
      return !1;
    if (r) {
      let a = n.tr;
      for (let l = 0; l < n.selection.ranges.length; l++) {
        let { $from: { pos: s }, $to: { pos: i } } = n.selection.ranges[l];
        a.setBlockType(s, i, e, t);
      }
      r(a.scrollIntoView());
    }
    return !0;
  };
}
function Cd(...e) {
  return function(t, n, r) {
    for (let o = 0; o < e.length; o++)
      if (e[o](t, n, r))
        return !0;
    return !1;
  };
}
Cd(Sh, Ih, Lh);
Cd(Sh, Eh, Ah);
Cd(Dh, Rh, Bh, P1);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function W1(e, t = null) {
  return function(n, r) {
    let { $from: o, $to: a } = n.selection, l = o.blockRange(a);
    if (!l)
      return !1;
    let s = r ? n.tr : null;
    return j1(s, l, e, t) ? (r && r(s.scrollIntoView()), !0) : !1;
  };
}
function j1(e, t, n, r = null) {
  let o = !1, a = t, l = t.$from.doc;
  if (t.depth >= 2 && t.$from.node(t.depth - 1).type.compatibleContent(n) && t.startIndex == 0) {
    if (t.$from.index(t.depth - 1) == 0)
      return !1;
    let i = l.resolve(t.start - 2);
    a = new vl(i, i, t.depth), t.endIndex < t.parent.childCount && (t = new vl(t.$from, l.resolve(t.$to.end(t.depth)), t.depth)), o = !0;
  }
  let s = vd(a, n, r, t);
  return s ? (e && U1(e, t, s, o, n), !0) : !1;
}
function U1(e, t, n, r, o) {
  let a = Ce.empty;
  for (let u = n.length - 1; u >= 0; u--)
    a = Ce.from(n[u].type.create(n[u].attrs, a));
  e.step(new vt(t.start - (r ? 2 : 0), t.end, t.start, t.end, new Ee(a, 0, 0), n.length, !0));
  let l = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == o && (l = u + 1);
  let s = n.length - l, i = t.start + n.length - (r ? 2 : 0), d = t.parent;
  for (let u = t.startIndex, f = t.endIndex, h = !0; u < f; u++, h = !1)
    !h && On(e.doc, i, s) && (e.split(i, s), i += 2 * s), i += d.child(u).nodeSize;
  return e;
}
function G1(e) {
  return function(t, n) {
    let { $from: r, $to: o } = t.selection, a = r.blockRange(o, (l) => l.childCount > 0 && l.firstChild.type == e);
    return a ? n ? r.node(a.depth - 1).type == e ? q1(t, n, e, a) : K1(t, n, a) : !0 : !1;
  };
}
function q1(e, t, n, r) {
  let o = e.tr, a = r.end, l = r.$to.end(r.depth);
  a < l && (o.step(new vt(a - 1, l, a, l, new Ee(Ce.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new vl(o.doc.resolve(r.$from.pos), o.doc.resolve(l), r.depth));
  const s = xo(r);
  if (s == null)
    return !1;
  o.lift(r, s);
  let i = o.doc.resolve(o.mapping.map(a, -1) - 1);
  return fr(o.doc, i.pos) && i.nodeBefore.type == i.nodeAfter.type && o.join(i.pos), t(o.scrollIntoView()), !0;
}
function K1(e, t, n) {
  let r = e.tr, o = n.parent;
  for (let b = n.end, m = n.endIndex - 1, v = n.startIndex; m > v; m--)
    b -= o.child(m).nodeSize, r.delete(b - 1, b + 1);
  let a = r.doc.resolve(n.start), l = a.nodeAfter;
  if (r.mapping.map(n.end) != n.start + a.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, i = n.endIndex == o.childCount, d = a.node(-1), u = a.index(-1);
  if (!d.canReplace(u + (s ? 0 : 1), u + 1, l.content.append(i ? Ce.empty : Ce.from(o))))
    return !1;
  let f = a.pos, h = f + l.nodeSize;
  return r.step(new vt(f - (s ? 1 : 0), h + (i ? 1 : 0), f + 1, h - 1, new Ee((s ? Ce.empty : Ce.from(o.copy(Ce.empty))).append(i ? Ce.empty : Ce.from(o.copy(Ce.empty))), s ? 0 : 1, i ? 0 : 1), s ? 0 : 1)), t(r.scrollIntoView()), !0;
}
function J1(e) {
  return function(t, n) {
    let { $from: r, $to: o } = t.selection, a = r.blockRange(o, (d) => d.childCount > 0 && d.firstChild.type == e);
    if (!a)
      return !1;
    let l = a.startIndex;
    if (l == 0)
      return !1;
    let s = a.parent, i = s.child(l - 1);
    if (i.type != e)
      return !1;
    if (n) {
      let d = i.lastChild && i.lastChild.type == s.type, u = Ce.from(d ? e.create() : null), f = new Ee(Ce.from(e.create(null, Ce.from(s.type.create(null, u)))), d ? 3 : 1, 0), h = a.start, b = a.end;
      n(t.tr.step(new vt(h - (d ? 3 : 1), b, h, b, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const wt = function(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}, fo = function(e) {
  let t = e.assignedSlot || e.parentNode;
  return t && t.nodeType == 11 ? t.host : t;
};
let Ci = null;
const Dn = function(e, t, n) {
  let r = Ci || (Ci = document.createRange());
  return r.setEnd(e, n ?? e.nodeValue.length), r.setStart(e, t || 0), r;
}, Z1 = function() {
  Ci = null;
}, Pr = function(e, t, n, r) {
  return n && (Xu(e, t, n, r, -1) || Xu(e, t, n, r, 1));
}, Y1 = /^(img|br|input|textarea|hr)$/i;
function Xu(e, t, n, r, o) {
  for (var a; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (o < 0 ? 0 : Yt(e))) {
      let l = e.parentNode;
      if (!l || l.nodeType != 1 || Ca(e) || Y1.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      t = wt(e) + (o < 0 ? 0 : 1), e = l;
    } else if (e.nodeType == 1) {
      let l = e.childNodes[t + (o < 0 ? -1 : 0)];
      if (l.nodeType == 1 && l.contentEditable == "false")
        if (!((a = l.pmViewDesc) === null || a === void 0) && a.ignoreForSelection)
          t += o;
        else
          return !1;
      else
        e = l, t = o < 0 ? Yt(e) : 0;
    } else
      return !1;
  }
}
function Yt(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function X1(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t)
      return e;
    if (e.nodeType == 1 && t > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t - 1], t = Yt(e);
    } else if (e.parentNode && !Ca(e))
      t = wt(e), e = e.parentNode;
    else
      return null;
  }
}
function Q1(e, t) {
  for (; ; ) {
    if (e.nodeType == 3 && t < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && t < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[t], t = 0;
    } else if (e.parentNode && !Ca(e))
      t = wt(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function _1(e, t, n) {
  for (let r = t == 0, o = t == Yt(e); r || o; ) {
    if (e == n)
      return !0;
    let a = wt(e);
    if (e = e.parentNode, !e)
      return !1;
    r = r && a == 0, o = o && a == Yt(e);
  }
}
function Ca(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode)
    ;
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const cs = function(e) {
  return e.focusNode && Pr(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function mr(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function ew(e) {
  let t = e.activeElement;
  for (; t && t.shadowRoot; )
    t = t.shadowRoot.activeElement;
  return t;
}
function tw(e, t, n) {
  if (e.caretPositionFromPoint)
    try {
      let r = e.caretPositionFromPoint(t, n);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Yt(r.offsetNode), r.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let r = e.caretRangeFromPoint(t, n);
    if (r)
      return { node: r.startContainer, offset: Math.min(Yt(r.startContainer), r.startOffset) };
  }
}
const Sn = typeof navigator < "u" ? navigator : null, Qu = typeof document < "u" ? document : null, hr = Sn && Sn.userAgent || "", Si = /Edge\/(\d+)/.exec(hr), zh = /MSIE \d/.exec(hr), $i = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(hr), Ft = !!(zh || $i || Si), rr = zh ? document.documentMode : $i ? +$i[1] : Si ? +Si[1] : 0, _t = !Ft && /gecko\/(\d+)/i.test(hr);
_t && +(/Firefox\/(\d+)/.exec(hr) || [0, 0])[1];
const Ii = !Ft && /Chrome\/(\d+)/.exec(hr), St = !!Ii, Nh = Ii ? +Ii[1] : 0, Lt = !Ft && !!Sn && /Apple Computer/.test(Sn.vendor), ho = Lt && (/Mobile\/\w+/.test(hr) || !!Sn && Sn.maxTouchPoints > 2), Zt = ho || (Sn ? /Mac/.test(Sn.platform) : !1), Vh = Sn ? /Win/.test(Sn.platform) : !1, Bn = /Android \d/.test(hr), Sa = !!Qu && "webkitFontSmoothing" in Qu.documentElement.style, nw = Sa ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function rw(e) {
  let t = e.defaultView && e.defaultView.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function Tn(e, t) {
  return typeof e == "number" ? e : e[t];
}
function ow(e) {
  let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, r = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * r
  };
}
function _u(e, t, n) {
  let r = e.someProp("scrollThreshold") || 0, o = e.someProp("scrollMargin") || 5, a = e.dom.ownerDocument;
  for (let l = n || e.dom; l; ) {
    if (l.nodeType != 1) {
      l = fo(l);
      continue;
    }
    let s = l, i = s == a.body, d = i ? rw(a) : ow(s), u = 0, f = 0;
    if (t.top < d.top + Tn(r, "top") ? f = -(d.top - t.top + Tn(o, "top")) : t.bottom > d.bottom - Tn(r, "bottom") && (f = t.bottom - t.top > d.bottom - d.top ? t.top + Tn(o, "top") - d.top : t.bottom - d.bottom + Tn(o, "bottom")), t.left < d.left + Tn(r, "left") ? u = -(d.left - t.left + Tn(o, "left")) : t.right > d.right - Tn(r, "right") && (u = t.right - d.right + Tn(o, "right")), u || f)
      if (i)
        a.defaultView.scrollBy(u, f);
      else {
        let b = s.scrollLeft, m = s.scrollTop;
        f && (s.scrollTop += f), u && (s.scrollLeft += u);
        let v = s.scrollLeft - b, x = s.scrollTop - m;
        t = { left: t.left - v, top: t.top - x, right: t.right - v, bottom: t.bottom - x };
      }
    let h = i ? "fixed" : getComputedStyle(l).position;
    if (/^(fixed|sticky)$/.test(h))
      break;
    l = h == "absolute" ? l.offsetParent : fo(l);
  }
}
function aw(e) {
  let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), r, o;
  for (let a = (t.left + t.right) / 2, l = n + 1; l < Math.min(innerHeight, t.bottom); l += 5) {
    let s = e.root.elementFromPoint(a, l);
    if (!s || s == e.dom || !e.dom.contains(s))
      continue;
    let i = s.getBoundingClientRect();
    if (i.top >= n - 20) {
      r = s, o = i.top;
      break;
    }
  }
  return { refDOM: r, refTop: o, stack: Fh(e.dom) };
}
function Fh(e) {
  let t = [], n = e.ownerDocument;
  for (let r = e; r && (t.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), e != n); r = fo(r))
    ;
  return t;
}
function lw({ refDOM: e, refTop: t, stack: n }) {
  let r = e ? e.getBoundingClientRect().top : 0;
  Hh(n, r == 0 ? 0 : r - t);
}
function Hh(e, t) {
  for (let n = 0; n < e.length; n++) {
    let { dom: r, top: o, left: a } = e[n];
    r.scrollTop != o + t && (r.scrollTop = o + t), r.scrollLeft != a && (r.scrollLeft = a);
  }
}
let Wr = null;
function sw(e) {
  if (e.setActive)
    return e.setActive();
  if (Wr)
    return e.focus(Wr);
  let t = Fh(e);
  e.focus(Wr == null ? {
    get preventScroll() {
      return Wr = { preventScroll: !0 }, !0;
    }
  } : void 0), Wr || (Wr = !1, Hh(t, 0));
}
function Wh(e, t) {
  let n, r = 2e8, o, a = 0, l = t.top, s = t.top, i, d;
  for (let u = e.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let h;
    if (u.nodeType == 1)
      h = u.getClientRects();
    else if (u.nodeType == 3)
      h = Dn(u).getClientRects();
    else
      continue;
    for (let b = 0; b < h.length; b++) {
      let m = h[b];
      if (m.top <= l && m.bottom >= s) {
        l = Math.max(m.bottom, l), s = Math.min(m.top, s);
        let v = m.left > t.left ? m.left - t.left : m.right < t.left ? t.left - m.right : 0;
        if (v < r) {
          n = u, r = v, o = v && n.nodeType == 3 ? {
            left: m.right < t.left ? m.right : m.left,
            top: t.top
          } : t, u.nodeType == 1 && v && (a = f + (t.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else m.top > t.top && !i && m.left <= t.left && m.right >= t.left && (i = u, d = { left: Math.max(m.left, Math.min(m.right, t.left)), top: m.top });
      !n && (t.left >= m.right && t.top >= m.top || t.left >= m.left && t.top >= m.bottom) && (a = f + 1);
    }
  }
  return !n && i && (n = i, o = d, r = 0), n && n.nodeType == 3 ? iw(n, o) : !n || r && n.nodeType == 1 ? { node: e, offset: a } : Wh(n, o);
}
function iw(e, t) {
  let n = e.nodeValue.length, r = document.createRange(), o;
  for (let a = 0; a < n; a++) {
    r.setEnd(e, a + 1), r.setStart(e, a);
    let l = Un(r, 1);
    if (l.top != l.bottom && Sd(t, l)) {
      o = { node: e, offset: a + (t.left >= (l.left + l.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return r.detach(), o || { node: e, offset: 0 };
}
function Sd(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function dw(e, t) {
  let n = e.parentNode;
  return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function uw(e, t, n) {
  let { node: r, offset: o } = Wh(t, n), a = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let l = r.getBoundingClientRect();
    a = l.left != l.right && n.left > (l.left + l.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(r, o, a);
}
function cw(e, t, n, r) {
  let o = -1;
  for (let a = t, l = !1; a != e.dom; ) {
    let s = e.docView.nearestDesc(a, !0), i;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((i = s.dom.getBoundingClientRect()).width || i.height) && (s.node.isBlock && s.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(s.dom.nodeName) && (!l && i.left > r.left || i.top > r.top ? o = s.posBefore : (!l && i.right < r.left || i.bottom < r.top) && (o = s.posAfter), l = !0), !s.contentDOM && o < 0 && !s.node.isText))
      return (s.node.isBlock ? r.top < (i.top + i.bottom) / 2 : r.left < (i.left + i.right) / 2) ? s.posBefore : s.posAfter;
    a = s.dom.parentNode;
  }
  return o > -1 ? o : e.docView.posFromDOM(t, n, -1);
}
function jh(e, t, n) {
  let r = e.childNodes.length;
  if (r && n.top < n.bottom)
    for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), a = o; ; ) {
      let l = e.childNodes[a];
      if (l.nodeType == 1) {
        let s = l.getClientRects();
        for (let i = 0; i < s.length; i++) {
          let d = s[i];
          if (Sd(t, d))
            return jh(l, t, d);
        }
      }
      if ((a = (a + 1) % r) == o)
        break;
    }
  return e;
}
function fw(e, t) {
  let n = e.dom.ownerDocument, r, o = 0, a = tw(n, t.left, t.top);
  a && ({ node: r, offset: o } = a);
  let l = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), s;
  if (!l || !e.dom.contains(l.nodeType != 1 ? l.parentNode : l)) {
    let d = e.dom.getBoundingClientRect();
    if (!Sd(t, d) || (l = jh(e.dom, t, d), !l))
      return null;
  }
  if (Lt)
    for (let d = l; r && d; d = fo(d))
      d.draggable && (r = void 0);
  if (l = dw(l, t), r) {
    if (_t && r.nodeType == 1 && (o = Math.min(o, r.childNodes.length), o < r.childNodes.length)) {
      let u = r.childNodes[o], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= t.left && f.bottom > t.top && o++;
    }
    let d;
    Sa && o && r.nodeType == 1 && (d = r.childNodes[o - 1]).nodeType == 1 && d.contentEditable == "false" && d.getBoundingClientRect().top >= t.top && o--, r == e.dom && o == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && t.top > r.lastChild.getBoundingClientRect().bottom ? s = e.state.doc.content.size : (o == 0 || r.nodeType != 1 || r.childNodes[o - 1].nodeName != "BR") && (s = cw(e, r, o, t));
  }
  s == null && (s = uw(e, l, t));
  let i = e.docView.nearestDesc(l, !0);
  return { pos: s, inside: i ? i.posAtStart - i.border : -1 };
}
function ec(e) {
  return e.top < e.bottom || e.left < e.right;
}
function Un(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let r = n[t < 0 ? 0 : n.length - 1];
    if (ec(r))
      return r;
  }
  return Array.prototype.find.call(n, ec) || e.getBoundingClientRect();
}
const hw = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function Uh(e, t, n) {
  let { node: r, offset: o, atom: a } = e.docView.domFromPos(t, n < 0 ? -1 : 1), l = Sa || _t;
  if (r.nodeType == 3)
    if (l && (hw.test(r.nodeValue) || (n < 0 ? !o : o == r.nodeValue.length))) {
      let i = Un(Dn(r, o, o), n);
      if (_t && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let d = Un(Dn(r, o - 1, o - 1), -1);
        if (d.top == i.top) {
          let u = Un(Dn(r, o, o + 1), -1);
          if (u.top != i.top)
            return Co(u, u.left < d.left);
        }
      }
      return i;
    } else {
      let i = o, d = o, u = n < 0 ? 1 : -1;
      return n < 0 && !o ? (d++, u = -1) : n >= 0 && o == r.nodeValue.length ? (i--, u = 1) : n < 0 ? i-- : d++, Co(Un(Dn(r, i, d), u), u < 0);
    }
  if (!e.state.doc.resolve(t - (a || 0)).parent.inlineContent) {
    if (a == null && o && (n < 0 || o == Yt(r))) {
      let i = r.childNodes[o - 1];
      if (i.nodeType == 1)
        return Os(i.getBoundingClientRect(), !1);
    }
    if (a == null && o < Yt(r)) {
      let i = r.childNodes[o];
      if (i.nodeType == 1)
        return Os(i.getBoundingClientRect(), !0);
    }
    return Os(r.getBoundingClientRect(), n >= 0);
  }
  if (a == null && o && (n < 0 || o == Yt(r))) {
    let i = r.childNodes[o - 1], d = i.nodeType == 3 ? Dn(i, Yt(i) - (l ? 0 : 1)) : i.nodeType == 1 && (i.nodeName != "BR" || !i.nextSibling) ? i : null;
    if (d)
      return Co(Un(d, 1), !1);
  }
  if (a == null && o < Yt(r)) {
    let i = r.childNodes[o];
    for (; i.pmViewDesc && i.pmViewDesc.ignoreForCoords; )
      i = i.nextSibling;
    let d = i ? i.nodeType == 3 ? Dn(i, 0, l ? 0 : 1) : i.nodeType == 1 ? i : null : null;
    if (d)
      return Co(Un(d, -1), !0);
  }
  return Co(Un(r.nodeType == 3 ? Dn(r) : r, -n), n >= 0);
}
function Co(e, t) {
  if (e.width == 0)
    return e;
  let n = t ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: n, right: n };
}
function Os(e, t) {
  if (e.height == 0)
    return e;
  let n = t ? e.top : e.bottom;
  return { top: n, bottom: n, left: e.left, right: e.right };
}
function Gh(e, t, n) {
  let r = e.state, o = e.root.activeElement;
  r != t && e.updateState(t), o != e.dom && e.focus();
  try {
    return n();
  } finally {
    r != t && e.updateState(r), o != e.dom && o && o.focus();
  }
}
function bw(e, t, n) {
  let r = t.selection, o = n == "up" ? r.$from : r.$to;
  return Gh(e, t, () => {
    let { node: a } = e.docView.domFromPos(o.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = e.docView.nearestDesc(a, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        a = s.contentDOM || s.dom;
        break;
      }
      a = s.dom.parentNode;
    }
    let l = Uh(e, o.pos, 1);
    for (let s = a.firstChild; s; s = s.nextSibling) {
      let i;
      if (s.nodeType == 1)
        i = s.getClientRects();
      else if (s.nodeType == 3)
        i = Dn(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let d = 0; d < i.length; d++) {
        let u = i[d];
        if (u.bottom > u.top + 1 && (n == "up" ? l.top - u.top > (u.bottom - l.top) * 2 : u.bottom - l.bottom > (l.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const pw = /[\u0590-\u08ac]/;
function gw(e, t, n) {
  let { $head: r } = t.selection;
  if (!r.parent.isTextblock)
    return !1;
  let o = r.parentOffset, a = !o, l = o == r.parent.content.size, s = e.domSelection();
  return s ? !pw.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? a : l : Gh(e, t, () => {
    let { focusNode: i, focusOffset: d, anchorNode: u, anchorOffset: f } = e.domSelectionRange(), h = s.caretBidiLevel;
    s.modify("move", n, "character");
    let b = r.depth ? e.docView.domAfterPos(r.before()) : e.dom, { focusNode: m, focusOffset: v } = e.domSelectionRange(), x = m && !b.contains(m.nodeType == 1 ? m : m.parentNode) || i == m && d == v;
    try {
      s.collapse(u, f), i && (i != u || d != f) && s.extend && s.extend(i, d);
    } catch {
    }
    return h != null && (s.caretBidiLevel = h), x;
  }) : r.pos == r.start() || r.pos == r.end();
}
let tc = null, nc = null, rc = !1;
function mw(e, t, n) {
  return tc == t && nc == n ? rc : (tc = t, nc = n, rc = n == "up" || n == "down" ? bw(e, t, n) : gw(e, t, n));
}
const en = 0, oc = 1, xr = 2, $n = 3;
class $a {
  constructor(t, n, r, o) {
    this.parent = t, this.children = n, this.dom = r, this.contentDOM = o, this.dirty = en, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(t) {
    return !1;
  }
  matchesMark(t) {
    return !1;
  }
  matchesNode(t, n, r) {
    return !1;
  }
  matchesHack(t) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(t) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let t = 0;
    for (let n = 0; n < this.children.length; n++)
      t += this.children[n].size;
    return t;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let t = 0; t < this.children.length; t++)
      this.children[t].destroy();
  }
  posBeforeChild(t) {
    for (let n = 0, r = this.posAtStart; ; n++) {
      let o = this.children[n];
      if (o == t)
        return r;
      r += o.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(t, n, r) {
    if (this.contentDOM && this.contentDOM.contains(t.nodeType == 1 ? t : t.parentNode))
      if (r < 0) {
        let a, l;
        if (t == this.contentDOM)
          a = t.childNodes[n - 1];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          a = t.previousSibling;
        }
        for (; a && !((l = a.pmViewDesc) && l.parent == this); )
          a = a.previousSibling;
        return a ? this.posBeforeChild(l) + l.size : this.posAtStart;
      } else {
        let a, l;
        if (t == this.contentDOM)
          a = t.childNodes[n];
        else {
          for (; t.parentNode != this.contentDOM; )
            t = t.parentNode;
          a = t.nextSibling;
        }
        for (; a && !((l = a.pmViewDesc) && l.parent == this); )
          a = a.nextSibling;
        return a ? this.posBeforeChild(l) : this.posAtEnd;
      }
    let o;
    if (t == this.dom && this.contentDOM)
      o = n > wt(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      o = t.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let a = t; ; a = a.parentNode) {
          if (a == this.dom) {
            o = !1;
            break;
          }
          if (a.previousSibling)
            break;
        }
      if (o == null && n == t.childNodes.length)
        for (let a = t; ; a = a.parentNode) {
          if (a == this.dom) {
            o = !0;
            break;
          }
          if (a.nextSibling)
            break;
        }
    }
    return o ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(t, n = !1) {
    for (let r = !0, o = t; o; o = o.parentNode) {
      let a = this.getDesc(o), l;
      if (a && (!n || a.node))
        if (r && (l = a.nodeDOM) && !(l.nodeType == 1 ? l.contains(t.nodeType == 1 ? t : t.parentNode) : l == t))
          r = !1;
        else
          return a;
    }
  }
  getDesc(t) {
    let n = t.pmViewDesc;
    for (let r = n; r; r = r.parent)
      if (r == this)
        return n;
  }
  posFromDOM(t, n, r) {
    for (let o = t; o; o = o.parentNode) {
      let a = this.getDesc(o);
      if (a)
        return a.localPosFromDOM(t, n, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(t) {
    for (let n = 0, r = 0; n < this.children.length; n++) {
      let o = this.children[n], a = r + o.size;
      if (r == t && a != r) {
        for (; !o.border && o.children.length; )
          for (let l = 0; l < o.children.length; l++) {
            let s = o.children[l];
            if (s.size) {
              o = s;
              break;
            }
          }
        return o;
      }
      if (t < a)
        return o.descAt(t - r - o.border);
      r = a;
    }
  }
  domFromPos(t, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: t + 1 };
    let r = 0, o = 0;
    for (let a = 0; r < this.children.length; r++) {
      let l = this.children[r], s = a + l.size;
      if (s > t || l instanceof Kh) {
        o = t - a;
        break;
      }
      a = s;
    }
    if (o)
      return this.children[r].domFromPos(o - this.children[r].border, n);
    for (let a; r && !(a = this.children[r - 1]).size && a instanceof qh && a.side >= 0; r--)
      ;
    if (n <= 0) {
      let a, l = !0;
      for (; a = r ? this.children[r - 1] : null, !(!a || a.dom.parentNode == this.contentDOM); r--, l = !1)
        ;
      return a && n && l && !a.border && !a.domAtom ? a.domFromPos(a.size, n) : { node: this.contentDOM, offset: a ? wt(a.dom) + 1 : 0 };
    } else {
      let a, l = !0;
      for (; a = r < this.children.length ? this.children[r] : null, !(!a || a.dom.parentNode == this.contentDOM); r++, l = !1)
        ;
      return a && l && !a.border && !a.domAtom ? a.domFromPos(0, n) : { node: this.contentDOM, offset: a ? wt(a.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(t, n, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: t, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let o = -1, a = -1;
    for (let l = r, s = 0; ; s++) {
      let i = this.children[s], d = l + i.size;
      if (o == -1 && t <= d) {
        let u = l + i.border;
        if (t >= u && n <= d - i.border && i.node && i.contentDOM && this.contentDOM.contains(i.contentDOM))
          return i.parseRange(t, n, u);
        t = l;
        for (let f = s; f > 0; f--) {
          let h = this.children[f - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            o = wt(h.dom) + 1;
            break;
          }
          t -= h.size;
        }
        o == -1 && (o = 0);
      }
      if (o > -1 && (d > n || s == this.children.length - 1)) {
        n = d;
        for (let u = s + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            a = wt(f.dom);
            break;
          }
          n += f.size;
        }
        a == -1 && (a = this.contentDOM.childNodes.length);
        break;
      }
      l = d;
    }
    return { node: this.contentDOM, from: t, to: n, fromOffset: o, toOffset: a };
  }
  emptyChildAt(t) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[t < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(t);
  }
  domAfterPos(t) {
    let { node: n, offset: r } = this.domFromPos(t, 0);
    if (n.nodeType != 1 || r == n.childNodes.length)
      throw new RangeError("No node after pos " + t);
    return n.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(t, n, r, o = !1) {
    let a = Math.min(t, n), l = Math.max(t, n);
    for (let b = 0, m = 0; b < this.children.length; b++) {
      let v = this.children[b], x = m + v.size;
      if (a > m && l < x)
        return v.setSelection(t - m - v.border, n - m - v.border, r, o);
      m = x;
    }
    let s = this.domFromPos(t, t ? -1 : 1), i = n == t ? s : this.domFromPos(n, n ? -1 : 1), d = r.root.getSelection(), u = r.domSelectionRange(), f = !1;
    if ((_t || Lt) && t == n) {
      let { node: b, offset: m } = s;
      if (b.nodeType == 3) {
        if (f = !!(m && b.nodeValue[m - 1] == `
`), f && m == b.nodeValue.length)
          for (let v = b, x; v; v = v.parentNode) {
            if (x = v.nextSibling) {
              x.nodeName == "BR" && (s = i = { node: x.parentNode, offset: wt(x) + 1 });
              break;
            }
            let k = v.pmViewDesc;
            if (k && k.node && k.node.isBlock)
              break;
          }
      } else {
        let v = b.childNodes[m - 1];
        f = v && (v.nodeName == "BR" || v.contentEditable == "false");
      }
    }
    if (_t && u.focusNode && u.focusNode != i.node && u.focusNode.nodeType == 1) {
      let b = u.focusNode.childNodes[u.focusOffset];
      b && b.contentEditable == "false" && (o = !0);
    }
    if (!(o || f && Lt) && Pr(s.node, s.offset, u.anchorNode, u.anchorOffset) && Pr(i.node, i.offset, u.focusNode, u.focusOffset))
      return;
    let h = !1;
    if ((d.extend || t == n) && !(f && _t)) {
      d.collapse(s.node, s.offset);
      try {
        t != n && d.extend(i.node, i.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (t > n) {
        let m = s;
        s = i, i = m;
      }
      let b = document.createRange();
      b.setEnd(i.node, i.offset), b.setStart(s.node, s.offset), d.removeAllRanges(), d.addRange(b);
    }
  }
  ignoreMutation(t) {
    return !this.contentDOM && t.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(t, n) {
    for (let r = 0, o = 0; o < this.children.length; o++) {
      let a = this.children[o], l = r + a.size;
      if (r == l ? t <= l && n >= r : t < l && n > r) {
        let s = r + a.border, i = l - a.border;
        if (t >= s && n <= i) {
          this.dirty = t == r || n == l ? xr : oc, t == s && n == i && (a.contentLost || a.dom.parentNode != this.contentDOM) ? a.dirty = $n : a.markDirty(t - s, n - s);
          return;
        } else
          a.dirty = a.dom == a.contentDOM && a.dom.parentNode == this.contentDOM && !a.children.length ? xr : $n;
      }
      r = l;
    }
    this.dirty = xr;
  }
  markParentsDirty() {
    let t = 1;
    for (let n = this.parent; n; n = n.parent, t++) {
      let r = t == 1 ? xr : oc;
      n.dirty < r && (n.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(t) {
    return !1;
  }
}
class qh extends $a {
  constructor(t, n, r, o) {
    let a, l = n.type.toDOM;
    if (typeof l == "function" && (l = l(r, () => {
      if (!a)
        return o;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    })), !n.type.spec.raw) {
      if (l.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(l), l = s;
      }
      l.contentEditable = "false", l.classList.add("ProseMirror-widget");
    }
    super(t, [], l, null), this.widget = n, this.widget = n, a = this;
  }
  matchesWidget(t) {
    return this.dirty == en && t.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(t) {
    let n = this.widget.spec.stopEvent;
    return n ? n(t) : !1;
  }
  ignoreMutation(t) {
    return t.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class vw extends $a {
  constructor(t, n, r, o) {
    super(t, [], n, null), this.textDOM = r, this.text = o;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(t, n) {
    return t != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(t) {
    return { node: this.textDOM, offset: t };
  }
  ignoreMutation(t) {
    return t.type === "characterData" && t.target.nodeValue == t.oldValue;
  }
}
class zr extends $a {
  constructor(t, n, r, o, a) {
    super(t, [], r, o), this.mark = n, this.spec = a;
  }
  static create(t, n, r, o) {
    let a = o.nodeViews[n.type.name], l = a && a(n, o, r);
    return (!l || !l.dom) && (l = Vr.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new zr(t, n, l.dom, l.contentDOM || l.dom, l);
  }
  parseRule() {
    return this.dirty & $n || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(t) {
    return this.dirty != $n && this.mark.eq(t);
  }
  markDirty(t, n) {
    if (super.markDirty(t, n), this.dirty != en) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = en;
    }
  }
  slice(t, n, r) {
    let o = zr.create(this.parent, this.mark, !0, r), a = this.children, l = this.size;
    n < l && (a = Li(a, n, l, r)), t > 0 && (a = Li(a, 0, t, r));
    for (let s = 0; s < a.length; s++)
      a[s].parent = o;
    return o.children = a, o;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class or extends $a {
  constructor(t, n, r, o, a, l, s, i, d) {
    super(t, [], a, l), this.node = n, this.outerDeco = r, this.innerDeco = o, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(t, n, r, o, a, l) {
    let s = a.nodeViews[n.type.name], i, d = s && s(n, a, () => {
      if (!i)
        return l;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    }, r, o), u = d && d.dom, f = d && d.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = Vr.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !f && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = Yh(u, r, n), d ? i = new xw(t, n, r, o, u, f || null, h, d, a, l + 1) : n.isText ? new fs(t, n, r, o, u, h, a) : new or(t, n, r, o, u, f || null, h, a, l + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let t = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (t.preserveWhitespace = "full"), !this.contentDOM)
      t.getContent = () => this.node.content;
    else if (!this.contentLost)
      t.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let r = this.children[n];
        if (this.dom.contains(r.dom.parentNode)) {
          t.contentElement = r.dom.parentNode;
          break;
        }
      }
      t.contentElement || (t.getContent = () => Ce.empty);
    }
    return t;
  }
  matchesNode(t, n, r) {
    return this.dirty == en && t.eq(this.node) && yl(n, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(t, n) {
    let r = this.node.inlineContent, o = n, a = t.composing ? this.localCompositionInfo(t, n) : null, l = a && a.pos > -1 ? a : null, s = a && a.pos < 0, i = new kw(this, l && l.node, t);
    Sw(this.node, this.innerDeco, (d, u, f) => {
      d.spec.marks ? i.syncToMarks(d.spec.marks, r, t, u) : d.type.side >= 0 && !f && i.syncToMarks(u == this.node.childCount ? et.none : this.node.child(u).marks, r, t, u), i.placeWidget(d, t, o);
    }, (d, u, f, h) => {
      i.syncToMarks(d.marks, r, t, h);
      let b;
      i.findNodeMatch(d, u, f, h) || s && t.state.selection.from > o && t.state.selection.to < o + d.nodeSize && (b = i.findIndexWithChild(a.node)) > -1 && i.updateNodeAt(d, u, f, b, t) || i.updateNextNode(d, u, f, t, h, o) || i.addNode(d, u, f, t, o), o += d.nodeSize;
    }), i.syncToMarks([], r, t, 0), this.node.isTextblock && i.addTextblockHacks(), i.destroyRest(), (i.changed || this.dirty == xr) && (l && this.protectLocalComposition(t, l), Jh(this.contentDOM, this.children, t), ho && $w(this.dom));
  }
  localCompositionInfo(t, n) {
    let { from: r, to: o } = t.state.selection;
    if (!(t.state.selection instanceof Fe) || r < n || o > n + this.node.content.size)
      return null;
    let a = t.input.compositionNode;
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let l = a.nodeValue, s = Iw(this.node.content, l, r - n, o - n);
      return s < 0 ? null : { node: a, pos: s, text: l };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(t, { node: n, pos: r, text: o }) {
    if (this.getDesc(n))
      return;
    let a = n;
    for (; a.parentNode != this.contentDOM; a = a.parentNode) {
      for (; a.previousSibling; )
        a.parentNode.removeChild(a.previousSibling);
      for (; a.nextSibling; )
        a.parentNode.removeChild(a.nextSibling);
      a.pmViewDesc && (a.pmViewDesc = void 0);
    }
    let l = new vw(this, a, n, o);
    t.input.compositionNodes.push(l), this.children = Li(this.children, r, r + o.length, t, l);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(t, n, r, o) {
    return this.dirty == $n || !t.sameMarkup(this.node) ? !1 : (this.updateInner(t, n, r, o), !0);
  }
  updateInner(t, n, r, o) {
    this.updateOuterDeco(n), this.node = t, this.innerDeco = r, this.contentDOM && this.updateChildren(o, this.posAtStart), this.dirty = en;
  }
  updateOuterDeco(t) {
    if (yl(t, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = Zh(this.dom, this.nodeDOM, Ti(this.outerDeco, this.node, n), Ti(t, this.node, n)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = t;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function ac(e, t, n, r, o) {
  Yh(r, t, e);
  let a = new or(void 0, e, t, n, r, r, r, o, 0);
  return a.contentDOM && a.updateChildren(o, 0), a;
}
class fs extends or {
  constructor(t, n, r, o, a, l, s) {
    super(t, n, r, o, a, null, l, s, 0);
  }
  parseRule() {
    let t = this.nodeDOM.parentNode;
    for (; t && t != this.dom && !t.pmIsDeco; )
      t = t.parentNode;
    return { skip: t || !0 };
  }
  update(t, n, r, o) {
    return this.dirty == $n || this.dirty != en && !this.inParent() || !t.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != en || t.text != this.node.text) && t.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = t.text, o.trackWrites == this.nodeDOM && (o.trackWrites = null)), this.node = t, this.dirty = en, !0);
  }
  inParent() {
    let t = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == t)
        return !0;
    return !1;
  }
  domFromPos(t) {
    return { node: this.nodeDOM, offset: t };
  }
  localPosFromDOM(t, n, r) {
    return t == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(t, n, r);
  }
  ignoreMutation(t) {
    return t.type != "characterData" && t.type != "selection";
  }
  slice(t, n, r) {
    let o = this.node.cut(t, n), a = document.createTextNode(o.text);
    return new fs(this.parent, o, this.outerDeco, this.innerDeco, a, a, r);
  }
  markDirty(t, n) {
    super.markDirty(t, n), this.dom != this.nodeDOM && (t == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = $n);
  }
  get domAtom() {
    return !1;
  }
  isText(t) {
    return this.node.text == t;
  }
}
class Kh extends $a {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(t) {
    return this.dirty == en && this.dom.nodeName == t;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class xw extends or {
  constructor(t, n, r, o, a, l, s, i, d, u) {
    super(t, n, r, o, a, l, s, d, u), this.spec = i;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(t, n, r, o) {
    if (this.dirty == $n)
      return !1;
    if (this.spec.update && (this.node.type == t.type || this.spec.multiType)) {
      let a = this.spec.update(t, n, r);
      return a && this.updateInner(t, n, r, o), a;
    } else return !this.contentDOM && !t.isLeaf ? !1 : super.update(t, n, r, o);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(t, n, r, o) {
    this.spec.setSelection ? this.spec.setSelection(t, n, r.root) : super.setSelection(t, n, r, o);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(t) {
    return this.spec.stopEvent ? this.spec.stopEvent(t) : !1;
  }
  ignoreMutation(t) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(t) : super.ignoreMutation(t);
  }
}
function Jh(e, t, n) {
  let r = e.firstChild, o = !1;
  for (let a = 0; a < t.length; a++) {
    let l = t[a], s = l.dom;
    if (s.parentNode == e) {
      for (; s != r; )
        r = lc(r), o = !0;
      r = r.nextSibling;
    } else
      o = !0, e.insertBefore(s, r);
    if (l instanceof zr) {
      let i = r ? r.previousSibling : e.lastChild;
      Jh(l.contentDOM, l.children, n), r = i ? i.nextSibling : e.firstChild;
    }
  }
  for (; r; )
    r = lc(r), o = !0;
  o && n.trackWrites == e && (n.trackWrites = null);
}
const jo = function(e) {
  e && (this.nodeName = e);
};
jo.prototype = /* @__PURE__ */ Object.create(null);
const yr = [new jo()];
function Ti(e, t, n) {
  if (e.length == 0)
    return yr;
  let r = n ? yr[0] : new jo(), o = [r];
  for (let a = 0; a < e.length; a++) {
    let l = e[a].type.attrs;
    if (l) {
      l.nodeName && o.push(r = new jo(l.nodeName));
      for (let s in l) {
        let i = l[s];
        i != null && (n && o.length == 1 && o.push(r = new jo(t.isInline ? "span" : "div")), s == "class" ? r.class = (r.class ? r.class + " " : "") + i : s == "style" ? r.style = (r.style ? r.style + ";" : "") + i : s != "nodeName" && (r[s] = i));
      }
    }
  }
  return o;
}
function Zh(e, t, n, r) {
  if (n == yr && r == yr)
    return t;
  let o = t;
  for (let a = 0; a < r.length; a++) {
    let l = r[a], s = n[a];
    if (a) {
      let i;
      s && s.nodeName == l.nodeName && o != e && (i = o.parentNode) && i.nodeName.toLowerCase() == l.nodeName || (i = document.createElement(l.nodeName), i.pmIsDeco = !0, i.appendChild(o), s = yr[0]), o = i;
    }
    yw(o, s || yr[0], l);
  }
  return o;
}
function yw(e, t, n) {
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && !(r in n) && e.removeAttribute(r);
  for (let r in n)
    r != "class" && r != "style" && r != "nodeName" && n[r] != t[r] && e.setAttribute(r, n[r]);
  if (t.class != n.class) {
    let r = t.class ? t.class.split(" ").filter(Boolean) : [], o = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let a = 0; a < r.length; a++)
      o.indexOf(r[a]) == -1 && e.classList.remove(r[a]);
    for (let a = 0; a < o.length; a++)
      r.indexOf(o[a]) == -1 && e.classList.add(o[a]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, o;
      for (; o = r.exec(t.style); )
        e.style.removeProperty(o[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function Yh(e, t, n) {
  return Zh(e, e, yr, Ti(t, n, e.nodeType != 1));
}
function yl(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].type.eq(t[n].type))
      return !1;
  return !0;
}
function lc(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class kw {
  constructor(t, n, r) {
    this.lock = n, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = t, this.preMatch = ww(t.node.content, t);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(t, n) {
    if (t != n) {
      for (let r = t; r < n; r++)
        this.top.children[r].destroy();
      this.top.children.splice(t, n - t), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(t, n, r, o) {
    let a = 0, l = this.stack.length >> 1, s = Math.min(l, t.length);
    for (; a < s && (a == l - 1 ? this.top : this.stack[a + 1 << 1]).matchesMark(t[a]) && t[a].type.spec.spanning !== !1; )
      a++;
    for (; a < l; )
      this.destroyRest(), this.top.dirty = en, this.index = this.stack.pop(), this.top = this.stack.pop(), l--;
    for (; l < t.length; ) {
      this.stack.push(this.top, this.index + 1);
      let i = -1, d = this.top.children.length;
      o < this.preMatch.index && (d = Math.min(this.index + 3, d));
      for (let u = this.index; u < d; u++) {
        let f = this.top.children[u];
        if (f.matchesMark(t[l]) && !this.isLocked(f.dom)) {
          i = u;
          break;
        }
      }
      if (i > -1)
        i > this.index && (this.changed = !0, this.destroyBetween(this.index, i)), this.top = this.top.children[this.index];
      else {
        let u = zr.create(this.top, t[l], n, r);
        this.top.children.splice(this.index, 0, u), this.top = u, this.changed = !0;
      }
      this.index = 0, l++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(t, n, r, o) {
    let a = -1, l;
    if (o >= this.preMatch.index && (l = this.preMatch.matches[o - this.preMatch.index]).parent == this.top && l.matchesNode(t, n, r))
      a = this.top.children.indexOf(l, this.index);
    else
      for (let s = this.index, i = Math.min(this.top.children.length, s + 5); s < i; s++) {
        let d = this.top.children[s];
        if (d.matchesNode(t, n, r) && !this.preMatch.matched.has(d)) {
          a = s;
          break;
        }
      }
    return a < 0 ? !1 : (this.destroyBetween(this.index, a), this.index++, !0);
  }
  updateNodeAt(t, n, r, o, a) {
    let l = this.top.children[o];
    return l.dirty == $n && l.dom == l.contentDOM && (l.dirty = xr), l.update(t, n, r, a) ? (this.destroyBetween(this.index, o), this.index++, !0) : !1;
  }
  findIndexWithChild(t) {
    for (; ; ) {
      let n = t.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let r = t.pmViewDesc;
        if (r) {
          for (let o = this.index; o < this.top.children.length; o++)
            if (this.top.children[o] == r)
              return o;
        }
        return -1;
      }
      t = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(t, n, r, o, a, l) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let i = this.top.children[s];
      if (i instanceof or) {
        let d = this.preMatch.matched.get(i);
        if (d != null && d != a)
          return !1;
        let u = i.dom, f, h = this.isLocked(u) && !(t.isText && i.node && i.node.isText && i.nodeDOM.nodeValue == t.text && i.dirty != $n && yl(n, i.outerDeco));
        if (!h && i.update(t, n, r, o))
          return this.destroyBetween(this.index, s), i.dom != u && (this.changed = !0), this.index++, !0;
        if (!h && (f = this.recreateWrapper(i, t, n, r, o, l)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = f, f.contentDOM && (f.dirty = xr, f.updateChildren(o, l + 1), f.dirty = en), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(t, n, r, o, a, l) {
    if (t.dirty || n.isAtom || !t.children.length || !t.node.content.eq(n.content) || !yl(r, t.outerDeco) || !o.eq(t.innerDeco))
      return null;
    let s = or.create(this.top, n, r, o, a, l);
    if (s.contentDOM) {
      s.children = t.children, t.children = [];
      for (let i of s.children)
        i.parent = s;
    }
    return t.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(t, n, r, o, a) {
    let l = or.create(this.top, t, n, r, o, a);
    l.contentDOM && l.updateChildren(o, a + 1), this.top.children.splice(this.index++, 0, l), this.changed = !0;
  }
  placeWidget(t, n, r) {
    let o = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (o && o.matchesWidget(t) && (t == o.widget || !o.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let a = new qh(this.top, t, n, r);
      this.top.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let t = this.top.children[this.index - 1], n = this.top;
    for (; t instanceof zr; )
      n = t, t = n.children[n.children.length - 1];
    (!t || // Empty textblock
    !(t instanceof fs) || /\n$/.test(t.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(t.node.text)) && ((Lt || St) && t && t.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(t, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(t))
      this.index++;
    else {
      let r = document.createElement(t);
      t == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), t == "BR" && (r.className = "ProseMirror-trailingBreak");
      let o = new Kh(this.top, [], r, null);
      n != this.top ? n.children.push(o) : n.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  isLocked(t) {
    return this.lock && (t == this.lock || t.nodeType == 1 && t.contains(this.lock.parentNode));
  }
}
function ww(e, t) {
  let n = t, r = n.children.length, o = e.childCount, a = /* @__PURE__ */ new Map(), l = [];
  e: for (; o > 0; ) {
    let s;
    for (; ; )
      if (r) {
        let d = n.children[r - 1];
        if (d instanceof zr)
          n = d, r = d.children.length;
        else {
          s = d, r--;
          break;
        }
      } else {
        if (n == t)
          break e;
        r = n.parent.children.indexOf(n), n = n.parent;
      }
    let i = s.node;
    if (i) {
      if (i != e.child(o - 1))
        break;
      --o, a.set(s, o), l.push(s);
    }
  }
  return { index: o, matched: a, matches: l.reverse() };
}
function Cw(e, t) {
  return e.type.side - t.type.side;
}
function Sw(e, t, n, r) {
  let o = t.locals(e), a = 0;
  if (o.length == 0) {
    for (let d = 0; d < e.childCount; d++) {
      let u = e.child(d);
      r(u, o, t.forChild(a, u), d), a += u.nodeSize;
    }
    return;
  }
  let l = 0, s = [], i = null;
  for (let d = 0; ; ) {
    let u, f;
    for (; l < o.length && o[l].to == a; ) {
      let x = o[l++];
      x.widget && (u ? (f || (f = [u])).push(x) : u = x);
    }
    if (u)
      if (f) {
        f.sort(Cw);
        for (let x = 0; x < f.length; x++)
          n(f[x], d, !!i);
      } else
        n(u, d, !!i);
    let h, b;
    if (i)
      b = -1, h = i, i = null;
    else if (d < e.childCount)
      b = d, h = e.child(d++);
    else
      break;
    for (let x = 0; x < s.length; x++)
      s[x].to <= a && s.splice(x--, 1);
    for (; l < o.length && o[l].from <= a && o[l].to > a; )
      s.push(o[l++]);
    let m = a + h.nodeSize;
    if (h.isText) {
      let x = m;
      l < o.length && o[l].from < x && (x = o[l].from);
      for (let k = 0; k < s.length; k++)
        s[k].to < x && (x = s[k].to);
      x < m && (i = h.cut(x - a), h = h.cut(0, x - a), m = x, b = -1);
    } else
      for (; l < o.length && o[l].to < m; )
        l++;
    let v = h.isInline && !h.isLeaf ? s.filter((x) => !x.inline) : s.slice();
    r(h, v, t.forChild(a, h), b), a = m;
  }
}
function $w(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let t = e.style.cssText;
    e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
  }
}
function Iw(e, t, n, r) {
  for (let o = 0, a = 0; o < e.childCount && a <= r; ) {
    let l = e.child(o++), s = a;
    if (a += l.nodeSize, !l.isText)
      continue;
    let i = l.text;
    for (; o < e.childCount; ) {
      let d = e.child(o++);
      if (a += d.nodeSize, !d.isText)
        break;
      i += d.text;
    }
    if (a >= n) {
      if (a >= r && i.slice(r - t.length - s, r - s) == t)
        return r - t.length;
      let d = s < r ? i.lastIndexOf(t, r - s - 1) : -1;
      if (d >= 0 && d + t.length + s >= n)
        return s + d;
      if (n == r && i.length >= r + t.length - s && i.slice(r - s, r - s + t.length) == t)
        return r;
    }
  }
  return -1;
}
function Li(e, t, n, r, o) {
  let a = [];
  for (let l = 0, s = 0; l < e.length; l++) {
    let i = e[l], d = s, u = s += i.size;
    d >= n || u <= t ? a.push(i) : (d < t && a.push(i.slice(0, t - d, r)), o && (a.push(o), o = void 0), u > n && a.push(i.slice(n - d, i.size, r)));
  }
  return a;
}
function $d(e, t = null) {
  let n = e.domSelectionRange(), r = e.state.doc;
  if (!n.focusNode)
    return null;
  let o = e.docView.nearestDesc(n.focusNode), a = o && o.size == 0, l = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (l < 0)
    return null;
  let s = r.resolve(l), i, d;
  if (cs(n)) {
    for (i = l; o && !o.node; )
      o = o.parent;
    let f = o.node;
    if (o && f.isAtom && Oe.isSelectable(f) && o.parent && !(f.isInline && _1(n.focusNode, n.focusOffset, o.dom))) {
      let h = o.posBefore;
      d = new Oe(l == h ? s : r.resolve(h));
    }
  } else {
    if (n instanceof e.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let f = l, h = l;
      for (let b = 0; b < n.rangeCount; b++) {
        let m = n.getRangeAt(b);
        f = Math.min(f, e.docView.posFromDOM(m.startContainer, m.startOffset, 1)), h = Math.max(h, e.docView.posFromDOM(m.endContainer, m.endOffset, -1));
      }
      if (f < 0)
        return null;
      [i, l] = h == e.state.selection.anchor ? [h, f] : [f, h], s = r.resolve(l);
    } else
      i = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (i < 0)
      return null;
  }
  let u = r.resolve(i);
  if (!d) {
    let f = t == "pointer" || e.state.selection.head < s.pos && !a ? 1 : -1;
    d = Id(e, u, s, f);
  }
  return d;
}
function Xh(e) {
  return e.editable ? e.hasFocus() : _h(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function Pn(e, t = !1) {
  let n = e.state.selection;
  if (Qh(e, n), !!Xh(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && St) {
      let r = e.domSelectionRange(), o = e.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && Pr(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      Lw(e);
    else {
      let { anchor: r, head: o } = n, a, l;
      sc && !(n instanceof Fe) && (n.$from.parent.inlineContent || (a = ic(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (l = ic(e, n.to))), e.docView.setSelection(r, o, e, t), sc && (a && dc(a), l && dc(l)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Tw(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const sc = Lt || St && Nh < 63;
function ic(e, t) {
  let { node: n, offset: r } = e.docView.domFromPos(t, 0), o = r < n.childNodes.length ? n.childNodes[r] : null, a = r ? n.childNodes[r - 1] : null;
  if (Lt && o && o.contentEditable == "false")
    return Ps(o);
  if ((!o || o.contentEditable == "false") && (!a || a.contentEditable == "false")) {
    if (o)
      return Ps(o);
    if (a)
      return Ps(a);
  }
}
function Ps(e) {
  return e.contentEditable = "true", Lt && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function dc(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function Tw(e) {
  let t = e.dom.ownerDocument;
  t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let n = e.domSelectionRange(), r = n.anchorNode, o = n.anchorOffset;
  t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (n.anchorNode != r || n.anchorOffset != o) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!Xh(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function Lw(e) {
  let t = e.domSelection();
  if (!t)
    return;
  let n = e.cursorWrapper.dom, r = n.nodeName == "IMG";
  r ? t.collapse(n.parentNode, wt(n) + 1) : t.collapse(n, 0), !r && !e.state.selection.visible && Ft && rr <= 11 && (n.disabled = !0, n.disabled = !1);
}
function Qh(e, t) {
  if (t instanceof Oe) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (uc(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else
    uc(e);
}
function uc(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function Id(e, t, n, r) {
  return e.someProp("createSelectionBetween", (o) => o(e, t, n)) || Fe.between(t, n, r);
}
function cc(e) {
  return e.editable && !e.hasFocus() ? !1 : _h(e);
}
function _h(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode)
    return !1;
  try {
    return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
  } catch {
    return !1;
  }
}
function Mw(e) {
  let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
  return Pr(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function Mi(e, t) {
  let { $anchor: n, $head: r } = e.selection, o = t > 0 ? n.max(r) : n.min(r), a = o.parent.inlineContent ? o.depth ? e.doc.resolve(t > 0 ? o.after() : o.before()) : null : o;
  return a && Ue.findFrom(a, t);
}
function Gn(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function fc(e, t, n) {
  let r = e.state.selection;
  if (r instanceof Fe)
    if (n.indexOf("s") > -1) {
      let { $head: o } = r, a = o.textOffset ? null : t < 0 ? o.nodeBefore : o.nodeAfter;
      if (!a || a.isText || !a.isLeaf)
        return !1;
      let l = e.state.doc.resolve(o.pos + a.nodeSize * (t < 0 ? -1 : 1));
      return Gn(e, new Fe(r.$anchor, l));
    } else if (r.empty) {
      if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
        let o = Mi(e.state, t);
        return o && o instanceof Oe ? Gn(e, o) : !1;
      } else if (!(Zt && n.indexOf("m") > -1)) {
        let o = r.$head, a = o.textOffset ? null : t < 0 ? o.nodeBefore : o.nodeAfter, l;
        if (!a || a.isText)
          return !1;
        let s = t < 0 ? o.pos - a.nodeSize : o.pos;
        return a.isAtom || (l = e.docView.descAt(s)) && !l.contentDOM ? Oe.isSelectable(a) ? Gn(e, new Oe(t < 0 ? e.state.doc.resolve(o.pos - a.nodeSize) : o)) : Sa ? Gn(e, new Fe(e.state.doc.resolve(t < 0 ? s : s + a.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof Oe && r.node.isInline)
      return Gn(e, new Fe(t > 0 ? r.$to : r.$from));
    {
      let o = Mi(e.state, t);
      return o ? Gn(e, o) : !1;
    }
  }
}
function kl(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Uo(e, t) {
  let n = e.pmViewDesc;
  return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function jr(e, t) {
  return t < 0 ? Ew(e) : Aw(e);
}
function Ew(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let o, a, l = !1;
  for (_t && n.nodeType == 1 && r < kl(n) && Uo(n.childNodes[r], -1) && (l = !0); ; )
    if (r > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[r - 1];
        if (Uo(s, -1))
          o = n, a = --r;
        else if (s.nodeType == 3)
          n = s, r = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (eb(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && Uo(s, -1); )
          o = n.parentNode, a = wt(s), s = s.previousSibling;
        if (s)
          n = s, r = kl(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = 0;
        }
      }
    }
  l ? Ei(e, n, r) : o && Ei(e, o, a);
}
function Aw(e) {
  let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
  if (!n)
    return;
  let o = kl(n), a, l;
  for (; ; )
    if (r < o) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[r];
      if (Uo(s, 1))
        a = n, l = ++r;
      else
        break;
    } else {
      if (eb(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && Uo(s, 1); )
          a = s.parentNode, l = wt(s) + 1, s = s.nextSibling;
        if (s)
          n = s, r = 0, o = kl(n);
        else {
          if (n = n.parentNode, n == e.dom)
            break;
          r = o = 0;
        }
      }
    }
  a && Ei(e, a, l);
}
function eb(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function Dw(e, t) {
  for (; e && t == e.childNodes.length && !Ca(e); )
    t = wt(e) + 1, e = e.parentNode;
  for (; e && t < e.childNodes.length; ) {
    let n = e.childNodes[t];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = 0;
  }
}
function Rw(e, t) {
  for (; e && !t && !Ca(e); )
    t = wt(e), e = e.parentNode;
  for (; e && t; ) {
    let n = e.childNodes[t - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    e = n, t = e.childNodes.length;
  }
}
function Ei(e, t, n) {
  if (t.nodeType != 3) {
    let a, l;
    (l = Dw(t, n)) ? (t = l, n = 0) : (a = Rw(t, n)) && (t = a, n = a.nodeValue.length);
  }
  let r = e.domSelection();
  if (!r)
    return;
  if (cs(r)) {
    let a = document.createRange();
    a.setEnd(t, n), a.setStart(t, n), r.removeAllRanges(), r.addRange(a);
  } else r.extend && r.extend(t, n);
  e.domObserver.setCurSelection();
  let { state: o } = e;
  setTimeout(() => {
    e.state == o && Pn(e);
  }, 50);
}
function hc(e, t) {
  let n = e.state.doc.resolve(t);
  if (!(St || Vh) && n.parent.inlineContent) {
    let o = e.coordsAtPos(t);
    if (t > n.start()) {
      let a = e.coordsAtPos(t - 1), l = (a.top + a.bottom) / 2;
      if (l > o.top && l < o.bottom && Math.abs(a.left - o.left) > 1)
        return a.left < o.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let a = e.coordsAtPos(t + 1), l = (a.top + a.bottom) / 2;
      if (l > o.top && l < o.bottom && Math.abs(a.left - o.left) > 1)
        return a.left > o.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function bc(e, t, n) {
  let r = e.state.selection;
  if (r instanceof Fe && !r.empty || n.indexOf("s") > -1 || Zt && n.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: a } = r;
  if (!o.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let l = Mi(e.state, t);
    if (l && l instanceof Oe)
      return Gn(e, l);
  }
  if (!o.parent.inlineContent) {
    let l = t < 0 ? o : a, s = r instanceof Ut ? Ue.near(l, t) : Ue.findFrom(l, t);
    return s ? Gn(e, s) : !1;
  }
  return !1;
}
function pc(e, t) {
  if (!(e.state.selection instanceof Fe))
    return !0;
  let { $head: n, $anchor: r, empty: o } = e.state.selection;
  if (!n.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward"))
    return !0;
  let a = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (a && !a.isText) {
    let l = e.state.tr;
    return t < 0 ? l.delete(n.pos - a.nodeSize, n.pos) : l.delete(n.pos, n.pos + a.nodeSize), e.dispatch(l), !0;
  }
  return !1;
}
function gc(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function Bw(e) {
  if (!Lt || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
    let r = t.firstChild;
    gc(e, r, "true"), setTimeout(() => gc(e, r, "false"), 20);
  }
  return !1;
}
function Ow(e) {
  let t = "";
  return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function Pw(e, t) {
  let n = t.keyCode, r = Ow(t);
  if (n == 8 || Zt && n == 72 && r == "c")
    return pc(e, -1) || jr(e, -1);
  if (n == 46 && !t.shiftKey || Zt && n == 68 && r == "c")
    return pc(e, 1) || jr(e, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || Zt && n == 66 && r == "c") {
    let o = n == 37 ? hc(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return fc(e, o, r) || jr(e, o);
  } else if (n == 39 || Zt && n == 70 && r == "c") {
    let o = n == 39 ? hc(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return fc(e, o, r) || jr(e, o);
  } else {
    if (n == 38 || Zt && n == 80 && r == "c")
      return bc(e, -1, r) || jr(e, -1);
    if (n == 40 || Zt && n == 78 && r == "c")
      return Bw(e) || bc(e, 1, r) || jr(e, 1);
    if (r == (Zt ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function Td(e, t) {
  e.someProp("transformCopied", (b) => {
    t = b(t, e);
  });
  let n = [], { content: r, openStart: o, openEnd: a } = t;
  for (; o > 1 && a > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, a--;
    let b = r.firstChild;
    n.push(b.type.name, b.attrs != b.type.defaultAttrs ? b.attrs : null), r = b.content;
  }
  let l = e.someProp("clipboardSerializer") || Vr.fromSchema(e.state.schema), s = lb(), i = s.createElement("div");
  i.appendChild(l.serializeFragment(r, { document: s }));
  let d = i.firstChild, u, f = 0;
  for (; d && d.nodeType == 1 && (u = ab[d.nodeName.toLowerCase()]); ) {
    for (let b = u.length - 1; b >= 0; b--) {
      let m = s.createElement(u[b]);
      for (; i.firstChild; )
        m.appendChild(i.firstChild);
      i.appendChild(m), f++;
    }
    d = i.firstChild;
  }
  d && d.nodeType == 1 && d.setAttribute("data-pm-slice", `${o} ${a}${f ? ` -${f}` : ""} ${JSON.stringify(n)}`);
  let h = e.someProp("clipboardTextSerializer", (b) => b(t, e)) || t.content.textBetween(0, t.content.size, `

`);
  return { dom: i, text: h, slice: t };
}
function tb(e, t, n, r, o) {
  let a = o.parent.type.spec.code, l, s;
  if (!n && !t)
    return null;
  let i = !!t && (r || a || !n);
  if (i) {
    if (e.someProp("transformPastedText", (h) => {
      t = h(t, a || r, e);
    }), a)
      return s = new Ee(Ce.from(e.state.schema.text(t.replace(/\r\n?/g, `
`))), 0, 0), e.someProp("transformPasted", (h) => {
        s = h(s, e, !0);
      }), s;
    let f = e.someProp("clipboardTextParser", (h) => h(t, o, r, e));
    if (f)
      s = f;
    else {
      let h = o.marks(), { schema: b } = e.state, m = Vr.fromSchema(b);
      l = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((v) => {
        let x = l.appendChild(document.createElement("p"));
        v && x.appendChild(m.serializeNode(b.text(v, h)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (f) => {
      n = f(n, e);
    }), l = Fw(n), Sa && Hw(l);
  let d = l && l.querySelector("[data-pm-slice]"), u = d && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(d.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let h = l.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      l = h;
    }
  if (s || (s = (e.someProp("clipboardParser") || e.someProp("domParser") || nr.fromSchema(e.state.schema)).parseSlice(l, {
    preserveWhitespace: !!(i || u),
    context: o,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !zw.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = Ww(mc(s, +u[1], +u[2]), u[4]);
  else if (s = Ee.maxOpen(Nw(s.content, o), !0), s.openStart || s.openEnd) {
    let f = 0, h = 0;
    for (let b = s.content.firstChild; f < s.openStart && !b.type.spec.isolating; f++, b = b.firstChild)
      ;
    for (let b = s.content.lastChild; h < s.openEnd && !b.type.spec.isolating; h++, b = b.lastChild)
      ;
    s = mc(s, f, h);
  }
  return e.someProp("transformPasted", (f) => {
    s = f(s, e, i);
  }), s;
}
const zw = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function Nw(e, t) {
  if (e.childCount < 2)
    return e;
  for (let n = t.depth; n >= 0; n--) {
    let o = t.node(n).contentMatchAt(t.index(n)), a, l = [];
    if (e.forEach((s) => {
      if (!l)
        return;
      let i = o.findWrapping(s.type), d;
      if (!i)
        return l = null;
      if (d = l.length && a.length && rb(i, a, s, l[l.length - 1], 0))
        l[l.length - 1] = d;
      else {
        l.length && (l[l.length - 1] = ob(l[l.length - 1], a.length));
        let u = nb(s, i);
        l.push(u), o = o.matchType(u.type), a = i;
      }
    }), l)
      return Ce.from(l);
  }
  return e;
}
function nb(e, t, n = 0) {
  for (let r = t.length - 1; r >= n; r--)
    e = t[r].create(null, Ce.from(e));
  return e;
}
function rb(e, t, n, r, o) {
  if (o < e.length && o < t.length && e[o] == t[o]) {
    let a = rb(e, t, n, r.lastChild, o + 1);
    if (a)
      return r.copy(r.content.replaceChild(r.childCount - 1, a));
    if (r.contentMatchAt(r.childCount).matchType(o == e.length - 1 ? n.type : e[o + 1]))
      return r.copy(r.content.append(Ce.from(nb(n, e, o + 1))));
  }
}
function ob(e, t) {
  if (t == 0)
    return e;
  let n = e.content.replaceChild(e.childCount - 1, ob(e.lastChild, t - 1)), r = e.contentMatchAt(e.childCount).fillBefore(Ce.empty, !0);
  return e.copy(n.append(r));
}
function Ai(e, t, n, r, o, a) {
  let l = t < 0 ? e.firstChild : e.lastChild, s = l.content;
  return e.childCount > 1 && (a = 0), o < r - 1 && (s = Ai(s, t, n, r, o + 1, a)), o >= n && (s = t < 0 ? l.contentMatchAt(0).fillBefore(s, a <= o).append(s) : s.append(l.contentMatchAt(l.childCount).fillBefore(Ce.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, l.copy(s));
}
function mc(e, t, n) {
  return t < e.openStart && (e = new Ee(Ai(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new Ee(Ai(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const ab = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let vc = null;
function lb() {
  return vc || (vc = document.implementation.createHTMLDocument("title"));
}
let zs = null;
function Vw(e) {
  let t = window.trustedTypes;
  return t ? (zs || (zs = t.defaultPolicy || t.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), zs.createHTML(e)) : e;
}
function Fw(e) {
  let t = /^(\s*<meta [^>]*>)*/.exec(e);
  t && (e = e.slice(t[0].length));
  let n = lb().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(e), o;
  if ((o = r && ab[r[1].toLowerCase()]) && (e = o.map((a) => "<" + a + ">").join("") + e + o.map((a) => "</" + a + ">").reverse().join("")), n.innerHTML = Vw(e), o)
    for (let a = 0; a < o.length; a++)
      n = n.querySelector(o[a]) || n;
  return n;
}
function Hw(e) {
  let t = e.querySelectorAll(St ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
  }
}
function Ww(e, t) {
  if (!e.size)
    return e;
  let n = e.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(t);
  } catch {
    return e;
  }
  let { content: o, openStart: a, openEnd: l } = e;
  for (let s = r.length - 2; s >= 0; s -= 2) {
    let i = n.nodes[r[s]];
    if (!i || i.hasRequiredAttrs())
      break;
    o = Ce.from(i.create(r[s + 1], o)), a++, l++;
  }
  return new Ee(o, a, l);
}
const Ot = {}, Pt = {}, jw = { touchstart: !0, touchmove: !0 };
class Uw {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function Gw(e) {
  for (let t in Ot) {
    let n = Ot[t];
    e.dom.addEventListener(t, e.input.eventHandlers[t] = (r) => {
      Kw(e, r) && !Ld(e, r) && (e.editable || !(r.type in Pt)) && n(e, r);
    }, jw[t] ? { passive: !0 } : void 0);
  }
  Lt && e.dom.addEventListener("input", () => null), Di(e);
}
function Xn(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function qw(e) {
  e.domObserver.stop();
  for (let t in e.input.eventHandlers)
    e.dom.removeEventListener(t, e.input.eventHandlers[t]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function Di(e) {
  e.someProp("handleDOMEvents", (t) => {
    for (let n in t)
      e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (r) => Ld(e, r));
  });
}
function Ld(e, t) {
  return e.someProp("handleDOMEvents", (n) => {
    let r = n[t.type];
    return r ? r(e, t) || t.defaultPrevented : !1;
  });
}
function Kw(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t))
      return !1;
  return !0;
}
function Jw(e, t) {
  !Ld(e, t) && Ot[t.type] && (e.editable || !(t.type in Pt)) && Ot[t.type](e, t);
}
Pt.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !ib(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Bn && St && n.keyCode == 13)))
    if (n.keyCode != 229 && e.domObserver.forceFlush(), ho && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let r = Date.now();
      e.input.lastIOSEnter = r, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == r && (e.someProp("handleKeyDown", (o) => o(e, mr(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (r) => r(e, n)) || Pw(e, n) ? n.preventDefault() : Xn(e, "key");
};
Pt.keyup = (e, t) => {
  t.keyCode == 16 && (e.input.shiftKey = !1);
};
Pt.keypress = (e, t) => {
  let n = t;
  if (ib(e, n) || !n.charCode || n.ctrlKey && !n.altKey || Zt && n.metaKey)
    return;
  if (e.someProp("handleKeyPress", (o) => o(e, n))) {
    n.preventDefault();
    return;
  }
  let r = e.state.selection;
  if (!(r instanceof Fe) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(n.charCode), a = () => e.state.tr.insertText(o).scrollIntoView();
    !/[\r\n]/.test(o) && !e.someProp("handleTextInput", (l) => l(e, r.$from.pos, r.$to.pos, o, a)) && e.dispatch(a()), n.preventDefault();
  }
};
function hs(e) {
  return { left: e.clientX, top: e.clientY };
}
function Zw(e, t) {
  let n = t.x - e.clientX, r = t.y - e.clientY;
  return n * n + r * r < 100;
}
function Md(e, t, n, r, o) {
  if (r == -1)
    return !1;
  let a = e.state.doc.resolve(r);
  for (let l = a.depth + 1; l > 0; l--)
    if (e.someProp(t, (s) => l > a.depth ? s(e, n, a.nodeAfter, a.before(l), o, !0) : s(e, n, a.node(l), a.before(l), o, !1)))
      return !0;
  return !1;
}
function to(e, t, n) {
  if (e.focused || e.focus(), e.state.selection.eq(t))
    return;
  let r = e.state.tr.setSelection(t);
  r.setMeta("pointer", !0), e.dispatch(r);
}
function Yw(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.doc.resolve(t), r = n.nodeAfter;
  return r && r.isAtom && Oe.isSelectable(r) ? (to(e, new Oe(n)), !0) : !1;
}
function Xw(e, t) {
  if (t == -1)
    return !1;
  let n = e.state.selection, r, o;
  n instanceof Oe && (r = n.node);
  let a = e.state.doc.resolve(t);
  for (let l = a.depth + 1; l > 0; l--) {
    let s = l > a.depth ? a.nodeAfter : a.node(l);
    if (Oe.isSelectable(s)) {
      r && n.$from.depth > 0 && l >= n.$from.depth && a.before(n.$from.depth + 1) == n.$from.pos ? o = a.before(n.$from.depth) : o = a.before(l);
      break;
    }
  }
  return o != null ? (to(e, Oe.create(e.state.doc, o)), !0) : !1;
}
function Qw(e, t, n, r, o) {
  return Md(e, "handleClickOn", t, n, r) || e.someProp("handleClick", (a) => a(e, t, r)) || (o ? Xw(e, n) : Yw(e, n));
}
function _w(e, t, n, r) {
  return Md(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", (o) => o(e, t, r));
}
function e2(e, t, n, r) {
  return Md(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", (o) => o(e, t, r)) || t2(e, n, r);
}
function t2(e, t, n) {
  if (n.button != 0)
    return !1;
  let r = e.state.doc;
  if (t == -1)
    return r.inlineContent ? (to(e, Fe.create(r, 0, r.content.size)), !0) : !1;
  let o = r.resolve(t);
  for (let a = o.depth + 1; a > 0; a--) {
    let l = a > o.depth ? o.nodeAfter : o.node(a), s = o.before(a);
    if (l.inlineContent)
      to(e, Fe.create(r, s + 1, s + 1 + l.content.size));
    else if (Oe.isSelectable(l))
      to(e, Oe.create(r, s));
    else
      continue;
    return !0;
  }
}
function Ed(e) {
  return wl(e);
}
const sb = Zt ? "metaKey" : "ctrlKey";
Ot.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let r = Ed(e), o = Date.now(), a = "singleClick";
  o - e.input.lastClick.time < 500 && Zw(n, e.input.lastClick) && !n[sb] && e.input.lastClick.button == n.button && (e.input.lastClick.type == "singleClick" ? a = "doubleClick" : e.input.lastClick.type == "doubleClick" && (a = "tripleClick")), e.input.lastClick = { time: o, x: n.clientX, y: n.clientY, type: a, button: n.button };
  let l = e.posAtCoords(hs(n));
  l && (a == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new n2(e, l, n, !!r)) : (a == "doubleClick" ? _w : e2)(e, l.pos, l.inside, n) ? n.preventDefault() : Xn(e, "pointer"));
};
class n2 {
  constructor(t, n, r, o) {
    this.view = t, this.pos = n, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = t.state.doc, this.selectNode = !!r[sb], this.allowDefault = r.shiftKey;
    let a, l;
    if (n.inside > -1)
      a = t.state.doc.nodeAt(n.inside), l = n.inside;
    else {
      let u = t.state.doc.resolve(n.pos);
      a = u.parent, l = u.depth ? u.before() : 0;
    }
    const s = o ? null : r.target, i = s ? t.docView.nearestDesc(s, !0) : null;
    this.target = i && i.nodeDOM.nodeType == 1 ? i.nodeDOM : null;
    let { selection: d } = t.state;
    r.button == 0 && (a.type.spec.draggable && a.type.spec.selectable !== !1 || d instanceof Oe && d.from <= l && d.to > l) && (this.mightDrag = {
      node: a,
      pos: l,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && _t && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), t.root.addEventListener("mouseup", this.up = this.up.bind(this)), t.root.addEventListener("mousemove", this.move = this.move.bind(this)), Xn(t, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Pn(this.view)), this.view.input.mouseDown = null;
  }
  up(t) {
    if (this.done(), !this.view.dom.contains(t.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(hs(t))), this.updateAllowDefault(t), this.allowDefault || !n ? Xn(this.view, "pointer") : Qw(this.view, n.pos, n.inside, t, this.selectNode) ? t.preventDefault() : t.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Lt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    St && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (to(this.view, Ue.near(this.view.state.doc.resolve(n.pos))), t.preventDefault()) : Xn(this.view, "pointer");
  }
  move(t) {
    this.updateAllowDefault(t), Xn(this.view, "pointer"), t.buttons == 0 && this.done();
  }
  updateAllowDefault(t) {
    !this.allowDefault && (Math.abs(this.event.x - t.clientX) > 4 || Math.abs(this.event.y - t.clientY) > 4) && (this.allowDefault = !0);
  }
}
Ot.touchstart = (e) => {
  e.input.lastTouch = Date.now(), Ed(e), Xn(e, "pointer");
};
Ot.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Xn(e, "pointer");
};
Ot.contextmenu = (e) => Ed(e);
function ib(e, t) {
  return e.composing ? !0 : Lt && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const r2 = Bn ? 5e3 : -1;
Pt.compositionstart = Pt.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: t } = e, n = t.selection.$to;
    if (t.selection instanceof Fe && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1) || St && Vh && o2(e)))
      e.markCursor = e.state.storedMarks || n.marks(), wl(e, !0), e.markCursor = null;
    else if (wl(e, !t.selection.empty), _t && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let r = e.domSelectionRange();
      for (let o = r.focusNode, a = r.focusOffset; o && o.nodeType == 1 && a != 0; ) {
        let l = a < 0 ? o.lastChild : o.childNodes[a - 1];
        if (!l)
          break;
        if (l.nodeType == 3) {
          let s = e.domSelection();
          s && s.collapse(l, l.nodeValue.length);
          break;
        } else
          o = l, a = -1;
      }
    }
    e.input.composing = !0;
  }
  db(e, r2);
};
function o2(e) {
  let { focusNode: t, focusOffset: n } = e.domSelectionRange();
  if (!t || t.nodeType != 1 || n >= t.childNodes.length)
    return !1;
  let r = t.childNodes[n];
  return r.nodeType == 1 && r.contentEditable == "false";
}
Pt.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, db(e, 20));
};
function db(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => wl(e), t));
}
function ub(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = l2()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function a2(e) {
  let t = e.domSelectionRange();
  if (!t.focusNode)
    return null;
  let n = X1(t.focusNode, t.focusOffset), r = Q1(t.focusNode, t.focusOffset);
  if (n && r && n != r) {
    let o = r.pmViewDesc, a = e.domObserver.lastChangedTextNode;
    if (n == a || r == a)
      return a;
    if (!o || !o.isText(r.nodeValue))
      return r;
    if (e.input.compositionNode == r) {
      let l = n.pmViewDesc;
      if (!(!l || !l.isText(n.nodeValue)))
        return r;
    }
  }
  return n || r;
}
function l2() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function wl(e, t = !1) {
  if (!(Bn && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), ub(e), t || e.docView && e.docView.dirty) {
      let n = $d(e), r = e.state.selection;
      return n && !n.eq(r) ? e.dispatch(e.state.tr.setSelection(n)) : (e.markCursor || t) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function s2(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), e.focus();
  }, 50);
}
const ia = Ft && rr < 15 || ho && nw < 604;
Ot.copy = Pt.cut = (e, t) => {
  let n = t, r = e.state.selection, o = n.type == "cut";
  if (r.empty)
    return;
  let a = ia ? null : n.clipboardData, l = r.content(), { dom: s, text: i } = Td(e, l);
  a ? (n.preventDefault(), a.clearData(), a.setData("text/html", s.innerHTML), a.setData("text/plain", i)) : s2(e, s), o && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function i2(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function d2(e, t) {
  if (!e.dom.parentNode)
    return;
  let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let o = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? da(e, r.value, null, o, t) : da(e, r.textContent, r.innerHTML, o, t);
  }, 50);
}
function da(e, t, n, r, o) {
  let a = tb(e, t, n, r, e.state.selection.$from);
  if (e.someProp("handlePaste", (i) => i(e, o, a || Ee.empty)))
    return !0;
  if (!a)
    return !1;
  let l = i2(a), s = l ? e.state.tr.replaceSelectionWith(l, r) : e.state.tr.replaceSelection(a);
  return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function cb(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t)
    return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Pt.paste = (e, t) => {
  let n = t;
  if (e.composing && !Bn)
    return;
  let r = ia ? null : n.clipboardData, o = e.input.shiftKey && e.input.lastKeyCode != 45;
  r && da(e, cb(r), r.getData("text/html"), o, n) ? n.preventDefault() : d2(e, n);
};
class fb {
  constructor(t, n, r) {
    this.slice = t, this.move = n, this.node = r;
  }
}
const u2 = Zt ? "altKey" : "ctrlKey";
function hb(e, t) {
  let n;
  return e.someProp("dragCopies", (r) => {
    n = n || r(t);
  }), n != null ? !n : !t[u2];
}
Ot.dragstart = (e, t) => {
  let n = t, r = e.input.mouseDown;
  if (r && r.done(), !n.dataTransfer)
    return;
  let o = e.state.selection, a = o.empty ? null : e.posAtCoords(hs(n)), l;
  if (!(a && a.pos >= o.from && a.pos <= (o instanceof Oe ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      l = Oe.create(e.state.doc, r.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let f = e.docView.nearestDesc(n.target, !0);
      f && f.node.type.spec.draggable && f != e.docView && (l = Oe.create(e.state.doc, f.posBefore));
    }
  }
  let s = (l || e.state.selection).content(), { dom: i, text: d, slice: u } = Td(e, s);
  (!n.dataTransfer.files.length || !St || Nh > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(ia ? "Text" : "text/html", i.innerHTML), n.dataTransfer.effectAllowed = "copyMove", ia || n.dataTransfer.setData("text/plain", d), e.dragging = new fb(u, hb(e, n), l);
};
Ot.dragend = (e) => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
};
Pt.dragover = Pt.dragenter = (e, t) => t.preventDefault();
Pt.drop = (e, t) => {
  try {
    c2(e, t, e.dragging);
  } finally {
    e.dragging = null;
  }
};
function c2(e, t, n) {
  if (!t.dataTransfer)
    return;
  let r = e.posAtCoords(hs(t));
  if (!r)
    return;
  let o = e.state.doc.resolve(r.pos), a = n && n.slice;
  a ? e.someProp("transformPasted", (b) => {
    a = b(a, e, !1);
  }) : a = tb(e, cb(t.dataTransfer), ia ? null : t.dataTransfer.getData("text/html"), !1, o);
  let l = !!(n && hb(e, t));
  if (e.someProp("handleDrop", (b) => b(e, t, a || Ee.empty, l))) {
    t.preventDefault();
    return;
  }
  if (!a)
    return;
  t.preventDefault();
  let s = a ? gh(e.state.doc, o.pos, a) : o.pos;
  s == null && (s = o.pos);
  let i = e.state.tr;
  if (l) {
    let { node: b } = n;
    b ? b.replace(i) : i.deleteSelection();
  }
  let d = i.mapping.map(s), u = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, f = i.doc;
  if (u ? i.replaceRangeWith(d, d, a.content.firstChild) : i.replaceRange(d, d, a), i.doc.eq(f))
    return;
  let h = i.doc.resolve(d);
  if (u && Oe.isSelectable(a.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(a.content.firstChild))
    i.setSelection(new Oe(h));
  else {
    let b = i.mapping.map(s);
    i.mapping.maps[i.mapping.maps.length - 1].forEach((m, v, x, k) => b = k), i.setSelection(Id(e, h, i.doc.resolve(b)));
  }
  e.focus(), e.dispatch(i.setMeta("uiEvent", "drop"));
}
Ot.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && Pn(e);
  }, 20));
};
Ot.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Ot.beforeinput = (e, t) => {
  if (St && Bn && t.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: r } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != r || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (a) => a(e, mr(8, "Backspace")))))
        return;
      let { $cursor: o } = e.state.selection;
      o && o.pos > 0 && e.dispatch(e.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Pt)
  Ot[e] = Pt[e];
function ua(e, t) {
  if (e == t)
    return !0;
  for (let n in e)
    if (e[n] !== t[n])
      return !1;
  for (let n in t)
    if (!(n in e))
      return !1;
  return !0;
}
class Cl {
  constructor(t, n) {
    this.toDOM = t, this.spec = n || Lr, this.side = this.spec.side || 0;
  }
  map(t, n, r, o) {
    let { pos: a, deleted: l } = t.mapResult(n.from + o, this.side < 0 ? -1 : 1);
    return l ? null : new Rt(a - r, a - r, this);
  }
  valid() {
    return !0;
  }
  eq(t) {
    return this == t || t instanceof Cl && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && ua(this.spec, t.spec));
  }
  destroy(t) {
    this.spec.destroy && this.spec.destroy(t);
  }
}
class ar {
  constructor(t, n) {
    this.attrs = t, this.spec = n || Lr;
  }
  map(t, n, r, o) {
    let a = t.map(n.from + o, this.spec.inclusiveStart ? -1 : 1) - r, l = t.map(n.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return a >= l ? null : new Rt(a, l, this);
  }
  valid(t, n) {
    return n.from < n.to;
  }
  eq(t) {
    return this == t || t instanceof ar && ua(this.attrs, t.attrs) && ua(this.spec, t.spec);
  }
  static is(t) {
    return t.type instanceof ar;
  }
  destroy() {
  }
}
class Ad {
  constructor(t, n) {
    this.attrs = t, this.spec = n || Lr;
  }
  map(t, n, r, o) {
    let a = t.mapResult(n.from + o, 1);
    if (a.deleted)
      return null;
    let l = t.mapResult(n.to + o, -1);
    return l.deleted || l.pos <= a.pos ? null : new Rt(a.pos - r, l.pos - r, this);
  }
  valid(t, n) {
    let { index: r, offset: o } = t.content.findIndex(n.from), a;
    return o == n.from && !(a = t.child(r)).isText && o + a.nodeSize == n.to;
  }
  eq(t) {
    return this == t || t instanceof Ad && ua(this.attrs, t.attrs) && ua(this.spec, t.spec);
  }
  destroy() {
  }
}
class Rt {
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.type = r;
  }
  /**
  @internal
  */
  copy(t, n) {
    return new Rt(t, n, this.type);
  }
  /**
  @internal
  */
  eq(t, n = 0) {
    return this.type.eq(t.type) && this.from + n == t.from && this.to + n == t.to;
  }
  /**
  @internal
  */
  map(t, n, r) {
    return this.type.map(t, this, n, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(t, n, r) {
    return new Rt(t, t, new Cl(n, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(t, n, r, o) {
    return new Rt(t, n, new ar(r, o));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(t, n, r, o) {
    return new Rt(t, n, new Ad(r, o));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof ar;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Cl;
  }
}
const Jr = [], Lr = {};
class rt {
  /**
  @internal
  */
  constructor(t, n) {
    this.local = t.length ? t : Jr, this.children = n.length ? n : Jr;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(t, n) {
    return n.length ? Sl(n, t, 0, Lr) : Tt;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(t, n, r) {
    let o = [];
    return this.findInner(t ?? 0, n ?? 1e9, o, 0, r), o;
  }
  findInner(t, n, r, o, a) {
    for (let l = 0; l < this.local.length; l++) {
      let s = this.local[l];
      s.from <= n && s.to >= t && (!a || a(s.spec)) && r.push(s.copy(s.from + o, s.to + o));
    }
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] < n && this.children[l + 1] > t) {
        let s = this.children[l] + 1;
        this.children[l + 2].findInner(t - s, n - s, r, o + s, a);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(t, n, r) {
    return this == Tt || t.maps.length == 0 ? this : this.mapInner(t, n, 0, 0, r || Lr);
  }
  /**
  @internal
  */
  mapInner(t, n, r, o, a) {
    let l;
    for (let s = 0; s < this.local.length; s++) {
      let i = this.local[s].map(t, r, o);
      i && i.type.valid(n, i) ? (l || (l = [])).push(i) : a.onRemove && a.onRemove(this.local[s].spec);
    }
    return this.children.length ? f2(this.children, l || [], t, n, r, o, a) : l ? new rt(l.sort(Mr), Jr) : Tt;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(t, n) {
    return n.length ? this == Tt ? rt.create(t, n) : this.addInner(t, n, 0) : this;
  }
  addInner(t, n, r) {
    let o, a = 0;
    t.forEach((s, i) => {
      let d = i + r, u;
      if (u = pb(n, s, d)) {
        for (o || (o = this.children.slice()); a < o.length && o[a] < i; )
          a += 3;
        o[a] == i ? o[a + 2] = o[a + 2].addInner(s, u, d + 1) : o.splice(a, 0, i, i + s.nodeSize, Sl(u, s, d + 1, Lr)), a += 3;
      }
    });
    let l = bb(a ? gb(n) : n, -r);
    for (let s = 0; s < l.length; s++)
      l[s].type.valid(t, l[s]) || l.splice(s--, 1);
    return new rt(l.length ? this.local.concat(l).sort(Mr) : this.local, o || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(t) {
    return t.length == 0 || this == Tt ? this : this.removeInner(t, 0);
  }
  removeInner(t, n) {
    let r = this.children, o = this.local;
    for (let a = 0; a < r.length; a += 3) {
      let l, s = r[a] + n, i = r[a + 1] + n;
      for (let u = 0, f; u < t.length; u++)
        (f = t[u]) && f.from > s && f.to < i && (t[u] = null, (l || (l = [])).push(f));
      if (!l)
        continue;
      r == this.children && (r = this.children.slice());
      let d = r[a + 2].removeInner(l, s + 1);
      d != Tt ? r[a + 2] = d : (r.splice(a, 3), a -= 3);
    }
    if (o.length) {
      for (let a = 0, l; a < t.length; a++)
        if (l = t[a])
          for (let s = 0; s < o.length; s++)
            o[s].eq(l, n) && (o == this.local && (o = this.local.slice()), o.splice(s--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new rt(o, r) : Tt;
  }
  forChild(t, n) {
    if (this == Tt)
      return this;
    if (n.isLeaf)
      return rt.empty;
    let r, o;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= t) {
        this.children[s] == t && (r = this.children[s + 2]);
        break;
      }
    let a = t + 1, l = a + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let i = this.local[s];
      if (i.from < l && i.to > a && i.type instanceof ar) {
        let d = Math.max(a, i.from) - a, u = Math.min(l, i.to) - a;
        d < u && (o || (o = [])).push(i.copy(d, u));
      }
    }
    if (o) {
      let s = new rt(o.sort(Mr), Jr);
      return r ? new Jn([s, r]) : s;
    }
    return r || Tt;
  }
  /**
  @internal
  */
  eq(t) {
    if (this == t)
      return !0;
    if (!(t instanceof rt) || this.local.length != t.local.length || this.children.length != t.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(t.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != t.children[n] || this.children[n + 1] != t.children[n + 1] || !this.children[n + 2].eq(t.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(t) {
    return Dd(this.localsInner(t));
  }
  /**
  @internal
  */
  localsInner(t) {
    if (this == Tt)
      return Jr;
    if (t.inlineContent || !this.local.some(ar.is))
      return this.local;
    let n = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof ar || n.push(this.local[r]);
    return n;
  }
  forEachSet(t) {
    t(this);
  }
}
rt.empty = new rt([], []);
rt.removeOverlap = Dd;
const Tt = rt.empty;
class Jn {
  constructor(t) {
    this.members = t;
  }
  map(t, n) {
    const r = this.members.map((o) => o.map(t, n, Lr));
    return Jn.from(r);
  }
  forChild(t, n) {
    if (n.isLeaf)
      return rt.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let a = this.members[o].forChild(t, n);
      a != Tt && (a instanceof Jn ? r = r.concat(a.members) : r.push(a));
    }
    return Jn.from(r);
  }
  eq(t) {
    if (!(t instanceof Jn) || t.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(t.members[n]))
        return !1;
    return !0;
  }
  locals(t) {
    let n, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let a = this.members[o].localsInner(t);
      if (a.length)
        if (!n)
          n = a;
        else {
          r && (n = n.slice(), r = !1);
          for (let l = 0; l < a.length; l++)
            n.push(a[l]);
        }
    }
    return n ? Dd(r ? n : n.sort(Mr)) : Jr;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(t) {
    switch (t.length) {
      case 0:
        return Tt;
      case 1:
        return t[0];
      default:
        return new Jn(t.every((n) => n instanceof rt) ? t : t.reduce((n, r) => n.concat(r instanceof rt ? r : r.members), []));
    }
  }
  forEachSet(t) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(t);
  }
}
function f2(e, t, n, r, o, a, l) {
  let s = e.slice();
  for (let d = 0, u = a; d < n.maps.length; d++) {
    let f = 0;
    n.maps[d].forEach((h, b, m, v) => {
      let x = v - m - (b - h);
      for (let k = 0; k < s.length; k += 3) {
        let L = s[k + 1];
        if (L < 0 || h > L + u - f)
          continue;
        let P = s[k] + u - f;
        b >= P ? s[k + 1] = h <= P ? -2 : -1 : h >= u && x && (s[k] += x, s[k + 1] += x);
      }
      f += x;
    }), u = n.maps[d].map(u, -1);
  }
  let i = !1;
  for (let d = 0; d < s.length; d += 3)
    if (s[d + 1] < 0) {
      if (s[d + 1] == -2) {
        i = !0, s[d + 1] = -1;
        continue;
      }
      let u = n.map(e[d] + a), f = u - o;
      if (f < 0 || f >= r.content.size) {
        i = !0;
        continue;
      }
      let h = n.map(e[d + 1] + a, -1), b = h - o, { index: m, offset: v } = r.content.findIndex(f), x = r.maybeChild(m);
      if (x && v == f && v + x.nodeSize == b) {
        let k = s[d + 2].mapInner(n, x, u + 1, e[d] + a + 1, l);
        k != Tt ? (s[d] = f, s[d + 1] = b, s[d + 2] = k) : (s[d + 1] = -2, i = !0);
      } else
        i = !0;
    }
  if (i) {
    let d = h2(s, e, t, n, o, a, l), u = Sl(d, r, 0, l);
    t = u.local;
    for (let f = 0; f < s.length; f += 3)
      s[f + 1] < 0 && (s.splice(f, 3), f -= 3);
    for (let f = 0, h = 0; f < u.children.length; f += 3) {
      let b = u.children[f];
      for (; h < s.length && s[h] < b; )
        h += 3;
      s.splice(h, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new rt(t.sort(Mr), s);
}
function bb(e, t) {
  if (!t || !e.length)
    return e;
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r];
    n.push(new Rt(o.from + t, o.to + t, o.type));
  }
  return n;
}
function h2(e, t, n, r, o, a, l) {
  function s(i, d) {
    for (let u = 0; u < i.local.length; u++) {
      let f = i.local[u].map(r, o, d);
      f ? n.push(f) : l.onRemove && l.onRemove(i.local[u].spec);
    }
    for (let u = 0; u < i.children.length; u += 3)
      s(i.children[u + 2], i.children[u] + d + 1);
  }
  for (let i = 0; i < e.length; i += 3)
    e[i + 1] == -1 && s(e[i + 2], t[i] + a + 1);
  return n;
}
function pb(e, t, n) {
  if (t.isLeaf)
    return null;
  let r = n + t.nodeSize, o = null;
  for (let a = 0, l; a < e.length; a++)
    (l = e[a]) && l.from > n && l.to < r && ((o || (o = [])).push(l), e[a] = null);
  return o;
}
function gb(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    e[n] != null && t.push(e[n]);
  return t;
}
function Sl(e, t, n, r) {
  let o = [], a = !1;
  t.forEach((s, i) => {
    let d = pb(e, s, i + n);
    if (d) {
      a = !0;
      let u = Sl(d, s, n + i + 1, r);
      u != Tt && o.push(i, i + s.nodeSize, u);
    }
  });
  let l = bb(a ? gb(e) : e, -n).sort(Mr);
  for (let s = 0; s < l.length; s++)
    l[s].type.valid(t, l[s]) || (r.onRemove && r.onRemove(l[s].spec), l.splice(s--, 1));
  return l.length || o.length ? new rt(l, o) : Tt;
}
function Mr(e, t) {
  return e.from - t.from || e.to - t.to;
}
function Dd(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let r = t[n];
    if (r.from != r.to)
      for (let o = n + 1; o < t.length; o++) {
        let a = t[o];
        if (a.from == r.from) {
          a.to != r.to && (t == e && (t = e.slice()), t[o] = a.copy(a.from, r.to), xc(t, o + 1, a.copy(r.to, a.to)));
          continue;
        } else {
          a.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, a.from), xc(t, o, r.copy(a.from, r.to)));
          break;
        }
      }
  }
  return t;
}
function xc(e, t, n) {
  for (; t < e.length && Mr(n, e[t]) > 0; )
    t++;
  e.splice(t, 0, n);
}
function Ns(e) {
  let t = [];
  return e.someProp("decorations", (n) => {
    let r = n(e.state);
    r && r != Tt && t.push(r);
  }), e.cursorWrapper && t.push(rt.create(e.state.doc, [e.cursorWrapper.deco])), Jn.from(t);
}
const b2 = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, p2 = Ft && rr <= 11;
class g2 {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(t) {
    this.anchorNode = t.anchorNode, this.anchorOffset = t.anchorOffset, this.focusNode = t.focusNode, this.focusOffset = t.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(t) {
    return t.anchorNode == this.anchorNode && t.anchorOffset == this.anchorOffset && t.focusNode == this.focusNode && t.focusOffset == this.focusOffset;
  }
}
class m2 {
  constructor(t, n) {
    this.view = t, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new g2(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let o = 0; o < r.length; o++)
        this.queue.push(r[o]);
      Ft && rr <= 11 && r.some((o) => o.type == "childList" && o.removedNodes.length || o.type == "characterData" && o.oldValue.length > o.target.nodeValue.length) ? this.flushSoon() : Lt && t.composing && r.some((o) => o.type == "childList" && o.target.nodeName == "TR") ? (t.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), p2 && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, b2)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let t = this.observer.takeRecords();
      if (t.length) {
        for (let n = 0; n < t.length; n++)
          this.queue.push(t[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (cc(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Pn(this.view);
      if (Ft && rr <= 11 && !this.view.state.selection.empty) {
        let t = this.view.domSelectionRange();
        if (t.focusNode && Pr(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(t) {
    if (!t.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), r;
    for (let a = t.focusNode; a; a = fo(a))
      n.add(a);
    for (let a = t.anchorNode; a; a = fo(a))
      if (n.has(a)) {
        r = a;
        break;
      }
    let o = r && this.view.docView.nearestDesc(r);
    if (o && o.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let t of this.observer.takeRecords())
        this.queue.push(t);
    return this.queue;
  }
  flush() {
    let { view: t } = this;
    if (!t.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let r = t.domSelectionRange(), o = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && cc(t) && !this.ignoreSelectionChange(r), a = -1, l = -1, s = !1, i = [];
    if (t.editable)
      for (let u = 0; u < n.length; u++) {
        let f = this.registerMutation(n[u], i);
        f && (a = a < 0 ? f.from : Math.min(f.from, a), l = l < 0 ? f.to : Math.max(f.to, l), f.typeOver && (s = !0));
      }
    if (i.some((u) => u.nodeName == "BR") && (t.input.lastKeyCode == 8 || t.input.lastKeyCode == 46)) {
      for (let u of i)
        if (u.nodeName == "BR" && u.parentNode) {
          let f = u.nextSibling;
          for (; f && f.nodeType == 1; ) {
            if (f.contentEditable == "false") {
              u.parentNode.removeChild(u);
              break;
            }
            f = f.firstChild;
          }
        }
    } else if (_t && i.length) {
      let u = i.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, h] = u;
        f.parentNode && f.parentNode.parentNode == h.parentNode ? h.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let h of u) {
          let b = h.parentNode;
          b && b.nodeName == "LI" && (!f || y2(t, f) != b) && h.remove();
        }
      }
    }
    let d = null;
    a < 0 && o && t.input.lastFocus > Date.now() - 200 && Math.max(t.input.lastTouch, t.input.lastClick.time) < Date.now() - 300 && cs(r) && (d = $d(t)) && d.eq(Ue.near(t.state.doc.resolve(0), 1)) ? (t.input.lastFocus = 0, Pn(t), this.currentSelection.set(r), t.scrollToSelection()) : (a > -1 || o) && (a > -1 && (t.docView.markDirty(a, l), v2(t)), t.input.badSafariComposition && (t.input.badSafariComposition = !1, k2(t, i)), this.handleDOMChange(a, l, s, i), t.docView && t.docView.dirty ? t.updateState(t.state) : this.currentSelection.eq(r) || Pn(t), this.currentSelection.set(r));
  }
  registerMutation(t, n) {
    if (n.indexOf(t.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(t.target);
    if (t.type == "attributes" && (r == this.view.docView || t.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    t.attributeName == "style" && !t.oldValue && !t.target.getAttribute("style")) || !r || r.ignoreMutation(t))
      return null;
    if (t.type == "childList") {
      for (let u = 0; u < t.addedNodes.length; u++) {
        let f = t.addedNodes[u];
        n.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(t.target))
        return { from: r.posBefore, to: r.posAfter };
      let o = t.previousSibling, a = t.nextSibling;
      if (Ft && rr <= 11 && t.addedNodes.length)
        for (let u = 0; u < t.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: h } = t.addedNodes[u];
          (!f || Array.prototype.indexOf.call(t.addedNodes, f) < 0) && (o = f), (!h || Array.prototype.indexOf.call(t.addedNodes, h) < 0) && (a = h);
        }
      let l = o && o.parentNode == t.target ? wt(o) + 1 : 0, s = r.localPosFromDOM(t.target, l, -1), i = a && a.parentNode == t.target ? wt(a) : t.target.childNodes.length, d = r.localPosFromDOM(t.target, i, 1);
      return { from: s, to: d };
    } else return t.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = t.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: t.target.nodeValue == t.oldValue
    });
  }
}
let yc = /* @__PURE__ */ new WeakMap(), kc = !1;
function v2(e) {
  if (!yc.has(e) && (yc.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = _t, kc)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), kc = !0;
  }
}
function wc(e, t) {
  let n = t.startContainer, r = t.startOffset, o = t.endContainer, a = t.endOffset, l = e.domAtPos(e.state.selection.anchor);
  return Pr(l.node, l.offset, o, a) && ([n, r, o, a] = [o, a, n, r]), { anchorNode: n, anchorOffset: r, focusNode: o, focusOffset: a };
}
function x2(e, t) {
  if (t.getComposedRanges) {
    let o = t.getComposedRanges(e.root)[0];
    if (o)
      return wc(e, o);
  }
  let n;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), n = o.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", r, !0), n ? wc(e, n) : null;
}
function y2(e, t) {
  for (let n = t.parentNode; n && n != e.dom; n = n.parentNode) {
    let r = e.docView.nearestDesc(n, !0);
    if (r && r.node.isBlock)
      return n;
  }
  return null;
}
function k2(e, t) {
  var n;
  let { focusNode: r, focusOffset: o } = e.domSelectionRange();
  for (let a of t)
    if (((n = a.parentNode) === null || n === void 0 ? void 0 : n.nodeName) == "TR") {
      let l = a.nextSibling;
      for (; l && l.nodeName != "TD" && l.nodeName != "TH"; )
        l = l.nextSibling;
      if (l) {
        let s = l;
        for (; ; ) {
          let i = s.firstChild;
          if (!i || i.nodeType != 1 || i.contentEditable == "false" || /^(BR|IMG)$/.test(i.nodeName))
            break;
          s = i;
        }
        s.insertBefore(a, s.firstChild), r == a && e.domSelection().collapse(a, o);
      } else
        a.parentNode.removeChild(a);
    }
}
function w2(e, t, n) {
  let { node: r, fromOffset: o, toOffset: a, from: l, to: s } = e.docView.parseRange(t, n), i = e.domSelectionRange(), d, u = i.anchorNode;
  if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (d = [{ node: u, offset: i.anchorOffset }], cs(i) || d.push({ node: i.focusNode, offset: i.focusOffset })), St && e.input.lastKeyCode === 8)
    for (let x = a; x > o; x--) {
      let k = r.childNodes[x - 1], L = k.pmViewDesc;
      if (k.nodeName == "BR" && !L) {
        a = x;
        break;
      }
      if (!L || L.size)
        break;
    }
  let f = e.state.doc, h = e.someProp("domParser") || nr.fromSchema(e.state.schema), b = f.resolve(l), m = null, v = h.parse(r, {
    topNode: b.parent,
    topMatch: b.parent.contentMatchAt(b.index()),
    topOpen: !0,
    from: o,
    to: a,
    preserveWhitespace: b.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: d,
    ruleFromNode: C2,
    context: b
  });
  if (d && d[0].pos != null) {
    let x = d[0].pos, k = d[1] && d[1].pos;
    k == null && (k = x), m = { anchor: x + l, head: k + l };
  }
  return { doc: v, sel: m, from: l, to: s };
}
function C2(e) {
  let t = e.pmViewDesc;
  if (t)
    return t.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (Lt && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (e.parentNode.lastChild == e || Lt && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const S2 = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $2(e, t, n, r, o) {
  let a = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let V = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, J = $d(e, V);
    if (J && !e.state.selection.eq(J)) {
      if (St && Bn && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (A) => A(e, mr(13, "Enter"))))
        return;
      let F = e.state.tr.setSelection(J);
      V == "pointer" ? F.setMeta("pointer", !0) : V == "key" && F.scrollIntoView(), a && F.setMeta("composition", a), e.dispatch(F);
    }
    return;
  }
  let l = e.state.doc.resolve(t), s = l.sharedDepth(n);
  t = l.before(s + 1), n = e.state.doc.resolve(n).after(s + 1);
  let i = e.state.selection, d = w2(e, t, n), u = e.state.doc, f = u.slice(d.from, d.to), h, b;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (h = e.state.selection.to, b = "end") : (h = e.state.selection.from, b = "start"), e.input.lastKeyCode = null;
  let m = L2(f.content, d.doc.content, d.from, h, b);
  if (m && e.input.domChangeCount++, (ho && e.input.lastIOSEnter > Date.now() - 225 || Bn) && o.some((V) => V.nodeType == 1 && !S2.test(V.nodeName)) && (!m || m.endA >= m.endB) && e.someProp("handleKeyDown", (V) => V(e, mr(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (r && i instanceof Fe && !i.empty && i.$head.sameParent(i.$anchor) && !e.composing && !(d.sel && d.sel.anchor != d.sel.head))
      m = { start: i.from, endA: i.to, endB: i.to };
    else {
      if (d.sel) {
        let V = Cc(e, e.state.doc, d.sel);
        if (V && !V.eq(e.state.selection)) {
          let J = e.state.tr.setSelection(V);
          a && J.setMeta("composition", a), e.dispatch(J);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && m.start == m.endB && e.state.selection instanceof Fe && (m.start > e.state.selection.from && m.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? m.start = e.state.selection.from : m.endA < e.state.selection.to && m.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (m.endB += e.state.selection.to - m.endA, m.endA = e.state.selection.to)), Ft && rr <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > d.from && d.doc.textBetween(m.start - d.from - 1, m.start - d.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let v = d.doc.resolveNoCache(m.start - d.from), x = d.doc.resolveNoCache(m.endB - d.from), k = u.resolve(m.start), L = v.sameParent(x) && v.parent.inlineContent && k.end() >= m.endA;
  if ((ho && e.input.lastIOSEnter > Date.now() - 225 && (!L || o.some((V) => V.nodeName == "DIV" || V.nodeName == "P")) || !L && v.pos < d.doc.content.size && (!v.sameParent(x) || !v.parent.inlineContent) && v.pos < x.pos && !/\S/.test(d.doc.textBetween(v.pos, x.pos, "", ""))) && e.someProp("handleKeyDown", (V) => V(e, mr(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > m.start && T2(u, m.start, m.endA, v, x) && e.someProp("handleKeyDown", (V) => V(e, mr(8, "Backspace")))) {
    Bn && St && e.domObserver.suppressSelectionUpdates();
    return;
  }
  St && m.endB == m.start && (e.input.lastChromeDelete = Date.now()), Bn && !L && v.start() != x.start() && x.parentOffset == 0 && v.depth == x.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == m.endA && (m.endB -= 2, x = d.doc.resolveNoCache(m.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(V) {
      return V(e, mr(13, "Enter"));
    });
  }, 20));
  let P = m.start, E = m.endA, O = (V) => {
    let J = V || e.state.tr.replace(P, E, d.doc.slice(m.start - d.from, m.endB - d.from));
    if (d.sel) {
      let F = Cc(e, J.doc, d.sel);
      F && !(St && e.composing && F.empty && (m.start != m.endB || e.input.lastChromeDelete < Date.now() - 100) && (F.head == P || F.head == J.mapping.map(E) - 1) || Ft && F.empty && F.head == P) && J.setSelection(F);
    }
    return a && J.setMeta("composition", a), J.scrollIntoView();
  }, R;
  if (L)
    if (v.pos == x.pos) {
      Ft && rr <= 11 && v.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => Pn(e), 20));
      let V = O(e.state.tr.delete(P, E)), J = u.resolve(m.start).marksAcross(u.resolve(m.endA));
      J && V.ensureMarks(J), e.dispatch(V);
    } else if (
      // Adding or removing a mark
      m.endA == m.endB && (R = I2(v.parent.content.cut(v.parentOffset, x.parentOffset), k.parent.content.cut(k.parentOffset, m.endA - k.start())))
    ) {
      let V = O(e.state.tr);
      R.type == "add" ? V.addMark(P, E, R.mark) : V.removeMark(P, E, R.mark), e.dispatch(V);
    } else if (v.parent.child(v.index()).isText && v.index() == x.index() - (x.textOffset ? 0 : 1)) {
      let V = v.parent.textBetween(v.parentOffset, x.parentOffset), J = () => O(e.state.tr.insertText(V, P, E));
      e.someProp("handleTextInput", (F) => F(e, P, E, V, J)) || e.dispatch(J());
    } else
      e.dispatch(O());
  else
    e.dispatch(O());
}
function Cc(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : Id(e, t.resolve(n.anchor), t.resolve(n.head));
}
function I2(e, t) {
  let n = e.firstChild.marks, r = t.firstChild.marks, o = n, a = r, l, s, i;
  for (let u = 0; u < r.length; u++)
    o = r[u].removeFromSet(o);
  for (let u = 0; u < n.length; u++)
    a = n[u].removeFromSet(a);
  if (o.length == 1 && a.length == 0)
    s = o[0], l = "add", i = (u) => u.mark(s.addToSet(u.marks));
  else if (o.length == 0 && a.length == 1)
    s = a[0], l = "remove", i = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let d = [];
  for (let u = 0; u < t.childCount; u++)
    d.push(i(t.child(u)));
  if (Ce.from(d).eq(e))
    return { mark: s, type: l };
}
function T2(e, t, n, r, o) {
  if (
    // The content must have shrunk
    n - t <= o.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Vs(r, !0, !1) < o.pos
  )
    return !1;
  let a = e.resolve(t);
  if (!r.parent.isTextblock) {
    let s = a.nodeAfter;
    return s != null && n == t + s.nodeSize;
  }
  if (a.parentOffset < a.parent.content.size || !a.parent.isTextblock)
    return !1;
  let l = e.resolve(Vs(a, !0, !0));
  return !l.parent.isTextblock || l.pos > n || Vs(l, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(l.parent.content);
}
function Vs(e, t, n) {
  let r = e.depth, o = t ? e.end() : e.pos;
  for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount); )
    r--, o++, t = !1;
  if (n) {
    let a = e.node(r).maybeChild(e.indexAfter(r));
    for (; a && !a.isLeaf; )
      a = a.firstChild, o++;
  }
  return o;
}
function L2(e, t, n, r, o) {
  let a = e.findDiffStart(t, n);
  if (a == null)
    return null;
  let { a: l, b: s } = e.findDiffEnd(t, n + e.size, n + t.size);
  if (o == "end") {
    let i = Math.max(0, a - Math.min(l, s));
    r -= l + i - a;
  }
  if (l < a && e.size < t.size) {
    let i = r <= a && r >= l ? a - r : 0;
    a -= i, a && a < t.size && Sc(t.textBetween(a - 1, a + 1)) && (a += i ? 1 : -1), s = a + (s - l), l = a;
  } else if (s < a) {
    let i = r <= a && r >= s ? a - r : 0;
    a -= i, a && a < e.size && Sc(e.textBetween(a - 1, a + 1)) && (a += i ? 1 : -1), l = a + (l - s), s = a;
  }
  return { start: a, endA: l, endB: s };
}
function Sc(e) {
  if (e.length != 2)
    return !1;
  let t = e.charCodeAt(0), n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
class mb {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(t, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new Uw(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Mc), this.dispatch = this.dispatch.bind(this), this.dom = t && t.mount || document.createElement("div"), t && (t.appendChild ? t.appendChild(this.dom) : typeof t == "function" ? t(this.dom) : t.mount && (this.mounted = !0)), this.editable = Tc(this), Ic(this), this.nodeViews = Lc(this), this.docView = ac(this.state.doc, $c(this), Ns(this), this.dom, this), this.domObserver = new m2(this, (r, o, a, l) => $2(this, r, o, a, l)), this.domObserver.start(), Gw(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let t = this._props;
      this._props = {};
      for (let n in t)
        this._props[n] = t[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(t) {
    t.handleDOMEvents != this._props.handleDOMEvents && Di(this);
    let n = this._props;
    this._props = t, t.plugins && (t.plugins.forEach(Mc), this.directPlugins = t.plugins), this.updateStateInner(t.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(t) {
    let n = {};
    for (let r in this._props)
      n[r] = this._props[r];
    n.state = this.state;
    for (let r in t)
      n[r] = t[r];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(t) {
    this.updateStateInner(t, this._props);
  }
  updateStateInner(t, n) {
    var r;
    let o = this.state, a = !1, l = !1;
    t.storedMarks && this.composing && (ub(this), l = !0), this.state = t;
    let s = o.plugins != t.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let b = Lc(this);
      E2(b, this.nodeViews) && (this.nodeViews = b, a = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && Di(this), this.editable = Tc(this), Ic(this);
    let i = Ns(this), d = $c(this), u = o.plugins != t.plugins && !o.doc.eq(t.doc) ? "reset" : t.scrollToSelection > o.scrollToSelection ? "to selection" : "preserve", f = a || !this.docView.matchesNode(t.doc, d, i);
    (f || !t.selection.eq(o.selection)) && (l = !0);
    let h = u == "preserve" && l && this.dom.style.overflowAnchor == null && aw(this);
    if (l) {
      this.domObserver.stop();
      let b = f && (Ft || St) && !this.composing && !o.selection.empty && !t.selection.empty && M2(o.selection, t.selection);
      if (f) {
        let m = St ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = a2(this)), (a || !this.docView.update(t.doc, d, i, this)) && (this.docView.updateOuterDeco(d), this.docView.destroy(), this.docView = ac(t.doc, d, i, this.dom, this)), m && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (b = !0);
      }
      b || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Mw(this)) ? Pn(this, b) : (Qh(this, t.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(o), !((r = this.dragging) === null || r === void 0) && r.node && !o.doc.eq(t.doc) && this.updateDraggedNode(this.dragging, o), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : h && lw(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let t = this.domSelectionRange().focusNode;
    if (!(!t || !this.dom.contains(t.nodeType == 1 ? t : t.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof Oe) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && _u(this, n.getBoundingClientRect(), t);
      } else
        _u(this, this.coordsAtPos(this.state.selection.head, 1), t);
    }
  }
  destroyPluginViews() {
    let t;
    for (; t = this.pluginViews.pop(); )
      t.destroy && t.destroy();
  }
  updatePluginViews(t) {
    if (!t || t.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let r = this.directPlugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let r = this.state.plugins[n];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let r = this.pluginViews[n];
        r.update && r.update(this, t);
      }
  }
  updateDraggedNode(t, n) {
    let r = t.node, o = -1;
    if (r.from < this.state.doc.content.size && this.state.doc.nodeAt(r.from) == r.node)
      o = r.from;
    else {
      let a = r.from + (this.state.doc.content.size - n.doc.content.size);
      (a > 0 && a < this.state.doc.content.size && this.state.doc.nodeAt(a)) == r.node && (o = a);
    }
    this.dragging = new fb(t.slice, t.move, o < 0 ? void 0 : Oe.create(this.state.doc, o));
  }
  someProp(t, n) {
    let r = this._props && this._props[t], o;
    if (r != null && (o = n ? n(r) : r))
      return o;
    for (let l = 0; l < this.directPlugins.length; l++) {
      let s = this.directPlugins[l].props[t];
      if (s != null && (o = n ? n(s) : s))
        return o;
    }
    let a = this.state.plugins;
    if (a)
      for (let l = 0; l < a.length; l++) {
        let s = a[l].props[t];
        if (s != null && (o = n ? n(s) : s))
          return o;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Ft) {
      let t = this.root.activeElement;
      if (t == this.dom)
        return !0;
      if (!t || !this.dom.contains(t))
        return !1;
      for (; t && this.dom != t && this.dom.contains(t); ) {
        if (t.contentEditable == "false")
          return !1;
        t = t.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && sw(this.dom), Pn(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let t = this._root;
    if (t == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return t || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(t) {
    return fw(this, t);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(t, n = 1) {
    return Uh(this, t, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(t, n = 0) {
    return this.docView.domFromPos(t, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(t) {
    let n = this.docView.descAt(t);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(t, n, r = -1) {
    let o = this.docView.posFromDOM(t, n, r);
    if (o == null)
      throw new RangeError("DOM position not inside the editor");
    return o;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(t, n) {
    return mw(this, n || this.state, t);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(t, n) {
    return da(this, "", t, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(t, n) {
    return da(this, t, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(t) {
    return Td(this, t);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (qw(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Ns(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, Z1());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(t) {
    return Jw(this, t);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let t = this.domSelection();
    return t ? Lt && this.root.nodeType === 11 && ew(this.dom.ownerDocument) == this.dom && x2(this, t) || t : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
mb.prototype.dispatch = function(e) {
  let t = this._props.dispatchTransaction;
  t ? t.call(this, e) : this.updateState(this.state.apply(e));
};
function $c(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(e.state)), n)
      for (let r in n)
        r == "class" ? t.class += " " + n[r] : r == "style" ? t.style = (t.style ? t.style + ";" : "") + n[r] : !t[r] && r != "contenteditable" && r != "nodeName" && (t[r] = String(n[r]));
  }), t.translate || (t.translate = "no"), [Rt.node(0, e.state.doc.content.size, t)];
}
function Ic(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = { dom: t, deco: Rt.widget(e.state.selection.from, t, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function Tc(e) {
  return !e.someProp("editable", (t) => t(e.state) === !1);
}
function M2(e, t) {
  let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
  return e.$anchor.start(n) != t.$anchor.start(n);
}
function Lc(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    for (let o in r)
      Object.prototype.hasOwnProperty.call(t, o) || (t[o] = r[o]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function E2(e, t) {
  let n = 0, r = 0;
  for (let o in e) {
    if (e[o] != t[o])
      return !0;
    n++;
  }
  for (let o in t)
    r++;
  return n != r;
}
function Mc(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var lr = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, $l = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, A2 = typeof navigator < "u" && /Mac/.test(navigator.platform), D2 = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ct = 0; Ct < 10; Ct++) lr[48 + Ct] = lr[96 + Ct] = String(Ct);
for (var Ct = 1; Ct <= 24; Ct++) lr[Ct + 111] = "F" + Ct;
for (var Ct = 65; Ct <= 90; Ct++)
  lr[Ct] = String.fromCharCode(Ct + 32), $l[Ct] = String.fromCharCode(Ct);
for (var Fs in lr) $l.hasOwnProperty(Fs) || ($l[Fs] = lr[Fs]);
function R2(e) {
  var t = A2 && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || D2 && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? $l : lr)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const B2 = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), O2 = typeof navigator < "u" && /Win/.test(navigator.platform);
function P2(e) {
  let t = e.split(/-(?!$)/), n = t[t.length - 1];
  n == "Space" && (n = " ");
  let r, o, a, l;
  for (let s = 0; s < t.length - 1; s++) {
    let i = t[s];
    if (/^(cmd|meta|m)$/i.test(i))
      l = !0;
    else if (/^a(lt)?$/i.test(i))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(i))
      o = !0;
    else if (/^s(hift)?$/i.test(i))
      a = !0;
    else if (/^mod$/i.test(i))
      B2 ? l = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + i);
  }
  return r && (n = "Alt-" + n), o && (n = "Ctrl-" + n), l && (n = "Meta-" + n), a && (n = "Shift-" + n), n;
}
function z2(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e)
    t[P2(n)] = e[n];
  return t;
}
function Hs(e, t, n = !0) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function N2(e) {
  return new lt({ props: { handleKeyDown: vb(e) } });
}
function vb(e) {
  let t = z2(e);
  return function(n, r) {
    let o = R2(r), a, l = t[Hs(o, r)];
    if (l && l(n.state, n.dispatch, n))
      return !0;
    if (o.length == 1 && o != " ") {
      if (r.shiftKey) {
        let s = t[Hs(o, r, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(O2 && r.ctrlKey && r.altKey) && (a = lr[r.keyCode]) && a != o) {
        let s = t[Hs(a, r)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
var V2 = Object.defineProperty, Rd = (e, t) => {
  for (var n in t)
    V2(e, n, { get: t[n], enumerable: !0 });
};
function bs(e) {
  const { state: t, transaction: n } = e;
  let { selection: r } = n, { doc: o } = n, { storedMarks: a } = n;
  return {
    ...t,
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return a;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = n.selection, o = n.doc, a = n.storedMarks, n;
    }
  };
}
var ps = class {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: t, state: n } = this, { view: r } = t, { tr: o } = n, a = this.buildProps(o);
    return Object.fromEntries(
      Object.entries(e).map(([l, s]) => [l, (...d) => {
        const u = s(...d)(a);
        return !o.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(o), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, t = !0) {
    const { rawCommands: n, editor: r, state: o } = this, { view: a } = r, l = [], s = !!e, i = e || o.tr, d = () => (!s && t && !i.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(i), l.every((f) => f === !0)), u = {
      ...Object.fromEntries(
        Object.entries(n).map(([f, h]) => [f, (...m) => {
          const v = this.buildProps(i, t), x = h(...m)(v);
          return l.push(x), u;
        }])
      ),
      run: d
    };
    return u;
  }
  createCan(e) {
    const { rawCommands: t, state: n } = this, r = !1, o = e || n.tr, a = this.buildProps(o, r);
    return {
      ...Object.fromEntries(
        Object.entries(t).map(([s, i]) => [s, (...d) => i(...d)({ ...a, dispatch: void 0 })])
      ),
      chain: () => this.createChain(o, r)
    };
  }
  buildProps(e, t = !0) {
    const { rawCommands: n, editor: r, state: o } = this, { view: a } = r, l = {
      tr: e,
      editor: r,
      view: a,
      state: bs({
        state: o,
        transaction: e
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(e, t),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(
          Object.entries(n).map(([s, i]) => [s, (...d) => i(...d)(l)])
        );
      }
    };
    return l;
  }
}, xb = {};
Rd(xb, {
  blur: () => F2,
  clearContent: () => H2,
  clearNodes: () => W2,
  command: () => j2,
  createParagraphNear: () => U2,
  cut: () => G2,
  deleteCurrentNode: () => q2,
  deleteNode: () => K2,
  deleteRange: () => J2,
  deleteSelection: () => X2,
  enter: () => Q2,
  exitCode: () => _2,
  extendMarkRange: () => eC,
  first: () => tC,
  focus: () => rC,
  forEach: () => oC,
  insertContent: () => aC,
  insertContentAt: () => iC,
  joinBackward: () => cC,
  joinDown: () => uC,
  joinForward: () => fC,
  joinItemBackward: () => hC,
  joinItemForward: () => bC,
  joinTextblockBackward: () => pC,
  joinTextblockForward: () => gC,
  joinUp: () => dC,
  keyboardShortcut: () => vC,
  lift: () => xC,
  liftEmptyBlock: () => yC,
  liftListItem: () => kC,
  newlineInCode: () => wC,
  resetAttributes: () => CC,
  scrollIntoView: () => SC,
  selectAll: () => $C,
  selectNodeBackward: () => IC,
  selectNodeForward: () => TC,
  selectParentNode: () => LC,
  selectTextblockEnd: () => MC,
  selectTextblockStart: () => EC,
  setContent: () => AC,
  setMark: () => QC,
  setMeta: () => _C,
  setNode: () => eS,
  setNodeSelection: () => tS,
  setTextDirection: () => nS,
  setTextSelection: () => rS,
  sinkListItem: () => oS,
  splitBlock: () => aS,
  splitListItem: () => lS,
  toggleList: () => iS,
  toggleMark: () => dS,
  toggleNode: () => uS,
  toggleWrap: () => cS,
  undoInputRule: () => fS,
  unsetAllMarks: () => hS,
  unsetMark: () => bS,
  unsetTextDirection: () => pS,
  updateAttributes: () => gS,
  wrapIn: () => mS,
  wrapInList: () => vS
});
var F2 = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
  var n;
  e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) == null || n.removeAllRanges());
}), !0), H2 = (e = !0) => ({ commands: t }) => t.setContent("", { emitUpdate: e }), W2 = () => ({ state: e, tr: t, dispatch: n }) => {
  const { selection: r } = t, { ranges: o } = r;
  return n && o.forEach(({ $from: a, $to: l }) => {
    e.doc.nodesBetween(a.pos, l.pos, (s, i) => {
      if (s.type.isText)
        return;
      const { doc: d, mapping: u } = t, f = d.resolve(u.map(i)), h = d.resolve(u.map(i + s.nodeSize)), b = f.blockRange(h);
      if (!b)
        return;
      const m = xo(b);
      if (s.type.isTextblock) {
        const { defaultType: v } = f.parent.contentMatchAt(f.index());
        t.setNodeMarkup(b.start, v);
      }
      (m || m === 0) && t.lift(b, m);
    });
  }), !0;
}, j2 = (e) => (t) => e(t), U2 = () => ({ state: e, dispatch: t }) => Rh(e, t), G2 = (e, t) => ({ editor: n, tr: r }) => {
  const { state: o } = n, a = o.doc.slice(e.from, e.to);
  r.deleteRange(e.from, e.to);
  const l = r.mapping.map(t);
  return r.insert(l, a.content), r.setSelection(new Fe(r.doc.resolve(Math.max(l - 1, 0)))), !0;
}, q2 = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, r = n.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const o = e.selection.$anchor;
  for (let a = o.depth; a > 0; a -= 1)
    if (o.node(a).type === r.type) {
      if (t) {
        const s = o.before(a), i = o.after(a);
        e.delete(s, i).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function ft(e, t) {
  if (typeof e == "string") {
    if (!t.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
var K2 = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const o = ft(e, n.schema), a = t.selection.$anchor;
  for (let l = a.depth; l > 0; l -= 1)
    if (a.node(l).type === o) {
      if (r) {
        const i = a.before(l), d = a.after(l);
        t.delete(i, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, J2 = (e) => ({ tr: t, dispatch: n }) => {
  const { from: r, to: o } = e;
  return n && t.delete(r, o), !0;
}, Z2 = (e) => e.content ? /^text(\*|\+)/.test(e.content) : !1, Ec = (e, t, n) => {
  if (!e.parent.isInline || n === "left" && e.pos > e.start() || n === "right" && e.pos < e.end())
    return e.pos;
  const r = t.nodes[e.parent.type.name].spec;
  return Z2(r) ? n === "left" ? e.start() - 1 : e.end() + 1 : e.pos;
}, Y2 = (e, t, n) => {
  const r = Ec(e, n, "left"), o = Ec(t, n, "right");
  return { from: r, to: o };
}, X2 = () => ({ state: e, dispatch: t }) => {
  const { $from: n, $to: r } = e.selection;
  if (e.selection.empty)
    return !1;
  const { from: o, to: a } = Y2(n, r, e.schema);
  return t && (e.tr.deleteRange(o, a).scrollIntoView(), t(e.tr)), !0;
}, Q2 = () => ({ commands: e }) => e.keyboardShortcut("Enter"), _2 = () => ({ state: e, dispatch: t }) => B1(e, t);
function Bd(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function Il(e, t, n = { strict: !0 }) {
  const r = Object.keys(t);
  return r.length ? r.every((o) => n.strict ? t[o] === e[o] : Bd(t[o]) ? t[o].test(e[o]) : t[o] === e[o]) : !0;
}
function yb(e, t, n = {}) {
  return e.find((r) => r.type === t && Il(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((o) => [o, r.attrs[o]])),
    n
  ));
}
function Ac(e, t, n = {}) {
  return !!yb(e, t, n);
}
function Od(e, t, n) {
  if (!e || !t)
    return;
  let r = e.parent.childAfter(e.parentOffset);
  if ((!r.node || !r.node.marks.some((d) => d.type === t)) && (r = e.parent.childBefore(e.parentOffset)), !r.node || !r.node.marks.some((d) => d.type === t))
    return;
  if (!n) {
    const d = r.node.marks.find((u) => u.type === t);
    d && (n = d.attrs);
  }
  if (!yb([...r.node.marks], t, n))
    return;
  let a = r.index, l = e.start() + r.offset, s = a + 1, i = l + r.node.nodeSize;
  for (; a > 0 && Ac([...e.parent.child(a - 1).marks], t, n); )
    a -= 1, l -= e.parent.child(a).nodeSize;
  for (; s < e.parent.childCount && Ac([...e.parent.child(s).marks], t, n); )
    i += e.parent.child(s).nodeSize, s += 1;
  return {
    from: l,
    to: i
  };
}
function Vn(e, t) {
  if (typeof e == "string") {
    if (!t.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
var eC = (e, t) => ({ tr: n, state: r, dispatch: o }) => {
  const a = Vn(e, r.schema), { doc: l, selection: s } = n, { $from: i, from: d, to: u } = s;
  if (o) {
    const f = Od(i, a, t);
    if (f && f.from <= d && f.to >= u) {
      const h = Fe.create(l, f.from, f.to);
      n.setSelection(h);
    }
  }
  return !0;
}, tC = (e) => (t) => {
  const n = typeof e == "function" ? e(t) : e;
  for (let r = 0; r < n.length; r += 1)
    if (n[r](t))
      return !0;
  return !1;
};
function kb(e) {
  return e instanceof Fe;
}
function kr(e = 0, t = 0, n = 0) {
  return Math.min(Math.max(e, t), n);
}
function wb(e, t = null) {
  if (!t)
    return null;
  const n = Ue.atStart(e), r = Ue.atEnd(e);
  if (t === "start" || t === !0)
    return n;
  if (t === "end")
    return r;
  const o = n.from, a = r.to;
  return t === "all" ? Fe.create(e, kr(0, o, a), kr(e.content.size, o, a)) : Fe.create(e, kr(t, o, a), kr(t, o, a));
}
function Dc() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Tl() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function nC() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var rC = (e = null, t = {}) => ({ editor: n, view: r, tr: o, dispatch: a }) => {
  t = {
    scrollIntoView: !0,
    ...t
  };
  const l = () => {
    (Tl() || Dc()) && r.dom.focus(), nC() && !Tl() && !Dc() && r.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      n.isDestroyed || (r.focus(), t != null && t.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  try {
    if (r.hasFocus() && e === null || e === !1)
      return !0;
  } catch {
    return !1;
  }
  if (a && e === null && !kb(n.state.selection))
    return l(), !0;
  const s = wb(o.doc, e) || n.state.selection, i = n.state.selection.eq(s);
  return a && (i || o.setSelection(s), i && o.storedMarks && o.setStoredMarks(o.storedMarks), l()), !0;
}, oC = (e, t) => (n) => e.every((r, o) => t(r, { ...n, index: o })), aC = (e, t) => ({ tr: n, commands: r }) => r.insertContentAt({ from: n.selection.from, to: n.selection.to }, e, t), Cb = (e) => {
  const t = e.childNodes;
  for (let n = t.length - 1; n >= 0; n -= 1) {
    const r = t[n];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? e.removeChild(r) : r.nodeType === 1 && Cb(r);
  }
  return e;
};
function Pa(e) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
  return Cb(n);
}
function ca(e, t, n) {
  if (e instanceof tr || e instanceof Ce)
    return e;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const r = typeof e == "object" && e !== null, o = typeof e == "string";
  if (r)
    try {
      if (Array.isArray(e) && e.length > 0)
        return Ce.fromArray(e.map((s) => t.nodeFromJSON(s)));
      const l = t.nodeFromJSON(e);
      return n.errorOnInvalidContent && l.check(), l;
    } catch (a) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", a), ca("", t, n);
    }
  if (o) {
    if (n.errorOnInvalidContent) {
      let l = !1, s = "";
      const i = new ah({
        topNode: t.spec.topNode,
        marks: t.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: t.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (d) => (l = !0, s = typeof d == "string" ? d : d.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? nr.fromSchema(i).parseSlice(Pa(e), n.parseOptions) : nr.fromSchema(i).parse(Pa(e), n.parseOptions), n.errorOnInvalidContent && l)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${s}`)
        });
    }
    const a = nr.fromSchema(t);
    return n.slice ? a.parseSlice(Pa(e), n.parseOptions).content : a.parse(Pa(e), n.parseOptions);
  }
  return ca("", t, n);
}
function lC(e, t, n) {
  const r = e.steps.length - 1;
  if (r < t)
    return;
  const o = e.steps[r];
  if (!(o instanceof ut || o instanceof vt))
    return;
  const a = e.mapping.maps[r];
  let l = 0;
  a.forEach((s, i, d, u) => {
    l === 0 && (l = u);
  }), e.setSelection(Ue.near(e.doc.resolve(l), n));
}
var sC = (e) => !("type" in e), iC = (e, t, n) => ({ tr: r, dispatch: o, editor: a }) => {
  var l;
  if (o) {
    n = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    const i = (x) => {
      a.emit("contentError", {
        editor: a,
        error: x,
        disableCollaboration: () => {
          "collaboration" in a.storage && typeof a.storage.collaboration == "object" && a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      });
    }, d = {
      preserveWhitespace: "full",
      ...n.parseOptions
    };
    if (!n.errorOnInvalidContent && !a.options.enableContentCheck && a.options.emitContentError)
      try {
        ca(t, a.schema, {
          parseOptions: d,
          errorOnInvalidContent: !0
        });
      } catch (x) {
        i(x);
      }
    try {
      s = ca(t, a.schema, {
        parseOptions: d,
        errorOnInvalidContent: (l = n.errorOnInvalidContent) != null ? l : a.options.enableContentCheck
      });
    } catch (x) {
      return i(x), !1;
    }
    let { from: u, to: f } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, h = !0, b = !0;
    if ((sC(s) ? s : [s]).forEach((x) => {
      x.check(), h = h ? x.isText && x.marks.length === 0 : !1, b = b ? x.isBlock : !1;
    }), u === f && b) {
      const { parent: x } = r.doc.resolve(u);
      x.isTextblock && !x.type.spec.code && !x.childCount && (u -= 1, f += 1);
    }
    let v;
    if (h) {
      if (Array.isArray(t))
        v = t.map((x) => x.text || "").join("");
      else if (t instanceof Ce) {
        let x = "";
        t.forEach((k) => {
          k.text && (x += k.text);
        }), v = x;
      } else typeof t == "object" && t && t.text ? v = t.text : v = t;
      r.insertText(v, u, f);
    } else {
      v = s;
      const x = r.doc.resolve(u), k = x.node(), L = x.parentOffset === 0, P = k.isText || k.isTextblock, E = k.content.size > 0;
      L && P && E && b && (u = Math.max(0, u - 1)), r.replaceWith(u, f, v);
    }
    n.updateSelection && lC(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", { from: u, text: v }), n.applyPasteRules && r.setMeta("applyPasteRules", { from: u, text: v });
  }
  return !0;
}, dC = () => ({ state: e, dispatch: t }) => A1(e, t), uC = () => ({ state: e, dispatch: t }) => D1(e, t), cC = () => ({ state: e, dispatch: t }) => Ih(e, t), fC = () => ({ state: e, dispatch: t }) => Eh(e, t), hC = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = is(e.doc, e.selection.$from.pos, -1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, bC = () => ({ state: e, dispatch: t, tr: n }) => {
  try {
    const r = is(e.doc, e.selection.$from.pos, 1);
    return r == null ? !1 : (n.join(r, 2), t && t(n), !0);
  } catch {
    return !1;
  }
}, pC = () => ({ state: e, dispatch: t }) => M1(e, t), gC = () => ({ state: e, dispatch: t }) => E1(e, t);
function Sb() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function mC(e) {
  const t = e.split(/-(?!$)/);
  let n = t[t.length - 1];
  n === "Space" && (n = " ");
  let r, o, a, l;
  for (let s = 0; s < t.length - 1; s += 1) {
    const i = t[s];
    if (/^(cmd|meta|m)$/i.test(i))
      l = !0;
    else if (/^a(lt)?$/i.test(i))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(i))
      o = !0;
    else if (/^s(hift)?$/i.test(i))
      a = !0;
    else if (/^mod$/i.test(i))
      Tl() || Sb() ? l = !0 : o = !0;
    else
      throw new Error(`Unrecognized modifier name: ${i}`);
  }
  return r && (n = `Alt-${n}`), o && (n = `Ctrl-${n}`), l && (n = `Meta-${n}`), a && (n = `Shift-${n}`), n;
}
var vC = (e) => ({ editor: t, view: n, tr: r, dispatch: o }) => {
  const a = mC(e).split(/-(?!$)/), l = a.find((d) => !["Alt", "Ctrl", "Meta", "Shift"].includes(d)), s = new KeyboardEvent("keydown", {
    key: l === "Space" ? " " : l,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), i = t.captureTransaction(() => {
    n.someProp("handleKeyDown", (d) => d(n, s));
  });
  return i == null || i.steps.forEach((d) => {
    const u = d.map(r.mapping);
    u && o && r.maybeStep(u);
  }), !0;
};
function sr(e, t, n = {}) {
  const { from: r, to: o, empty: a } = e.selection, l = t ? ft(t, e.schema) : null, s = [];
  e.doc.nodesBetween(r, o, (f, h) => {
    if (f.isText)
      return;
    const b = Math.max(r, h), m = Math.min(o, h + f.nodeSize);
    s.push({
      node: f,
      from: b,
      to: m
    });
  });
  const i = o - r, d = s.filter((f) => l ? l.name === f.node.type.name : !0).filter((f) => Il(f.node.attrs, n, { strict: !1 }));
  return a ? !!d.length : d.reduce((f, h) => f + h.to - h.from, 0) >= i;
}
var xC = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const o = ft(e, n.schema);
  return sr(n, o, t) ? R1(n, r) : !1;
}, yC = () => ({ state: e, dispatch: t }) => Bh(e, t), kC = (e) => ({ state: t, dispatch: n }) => {
  const r = ft(e, t.schema);
  return G1(r)(t, n);
}, wC = () => ({ state: e, dispatch: t }) => Dh(e, t);
function gs(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function Rc(e, t) {
  const n = typeof t == "string" ? [t] : t;
  return Object.keys(e).reduce((r, o) => (n.includes(o) || (r[o] = e[o]), r), {});
}
var CC = (e, t) => ({ tr: n, state: r, dispatch: o }) => {
  let a = null, l = null;
  const s = gs(
    typeof e == "string" ? e : e.name,
    r.schema
  );
  if (!s)
    return !1;
  s === "node" && (a = ft(e, r.schema)), s === "mark" && (l = Vn(e, r.schema));
  let i = !1;
  return n.selection.ranges.forEach((d) => {
    r.doc.nodesBetween(d.$from.pos, d.$to.pos, (u, f) => {
      a && a === u.type && (i = !0, o && n.setNodeMarkup(f, void 0, Rc(u.attrs, t))), l && u.marks.length && u.marks.forEach((h) => {
        l === h.type && (i = !0, o && n.addMark(f, f + u.nodeSize, l.create(Rc(h.attrs, t))));
      });
    });
  }), i;
}, SC = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), $C = () => ({ tr: e, dispatch: t }) => {
  if (t) {
    const n = new Ut(e.doc);
    e.setSelection(n);
  }
  return !0;
}, IC = () => ({ state: e, dispatch: t }) => Lh(e, t), TC = () => ({ state: e, dispatch: t }) => Ah(e, t), LC = () => ({ state: e, dispatch: t }) => z1(e, t), MC = () => ({ state: e, dispatch: t }) => F1(e, t), EC = () => ({ state: e, dispatch: t }) => V1(e, t);
function Ri(e, t, n = {}, r = {}) {
  return ca(e, t, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
var AC = (e, { errorOnInvalidContent: t, emitUpdate: n = !0, parseOptions: r = {} } = {}) => ({ editor: o, tr: a, dispatch: l, commands: s }) => {
  const { doc: i } = a;
  if (r.preserveWhitespace !== "full") {
    const d = Ri(e, o.schema, r, {
      errorOnInvalidContent: t ?? o.options.enableContentCheck
    });
    return l && a.replaceWith(0, i.content.size, d).setMeta("preventUpdate", !n), !0;
  }
  return l && a.setMeta("preventUpdate", !n), s.insertContentAt({ from: 0, to: i.content.size }, e, {
    parseOptions: r,
    errorOnInvalidContent: t ?? o.options.enableContentCheck
  });
};
function $b(e, t) {
  const n = Vn(t, e.schema), { from: r, to: o, empty: a } = e.selection, l = [];
  a ? (e.storedMarks && l.push(...e.storedMarks), l.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, o, (i) => {
    l.push(...i.marks);
  });
  const s = l.find((i) => i.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function Ib(e, t) {
  const n = new kh(e);
  return t.forEach((r) => {
    r.steps.forEach((o) => {
      n.step(o);
    });
  }), n;
}
function DC(e) {
  for (let t = 0; t < e.edgeCount; t += 1) {
    const { type: n } = e.edge(t);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function RC(e, t, n) {
  const r = [];
  return e.nodesBetween(t.from, t.to, (o, a) => {
    n(o) && r.push({
      node: o,
      pos: a
    });
  }), r;
}
function BC(e, t) {
  for (let n = e.depth; n > 0; n -= 1) {
    const r = e.node(n);
    if (t(r))
      return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: r
      };
  }
}
function ms(e) {
  return (t) => BC(t.$from, e);
}
function Re(e, t, n) {
  return e.config[t] === void 0 && e.parent ? Re(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
    ...n,
    parent: e.parent ? Re(e.parent, t, n) : null
  }) : e.config[t];
}
function Pd(e) {
  return e.map((t) => {
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    }, r = Re(t, "addExtensions", n);
    return r ? [t, ...Pd(r())] : t;
  }).flat(10);
}
function zd(e, t) {
  const n = Vr.fromSchema(t).serializeFragment(e), o = document.implementation.createHTMLDocument().createElement("div");
  return o.appendChild(n), o.innerHTML;
}
function Tb(e) {
  return typeof e == "function";
}
function Xe(e, t = void 0, ...n) {
  return Tb(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function OC(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function bo(e) {
  const t = e.filter((o) => o.type === "extension"), n = e.filter((o) => o.type === "node"), r = e.filter((o) => o.type === "mark");
  return {
    baseExtensions: t,
    nodeExtensions: n,
    markExtensions: r
  };
}
function Lb(e) {
  const t = [], { nodeExtensions: n, markExtensions: r } = bo(e), o = [...n, ...r], a = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, l = n.filter((d) => d.name !== "text").map((d) => d.name), s = r.map((d) => d.name), i = [...l, ...s];
  return e.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage,
      extensions: o
    }, f = Re(
      d,
      "addGlobalAttributes",
      u
    );
    if (!f)
      return;
    f().forEach((b) => {
      let m;
      Array.isArray(b.types) ? m = b.types : b.types === "*" ? m = i : b.types === "nodes" ? m = l : b.types === "marks" ? m = s : m = [], m.forEach((v) => {
        Object.entries(b.attributes).forEach(([x, k]) => {
          t.push({
            type: v,
            name: x,
            attribute: {
              ...a,
              ...k
            }
          });
        });
      });
    });
  }), o.forEach((d) => {
    const u = {
      name: d.name,
      options: d.options,
      storage: d.storage
    }, f = Re(
      d,
      "addAttributes",
      u
    );
    if (!f)
      return;
    const h = f();
    Object.entries(h).forEach(([b, m]) => {
      const v = {
        ...a,
        ...m
      };
      typeof (v == null ? void 0 : v.default) == "function" && (v.default = v.default()), v != null && v.isRequired && (v == null ? void 0 : v.default) === void 0 && delete v.default, t.push({
        type: d.name,
        name: b,
        attribute: v
      });
    });
  }), t;
}
function PC(e) {
  const t = [];
  let n = "", r = !1, o = !1, a = 0;
  const l = e.length;
  for (let s = 0; s < l; s += 1) {
    const i = e[s];
    if (i === "'" && !o) {
      r = !r, n += i;
      continue;
    }
    if (i === '"' && !r) {
      o = !o, n += i;
      continue;
    }
    if (!r && !o) {
      if (i === "(") {
        a += 1, n += i;
        continue;
      }
      if (i === ")" && a > 0) {
        a -= 1, n += i;
        continue;
      }
      if (i === ";" && a === 0) {
        t.push(n), n = "";
        continue;
      }
    }
    n += i;
  }
  return n && t.push(n), t;
}
function Bc(e) {
  const t = [], n = PC(e || ""), r = n.length;
  for (let o = 0; o < r; o += 1) {
    const a = n[o], l = a.indexOf(":");
    if (l === -1)
      continue;
    const s = a.slice(0, l).trim(), i = a.slice(l + 1).trim();
    s && i && t.push([s, i]);
  }
  return t;
}
function at(...e) {
  return e.filter((t) => !!t).reduce((t, n) => {
    const r = { ...t };
    return Object.entries(n).forEach(([o, a]) => {
      if (!r[o]) {
        r[o] = a;
        return;
      }
      if (o === "class") {
        const s = a ? String(a).split(" ") : [], i = r[o] ? r[o].split(" ") : [], d = s.filter((u) => !i.includes(u));
        r[o] = [...i, ...d].join(" ");
      } else if (o === "style") {
        const s = new Map([...Bc(r[o]), ...Bc(a)]);
        r[o] = Array.from(s.entries()).map(([i, d]) => `${i}: ${d}`).join("; ");
      } else
        r[o] = a;
    }), r;
  }, {});
}
function fa(e, t) {
  return t.filter((n) => n.type === e.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(e.attrs) || {} : {
    [n.name]: e.attrs[n.name]
  }).reduce((n, r) => at(n, r), {});
}
function zC(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function Oc(e, t) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (n) => {
      const r = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (r === !1)
        return !1;
      const o = t.reduce((a, l) => {
        const s = l.attribute.parseHTML ? l.attribute.parseHTML(n) : zC(n.getAttribute(l.name));
        return s == null ? a : {
          ...a,
          [l.name]: s
        };
      }, {});
      return { ...r, ...o };
    }
  };
}
function Pc(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([t, n]) => t === "attrs" && OC(n) ? !1 : n != null)
  );
}
function zc(e) {
  var t, n;
  const r = {};
  return !((t = e == null ? void 0 : e.attribute) != null && t.isRequired) && "default" in ((e == null ? void 0 : e.attribute) || {}) && (r.default = e.attribute.default), ((n = e == null ? void 0 : e.attribute) == null ? void 0 : n.validate) !== void 0 && (r.validate = e.attribute.validate), [e.name, r];
}
function NC(e, t) {
  var n;
  const r = Lb(e), { nodeExtensions: o, markExtensions: a } = bo(e), l = (n = o.find((d) => Re(d, "topNode"))) == null ? void 0 : n.name, s = Object.fromEntries(
    o.map((d) => {
      const u = r.filter((k) => k.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: t
      }, h = e.reduce((k, L) => {
        const P = Re(L, "extendNodeSchema", f);
        return {
          ...k,
          ...P ? P(d) : {}
        };
      }, {}), b = Pc({
        ...h,
        content: Xe(Re(d, "content", f)),
        marks: Xe(Re(d, "marks", f)),
        group: Xe(Re(d, "group", f)),
        inline: Xe(Re(d, "inline", f)),
        atom: Xe(Re(d, "atom", f)),
        selectable: Xe(Re(d, "selectable", f)),
        draggable: Xe(Re(d, "draggable", f)),
        code: Xe(Re(d, "code", f)),
        whitespace: Xe(Re(d, "whitespace", f)),
        linebreakReplacement: Xe(
          Re(d, "linebreakReplacement", f)
        ),
        defining: Xe(Re(d, "defining", f)),
        isolating: Xe(Re(d, "isolating", f)),
        attrs: Object.fromEntries(u.map(zc))
      }), m = Xe(Re(d, "parseHTML", f));
      m && (b.parseDOM = m.map(
        (k) => Oc(k, u)
      ));
      const v = Re(d, "renderHTML", f);
      v && (b.toDOM = (k) => v({
        node: k,
        HTMLAttributes: fa(k, u)
      }));
      const x = Re(d, "renderText", f);
      return x && (b.toText = x), [d.name, b];
    })
  ), i = Object.fromEntries(
    a.map((d) => {
      const u = r.filter((x) => x.type === d.name), f = {
        name: d.name,
        options: d.options,
        storage: d.storage,
        editor: t
      }, h = e.reduce((x, k) => {
        const L = Re(k, "extendMarkSchema", f);
        return {
          ...x,
          ...L ? L(d) : {}
        };
      }, {}), b = Pc({
        ...h,
        inclusive: Xe(Re(d, "inclusive", f)),
        excludes: Xe(Re(d, "excludes", f)),
        group: Xe(Re(d, "group", f)),
        spanning: Xe(Re(d, "spanning", f)),
        code: Xe(Re(d, "code", f)),
        attrs: Object.fromEntries(u.map(zc))
      }), m = Xe(Re(d, "parseHTML", f));
      m && (b.parseDOM = m.map(
        (x) => Oc(x, u)
      ));
      const v = Re(d, "renderHTML", f);
      return v && (b.toDOM = (x) => v({
        mark: x,
        HTMLAttributes: fa(x, u)
      })), [d.name, b];
    })
  );
  return new ah({
    topNode: l,
    nodes: s,
    marks: i
  });
}
function VC(e) {
  const t = e.filter((n, r) => e.indexOf(n) !== r);
  return Array.from(new Set(t));
}
function Go(e) {
  return e.sort((n, r) => {
    const o = Re(n, "priority") || 100, a = Re(r, "priority") || 100;
    return o > a ? -1 : o < a ? 1 : 0;
  });
}
function Mb(e) {
  const t = Go(Pd(e)), n = VC(t.map((r) => r.name));
  return n.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${n.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`
  ), t;
}
function Eb(e, t, n) {
  const { from: r, to: o } = t, { blockSeparator: a = `

`, textSerializers: l = {} } = n || {};
  let s = "";
  return e.nodesBetween(r, o, (i, d, u, f) => {
    var h;
    i.isBlock && d > r && (s += a);
    const b = l == null ? void 0 : l[i.type.name];
    if (b)
      return u && (s += b({
        node: i,
        pos: d,
        parent: u,
        index: f,
        range: t
      })), !1;
    i.isText && (s += (h = i == null ? void 0 : i.text) == null ? void 0 : h.slice(Math.max(r, d) - d, o - d));
  }), s;
}
function FC(e, t) {
  const n = {
    from: 0,
    to: e.content.size
  };
  return Eb(e, n, t);
}
function Ab(e) {
  return Object.fromEntries(
    Object.entries(e.nodes).filter(([, t]) => t.spec.toText).map(([t, n]) => [t, n.spec.toText])
  );
}
function HC(e, t) {
  const n = ft(t, e.schema), { from: r, to: o } = e.selection, a = [];
  e.doc.nodesBetween(r, o, (s) => {
    a.push(s);
  });
  const l = a.reverse().find((s) => s.type.name === n.name);
  return l ? { ...l.attrs } : {};
}
function Db(e, t) {
  const n = gs(
    typeof t == "string" ? t : t.name,
    e.schema
  );
  return n === "node" ? HC(e, t) : n === "mark" ? $b(e, t) : {};
}
function WC(e, t = JSON.stringify) {
  const n = {};
  return e.filter((r) => {
    const o = t(r);
    return Object.prototype.hasOwnProperty.call(n, o) ? !1 : n[o] = !0;
  });
}
function jC(e) {
  const t = WC(e);
  return t.length === 1 ? t : t.filter((n, r) => !t.filter((a, l) => l !== r).some((a) => n.oldRange.from >= a.oldRange.from && n.oldRange.to <= a.oldRange.to && n.newRange.from >= a.newRange.from && n.newRange.to <= a.newRange.to));
}
function Rb(e) {
  const { mapping: t, steps: n } = e, r = [];
  return t.maps.forEach((o, a) => {
    const l = [];
    if (o.ranges.length)
      o.forEach((s, i) => {
        l.push({ from: s, to: i });
      });
    else {
      const { from: s, to: i } = n[a];
      if (s === void 0 || i === void 0)
        return;
      l.push({ from: s, to: i });
    }
    l.forEach(({ from: s, to: i }) => {
      const d = t.slice(a).map(s, -1), u = t.slice(a).map(i), f = t.invert().map(d, -1), h = t.invert().map(u);
      r.push({
        oldRange: {
          from: f,
          to: h
        },
        newRange: {
          from: d,
          to: u
        }
      });
    });
  }), jC(r);
}
function Nd(e, t, n) {
  const r = [];
  return e === t ? n.resolve(e).marks().forEach((o) => {
    const a = n.resolve(e), l = Od(a, o.type);
    l && r.push({
      mark: o,
      ...l
    });
  }) : n.nodesBetween(e, t, (o, a) => {
    !o || (o == null ? void 0 : o.nodeSize) === void 0 || r.push(
      ...o.marks.map((l) => ({
        from: a,
        to: a + o.nodeSize,
        mark: l
      }))
    );
  }), r;
}
var UC = (e, t, n, r = 20) => {
  const o = e.doc.resolve(n);
  let a = r, l = null;
  for (; a > 0 && l === null; ) {
    const s = o.node(a);
    (s == null ? void 0 : s.type.name) === t ? l = s : a -= 1;
  }
  return [l, a];
};
function So(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function ol(e, t, n) {
  return Object.fromEntries(
    Object.entries(n).filter(([r]) => {
      const o = e.find((a) => a.type === t && a.name === r);
      return o ? o.attribute.keepOnSplit : !1;
    })
  );
}
var GC = (e, t = 500) => {
  let n = "";
  const r = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, r - t), r, (o, a, l, s) => {
    var i, d;
    const u = ((d = (i = o.type.spec).toText) == null ? void 0 : d.call(i, {
      node: o,
      pos: a,
      parent: l,
      index: s
    })) || o.textContent || "%leaf%";
    n += o.isAtom && !o.isText ? u : u.slice(0, Math.max(0, r - a));
  }), n;
};
function Bi(e, t, n = {}) {
  const { empty: r, ranges: o } = e.selection, a = t ? Vn(t, e.schema) : null;
  if (r)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((f) => a ? a.name === f.type.name : !0).find((f) => Il(f.attrs, n, { strict: !1 }));
  let l = 0;
  const s = [];
  if (o.forEach(({ $from: f, $to: h }) => {
    const b = f.pos, m = h.pos;
    e.doc.nodesBetween(b, m, (v, x) => {
      if (a && v.inlineContent && !v.type.allowsMarkType(a))
        return !1;
      if (!v.isText && !v.marks.length)
        return;
      const k = Math.max(b, x), L = Math.min(m, x + v.nodeSize), P = L - k;
      l += P, s.push(
        ...v.marks.map((E) => ({
          mark: E,
          from: k,
          to: L
        }))
      );
    });
  }), l === 0)
    return !1;
  const i = s.filter((f) => a ? a.name === f.mark.type.name : !0).filter((f) => Il(f.mark.attrs, n, { strict: !1 })).reduce((f, h) => f + h.to - h.from, 0), d = s.filter((f) => a ? f.mark.type !== a && f.mark.type.excludes(a) : !0).reduce((f, h) => f + h.to - h.from, 0);
  return (i > 0 ? i + d : i) >= l;
}
function qC(e, t, n = {}) {
  if (!t)
    return sr(e, null, n) || Bi(e, null, n);
  const r = gs(t, e.schema);
  return r === "node" ? sr(e, t, n) : r === "mark" ? Bi(e, t, n) : !1;
}
var KC = (e, t) => {
  const { $from: n, $to: r, $anchor: o } = e.selection;
  if (t) {
    const a = ms((s) => s.type.name === t)(e.selection);
    if (!a)
      return !1;
    const l = e.doc.resolve(a.pos + 1);
    return o.pos + 1 === l.end();
  }
  return !(r.parentOffset < r.parent.nodeSize - 2 || n.pos !== r.pos);
}, JC = (e) => {
  const { $from: t, $to: n } = e.selection;
  return !(t.parentOffset > 0 || t.pos !== n.pos);
};
function Nc(e, t) {
  return Array.isArray(t) ? t.some((n) => (typeof n == "string" ? n : n.name) === e.name) : t;
}
function Ws(e, t) {
  const { nodeExtensions: n } = bo(t), r = n.find((l) => l.name === e);
  if (!r)
    return !1;
  const o = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, a = Xe(Re(r, "group", o));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function ha(e, {
  checkChildren: t = !0,
  ignoreWhitespace: n = !1
} = {}) {
  var r;
  if (n) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return !/\S/.test((r = e.text) != null ? r : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (t) {
    let o = !0;
    return e.content.forEach((a) => {
      o !== !1 && (ha(a, { ignoreWhitespace: n, checkChildren: t }) || (o = !1));
    }), o;
  }
  return !1;
}
function Bb(e) {
  return e instanceof Oe;
}
var Ob = class Pb {
  constructor(t) {
    this.position = t;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(t) {
    return new Pb(t.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function ZC(e, t) {
  const n = t.mapping.mapResult(e.position);
  return {
    position: new Ob(n.pos),
    mapResult: n
  };
}
function YC(e) {
  return new Ob(e);
}
function XC(e, t, n) {
  var r;
  const { selection: o } = t;
  let a = null;
  if (kb(o) && (a = o.$cursor), a) {
    const s = (r = e.storedMarks) != null ? r : a.marks();
    return a.parent.type.allowsMarkType(n) && (!!n.isInSet(s) || !s.some((d) => d.type.excludes(n)));
  }
  const { ranges: l } = o;
  return l.some(({ $from: s, $to: i }) => {
    let d = s.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(n) : !1;
    return e.doc.nodesBetween(s.pos, i.pos, (u, f, h) => {
      if (d)
        return !1;
      if (u.isInline) {
        const b = !h || h.type.allowsMarkType(n), m = !!n.isInSet(u.marks) || !u.marks.some((v) => v.type.excludes(n));
        d = b && m;
      }
      return !d;
    }), d;
  });
}
var QC = (e, t = {}) => ({ tr: n, state: r, dispatch: o }) => {
  const { selection: a } = n, { empty: l, ranges: s } = a, i = Vn(e, r.schema);
  if (o)
    if (l) {
      const d = $b(r, i);
      n.addStoredMark(
        i.create({
          ...d,
          ...t
        })
      );
    } else
      s.forEach((d) => {
        const u = d.$from.pos, f = d.$to.pos;
        r.doc.nodesBetween(u, f, (h, b) => {
          const m = Math.max(b, u), v = Math.min(b + h.nodeSize, f);
          h.marks.find((k) => k.type === i) ? h.marks.forEach((k) => {
            i === k.type && n.addMark(
              m,
              v,
              i.create({
                ...k.attrs,
                ...t
              })
            );
          }) : n.addMark(m, v, i.create(t));
        });
      });
  return XC(r, n, i);
}, _C = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), eS = (e, t = {}) => ({ state: n, dispatch: r, chain: o }) => {
  const a = ft(e, n.schema);
  let l;
  return n.selection.$anchor.sameParent(n.selection.$head) && (l = n.selection.$anchor.parent.attrs), a.isTextblock ? o().command(({ commands: s }) => Yu(a, { ...l, ...t })(n) ? !0 : s.clearNodes()).command(({ state: s }) => Yu(a, { ...l, ...t })(s, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, tS = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, o = kr(e, 0, r.content.size), a = Oe.create(r, o);
    t.setSelection(a);
  }
  return !0;
}, nS = (e, t) => ({ tr: n, state: r, dispatch: o }) => {
  const { selection: a } = r;
  let l, s;
  return typeof t == "number" ? (l = t, s = t) : t && "from" in t && "to" in t ? (l = t.from, s = t.to) : (l = a.from, s = a.to), o && n.doc.nodesBetween(l, s, (i, d) => {
    i.isText || n.setNodeMarkup(d, void 0, {
      ...i.attrs,
      dir: e
    });
  }), !0;
}, rS = (e) => ({ tr: t, dispatch: n }) => {
  if (n) {
    const { doc: r } = t, { from: o, to: a } = typeof e == "number" ? { from: e, to: e } : e, l = Fe.atStart(r).from, s = Fe.atEnd(r).to, i = kr(o, l, s), d = kr(a, l, s), u = Fe.create(r, i, d);
    t.setSelection(u);
  }
  return !0;
}, oS = (e) => ({ state: t, dispatch: n }) => {
  const r = ft(e, t.schema);
  return J1(r)(t, n);
};
function Vc(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const r = n.filter((o) => t == null ? void 0 : t.includes(o.type.name));
    e.tr.ensureMarks(r);
  }
}
var aS = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: r, editor: o }) => {
  const { selection: a, doc: l } = t, { $from: s, $to: i } = a, d = o.extensionManager.attributes, u = ol(d, s.node().type.name, s.node().attrs);
  if (a instanceof Oe && a.node.isBlock)
    return !s.parentOffset || !On(l, s.pos) ? !1 : (r && (e && Vc(n, o.extensionManager.splittableMarks), t.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const f = i.parentOffset === i.parent.content.size, h = s.depth === 0 ? void 0 : DC(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let b = f && h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0, m = On(t.doc, t.mapping.map(s.pos), 1, b);
  if (!b && !m && On(t.doc, t.mapping.map(s.pos), 1, h ? [{ type: h }] : void 0) && (m = !0, b = h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0), r) {
    if (m && (a instanceof Fe && t.deleteSelection(), t.split(t.mapping.map(s.pos), 1, b), h && !f && !s.parentOffset && s.parent.type !== h)) {
      const v = t.mapping.map(s.before()), x = t.doc.resolve(v);
      s.node(-1).canReplaceWith(x.index(), x.index() + 1, h) && t.setNodeMarkup(t.mapping.map(s.before()), h);
    }
    e && Vc(n, o.extensionManager.splittableMarks), t.scrollIntoView();
  }
  return m;
}, lS = (e, t = {}) => ({ tr: n, state: r, dispatch: o, editor: a }) => {
  var l;
  const s = ft(e, r.schema), { $from: i, $to: d } = r.selection, u = r.selection.node;
  if (u && u.isBlock || i.depth < 2 || !i.sameParent(d))
    return !1;
  const f = i.node(-1);
  if (f.type !== s)
    return !1;
  const h = a.extensionManager.attributes;
  if (i.parent.content.size === 0 && i.node(-1).childCount === i.indexAfter(-1)) {
    if (i.depth === 2 || i.node(-3).type !== s || i.index(-2) !== i.node(-2).childCount - 1)
      return !1;
    if (o) {
      let k = Ce.empty;
      const L = i.index(-1) ? 1 : i.index(-2) ? 2 : 3;
      for (let J = i.depth - L; J >= i.depth - 3; J -= 1)
        k = Ce.from(i.node(J).copy(k));
      const P = (
        // eslint-disable-next-line no-nested-ternary
        i.indexAfter(-1) < i.node(-2).childCount ? 1 : i.indexAfter(-2) < i.node(-3).childCount ? 2 : 3
      ), E = {
        ...ol(h, i.node().type.name, i.node().attrs),
        ...t
      }, O = ((l = s.contentMatch.defaultType) == null ? void 0 : l.createAndFill(E)) || void 0;
      k = k.append(Ce.from(s.createAndFill(null, O) || void 0));
      const R = i.before(i.depth - (L - 1));
      n.replace(R, i.after(-P), new Ee(k, 4 - L, 0));
      let V = -1;
      n.doc.nodesBetween(R, n.doc.content.size, (J, F) => {
        if (V > -1)
          return !1;
        J.isTextblock && J.content.size === 0 && (V = F + 1);
      }), V > -1 && n.setSelection(Fe.near(n.doc.resolve(V))), n.scrollIntoView();
    }
    return !0;
  }
  const b = d.pos === i.end() ? f.contentMatchAt(0).defaultType : null, m = {
    ...ol(h, f.type.name, f.attrs),
    ...t
  }, v = {
    ...ol(h, i.node().type.name, i.node().attrs),
    ...t
  };
  n.delete(i.pos, d.pos);
  const x = b ? [
    { type: s, attrs: m },
    { type: b, attrs: v }
  ] : [{ type: s, attrs: m }];
  if (!On(n.doc, i.pos, 2))
    return !1;
  if (o) {
    const { selection: k, storedMarks: L } = r, { splittableMarks: P } = a.extensionManager, E = L || k.$to.parentOffset && k.$from.marks();
    if (n.split(i.pos, 2, x).scrollIntoView(), !E || !o)
      return !0;
    const O = E.filter((R) => P.includes(R.type.name));
    n.ensureMarks(O);
  }
  return !0;
}, js = (e, t) => {
  const n = ms((l) => l.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (r === void 0)
    return !0;
  const o = e.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && fr(e.doc, n.pos) && e.join(n.pos), !0;
}, Us = (e, t) => {
  const n = ms((l) => l.type === t)(e.selection);
  if (!n)
    return !0;
  const r = e.doc.resolve(n.start).after(n.depth);
  if (r === void 0)
    return !0;
  const o = e.doc.nodeAt(r);
  return n.node.type === (o == null ? void 0 : o.type) && fr(e.doc, r) && e.join(r), !0;
};
function sS(e) {
  const t = e.doc, n = t.firstChild;
  if (!n)
    return null;
  const r = t.resolve(1), o = t.resolve(n.nodeSize - 1);
  return Fe.between(r, o);
}
var iS = (e, t, n, r = {}) => ({ editor: o, tr: a, state: l, dispatch: s, chain: i, commands: d, can: u }) => {
  const { extensions: f, splittableMarks: h } = o.extensionManager, b = ft(e, l.schema), m = ft(t, l.schema), { selection: v, storedMarks: x } = l, { $from: k, $to: L } = v, P = k.blockRange(L), E = x || v.$to.parentOffset && v.$from.marks();
  if (!P)
    return !1;
  const O = ms((U) => Ws(U.type.name, f))(v), R = v.from === 0 && v.to === l.doc.content.size, V = l.doc.content.content, J = V.length === 1 ? V[0] : null, F = R && J && Ws(J.type.name, f) ? {
    node: J,
    pos: 0
  } : null, A = O ?? F, j = !!O && P.depth >= 1 && P.depth - O.depth <= 1, _ = !!F;
  if ((j || _) && A) {
    if (A.node.type === b)
      return R && _ ? i().command(({ tr: U, dispatch: W }) => {
        const K = sS(U);
        return K ? (U.setSelection(K), W && W(U), !0) : !1;
      }).liftListItem(m).run() : d.liftListItem(m);
    if (Ws(A.node.type.name, f) && b.validContent(A.node.content))
      return i().command(() => (a.setNodeMarkup(A.pos, b), !0)).command(() => js(a, b)).command(() => Us(a, b)).run();
  }
  return !n || !E || !s ? i().command(() => u().wrapInList(b, r) ? !0 : d.clearNodes()).wrapInList(b, r).command(() => js(a, b)).command(() => Us(a, b)).run() : i().command(() => {
    const U = u().wrapInList(b, r), W = E.filter((K) => h.includes(K.type.name));
    return a.ensureMarks(W), U ? !0 : d.clearNodes();
  }).wrapInList(b, r).command(() => js(a, b)).command(() => Us(a, b)).run();
}, dS = (e, t = {}, n = {}) => ({ state: r, commands: o }) => {
  const { extendEmptyMarkRange: a = !1 } = n, l = Vn(e, r.schema);
  return Bi(r, l, t) ? o.unsetMark(l, { extendEmptyMarkRange: a }) : o.setMark(l, t);
}, uS = (e, t, n = {}) => ({ state: r, commands: o }) => {
  const a = ft(e, r.schema), l = ft(t, r.schema), s = sr(r, a, n);
  let i;
  return r.selection.$anchor.sameParent(r.selection.$head) && (i = r.selection.$anchor.parent.attrs), s ? o.setNode(l, i) : o.setNode(a, { ...i, ...n });
}, cS = (e, t = {}) => ({ state: n, commands: r }) => {
  const o = ft(e, n.schema);
  return sr(n, o, t) ? r.lift(o) : r.wrapIn(o, t);
}, fS = () => ({ state: e, dispatch: t }) => {
  const n = e.plugins;
  for (let r = 0; r < n.length; r += 1) {
    const o = n[r];
    let a;
    if (o.spec.isInputRules && (a = o.getState(e))) {
      if (t) {
        const l = e.tr, s = a.transform;
        for (let i = s.steps.length - 1; i >= 0; i -= 1)
          l.step(s.steps[i].invert(s.docs[i]));
        if (a.text) {
          const i = l.doc.resolve(a.from).marks();
          l.replaceWith(a.from, a.to, e.schema.text(a.text, i));
        } else
          l.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, hS = () => ({ tr: e, dispatch: t }) => {
  const { selection: n } = e, { empty: r, ranges: o } = n;
  return r || t && o.forEach((a) => {
    e.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, bS = (e, t = {}) => ({ tr: n, state: r, dispatch: o }) => {
  var a;
  const { extendEmptyMarkRange: l = !1 } = t, { selection: s } = n, i = Vn(e, r.schema), { $from: d, empty: u, ranges: f } = s;
  if (!o)
    return !0;
  if (u && l) {
    let { from: h, to: b } = s;
    const m = (a = d.marks().find((x) => x.type === i)) == null ? void 0 : a.attrs, v = Od(d, i, m);
    v && (h = v.from, b = v.to), n.removeMark(h, b, i);
  } else
    f.forEach((h) => {
      n.removeMark(h.$from.pos, h.$to.pos, i);
    });
  return n.removeStoredMark(i), !0;
}, pS = (e) => ({ tr: t, state: n, dispatch: r }) => {
  const { selection: o } = n;
  let a, l;
  return typeof e == "number" ? (a = e, l = e) : e && "from" in e && "to" in e ? (a = e.from, l = e.to) : (a = o.from, l = o.to), r && t.doc.nodesBetween(a, l, (s, i) => {
    if (s.isText)
      return;
    const d = { ...s.attrs };
    delete d.dir, t.setNodeMarkup(i, void 0, d);
  }), !0;
}, gS = (e, t = {}) => ({ tr: n, state: r, dispatch: o }) => {
  let a = null, l = null;
  const s = gs(
    typeof e == "string" ? e : e.name,
    r.schema
  );
  if (!s)
    return !1;
  s === "node" && (a = ft(e, r.schema)), s === "mark" && (l = Vn(e, r.schema));
  let i = !1;
  return n.selection.ranges.forEach((d) => {
    const u = d.$from.pos, f = d.$to.pos;
    let h, b, m, v;
    n.selection.empty ? r.doc.nodesBetween(u, f, (x, k) => {
      a && a === x.type && (i = !0, m = Math.max(k, u), v = Math.min(k + x.nodeSize, f), h = k, b = x);
    }) : r.doc.nodesBetween(u, f, (x, k) => {
      k < u && a && a === x.type && (i = !0, m = Math.max(k, u), v = Math.min(k + x.nodeSize, f), h = k, b = x), k >= u && k <= f && (a && a === x.type && (i = !0, o && n.setNodeMarkup(k, void 0, {
        ...x.attrs,
        ...t
      })), l && x.marks.length && x.marks.forEach((L) => {
        if (l === L.type && (i = !0, o)) {
          const P = Math.max(k, u), E = Math.min(k + x.nodeSize, f);
          n.addMark(
            P,
            E,
            l.create({
              ...L.attrs,
              ...t
            })
          );
        }
      }));
    }), b && (h !== void 0 && o && n.setNodeMarkup(h, void 0, {
      ...b.attrs,
      ...t
    }), l && b.marks.length && b.marks.forEach((x) => {
      l === x.type && o && n.addMark(
        m,
        v,
        l.create({
          ...x.attrs,
          ...t
        })
      );
    }));
  }), i;
}, mS = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const o = ft(e, n.schema);
  return H1(o, t)(n, r);
}, vS = (e, t = {}) => ({ state: n, dispatch: r }) => {
  const o = ft(e, n.schema);
  return W1(o, t)(n, r);
}, xS = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e, ...t) {
    const n = this.callbacks[e];
    return n && n.forEach((r) => r.apply(this, t)), this;
  }
  off(e, t) {
    const n = this.callbacks[e];
    return n && (t ? this.callbacks[e] = n.filter((r) => r !== t) : delete this.callbacks[e]), this;
  }
  once(e, t) {
    const n = (...r) => {
      this.off(e, n), t.apply(this, r);
    };
    return this.on(e, n);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, vs = class {
  constructor(e) {
    var t;
    this.find = e.find, this.handler = e.handler, this.undoable = (t = e.undoable) != null ? t : !0;
  }
}, yS = (e, t) => {
  if (Bd(t))
    return t.exec(e);
  const n = t(e);
  if (!n)
    return null;
  const r = [n.text];
  return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
};
function za(e) {
  var t;
  const { editor: n, from: r, to: o, text: a, rules: l, plugin: s } = e, { view: i } = n;
  if (i.composing)
    return !1;
  const d = i.state.doc.resolve(r);
  if (
    // check for code node
    d.parent.type.spec.code || (t = d.nodeBefore || d.nodeAfter) != null && t.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = GC(d) + a;
  return l.forEach((h) => {
    if (u)
      return;
    const b = yS(f, h.find);
    if (!b)
      return;
    const m = i.state.tr, v = bs({
      state: i.state,
      transaction: m
    }), x = {
      from: r - (b[0].length - a.length),
      to: o
    }, { commands: k, chain: L, can: P } = new ps({
      editor: n,
      state: v
    });
    h.handler({
      state: v,
      range: x,
      match: b,
      commands: k,
      chain: L,
      can: P
    }) === null || !m.steps.length || (h.undoable && m.setMeta(s, {
      transform: m,
      from: r,
      to: o,
      text: a
    }), i.dispatch(m), u = !0);
  }), u;
}
function kS(e) {
  const { editor: t, rules: n } = e, r = new lt({
    state: {
      init() {
        return null;
      },
      apply(o, a, l) {
        const s = o.getMeta(r);
        if (s)
          return s;
        const i = o.getMeta("applyInputRules");
        return !!i && setTimeout(() => {
          let { text: u } = i;
          typeof u == "string" ? u = u : u = zd(Ce.from(u), l.schema);
          const { from: f } = i, h = f + u.length;
          za({
            editor: t,
            from: f,
            to: h,
            text: u,
            rules: n,
            plugin: r
          });
        }), o.selectionSet || o.docChanged ? null : a;
      }
    },
    props: {
      handleTextInput(o, a, l, s) {
        return za({
          editor: t,
          from: a,
          to: l,
          text: s,
          rules: n,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (o) => (setTimeout(() => {
          const { $cursor: a } = o.state.selection;
          a && za({
            editor: t,
            from: a.pos,
            to: a.pos,
            text: "",
            rules: n,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(o, a) {
        if (a.key !== "Enter")
          return !1;
        const { $cursor: l } = o.state.selection;
        return l ? za({
          editor: t,
          from: l.pos,
          to: l.pos,
          text: `
`,
          rules: n,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function wS(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Na(e) {
  return wS(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function zb(e, t) {
  const n = { ...e };
  return Na(e) && Na(t) && Object.keys(t).forEach((r) => {
    Na(t[r]) && Na(e[r]) ? n[r] = zb(e[r], t[r]) : n[r] = t[r];
  }), n;
}
var Vd = class {
  constructor(e = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Xe(
        Re(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Xe(
        Re(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(e = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zb(this.options, e)
    });
    return t.name = this.name, t.parent = this.parent, this.child = null, t;
  }
  extend(e = {}) {
    const t = new this.constructor({ ...this.config, ...e });
    return t.parent = this, this.child = t, t.name = "name" in e ? e.name : t.parent.name, t;
  }
}, Fn = class Nb extends Vd {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(t = {}) {
    const n = typeof t == "function" ? t() : t;
    return new Nb(n);
  }
  static handleExit({ editor: t, mark: n }) {
    const { tr: r } = t.state, o = t.state.selection.$from;
    if (o.pos === o.end()) {
      const l = o.marks();
      if (!!!l.find((d) => (d == null ? void 0 : d.type.name) === n.name))
        return !1;
      const i = l.find((d) => (d == null ? void 0 : d.type.name) === n.name);
      return i && r.removeStoredMark(i), r.insertText(" ", o.pos), t.view.dispatch(r), !0;
    }
    return !1;
  }
  configure(t) {
    return super.configure(t);
  }
  extend(t) {
    const n = typeof t == "function" ? t() : t;
    return super.extend(n);
  }
};
function CS(e) {
  return typeof e == "number";
}
var SS = class {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}, $S = (e, t, n) => {
  if (Bd(t))
    return [...e.matchAll(t)];
  const r = t(e, n);
  return r ? r.map((o) => {
    const a = [o.text];
    return a.index = o.index, a.input = e, a.data = o.data, o.replaceWith && (o.text.includes(o.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), a.push(o.replaceWith)), a;
  }) : [];
};
function IS(e) {
  const { editor: t, state: n, from: r, to: o, rule: a, pasteEvent: l, dropEvent: s } = e, { commands: i, chain: d, can: u } = new ps({
    editor: t,
    state: n
  }), f = [];
  return n.doc.nodesBetween(r, o, (b, m) => {
    var v, x, k, L, P;
    if ((x = (v = b.type) == null ? void 0 : v.spec) != null && x.code || !(b.isText || b.isTextblock || b.isInline))
      return;
    const E = (P = (L = (k = b.content) == null ? void 0 : k.size) != null ? L : b.nodeSize) != null ? P : 0, O = Math.max(r, m), R = Math.min(o, m + E);
    if (O >= R)
      return;
    const V = b.isText ? b.text || "" : b.textBetween(O - m, R - m, void 0, "￼");
    $S(V, a.find, l).forEach((F) => {
      if (F.index === void 0)
        return;
      const A = O + F.index + 1, j = A + F[0].length, _ = {
        from: n.tr.mapping.map(A),
        to: n.tr.mapping.map(j)
      }, U = a.handler({
        state: n,
        range: _,
        match: F,
        commands: i,
        chain: d,
        can: u,
        pasteEvent: l,
        dropEvent: s
      });
      f.push(U);
    });
  }), f.every((b) => b !== null);
}
var Va = null, TS = (e) => {
  var t;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (t = n.clipboardData) == null || t.setData("text/html", e), n;
};
function LS(e) {
  const { editor: t, rules: n } = e;
  let r = null, o = !1, a = !1, l = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
  try {
    s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    s = null;
  }
  const i = ({
    state: u,
    from: f,
    to: h,
    rule: b,
    pasteEvt: m
  }) => {
    const v = u.tr, x = bs({
      state: u,
      transaction: v
    });
    if (!(!IS({
      editor: t,
      state: x,
      from: Math.max(f - 1, 0),
      to: h.b - 1,
      rule: b,
      pasteEvent: m,
      dropEvent: s
    }) || !v.steps.length)) {
      try {
        s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        s = null;
      }
      return l = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, v;
    }
  };
  return n.map((u) => new lt({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const h = (m) => {
        var v;
        r = (v = f.dom.parentElement) != null && v.contains(m.target) ? f.dom.parentElement : null, r && (Va = t);
      }, b = () => {
        Va && (Va = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", b), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", b);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, h) => {
          if (a = r === f.dom.parentElement, s = h, !a) {
            const b = Va;
            b != null && b.isEditable && setTimeout(() => {
              const m = b.state.selection;
              m && b.commands.deleteRange({ from: m.from, to: m.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, h) => {
          var b;
          const m = (b = h.clipboardData) == null ? void 0 : b.getData("text/html");
          return l = h, o = !!(m != null && m.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, h, b) => {
      const m = f[0], v = m.getMeta("uiEvent") === "paste" && !o, x = m.getMeta("uiEvent") === "drop" && !a, k = m.getMeta("applyPasteRules"), L = !!k;
      if (!v && !x && !L)
        return;
      if (L) {
        let { text: O } = k;
        typeof O == "string" ? O = O : O = zd(Ce.from(O), b.schema);
        const { from: R } = k, V = R + O.length, J = TS(O);
        return i({
          rule: u,
          state: b,
          from: R,
          to: { b: V },
          pasteEvt: J
        });
      }
      const P = h.doc.content.findDiffStart(b.doc.content), E = h.doc.content.findDiffEnd(b.doc.content);
      if (!(!CS(P) || !E || P === E.b))
        return i({
          rule: u,
          state: b,
          from: P,
          to: E,
          pasteEvt: l
        });
    }
  }));
}
var xs = class {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.baseExtensions = e, this.extensions = Mb(e), this.schema = NC(this.extensions, t), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, t) => {
      const n = {
        name: t.name,
        options: t.options,
        storage: this.editor.extensionStorage[t.name],
        editor: this.editor,
        type: So(t.name, this.schema)
      }, r = Re(t, "addCommands", n);
      return r ? {
        ...e,
        ...r()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this;
    return Go([...this.extensions].reverse()).flatMap((r) => {
      const o = {
        name: r.name,
        options: r.options,
        storage: this.editor.extensionStorage[r.name],
        editor: e,
        type: So(r.name, this.schema)
      }, a = [], l = Re(
        r,
        "addKeyboardShortcuts",
        o
      );
      let s = {};
      if (r.type === "mark" && Re(r, "exitable", o) && (s.ArrowRight = () => Fn.handleExit({ editor: e, mark: r })), l) {
        const h = Object.fromEntries(
          Object.entries(l()).map(([b, m]) => [b, () => m({ editor: e })])
        );
        s = { ...s, ...h };
      }
      const i = N2(s);
      a.push(i);
      const d = Re(r, "addInputRules", o);
      if (Nc(r, e.options.enableInputRules) && d) {
        const h = d();
        if (h && h.length) {
          const b = kS({
            editor: e,
            rules: h
          }), m = Array.isArray(b) ? b : [b];
          a.push(...m);
        }
      }
      const u = Re(r, "addPasteRules", o);
      if (Nc(r, e.options.enablePasteRules) && u) {
        const h = u();
        if (h && h.length) {
          const b = LS({ editor: e, rules: h });
          a.push(...b);
        }
      }
      const f = Re(
        r,
        "addProseMirrorPlugins",
        o
      );
      if (f) {
        const h = f();
        a.push(...h);
      }
      return a;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Lb(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: t } = bo(this.extensions);
    return Object.fromEntries(
      t.filter((n) => !!Re(n, "addNodeView")).map((n) => {
        const r = this.attributes.filter((i) => i.type === n.name), o = {
          name: n.name,
          options: n.options,
          storage: this.editor.extensionStorage[n.name],
          editor: e,
          type: ft(n.name, this.schema)
        }, a = Re(n, "addNodeView", o);
        if (!a)
          return [];
        const l = a();
        if (!l)
          return [];
        const s = (i, d, u, f, h) => {
          const b = fa(i, r);
          return l({
            // pass-through
            node: i,
            view: d,
            getPos: u,
            decorations: f,
            innerDecorations: h,
            // tiptap-specific
            editor: e,
            extension: n,
            HTMLAttributes: b
          });
        };
        return [n.name, s];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(e) {
    const { editor: t } = this;
    return Go([...this.extensions].reverse()).reduceRight((r, o) => {
      const a = {
        name: o.name,
        options: o.options,
        storage: this.editor.extensionStorage[o.name],
        editor: t,
        type: So(o.name, this.schema)
      }, l = Re(
        o,
        "dispatchTransaction",
        a
      );
      return l ? (s) => {
        l.call(a, { transaction: s, next: r });
      } : r;
    }, e);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(e) {
    const { editor: t } = this;
    return Go([...this.extensions]).reduce(
      (r, o) => {
        const a = {
          name: o.name,
          options: o.options,
          storage: this.editor.extensionStorage[o.name],
          editor: t,
          type: So(o.name, this.schema)
        }, l = Re(
          o,
          "transformPastedHTML",
          a
        );
        return l ? (s, i) => {
          const d = r(s, i);
          return l.call(a, d);
        } : r;
      },
      e || ((r) => r)
    );
  }
  get markViews() {
    const { editor: e } = this, { markExtensions: t } = bo(this.extensions);
    return Object.fromEntries(
      t.filter((n) => !!Re(n, "addMarkView")).map((n) => {
        const r = this.attributes.filter((s) => s.type === n.name), o = {
          name: n.name,
          options: n.options,
          storage: this.editor.extensionStorage[n.name],
          editor: e,
          type: Vn(n.name, this.schema)
        }, a = Re(n, "addMarkView", o);
        if (!a)
          return [];
        const l = (s, i, d) => {
          const u = fa(s, r);
          return a()({
            // pass-through
            mark: s,
            view: i,
            inline: d,
            // tiptap-specific
            editor: e,
            extension: n,
            HTMLAttributes: u,
            updateAttributes: (f) => {
              jS(s, e, f);
            }
          });
        };
        return [n.name, l];
      })
    );
  }
  /**
   * Destroy the extension manager and clean up all extension references
   * to prevent memory leaks through parent/child extension chains.
   *
   * Walks each extension's full parent chain and nulls every forward
   * `parent.child → current` link where the parent still points to the
   * current node. This breaks the retention path from module-scope
   * singleton roots through deep extend() chains.
   *
   * Only ancestor `.child` links matching the current chain are cleared.
   * The `.parent` pointer on ancestors is never touched — extensions
   * may be shared across live editors, so their own backward references
   * and non-matching forward links must remain intact.
   */
  destroy() {
    this.extensions.forEach((e) => {
      let t = e;
      for (; t.parent; ) {
        const n = t.parent;
        n.child === t && (n.child = null), t = n;
      }
    }), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const e = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      e.map((t) => [t.name, t.storage])
    ), e.forEach((t) => {
      var n;
      const r = {
        name: t.name,
        options: t.options,
        storage: this.editor.extensionStorage[t.name],
        editor: this.editor,
        type: So(t.name, this.schema)
      };
      t.type === "mark" && ((n = Xe(Re(t, "keepOnSplit", r))) == null || n) && this.splittableMarks.push(t.name);
      const o = Re(t, "onBeforeCreate", r), a = Re(t, "onCreate", r), l = Re(t, "onUpdate", r), s = Re(
        t,
        "onSelectionUpdate",
        r
      ), i = Re(t, "onTransaction", r), d = Re(t, "onFocus", r), u = Re(t, "onBlur", r), f = Re(t, "onDestroy", r);
      o && this.editor.on("beforeCreate", o), a && this.editor.on("create", a), l && this.editor.on("update", l), s && this.editor.on("selectionUpdate", s), i && this.editor.on("transaction", i), d && this.editor.on("focus", d), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
};
xs.resolve = Mb;
xs.sort = Go;
xs.flatten = Pd;
var MS = {};
Rd(MS, {
  ClipboardTextSerializer: () => Fb,
  Commands: () => Hb,
  Delete: () => Wb,
  Drop: () => jb,
  Editable: () => Ub,
  FocusEvents: () => qb,
  Keymap: () => Kb,
  Paste: () => Jb,
  Tabindex: () => Zb,
  TextDirection: () => Yb,
  focusEventsPluginKey: () => Gb
});
var _e = class Vb extends Vd {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(t = {}) {
    const n = typeof t == "function" ? t() : t;
    return new Vb(n);
  }
  configure(t) {
    return super.configure(t);
  }
  extend(t) {
    const n = typeof t == "function" ? t() : t;
    return super.extend(n);
  }
}, Fb = _e.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: t, schema: n } = e, { doc: r, selection: o } = t, { ranges: a } = o, l = Math.min(...a.map((u) => u.$from.pos)), s = Math.max(...a.map((u) => u.$to.pos)), i = Ab(n);
            return Eb(r, { from: l, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: i
            });
          }
        }
      })
    ];
  }
}), Hb = _e.create({
  name: "commands",
  addCommands() {
    return {
      ...xb
    };
  }
}), Wb = _e.create({
  name: "delete",
  onUpdate({ transaction: e, appendedTransactions: t }) {
    var n, r, o;
    const a = () => {
      var l, s, i, d;
      if ((d = (i = (s = (l = this.editor.options.coreExtensionOptions) == null ? void 0 : l.delete) == null ? void 0 : s.filterTransaction) == null ? void 0 : i.call(s, e)) != null ? d : e.getMeta("y-sync$"))
        return;
      const u = Ib(e.before, [e, ...t]);
      Rb(u).forEach((b) => {
        u.mapping.mapResult(b.oldRange.from).deletedAfter && u.mapping.mapResult(b.oldRange.to).deletedBefore && u.before.nodesBetween(b.oldRange.from, b.oldRange.to, (m, v) => {
          const x = v + m.nodeSize - 2, k = b.oldRange.from <= v && x <= b.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: m,
            from: v,
            to: x,
            newFrom: u.mapping.map(v),
            newTo: u.mapping.map(x),
            deletedRange: b.oldRange,
            newRange: b.newRange,
            partial: !k,
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        });
      });
      const h = u.mapping;
      u.steps.forEach((b, m) => {
        var v, x;
        if (b instanceof sn) {
          const k = h.slice(m).map(b.from, -1), L = h.slice(m).map(b.to), P = h.invert().map(k, -1), E = h.invert().map(L), O = k > 0 ? (v = u.doc.nodeAt(k - 1)) == null ? void 0 : v.marks.some((V) => V.eq(b.mark)) : !1, R = (x = u.doc.nodeAt(L)) == null ? void 0 : x.marks.some((V) => V.eq(b.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: b.mark,
            from: b.from,
            to: b.to,
            deletedRange: {
              from: P,
              to: E
            },
            newRange: {
              from: k,
              to: L
            },
            partial: !!(R || O),
            editor: this.editor,
            transaction: e,
            combinedTransform: u
          });
        }
      });
    };
    (o = (r = (n = this.editor.options.coreExtensionOptions) == null ? void 0 : n.delete) == null ? void 0 : r.async) == null || o ? setTimeout(a, 0) : a();
  }
}), jb = _e.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("tiptapDrop"),
        props: {
          handleDrop: (e, t, n, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: t,
              slice: n,
              moved: r
            });
          }
        }
      })
    ];
  }
}), Ub = _e.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Gb = new gt("focusEvents"), qb = _e.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new lt({
        key: Gb,
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const r = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const r = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), Kb = _e.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: l }) => [
      () => l.undoInputRule(),
      // maybe convert first text block node to default node
      () => l.command(({ tr: s }) => {
        const { selection: i, doc: d } = s, { empty: u, $anchor: f } = i, { pos: h, parent: b } = f, m = f.parent.isTextblock && h > 0 ? s.doc.resolve(h - 1) : f, v = m.parent.type.spec.isolating, x = f.pos - f.parentOffset, k = v && m.parent.childCount === 1 ? x === f.pos : Ue.atStart(d).from === h;
        return !u || !b.type.isTextblock || b.textContent.length || !k || k && f.parent.type.name === "paragraph" ? !1 : l.clearNodes();
      }),
      () => l.deleteSelection(),
      () => l.joinBackward(),
      () => l.selectNodeBackward()
    ]), t = () => this.editor.commands.first(({ commands: l }) => [
      () => l.deleteSelection(),
      () => l.deleteCurrentNode(),
      () => l.joinForward(),
      () => l.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: l }) => [
        () => l.newlineInCode(),
        () => l.createParagraphNear(),
        () => l.liftEmptyBlock(),
        () => l.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: t,
      "Mod-Delete": t,
      "Mod-a": () => this.editor.commands.selectAll()
    }, o = {
      ...r
    }, a = {
      ...r,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": t,
      "Ctrl-Alt-Backspace": t,
      "Alt-Delete": t,
      "Alt-d": t,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Tl() || Sb() ? a : o;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new lt({
        key: new gt("clearDocument"),
        appendTransaction: (e, t, n) => {
          if (e.some((v) => v.getMeta("composition")))
            return;
          const r = e.some((v) => v.docChanged) && !t.doc.eq(n.doc), o = e.some((v) => v.getMeta("preventClearDocument"));
          if (!r || o)
            return;
          const { empty: a, from: l, to: s } = t.selection, i = Ue.atStart(t.doc).from, d = Ue.atEnd(t.doc).to;
          if (a || !(l === i && s === d) || !ha(n.doc))
            return;
          const h = n.tr, b = bs({
            state: n,
            transaction: h
          }), { commands: m } = new ps({
            editor: this.editor,
            state: b
          });
          if (m.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), Jb = _e.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("tiptapPaste"),
        props: {
          handlePaste: (e, t, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: t,
              slice: n
            });
          }
        }
      })
    ];
  }
}), Zb = _e.create({
  name: "tabindex",
  addOptions() {
    return {
      value: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("tabindex"),
        props: {
          attributes: () => {
            var e;
            return !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: (e = this.options.value) != null ? e : "0" };
          }
        }
      })
    ];
  }
}), Yb = _e.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: e } = bo(this.extensions);
    return [
      {
        types: e.filter((t) => t.name !== "text").map((t) => t.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (t) => {
              const n = t.getAttribute("dir");
              return n && (n === "ltr" || n === "rtl" || n === "auto") ? n : this.options.direction;
            },
            renderHTML: (t) => t.dir ? {
              dir: t.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("textDirection"),
        props: {
          attributes: () => {
            const e = this.options.direction;
            return e ? {
              dir: e
            } : {};
          }
        }
      })
    ];
  }
}), ES = class Po {
  constructor(t, n, r = !1, o = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = t, this.editor = n, this.currentNode = o;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var t;
    return (t = this.actualDepth) != null ? t : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(t) {
    let n = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: r }, t);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
    return new Po(n, this.editor);
  }
  get before() {
    let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new Po(t, this.editor);
  }
  get after() {
    let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new Po(t, this.editor);
  }
  get children() {
    const t = [];
    return this.node.content.forEach((n, r) => {
      const o = n.isBlock && !n.isTextblock, a = n.isAtom && !n.isText, l = n.isInline, s = this.pos + r + (a ? 0 : 1);
      if (s < 0 || s > this.resolvedPos.doc.nodeSize - 2)
        return;
      const i = this.resolvedPos.doc.resolve(s);
      if (!o && !l && i.depth <= this.depth)
        return;
      const d = new Po(i, this.editor, o, o || l ? n : null);
      o && (d.actualDepth = this.depth + 1), t.push(d);
    }), t;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const t = this.children;
    return t[t.length - 1] || null;
  }
  closest(t, n = {}) {
    let r = null, o = this.parent;
    for (; o && !r; ) {
      if (o.node.type.name === t)
        if (Object.keys(n).length > 0) {
          const a = o.node.attrs, l = Object.keys(n);
          for (let s = 0; s < l.length; s += 1) {
            const i = l[s];
            if (a[i] !== n[i])
              break;
          }
        } else
          r = o;
      o = o.parent;
    }
    return r;
  }
  querySelector(t, n = {}) {
    return this.querySelectorAll(t, n, !0)[0] || null;
  }
  querySelectorAll(t, n = {}, r = !1) {
    let o = [];
    if (!this.children || this.children.length === 0)
      return o;
    const a = Object.keys(n);
    return this.children.forEach((l) => {
      r && o.length > 0 || (l.node.type.name === t && a.every((i) => n[i] === l.node.attrs[i]) && o.push(l), !(r && o.length > 0) && (o = o.concat(l.querySelectorAll(t, n, r))));
    }), o;
  }
  setAttribute(t) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...t
    }), this.editor.view.dispatch(n);
  }
}, AS = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function DS(e, t, n) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const o = document.createElement("style");
  return t && o.setAttribute("nonce", t), o.setAttribute("data-tiptap-style", ""), o.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(o), o;
}
var RS = class extends xS {
  constructor(t = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: o }) => {
        throw o;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: ZC,
      createMappablePosition: YC
    }, this.setOptions(t), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: o, slice: a, moved: l }) => this.options.onDrop(o, a, l)), this.on("paste", ({ event: o, slice: a }) => this.options.onPaste(o, a)), this.on("delete", this.options.onDelete);
    const n = this.createDoc(), r = wb(n, this.options.autofocus);
    this.editorState = Yr.create({
      doc: n,
      schema: this.schema,
      selection: r || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(t) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(t), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const t = this.editorView.dom;
      t != null && t.editor && delete t.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (t) {
        console.warn("Failed to remove CSS element:", t);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = DS(AS, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(t = {}) {
    this.options = {
      ...this.options,
      ...t
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(t, n = !0) {
    this.setOptions({ editable: t }), n && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (t) => {
          this.editorState = t;
        },
        dispatch: (t) => {
          this.dispatchTransaction(t);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (t, n) => {
          if (this.editorView)
            return this.editorView[n];
          if (n === "state")
            return this.editorState;
          if (n in t)
            return Reflect.get(t, n);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${n}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(t, n) {
    const r = Tb(n) ? n(t, [...this.state.plugins]) : [...this.state.plugins, t], o = this.state.reconfigure({ plugins: r });
    return this.view.updateState(o), o;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(t) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let r = n;
    if ([].concat(t).forEach((a) => {
      const l = typeof a == "string" ? `${a}$` : a.key;
      r = r.filter((s) => !s.key.startsWith(l));
    }), n.length === r.length)
      return;
    const o = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(o), o;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var t, n, r, o;
    const l = [...this.options.enableCoreExtensions ? [
      Ub,
      Fb.configure({
        blockSeparator: (n = (t = this.options.coreExtensionOptions) == null ? void 0 : t.clipboardTextSerializer) == null ? void 0 : n.blockSeparator
      }),
      Hb,
      qb,
      Kb,
      Zb.configure({
        value: (o = (r = this.options.coreExtensionOptions) == null ? void 0 : r.tabindex) == null ? void 0 : o.value
      }),
      jb,
      Jb,
      Wb,
      Yb.configure({
        direction: this.options.textDirection
      })
    ].filter((s) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[s.name] !== !1 : !0) : [], ...this.options.extensions].filter((s) => ["extension", "node", "mark"].includes(s == null ? void 0 : s.type));
    this.extensionManager = new xs(l, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new ps({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let t;
    try {
      t = Ri(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (n) {
      if (!(n instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(n.message))
        throw n;
      this.emit("contentError", {
        editor: this,
        error: n,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((r) => r.name !== "collaboration"), this.createExtensionManager();
        }
      }), t = Ri(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return t;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(t) {
    const { editorProps: n, enableExtensionDispatchTransaction: r } = this.options, o = n.dispatchTransaction || this.dispatchTransaction.bind(this), a = r ? this.extensionManager.dispatchTransaction(o) : o, l = n.transformPastedHTML, s = this.extensionManager.transformPastedHTML(l);
    this.editorView = new mb(t, {
      ...n,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...n == null ? void 0 : n.attributes
      },
      dispatchTransaction: a,
      transformPastedHTML: s,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.prependClass(), this.injectCSS();
    const d = this.view.dom;
    d.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(t) {
    this.isCapturingTransaction = !0, t(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(t) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = t;
        return;
      }
      t.steps.forEach((u) => {
        var f;
        return (f = this.capturedTransaction) == null ? void 0 : f.step(u);
      });
      return;
    }
    const { state: n, transactions: r } = this.state.applyTransaction(t), o = !this.state.selection.eq(n.selection), a = r.includes(t), l = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: t,
      nextState: n
    }), !a)
      return;
    this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: t,
      appendedTransactions: r.slice(1)
    }), o && this.emit("selectionUpdate", {
      editor: this,
      transaction: t
    });
    const s = r.findLast((u) => u.getMeta("focus") || u.getMeta("blur")), i = s == null ? void 0 : s.getMeta("focus"), d = s == null ? void 0 : s.getMeta("blur");
    i && this.emit("focus", {
      editor: this,
      event: i.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: s
    }), d && this.emit("blur", {
      editor: this,
      event: d.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: s
    }), !(t.getMeta("preventUpdate") || !r.some((u) => u.docChanged) || l.doc.eq(n.doc)) && this.emit("update", {
      editor: this,
      transaction: t,
      appendedTransactions: r.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(t) {
    return Db(this.state, t);
  }
  isActive(t, n) {
    const r = typeof t == "string" ? t : null, o = typeof t == "string" ? n : t;
    return qC(this.state, r, o);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return zd(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(t) {
    const { blockSeparator: n = `

`, textSerializers: r = {} } = t || {};
    return FC(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...Ab(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return ha(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var t, n;
    return (n = (t = this.editorView) == null ? void 0 : t.isDestroyed) != null ? n : !0;
  }
  $node(t, n) {
    var r;
    return ((r = this.$doc) == null ? void 0 : r.querySelector(t, n)) || null;
  }
  $nodes(t, n) {
    var r;
    return ((r = this.$doc) == null ? void 0 : r.querySelectorAll(t, n)) || null;
  }
  $pos(t) {
    const n = this.state.doc.resolve(t), r = t > 0 && n.nodeAfter && !n.nodeAfter.isText ? n.nodeAfter : null;
    return new ES(n, this, !1, r);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function Nr(e) {
  return new vs({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const o = Xe(e.getAttributes, void 0, r);
      if (o === !1 || o === null)
        return null;
      const { tr: a } = t, l = r[r.length - 1], s = r[0];
      if (l) {
        const i = s.search(/\S/), d = n.from + s.indexOf(l), u = d + l.length;
        if (Nd(n.from, n.to, t.doc).filter((b) => b.mark.type.excluded.find((v) => v === e.type && v !== b.mark.type)).filter((b) => b.to > d).length)
          return null;
        u < n.to && a.delete(u, n.to), d > n.from && a.delete(n.from + i, d);
        const h = n.from + i + l.length;
        a.addMark(n.from + i, h, e.type.create(o || {})), a.removeStoredMark(e.type);
      }
    },
    undoable: e.undoable
  });
}
function Xb(e) {
  return new vs({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const o = Xe(e.getAttributes, void 0, r) || {}, { tr: a } = t, l = n.from;
      let s = n.to;
      const i = e.type.create(o);
      if (r[1]) {
        const d = r[0].lastIndexOf(r[1]);
        let u = l + d;
        u > s ? u = s : s = u + r[1].length;
        const f = r[0][r[0].length - 1];
        a.insertText(f, l + r[0].length - 1), a.replaceWith(u, s, i);
      } else if (r[0]) {
        const d = e.type.isInline ? l : l - 1;
        a.insert(d, e.type.create(o)).delete(a.mapping.map(l), a.mapping.map(s));
      }
      a.scrollIntoView();
    },
    undoable: e.undoable
  });
}
function Oi(e) {
  return new vs({
    find: e.find,
    handler: ({ state: t, range: n, match: r }) => {
      const o = t.doc.resolve(n.from), a = Xe(e.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), e.type))
        return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, a);
    },
    undoable: e.undoable
  });
}
function po(e) {
  return new vs({
    find: e.find,
    handler: ({ state: t, range: n, match: r, chain: o }) => {
      const a = Xe(e.getAttributes, void 0, r) || {}, l = t.tr.delete(n.from, n.to), i = l.doc.resolve(n.from).blockRange(), d = i && vd(i, e.type, a);
      if (!d)
        return null;
      if (l.wrap(i, d), e.keepMarks && e.editor) {
        const { selection: f, storedMarks: h } = t, { splittableMarks: b } = e.editor.extensionManager, m = h || f.$to.parentOffset && f.$from.marks();
        if (m) {
          const v = m.filter((x) => b.includes(x.type.name));
          l.ensureMarks(v);
        }
      }
      if (e.keepAttributes) {
        const f = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        o().updateAttributes(f, a).run();
      }
      const u = l.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === e.type && fr(l.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, u)) && l.join(n.from - 1);
    },
    undoable: e.undoable
  });
}
var BS = (e) => "touches" in e, OS = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(e) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (s) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const i = s.clientX - this.startX, d = s.clientY - this.startY;
      this.handleResize(i, d);
    }, this.handleTouchMove = (s) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const i = s.touches[0];
      if (!i)
        return;
      const d = i.clientX - this.startX, u = i.clientY - this.startY;
      this.handleResize(d, u);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const s = this.element.offsetWidth, i = this.element.offsetHeight;
      this.onCommit(s, i), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (s) => {
      s.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (s) => {
      s.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var t, n, r, o, a, l;
    this.node = e.node, this.editor = e.editor, this.element = e.element, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, (t = e.options) != null && t.min && (this.minSize = {
      ...this.minSize,
      ...e.options.min
    }), (n = e.options) != null && n.max && (this.maxSize = e.options.max), (r = e == null ? void 0 : e.options) != null && r.directions && (this.directions = e.options.directions), (o = e.options) != null && o.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), (a = e.options) != null && a.className && (this.classNames = {
      container: e.options.className.container || "",
      wrapper: e.options.className.wrapper || "",
      handle: e.options.className.handle || "",
      resizing: e.options.className.resizing || ""
    }), (l = e.options) != null && l.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var e;
    return (e = this.contentElement) != null ? e : null;
  }
  handleEditorUpdate() {
    const e = this.editor.isEditable;
    e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(e, t, n) {
    return e.type !== this.node.type ? !1 : (this.node = e, this.onUpdate ? this.onUpdate(e, t, n) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const e = document.createElement("div");
    return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const e = document.createElement("div");
    return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(e) {
    const t = document.createElement("div");
    return t.dataset.resizeHandle = e, t.style.position = "absolute", this.classNames.handle && (t.className = this.classNames.handle), t;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(e, t) {
    const n = t.includes("top"), r = t.includes("bottom"), o = t.includes("left"), a = t.includes("right");
    n && (e.style.top = "0"), r && (e.style.bottom = "0"), o && (e.style.left = "0"), a && (e.style.right = "0"), (t === "top" || t === "bottom") && (e.style.left = "0", e.style.right = "0"), (t === "left" || t === "right") && (e.style.top = "0", e.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((e) => {
      let t;
      this.createCustomHandle ? t = this.createCustomHandle(e) : t = this.createHandle(e), t instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`
      ), t = this.createHandle(e)), this.createCustomHandle || this.positionHandle(t, e), t.addEventListener("mousedown", (n) => this.handleResizeStart(n, e)), t.addEventListener("touchstart", (n) => this.handleResizeStart(n, e)), this.handleMap.set(e, t), this.wrapper.appendChild(t);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const e = this.node.attrs.width, t = this.node.attrs.height;
    e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, t ? (this.element.style.height = `${t}px`, this.initialHeight = t) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(e, t) {
    e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = t, BS(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(e, t) {
    if (!this.activeHandle)
      return;
    const n = this.preserveAspectRatio || this.isShiftKeyPressed, { width: r, height: o } = this.calculateNewDimensions(this.activeHandle, e, t), a = this.applyConstraints(r, o, n);
    this.element.style.width = `${a.width}px`, this.element.style.height = `${a.height}px`, this.onResize && this.onResize(a.width, a.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(e, t, n) {
    let r = this.startWidth, o = this.startHeight;
    const a = e.includes("right"), l = e.includes("left"), s = e.includes("bottom"), i = e.includes("top");
    return a ? r = this.startWidth + t : l && (r = this.startWidth - t), s ? o = this.startHeight + n : i && (o = this.startHeight - n), (e === "right" || e === "left") && (r = this.startWidth + (a ? t : -t)), (e === "top" || e === "bottom") && (o = this.startHeight + (s ? n : -n)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(r, o, e) : { width: r, height: o };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(e, t, n) {
    var r, o, a, l;
    if (!n) {
      let d = Math.max(this.minSize.width, e), u = Math.max(this.minSize.height, t);
      return (r = this.maxSize) != null && r.width && (d = Math.min(this.maxSize.width, d)), (o = this.maxSize) != null && o.height && (u = Math.min(this.maxSize.height, u)), { width: d, height: u };
    }
    let s = e, i = t;
    return s < this.minSize.width && (s = this.minSize.width, i = s / this.aspectRatio), i < this.minSize.height && (i = this.minSize.height, s = i * this.aspectRatio), (a = this.maxSize) != null && a.width && s > this.maxSize.width && (s = this.maxSize.width, i = s / this.aspectRatio), (l = this.maxSize) != null && l.height && i > this.maxSize.height && (i = this.maxSize.height, s = i * this.aspectRatio), { width: s, height: i };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(e, t, n) {
    const r = n === "left" || n === "right", o = n === "top" || n === "bottom";
    return r ? {
      width: e,
      height: e / this.aspectRatio
    } : o ? {
      width: t * this.aspectRatio,
      height: t
    } : {
      width: e,
      height: e / this.aspectRatio
    };
  }
};
function PS(e, t) {
  const { selection: n } = e, { $from: r } = n;
  if (n instanceof Oe) {
    const a = r.index();
    return r.parent.canReplaceWith(a, a + 1, t);
  }
  let o = r.depth;
  for (; o >= 0; ) {
    const a = r.index(o);
    if (r.node(o).contentMatchAt(a).matchType(t))
      return !0;
    o -= 1;
  }
  return !1;
}
function yo(e, t) {
  const n = e.getAttribute("style");
  if (!n)
    return null;
  const r = n.split(";").map((a) => a.trim()).filter(Boolean), o = t.toLowerCase();
  for (let a = r.length - 1; a >= 0; a -= 1) {
    const l = r[a], s = l.indexOf(":");
    if (s === -1)
      continue;
    if (l.slice(0, s).trim().toLowerCase() === o)
      return l.slice(s + 1).trim();
  }
  return null;
}
var zS = {};
Rd(zS, {
  createAtomBlockMarkdownSpec: () => NS,
  createBlockMarkdownSpec: () => VS,
  createInlineMarkdownSpec: () => WS,
  parseAttributes: () => Fd,
  parseIndentedBlocks: () => Pi,
  renderNestedMarkdownContent: () => Wd,
  serializeAttributes: () => Hd
});
function Fd(e) {
  if (!(e != null && e.trim()))
    return {};
  const t = {}, n = [], r = e.replace(/["']([^"']*)["']/g, (d) => (n.push(d), `__QUOTED_${n.length - 1}__`)), o = r.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (o) {
    const d = o.map((u) => u.trim().slice(1));
    t.class = d.join(" ");
  }
  const a = r.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  a && (t.id = a[1]);
  const l = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(r.matchAll(l)).forEach(([, d, u]) => {
    var f;
    const h = parseInt(((f = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : f[1]) || "0", 10), b = n[h];
    b && (t[d] = b.slice(1, -1));
  });
  const i = r.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return i && i.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (t[u] = !0);
  }), t;
}
function Hd(e) {
  if (!e || Object.keys(e).length === 0)
    return "";
  const t = [];
  return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((r) => t.push(`.${r}`)), e.id && t.push(`#${e.id}`), Object.entries(e).forEach(([n, r]) => {
    n === "class" || n === "id" || (r === !0 ? t.push(n) : r !== !1 && r != null && t.push(`${n}="${String(r)}"`));
  }), t.join(" ");
}
function NS(e) {
  const {
    nodeName: t,
    name: n,
    parseAttributes: r = Fd,
    serializeAttributes: o = Hd,
    defaultAttributes: a = {},
    requiredAttributes: l = [],
    allowedAttributes: s
  } = e, i = n || t, d = (u) => {
    if (!s)
      return u;
    const f = {};
    return s.forEach((h) => {
      h in u && (f[h] = u[h]);
    }), f;
  };
  return {
    parseMarkdown: (u, f) => {
      const h = { ...a, ...u.attributes };
      return f.createNode(t, h, []);
    },
    markdownTokenizer: {
      name: t,
      level: "block",
      start(u) {
        var f;
        const h = new RegExp(`^:::${i}(?:\\s|$)`, "m"), b = (f = u.match(h)) == null ? void 0 : f.index;
        return b !== void 0 ? b : -1;
      },
      tokenize(u, f, h) {
        const b = new RegExp(`^:::${i}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), m = u.match(b);
        if (!m)
          return;
        const v = m[1] || "", x = r(v);
        if (!l.find((L) => !(L in x)))
          return {
            type: t,
            raw: m[0],
            attributes: x
          };
      }
    },
    renderMarkdown: (u) => {
      const f = d(u.attrs || {}), h = o(f), b = h ? ` {${h}}` : "";
      return `:::${i}${b} :::`;
    }
  };
}
function VS(e) {
  const {
    nodeName: t,
    name: n,
    getContent: r,
    parseAttributes: o = Fd,
    serializeAttributes: a = Hd,
    defaultAttributes: l = {},
    content: s = "block",
    allowedAttributes: i
  } = e, d = n || t, u = (f) => {
    if (!i)
      return f;
    const h = {};
    return i.forEach((b) => {
      b in f && (h[b] = f[b]);
    }), h;
  };
  return {
    parseMarkdown: (f, h) => {
      let b;
      if (r) {
        const v = r(f);
        b = typeof v == "string" ? [{ type: "text", text: v }] : v;
      } else s === "block" ? b = h.parseChildren(f.tokens || []) : b = h.parseInline(f.tokens || []);
      const m = { ...l, ...f.attributes };
      return h.createNode(t, m, b);
    },
    markdownTokenizer: {
      name: t,
      level: "block",
      start(f) {
        var h;
        const b = new RegExp(`^:::${d}`, "m"), m = (h = f.match(b)) == null ? void 0 : h.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(f, h, b) {
        var m;
        const v = new RegExp(`^:::${d}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), x = f.match(v);
        if (!x)
          return;
        const [k, L = ""] = x, P = o(L);
        let E = 1;
        const O = k.length;
        let R = "";
        const V = /^:::([\w-]*)(\s.*)?/gm, J = f.slice(O);
        for (V.lastIndex = 0; ; ) {
          const F = V.exec(J);
          if (F === null)
            break;
          const A = F.index, j = F[1];
          if (!((m = F[2]) != null && m.endsWith(":::"))) {
            if (j)
              E += 1;
            else if (E -= 1, E === 0) {
              const _ = J.slice(0, A);
              R = _.trim();
              const U = f.slice(0, O + A + F[0].length);
              let W = [];
              if (R)
                if (s === "block")
                  for (W = b.blockTokens(_), W.forEach((K) => {
                    K.text && (!K.tokens || K.tokens.length === 0) && (K.tokens = b.inlineTokens(K.text));
                  }); W.length > 0; ) {
                    const K = W[W.length - 1];
                    if (K.type === "paragraph" && (!K.text || K.text.trim() === ""))
                      W.pop();
                    else
                      break;
                  }
                else
                  W = b.inlineTokens(R);
              return {
                type: t,
                raw: U,
                attributes: P,
                content: R,
                tokens: W
              };
            }
          }
        }
      }
    },
    renderMarkdown: (f, h) => {
      const b = u(f.attrs || {}), m = a(b), v = m ? ` {${m}}` : "", x = h.renderChildren(f.content || [], `

`);
      return `:::${d}${v}

${x}

:::`;
    }
  };
}
function FS(e) {
  if (!e.trim())
    return {};
  const t = {}, n = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let r = n.exec(e);
  for (; r !== null; ) {
    const [, o, a, l] = r;
    t[o] = a || l, r = n.exec(e);
  }
  return t;
}
function HS(e) {
  return Object.entries(e).filter(([, t]) => t != null).map(([t, n]) => `${t}="${n}"`).join(" ");
}
function WS(e) {
  const {
    nodeName: t,
    name: n,
    getContent: r,
    parseAttributes: o = FS,
    serializeAttributes: a = HS,
    defaultAttributes: l = {},
    selfClosing: s = !1,
    allowedAttributes: i
  } = e, d = n || t, u = (h) => {
    if (!i)
      return h;
    const b = {};
    return i.forEach((m) => {
      const v = typeof m == "string" ? m : m.name, x = typeof m == "string" ? void 0 : m.skipIfDefault;
      if (v in h) {
        const k = h[v];
        if (x !== void 0 && k === x)
          return;
        b[v] = k;
      }
    }), b;
  }, f = d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (h, b) => {
      const m = { ...l, ...h.attributes };
      if (s)
        return b.createNode(t, m);
      const v = r ? r(h) : h.content || "";
      return v ? b.createNode(t, m, [b.createTextNode(v)]) : b.createNode(t, m, []);
    },
    markdownTokenizer: {
      name: t,
      level: "inline",
      start(h) {
        const b = s ? new RegExp(`\\[${f}\\s*[^\\]]*\\]`) : new RegExp(`\\[${f}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${f}\\]`), m = h.match(b), v = m == null ? void 0 : m.index;
        return v !== void 0 ? v : -1;
      },
      tokenize(h, b, m) {
        const v = s ? new RegExp(`^\\[${f}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${f}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${f}\\]`), x = h.match(v);
        if (!x)
          return;
        let k = "", L = "";
        if (s) {
          const [, E] = x;
          L = E;
        } else {
          const [, E, O] = x;
          L = E, k = O || "";
        }
        const P = o(L.trim());
        return {
          type: t,
          raw: x[0],
          content: k.trim(),
          attributes: P
        };
      }
    },
    renderMarkdown: (h) => {
      let b = "";
      r ? b = r(h) : h.content && h.content.length > 0 && (b = h.content.filter((k) => k.type === "text").map((k) => k.text).join(""));
      const m = u(h.attrs || {}), v = a(m), x = v ? ` ${v}` : "";
      return s ? `[${d}${x}]` : `[${d}${x}]${b}[/${d}]`;
    }
  };
}
function Pi(e, t, n) {
  var r, o, a, l;
  const s = e.split(`
`), i = [];
  let d = "", u = 0;
  const f = t.baseIndentSize || 2;
  for (; u < s.length; ) {
    const h = s[u], b = h.match(t.itemPattern);
    if (!b) {
      if (i.length > 0)
        break;
      if (h.trim() === "") {
        u += 1, d = `${d}${h}
`;
        continue;
      } else
        return;
    }
    const m = t.extractItemData(b), { indentLevel: v, mainContent: x } = m;
    d = `${d}${h}
`;
    const k = [x];
    for (u += 1; u < s.length; ) {
      const O = s[u];
      if (O.trim() === "") {
        const V = s.slice(u + 1).findIndex((A) => A.trim() !== "");
        if (V === -1)
          break;
        if ((((o = (r = s[u + 1 + V].match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : o.length) || 0) > v) {
          k.push(O), d = `${d}${O}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((l = (a = O.match(/^(\s*)/)) == null ? void 0 : a[1]) == null ? void 0 : l.length) || 0) > v)
        k.push(O), d = `${d}${O}
`, u += 1;
      else
        break;
    }
    let L;
    const P = k.slice(1);
    if (P.length > 0) {
      const O = P.map((R) => R.slice(v + f)).join(`
`);
      O.trim() && (t.customNestedParser ? L = t.customNestedParser(O) : L = n.blockTokens(O));
    }
    const E = t.createToken(m, L);
    i.push(E);
  }
  if (i.length !== 0)
    return {
      items: i,
      raw: d
    };
}
function Wd(e, t, n, r) {
  if (!e || !Array.isArray(e.content))
    return "";
  const o = typeof n == "function" ? n(r) : n, [a, ...l] = e.content, s = t.renderChildren([a]);
  let i = `${o}${s}`;
  return l && l.length > 0 && l.forEach((d, u) => {
    var f, h;
    const b = (h = (f = t.renderChild) == null ? void 0 : f.call(t, d, u + 1)) != null ? h : t.renderChildren([d]);
    if (b != null) {
      const m = b.split(`
`).map((v) => v ? t.indent(v) : t.indent("")).join(`
`);
      i += d.type === "paragraph" ? `

${m}` : `
${m}`;
    }
  }), i;
}
function jS(e, t, n = {}) {
  const { state: r } = t, { doc: o, tr: a } = r, l = e;
  o.descendants((s, i) => {
    const d = a.mapping.map(i), u = a.mapping.map(i) + s.nodeSize;
    let f = null;
    if (s.marks.forEach((b) => {
      if (b !== l)
        return !1;
      f = b;
    }), !f)
      return;
    let h = !1;
    if (Object.keys(n).forEach((b) => {
      n[b] !== f.attrs[b] && (h = !0);
    }), h) {
      const b = e.type.create({
        ...e.attrs,
        ...n
      });
      a.removeMark(d, u, e.type), a.addMark(d, u, b);
    }
  }), a.docChanged && t.view.dispatch(a);
}
var Ht = class Qb extends Vd {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(t = {}) {
    const n = typeof t == "function" ? t() : t;
    return new Qb(n);
  }
  configure(t) {
    return super.configure(t);
  }
  extend(t) {
    const n = typeof t == "function" ? t() : t;
    return super.extend(n);
  }
};
function ir(e) {
  return new SS({
    find: e.find,
    handler: ({ state: t, range: n, match: r, pasteEvent: o }) => {
      const a = Xe(e.getAttributes, void 0, r, o);
      if (a === !1 || a === null)
        return null;
      const { tr: l } = t, s = r[r.length - 1], i = r[0];
      let d = n.to;
      if (s) {
        const u = i.search(/\S/), f = n.from + i.indexOf(s), h = f + s.length;
        if (Nd(n.from, n.to, t.doc).filter((v) => v.mark.type.excluded.find((k) => k === e.type && k !== v.mark.type)).filter((v) => v.to > f).length)
          return null;
        h < n.to && l.delete(h, n.to), f > n.from && l.delete(n.from + u, f), d = n.from + u + s.length, l.addMark(n.from + u, d, e.type.create(a || {})), r.index !== void 0 && r.input !== void 0 && r.index + r[0].length >= r.input.length || l.removeStoredMark(e.type);
      }
    }
  });
}
function Fc(e) {
  return fg((t, n) => ({
    get() {
      return t(), e;
    },
    set(r) {
      e = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          n();
        });
      });
    }
  }));
}
var US = class extends RS {
  constructor(e = {}) {
    return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = Fc(this.view.state), this.reactiveExtensionStorage = Fc(this.extensionStorage), this.on("beforeTransaction", ({ nextState: t }) => {
      this.reactiveState.value = t, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), cg(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(e, t) {
    const n = super.registerPlugin(e, t);
    return this.reactiveState && (this.reactiveState.value = n), n;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(e) {
    const t = super.unregisterPlugin(e);
    return this.reactiveState && t && (this.reactiveState.value = t), t;
  }
}, GS = ge({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(e) {
    const t = N(), n = Mf();
    return Ef(() => {
      const r = e.editor;
      r && r.options.element && t.value && Pe(() => {
        var o;
        if (!t.value || !((o = r.view.dom) != null && o.parentNode))
          return;
        const a = T(t.value);
        t.value.append(...r.view.dom.parentNode.childNodes), r.contentComponent = n.ctx._, n && (r.appContext = {
          ...n.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: n.provides
        }), r.setOptions({
          element: a
        }), r.createNodeViews();
      });
    }), Bt(() => {
      const r = e.editor;
      r && (r.contentComponent = null, r.appContext = null);
    }), { rootEl: t };
  },
  render() {
    return xa("div", {
      ref: (e) => {
        this.rootEl = e;
      }
    });
  }
});
ge({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return xa(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
ge({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var e, t;
    return xa(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (t = (e = this.$slots).default) == null ? void 0 : t.call(e)
    );
  }
});
var qS = (e = {}) => {
  const t = ld();
  return Qe(() => {
    t.value = new US(e);
  }), Bt(() => {
    var n;
    (n = t.value) == null || n.destroy();
  }), t;
};
ge({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return xa(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var Ll = (e, t) => {
  if (e === "slot")
    return 0;
  if (e instanceof Function)
    return e(t);
  const { children: n, ...r } = t ?? {};
  if (e === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [e, r, n];
}, KS = /^\s*>\s$/, JS = Ht.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ Ll("blockquote", { ...at(this.options.HTMLAttributes, e), children: /* @__PURE__ */ Ll("slot", {}) });
  },
  parseMarkdown: (e, t) => {
    var n;
    const r = (n = t.parseBlockChildren) != null ? n : t.parseChildren;
    return t.createNode("blockquote", void 0, r(e.tokens || []));
  },
  renderMarkdown: (e, t) => {
    if (!e.content)
      return "";
    const n = ">", r = [];
    return e.content.forEach((o, a) => {
      var l, s;
      const u = ((s = (l = t.renderChild) == null ? void 0 : l.call(t, o, a)) != null ? s : t.renderChildren([o])).split(`
`).map((f) => f.trim() === "" ? n : `${n} ${f}`);
      r.push(u.join(`
`));
    }), r.join(`
${n}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      po({
        find: KS,
        type: this.type
      })
    ];
  }
}), ZS = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, YS = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, XS = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, QS = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, _S = Fn.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return /* @__PURE__ */ Ll("strong", { ...at(this.options.HTMLAttributes, e), children: /* @__PURE__ */ Ll("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (e, t) => t.applyMark("bold", t.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<strong>",
      close: "</strong>"
    }
  },
  renderMarkdown: (e, t) => `**${t.renderChildren(e)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      Nr({
        find: ZS,
        type: this.type
      }),
      Nr({
        find: XS,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ir({
        find: YS,
        type: this.type
      }),
      ir({
        find: QS,
        type: this.type
      })
    ];
  }
}), e$ = /(^|[^`])`([^`]+)`(?!`)$/, t$ = /(^|[^`])`([^`]+)`(?!`)/g, n$ = Fn.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", at(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (e, t) => t.applyMark("code", [{ type: "text", text: e.text || "" }]),
  renderMarkdown: (e, t) => e.content ? `\`${t.renderChildren(e.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      Nr({
        find: e$,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ir({
        find: t$,
        type: this.type
      })
    ];
  }
}), Gs = 4, r$ = /^```([a-z]+)?[\s\n]$/, o$ = /^~~~([a-z]+)?[\s\n]$/, a$ = Ht.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: Gs,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var t;
          const { languageClassPrefix: n } = this.options;
          if (!n)
            return null;
          const a = [...((t = e.firstElementChild) == null ? void 0 : t.classList) || []].filter((l) => l.startsWith(n)).map((l) => l.replace(n, ""))[0];
          return a || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "pre",
      at(this.options.HTMLAttributes, t),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (e, t) => {
    var n, r;
    return ((n = e.raw) == null ? void 0 : n.startsWith("```")) === !1 && ((r = e.raw) == null ? void 0 : r.startsWith("~~~")) === !1 && e.codeBlockStyle !== "indented" ? [] : t.createNode(
      "codeBlock",
      { language: e.lang || null },
      e.text ? [t.createTextNode(e.text)] : []
    );
  },
  renderMarkdown: (e, t) => {
    var n;
    let r = "";
    const o = ((n = e.attrs) == null ? void 0 : n.language) || "";
    return e.content ? r = [`\`\`\`${o}`, t.renderChildren(e.content), "```"].join(`
`) : r = `\`\`\`${o}

\`\`\``, r;
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: t }) => t.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: t }) => t.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: t } = this.editor.state.selection, n = t.pos === 1;
        return !e || t.parent.type.name !== this.name ? !1 : n || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: e }) => {
        var t;
        if (!this.options.enableTabIndentation)
          return !1;
        const n = (t = this.options.tabSize) != null ? t : Gs, { state: r } = e, { selection: o } = r, { $from: a, empty: l } = o;
        if (a.parent.type !== this.type)
          return !1;
        const s = " ".repeat(n);
        return l ? e.commands.insertContent(s) : e.commands.command(({ tr: i }) => {
          const { from: d, to: u } = o, b = r.doc.textBetween(d, u, `
`, `
`).split(`
`).map((m) => s + m).join(`
`);
          return i.replaceWith(d, u, r.schema.text(b)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: e }) => {
        var t;
        if (!this.options.enableTabIndentation)
          return !1;
        const n = (t = this.options.tabSize) != null ? t : Gs, { state: r } = e, { selection: o } = r, { $from: a, empty: l } = o;
        return a.parent.type !== this.type ? !1 : l ? e.commands.command(({ tr: s }) => {
          var i;
          const { pos: d } = a, u = a.start(), f = a.end(), b = r.doc.textBetween(u, f, `
`, `
`).split(`
`);
          let m = 0, v = 0;
          const x = d - u;
          for (let R = 0; R < b.length; R += 1) {
            if (v + b[R].length >= x) {
              m = R;
              break;
            }
            v += b[R].length + 1;
          }
          const L = ((i = b[m].match(/^ */)) == null ? void 0 : i[0]) || "", P = Math.min(L.length, n);
          if (P === 0)
            return !0;
          let E = u;
          for (let R = 0; R < m; R += 1)
            E += b[R].length + 1;
          return s.delete(E, E + P), d - E <= P && s.setSelection(Fe.create(s.doc, E)), !0;
        }) : e.commands.command(({ tr: s }) => {
          const { from: i, to: d } = o, h = r.doc.textBetween(i, d, `
`, `
`).split(`
`).map((b) => {
            var m;
            const v = ((m = b.match(/^ */)) == null ? void 0 : m[0]) || "", x = Math.min(v.length, n);
            return b.slice(x);
          }).join(`
`);
          return s.replaceWith(i, d, r.schema.text(h)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: t } = e, { selection: n } = t, { $from: r, empty: o } = n;
        if (!o || r.parent.type !== this.type)
          return !1;
        const a = r.parentOffset === r.parent.nodeSize - 2, l = r.parent.textContent.endsWith(`

`);
        return !a || !l ? !1 : e.chain().command(({ tr: s }) => (s.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: t } = e, { selection: n, doc: r } = t, { $from: o, empty: a } = n;
        if (!a || o.parent.type !== this.type || !(o.parentOffset === o.parent.nodeSize - 2))
          return !1;
        const s = o.after();
        return s === void 0 ? !1 : r.nodeAt(s) ? e.commands.command(({ tr: d }) => (d.setSelection(Ue.near(r.resolve(s))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Oi({
        find: r$,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      Oi({
        find: o$,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new lt({
        key: new gt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = t.clipboardData.getData("text/plain"), r = t.clipboardData.getData("vscode-editor-data"), o = r ? JSON.parse(r) : void 0, a = o == null ? void 0 : o.mode;
            if (!n || !a)
              return !1;
            const { tr: l, schema: s } = e.state, i = s.text(n.replace(/\r\n?/g, `
`));
            return l.replaceSelectionWith(this.type.create({ language: a }, i)), l.selection.$from.parent.type !== this.type && l.setSelection(Fe.near(l.doc.resolve(Math.max(0, l.selection.from - 2)))), l.setMeta("paste", !0), e.dispatch(l), !0;
          }
        }
      })
    ];
  }
}), l$ = Ht.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `

`) : ""
}), s$ = Ht.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", at(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: t, state: n, editor: r }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: o, storedMarks: a } = n;
          if (o.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: l } = this.options, { splittableMarks: s } = r.extensionManager, i = a || o.$to.parentOffset && o.$from.marks();
          return t().insertContent({ type: this.name }).command(({ tr: d, dispatch: u }) => {
            if (u && i && l) {
              const f = i.filter((h) => s.includes(h.type.name));
              d.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), i$ = Ht.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, at(this.options.HTMLAttributes, t), 0];
  },
  parseMarkdown: (e, t) => t.createNode("heading", { level: e.depth || 1 }, t.parseInline(e.tokens || [])),
  renderMarkdown: (e, t) => {
    var n;
    const r = (n = e.attrs) != null && n.level ? parseInt(e.attrs.level, 10) : 1, o = "#".repeat(r);
    return e.content ? `${o} ${t.renderChildren(e.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (e, t) => ({
        ...e,
        [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((e) => Oi({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
}), d$ = Ht.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", at(this.options.HTMLAttributes, e)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (e, t) => t.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: t }) => {
        if (!PS(t, t.schema.nodes[this.name]))
          return !1;
        const { selection: n } = t, { $to: r } = n, o = e();
        return Bb(n) ? o.insertContentAt(r.pos, {
          type: this.name
        }) : o.insertContent({ type: this.name }), o.command(({ state: a, tr: l, dispatch: s }) => {
          if (s) {
            const { $to: i } = l.selection, d = i.end();
            if (i.nodeAfter)
              i.nodeAfter.isTextblock ? l.setSelection(Fe.create(l.doc, i.pos + 1)) : i.nodeAfter.isBlock ? l.setSelection(Oe.create(l.doc, i.pos)) : l.setSelection(Fe.create(l.doc, i.pos));
            else {
              const u = a.schema.nodes[this.options.nextNodeType] || i.parent.type.contentMatch.defaultType, f = u == null ? void 0 : u.create();
              f && (l.insert(d, f), l.setSelection(Fe.create(l.doc, d + 1)));
            }
            l.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Xb({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), u$ = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, c$ = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, f$ = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, h$ = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, b$ = Fn.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", at(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (e, t) => t.applyMark("italic", t.parseInline(e.tokens || [])),
  markdownOptions: {
    htmlReopen: {
      open: "<em>",
      close: "</em>"
    }
  },
  renderMarkdown: (e, t) => `*${t.renderChildren(e)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      Nr({
        find: u$,
        type: this.type
      }),
      Nr({
        find: f$,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ir({
        find: c$,
        type: this.type
      }),
      ir({
        find: h$,
        type: this.type
      })
    ];
  }
});
const p$ = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", g$ = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", zi = "numeric", Ni = "ascii", Vi = "alpha", qo = "asciinumeric", zo = "alphanumeric", Fi = "domain", _b = "emoji", m$ = "scheme", v$ = "slashscheme", qs = "whitespace";
function x$(e, t) {
  return e in t || (t[e] = []), t[e];
}
function wr(e, t, n) {
  t[zi] && (t[qo] = !0, t[zo] = !0), t[Ni] && (t[qo] = !0, t[Vi] = !0), t[qo] && (t[zo] = !0), t[Vi] && (t[zo] = !0), t[zo] && (t[Fi] = !0), t[_b] && (t[Fi] = !0);
  for (const r in t) {
    const o = x$(r, n);
    o.indexOf(e) < 0 && o.push(e);
  }
}
function y$(e, t) {
  const n = {};
  for (const r in t)
    t[r].indexOf(e) >= 0 && (n[r] = !0);
  return n;
}
function zt(e = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
zt.groups = {};
zt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(e) {
    const t = this, n = t.j[e];
    if (n)
      return n;
    for (let r = 0; r < t.jr.length; r++) {
      const o = t.jr[r][0], a = t.jr[r][1];
      if (a && o.test(e))
        return a;
    }
    return t.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(e, t = !1) {
    return t ? e in this.j : !!this.go(e);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(e, t, n, r) {
    for (let o = 0; o < e.length; o++)
      this.tt(e[o], t, n, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(e, t, n, r) {
    r = r || zt.groups;
    let o;
    return t && t.j ? o = t : (o = new zt(t), n && r && wr(t, n, r)), this.jr.push([e, o]), o;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(e, t, n, r) {
    let o = this;
    const a = e.length;
    if (!a)
      return o;
    for (let l = 0; l < a - 1; l++)
      o = o.tt(e[l]);
    return o.tt(e[a - 1], t, n, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(e, t, n, r) {
    r = r || zt.groups;
    const o = this;
    if (t && t.j)
      return o.j[e] = t, t;
    const a = t;
    let l, s = o.go(e);
    if (s ? (l = new zt(), Object.assign(l.j, s.j), l.jr.push.apply(l.jr, s.jr), l.jd = s.jd, l.t = s.t) : l = new zt(), a) {
      if (r)
        if (l.t && typeof l.t == "string") {
          const i = Object.assign(y$(l.t, r), n);
          wr(a, i, r);
        } else n && wr(a, n, r);
      l.t = a;
    }
    return o.j[e] = l, l;
  }
};
const Ge = (e, t, n, r, o) => e.ta(t, n, r, o), st = (e, t, n, r, o) => e.tr(t, n, r, o), Hc = (e, t, n, r, o) => e.ts(t, n, r, o), Se = (e, t, n, r, o) => e.tt(t, n, r, o), An = "WORD", Hi = "UWORD", ep = "ASCIINUMERICAL", tp = "ALPHANUMERICAL", ba = "LOCALHOST", Wi = "TLD", ji = "UTLD", al = "SCHEME", Zr = "SLASH_SCHEME", jd = "NUM", Ui = "WS", Ud = "NL", Ko = "OPENBRACE", Jo = "CLOSEBRACE", Ml = "OPENBRACKET", El = "CLOSEBRACKET", Al = "OPENPAREN", Dl = "CLOSEPAREN", Rl = "OPENANGLEBRACKET", Bl = "CLOSEANGLEBRACKET", Ol = "FULLWIDTHLEFTPAREN", Pl = "FULLWIDTHRIGHTPAREN", zl = "LEFTCORNERBRACKET", Nl = "RIGHTCORNERBRACKET", Vl = "LEFTWHITECORNERBRACKET", Fl = "RIGHTWHITECORNERBRACKET", Hl = "FULLWIDTHLESSTHAN", Wl = "FULLWIDTHGREATERTHAN", jl = "AMPERSAND", Ul = "APOSTROPHE", Gl = "ASTERISK", qn = "AT", ql = "BACKSLASH", Kl = "BACKTICK", Jl = "CARET", Cr = "COLON", Gd = "COMMA", Zl = "DOLLAR", pn = "DOT", Yl = "EQUALS", qd = "EXCLAMATION", Jt = "HYPHEN", Zo = "PERCENT", Xl = "PIPE", Ql = "PLUS", _l = "POUND", Yo = "QUERY", Kd = "QUOTE", np = "FULLWIDTHMIDDLEDOT", Jd = "SEMI", gn = "SLASH", Xo = "TILDE", es = "UNDERSCORE", rp = "EMOJI", ts = "SYM";
var op = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: tp,
  AMPERSAND: jl,
  APOSTROPHE: Ul,
  ASCIINUMERICAL: ep,
  ASTERISK: Gl,
  AT: qn,
  BACKSLASH: ql,
  BACKTICK: Kl,
  CARET: Jl,
  CLOSEANGLEBRACKET: Bl,
  CLOSEBRACE: Jo,
  CLOSEBRACKET: El,
  CLOSEPAREN: Dl,
  COLON: Cr,
  COMMA: Gd,
  DOLLAR: Zl,
  DOT: pn,
  EMOJI: rp,
  EQUALS: Yl,
  EXCLAMATION: qd,
  FULLWIDTHGREATERTHAN: Wl,
  FULLWIDTHLEFTPAREN: Ol,
  FULLWIDTHLESSTHAN: Hl,
  FULLWIDTHMIDDLEDOT: np,
  FULLWIDTHRIGHTPAREN: Pl,
  HYPHEN: Jt,
  LEFTCORNERBRACKET: zl,
  LEFTWHITECORNERBRACKET: Vl,
  LOCALHOST: ba,
  NL: Ud,
  NUM: jd,
  OPENANGLEBRACKET: Rl,
  OPENBRACE: Ko,
  OPENBRACKET: Ml,
  OPENPAREN: Al,
  PERCENT: Zo,
  PIPE: Xl,
  PLUS: Ql,
  POUND: _l,
  QUERY: Yo,
  QUOTE: Kd,
  RIGHTCORNERBRACKET: Nl,
  RIGHTWHITECORNERBRACKET: Fl,
  SCHEME: al,
  SEMI: Jd,
  SLASH: gn,
  SLASH_SCHEME: Zr,
  SYM: ts,
  TILDE: Xo,
  TLD: Wi,
  UNDERSCORE: es,
  UTLD: ji,
  UWORD: Hi,
  WORD: An,
  WS: Ui
});
const Ln = /[a-z]/, $o = new RegExp("\\p{L}", "u"), Ks = new RegExp("\\p{Emoji}", "u"), Mn = /\d/, Js = /\s/, Wc = "\r", Zs = `
`, k$ = "️", w$ = "‍", Ys = "￼";
let Fa = null, Ha = null;
function C$(e = []) {
  const t = {};
  zt.groups = t;
  const n = new zt();
  Fa == null && (Fa = jc(p$)), Ha == null && (Ha = jc(g$)), Se(n, "'", Ul), Se(n, "{", Ko), Se(n, "}", Jo), Se(n, "[", Ml), Se(n, "]", El), Se(n, "(", Al), Se(n, ")", Dl), Se(n, "<", Rl), Se(n, ">", Bl), Se(n, "（", Ol), Se(n, "）", Pl), Se(n, "「", zl), Se(n, "」", Nl), Se(n, "『", Vl), Se(n, "』", Fl), Se(n, "＜", Hl), Se(n, "＞", Wl), Se(n, "&", jl), Se(n, "*", Gl), Se(n, "@", qn), Se(n, "`", Kl), Se(n, "^", Jl), Se(n, ":", Cr), Se(n, ",", Gd), Se(n, "$", Zl), Se(n, ".", pn), Se(n, "=", Yl), Se(n, "!", qd), Se(n, "-", Jt), Se(n, "%", Zo), Se(n, "|", Xl), Se(n, "+", Ql), Se(n, "#", _l), Se(n, "?", Yo), Se(n, '"', Kd), Se(n, "/", gn), Se(n, ";", Jd), Se(n, "~", Xo), Se(n, "_", es), Se(n, "\\", ql), Se(n, "・", np);
  const r = st(n, Mn, jd, {
    [zi]: !0
  });
  st(r, Mn, r);
  const o = st(r, Ln, ep, {
    [qo]: !0
  }), a = st(r, $o, tp, {
    [zo]: !0
  }), l = st(n, Ln, An, {
    [Ni]: !0
  });
  st(l, Mn, o), st(l, Ln, l), st(o, Mn, o), st(o, Ln, o);
  const s = st(n, $o, Hi, {
    [Vi]: !0
  });
  st(s, Ln), st(s, Mn, a), st(s, $o, s), st(a, Mn, a), st(a, Ln), st(a, $o, a);
  const i = Se(n, Zs, Ud, {
    [qs]: !0
  }), d = Se(n, Wc, Ui, {
    [qs]: !0
  }), u = st(n, Js, Ui, {
    [qs]: !0
  });
  Se(n, Ys, u), Se(d, Zs, i), Se(d, Ys, u), st(d, Js, u), Se(u, Wc), Se(u, Zs), st(u, Js, u), Se(u, Ys, u);
  const f = st(n, Ks, rp, {
    [_b]: !0
  });
  Se(f, "#"), st(f, Ks, f), Se(f, k$, f);
  const h = Se(f, w$);
  Se(h, "#"), st(h, Ks, f);
  const b = [[Ln, l], [Mn, o]], m = [[Ln, null], [$o, s], [Mn, a]];
  for (let v = 0; v < Fa.length; v++)
    jn(n, Fa[v], Wi, An, b);
  for (let v = 0; v < Ha.length; v++)
    jn(n, Ha[v], ji, Hi, m);
  wr(Wi, {
    tld: !0,
    ascii: !0
  }, t), wr(ji, {
    utld: !0,
    alpha: !0
  }, t), jn(n, "file", al, An, b), jn(n, "mailto", al, An, b), jn(n, "http", Zr, An, b), jn(n, "https", Zr, An, b), jn(n, "ftp", Zr, An, b), jn(n, "ftps", Zr, An, b), wr(al, {
    scheme: !0,
    ascii: !0
  }, t), wr(Zr, {
    slashscheme: !0,
    ascii: !0
  }, t), e = e.sort((v, x) => v[0] > x[0] ? 1 : -1);
  for (let v = 0; v < e.length; v++) {
    const x = e[v][0], L = e[v][1] ? {
      [m$]: !0
    } : {
      [v$]: !0
    };
    x.indexOf("-") >= 0 ? L[Fi] = !0 : Ln.test(x) ? Mn.test(x) ? L[qo] = !0 : L[Ni] = !0 : L[zi] = !0, Hc(n, x, x, L);
  }
  return Hc(n, "localhost", ba, {
    ascii: !0
  }), n.jd = new zt(ts), {
    start: n,
    tokens: Object.assign({
      groups: t
    }, op)
  };
}
function ap(e, t) {
  const n = S$(t.replace(/[A-Z]/g, (s) => s.toLowerCase())), r = n.length, o = [];
  let a = 0, l = 0;
  for (; l < r; ) {
    let s = e, i = null, d = 0, u = null, f = -1, h = -1;
    for (; l < r && (i = s.go(n[l])); )
      s = i, s.accepts() ? (f = 0, h = 0, u = s) : f >= 0 && (f += n[l].length, h++), d += n[l].length, a += n[l].length, l++;
    a -= f, l -= h, d -= f, o.push({
      t: u.t,
      // token type/name
      v: t.slice(a - d, a),
      // string value
      s: a - d,
      // start index
      e: a
      // end index (excluding)
    });
  }
  return o;
}
function S$(e) {
  const t = [], n = e.length;
  let r = 0;
  for (; r < n; ) {
    let o = e.charCodeAt(r), a, l = o < 55296 || o > 56319 || r + 1 === n || (a = e.charCodeAt(r + 1)) < 56320 || a > 57343 ? e[r] : e.slice(r, r + 2);
    t.push(l), r += l.length;
  }
  return t;
}
function jn(e, t, n, r, o) {
  let a;
  const l = t.length;
  for (let s = 0; s < l - 1; s++) {
    const i = t[s];
    e.j[i] ? a = e.j[i] : (a = new zt(r), a.jr = o.slice(), e.j[i] = a), e = a;
  }
  return a = new zt(n), a.jr = o.slice(), e.j[t[l - 1]] = a, a;
}
function jc(e) {
  const t = [], n = [];
  let r = 0, o = "0123456789";
  for (; r < e.length; ) {
    let a = 0;
    for (; o.indexOf(e[r + a]) >= 0; )
      a++;
    if (a > 0) {
      t.push(n.join(""));
      for (let l = parseInt(e.substring(r, r + a), 10); l > 0; l--)
        n.pop();
      r += a;
    } else
      n.push(e[r]), r++;
  }
  return t;
}
const pa = {
  defaultProtocol: "http",
  events: null,
  format: Uc,
  formatHref: Uc,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Zd(e, t = null) {
  let n = Object.assign({}, pa);
  e && (n = Object.assign(n, e instanceof Zd ? e.o : e));
  const r = n.ignoreTags, o = [];
  for (let a = 0; a < r.length; a++)
    o.push(r[a].toUpperCase());
  this.o = n, t && (this.defaultRender = t), this.ignoreTags = o;
}
Zd.prototype = {
  o: pa,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(e) {
    return e;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(e, t, n) {
    const r = t != null;
    let o = this.o[e];
    return o && (typeof o == "object" ? (o = n.t in o ? o[n.t] : pa[e], typeof o == "function" && r && (o = o(t, n))) : typeof o == "function" && r && (o = o(t, n.t, n)), o);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(e, t, n) {
    let r = this.o[e];
    return typeof r == "function" && t != null && (r = r(t, n.t, n)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
};
function Uc(e) {
  return e;
}
function lp(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
lp.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(e) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(e) {
    const t = this.toString(), n = e.get("truncate", t, this), r = e.get("format", t, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(e = pa.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(e) {
    const t = this, n = this.toHref(e.get("defaultProtocol")), r = e.get("formatHref", n, this), o = e.get("tagName", n, t), a = this.toFormattedString(e), l = {}, s = e.get("className", n, t), i = e.get("target", n, t), d = e.get("rel", n, t), u = e.getObj("attributes", n, t), f = e.getObj("events", n, t);
    return l.href = r, s && (l.class = s), i && (l.target = i), d && (l.rel = d), u && Object.assign(l, u), {
      tagName: o,
      attributes: l,
      content: a,
      eventListeners: f
    };
  }
};
function ys(e, t) {
  class n extends lp {
    constructor(o, a) {
      super(o, a), this.t = e;
    }
  }
  for (const r in t)
    n.prototype[r] = t[r];
  return n.t = e, n;
}
const $$ = ys("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), Gc = ys("text"), I$ = ys("nl"), Wa = ys("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(e = pa.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${e}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const e = this.tk;
    return e.length >= 2 && e[0].t !== ba && e[1].t === Cr;
  }
}), Kt = (e) => new zt(e);
function T$({
  groups: e
}) {
  const t = e.domain.concat([jl, Gl, qn, ql, Kl, Jl, Zl, Yl, Jt, jd, Zo, Xl, Ql, _l, gn, ts, Xo, es]), n = [Ul, Cr, Gd, pn, qd, Zo, Yo, Kd, Jd, Rl, Bl, Ko, Jo, El, Ml, Al, Dl, Ol, Pl, zl, Nl, Vl, Fl, Hl, Wl], r = [jl, Ul, Gl, ql, Kl, Jl, Zl, Yl, Jt, Ko, Jo, Zo, Xl, Ql, _l, Yo, gn, ts, Xo, es], o = Kt(), a = Se(o, Xo);
  Ge(a, r, a), Ge(a, e.domain, a);
  const l = Kt(), s = Kt(), i = Kt();
  Ge(o, e.domain, l), Ge(o, e.scheme, s), Ge(o, e.slashscheme, i), Ge(l, r, a), Ge(l, e.domain, l);
  const d = Se(l, qn);
  Se(a, qn, d), Se(s, qn, d), Se(i, qn, d);
  const u = Se(a, pn);
  Ge(u, r, a), Ge(u, e.domain, a);
  const f = Kt();
  Ge(d, e.domain, f), Ge(f, e.domain, f);
  const h = Se(f, pn);
  Ge(h, e.domain, f);
  const b = Kt($$);
  Ge(h, e.tld, b), Ge(h, e.utld, b), Se(d, ba, b);
  const m = Se(f, Jt);
  Se(m, Jt, m), Ge(m, e.domain, f), Ge(b, e.domain, f), Se(b, pn, h), Se(b, Jt, m);
  const v = Se(l, Jt), x = Se(l, pn);
  Se(v, Jt, v), Ge(v, e.domain, l), Ge(x, r, a), Ge(x, e.domain, l);
  const k = Kt(Wa);
  Ge(x, e.tld, k), Ge(x, e.utld, k), Ge(k, e.domain, l), Ge(k, r, a), Se(k, pn, x), Se(k, Jt, v), Se(k, qn, d);
  const L = Se(k, Cr), P = Kt(Wa);
  Ge(L, e.numeric, P);
  const E = Kt(Wa), O = Kt();
  Ge(E, t, E), Ge(E, n, O), Ge(O, t, E), Ge(O, n, O), Se(k, gn, E), Se(P, gn, E);
  const R = Se(s, Cr), V = Se(i, Cr), J = Se(V, gn), F = Se(J, gn);
  Ge(s, e.domain, l), Se(s, pn, x), Se(s, Jt, v), Ge(i, e.domain, l), Se(i, pn, x), Se(i, Jt, v), Ge(R, e.domain, E), Se(R, gn, E), Se(R, Yo, E), Ge(F, e.domain, E), Ge(F, t, E), Se(F, gn, E);
  const A = [
    [Ko, Jo],
    // {}
    [Ml, El],
    // []
    [Al, Dl],
    // ()
    [Rl, Bl],
    // <>
    [Ol, Pl],
    // （）
    [zl, Nl],
    // 「」
    [Vl, Fl],
    // 『』
    [Hl, Wl]
    // ＜＞
  ];
  for (let j = 0; j < A.length; j++) {
    const [_, U] = A[j], W = Se(E, _);
    Se(O, _, W);
    const K = Kt(Wa);
    Ge(W, t, K);
    const le = Kt();
    Ge(W, n, le), Se(W, U, E), Ge(K, t, K), Ge(K, n, le), Ge(le, t, K), Ge(le, n, le), Se(K, U, E), Se(le, U, E);
  }
  return Se(o, ba, k), Se(o, Ud, I$), {
    start: o,
    tokens: op
  };
}
function L$(e, t, n) {
  let r = n.length, o = 0, a = [], l = [];
  for (; o < r; ) {
    let s = e, i = null, d = null, u = 0, f = null, h = -1;
    for (; o < r && !(i = s.go(n[o].t)); )
      l.push(n[o++]);
    for (; o < r && (d = i || s.go(n[o].t)); )
      i = null, s = d, s.accepts() ? (h = 0, f = s) : h >= 0 && h++, o++, u++;
    if (h < 0)
      o -= u, o < r && (l.push(n[o]), o++);
    else {
      l.length > 0 && (a.push(Xs(Gc, t, l)), l = []), o -= h, u -= h;
      const b = f.t, m = n.slice(o - u, o);
      a.push(Xs(b, t, m));
    }
  }
  return l.length > 0 && a.push(Xs(Gc, t, l)), a;
}
function Xs(e, t, n) {
  const r = n[0].s, o = n[n.length - 1].e, a = t.slice(r, o);
  return new e(a, n);
}
const M$ = typeof console < "u" && console && console.warn || (() => {
}), E$ = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", tt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function A$() {
  return zt.groups = {}, tt.scanner = null, tt.parser = null, tt.tokenQueue = [], tt.pluginQueue = [], tt.customSchemes = [], tt.initialized = !1, tt;
}
function qc(e, t = !1) {
  if (tt.initialized && M$(`linkifyjs: already initialized - will not register custom scheme "${e}" ${E$}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  tt.customSchemes.push([e, t]);
}
function D$() {
  tt.scanner = C$(tt.customSchemes);
  for (let e = 0; e < tt.tokenQueue.length; e++)
    tt.tokenQueue[e][1]({
      scanner: tt.scanner
    });
  tt.parser = T$(tt.scanner.tokens);
  for (let e = 0; e < tt.pluginQueue.length; e++)
    tt.pluginQueue[e][1]({
      scanner: tt.scanner,
      parser: tt.parser
    });
  return tt.initialized = !0, tt;
}
function Yd(e) {
  return tt.initialized || D$(), L$(tt.parser.start, e, ap(tt.scanner.start, e));
}
Yd.scan = ap;
function sp(e, t = null, n = null) {
  if (t && typeof t == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    n = t, t = null;
  }
  const r = new Zd(n), o = Yd(e), a = [];
  for (let l = 0; l < o.length; l++) {
    const s = o[l];
    s.isLink && (!t || s.t === t) && r.check(s) && a.push(s.toFormattedObject(r));
  }
  return a;
}
var Xd = "[\0-   ᠎ -\u2029 　]", R$ = new RegExp(Xd), B$ = new RegExp(`${Xd}$`), O$ = new RegExp(Xd, "g");
function P$(e) {
  return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function z$(e) {
  return new lt({
    key: new gt("autolink"),
    appendTransaction: (t, n, r) => {
      const o = t.some((d) => d.docChanged) && !n.doc.eq(r.doc), a = t.some((d) => d.getMeta("preventAutolink"));
      if (!o || a)
        return;
      const { tr: l } = r, s = Ib(n.doc, [...t]);
      if (Rb(s).forEach(({ newRange: d }) => {
        const u = RC(r.doc, d, (b) => b.isTextblock);
        let f, h;
        if (u.length > 1)
          f = u[0], h = r.doc.textBetween(
            f.pos,
            f.pos + f.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const b = r.doc.textBetween(d.from, d.to, " ", " ");
          if (!B$.test(b))
            return;
          f = u[0], h = r.doc.textBetween(f.pos, d.to, void 0, " ");
        }
        if (f && h) {
          const b = h.split(R$).filter(Boolean);
          if (b.length <= 0)
            return !1;
          const m = b[b.length - 1], v = f.pos + h.lastIndexOf(m);
          if (!m)
            return !1;
          const x = Yd(m).map((k) => k.toObject(e.defaultProtocol));
          if (!P$(x))
            return !1;
          x.filter((k) => k.isLink).map((k) => ({
            ...k,
            from: v + k.start + 1,
            to: v + k.end + 1
          })).filter((k) => r.schema.marks.code ? !r.doc.rangeHasMark(k.from, k.to, r.schema.marks.code) : !0).filter((k) => e.validate(k.value)).filter((k) => e.shouldAutoLink(k.value)).forEach((k) => {
            Nd(k.from, k.to, r.doc).some((L) => L.mark.type === e.type) || l.addMark(
              k.from,
              k.to,
              e.type.create({
                href: k.href
              })
            );
          });
        }
      }), !!l.steps.length)
        return l;
    }
  });
}
function N$(e) {
  return new lt({
    key: new gt("handleClickLink"),
    props: {
      handleClick: (t, n, r) => {
        var o, a;
        if (r.button !== 0 || !t.editable)
          return !1;
        let l = null;
        if (r.target instanceof HTMLAnchorElement)
          l = r.target;
        else {
          const i = r.target;
          if (!i)
            return !1;
          const d = e.editor.view.dom;
          l = i.closest("a"), l && !d.contains(l) && (l = null);
        }
        if (!l)
          return !1;
        let s = !1;
        if (e.enableClickSelection && (s = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
          const i = Db(t.state, e.type.name), d = (o = l.href) != null ? o : i.href, u = (a = l.target) != null ? a : i.target;
          d && (window.open(d, u), s = !0);
        }
        return s;
      }
    }
  });
}
function V$(e) {
  return new lt({
    key: new gt("handlePasteLink"),
    props: {
      handlePaste: (t, n, r) => {
        const { shouldAutoLink: o } = e, { state: a } = t, { selection: l } = a, { empty: s } = l;
        if (s)
          return !1;
        let i = "";
        r.content.forEach((u) => {
          i += u.textContent;
        });
        const d = sp(i, { defaultProtocol: e.defaultProtocol }).find(
          (u) => u.isLink && u.value === i
        );
        return !i || !d || o !== void 0 && !o(d.value) ? !1 : e.editor.commands.setMark(e.type, {
          href: d.href
        });
      }
    }
  });
}
function pr(e, t) {
  const n = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return t && t.forEach((r) => {
    const o = typeof r == "string" ? r : r.scheme;
    o && n.push(o);
  }), !e || e.replace(O$, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var F$ = Fn.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
      if (typeof e == "string") {
        qc(e);
        return;
      }
      qc(e.scheme, e.optionalSlashes);
    });
  },
  onDestroy() {
    A$();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (e, t) => !!pr(e, t.protocols),
      validate: (e) => !!e,
      shouldAutoLink: (e) => {
        const t = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), n = /^[a-z][a-z0-9+.-]*:/i.test(e);
        if (t || n && !e.includes("@"))
          return !0;
        const o = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(o) || !/\./.test(o));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(e) {
          return e.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (e) => {
          const t = e.getAttribute("href");
          return !t || !this.options.isAllowedUri(t, {
            defaultValidate: (n) => !!pr(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return this.options.isAllowedUri(e.href, {
      defaultValidate: (t) => !!pr(t, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", at(this.options.HTMLAttributes, e), 0] : ["a", at(this.options.HTMLAttributes, { ...e, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (e, t) => t.applyMark("link", t.parseInline(e.tokens || []), {
    href: e.href,
    title: e.title || null
  }),
  renderMarkdown: (e, t) => {
    var n, r, o, a;
    const l = (r = (n = e.attrs) == null ? void 0 : n.href) != null ? r : "", s = (a = (o = e.attrs) == null ? void 0 : o.title) != null ? a : "", i = t.renderChildren(e);
    return s ? `[${i}](${l} "${s}")` : `[${i}](${l})`;
  },
  addCommands() {
    return {
      setLink: (e) => ({ chain: t }) => {
        const { href: n } = e;
        return this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!pr(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? t().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (e) => ({ chain: t }) => {
        const { href: n } = e || {};
        return n && !this.options.isAllowedUri(n, {
          defaultValidate: (r) => !!pr(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      ir({
        find: (e) => {
          const t = [];
          if (e) {
            const { protocols: n, defaultProtocol: r } = this.options, o = sp(e).filter(
              (a) => a.isLink && this.options.isAllowedUri(a.value, {
                defaultValidate: (l) => !!pr(l, n),
                protocols: n,
                defaultProtocol: r
              })
            );
            o.length && o.forEach((a) => {
              this.options.shouldAutoLink(a.value) && t.push({
                text: a.value,
                data: {
                  href: a.href
                },
                index: a.start
              });
            });
          }
          return t;
        },
        type: this.type,
        getAttributes: (e) => {
          var t;
          return {
            href: (t = e.data) == null ? void 0 : t.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const e = [], { protocols: t, defaultProtocol: n } = this.options;
    return this.options.autolink && e.push(
      z$({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (r) => this.options.isAllowedUri(r, {
          defaultValidate: (o) => !!pr(o, t),
          protocols: t,
          defaultProtocol: n
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e.push(
      N$({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && e.push(
      V$({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), e;
  }
}), H$ = Object.defineProperty, W$ = (e, t) => {
  for (var n in t)
    H$(e, n, { get: t[n], enumerable: !0 });
}, j$ = "listItem", Kc = "textStyle", Jc = /^\s*([-+*])\s$/, ip = Ht.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", at(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, t) => e.type !== "list" || e.ordered ? [] : {
    type: "bulletList",
    content: e.items ? t.parseChildren(e.items) : []
  },
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(j$, this.editor.getAttributes(Kc)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = po({
      find: Jc,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = po({
      find: Jc,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Kc),
      editor: this.editor
    })), [e];
  }
});
function U$(e) {
  var t, n;
  const r = (t = e.tokens) == null ? void 0 : t[0];
  return !!(e.text && ((n = e.tokens) == null ? void 0 : n.length) === 1 && (r == null ? void 0 : r.type) === "list" && r.ordered && r.raw === e.text);
}
function G$(e, t) {
  return t.tokenizeInline ? t.parseInline(t.tokenizeInline(e)) : t.parseInline([
    {
      type: "text",
      raw: e,
      text: e
    }
  ]);
}
var dp = Ht.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", at(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (e, t) => {
    var n;
    if (e.type !== "list_item")
      return [];
    const r = (n = t.parseBlockChildren) != null ? n : t.parseChildren;
    let o = [];
    if (e.tokens && e.tokens.length > 0) {
      if (U$(e))
        return {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: G$(e.text || "", t)
            }
          ]
        };
      if (e.tokens.some((l) => l.type === "paragraph"))
        o = r(e.tokens);
      else {
        const l = e.tokens[0];
        if (l && l.type === "text" && l.tokens && l.tokens.length > 0) {
          if (o = [
            {
              type: "paragraph",
              content: t.parseInline(l.tokens)
            }
          ], e.tokens.length > 1) {
            const i = e.tokens.slice(1), d = r(i);
            o.push(...d);
          }
        } else
          o = r(e.tokens);
      }
    }
    return o.length === 0 && (o = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: o
    };
  },
  renderMarkdown: (e, t, n) => Wd(
    e,
    t,
    (r) => {
      var o, a;
      return r.parentType === "bulletList" ? "- " : r.parentType === "orderedList" ? `${(((a = (o = r.meta) == null ? void 0 : o.parentAttrs) == null ? void 0 : a.start) || 1) + r.index}. ` : "- ";
    },
    n
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), q$ = {};
W$(q$, {
  findListItemPos: () => Ia,
  getNextListDepth: () => Qd,
  handleBackspace: () => Gi,
  handleDelete: () => qi,
  hasListBefore: () => up,
  hasListItemAfter: () => K$,
  hasListItemBefore: () => cp,
  listItemHasSubList: () => fp,
  nextListIsDeeper: () => hp,
  nextListIsHigher: () => bp
});
var Ia = (e, t) => {
  const { $from: n } = t.selection, r = ft(e, t.schema);
  let o = null, a = n.depth, l = n.pos, s = null;
  for (; a > 0 && s === null; )
    o = n.node(a), o.type === r ? s = a : (a -= 1, l -= 1);
  return s === null ? null : { $pos: t.doc.resolve(l), depth: s };
}, Qd = (e, t) => {
  const n = Ia(e, t);
  if (!n)
    return !1;
  const [, r] = UC(t, e, n.$pos.pos + 4);
  return r;
}, up = (e, t, n) => {
  const { $anchor: r } = e.selection, o = Math.max(0, r.pos - 2), a = e.doc.resolve(o).node();
  return !(!a || !n.includes(a.type.name));
}, cp = (e, t) => {
  var n;
  const { $anchor: r } = t.selection, o = t.doc.resolve(r.pos - 2);
  return !(o.index() === 0 || ((n = o.nodeBefore) == null ? void 0 : n.type.name) !== e);
}, fp = (e, t, n) => {
  if (!n)
    return !1;
  const r = ft(e, t.schema);
  let o = !1;
  return n.descendants((a) => {
    a.type === r && (o = !0);
  }), o;
}, Gi = (e, t, n) => {
  if (e.commands.undoInputRule())
    return !0;
  if (e.state.selection.from !== e.state.selection.to)
    return !1;
  if (!sr(e.state, t) && up(e.state, t, n)) {
    const { $anchor: s } = e.state.selection, i = e.state.doc.resolve(s.before() - 1), d = [];
    i.node().descendants((h, b) => {
      h.type.name === t && d.push({ node: h, pos: b });
    });
    const u = d.at(-1);
    if (!u)
      return !1;
    const f = e.state.doc.resolve(i.start() + u.pos + 1);
    return e.chain().cut({ from: s.start() - 1, to: s.end() + 1 }, f.end()).joinForward().run();
  }
  if (!sr(e.state, t) || !JC(e.state))
    return !1;
  const r = Ia(t, e.state);
  if (!r)
    return !1;
  const a = e.state.doc.resolve(r.$pos.pos - 2).node(r.depth), l = fp(t, e.state, a);
  return cp(t, e.state) && !l ? e.commands.joinItemBackward() : e.chain().liftListItem(t).run();
}, hp = (e, t) => {
  const n = Qd(e, t), r = Ia(e, t);
  return !r || !n ? !1 : n > r.depth;
}, bp = (e, t) => {
  const n = Qd(e, t), r = Ia(e, t);
  return !r || !n ? !1 : n < r.depth;
}, qi = (e, t) => {
  if (!sr(e.state, t) || !KC(e.state, t))
    return !1;
  const { selection: n } = e.state, { $from: r, $to: o } = n;
  return !n.empty && r.sameParent(o) ? !1 : hp(t, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(t).joinBackward().run() : bp(t, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, K$ = (e, t) => {
  var n;
  const { $anchor: r } = t.selection, o = t.doc.resolve(r.pos - r.parentOffset - 2);
  return !(o.index() === o.parent.childCount - 1 || ((n = o.nodeAfter) == null ? void 0 : n.type.name) !== e);
}, pp = _e.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n }) => {
          e.state.schema.nodes[n] !== void 0 && qi(e, n) && (t = !0);
        }), t;
      },
      "Mod-Delete": ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n }) => {
          e.state.schema.nodes[n] !== void 0 && qi(e, n) && (t = !0);
        }), t;
      },
      Backspace: ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
          e.state.schema.nodes[n] !== void 0 && Gi(e, n, r) && (t = !0);
        }), t;
      },
      "Mod-Backspace": ({ editor: e }) => {
        let t = !1;
        return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
          e.state.schema.nodes[n] !== void 0 && Gi(e, n, r) && (t = !0);
        }), t;
      }
    };
  }
}), Zc = /^(\s*)(\d+)\.\s+(.*)$/, J$ = /^\s/;
function Z$(e) {
  const t = e.trimStart();
  return /^[-+*]\s+/.test(t) || /^\d+\.\s+/.test(t) || /^>\s?/.test(t) || /^```/.test(t) || /^~~~/.test(t);
}
function Y$(e) {
  const t = [], n = [];
  let r = !1;
  return e.forEach((o) => {
    if (r) {
      n.push(o);
      return;
    }
    if (o.trim() === "") {
      r = !0, n.push(o);
      return;
    }
    if (t.length > 0 && Z$(o)) {
      r = !0, n.push(o);
      return;
    }
    t.push(o);
  }), {
    paragraphLines: t,
    blockLines: n
  };
}
function X$(e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < e.length; ) {
    const o = e[n], a = o.match(Zc);
    if (!a)
      break;
    const [, l, s, i] = a, d = l.length, u = [i];
    let f = n + 1;
    const h = [o];
    let b = !1;
    for (; f < e.length; ) {
      const m = e[f];
      if (m.match(Zc))
        break;
      if (m.trim() === "")
        h.push(m), u.push(""), b = !0, f += 1;
      else if (m.match(J$))
        h.push(m), u.push(m.slice(d + 2)), f += 1;
      else {
        if (b)
          break;
        h.push(m), u.push(m), f += 1;
      }
    }
    t.push({
      indent: d,
      number: parseInt(s, 10),
      content: u.join(`
`).trim(),
      contentLines: u,
      raw: h.join(`
`)
    }), r = f, n = f;
  }
  return [t, r];
}
function gp(e, t, n) {
  const r = [];
  let o = 0;
  for (; o < e.length; ) {
    const a = e[o];
    if (a.indent === t) {
      const { paragraphLines: l, blockLines: s } = Y$(a.contentLines), i = l.join(`
`).trim(), d = [];
      i && d.push({
        type: "paragraph",
        raw: i,
        tokens: n.inlineTokens(i)
      });
      const u = s.join(`
`).trim();
      if (u) {
        const b = n.blockTokens(u);
        d.push(...b);
      }
      let f = o + 1;
      const h = [];
      for (; f < e.length && e[f].indent > t; )
        h.push(e[f]), f += 1;
      if (h.length > 0) {
        const b = Math.min(...h.map((v) => v.indent)), m = gp(h, b, n);
        d.push({
          type: "list",
          ordered: !0,
          start: h[0].number,
          items: m,
          raw: h.map((v) => v.raw).join(`
`)
        });
      }
      r.push({
        type: "list_item",
        raw: a.raw,
        tokens: d
      }), o = f;
    } else
      o += 1;
  }
  return r;
}
function Q$(e, t) {
  return e.map((n) => {
    if (n.type !== "list_item")
      return t.parseChildren([n])[0];
    const r = [];
    return n.tokens && n.tokens.length > 0 && n.tokens.forEach((o) => {
      if (o.type === "paragraph" || o.type === "list" || o.type === "blockquote" || o.type === "code")
        r.push(...t.parseChildren([o]));
      else if (o.type === "text" && o.tokens) {
        const a = t.parseChildren([o]);
        r.push({
          type: "paragraph",
          content: a
        });
      } else {
        const a = t.parseChildren([o]);
        a.length > 0 && r.push(...a);
      }
    }), {
      type: "listItem",
      content: r
    };
  });
}
var _$ = "listItem", Yc = "textStyle", Xc = /^(\d+)\.\s$/, mp = Ht.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: t, ...n } = e;
    return t === 1 ? ["ol", at(this.options.HTMLAttributes, n), 0] : ["ol", at(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (e, t) => {
    if (e.type !== "list" || !e.ordered)
      return [];
    const n = e.start || 1, r = e.items ? Q$(e.items, t) : [];
    return n !== 1 ? {
      type: "orderedList",
      attrs: { start: n },
      content: r
    } : {
      type: "orderedList",
      content: r
    };
  },
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (e) => {
      const t = e.match(/^(\s*)(\d+)\.\s+/), n = t == null ? void 0 : t.index;
      return n !== void 0 ? n : -1;
    },
    tokenize: (e, t, n) => {
      var r;
      const o = e.split(`
`), [a, l] = X$(o);
      if (a.length === 0)
        return;
      const s = gp(a, 0, n);
      return s.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((r = a[0]) == null ? void 0 : r.number) || 1,
        items: s,
        raw: o.slice(0, l).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(_$, this.editor.getAttributes(Yc)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = po({
      find: Xc,
      type: this.type,
      getAttributes: (t) => ({ start: +t[1] }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = po({
      find: Xc,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (t) => ({ start: +t[1], ...this.editor.getAttributes(Yc) }),
      joinPredicate: (t, n) => n.childCount + n.attrs.start === +t[1],
      editor: this.editor
    })), [e];
  }
}), e5 = /^\s*(\[([( |x])?\])\s$/, t5 = Ht.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (e) => {
          const t = e.getAttribute("data-checked");
          return t === "" || t === "true";
        },
        renderHTML: (e) => ({
          "data-checked": e.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: t }) {
    return [
      "li",
      at(this.options.HTMLAttributes, t, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: e.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (e, t) => {
    const n = [];
    if (e.tokens && e.tokens.length > 0 ? n.push(t.createNode("paragraph", {}, t.parseInline(e.tokens))) : e.text ? n.push(t.createNode("paragraph", {}, [t.createNode("text", { text: e.text })])) : n.push(t.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
      const r = t.parseChildren(e.nestedTokens);
      n.push(...r);
    }
    return t.createNode("taskItem", { checked: e.checked || !1 }, n);
  },
  renderMarkdown: (e, t) => {
    var n;
    const o = `- [${(n = e.attrs) != null && n.checked ? "x" : " "}] `;
    return Wd(e, t, o);
  },
  addKeyboardShortcuts() {
    const e = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...e,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : e;
  },
  addNodeView() {
    return ({ node: e, HTMLAttributes: t, getPos: n, editor: r }) => {
      const o = document.createElement("li"), a = document.createElement("label"), l = document.createElement("span"), s = document.createElement("input"), i = document.createElement("div"), d = (f) => {
        var h, b;
        s.ariaLabel = ((b = (h = this.options.a11y) == null ? void 0 : h.checkboxLabel) == null ? void 0 : b.call(h, f, s.checked)) || `Task item checkbox for ${f.textContent || "empty task item"}`;
      };
      d(e), a.contentEditable = "false", s.type = "checkbox", s.addEventListener("mousedown", (f) => f.preventDefault()), s.addEventListener("change", (f) => {
        if (!r.isEditable && !this.options.onReadOnlyChecked) {
          s.checked = !s.checked;
          return;
        }
        const { checked: h } = f.target;
        r.isEditable && typeof n == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: b }) => {
          const m = n();
          if (typeof m != "number")
            return !1;
          const v = b.doc.nodeAt(m);
          return b.setNodeMarkup(m, void 0, {
            ...v == null ? void 0 : v.attrs,
            checked: h
          }), !0;
        }).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, h) || (s.checked = !s.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([f, h]) => {
        o.setAttribute(f, h);
      }), o.dataset.checked = e.attrs.checked, s.checked = e.attrs.checked, a.append(s, l), o.append(a, i), Object.entries(t).forEach(([f, h]) => {
        o.setAttribute(f, h);
      });
      let u = new Set(Object.keys(t));
      return {
        dom: o,
        contentDOM: i,
        update: (f) => {
          if (f.type !== this.type)
            return !1;
          o.dataset.checked = f.attrs.checked, s.checked = f.attrs.checked, d(f);
          const h = r.extensionManager.attributes, b = fa(f, h), m = new Set(Object.keys(b)), v = this.options.HTMLAttributes;
          return u.forEach((x) => {
            m.has(x) || (x in v ? o.setAttribute(x, v[x]) : o.removeAttribute(x));
          }), Object.entries(b).forEach(([x, k]) => {
            k == null ? x in v ? o.setAttribute(x, v[x]) : o.removeAttribute(x) : o.setAttribute(x, k);
          }), u = m, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      po({
        find: e5,
        type: this.type,
        getAttributes: (e) => ({
          checked: e[e.length - 1] === "x"
        })
      })
    ];
  }
}), n5 = Ht.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", at(this.options.HTMLAttributes, e, { "data-type": this.name }), 0];
  },
  parseMarkdown: (e, t) => t.createNode("taskList", {}, t.parseChildren(e.items || [])),
  renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(e) {
      var t;
      const n = (t = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : t.index;
      return n !== void 0 ? n : -1;
    },
    tokenize(e, t, n) {
      const r = (a) => {
        const l = Pi(
          a,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (s) => ({
              indentLevel: s[1].length,
              mainContent: s[4],
              checked: s[3].toLowerCase() === "x"
            }),
            createToken: (s, i) => ({
              type: "taskItem",
              raw: "",
              mainContent: s.mainContent,
              indentLevel: s.indentLevel,
              checked: s.checked,
              text: s.mainContent,
              tokens: n.inlineTokens(s.mainContent),
              nestedTokens: i
            }),
            // Allow recursive nesting
            customNestedParser: r
          },
          n
        );
        return l ? [
          {
            type: "taskList",
            raw: l.raw,
            items: l.items
          }
        ] : n.blockTokens(a);
      }, o = Pi(
        e,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (a) => ({
            indentLevel: a[1].length,
            mainContent: a[4],
            checked: a[3].toLowerCase() === "x"
          }),
          createToken: (a, l) => ({
            type: "taskItem",
            raw: "",
            mainContent: a.mainContent,
            indentLevel: a.indentLevel,
            checked: a.checked,
            text: a.mainContent,
            tokens: n.inlineTokens(a.mainContent),
            nestedTokens: l
          }),
          // Use the recursive parser for nested content
          customNestedParser: r
        },
        n
      );
      if (o)
        return {
          type: "taskList",
          raw: o.raw,
          items: o.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
_e.create({
  name: "listKit",
  addExtensions() {
    const e = [];
    return this.options.bulletList !== !1 && e.push(ip.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(dp.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(pp.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(mp.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(t5.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(n5.configure(this.options.taskList)), e;
  }
});
var ja = "&nbsp;", Qs = " ", r5 = Ht.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", at(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (e, t) => {
    const n = e.tokens || [];
    if (n.length === 1 && n[0].type === "image")
      return t.parseChildren([n[0]]);
    const r = t.parseInline(n);
    return n.length === 1 && n[0].type === "text" && (n[0].raw === ja || n[0].text === ja || n[0].raw === Qs || n[0].text === Qs) && r.length === 1 && r[0].type === "text" && (r[0].text === ja || r[0].text === Qs) ? t.createNode("paragraph", void 0, []) : t.createNode("paragraph", void 0, r);
  },
  renderMarkdown: (e, t, n) => {
    var r, o;
    if (!e)
      return "";
    const a = Array.isArray(e.content) ? e.content : [];
    if (a.length === 0) {
      const l = Array.isArray((r = n == null ? void 0 : n.previousNode) == null ? void 0 : r.content) ? n.previousNode.content : [];
      return ((o = n == null ? void 0 : n.previousNode) == null ? void 0 : o.type) === "paragraph" && l.length === 0 ? ja : "";
    }
    return t.renderChildren(a);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), o5 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, a5 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, l5 = Fn.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", at(this.options.HTMLAttributes, e), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (e, t) => t.applyMark("strike", t.parseInline(e.tokens || [])),
  renderMarkdown: (e, t) => `~~${t.renderChildren(e)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      Nr({
        find: o5,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ir({
        find: a5,
        type: this.type
      })
    ];
  }
}), s5 = Ht.create({
  name: "text",
  group: "inline",
  parseMarkdown: (e) => ({
    type: "text",
    text: e.text || ""
  }),
  renderMarkdown: (e) => e.text || ""
}), i5 = Fn.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["u", at(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown(e, t) {
    return t.applyMark(this.name || "underline", t.parseInline(e.tokens || []));
  },
  renderMarkdown(e, t) {
    return `++${t.renderChildren(e)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(e) {
      return e.indexOf("++");
    },
    tokenize(e, t, n) {
      const o = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
      if (!o)
        return;
      const a = o[2].trim();
      return {
        type: "underline",
        raw: o[0],
        text: a,
        tokens: n.inlineTokens(a)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: e }) => e.setMark(this.name),
      toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function d5(e = {}) {
  return new lt({
    view(t) {
      return new u5(t, e);
    }
  });
}
class u5 {
  constructor(t, n) {
    var r;
    this.editorView = t, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = n.width) !== null && r !== void 0 ? r : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((o) => {
      let a = (l) => {
        this[o](l);
      };
      return t.dom.addEventListener(o, a), { name: o, handler: a };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: t, handler: n }) => this.editorView.dom.removeEventListener(t, n));
  }
  update(t, n) {
    this.cursorPos != null && n.doc != t.state.doc && (this.cursorPos > t.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(t) {
    t != this.cursorPos && (this.cursorPos = t, t == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let t = this.editorView.state.doc.resolve(this.cursorPos), n = !t.parent.inlineContent, r, o = this.editorView.dom, a = o.getBoundingClientRect(), l = a.width / o.offsetWidth, s = a.height / o.offsetHeight;
    if (n) {
      let f = t.nodeBefore, h = t.nodeAfter;
      if (f || h) {
        let b = this.editorView.nodeDOM(this.cursorPos - (f ? f.nodeSize : 0));
        if (b) {
          let m = b.getBoundingClientRect(), v = f ? m.bottom : m.top;
          f && h && (v = (v + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let x = this.width / 2 * s;
          r = { left: m.left, right: m.right, top: v - x, bottom: v + x };
        }
      }
    }
    if (!r) {
      let f = this.editorView.coordsAtPos(this.cursorPos), h = this.width / 2 * l;
      r = { left: f.left - h, right: f.left + h, top: f.top, bottom: f.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let d, u;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      d = -pageXOffset, u = -pageYOffset;
    else {
      let f = i.getBoundingClientRect(), h = f.width / i.offsetWidth, b = f.height / i.offsetHeight;
      d = f.left - i.scrollLeft * h, u = f.top - i.scrollTop * b;
    }
    this.element.style.left = (r.left - d) / l + "px", this.element.style.top = (r.top - u) / s + "px", this.element.style.width = (r.right - r.left) / l + "px", this.element.style.height = (r.bottom - r.top) / s + "px";
  }
  scheduleRemoval(t) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), t);
  }
  dragover(t) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: t.clientX, top: t.clientY }), r = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), o = r && r.type.spec.disableDropCursor, a = typeof o == "function" ? o(this.editorView, n, t) : o;
    if (n && !a) {
      let l = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = gh(this.editorView.state.doc, l, this.editorView.dragging.slice);
        s != null && (l = s);
      }
      this.setCursor(l), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(t) {
    this.editorView.dom.contains(t.relatedTarget) || this.setCursor(null);
  }
}
class it extends Ue {
  /**
  Create a gap cursor.
  */
  constructor(t) {
    super(t, t);
  }
  map(t, n) {
    let r = t.resolve(n.map(this.head));
    return it.valid(r) ? new it(r) : Ue.near(r);
  }
  content() {
    return Ee.empty;
  }
  eq(t) {
    return t instanceof it && t.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(t, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new it(t.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new _d(this.anchor);
  }
  /**
  @internal
  */
  static valid(t) {
    let n = t.parent;
    if (n.inlineContent || !c5(t) || !f5(t))
      return !1;
    let r = n.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let o = n.contentMatchAt(t.index()).defaultType;
    return o && o.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(t, n, r = !1) {
    e: for (; ; ) {
      if (!r && it.valid(t))
        return t;
      let o = t.pos, a = null;
      for (let l = t.depth; ; l--) {
        let s = t.node(l);
        if (n > 0 ? t.indexAfter(l) < s.childCount : t.index(l) > 0) {
          a = s.child(n > 0 ? t.indexAfter(l) : t.index(l) - 1);
          break;
        } else if (l == 0)
          return null;
        o += n;
        let i = t.doc.resolve(o);
        if (it.valid(i))
          return i;
      }
      for (; ; ) {
        let l = n > 0 ? a.firstChild : a.lastChild;
        if (!l) {
          if (a.isAtom && !a.isText && !Oe.isSelectable(a)) {
            t = t.doc.resolve(o + a.nodeSize * n), r = !1;
            continue e;
          }
          break;
        }
        a = l, o += n;
        let s = t.doc.resolve(o);
        if (it.valid(s))
          return s;
      }
      return null;
    }
  }
}
it.prototype.visible = !1;
it.findFrom = it.findGapCursorFrom;
Ue.jsonID("gapcursor", it);
class _d {
  constructor(t) {
    this.pos = t;
  }
  map(t) {
    return new _d(t.map(this.pos));
  }
  resolve(t) {
    let n = t.resolve(this.pos);
    return it.valid(n) ? new it(n) : Ue.near(n);
  }
}
function vp(e) {
  return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function c5(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.index(t), r = e.node(t);
    if (n == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n - 1); ; o = o.lastChild) {
      if (o.childCount == 0 && !o.inlineContent || vp(o.type))
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function f5(e) {
  for (let t = e.depth; t >= 0; t--) {
    let n = e.indexAfter(t), r = e.node(t);
    if (n == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let o = r.child(n); ; o = o.firstChild) {
      if (o.childCount == 0 && !o.inlineContent || vp(o.type))
        return !0;
      if (o.inlineContent)
        return !1;
    }
  }
  return !0;
}
function h5() {
  return new lt({
    props: {
      decorations: m5,
      createSelectionBetween(e, t, n) {
        return t.pos == n.pos && it.valid(n) ? new it(n) : null;
      },
      handleClick: p5,
      handleKeyDown: b5,
      handleDOMEvents: { beforeinput: g5 }
    }
  });
}
const b5 = vb({
  ArrowLeft: Ua("horiz", -1),
  ArrowRight: Ua("horiz", 1),
  ArrowUp: Ua("vert", -1),
  ArrowDown: Ua("vert", 1)
});
function Ua(e, t) {
  const n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function(r, o, a) {
    let l = r.selection, s = t > 0 ? l.$to : l.$from, i = l.empty;
    if (l instanceof Fe) {
      if (!a.endOfTextblock(n) || s.depth == 0)
        return !1;
      i = !1, s = r.doc.resolve(t > 0 ? s.after() : s.before());
    }
    let d = it.findGapCursorFrom(s, t, i);
    return d ? (o && o(r.tr.setSelection(new it(d))), !0) : !1;
  };
}
function p5(e, t, n) {
  if (!e || !e.editable)
    return !1;
  let r = e.state.doc.resolve(t);
  if (!it.valid(r))
    return !1;
  let o = e.posAtCoords({ left: n.clientX, top: n.clientY });
  return o && o.inside > -1 && Oe.isSelectable(e.state.doc.nodeAt(o.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new it(r))), !0);
}
function g5(e, t) {
  if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof it))
    return !1;
  let { $from: n } = e.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!r)
    return !1;
  let o = Ce.empty;
  for (let l = r.length - 1; l >= 0; l--)
    o = Ce.from(r[l].createAndFill(null, o));
  let a = e.state.tr.replace(n.pos, n.pos, new Ee(o, 0, 0));
  return a.setSelection(Fe.near(a.doc.resolve(n.pos + 1))), e.dispatch(a), !1;
}
function m5(e) {
  if (!(e.selection instanceof it))
    return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", rt.create(e.doc, [Rt.widget(e.selection.head, t, { key: "gapcursor" })]);
}
var ns = 200, xt = function() {
};
xt.prototype.append = function(t) {
  return t.length ? (t = xt.from(t), !this.length && t || t.length < ns && this.leafAppend(t) || this.length < ns && t.leafPrepend(this) || this.appendInner(t)) : this;
};
xt.prototype.prepend = function(t) {
  return t.length ? xt.from(t).append(this) : this;
};
xt.prototype.appendInner = function(t) {
  return new v5(this, t);
};
xt.prototype.slice = function(t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = this.length), t >= n ? xt.empty : this.sliceInner(Math.max(0, t), Math.min(this.length, n));
};
xt.prototype.get = function(t) {
  if (!(t < 0 || t >= this.length))
    return this.getInner(t);
};
xt.prototype.forEach = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length), n <= r ? this.forEachInner(t, n, r, 0) : this.forEachInvertedInner(t, n, r, 0);
};
xt.prototype.map = function(t, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = this.length);
  var o = [];
  return this.forEach(function(a, l) {
    return o.push(t(a, l));
  }, n, r), o;
};
xt.from = function(t) {
  return t instanceof xt ? t : t && t.length ? new xp(t) : xt.empty;
};
var xp = /* @__PURE__ */ function(e) {
  function t(r) {
    e.call(this), this.values = r;
  }
  e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return t.prototype.flatten = function() {
    return this.values;
  }, t.prototype.sliceInner = function(o, a) {
    return o == 0 && a == this.length ? this : new t(this.values.slice(o, a));
  }, t.prototype.getInner = function(o) {
    return this.values[o];
  }, t.prototype.forEachInner = function(o, a, l, s) {
    for (var i = a; i < l; i++)
      if (o(this.values[i], s + i) === !1)
        return !1;
  }, t.prototype.forEachInvertedInner = function(o, a, l, s) {
    for (var i = a - 1; i >= l; i--)
      if (o(this.values[i], s + i) === !1)
        return !1;
  }, t.prototype.leafAppend = function(o) {
    if (this.length + o.length <= ns)
      return new t(this.values.concat(o.flatten()));
  }, t.prototype.leafPrepend = function(o) {
    if (this.length + o.length <= ns)
      return new t(o.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(t.prototype, n), t;
}(xt);
xt.empty = new xp([]);
var v5 = /* @__PURE__ */ function(e) {
  function t(n, r) {
    e.call(this), this.left = n, this.right = r, this.length = n.length + r.length, this.depth = Math.max(n.depth, r.depth) + 1;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, t.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, t.prototype.forEachInner = function(r, o, a, l) {
    var s = this.left.length;
    if (o < s && this.left.forEachInner(r, o, Math.min(a, s), l) === !1 || a > s && this.right.forEachInner(r, Math.max(o - s, 0), Math.min(this.length, a) - s, l + s) === !1)
      return !1;
  }, t.prototype.forEachInvertedInner = function(r, o, a, l) {
    var s = this.left.length;
    if (o > s && this.right.forEachInvertedInner(r, o - s, Math.max(a, s) - s, l + s) === !1 || a < s && this.left.forEachInvertedInner(r, Math.min(o, s), a, l) === !1)
      return !1;
  }, t.prototype.sliceInner = function(r, o) {
    if (r == 0 && o == this.length)
      return this;
    var a = this.left.length;
    return o <= a ? this.left.slice(r, o) : r >= a ? this.right.slice(r - a, o - a) : this.left.slice(r, a).append(this.right.slice(0, o - a));
  }, t.prototype.leafAppend = function(r) {
    var o = this.right.leafAppend(r);
    if (o)
      return new t(this.left, o);
  }, t.prototype.leafPrepend = function(r) {
    var o = this.left.leafPrepend(r);
    if (o)
      return new t(o, this.right);
  }, t.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new t(this.left, new t(this.right, r)) : new t(this, r);
  }, t;
}(xt);
const x5 = 500;
class ln {
  constructor(t, n) {
    this.items = t, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(t, n) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let o, a;
    n && (o = this.remapping(r, this.items.length), a = o.maps.length);
    let l = t.tr, s, i, d = [], u = [];
    return this.items.forEach((f, h) => {
      if (!f.step) {
        o || (o = this.remapping(r, h + 1), a = o.maps.length), a--, u.push(f);
        return;
      }
      if (o) {
        u.push(new mn(f.map));
        let b = f.step.map(o.slice(a)), m;
        b && l.maybeStep(b).doc && (m = l.mapping.maps[l.mapping.maps.length - 1], d.push(new mn(m, void 0, void 0, d.length + u.length))), a--, m && o.appendMap(m, a);
      } else
        l.maybeStep(f.step);
      if (f.selection)
        return s = o ? f.selection.map(o.slice(a)) : f.selection, i = new ln(this.items.slice(0, r).append(u.reverse().concat(d)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: i, transform: l, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(t, n, r, o) {
    let a = [], l = this.eventCount, s = this.items, i = !o && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < t.steps.length; u++) {
      let f = t.steps[u].invert(t.docs[u]), h = new mn(t.mapping.maps[u], f, n), b;
      (b = i && i.merge(h)) && (h = b, u ? a.pop() : s = s.slice(0, s.length - 1)), a.push(h), n && (l++, n = void 0), o || (i = h);
    }
    let d = l - r.depth;
    return d > k5 && (s = y5(s, d), l -= d), new ln(s.append(a), l);
  }
  remapping(t, n) {
    let r = new la();
    return this.items.forEach((o, a) => {
      let l = o.mirrorOffset != null && a - o.mirrorOffset >= t ? r.maps.length - o.mirrorOffset : void 0;
      r.appendMap(o.map, l);
    }, t, n), r;
  }
  addMaps(t) {
    return this.eventCount == 0 ? this : new ln(this.items.append(t.map((n) => new mn(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(t, n) {
    if (!this.eventCount)
      return this;
    let r = [], o = Math.max(0, this.items.length - n), a = t.mapping, l = t.steps.length, s = this.eventCount;
    this.items.forEach((h) => {
      h.selection && s--;
    }, o);
    let i = n;
    this.items.forEach((h) => {
      let b = a.getMirror(--i);
      if (b == null)
        return;
      l = Math.min(l, b);
      let m = a.maps[b];
      if (h.step) {
        let v = t.steps[b].invert(t.docs[b]), x = h.selection && h.selection.map(a.slice(i + 1, b));
        x && s++, r.push(new mn(m, v, x));
      } else
        r.push(new mn(m));
    }, o);
    let d = [];
    for (let h = n; h < l; h++)
      d.push(new mn(a.maps[h]));
    let u = this.items.slice(0, o).append(d).append(r), f = new ln(u, s);
    return f.emptyItemCount() > x5 && (f = f.compress(this.items.length - r.length)), f;
  }
  emptyItemCount() {
    let t = 0;
    return this.items.forEach((n) => {
      n.step || t++;
    }), t;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(t = this.items.length) {
    let n = this.remapping(0, t), r = n.maps.length, o = [], a = 0;
    return this.items.forEach((l, s) => {
      if (s >= t)
        o.push(l), l.selection && a++;
      else if (l.step) {
        let i = l.step.map(n.slice(r)), d = i && i.getMap();
        if (r--, d && n.appendMap(d, r), i) {
          let u = l.selection && l.selection.map(n.slice(r));
          u && a++;
          let f = new mn(d.invert(), i, u), h, b = o.length - 1;
          (h = o.length && o[b].merge(f)) ? o[b] = h : o.push(f);
        }
      } else l.map && r--;
    }, this.items.length, 0), new ln(xt.from(o.reverse()), a);
  }
}
ln.empty = new ln(xt.empty, 0);
function y5(e, t) {
  let n;
  return e.forEach((r, o) => {
    if (r.selection && t-- == 0)
      return n = o, !1;
  }), e.slice(n);
}
class mn {
  constructor(t, n, r, o) {
    this.map = t, this.step = n, this.selection = r, this.mirrorOffset = o;
  }
  merge(t) {
    if (this.step && t.step && !t.selection) {
      let n = t.step.merge(this.step);
      if (n)
        return new mn(n.getMap().invert(), n, this.selection);
    }
  }
}
class Kn {
  constructor(t, n, r, o, a) {
    this.done = t, this.undone = n, this.prevRanges = r, this.prevTime = o, this.prevComposition = a;
  }
}
const k5 = 20;
function w5(e, t, n, r) {
  let o = n.getMeta(Er), a;
  if (o)
    return o.historyState;
  n.getMeta($5) && (e = new Kn(e.done, e.undone, null, 0, -1));
  let l = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return e;
  if (l && l.getMeta(Er))
    return l.getMeta(Er).redo ? new Kn(e.done.addTransform(n, void 0, r, ll(t)), e.undone, Qc(n.mapping.maps), e.prevTime, e.prevComposition) : new Kn(e.done, e.undone.addTransform(n, void 0, r, ll(t)), null, e.prevTime, e.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(l && l.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), i = e.prevTime == 0 || !l && e.prevComposition != s && (e.prevTime < (n.time || 0) - r.newGroupDelay || !C5(n, e.prevRanges)), d = l ? _s(e.prevRanges, n.mapping) : Qc(n.mapping.maps);
    return new Kn(e.done.addTransform(n, i ? t.selection.getBookmark() : void 0, r, ll(t)), ln.empty, d, n.time, s ?? e.prevComposition);
  } else return (a = n.getMeta("rebased")) ? new Kn(e.done.rebased(n, a), e.undone.rebased(n, a), _s(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new Kn(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), _s(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function C5(e, t) {
  if (!t)
    return !1;
  if (!e.docChanged)
    return !0;
  let n = !1;
  return e.mapping.maps[0].forEach((r, o) => {
    for (let a = 0; a < t.length; a += 2)
      r <= t[a + 1] && o >= t[a] && (n = !0);
  }), n;
}
function Qc(e) {
  let t = [];
  for (let n = e.length - 1; n >= 0 && t.length == 0; n--)
    e[n].forEach((r, o, a, l) => t.push(a, l));
  return t;
}
function _s(e, t) {
  if (!e)
    return null;
  let n = [];
  for (let r = 0; r < e.length; r += 2) {
    let o = t.map(e[r], 1), a = t.map(e[r + 1], -1);
    o <= a && n.push(o, a);
  }
  return n;
}
function S5(e, t, n) {
  let r = ll(t), o = Er.get(t).spec.config, a = (n ? e.undone : e.done).popEvent(t, r);
  if (!a)
    return null;
  let l = a.selection.resolve(a.transform.doc), s = (n ? e.done : e.undone).addTransform(a.transform, t.selection.getBookmark(), o, r), i = new Kn(n ? s : a.remaining, n ? a.remaining : s, null, 0, -1);
  return a.transform.setSelection(l).setMeta(Er, { redo: n, historyState: i });
}
let ei = !1, _c = null;
function ll(e) {
  let t = e.plugins;
  if (_c != t) {
    ei = !1, _c = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].spec.historyPreserveItems) {
        ei = !0;
        break;
      }
  }
  return ei;
}
const Er = new gt("history"), $5 = new gt("closeHistory");
function I5(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new lt({
    key: Er,
    state: {
      init() {
        return new Kn(ln.empty, ln.empty, null, 0, -1);
      },
      apply(t, n, r) {
        return w5(n, r, t, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(t, n) {
          let r = n.inputType, o = r == "historyUndo" ? kp : r == "historyRedo" ? wp : null;
          return !o || !t.editable ? !1 : (n.preventDefault(), o(t.state, t.dispatch));
        }
      }
    }
  });
}
function yp(e, t) {
  return (n, r) => {
    let o = Er.getState(n);
    if (!o || (e ? o.undone : o.done).eventCount == 0)
      return !1;
    if (r) {
      let a = S5(o, n, e);
      a && r(t ? a.scrollIntoView() : a);
    }
    return !0;
  };
}
const kp = yp(!1, !0), wp = yp(!0, !0);
_e.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      autoTrim: !0,
      mode: "textSize",
      textCounter: (e) => e.length,
      wordCounter: (e) => e.split(" ").filter((t) => t !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (e) => {
      const t = (e == null ? void 0 : e.node) || this.editor.state.doc;
      if (((e == null ? void 0 : e.mode) || this.options.mode) === "textSize") {
        const r = t.textBetween(0, t.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return t.nodeSize;
    }, this.storage.words = (e) => {
      const t = (e == null ? void 0 : e.node) || this.editor.state.doc, n = t.textBetween(0, t.content.size, " ", " ");
      return this.options.wordCounter(n);
    };
  },
  addProseMirrorPlugins() {
    let e = !1;
    return [
      new lt({
        key: new gt("characterCount"),
        appendTransaction: (t, n, r) => {
          if (e)
            return;
          const o = this.options.limit, a = this.options.autoTrim;
          if (o == null || o === 0 || a === !1) {
            e = !0;
            return;
          }
          const l = this.storage.characters({ node: r.doc });
          if (l > o) {
            const s = l - o, i = 0, d = s;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${o} characters. Content was automatically trimmed.`
            );
            const u = r.tr.deleteRange(i, d);
            return e = !0, u;
          }
          e = !0;
        },
        filterTransaction: (t, n) => {
          const r = this.options.limit;
          if (!t.docChanged || r === 0 || r === null || r === void 0)
            return !0;
          const o = this.storage.characters({ node: n.doc }), a = this.storage.characters({ node: t.doc });
          if (a <= r || o > r && a > r && a <= o)
            return !0;
          if (o > r && a > r && a > o || !t.getMeta("paste"))
            return !1;
          const s = t.selection.$head.pos, i = a - r, d = s - i, u = s;
          return t.deleteRange(d, u), !(this.storage.characters({ node: t.doc }) > r);
        }
      })
    ];
  }
});
var T5 = _e.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [d5(this.options)];
  }
});
_e.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new lt({
        key: new gt("focus"),
        props: {
          decorations: ({ doc: e, selection: t }) => {
            const { isEditable: n, isFocused: r } = this.editor, { anchor: o } = t, a = [];
            if (!n || !r)
              return rt.create(e, []);
            let l = 0;
            this.options.mode === "deepest" && e.descendants((i, d) => {
              if (i.isText)
                return;
              if (!(o >= d && o <= d + i.nodeSize - 1))
                return !1;
              l += 1;
            });
            let s = 0;
            return e.descendants((i, d) => {
              if (i.isText || !(o >= d && o <= d + i.nodeSize - 1))
                return !1;
              if (s += 1, this.options.mode === "deepest" && l - s > 0 || this.options.mode === "shallowest" && s > 1)
                return this.options.mode === "deepest";
              a.push(
                Rt.node(d, d + i.nodeSize, {
                  class: this.options.className
                })
              );
            }), rt.create(e, a);
          }
        }
      })
    ];
  }
});
var L5 = _e.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [h5()];
  },
  extendNodeSchema(e) {
    var t;
    const n = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (t = Xe(Re(e, "allowGapCursor", n))) != null ? t : null
    };
  }
});
function ef(e) {
  const {
    editor: t,
    placeholder: n,
    dataAttribute: r,
    pos: o,
    node: a,
    isEmptyDoc: l,
    hasAnchor: s,
    classes: { emptyNode: i, emptyEditor: d }
  } = e, u = [i];
  return l && u.push(d), Rt.node(o, o + a.nodeSize, {
    class: u.join(" "),
    [r]: typeof n == "function" ? n({
      editor: t,
      node: a,
      pos: o,
      hasAnchor: s
    }) : n
  });
}
function M5(e) {
  const t = getComputedStyle(e), n = `${t.overflow} ${t.overflowY} ${t.overflowX}`;
  return /auto|scroll|overlay/.test(n);
}
function E5(e) {
  let t = e;
  for (; t; ) {
    if (M5(t))
      return t;
    const n = t.parentElement;
    if (!n) {
      const r = t.getRootNode();
      if (r instanceof ShadowRoot) {
        t = r.host;
        continue;
      }
      return window;
    }
    t = n;
  }
  return window;
}
function A5(e) {
  return e === window ? { top: 0, bottom: window.innerHeight } : e.getBoundingClientRect();
}
function D5({
  doc: e,
  view: t,
  scrollContainer: n
}) {
  const r = t.dom.getBoundingClientRect(), o = n ? A5(n) : { top: 0, bottom: window.innerHeight }, a = Math.max(r.top, o.top), l = Math.min(r.bottom, o.bottom);
  if (a >= l)
    return { top: 0, bottom: e.content.size };
  const i = getComputedStyle(t.dom).direction === "rtl" ? Math.max(r.right - 2, r.left + 2) : r.left + 2, d = t.posAtCoords({ left: i, top: a + 2 }), u = t.posAtCoords({ left: i, top: l - 2 });
  return {
    top: d ? d.pos : 0,
    bottom: u ? u.pos : e.content.size
  };
}
function R5(e, t) {
  let n = null;
  return { call: (...a) => {
    n || (e(...a), n = setTimeout(() => {
      n = null;
    }, t));
  }, cancel: () => {
    n && (clearTimeout(n), n = null);
  } };
}
var tf = "placeholder";
function B5(e) {
  return e.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var Io = new gt("tiptap__placeholder");
_e.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: tf,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const e = this.options.dataAttribute ? `data-${B5(this.options.dataAttribute)}` : `data-${tf}`;
    return [
      new lt({
        state: {
          init() {
            return {
              // null means "no viewport info yet" — decoration callback falls
              // back to full document scan until the scroll handler fires.
              topPos: null,
              bottomPos: null
            };
          },
          apply(t, n) {
            const r = t.getMeta(Io);
            return r != null && r.positions ? {
              topPos: r.positions.top,
              bottomPos: r.positions.bottom
            } : t.docChanged ? {
              topPos: n.topPos !== null ? t.mapping.map(n.topPos) : null,
              bottomPos: n.bottomPos !== null ? t.mapping.map(n.bottomPos) : null
            } : n;
          }
        },
        key: Io,
        view(t) {
          const n = E5(t.dom), r = () => {
            const s = D5({
              view: t,
              doc: t.state.doc,
              scrollContainer: n
            }), i = Io.getState(t.state);
            if (i.topPos === s.top && i.bottomPos === s.bottom)
              return;
            const d = t.state.tr.setMeta(Io, { positions: s }).setMeta("tiptap__viewportUpdate", !0);
            t.dispatch(d);
          }, { call: o, cancel: a } = R5(r, 250), l = n;
          return l.addEventListener("scroll", o, { passive: !0 }), r(), {
            update(s, i) {
              t.state.doc.content.size !== i.doc.content.size && r();
            },
            destroy: () => {
              a(), l.removeEventListener("scroll", o);
            }
          };
        },
        props: {
          decorations: ({ doc: t, selection: n }) => {
            var r, o;
            if (!(this.editor.isEditable || !this.options.showOnlyWhenEditable))
              return null;
            const { anchor: l } = n, s = [], i = this.editor.isEmpty;
            if (this.options.showOnlyCurrent && !this.options.includeChildren) {
              const u = t.resolve(l);
              if (u.depth > 0) {
                const f = u.node(1), h = u.before(1);
                if (f.type.isTextblock && ha(f)) {
                  const b = l >= h && l <= h + f.nodeSize, m = ef({
                    node: f,
                    dataAttribute: e,
                    hasAnchor: b,
                    placeholder: this.options.placeholder,
                    classes: {
                      emptyEditor: this.options.emptyEditorClass,
                      emptyNode: this.options.emptyNodeClass
                    },
                    editor: this.editor,
                    isEmptyDoc: i,
                    pos: u.before(1)
                  });
                  s.push(m);
                }
              }
            } else {
              const u = Io.getState(this.editor.state), f = (r = u.topPos) != null ? r : 0, h = (o = u.bottomPos) != null ? o : t.content.size;
              t.nodesBetween(f, h, (b, m) => {
                const v = l >= m && l <= m + b.nodeSize, x = !b.isLeaf && ha(b);
                if (!b.type.isTextblock)
                  return this.options.includeChildren;
                if ((v || !this.options.showOnlyCurrent) && x) {
                  const k = ef({
                    classes: { emptyEditor: this.options.emptyEditorClass, emptyNode: this.options.emptyNodeClass },
                    editor: this.editor,
                    isEmptyDoc: i,
                    dataAttribute: e,
                    hasAnchor: v,
                    placeholder: this.options.placeholder,
                    node: b,
                    pos: m
                  });
                  s.push(k);
                }
                return this.options.includeChildren;
              });
            }
            return rt.create(t, s);
          }
        }
      })
    ];
  }
});
_e.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: e, options: t } = this;
    return [
      new lt({
        key: new gt("selection"),
        props: {
          decorations(n) {
            return n.selection.empty || e.isFocused || !e.isEditable || Bb(n.selection) || e.view.dragging ? null : rt.create(n.doc, [
              Rt.inline(n.selection.from, n.selection.to, {
                class: t.className
              })
            ]);
          }
        }
      })
    ];
  }
});
var O5 = "skipTrailingNode";
function nf({ types: e, node: t }) {
  return t && Array.isArray(e) && e.includes(t.type) || (t == null ? void 0 : t.type) === e;
}
var P5 = _e.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var e;
    const t = new gt(this.name), n = this.options.node || ((e = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : e.name) || "paragraph", r = Object.entries(this.editor.schema.nodes).map(([, o]) => o).filter((o) => (this.options.notAfter || []).concat(n).includes(o.name));
    return [
      new lt({
        key: t,
        appendTransaction: (o, a, l) => {
          const { doc: s, tr: i, schema: d } = l, u = t.getState(l), f = s.content.size, h = d.nodes[n];
          if (!o.some((b) => b.getMeta(O5)) && u)
            return i.insert(f, h.create());
        },
        state: {
          init: (o, a) => {
            const l = a.tr.doc.lastChild;
            return !nf({ node: l, types: r });
          },
          apply: (o, a) => {
            if (!o.docChanged || o.getMeta("__uniqueIDTransaction"))
              return a;
            const l = o.doc.lastChild;
            return !nf({ node: l, types: r });
          }
        }
      })
    ];
  }
}), z5 = _e.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: t }) => kp(e, t),
      redo: () => ({ state: e, dispatch: t }) => wp(e, t)
    };
  },
  addProseMirrorPlugins() {
    return [I5(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), N5 = _e.create({
  name: "starterKit",
  addExtensions() {
    var e, t, n, r;
    const o = [];
    return this.options.bold !== !1 && o.push(_S.configure(this.options.bold)), this.options.blockquote !== !1 && o.push(JS.configure(this.options.blockquote)), this.options.bulletList !== !1 && o.push(ip.configure(this.options.bulletList)), this.options.code !== !1 && o.push(n$.configure(this.options.code)), this.options.codeBlock !== !1 && o.push(a$.configure(this.options.codeBlock)), this.options.document !== !1 && o.push(l$.configure(this.options.document)), this.options.dropcursor !== !1 && o.push(T5.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && o.push(L5.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && o.push(s$.configure(this.options.hardBreak)), this.options.heading !== !1 && o.push(i$.configure(this.options.heading)), this.options.undoRedo !== !1 && o.push(z5.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && o.push(d$.configure(this.options.horizontalRule)), this.options.italic !== !1 && o.push(b$.configure(this.options.italic)), this.options.listItem !== !1 && o.push(dp.configure(this.options.listItem)), this.options.listKeymap !== !1 && o.push(pp.configure((e = this.options) == null ? void 0 : e.listKeymap)), this.options.link !== !1 && o.push(F$.configure((t = this.options) == null ? void 0 : t.link)), this.options.orderedList !== !1 && o.push(mp.configure(this.options.orderedList)), this.options.paragraph !== !1 && o.push(r5.configure(this.options.paragraph)), this.options.strike !== !1 && o.push(l5.configure(this.options.strike)), this.options.text !== !1 && o.push(s5.configure(this.options.text)), this.options.underline !== !1 && o.push(i5.configure((n = this.options) == null ? void 0 : n.underline)), this.options.trailingNode !== !1 && o.push(P5.configure((r = this.options) == null ? void 0 : r.trailingNode)), o;
  }
}), V5 = N5, F5 = _e.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (e) => {
              const t = e.style.textAlign;
              return this.options.alignments.includes(t) ? t : this.options.defaultAlignment;
            },
            renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.map((n) => t.updateAttributes(n, { textAlign: e })).some((n) => n) : !1,
      unsetTextAlign: () => ({ commands: e }) => this.options.types.map((t) => e.resetAttributes(t, "textAlign")).some((t) => t),
      toggleTextAlign: (e) => ({ editor: t, commands: n }) => this.options.alignments.includes(e) ? t.isActive({ textAlign: e }) ? n.unsetTextAlign() : n.setTextAlign(e) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), H5 = F5, W5 = 20, Cp = (e, t = 0) => {
  const n = [];
  return !e.children.length || t > W5 || Array.from(e.children).forEach((r) => {
    r.tagName === "SPAN" ? n.push(r) : r.children.length && n.push(...Cp(r, t + 1));
  }), n;
}, j5 = (e) => {
  if (!e.children.length)
    return;
  const t = Cp(e);
  t && t.forEach((n) => {
    var r, o;
    const a = n.getAttribute("style"), l = (o = (r = n.parentElement) == null ? void 0 : r.closest("span")) == null ? void 0 : o.getAttribute("style");
    n.setAttribute("style", `${l};${a}`);
  });
}, Sp = Fn.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (e) => e.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && j5(e), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["span", at(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (e) => ({ commands: t }) => t.toggleMark(this.name, e),
      removeEmptyTextStyle: () => ({ tr: e }) => {
        const { selection: t } = e;
        return e.doc.nodesBetween(t.from, t.to, (n, r) => {
          if (n.isTextblock)
            return !0;
          n.marks.filter((o) => o.type === this.type).some((o) => Object.values(o.attrs).some((a) => !!a)) || e.removeMark(r, r + n.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), U5 = _e.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (e) => {
              var t;
              const n = (t = yo(e, "background-color")) != null ? t : e.style.backgroundColor;
              return n == null ? void 0 : n.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.backgroundColor ? {
              style: `background-color: ${e.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (e) => ({ chain: t }) => t().setMark("textStyle", { backgroundColor: e }).run(),
      unsetBackgroundColor: () => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), $p = _e.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (e) => {
              var t;
              const n = (t = yo(e, "color")) != null ? t : e.style.color;
              return n == null ? void 0 : n.replace(/['"]+/g, "");
            },
            renderHTML: (e) => e.color ? {
              style: `color: ${e.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (e) => ({ chain: t }) => t().setMark("textStyle", { color: e }).run(),
      unsetColor: () => ({ chain: e }) => e().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), G5 = _e.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            // Prefer the raw inline `style` attribute so unquoted or
            // single-quoted multi-word names are preserved instead of being
            // canonicalized by `element.style.fontFamily`, which forces double
            // quotes that then get HTML-encoded to `&quot;` on serialization.
            parseHTML: (e) => {
              var t;
              return (t = yo(e, "font-family")) != null ? t : e.style.fontFamily;
            },
            renderHTML: (e) => e.fontFamily ? {
              style: `font-family: ${e.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (e) => ({ chain: t }) => t().setMark("textStyle", { fontFamily: e }).run(),
      unsetFontFamily: () => ({ chain: e }) => e().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), q5 = _e.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.fontSize`.
            parseHTML: (e) => {
              var t;
              return (t = yo(e, "font-size")) != null ? t : e.style.fontSize;
            },
            renderHTML: (e) => e.fontSize ? {
              style: `font-size: ${e.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (e) => ({ chain: t }) => t().setMark("textStyle", { fontSize: e }).run(),
      unsetFontSize: () => ({ chain: e }) => e().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), K5 = _e.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            // Prefer the raw inline `style` attribute so the original format
            // is preserved instead of the canonicalized value returned by
            // `element.style.lineHeight`.
            parseHTML: (e) => {
              var t;
              return (t = yo(e, "line-height")) != null ? t : e.style.lineHeight;
            },
            renderHTML: (e) => e.lineHeight ? {
              style: `line-height: ${e.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (e) => ({ chain: t }) => t().setMark("textStyle", { lineHeight: e }).run(),
      unsetLineHeight: () => ({ chain: e }) => e().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
_e.create({
  name: "textStyleKit",
  addExtensions() {
    const e = [];
    return this.options.backgroundColor !== !1 && e.push(U5.configure(this.options.backgroundColor)), this.options.color !== !1 && e.push($p.configure(this.options.color)), this.options.fontFamily !== !1 && e.push(G5.configure(this.options.fontFamily)), this.options.fontSize !== !1 && e.push(q5.configure(this.options.fontSize)), this.options.lineHeight !== !1 && e.push(K5.configure(this.options.lineHeight)), this.options.textStyle !== !1 && e.push(Sp.configure(this.options.textStyle)), e;
  }
});
var J5 = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, Z5 = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, Y5 = Fn.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        // Prefer `data-color` (set by our own `renderHTML`) for lossless
        // round-trips. Otherwise parse the raw inline `style` attribute so
        // the original color format (e.g. `#rrggbb`) is preserved instead of
        // the canonicalized `rgb(...)` value from `element.style.backgroundColor`.
        parseHTML: (e) => e.getAttribute("data-color") || yo(e, "background-color") || e.style.backgroundColor,
        renderHTML: (e) => e.color ? {
          "data-color": e.color,
          style: `background-color: ${e.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["mark", at(this.options.HTMLAttributes, e), 0];
  },
  renderMarkdown: (e, t) => `==${t.renderChildren(e)}==`,
  parseMarkdown: (e, t) => t.applyMark("highlight", t.parseInline(e.tokens || [])),
  markdownTokenizer: {
    name: "highlight",
    level: "inline",
    start: (e) => e.indexOf("=="),
    tokenize(e, t, n) {
      const o = /^(==)([^=]+)(==)/.exec(e);
      if (o) {
        const a = o[2].trim(), l = n.inlineTokens(a);
        return {
          type: "highlight",
          raw: o[0],
          text: a,
          tokens: l
        };
      }
    }
  },
  addCommands() {
    return {
      setHighlight: (e) => ({ commands: t }) => t.setMark(this.name, e),
      toggleHighlight: (e) => ({ commands: t }) => t.toggleMark(this.name, e),
      unsetHighlight: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      Nr({
        find: J5,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      ir({
        find: Z5,
        type: this.type
      })
    ];
  }
}), X5 = Y5, Q5 = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, _5 = Ht.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["img", at(this.options.HTMLAttributes, e)];
  },
  parseMarkdown: (e, t) => t.createNode("image", {
    src: e.href,
    title: e.title,
    alt: e.text
  }),
  renderMarkdown: (e) => {
    var t, n, r, o, a, l;
    const s = (n = (t = e.attrs) == null ? void 0 : t.src) != null ? n : "", i = (o = (r = e.attrs) == null ? void 0 : r.alt) != null ? o : "", d = (l = (a = e.attrs) == null ? void 0 : a.title) != null ? l : "";
    return d ? `![${i}](${s} "${d}")` : `![${i}](${s})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: e, minWidth: t, minHeight: n, alwaysPreserveAspectRatio: r } = this.options.resize;
    return ({ node: o, getPos: a, HTMLAttributes: l, editor: s }) => {
      const i = document.createElement("img");
      Object.entries(l).forEach(([f, h]) => {
        if (h != null)
          switch (f) {
            case "width":
            case "height":
              break;
            default:
              i.setAttribute(f, h);
              break;
          }
      }), i.src = l.src;
      const d = new OS({
        element: i,
        editor: s,
        node: o,
        getPos: a,
        onResize: (f, h) => {
          i.style.width = `${f}px`, i.style.height = `${h}px`;
        },
        onCommit: (f, h) => {
          const b = a();
          b !== void 0 && this.editor.chain().setNodeSelection(b).updateAttributes(this.name, {
            width: f,
            height: h
          }).run();
        },
        onUpdate: (f, h, b) => f.type === o.type,
        options: {
          directions: e,
          min: {
            width: t,
            height: n
          },
          preserveAspectRatio: r === !0
        }
      }), u = d.dom;
      return u.style.visibility = "hidden", u.style.pointerEvents = "none", i.onload = () => {
        u.style.visibility = "", u.style.pointerEvents = "";
      }, d;
    };
  },
  addCommands() {
    return {
      setImage: (e) => ({ commands: t }) => t.insertContent({
        type: this.name,
        attrs: e
      })
    };
  },
  addInputRules() {
    return [
      Xb({
        find: Q5,
        type: this.type,
        getAttributes: (e) => {
          const [, , t, n, r] = e;
          return { src: n, alt: t, title: r };
        }
      })
    ];
  }
}), eI = _5;
const tI = ["id", "for"], nI = { class: "font-medium" }, rI = {
  key: 0,
  "aria-hidden": "true",
  class: "font-medium"
}, oI = ["aria-label"], aI = { class: "flex items-center gap-1 flex-wrap" }, lI = ["disabled", "aria-label", "title"], sI = ["disabled", "aria-label", "title"], iI = ["disabled", "aria-label", "title"], dI = ["disabled", "aria-label", "title"], uI = ["disabled", "aria-label", "title"], cI = ["aria-label", "title"], fI = ["disabled"], hI = ["aria-label", "title"], bI = ["disabled"], pI = ["disabled", "aria-label", "title"], gI = ["disabled", "aria-label", "title"], mI = ["disabled", "aria-label", "title"], vI = { class: "flex items-center gap-2 flex-wrap" }, xI = ["disabled", "aria-expanded", "aria-label"], yI = { class: "leading-5" }, kI = ["aria-label"], wI = ["aria-selected", "onClick"], CI = {
  key: 0,
  "aria-hidden": "true",
  class: "format-menu-shortcut"
}, SI = ["disabled", "aria-label", "title"], $I = ["disabled", "aria-label", "title"], II = ["disabled", "aria-label", "title"], TI = ["disabled", "aria-label", "title"], LI = ["disabled", "aria-label", "title"], MI = {
  key: 1,
  "aria-hidden": "true",
  class: "pointer-events-none absolute top-3 left-3 text-sm text-(--text-text-body-subtle) leading-5"
}, EI = { class: "min-h-4.5 flex flex-col gap-px" }, AI = ["id"], DI = ["id"], RI = ["aria-label"], BI = { class: "rte-dialog-title" }, OI = { class: "rte-dialog-field" }, PI = { class: "rte-dialog-label" }, zI = ["placeholder", "aria-invalid", "onKeydown"], NI = {
  key: 0,
  class: "rte-dialog-error",
  role: "alert"
}, VI = { class: "rte-dialog-actions" }, FI = ["aria-label"], HI = { class: "rte-dialog-title" }, WI = { class: "rte-dialog-field" }, jI = { class: "rte-dialog-label" }, UI = ["placeholder", "aria-invalid", "onKeydown"], GI = {
  key: 0,
  class: "rte-dialog-error",
  role: "alert"
}, qI = { class: "rte-dialog-actions" }, KI = /* @__PURE__ */ ge({
  __name: "RichTextEditor",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    helpText: { default: void 0 },
    error: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 },
    width: { default: void 0 },
    minHeight: { default: "184px" },
    id: { default: void 0 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = {
      toolbar: "Rich text formatting",
      bold: "Bold",
      clearFormatting: "Clear formatting",
      italic: "Italic",
      underline: "Underline",
      strikethrough: "Strikethrough",
      textColor: "Text color",
      highlight: "Highlight",
      alignLeft: "Align left",
      alignCenter: "Align center",
      alignRight: "Align right",
      textFormat: "Text format",
      paragraph: "Paragraph",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      insertLink: "Insert link",
      insertImage: "Insert image",
      bulletList: "Bullet list",
      orderedList: "Ordered list",
      blockquote: "Blockquote",
      linkDialogTitle: "Insert link",
      linkUrlLabel: "URL",
      linkUrlPlaceholder: "https://example.com",
      linkInsert: "Insert",
      linkRemove: "Remove link",
      imageDialogTitle: "Insert image",
      imageUrlLabel: "Image URL",
      imageUrlPlaceholder: "https://example.com/image.png",
      imageInsert: "Insert",
      cancel: "Cancel",
      invalidUrl: "Enter a valid http(s) URL."
    }, r = e, o = y(() => ({ ...n, ...r.labels })), a = t, l = Ke(), s = y(() => r.id || l), i = y(() => r.label ? `${s.value}-label` : void 0), d = y(() => `${s.value}-error`), u = y(() => `${s.value}-help`), f = y(() => !!r.error), h = y(() => {
      const G = [];
      return f.value && G.push(d.value), r.helpText && G.push(u.value), G.length ? G.join(" ") : void 0;
    }), b = qS({
      content: r.modelValue,
      editable: !r.disabled,
      extensions: [
        V5.configure({
          // StarterKit v3 already bundles Underline, Link, lists.
          link: {
            openOnClick: !1,
            autolink: !0,
            defaultProtocol: "https"
          }
        }),
        H5.configure({ types: ["heading", "paragraph"] }),
        Sp,
        $p,
        X5.configure({ multicolor: !0 }),
        eI.configure({ inline: !1 })
      ],
      editorProps: {
        attributes: {
          id: s.value,
          "aria-labelledby": i.value ?? "",
          "aria-invalid": f.value ? "true" : "false",
          "aria-describedby": h.value ?? "",
          class: "prose prose-sm max-w-none focus:outline-none text-(--text-text-body) dark:text-(--colors-text-white-default) min-h-full"
        }
      },
      onUpdate({ editor: G }) {
        a("update:modelValue", G.getHTML());
      },
      onFocus() {
        m.value = !0, a("focus");
      },
      onBlur() {
        m.value = !1, a("blur");
      }
    }), m = N(!1);
    we(
      () => r.modelValue,
      (G) => {
        var z, X;
        const H = (z = b.value) == null ? void 0 : z.getHTML();
        G !== void 0 && G !== H && ((X = b.value) == null || X.commands.setContent(G || "", { emitUpdate: !1 }));
      }
    ), we(
      () => r.disabled,
      (G) => {
        var H;
        (H = b.value) == null || H.setEditable(!G);
      }
    ), Bt(() => {
      var G;
      (G = b.value) == null || G.destroy();
    });
    const v = y(() => [
      { value: "paragraph", label: o.value.paragraph, shortcut: "⌘⌥0" },
      { value: "h1", label: o.value.heading1, shortcut: "⌘⌥1" },
      { value: "h2", label: o.value.heading2, shortcut: "⌘⌥2" },
      { value: "h3", label: o.value.heading3, shortcut: "⌘⌥3" }
    ]), x = (G) => {
      var z;
      const H = (z = b.value) == null ? void 0 : z.chain().focus();
      if (H) {
        if (G === "paragraph")
          H.setParagraph().run();
        else {
          const X = Number(G.replace("h", ""));
          H.toggleHeading({ level: X }).run();
        }
        k.value = !1;
      }
    }, k = N(!1), L = N(null), P = () => {
      r.disabled || (k.value = !k.value);
    }, E = (G) => {
      k.value && L.value && !L.value.contains(G.target) && (k.value = !1);
    }, O = (G) => {
      k.value && G.key === "Escape" && (G.stopPropagation(), G.preventDefault(), k.value = !1);
    };
    Qe(() => {
      document.addEventListener("mousedown", E), document.addEventListener("keydown", O);
    }), Bt(() => {
      document.removeEventListener("mousedown", E), document.removeEventListener("keydown", O);
    });
    const R = (G) => {
      var z;
      const H = G.target.value;
      (z = b.value) == null || z.chain().focus().setColor(H).run();
    }, V = (G) => {
      var z;
      const H = G.target.value;
      (z = b.value) == null || z.chain().focus().toggleHighlight({ color: H }).run();
    }, J = N(!1), F = N(""), A = N(!1), j = N(!1), _ = N(""), U = N(!1);
    function W(G) {
      try {
        const H = new URL(G);
        return H.protocol === "http:" || H.protocol === "https:";
      } catch {
        return !1;
      }
    }
    const K = () => {
      var H;
      if (r.disabled) return;
      const G = (H = b.value) == null ? void 0 : H.getAttributes("link").href;
      F.value = G ?? "", A.value = !1, J.value = !0;
    }, le = () => {
      var G;
      (G = b.value) == null || G.chain().focus().extendMarkRange("link").unsetLink().run(), J.value = !1;
    }, C = () => {
      var H;
      const G = F.value.trim();
      if (G === "") {
        le();
        return;
      }
      if (!W(G)) {
        A.value = !0;
        return;
      }
      (H = b.value) == null || H.chain().focus().extendMarkRange("link").setLink({ href: G, target: "_blank", rel: "noopener noreferrer" }).run(), J.value = !1;
    }, B = () => {
      J.value = !1;
    }, I = () => {
      r.disabled || (_.value = "", U.value = !1, j.value = !0);
    }, M = () => {
      var H;
      const G = _.value.trim();
      if (!W(G)) {
        U.value = !0;
        return;
      }
      (H = b.value) == null || H.chain().focus().setImage({ src: G }).run(), j.value = !1;
    }, D = () => {
      j.value = !1;
    }, re = () => {
      var G;
      (G = b.value) == null || G.chain().focus().clearNodes().unsetAllMarks().run();
    }, se = (G, H) => b.value ? typeof G == "string" ? b.value.isActive(G, {}) : b.value.isActive(G) : !1, de = y(() => b.value ? b.value.isActive("heading", { level: 1 }) ? "h1" : b.value.isActive("heading", { level: 2 }) ? "h2" : b.value.isActive("heading", { level: 3 }) ? "h3" : "paragraph" : "paragraph"), fe = y(
      () => {
        var G;
        return ((G = v.value.find((H) => H.value === de.value)) == null ? void 0 : G.label) ?? o.value.paragraph;
      }
    ), q = y(() => {
      const G = "rounded-xl border-solid border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) overflow-hidden shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] font-inter";
      return r.disabled ? `${G} bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) cursor-not-allowed` : f.value ? `${G} border-(--border-border-error-strong) dark:border-(--border-border-error)` : m.value ? `${G} bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) shadow-[0px_0px_2px_2px_var(--colors-background-hover)]` : `${G} border-(--border-border-base-medium) dark:border-(--colors-border-base)`;
    }), oe = y(() => `${r.fullWidth ? "w-full" : "max-w-lg w-full"} flex flex-col items-start gap-0.5 text-left text-sm font-inter`), ue = y(() => r.fullWidth ? {} : r.width ? { width: r.width } : {});
    return (G, H) => {
      var z, X;
      return c(), p("div", {
        class: S(oe.value),
        style: Ae(ue.value)
      }, [
        e.label ? (c(), p("label", {
          key: 0,
          id: i.value,
          for: s.value,
          class: "flex items-center gap-1 text-(--text-text-black-default) dark:text-(--colors-text-white-default) leading-5"
        }, [
          g("span", nI, $(e.label), 1),
          e.required ? (c(), p("span", rI, "*")) : w("", !0)
        ], 8, tI)) : w("", !0),
        g("div", {
          class: S([q.value, "self-stretch flex flex-col"])
        }, [
          g("div", {
            class: "flex flex-col gap-2 px-3 py-3 border-b border-(--border-border-base-medium) bg-(--background-background-white) dark:bg-(--background-background-black-default)",
            role: "toolbar",
            "aria-label": ((z = G.$attrs["aria-label"]) == null ? void 0 : z.toString()) ?? o.value.toolbar
          }, [
            g("div", aI, [
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("bold") }]),
                disabled: e.disabled,
                "aria-label": o.value.bold,
                title: o.value.bold,
                onClick: H[0] || (H[0] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleBold().run();
                })
              }, [...H[14] || (H[14] = [
                g("i", {
                  class: "ri-bold",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, lI),
              g("button", {
                type: "button",
                class: "toolbar-btn",
                disabled: e.disabled,
                "aria-label": o.value.clearFormatting,
                title: o.value.clearFormatting,
                onClick: re
              }, [...H[15] || (H[15] = [
                g("i", {
                  class: "ri-format-clear",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 8, sI),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("italic") }]),
                disabled: e.disabled,
                "aria-label": o.value.italic,
                title: o.value.italic,
                onClick: H[1] || (H[1] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleItalic().run();
                })
              }, [...H[16] || (H[16] = [
                g("i", {
                  class: "ri-italic",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, iI),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("underline") }]),
                disabled: e.disabled,
                "aria-label": o.value.underline,
                title: o.value.underline,
                onClick: H[2] || (H[2] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleUnderline().run();
                })
              }, [...H[17] || (H[17] = [
                g("i", {
                  class: "ri-underline",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, dI),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("strike") }]),
                disabled: e.disabled,
                "aria-label": o.value.strikethrough,
                title: o.value.strikethrough,
                onClick: H[3] || (H[3] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleStrike().run();
                })
              }, [...H[18] || (H[18] = [
                g("i", {
                  class: "ri-strikethrough",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, uI),
              g("label", {
                class: S(["toolbar-btn relative cursor-pointer", { "opacity-50 cursor-not-allowed": e.disabled }]),
                "aria-label": o.value.textColor,
                title: o.value.textColor
              }, [
                H[19] || (H[19] = g("i", {
                  class: "ri-font-color",
                  "aria-hidden": "true"
                }, null, -1)),
                g("input", {
                  type: "color",
                  class: "absolute inset-0 opacity-0 cursor-pointer",
                  disabled: e.disabled,
                  onInput: R
                }, null, 40, fI)
              ], 10, cI),
              g("label", {
                class: S(["toolbar-btn relative cursor-pointer", {
                  "is-active": se("highlight"),
                  "opacity-50 cursor-not-allowed": e.disabled
                }]),
                "aria-label": o.value.highlight,
                title: o.value.highlight
              }, [
                H[20] || (H[20] = g("i", {
                  class: "ri-mark-pen-line",
                  "aria-hidden": "true"
                }, null, -1)),
                g("input", {
                  type: "color",
                  class: "absolute inset-0 opacity-0 cursor-pointer",
                  disabled: e.disabled,
                  onInput: V
                }, null, 40, bI)
              ], 10, hI),
              H[24] || (H[24] = g("span", {
                class: "mx-1 inline-block w-px h-4 bg-(--colors-background-gray)",
                "aria-hidden": "true"
              }, null, -1)),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se({ textAlign: "left" }) }]),
                disabled: e.disabled,
                "aria-label": o.value.alignLeft,
                title: o.value.alignLeft,
                onClick: H[4] || (H[4] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().setTextAlign("left").run();
                })
              }, [...H[21] || (H[21] = [
                g("i", {
                  class: "ri-align-left",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, pI),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se({ textAlign: "center" }) }]),
                disabled: e.disabled,
                "aria-label": o.value.alignCenter,
                title: o.value.alignCenter,
                onClick: H[5] || (H[5] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().setTextAlign("center").run();
                })
              }, [...H[22] || (H[22] = [
                g("i", {
                  class: "ri-align-center",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, gI),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se({ textAlign: "right" }) }]),
                disabled: e.disabled,
                "aria-label": o.value.alignRight,
                title: o.value.alignRight,
                onClick: H[6] || (H[6] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().setTextAlign("right").run();
                })
              }, [...H[23] || (H[23] = [
                g("i", {
                  class: "ri-align-right",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, mI)
            ]),
            g("div", vI, [
              g("div", {
                ref_key: "formatWrapperRef",
                ref: L,
                class: "relative"
              }, [
                g("button", {
                  type: "button",
                  class: S(["format-btn", { "is-open": k.value }]),
                  disabled: e.disabled,
                  "aria-expanded": k.value,
                  "aria-haspopup": "listbox",
                  "aria-label": o.value.textFormat,
                  onClick: P
                }, [
                  g("span", yI, $(fe.value), 1),
                  H[25] || (H[25] = g("i", {
                    class: "ri-arrow-down-s-line text-sm",
                    "aria-hidden": "true"
                  }, null, -1))
                ], 10, xI),
                k.value ? (c(), p("div", {
                  key: 0,
                  role: "listbox",
                  "aria-label": o.value.textFormat,
                  class: "format-menu"
                }, [
                  (c(!0), p(Z, null, ke(v.value, (Y) => (c(), p("button", {
                    key: Y.value,
                    type: "button",
                    role: "option",
                    class: S(["format-menu-item", { "is-current": de.value === Y.value }]),
                    "aria-selected": de.value === Y.value,
                    onClick: (ce) => x(Y.value)
                  }, [
                    g("span", null, $(Y.label), 1),
                    Y.shortcut ? (c(), p("span", CI, $(Y.shortcut), 1)) : w("", !0)
                  ], 10, wI))), 128))
                ], 8, kI)) : w("", !0)
              ], 512),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("link") }]),
                disabled: e.disabled,
                "aria-label": o.value.insertLink,
                title: o.value.insertLink,
                onClick: K
              }, [...H[26] || (H[26] = [
                g("i", {
                  class: "ri-link",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, SI),
              g("button", {
                type: "button",
                class: "toolbar-btn",
                disabled: e.disabled,
                "aria-label": o.value.insertImage,
                title: o.value.insertImage,
                onClick: I
              }, [...H[27] || (H[27] = [
                g("i", {
                  class: "ri-image-line",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 8, $I),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("bulletList") }]),
                disabled: e.disabled,
                "aria-label": o.value.bulletList,
                title: o.value.bulletList,
                onClick: H[7] || (H[7] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleBulletList().run();
                })
              }, [...H[28] || (H[28] = [
                g("i", {
                  class: "ri-list-unordered",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, II),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("orderedList") }]),
                disabled: e.disabled,
                "aria-label": o.value.orderedList,
                title: o.value.orderedList,
                onClick: H[8] || (H[8] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleOrderedList().run();
                })
              }, [...H[29] || (H[29] = [
                g("i", {
                  class: "ri-list-ordered",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, TI),
              g("button", {
                type: "button",
                class: S(["toolbar-btn", { "is-active": se("blockquote") }]),
                disabled: e.disabled,
                "aria-label": o.value.blockquote,
                title: o.value.blockquote,
                onClick: H[9] || (H[9] = (Y) => {
                  var ce;
                  return (ce = T(b)) == null ? void 0 : ce.chain().focus().toggleBlockquote().run();
                })
              }, [...H[30] || (H[30] = [
                g("i", {
                  class: "ri-double-quotes-l",
                  "aria-hidden": "true"
                }, null, -1)
              ])], 10, LI)
            ])
          ], 8, oI),
          g("div", {
            class: "px-3 py-3 relative",
            style: Ae({ minHeight: e.minHeight })
          }, [
            T(b) ? (c(), te(T(GS), {
              key: 0,
              editor: T(b),
              "data-testid": "rich-text-editor",
              class: "text-sm leading-5"
            }, null, 8, ["editor"])) : w("", !0),
            e.placeholder && ((X = T(b)) != null && X.isEmpty) && !m.value ? (c(), p("span", MI, $(e.placeholder), 1)) : w("", !0)
          ], 4)
        ], 2),
        g("div", EI, [
          e.helpText ? (c(), p("div", {
            key: 0,
            id: u.value,
            class: "flex items-center gap-1 text-xs text-(--text-text-body)"
          }, [
            H[31] || (H[31] = g("i", {
              class: "ri-information-line text-sm text-(--colors-icon-dark-default)",
              "aria-hidden": "true"
            }, null, -1)),
            g("span", null, $(e.helpText), 1)
          ], 8, AI)) : w("", !0),
          e.error ? (c(), p("div", {
            key: 1,
            id: d.value,
            class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
            role: "alert"
          }, [
            H[32] || (H[32] = g("i", {
              class: "ri-error-warning-fill",
              "aria-hidden": "true"
            }, null, -1)),
            g("span", null, $(e.error), 1)
          ], 8, DI)) : w("", !0)
        ]),
        J.value ? (c(), p("div", {
          key: 1,
          class: "rte-dialog-backdrop",
          onClick: Ie(B, ["self"])
        }, [
          g("div", {
            class: "rte-dialog",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": o.value.linkDialogTitle
          }, [
            g("h3", BI, $(o.value.linkDialogTitle), 1),
            g("label", OI, [
              g("span", PI, $(o.value.linkUrlLabel), 1),
              Ar(g("input", {
                "onUpdate:modelValue": H[10] || (H[10] = (Y) => F.value = Y),
                type: "url",
                class: "rte-dialog-input",
                placeholder: o.value.linkUrlPlaceholder,
                "aria-invalid": A.value,
                onKeydown: je(Ie(C, ["prevent"]), ["enter"]),
                onInput: H[11] || (H[11] = (Y) => A.value = !1)
              }, null, 40, zI), [
                [dl, F.value]
              ])
            ]),
            A.value ? (c(), p("p", NI, $(o.value.invalidUrl), 1)) : w("", !0),
            g("div", VI, [
              g("button", {
                type: "button",
                class: "rte-dialog-btn rte-dialog-btn-remove",
                onClick: le
              }, $(o.value.linkRemove), 1),
              H[33] || (H[33] = g("span", { class: "flex-1" }, null, -1)),
              g("button", {
                type: "button",
                class: "rte-dialog-btn rte-dialog-btn-secondary",
                onClick: B
              }, $(o.value.cancel), 1),
              g("button", {
                type: "button",
                class: "rte-dialog-btn rte-dialog-btn-primary",
                onClick: C
              }, $(o.value.linkInsert), 1)
            ])
          ], 8, RI)
        ])) : w("", !0),
        j.value ? (c(), p("div", {
          key: 2,
          class: "rte-dialog-backdrop",
          onClick: Ie(D, ["self"])
        }, [
          g("div", {
            class: "rte-dialog",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": o.value.imageDialogTitle
          }, [
            g("h3", HI, $(o.value.imageDialogTitle), 1),
            g("label", WI, [
              g("span", jI, $(o.value.imageUrlLabel), 1),
              Ar(g("input", {
                "onUpdate:modelValue": H[12] || (H[12] = (Y) => _.value = Y),
                type: "url",
                class: "rte-dialog-input",
                placeholder: o.value.imageUrlPlaceholder,
                "aria-invalid": U.value,
                onKeydown: je(Ie(M, ["prevent"]), ["enter"]),
                onInput: H[13] || (H[13] = (Y) => U.value = !1)
              }, null, 40, UI), [
                [dl, _.value]
              ])
            ]),
            U.value ? (c(), p("p", GI, $(o.value.invalidUrl), 1)) : w("", !0),
            g("div", qI, [
              H[34] || (H[34] = g("span", { class: "flex-1" }, null, -1)),
              g("button", {
                type: "button",
                class: "rte-dialog-btn rte-dialog-btn-secondary",
                onClick: D
              }, $(o.value.cancel), 1),
              g("button", {
                type: "button",
                class: "rte-dialog-btn rte-dialog-btn-primary",
                onClick: M
              }, $(o.value.imageInsert), 1)
            ])
          ], 8, FI)
        ])) : w("", !0)
      ], 6);
    };
  }
}), iV = /* @__PURE__ */ He(KI, [["__scopeId", "data-v-9ef3f145"]]), JI = /* @__PURE__ */ ge({
  __name: "EmailInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    iconLeft: { default: void 0 },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidEmailMessage: { default: "Please enter a valid email address" },
    requiredMessage: { default: "Email is required" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "validation-change"],
  setup(e, { expose: t, emit: n }) {
    const r = ht(), o = e, a = n, l = N(void 0), s = N(!1), i = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, d = (k) => {
      if (o.validator)
        return o.validator(k) ?? void 0;
      if (o.required && !k.trim())
        return o.requiredMessage;
      if (k.trim() && !i.test(k))
        return o.invalidEmailMessage;
    }, u = () => {
      const k = d(o.modelValue ?? "");
      l.value = k, a("validation-change", !k, k);
    }, f = y(() => {
      if (o.error) return o.error;
      if (s.value) return l.value;
    }), h = (k) => {
      const L = k.target;
      a("update:modelValue", L.value), a("input", k), o.validateOnInput && u();
    }, b = (k) => {
      a("focus", k);
    }, m = (k) => {
      s.value = !0, a("blur", k), o.validateOnBlur && u();
    };
    return we(
      () => o.modelValue,
      () => {
        s.value && (o.validateOnBlur || o.validateOnInput) && u();
      }
    ), we(
      () => o.error,
      (k) => {
        k && (l.value = void 0);
      }
    ), t({
      validate: () => (s.value = !0, u(), !l.value),
      resetValidation: () => {
        s.value = !1, l.value = void 0;
      }
    }), (k, L) => (c(), te(er, {
      id: e.id,
      "model-value": e.modelValue,
      placeholder: e.placeholder,
      label: e.label,
      required: e.required,
      disabled: e.disabled,
      readonly: e.readonly,
      size: e.size,
      name: e.name,
      "full-width": e.fullWidth,
      width: e.width,
      "icon-left": e.iconLeft,
      hint: e.hint,
      "label-inline": e.labelInline,
      error: f.value,
      type: "email",
      inputmode: "email",
      autocomplete: e.autocomplete,
      "data-testid": "email-input",
      "onUpdate:modelValue": L[0] || (L[0] = (P) => a("update:modelValue", P)),
      onInput: h,
      onFocus: b,
      onBlur: m
    }, zn({ _: 2 }, [
      T(r)("actions") ? {
        name: "actions",
        fn: pe(() => [
          be(k.$slots, "actions")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "model-value", "placeholder", "label", "required", "disabled", "readonly", "size", "name", "full-width", "width", "icon-left", "hint", "label-inline", "error", "autocomplete"]));
  }
});
function Ip(e) {
  if (!e || !/^[dmy/\-. ]+$/.test(e) || !/[dmy]/.test(e)) return null;
  for (const t of e.match(/([dmy])\1*/g) ?? [])
    if (t.length < 2) return null;
  return e.replace(/[dmy]/g, "0");
}
function Ki(e) {
  const t = new Set([...e].filter((o) => /\D/.test(o)));
  if (t.size !== 1) return null;
  const [n] = [...t], r = e.split(n).map((o) => o.length).filter((o) => o > 0);
  return r.length === 0 ? null : { groupSizes: r, separator: n };
}
function ZI(e) {
  if (!e) return null;
  const t = e.match(/[Xx]+/g);
  if (!t) return null;
  const n = e.split(/[Xx]+/);
  if (n[0] !== "" || n[n.length - 1] !== "") return null;
  const r = n.slice(1, -1);
  if (r.length === 0) return null;
  const [o] = r;
  return o === "" || r.some((a) => a !== o) ? null : { groupSizes: t.map((a) => a.length), separator: o };
}
function ga(e, t) {
  if (!e) return "";
  const n = [];
  let r = 0;
  for (const o of t.groupSizes) {
    if (r >= e.length) break;
    n.push(e.slice(r, r + o)), r += o;
  }
  return r < e.length && n.push(e.slice(r)), n.join(t.separator);
}
function YI(e, t) {
  if (t <= 0) return 0;
  let n = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (n += 1, n === t))
      return r + 1;
  return e.length;
}
function Tp(e, t, n) {
  const r = e.value, o = e.selectionStart ?? r.length, a = t(r.slice(0, o)).length, l = t(r), s = n(l);
  e.value = s;
  const i = YI(s, a);
  try {
    e.setSelectionRange(i, i);
  } catch {
  }
  return s;
}
function rf(e, t, n) {
  return Tp(
    e,
    t,
    (r) => n ? ga(r, n) : r
  );
}
function Lp(e, t, n) {
  if (e.key !== "Backspace" && e.key !== "Delete" || e.ctrlKey || e.altKey || e.metaKey) return !1;
  const r = t.selectionStart, o = t.selectionEnd;
  if (r === null || o === null || r !== o) return !1;
  const a = t.value, l = (d) => d !== void 0 && /\d/.test(d);
  let s, i;
  if (e.key === "Backspace") {
    if (r === 0 || l(a[r - 1])) return !1;
    let d = r - 1;
    for (; d >= 0 && !l(a[d]); ) d -= 1;
    if (d < 0) return !1;
    s = d, i = d;
  } else {
    if (r >= a.length || l(a[r])) return !1;
    let d = r;
    for (; d < a.length && !l(a[d]); ) d += 1;
    if (d >= a.length) return !1;
    s = d, i = r;
  }
  t.value = a.slice(0, s) + a.slice(s + 1);
  try {
    t.setSelectionRange(i, i);
  } catch {
  }
  return e.preventDefault(), n(t), !0;
}
const xn = {
  FR: { placeholder: "6 12 34 56 78", min: 9, max: 9, name: "France", hasTrunkZero: !0 },
  GB: {
    placeholder: "7911 123456",
    min: 9,
    max: 10,
    name: "United Kingdom",
    hasTrunkZero: !0
  },
  CA: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "Canada",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  US: {
    placeholder: "123-456-7890",
    min: 10,
    max: 10,
    name: "United States",
    hasTrunkZero: !1,
    displaySeparator: " "
  },
  NL: { placeholder: "6 12345678", min: 9, max: 9, name: "Netherlands", hasTrunkZero: !0 },
  DE: { placeholder: "176 12345678", min: 10, max: 11, name: "Germany", hasTrunkZero: !0 },
  // min: 8 covers landline numbers behind a 2-digit area code (Brussels "02 XXX XX XX" = 8
  // significant digits); mobiles and other landlines are 9 (the placeholder's own length).
  BE: { placeholder: "470 12 34 56", min: 8, max: 9, name: "Belgium", hasTrunkZero: !0 },
  CH: { placeholder: "78 123 45 67", min: 9, max: 9, name: "Switzerland", hasTrunkZero: !0 },
  // The leading "0" is a significant digit of the Italian landline numbering plan (mandatory,
  // not a trunk prefix) — hasTrunkZero: false so it is never split out, stripped, or parenthesised
  // anywhere (input, display, validation count). min/max count the "0" itself, so hasTrunkZero:
  // false means nothing strips it before counting. min: 9 covers a shorter landline behind a
  // 2-digit area code ("02 1234 567" = 9 digits); max: 10 matches the placeholder (mobiles and
  // longer landlines).
  IT: { placeholder: "06 1234 5678", min: 9, max: 10, name: "Italy", hasTrunkZero: !1 },
  ES: { placeholder: "612 34 56 78", min: 9, max: 9, name: "Spain", hasTrunkZero: !1 },
  PT: { placeholder: "912 345 678", min: 9, max: 9, name: "Portugal", hasTrunkZero: !1 },
  GR: { placeholder: "691 234 5678", min: 10, max: 10, name: "Greece", hasTrunkZero: !1 },
  DK: { placeholder: "20 12 34 56", min: 8, max: 8, name: "Denmark", hasTrunkZero: !1 },
  NO: { placeholder: "406 12 345", min: 8, max: 8, name: "Norway", hasTrunkZero: !1 }
}, Xr = {
  placeholder: "123 456 789",
  min: 6,
  max: Number.POSITIVE_INFINITY,
  name: "",
  hasTrunkZero: !1
}, of = "FR", Mp = {
  FR: "+33",
  GB: "+44",
  CA: "+1",
  US: "+1",
  NL: "+31",
  DE: "+49",
  BE: "+32",
  CH: "+41",
  IT: "+39",
  ES: "+34",
  PT: "+351",
  GR: "+30",
  DK: "+45",
  NO: "+47"
}, eu = Object.entries(Mp).sort((e, t) => t[1].length - e[1].length), XI = Object.entries(
  xn
).reduce((e, [t, n]) => {
  const r = Mp[t];
  return r in e || (e[r] = n), e;
}, {});
function af(e) {
  const t = e.replace(/^0+/, "");
  return t.length > 0 ? t : e;
}
function lf(e, t) {
  const n = xn[t] ?? Xr, r = Ki(n.placeholder);
  if (!r) return e;
  const o = n.displaySeparator ?? r.separator;
  return ga(e, { groupSizes: r.groupSizes, separator: o });
}
function To(e, t, n) {
  if (!e) return "";
  if (!n) {
    const s = Ki(t);
    return s ? ga(e, s) : e;
  }
  if (/^0*$/.test(e)) return e;
  const r = e.startsWith("0"), o = r ? "0" : "", a = r ? e.slice(1) : e, l = Ki(t);
  return o + (l ? ga(a, l) : a);
}
function tu(e, t) {
  return /^0*$/.test(e) ? "" : t && e.startsWith("0") ? e.slice(1) : e;
}
function dV(e) {
  const t = (e ?? "").trim();
  if (!t.startsWith("+")) return e;
  const n = eu.find(([, s]) => t.startsWith(s));
  if (!n) return e;
  const [r, o] = n;
  if (!xn[r].hasTrunkZero) return e;
  const l = t.slice(o.length).replace(/\D/g, "");
  return !l || l.startsWith("0") ? e : `${o}0${l}`;
}
function uV(e) {
  const t = (e ?? "").trim();
  if (!t.startsWith("+")) return e;
  const n = eu.find(([, i]) => t.startsWith(i));
  if (!n) return e;
  const [r, o] = n, a = xn[r], l = t.slice(o.length).replace(/\D/g, ""), s = a.hasTrunkZero ? tu(l, !0) : l;
  return s ? `${o}${s}` : e;
}
function QI(e) {
  const t = (e ?? "").trim();
  if (!t) return e;
  if (t.startsWith("+")) {
    const s = eu.find(([, v]) => t.startsWith(v));
    if (!s) return e;
    const [i, d] = s, u = xn[i], f = t.slice(d.length).replace(/\D/g, ""), h = u.hasTrunkZero ? af(f) : f;
    if (!h) return e;
    const b = lf(h, i), m = u.hasTrunkZero ? "(0)" : "";
    return `${d} ${m}${b}`;
  }
  const n = af(t.replace(/\D/g, ""));
  if (!n) return e;
  const { min: r, max: o } = xn[of];
  if (n.length < r || n.length > o) return e;
  const a = lf(n, of);
  return `${t.replace(/\D/g, "").startsWith("0") ? "0" : ""}${a}`;
}
const _I = ["id", "for"], e4 = { key: 0 }, t4 = ["id"], n4 = { class: "flex items-end gap-3" }, r4 = { class: "relative flex-1" }, o4 = {
  key: 0,
  class: "relative"
}, a4 = ["disabled", "aria-expanded"], l4 = ["title"], s4 = { class: "mr-2" }, i4 = { class: "relative flex-1" }, d4 = { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, u4 = ["id", "autocomplete", "disabled", "readonly", "aria-labelledby", "aria-invalid", "aria-describedby", "placeholder"], c4 = {
  key: 1,
  class: "relative"
}, f4 = ["disabled", "aria-expanded"], h4 = { class: "mr-2" }, b4 = {
  class: "p-2 text-sm text-(--text-text-body) dark:text-(--text-text-white-secondary)",
  role: "listbox"
}, p4 = ["aria-selected", "onClick"], g4 = ["title"], m4 = { class: "flex-1 truncate" }, v4 = { class: "text-(--text-text-body-subtle) shrink-0" }, x4 = {
  class: "p-2 text-sm text-(--text-text-body) dark:text-(--text-text-white-secondary)",
  role: "menu"
}, y4 = ["onClick"], k4 = {
  key: 0,
  class: "shrink-0"
}, w4 = { class: "min-h-4.5" }, C4 = ["id"], S4 = /* @__PURE__ */ ge({
  __name: "PhoneInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    disableInternalValidation: { type: Boolean, default: !1 },
    showCountrySelector: { type: Boolean, default: !0 },
    showVerificationButton: { type: Boolean, default: !1 },
    verificationOptions: { default: () => [
      { id: "sms", label: "Send SMS" },
      { id: "call", label: "Call" }
    ] },
    countries: { default: () => [
      { code: "FR", name: "France", dialCode: "+33" },
      { code: "GB", name: "United Kingdom", dialCode: "+44" },
      { code: "CA", name: "Canada", dialCode: "+1" },
      { code: "NL", name: "Netherlands", dialCode: "+31" },
      { code: "DE", name: "Germany", dialCode: "+49" },
      { code: "BE", name: "Belgium", dialCode: "+32" },
      { code: "CH", name: "Switzerland", dialCode: "+41" },
      { code: "IT", name: "Italy", dialCode: "+39" },
      { code: "ES", name: "Spain", dialCode: "+34" },
      { code: "PT", name: "Portugal", dialCode: "+351" },
      { code: "GR", name: "Greece", dialCode: "+30" },
      { code: "DK", name: "Denmark", dialCode: "+45" },
      { code: "NO", name: "Norway", dialCode: "+47" }
    ] },
    fullWidth: { type: Boolean, default: !1 },
    size: { default: "md" },
    autocomplete: { default: "tel" },
    maskInput: { type: Boolean, default: !0 },
    formatHintLabel: { default: void 0 },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur", "validation-change", "verification-click", "country-change"],
  setup(e, { emit: t }) {
    const n = e, r = ht(), o = y(() => r("actions")), a = t, l = N(!1), s = N(!1), i = N(""), d = N(n.countries[0]), u = N(n.verificationOptions[0]), f = N(!1), h = N(void 0), b = N(null), m = N(null), v = N(null), x = N(null), k = N(""), L = N(null), P = N(null), E = {}, O = (he) => {
      var ie;
      return he.placeholder || ((ie = xn[he.code]) == null ? void 0 : ie.placeholder) || Xr.placeholder;
    }, R = (he) => {
      const ie = he.replace(/\s/g, "");
      return [...n.countries].sort((Q, ee) => ee.dialCode.length - Q.dialCode.length).find((Q) => ie.startsWith(Q.dialCode));
    }, V = () => {
      if (!n.modelValue) {
        i.value = "";
        return;
      }
      const he = R(n.modelValue);
      if (he) {
        d.value = he;
        const ie = n.modelValue.slice(he.dialCode.length);
        i.value = n.maskInput && n.showCountrySelector ? To(
          ie.replace(/\D/g, ""),
          O(he),
          (xn[he.code] ?? Xr).hasTrunkZero
        ) : ie;
        return;
      }
      i.value = n.modelValue.replace(/^\+/, "");
    };
    V();
    const J = y(() => {
      const he = i.value.replace(/\D/g, "");
      return !he || !/[1-9]/.test(he) ? "" : n.showCountrySelector ? `${d.value.dialCode}${he}` : `+${he}`;
    }), F = y(() => xn[d.value.code] || Xr), A = y(() => n.showCountrySelector ? O(d.value) : "+33612345678"), j = y(() => {
      if (n.error) return n.error;
      if (!n.disableInternalValidation && f.value)
        return h.value;
    }), _ = () => {
      const he = i.value.replace(/\D/g, "");
      if (n.required && !he)
        return "Phone number is required";
      if (!he)
        return;
      const ie = tu(he, F.value.hasTrunkZero), { min: me, max: Q } = F.value;
      if (ie.length < me || ie.length > Q)
        return `Phone number must be ${me === Q ? `${me}` : `${me}–${Q}`} digits for ${d.value.name}`;
    }, U = () => {
      const he = _();
      h.value = he, a("validation-change", !he, he);
    }, W = () => {
      h.value = void 0;
    }, K = (he) => Tp(
      he,
      (ie) => ie.replace(/\D/g, ""),
      (ie) => To(ie, A.value, F.value.hasTrunkZero)
    ), le = (he) => {
      const ie = he.target;
      if (W(), n.maskInput && n.showCountrySelector) {
        i.value = K(ie);
        return;
      }
      const me = ie.value.replace(/[^\d\s\-()]/g, "");
      i.value = me, ie.value = me;
    }, C = (he) => {
      if (n.readonly || n.disabled || !(n.maskInput && n.showCountrySelector)) return;
      const ie = he.target;
      Lp(he, ie, (Q) => K(Q)) && (W(), i.value = ie.value);
    }, B = (he) => {
      if (f.value = !0, n.showCountrySelector) {
        const ie = i.value.replace(/\D/g, "");
        i.value = n.maskInput ? To(
          ie,
          A.value,
          F.value.hasTrunkZero
        ) : ie;
      }
      U(), a("blur", he);
    }, I = (he) => {
      a("focus", he);
    }, M = (he) => {
      var ve;
      if (!n.showCountrySelector) return;
      const ie = (((ve = he.clipboardData) == null ? void 0 : ve.getData("text")) ?? "").trim();
      if (!ie.startsWith("+")) return;
      const me = R(ie);
      if (!me) return;
      he.preventDefault(), W(), d.value = me;
      const Q = xn[me.code] ?? Xr, ee = ie.replace(/\D/g, "").slice(me.dialCode.replace(/\D/g, "").length);
      i.value = n.maskInput ? To(ee, O(me), Q.hasTrunkZero) : ee;
    }, D = (he) => {
      d.value = he, l.value = !1, k.value = "", P.value = null, L.value && (clearTimeout(L.value), L.value = null), n.maskInput && n.showCountrySelector && i.value && (i.value = To(
        i.value.replace(/\D/g, ""),
        A.value,
        F.value.hasTrunkZero
      )), f.value && U();
    }, re = (he, ie) => {
      ie.stopPropagation(), D(he);
    }, se = (he) => {
      var Q;
      if (!l.value) return;
      if (he.key === "Escape") {
        he.stopPropagation(), he.preventDefault(), l.value = !1, (Q = b.value) == null || Q.focus();
        return;
      }
      if (he.key === "Enter" && P.value) {
        he.preventDefault(), he.stopPropagation();
        const ee = n.countries.find((ve) => ve.code === P.value);
        ee && D(ee);
        return;
      }
      if (he.key.length !== 1 || !/[a-zA-Z ]/.test(he.key)) return;
      he.preventDefault(), he.stopPropagation(), k.value += he.key, L.value && clearTimeout(L.value);
      const ie = k.value.toLowerCase(), me = n.countries.find((ee) => ee.name.toLowerCase().startsWith(ie));
      me && (P.value = me.code, Pe(() => {
        var ee;
        (ee = E[me.code]) == null || ee.scrollIntoView({ block: "nearest" });
      })), L.value = setTimeout(() => {
        k.value = "", P.value = null, L.value = null;
      }, 1e3);
    }, de = (he) => {
      n.disabled || (he.stopPropagation(), l.value = !l.value);
    }, fe = (he) => {
      n.disabled || (he.stopPropagation(), s.value = !s.value);
    }, q = (he, ie) => {
      ie.stopPropagation(), u.value = he, s.value = !1, a("verification-click", he.id);
    }, oe = (he) => {
      const ie = he.target, me = !b.value || !b.value.contains(ie), Q = !m.value || !m.value.contains(ie);
      me && Q && (l.value = !1);
      const ee = !v.value || !v.value.contains(ie), ve = !x.value || !x.value.contains(ie);
      ee && ve && (s.value = !1);
    };
    we([i, d], () => {
      if (a("update:modelValue", J.value), n.showCountrySelector) {
        const he = i.value.replace(/\D/g, "");
        a("country-change", d.value, he);
      }
    }), we(
      () => n.modelValue,
      (he) => {
        he !== J.value && (W(), V());
      }
    ), we([l, s], ([he, ie]) => {
      he || ie ? document.addEventListener("click", oe) : document.removeEventListener("click", oe), he ? document.addEventListener("keydown", se) : (document.removeEventListener("keydown", se), k.value = "", P.value = null, L.value && (clearTimeout(L.value), L.value = null));
    }), Qe(() => {
      n.maskInput && n.showCountrySelector && n.modelValue && n.countries.some((he) => n.modelValue.startsWith(he.dialCode)) && J.value !== n.modelValue && a("update:modelValue", J.value);
    }), nt(() => {
      document.removeEventListener("click", oe), document.removeEventListener("keydown", se), L.value && clearTimeout(L.value);
    });
    const ue = {
      sm: {
        container: "h-[32px]",
        button: "px-3 py-1.5 text-xs",
        input: "py-1.5 text-xs"
      },
      md: {
        container: "h-[36px]",
        button: "px-3 py-2 text-sm",
        input: "py-2 text-sm"
      },
      lg: {
        container: "h-[48px]",
        button: "px-4 py-3 text-base",
        input: "py-3 text-base"
      },
      xl: {
        container: "h-[52px]",
        button: "px-5 py-3.5 text-base",
        input: "py-3.5 text-base"
      }
    }, G = y(() => ue[n.size]), H = Ke(), z = y(() => `${H}-phone`), X = y(() => n.label ? `${H}-label` : void 0), Y = y(() => `${H}-error`), ce = y(() => `${H}-format-hint`), ne = y(() => n.formatHintLabel ? `${n.formatHintLabel} ${A.value}` : n.showCountrySelector ? A.value : ""), ye = y(() => {
      const he = [];
      return ne.value && he.push(ce.value), j.value && he.push(Y.value), he.length > 0 ? he.join(" ") : void 0;
    });
    return (he, ie) => (c(), p("div", {
      class: S(["w-full flex flex-col gap-0.5 pb-0.5", { "max-w-sm": !e.fullWidth }])
    }, [
      e.label ? (c(), p("label", {
        key: 0,
        id: X.value,
        for: z.value,
        class: "block text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)"
      }, [
        Ze($(e.label) + " ", 1),
        e.required ? (c(), p("span", e4, " * ")) : w("", !0)
      ], 8, _I)) : w("", !0),
      ne.value ? (c(), p("span", {
        key: 1,
        id: ce.value,
        class: "sr-only"
      }, $(ne.value), 9, t4)) : w("", !0),
      g("div", n4, [
        g("div", r4, [
          g("div", {
            class: S([
              "flex items-center rounded-xl overflow-hidden",
              G.value.container,
              e.disabled ? "border border-(--border-border-base-medium) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : e.readonly ? "border border-(--border-border-base-soft) dark:border-(--border-border-base) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) cursor-default focus-within:border-(--border-border-accent) focus-within:shadow-[0px_0px_2px_var(--border-border-accent)]" : j.value ? "border border-(--border-border-error-strong) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : "border border-(--border-border-base-medium) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] hover:border-(--border-border-accent) focus-within:border-(--border-border-accent) focus-within:shadow-[0px_0px_2px_var(--border-border-accent)] focus-within:bg-(--background-background-selected)"
            ])
          }, [
            e.showCountrySelector ? (c(), p("div", o4, [
              g("button", {
                ref_key: "dropdownRef",
                ref: b,
                type: "button",
                disabled: e.disabled || e.readonly,
                "aria-expanded": l.value,
                class: S([
                  "inline-flex items-center shrink-0 z-10 font-medium border-r border-(--border-border-base-medium) focus:ring-4 focus:outline-none focus:ring-(--border-border-accent) transition-colors",
                  G.value.button,
                  e.disabled ? "bg-(--background-background-disabled) text-(--text-text-disabled-light) cursor-not-allowed" : e.readonly ? "bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "bg-(--background-background-white) text-(--text-text-black-default) hover:bg-(--background-background-hover) dark:bg-(--background-background-black-default) dark:text-(--text-text-white-default) dark:hover:bg-(--background-background-hover)"
                ]),
                onClick: de,
                onKeydown: se
              }, [
                g("span", {
                  class: S([
                    "fi",
                    `fi-${d.value.code.toLowerCase()}`,
                    "text-lg leading-none mr-2"
                  ]),
                  title: d.value.name
                }, null, 10, l4),
                g("span", s4, $(d.value.dialCode), 1),
                (c(), p("svg", {
                  class: S(["w-4 h-4 transition-transform", { "rotate-180": l.value }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  "aria-hidden": "true"
                }, [...ie[1] || (ie[1] = [
                  g("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 2))
              ], 42, a4)
            ])) : w("", !0),
            g("div", i4, [
              g("div", d4, [
                g("i", {
                  class: S(e.disabled ? "ri-phone-fill text-text-disabled dark:text-(--text-text-disabled-light)" : "ri-phone-fill text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)")
                }, null, 2)
              ]),
              Ar(g("input", {
                id: z.value,
                "onUpdate:modelValue": ie[0] || (ie[0] = (me) => i.value = me),
                type: "tel",
                inputmode: "tel",
                autocomplete: e.autocomplete,
                disabled: e.disabled,
                readonly: e.readonly,
                "aria-labelledby": X.value,
                "aria-invalid": !!j.value,
                "aria-describedby": ye.value,
                class: S([
                  "w-full pl-10 pr-4 border-0 outline-none focus:outline-none focus:ring-0 transition-colors",
                  G.value.input,
                  e.disabled ? "bg-(--background-background-disabled) text-(--text-text-disabled-light)" : e.readonly ? "bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default)" : j.value ? "bg-(--background-background-error) text-(--text-text-error-strong) placeholder:text-(--text-text-error)" : "bg-(--background-background-white) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) dark:bg-(--background-background-black-default) dark:text-(--text-text-white-default) dark:placeholder:text-(--colors-text-white-secondary)"
                ]),
                placeholder: A.value,
                onInput: le,
                onKeydown: C,
                onPaste: M,
                onBlur: B,
                onFocus: I
              }, null, 42, u4), [
                [dl, i.value]
              ])
            ]),
            e.showVerificationButton ? (c(), p("div", c4, [
              g("button", {
                ref_key: "verificationDropdownRef",
                ref: v,
                type: "button",
                disabled: e.disabled || e.readonly,
                "aria-expanded": s.value,
                class: S([
                  "inline-flex items-center shrink-0 z-10 font-medium border-l border-(--border-border-base-medium) focus:ring-4 focus:outline-none focus:ring-(--border-border-accent) transition-colors",
                  G.value.button,
                  e.disabled ? "bg-(--background-background-disabled) text-(--text-text-disabled-light) cursor-not-allowed" : e.readonly ? "bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "bg-(--background-background-white) text-(--text-text-black-default) hover:bg-(--background-background-hover) dark:bg-(--background-background-black-default) dark:text-(--text-text-white-default) dark:hover:bg-(--background-background-hover)"
                ]),
                onClick: fe
              }, [
                g("span", h4, $(u.value.label), 1),
                (c(), p("svg", {
                  class: S(["w-4 h-4 transition-transform", { "rotate-180": s.value }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  "aria-hidden": "true"
                }, [...ie[2] || (ie[2] = [
                  g("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ])], 2))
              ], 10, f4)
            ])) : w("", !0)
          ], 2),
          e.showCountrySelector && l.value ? (c(), p("div", {
            key: 0,
            ref_key: "countryDropdownMenuRef",
            ref: m,
            class: "absolute left-0 top-full z-50 mt-1 bg-white-50-opacity-bold border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] w-56 dark:bg-(--background-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
          }, [
            g("ul", b4, [
              (c(!0), p(Z, null, ke(e.countries, (me) => (c(), p("li", {
                key: me.code,
                ref_for: !0,
                ref: (Q) => {
                  Q && (E[me.code] = Q);
                },
                role: "option",
                "aria-selected": me.code === d.value.code || me.code === P.value,
                class: S(["flex items-center gap-2 px-3 py-2 cursor-pointer rounded-lg transition-colors", {
                  "bg-(--background-background-selected)": me.code === d.value.code || me.code === P.value,
                  "hover:bg-(--background-background-hover)": me.code !== d.value.code && me.code !== P.value
                }]),
                onClick: (Q) => re(me, Q)
              }, [
                g("span", {
                  class: S(["fi", `fi-${me.code.toLowerCase()}`, "text-lg leading-none shrink-0"]),
                  title: me.name
                }, null, 10, g4),
                g("span", m4, $(me.name), 1),
                g("span", v4, $(me.dialCode), 1)
              ], 10, p4))), 128))
            ])
          ], 512)) : w("", !0),
          e.showVerificationButton && s.value ? (c(), p("div", {
            key: 1,
            ref_key: "verificationDropdownMenuRef",
            ref: x,
            class: "absolute right-0 top-full z-50 mt-1 bg-white-50-opacity-bold border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] w-36 dark:bg-(--background-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
          }, [
            g("ul", x4, [
              (c(!0), p(Z, null, ke(e.verificationOptions, (me) => (c(), p("li", {
                key: me.id,
                role: "menuitem",
                class: S(["px-3 py-2 cursor-pointer rounded-lg transition-colors", {
                  "bg-(--background-background-selected)": me.id === u.value.id,
                  "hover:bg-(--background-background-hover)": me.id !== u.value.id
                }]),
                onClick: (Q) => q(me, Q)
              }, $(me.label), 11, y4))), 128))
            ])
          ], 512)) : w("", !0)
        ]),
        o.value ? (c(), p("div", k4, [
          be(he.$slots, "actions", {}, void 0, !0)
        ])) : w("", !0)
      ]),
      g("div", w4, [
        j.value ? (c(), p("div", {
          key: 0,
          id: Y.value,
          role: "alert",
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)"
        }, [
          ie[3] || (ie[3] = g("i", { class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)" }, null, -1)),
          g("span", null, $(j.value), 1)
        ], 8, C4)) : w("", !0)
      ])
    ], 2));
  }
}), $4 = /* @__PURE__ */ He(S4, [["__scopeId", "data-v-ca767ced"]]), I4 = ["href", "aria-label"], T4 = { key: 1 }, cV = /* @__PURE__ */ ge({
  __name: "PhoneDisplay",
  props: {
    value: {},
    link: { type: Boolean, default: !0 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const t = e, n = y(() => QI(t.value)), r = y(() => `tel:${t.value.replace(/[^\d+]/g, "")}`);
    return (o, a) => e.link ? (c(), p("a", {
      key: 0,
      href: r.value,
      "aria-label": e.ariaLabel
    }, $(n.value), 9, I4)) : (c(), p("span", T4, $(n.value), 1));
  }
}), L4 = ["id"], fV = /* @__PURE__ */ ge({
  __name: "MaskedInput",
  props: {
    modelValue: { default: "" },
    mask: {},
    label: { default: void 0 },
    placeholder: { default: void 0 },
    hint: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    iconLeft: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    formatHintLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = ht(), a = y(() => ZI(n.mask)), l = (L) => L.replace(/\D/g, ""), s = y(() => {
      const L = l(n.modelValue ?? "");
      return a.value ? ga(L, a.value) : L;
    }), i = Ke(), d = y(() => n.id || `${i}-masked`), u = y(() => `${d.value}-format-hint`), f = y(
      () => n.formatHintLabel ? `${n.formatHintLabel} ${n.mask}` : n.mask
    ), h = y(() => {
      const L = [u.value];
      return n.hint && L.push(`${d.value}-hint`), n.error && L.push(`${d.value}-error`), L.join(" ");
    }), b = (L) => {
      const P = L.target, E = rf(P, l, a.value);
      r("update:modelValue", E), r("input", L);
    }, m = (L) => {
      if (n.readonly || n.disabled) return;
      const P = L.target;
      Lp(
        L,
        P,
        (O) => rf(O, l, a.value)
      ) && r("update:modelValue", P.value);
    }, v = (L) => r("focus", L), x = (L) => r("blur", L), k = () => {
      r("update:modelValue", ""), r("clear");
    };
    return (L, P) => (c(), p("div", null, [
      g("span", {
        id: u.value,
        class: "sr-only"
      }, $(f.value), 9, L4),
      ae(er, {
        id: d.value,
        "model-value": s.value,
        placeholder: e.placeholder,
        label: e.label,
        hint: e.hint,
        error: e.error,
        required: e.required,
        "required-indicator": e.requiredIndicator,
        disabled: e.disabled,
        readonly: e.readonly,
        size: e.size,
        name: e.name,
        "full-width": e.fullWidth,
        width: e.width,
        "icon-left": e.iconLeft,
        "label-inline": e.labelInline,
        autocomplete: e.autocomplete,
        "aria-describedby": h.value,
        type: "text",
        inputmode: "numeric",
        "data-testid": "masked-input",
        onInput: b,
        onKeydown: m,
        onFocus: v,
        onBlur: x,
        onClear: k
      }, zn({ _: 2 }, [
        T(o)("actions") ? {
          name: "actions",
          fn: pe(() => [
            be(L.$slots, "actions")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "model-value", "placeholder", "label", "hint", "error", "required", "required-indicator", "disabled", "readonly", "size", "name", "full-width", "width", "icon-left", "label-inline", "autocomplete", "aria-describedby"])
    ]));
  }
}), M4 = [
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "object",
  "embed",
  "[contenteditable]",
  "[tabindex]:not([tabindex^='-'])"
].join(",");
function Lo(e) {
  return Array.from(e.querySelectorAll(M4)).filter((t) => {
    if (t.hasAttribute("disabled") || t.offsetParent === null) return !1;
    const n = t.getAttribute("tabindex");
    return n === null || !n.startsWith("-");
  });
}
const Ep = "[data-focus-trap-allow-outside]";
function sf(e) {
  return e instanceof Element && e.closest(Ep) !== null;
}
const Mo = [];
function ks(e) {
  const {
    active: t,
    container: n,
    autoFocus: r = !0,
    restoreFocus: o = !0,
    restoreFocusTo: a,
    containFocus: l = !1,
    allowOutsideElements: s
  } = e, i = Symbol("focus-trap");
  let d = null, u = null;
  const f = () => Mo[Mo.length - 1] === i;
  function h(O) {
    if (!f() || O.key !== "Tab" || !n.value) return;
    if (!n.value.contains(document.activeElement) && sf(document.activeElement)) {
      if (O.shiftKey) return;
      const A = document.activeElement.closest(
        Ep
      ), j = A ? Lo(A) : [];
      if (!(j.length === 0 || document.activeElement === j[j.length - 1])) return;
      const U = Lo(n.value);
      if (U.length === 0) {
        O.preventDefault();
        return;
      }
      const W = u ? U.indexOf(u) : -1;
      O.preventDefault(), U[W === -1 ? 0 : (W + 1) % U.length].focus();
      return;
    }
    const R = Lo(n.value);
    if (R.length === 0) {
      O.preventDefault();
      return;
    }
    const V = R[0], J = R[R.length - 1], F = document.activeElement;
    O.shiftKey ? (F === V || !n.value.contains(F)) && (O.preventDefault(), J.focus()) : F === J && (O.preventDefault(), V.focus());
  }
  function b() {
    var O;
    n.value && ((O = Lo(n.value)[0]) == null || O.focus({ preventScroll: !0 }));
  }
  function m(O) {
    if (!f() || !n.value) return;
    const R = O.target;
    R && n.value.contains(R) && (u = R);
  }
  function v(O) {
    return sf(O) ? !0 : s ? s().some((R) => R && O && R.contains(O)) : !1;
  }
  function x(O) {
    if (!f() || !n.value) return;
    const R = O.target;
    R && n.value.contains(R) || v(R) || b();
  }
  function k(O) {
    !f() || O.relatedTarget !== null || requestAnimationFrame(() => {
      !t.value || !f() || !n.value || n.value.contains(document.activeElement) || v(document.activeElement) || b();
    });
  }
  function L() {
    l && (document.addEventListener("focusin", x), document.addEventListener("focusout", k));
  }
  function P() {
    document.removeEventListener("focusin", x), document.removeEventListener("focusout", k);
  }
  function E() {
    const O = Mo.indexOf(i);
    O !== -1 && Mo.splice(O, 1);
  }
  we(t, (O) => {
    if (O)
      Mo.push(i), d = document.activeElement, document.addEventListener("keydown", h), document.addEventListener("focusin", m), L(), r && requestAnimationFrame(() => {
        var V;
        if (!n.value || n.value.contains(document.activeElement) || v(document.activeElement)) return;
        (V = Lo(n.value)[0]) == null || V.focus();
      });
    else if (E(), document.removeEventListener("keydown", h), P(), document.removeEventListener("focusin", m), u = null, o) {
      const R = (a == null ? void 0 : a()) ?? d;
      R == null || R.focus(), d = null;
    }
  }, { immediate: !0 }), Bt(() => {
    E(), document.removeEventListener("keydown", h), P(), document.removeEventListener("focusin", m);
  });
}
const go = [];
function rs(e) {
  go.includes(e) || go.push(e);
}
function ma(e) {
  const t = go.indexOf(e);
  t !== -1 && go.splice(t, 1);
}
function nu(e) {
  return go[go.length - 1] === e;
}
const E4 = {
  "data-testid": "modal-pre-header",
  class: "flex items-center justify-end h-9"
}, A4 = { class: "flex-1 min-w-0" }, D4 = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    headerPosition: { default: "left" },
    footerPosition: { default: "right" },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showFooter: { type: Boolean, default: !0 },
    showHeader: { type: Boolean, default: !0 },
    showHeaderBorder: { type: Boolean, default: !1 },
    showFooterBorder: { type: Boolean, default: !1 },
    contentClass: {},
    headerClass: {},
    overlayClass: {},
    borderGradient: {}
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    const n = ad(), r = e, o = t, a = () => {
      o("update:modelValue", !1), o("close");
    }, l = () => {
      r.dismissable && a();
    }, s = Symbol("opal-modal"), i = () => rs(s), d = () => ma(s), u = (E) => {
      E.key !== "Escape" || !r.closeOnEscape || !r.modelValue || nu(s) && (E.defaultPrevented || (E.preventDefault(), a()));
    };
    we(
      () => r.modelValue,
      (E) => {
        E ? (i(), document.body.style.overflow = "hidden") : (d(), document.body.style.overflow = "");
      }
    ), Qe(() => {
      document.addEventListener("keydown", u), r.modelValue && (i(), document.body.style.overflow = "hidden");
    }), nt(() => {
      document.removeEventListener("keydown", u), d(), document.body.style.overflow = "";
    });
    const f = {
      xs: "max-w-[384px]",
      sm: "max-w-[500px]",
      md: "max-w-[704px]",
      lg: "max-w-[996px]",
      xl: "max-w-[1340px]",
      "2xl": "max-w-full"
    }, h = {
      left: "justify-start text-left",
      center: "justify-center text-center"
    }, b = {
      left: "justify-start",
      right: "justify-end",
      center: "justify-center",
      split: "justify-between"
    }, m = y(() => f[r.size]), v = y(() => h[r.headerPosition]), x = y(() => b[r.footerPosition]), k = y(() => r.size === "2xl"), L = y(
      () => r.borderGradient ? { "--Border-gradient": r.borderGradient } : void 0
    ), P = N(null);
    return ks({
      active: oo(r, "modelValue"),
      container: P,
      containFocus: !0
    }), (E, O) => (c(), te(cn, { to: "body" }, [
      ae(ot, { name: "modal-fade" }, {
        default: pe(() => [
          e.modelValue ? (c(), p("div", {
            key: 0,
            "data-testid": "modal-backdrop",
            class: S([
              "fixed inset-0 z-50 flex overflow-y-auto overflow-x-hidden",
              k.value ? "p-0" : "p-4",
              e.overlayClass
            ]),
            onClick: Ie(l, ["self"])
          }, [
            g("div", {
              class: "fixed inset-0 bg-black/50 dark:bg-black/70",
              onClick: l
            }),
            g("div", Je(T(n), {
              "data-testid": "modal-container",
              role: "dialog",
              "aria-modal": "true",
              class: ["relative z-10 w-full m-auto", m.value, k.value ? "h-full" : ""],
              onClick: O[0] || (O[0] = Ie(() => {
              }, ["stop"]))
            }), [
              g("div", {
                ref_key: "panelRef",
                ref: P,
                class: S([
                  "relative flex flex-col bg-white dark:bg-(--colors-background-black-default) modal-container",
                  k.value ? "rounded-none h-full border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-xl" : (
                    // DS rule: constant 30px vertical margin — beyond that the content
                    // scrolls internally and the footer stays pinned.
                    "rounded-[var(--border-border-radius-rounded-base,24px)] p-2 shadow-(--shadow-xl) max-h-[calc(100dvh-60px)]"
                  ),
                  e.contentClass
                ]),
                style: Ae(L.value)
              }, [
                g("div", E4, [
                  e.showCloseButton ? (c(), p("button", {
                    key: 0,
                    "data-testid": "modal-close-button",
                    type: "button",
                    class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-transparent text-(--colors-text-body-subtle) hover:bg-(--colors-background-hover) hover:text-(--colors-text-heading) dark:hover:bg-gray-600 dark:hover:text-white transition-colors duration-200",
                    onClick: a
                  }, [...O[1] || (O[1] = [
                    g("i", { class: "ri-close-line text-lg" }, null, -1),
                    g("span", { class: "sr-only" }, "Close modal", -1)
                  ])])) : w("", !0)
                ]),
                e.showHeader ? (c(), p("div", {
                  key: 0,
                  "data-testid": "modal-header",
                  class: S([
                    [
                      "flex items-center gap-5 pt-0 pb-6 px-6",
                      e.showHeaderBorder && "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    v.value,
                    e.headerClass
                  ])
                }, [
                  g("div", A4, [
                    be(E.$slots, "header", {}, void 0, !0)
                  ])
                ], 2)) : w("", !0),
                g("div", {
                  "data-testid": "modal-content",
                  class: S([
                    "flex-1 flex flex-col gap-5 pt-0 px-6 overflow-y-auto",
                    e.showFooter ? "pb-0" : "pb-6"
                  ])
                }, [
                  be(E.$slots, "default", {}, void 0, !0)
                ], 2),
                e.showFooter ? (c(), p("div", {
                  key: 1,
                  "data-testid": "modal-footer",
                  class: S([
                    [
                      "flex items-center gap-5 pt-6 pb-6 px-6",
                      e.showFooterBorder && "border-t border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                    ],
                    x.value
                  ])
                }, [
                  be(E.$slots, "footer", {}, void 0, !0)
                ], 2)) : w("", !0)
              ], 6)
            ], 16)
          ], 2)) : w("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Ta = /* @__PURE__ */ He(D4, [["__scopeId", "data-v-9833c840"]]), R4 = {
  key: 2,
  class: "flex w-full items-start gap-2"
}, B4 = { class: "flex items-center py-1 shrink-0" }, O4 = { class: "flex-1 flex flex-col gap-1" }, P4 = {
  key: 3,
  class: "flex w-full items-start gap-2"
}, z4 = { class: "flex-1 flex flex-col gap-2" }, N4 = { class: "flex flex-col gap-1" }, V4 = {
  key: 0,
  class: "flex items-center gap-4"
}, F4 = { class: "flex-1 flex flex-col gap-1" }, H4 = { class: "flex items-start gap-2" }, W4 = { class: "flex items-center py-1 shrink-0" }, j4 = {
  key: 0,
  class: "flex items-center gap-4 mt-2"
}, U4 = {
  key: 0,
  "data-testid": "alert-right-column",
  class: "flex flex-col items-end gap-2 shrink-0"
}, df = "text-(length:--size-l) leading-(--line-height-xxl) font-(--weight-medium)", G4 = "text-(length:--size-m) leading-(--line-height-l) font-(--weight-medium)", q4 = "text-(length:--size-xs) leading-(--line-height-xs) font-(--weight-regular)", as = /* @__PURE__ */ ge({
  __name: "Alert",
  props: {
    color: { default: "success" },
    surface: { default: "card" },
    layout: { default: "inline" },
    heading: {},
    message: { default: "" },
    closable: { type: Boolean, default: !1 },
    percentage: { default: void 0 },
    buttons: { default: () => [] },
    buttonsPosition: { default: "bottom" },
    compact: { type: Boolean, default: !1 },
    href: { default: void 0 },
    labels: { default: () => ({}) }
  },
  emits: ["close", "navigate"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = {
      success: {
        bg: "bg-(--colors-background-success)",
        borderClass: "border-(--colors-border-success-sublte)",
        borderVar: "--colors-border-success-sublte",
        borderTopClass: "border-(--colors-border-success-sublte)",
        pillHoverBorderClass: "hover:border-(--colors-background-success)",
        icon: "ri-checkbox-circle-line",
        iconTint: "text-(--colors-text-success)",
        badgeTheme: "green"
      },
      danger: {
        bg: "bg-(--colors-background-error)",
        borderClass: "border-(--colors-border-error-subtle)",
        borderVar: "--colors-border-error-subtle",
        borderTopClass: "border-(--colors-border-error-strong)",
        pillHoverBorderClass: "hover:border-(--colors-background-error)",
        icon: "ri-alert-line",
        iconTint: "text-(--colors-text-error)",
        badgeTheme: "red"
      },
      warning: {
        bg: "bg-(--colors-background-warning)",
        borderClass: "border-(--colors-border-warning-subtle)",
        borderVar: "--colors-border-warning-subtle",
        borderTopClass: "border-(--colors-border-warning)",
        pillHoverBorderClass: "hover:border-(--colors-background-warning)",
        icon: "ri-error-warning-line",
        iconTint: "text-(--colors-text-warning)",
        badgeTheme: "orange"
      },
      info: {
        bg: "bg-(--colors-background-info)",
        borderClass: "border-(--colors-border-info-subtle)",
        borderVar: "--colors-border-info-subtle",
        borderTopClass: "border-(--colors-border-info-subtle)",
        pillHoverBorderClass: "hover:border-(--colors-background-info)",
        icon: "ri-information-line",
        iconTint: "text-(--colors-text-info)",
        badgeTheme: "indigo"
      },
      default: {
        bg: "bg-(--colors-background-selected)",
        borderClass: "border-(--colors-border-base-medium)",
        borderVar: "--colors-border-base-medium",
        borderTopClass: "border-(--colors-border-base-medium)",
        pillHoverBorderClass: "hover:border-(--colors-background-selected)",
        icon: "ri-information-line",
        iconTint: "text-(--colors-text-body)",
        badgeTheme: "grey"
      },
      ia: {
        bg: "bg-(--colors-background-ia)",
        borderClass: "border-(--colors-border-ia)",
        borderVar: "--colors-border-ia",
        borderTopClass: "border-(--colors-border-ia-strong)",
        pillHoverBorderClass: "hover:border-(--colors-background-ia)",
        icon: "ri-magic-line",
        iconTint: "text-(--colors-text-ia)",
        badgeTheme: "purple"
      }
    }, l = y(() => a[n.color]), s = y(() => l.value.badgeTheme), i = y(
      () => n.color === "danger" ? { role: "alert", ariaLive: "assertive" } : { role: "status", ariaLive: "polite" }
    ), d = y(() => n.surface === "pill"), u = y(() => d.value ? n.href ? "a" : "button" : "div"), f = y(() => d.value ? n.href ? { href: n.href } : { type: "button" } : {
      role: i.value.role,
      "aria-live": i.value.ariaLive
    }), h = y(() => n.surface === "pill" ? "rounded-(--border-border-radius-rounded-full) border-(length:--border-border-width-border) border-solid flex-row items-center gap-2 pl-1 pr-2 py-1 w-full max-w-lg" : n.surface === "borderTop" ? "rounded-none border-t-(length:--border-border-width-border-lg) border-solid flex-col items-start gap-4 p-4 w-full max-w-3xl" : "rounded-(--border-border-radius-rounded-l) border-(length:--border-border-width-border) border-solid flex-col items-start gap-4 p-4 w-full max-w-3xl"), b = y(() => [
      "relative box-border flex min-w-72 text-left font-inter transition-all duration-300",
      l.value.bg,
      n.surface === "borderTop" ? l.value.borderTopClass : l.value.borderClass,
      "text-(--colors-text-heading)",
      h.value,
      d.value ? ["cursor-pointer", "transition-colors", l.value.pillHoverBorderClass] : ""
    ]), m = y(() => n.percentage !== void 0 ? "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular)" : "text-(length:--size-m) leading-(--line-height-l) font-(--weight-regular)"), v = y(
      () => n.closable && n.percentage === void 0 && !d.value && !n.compact
    ), x = y(() => n.percentage !== void 0), k = y(() => {
      var J;
      return ((J = n.labels) == null ? void 0 : J.closeButton) ?? "Dismiss alert";
    });
    function L() {
      o.value = !0, r("close");
    }
    function P() {
      r("navigate");
    }
    function E(J) {
      var F;
      (F = J.onClick) == null || F.call(J);
    }
    function O(J) {
      return {
        as: J.href ? "a" : "button",
        href: J.href,
        ariaLabel: J.ariaLabel,
        iconLeft: J.iconPosition !== "right" ? J.icon : void 0,
        iconRight: J.iconPosition === "right" ? J.icon : void 0,
        size: "s",
        onClick: () => E(J)
      };
    }
    function R(J) {
      return {
        label: J.label,
        variant: J.variant ?? "primary",
        as: J.href ? "a" : "button",
        href: J.href,
        // Passed as a literal HTML attribute key, not a declared Button prop —
        // Button.vue never declares `ariaLabel`, so this lands in Button's
        // $attrs and Vue's default attrs inheritance forwards it straight to
        // the root <button>/<a> element, overriding nothing else. Declaring a
        // real `ariaLabel` prop on Button.vue would close the automatic $attrs
        // fallthrough for that attribute name for every consumer in the
        // monorepo (many icon-only Button call sites rely on a raw, undeclared
        // :aria-label falling through) — see Refs: #OP-5881 fix commit.
        "aria-label": J.ariaLabel,
        iconLeft: J.iconPosition !== "right" ? J.icon : void 0,
        iconRight: J.iconPosition === "right" ? J.icon : void 0,
        size: "xs",
        onClick: () => E(J)
      };
    }
    function V() {
      d.value && !n.href && P();
    }
    return (J, F) => o.value ? w("", !0) : (c(), te(Wt(u.value), Je({ key: 0 }, f.value, {
      class: b.value,
      onClick: V
    }), {
      default: pe(() => [
        J.$slots.default ? be(J.$slots, "default", { key: 0 }) : d.value ? (c(), p(Z, { key: 1 }, [
          ae(T(pt), {
            "data-testid": "alert-badge",
            label: e.heading,
            theme: s.value,
            size: "sm",
            "show-left-icon": !1,
            "show-close-icon": !1,
            class: "rounded-(--border-border-radius-rounded-full)! px-2! py-0.5!"
          }, null, 8, ["label", "theme"]),
          e.message ? (c(), p("span", {
            key: 0,
            "data-testid": "alert-message",
            class: S([m.value, "flex-1"])
          }, $(e.message), 3)) : w("", !0),
          F[0] || (F[0] = g("i", {
            class: "ri-arrow-right-line text-(length:--size-l) leading-none shrink-0",
            "aria-hidden": "true"
          }, null, -1))
        ], 64)) : e.layout === "inline" ? (c(), p("div", R4, [
          g("div", B4, [
            g("i", {
              class: S([[l.value.icon, l.value.iconTint], "text-(length:--size-l) leading-none"]),
              "aria-hidden": "true"
            }, null, 2)
          ]),
          g("div", O4, [
            g("p", {
              "data-testid": "alert-heading",
              class: S(df)
            }, $(e.heading), 1),
            e.message ? (c(), p("p", {
              key: 0,
              "data-testid": "alert-message",
              class: S(m.value)
            }, $(e.message), 3)) : w("", !0)
          ]),
          v.value ? (c(), te(T($e), {
            key: 0,
            variant: "text",
            "icon-only": "",
            "icon-left": "ri-close-line",
            size: "xxs",
            "icon-alt": k.value,
            class: "shrink-0",
            onClick: L
          }, null, 8, ["icon-alt"])) : w("", !0)
        ])) : e.compact ? (c(), p("div", P4, [
          x.value ? (c(), te(T(pt), {
            key: 0,
            "data-testid": "alert-percentage",
            label: `${e.percentage}%`,
            theme: s.value,
            size: "sm",
            "show-left-icon": !1,
            "show-close-icon": !1,
            class: "min-w-10 rounded-(--border-border-radius-rounded-xs)!"
          }, null, 8, ["label", "theme"])) : w("", !0),
          g("div", z4, [
            g("div", N4, [
              g("p", {
                "data-testid": "alert-heading",
                class: S(G4)
              }, $(e.heading), 1),
              be(J.$slots, "body", {}, () => [
                e.message ? (c(), p("p", {
                  key: 0,
                  "data-testid": "alert-message",
                  class: S(q4)
                }, $(e.message), 1)) : w("", !0)
              ])
            ]),
            e.buttons.length ? (c(), p("div", V4, [
              (c(!0), p(Z, null, ke(e.buttons, (A, j) => (c(), p(Z, { key: j }, [
                A.component === "link" ? (c(), te(T($r), Je({
                  key: 0,
                  ref_for: !0
                }, O(A)), {
                  default: pe(() => [
                    Ze($(A.label), 1)
                  ]),
                  _: 2
                }, 1040)) : (c(), te(T($e), Je({
                  key: 1,
                  ref_for: !0
                }, R(A)), null, 16))
              ], 64))), 128))
            ])) : w("", !0)
          ])
        ])) : (c(), p("div", {
          key: 4,
          class: S(["flex w-full", e.buttonsPosition === "right" ? "items-start gap-2" : "flex-col gap-3"])
        }, [
          g("div", F4, [
            g("div", H4, [
              g("div", W4, [
                g("i", {
                  class: S([[l.value.icon, l.value.iconTint], "text-(length:--size-l) leading-none"]),
                  "aria-hidden": "true"
                }, null, 2)
              ]),
              g("p", {
                "data-testid": "alert-heading",
                class: S([df, "flex-1"])
              }, $(e.heading), 1),
              x.value ? (c(), te(T(pt), {
                key: 0,
                "data-testid": "alert-percentage",
                label: `${e.percentage}%`,
                theme: s.value,
                size: "sm",
                "show-left-icon": !1,
                "show-close-icon": !1,
                class: "shrink-0 min-w-10 rounded-(--border-border-radius-rounded-xs)!"
              }, null, 8, ["label", "theme"])) : w("", !0),
              v.value && e.buttonsPosition !== "right" ? (c(), te(T($e), {
                key: 1,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-close-line",
                size: "xxs",
                "icon-alt": k.value,
                class: "shrink-0",
                onClick: L
              }, null, 8, ["icon-alt"])) : w("", !0)
            ]),
            be(J.$slots, "body", {}, () => [
              e.message ? (c(), p("p", {
                key: 0,
                "data-testid": "alert-message",
                class: S(m.value)
              }, $(e.message), 3)) : w("", !0)
            ]),
            e.buttons.length && e.buttonsPosition === "bottom" ? (c(), p("div", j4, [
              (c(!0), p(Z, null, ke(e.buttons, (A, j) => (c(), p(Z, { key: j }, [
                A.component === "link" ? (c(), te(T($r), Je({
                  key: 0,
                  ref_for: !0
                }, O(A)), {
                  default: pe(() => [
                    Ze($(A.label), 1)
                  ]),
                  _: 2
                }, 1040)) : (c(), te(T($e), Je({
                  key: 1,
                  ref_for: !0
                }, R(A)), null, 16))
              ], 64))), 128))
            ])) : w("", !0)
          ]),
          e.buttonsPosition === "right" && (v.value || e.buttons.length) ? (c(), p("div", U4, [
            v.value ? (c(), te(T($e), {
              key: 0,
              variant: "text",
              "icon-only": "",
              "icon-left": "ri-close-line",
              size: "xxs",
              "icon-alt": k.value,
              onClick: L
            }, null, 8, ["icon-alt"])) : w("", !0),
            (c(!0), p(Z, null, ke(e.buttons, (A, j) => (c(), p(Z, { key: j }, [
              A.component === "link" ? (c(), te(T($r), Je({
                key: 0,
                ref_for: !0
              }, O(A)), {
                default: pe(() => [
                  Ze($(A.label), 1)
                ]),
                _: 2
              }, 1040)) : (c(), te(T($e), Je({
                key: 1,
                ref_for: !0
              }, R(A)), null, 16))
            ], 64))), 128))
          ])) : w("", !0)
        ], 2))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), K4 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"/></svg>', uf = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"/></svg>', J4 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"/></svg>', Z4 = { class: "flex items-center gap-0.5" }, Y4 = { class: "relative leading-5 font-medium" }, X4 = {
  key: 0,
  class: "relative leading-5 font-medium"
}, Q4 = ["src", "alt"], _4 = ["aria-label", "disabled"], eT = { class: "text-lg font-semibold text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, tT = { class: "flex flex-col gap-4" }, nT = { class: "flex items-start gap-4" }, rT = {
  "data-testid": "image-upload-preview",
  class: "shrink-0"
}, oT = ["src", "alt"], aT = { class: "flex-1 min-w-0" }, lT = {
  key: 0,
  class: "text-sm text-red-600",
  role: "alert"
}, sT = { key: 1 }, cf = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23c0c0c0'/%3E%3Crect x='30' y='30' width='140' height='140' rx='4' fill='%23e0e0e0'/%3E%3Ccircle cx='80' cy='82' r='14' fill='%23b0b0b0'/%3E%3Cpath d='M50 140 l30-40 l20 25 l15-18 l35 45 H50z' fill='%23b0b0b0'/%3E%3C/svg%3E", hV = /* @__PURE__ */ ge({
  __name: "ImageUploadInput",
  props: {
    imageUrl: { default: void 0 },
    imageAlt: { default: "Profile picture" },
    avatarSize: { default: 64 },
    label: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    accept: { default: "image/*" },
    maxFileSize: { default: 30 * 1024 * 1024 },
    maxFileSizeText: { default: "SVG, PNG, JPG or GIF (MAX. 800x400px)." },
    fileTypeErrorText: { default: void 0 },
    fileSizeErrorText: { default: void 0 },
    fileInputLabel: { default: void 0 },
    browseButtonText: { default: "Choose files" },
    placeholder: { default: "No file chosen" },
    removeButtonLabel: { default: "Remove current picture" },
    alertHeading: { default: "Important" },
    alertMessage: { default: "In order for new users to access their accounts, they must receive approval from an administrator to verify their eligibility." },
    alertVariant: { default: "info" },
    showAlert: { type: Boolean, default: !0 },
    cancelButtonLabel: { default: "Cancel" },
    uploadButtonLabel: { default: "Upload new picture" },
    modalTitle: { default: "Upload profile picture" },
    modalSize: { default: "sm" },
    disabled: { type: Boolean, default: !1 },
    editButtonLabel: { default: "Edit profile picture" }
  },
  emits: ["upload", "remove", "cancel"],
  setup(e, { emit: t }) {
    const n = (O, R) => {
      const V = O.replace('fill="currentColor"', `fill="${R}"`).replace("<svg", '<svg width="16" height="16"');
      return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(V)}`;
    }, r = {
      arrowLeftDark: n(K4, "#242424"),
      arrowRightDark: n(uf, "#242424"),
      arrowRightLight: n(uf, "#f2f0f0"),
      deleteDark: n(J4, "#242424")
    }, o = e, a = t, l = N(!1), s = N(null), i = N(void 0), d = N(null), u = y(() => ({
      width: `${o.avatarSize}px`,
      height: `${o.avatarSize}px`
    })), f = y(() => {
      const O = "flex text-left text-sm font-inter";
      return o.labelInline ? `${O} flex-row items-center gap-4` : `${O} flex-col items-start gap-2`;
    }), h = () => {
      o.disabled || (s.value = null, i.value = o.imageUrl, d.value = null, l.value = !0);
    }, b = () => {
      l.value = !1, s.value = null, i.value = void 0;
    }, m = () => {
      a("cancel"), b();
    }, v = (O) => {
      !O || Array.isArray(O) || (d.value = null, s.value = O, i.value = URL.createObjectURL(O));
    }, x = (O) => {
      d.value = O, s.value = null;
    }, k = () => {
      s.value = null, i.value = void 0, a("remove");
    }, L = () => {
      s.value && (a("upload", s.value), b());
    }, P = y(() => !!s.value), E = y(() => !!i.value);
    return we(l, (O) => {
      !O && i.value && i.value !== o.imageUrl && URL.revokeObjectURL(i.value);
    }), (O, R) => (c(), p("div", {
      "data-testid": "image-upload-input",
      class: S(f.value)
    }, [
      e.label ? (c(), p("div", {
        key: 0,
        "data-testid": "image-upload-label",
        class: S([
          "flex items-center text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
          e.labelInline ? "shrink-0" : ""
        ])
      }, [
        g("div", Z4, [
          g("div", Y4, $(e.label), 1),
          e.required ? (c(), p("div", X4, " * ")) : w("", !0)
        ])
      ], 2)) : w("", !0),
      g("div", {
        class: "relative inline-block",
        style: Ae(u.value)
      }, [
        g("div", {
          "data-testid": "image-upload-trigger",
          class: S(["w-full h-full rounded-xl overflow-hidden border border-(--colors-border-base-soft) dark:border-(--colors-border-base)", e.disabled ? "opacity-50" : ""])
        }, [
          g("img", {
            src: e.imageUrl || cf,
            alt: e.imageAlt,
            class: "w-full h-full object-cover"
          }, null, 8, Q4)
        ], 2),
        g("button", {
          "data-testid": "image-upload-edit-button",
          type: "button",
          "aria-label": e.editButtonLabel,
          class: S(["absolute -top-2 -right-2 flex items-center justify-center w-8 h-8 rounded-full bg-white dark:bg-(--colors-background-black-default) border border-(--colors-border-base-soft) dark:border-(--colors-border-base) shadow-sm transition-colors duration-200 hover:bg-(--colors-background-hover) dark:hover:bg-[rgba(255,255,255,0.1)]", e.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"]),
          disabled: e.disabled,
          onClick: h
        }, [...R[1] || (R[1] = [
          g("i", {
            class: "ri-pencil-line text-sm text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
            "aria-hidden": "true"
          }, null, -1)
        ])], 10, _4)
      ], 4),
      ae(T(Ta), {
        modelValue: l.value,
        "onUpdate:modelValue": R[0] || (R[0] = (V) => l.value = V),
        size: e.modalSize,
        "header-position": "left",
        "footer-position": "right"
      }, {
        header: pe(() => [
          g("h3", eT, $(e.modalTitle), 1)
        ]),
        footer: pe(() => [
          ae(T($e), {
            "data-testid": "image-upload-cancel-button",
            variant: "secondary",
            label: e.cancelButtonLabel,
            "icon-left": r.arrowLeftDark,
            onClick: m
          }, null, 8, ["label", "icon-left"]),
          ae(T($e), {
            "data-testid": "image-upload-submit-button",
            variant: "primary",
            label: e.uploadButtonLabel,
            "icon-right": r.arrowRightLight,
            disabled: !P.value,
            onClick: L
          }, null, 8, ["label", "icon-right", "disabled"])
        ]),
        default: pe(() => [
          g("div", tT, [
            g("div", nT, [
              g("div", rT, [
                g("img", {
                  src: i.value || cf,
                  alt: e.imageAlt,
                  class: "w-16 h-16 rounded-xl object-cover border border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
                }, null, 8, oT)
              ]),
              g("div", aT, [
                ae(T(gk), {
                  variant: "basic",
                  accept: e.accept,
                  "max-file-size": e.maxFileSize,
                  "max-file-size-text": e.maxFileSizeText,
                  "file-type-error-text": e.fileTypeErrorText,
                  "file-size-error-text": e.fileSizeErrorText,
                  label: e.fileInputLabel,
                  "browse-button-text": e.browseButtonText,
                  placeholder: e.placeholder,
                  "model-value": s.value,
                  "onUpdate:modelValue": v,
                  onError: x
                }, null, 8, ["accept", "max-file-size", "max-file-size-text", "file-type-error-text", "file-size-error-text", "label", "browse-button-text", "placeholder", "model-value"])
              ])
            ]),
            d.value ? (c(), p("p", lT, $(d.value), 1)) : w("", !0),
            E.value ? (c(), p("div", sT, [
              ae(T($e), {
                "data-testid": "image-upload-remove-button",
                variant: "secondary",
                label: e.removeButtonLabel,
                "icon-left": r.deleteDark,
                size: "sm",
                onClick: k
              }, null, 8, ["label", "icon-left"])
            ])) : w("", !0),
            e.showAlert ? (c(), te(T(as), {
              key: 2,
              heading: e.alertHeading,
              message: e.alertMessage,
              color: e.alertVariant === "error" ? "danger" : e.alertVariant,
              closable: !1
            }, null, 8, ["heading", "message", "color"])) : w("", !0)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "size"])
    ], 2));
  }
}), iT = ["id", "aria-label", "data-testid"], dT = {
  key: 0,
  class: "flex w-full items-center gap-3"
}, Ap = /* @__PURE__ */ ge({
  __name: "DatepickerPanel",
  props: {
    open: { type: Boolean, default: !1 },
    anchorEl: {},
    dialogLabel: {},
    testId: {},
    widthClass: {},
    id: { default: void 0 },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    placement: { default: "bottom-start" }
  },
  emits: ["update:open", "close"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n, a = N(null);
    let l = null;
    function s(m) {
      return m.startsWith("bottom") ? m.replace("bottom", "top") : m.replace("top", "bottom");
    }
    function i() {
      a.value && (l == null || l.destroy(), l = vo(r.anchorEl, a.value, {
        strategy: "fixed",
        placement: r.placement,
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: [s(r.placement)] } },
          { name: "preventOverflow", options: { padding: 8 } }
        ]
      }));
    }
    function d() {
      l == null || l.destroy(), l = null;
    }
    function u() {
      l == null || l.update();
    }
    function f() {
      o("update:open", !1), o("close");
    }
    ks({
      active: oo(r, "open"),
      container: a,
      containFocus: !0,
      restoreFocusTo: () => r.anchorEl,
      // See keepAnchorFocusable's doc above: without this, a consumer whose anchor IS its own
      // typing surface can never place a caret in it while the panel is open — containFocus treats
      // the click as focus escaping the trap and yanks it straight back to the panel's first
      // focusable cell.
      allowOutsideElements: r.keepAnchorFocusable ? () => [r.anchorEl] : void 0
    }), pd(a, f, {
      isActive: () => r.open,
      ignoreElements: () => [r.anchorEl]
    });
    const h = Symbol("datepicker-panel");
    function b(m) {
      m.key !== "Escape" || !r.open || nu(h) && (m.defaultPrevented || (m.stopPropagation(), m.preventDefault(), f()));
    }
    return we(
      () => r.open,
      async (m) => {
        m ? (rs(h), await Pe(), i()) : (ma(h), d());
      },
      { immediate: !0 }
    ), Qe(() => {
      document.addEventListener("keydown", b);
    }), Bt(() => {
      document.removeEventListener("keydown", b), ma(h), d();
    }), t({ updatePosition: u }), (m, v) => (c(), te(cn, { to: "body" }, [
      e.open ? (c(), p("div", {
        key: 0,
        id: e.id,
        ref_key: "panelRef",
        ref: a,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": e.dialogLabel,
        "data-focus-trap-allow-outside": "",
        "data-testid": e.testId,
        class: S([
          "z-[400] flex flex-col items-center gap-4 rounded-(--border-border-radius-rounded-l) border border-solid border-(--border-border-base-soft) bg-(--background-background-white) p-5 shadow-(--blur-shadow-m) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
          e.widthClass
        ])
      }, [
        be(m.$slots, "default"),
        m.$slots.actions ? (c(), p("div", dT, [
          be(m.$slots, "actions")
        ])) : w("", !0)
      ], 10, iT)) : w("", !0)
    ]));
  }
}), uT = ["aria-disabled", "data-state", "aria-current"], gr = "relative inline-flex items-center justify-center font-inter focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1", cT = "flex size-9 items-center justify-center rounded-(--border-border-radius-rounded-full) border border-solid datepicker-cell--gradient-white", Ur = "text-(length:--size-sm) leading-(--line-height-l)", fT = /* @__PURE__ */ ge({
  __name: "DatepickerCell",
  props: {
    type: { default: "Day" },
    state: { default: "Initial" },
    text: { default: "" },
    muted: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => n.state === "Disabled");
    function a(u) {
      o.value || r("click", u);
    }
    const l = y(
      () => n.type === "Day" && (n.state === "Active start" || n.state === "Active end")
    ), s = y(() => {
      switch (n.type) {
        case "Month":
          return "h-9 min-w-[78px] flex-1";
        case "Year":
        case "Wheel":
          return "h-9 min-w-[57px] flex-1";
        default:
          return "size-9 shrink-0";
      }
    }), i = y(() => {
      switch (n.state) {
        case "Hover":
          return `${gr} bg-(--background-background-accent) rounded-(--border-border-radius-rounded-base)`;
        case "Active":
          return `${gr} datepicker-cell--gradient-white border border-solid rounded-(--border-border-radius-rounded-full)`;
        case "Active start":
          return `${gr} bg-(--background-background-accent) rounded-l-(--border-border-radius-rounded-base)`;
        case "Active between":
          return `${gr} bg-(--background-background-accent)`;
        case "Active end":
          return `${gr} bg-(--background-background-accent) rounded-r-(--border-border-radius-rounded-base)`;
        case "Today":
          return `${gr} datepicker-cell--gradient-black border border-solid rounded-(--border-border-radius-rounded-full)`;
        default:
          return `${gr} rounded-(--border-border-radius-rounded-base)`;
      }
    }), d = y(() => {
      switch (n.state) {
        case "Active":
        case "Active start":
        case "Active end":
          return `${Ur} font-(--weight-semi-bold) text-(--text-text-accent)`;
        case "Today":
          return `${Ur} font-(--weight-semi-bold) text-(--text-text-white-default)`;
        case "Disabled":
          return `${Ur} font-(--weight-medium) text-(--text-text-disabled-light)`;
        case "Hover":
        case "Active between":
          return `${Ur} font-(--weight-medium) text-(--text-text-black-default)`;
        default:
          return n.muted ? `${Ur} font-(--weight-medium) text-(--text-text-disabled-strong) dark:text-(--text-text-disabled-light)` : `${Ur} font-(--weight-medium) text-(--text-text-black-default) dark:text-(--colors-text-white-default)`;
      }
    });
    return (u, f) => (c(), p("button", {
      type: "button",
      "aria-disabled": o.value ? "true" : void 0,
      class: S([i.value, s.value, o.value ? "cursor-not-allowed" : "cursor-pointer"]),
      "data-state": e.state,
      "aria-current": e.state === "Today" ? "date" : void 0,
      "data-testid": "datepicker-cell",
      onClick: a
    }, [
      l.value ? (c(), p("span", {
        key: 0,
        class: S(cT),
        "data-testid": "datepicker-cell-inner"
      }, [
        g("span", {
          class: S(d.value)
        }, $(e.text), 3)
      ])) : (c(), p("span", {
        key: 1,
        class: S(d.value)
      }, $(e.text), 3))
    ], 10, uT));
  }
}), Qo = /* @__PURE__ */ He(fT, [["__scopeId", "data-v-c4eaa4a3"]]);
function ti(e, t) {
  const n = N(0);
  function r() {
    const i = e.value.findIndex((d) => d.value === t.value);
    n.value = i >= 0 ? i : Math.max(e.value.findIndex((d) => !d.disabled), 0);
  }
  r();
  function o(i) {
    const d = e.value[i];
    !d || d.disabled || (n.value = i, t.value = d.value);
  }
  function a(i) {
    if (i < 0 || i >= e.value.length) return;
    n.value = i;
    const d = e.value[i];
    d.disabled || (t.value = d.value);
  }
  function l(i) {
    a(n.value + i);
  }
  function s(i) {
    const d = e.value;
    a(i === "start" ? 0 : d.length - 1);
  }
  return { focusedIndex: n, selectIndex: o, moveFocus: l, moveToEdge: s, syncFocusToSelected: r };
}
const hT = { class: "w-full text-center text-(length:--size-m) font-(--weight-semi-bold) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, bT = { class: "flex w-full flex-wrap content-start items-start justify-between" }, pT = ["aria-label"], gT = ["aria-label"], mT = ["aria-label"], vT = 120, xT = 10, yT = 200, kT = 200, wT = /* @__PURE__ */ ge({
  __name: "DatepickerDobPicker",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    anchorEl: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    defaultDate: { default: void 0 },
    id: { default: void 0 },
    autoFocusOnOpen: { type: Boolean, default: !0 },
    title: {},
    yearColumnLabel: {},
    monthColumnLabel: {},
    dayColumnLabel: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {}
  },
  emits: ["update:open", "update:modelValue", "clear", "close"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n;
    function a(z) {
      return String(z).padStart(2, "0");
    }
    function l(z, X, Y) {
      return `${z}-${a(X + 1)}-${a(Y)}`;
    }
    function s(z, X) {
      return new Date(z, X + 1, 0).getDate();
    }
    function i() {
      const z = r.modelValue || r.defaultDate, X = z ? /* @__PURE__ */ new Date(`${z}T00:00:00`) : /* @__PURE__ */ new Date();
      return { year: X.getFullYear(), month: X.getMonth(), day: X.getDate() };
    }
    const d = i(), u = N(d.year), f = N(d.month), h = N(d.day);
    function b(z) {
      const X = (/* @__PURE__ */ new Date()).getFullYear();
      return Math.min(Math.max(z, X - yT), X + kT);
    }
    const m = y(() => r.minDate ? b(Number(r.minDate.slice(0, 4))) : void 0), v = y(() => r.maxDate ? b(Number(r.maxDate.slice(0, 4))) : void 0), x = y(() => {
      const z = (/* @__PURE__ */ new Date()).getFullYear(), X = [z - vT, z + xT];
      return m.value !== void 0 && X.push(m.value), v.value !== void 0 && X.push(v.value), X.push(b(u.value)), {
        min: Math.min(...X),
        max: Math.max(...X)
      };
    });
    function k(z) {
      const { minDate: X, maxDate: Y } = r;
      return !!(X && z < X.slice(0, z.length) || Y && z > Y.slice(0, z.length));
    }
    const L = y(() => {
      const { min: z, max: X } = x.value, Y = [];
      for (let ce = z; ce <= X; ce++) {
        const ne = String(ce);
        k(ne) || Y.push({ value: ce, label: ne, disabled: !1 });
      }
      return Y;
    }), P = y(() => {
      const z = [];
      return r.monthShortLabels.forEach((X, Y) => {
        const ce = `${u.value}-${a(Y + 1)}`;
        k(ce) || z.push({ value: Y, label: X, disabled: !1 });
      }), z;
    }), E = y(() => {
      const z = s(u.value, f.value), X = [];
      for (let Y = 0; Y < z; Y++) {
        const ce = Y + 1, ne = l(u.value, f.value, ce);
        k(ne) || X.push({ value: ce, label: String(ce), disabled: !1 });
      }
      return X;
    }), O = ti(L, u), R = ti(P, f), V = ti(E, h);
    function J() {
      o("update:modelValue", l(u.value, f.value, h.value));
    }
    function F(z) {
      u.value = b(u.value), v.value !== void 0 && u.value > v.value && (u.value = v.value), m.value !== void 0 && u.value < m.value && (u.value = m.value);
      const X = s(u.value, f.value);
      if (h.value > X && (h.value = X), r.maxDate) {
        const [ne, ye, he] = r.maxDate.split("-").map(Number);
        u.value === ne && f.value > ye - 1 && (f.value = ye - 1, h.value = Math.min(h.value, s(u.value, f.value))), u.value === ne && f.value === ye - 1 && h.value > he && (h.value = he);
      }
      if (r.minDate) {
        const [ne, ye, he] = r.minDate.split("-").map(Number);
        u.value === ne && f.value < ye - 1 && (f.value = ye - 1, h.value = Math.min(h.value, s(u.value, f.value))), u.value === ne && f.value === ye - 1 && h.value < he && (h.value = he);
      }
      const Y = z ?? de, ce = ["year", "month", "day"].filter((ne) => ne !== Y);
      ce.forEach((ne) => se.value.add(ne)), z !== void 0 && (de = z), O.syncFocusToSelected(), R.syncFocusToSelected(), V.syncFocusToSelected(), Pe(() => {
        ce.forEach((ne) => se.value.delete(ne)), z !== void 0 && (de = void 0);
      });
    }
    we([u, f], () => F());
    function A(z) {
      O.selectIndex(z), F("year"), J();
    }
    function j(z) {
      R.selectIndex(z), F("month"), J();
    }
    function _(z) {
      V.selectIndex(z), J();
    }
    const U = { year: O, month: R, day: V }, W = {
      year: u,
      month: f,
      day: h
    }, K = ["year", "month", "day"];
    function le(z, X) {
      const Y = K.indexOf(z) + X;
      if (Y < 0 || Y >= K.length) return;
      const ce = K[Y], ne = re[ce].value, ye = ne == null ? void 0 : ne.querySelectorAll('[role="option"]')[U[ce].focusedIndex.value];
      ye == null || ye.focus({ preventScroll: !0 }), ye == null || ye.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    function C() {
      o("update:open", !1), o("close");
    }
    function B(z, X) {
      if (z.key === "ArrowLeft" || z.key === "ArrowRight") {
        z.preventDefault(), le(X, z.key === "ArrowLeft" ? -1 : 1);
        return;
      }
      if (z.key === "Enter" || z.key === " ") {
        z.preventDefault(), C();
        return;
      }
      const Y = U[X], ce = W[X], ne = ce.value;
      switch (z.key) {
        case "ArrowDown":
          z.preventDefault(), Y.moveFocus(1);
          break;
        case "ArrowUp":
          z.preventDefault(), Y.moveFocus(-1);
          break;
        case "Home":
          z.preventDefault(), Y.moveToEdge("start");
          break;
        case "End":
          z.preventDefault(), Y.moveToEdge("end");
          break;
        default:
          return;
      }
      ce.value !== ne && (X !== "day" && F(X), J());
    }
    const I = N(null), M = N(null), D = N(null), re = { year: I, month: M, day: D }, se = N(/* @__PURE__ */ new Set());
    let de;
    function fe(z) {
      const X = re[z].value, Y = X == null ? void 0 : X.querySelectorAll('[role="option"]')[U[z].focusedIndex.value];
      se.value.has(z) || Y == null || Y.focus({ preventScroll: !0 }), Y == null || Y.scrollIntoView({ block: "center", behavior: "smooth" });
    }
    we(O.focusedIndex, () => fe("year"), { flush: "post" }), we(R.focusedIndex, () => fe("month"), { flush: "post" }), we(V.focusedIndex, () => fe("day"), { flush: "post" });
    function q(z, X) {
      return z.value === X ? "Active" : "Initial";
    }
    function oe() {
      o("clear");
    }
    async function ue() {
      const z = i();
      u.value = z.year, f.value = z.month, h.value = z.day, F(), se.value.add("year"), se.value.add("month"), se.value.add("day"), O.syncFocusToSelected(), R.syncFocusToSelected(), V.syncFocusToSelected(), await Pe(), se.value.delete("year"), se.value.delete("month"), se.value.delete("day");
      const X = ["year", "month", "day"].map(
        (Y) => {
          var ce;
          return (ce = re[Y].value) == null ? void 0 : ce.querySelectorAll('[role="option"]')[U[Y].focusedIndex.value];
        }
      );
      return X.forEach((Y) => Y == null ? void 0 : Y.scrollIntoView({ block: "center" })), X[0];
    }
    async function G() {
      const z = await ue();
      z == null || z.focus({ preventScroll: !0 });
    }
    we(
      () => r.open,
      (z) => {
        z && (r.autoFocusOnOpen ? G() : ue());
      },
      // DatePickerInput's openDobPicker() sets
      // dobMounted/isDobOpen true in the SAME synchronous call, so this component can mount with
      // `open` ALREADY true on first open — without `immediate`, this watcher would never fire for
      // that case (a plain watch only fires on a subsequent CHANGE), and the explicit year-column
      // focus above would never run on the very first open at all.
      { immediate: !0 }
    );
    function H() {
      G();
    }
    return t({ focusYearColumn: H }), we(
      () => r.modelValue,
      (z) => {
        if (!r.open || z === l(u.value, f.value, h.value)) return;
        const X = i();
        u.value = X.year, f.value = X.month, h.value = X.day, F();
      }
    ), (z, X) => (c(), te(Ap, {
      id: e.id,
      open: e.open,
      "anchor-el": e.anchorEl,
      "keep-anchor-focusable": "",
      "dialog-label": e.title,
      "test-id": "datepicker-dob-picker",
      "width-class": "w-[224px]",
      "onUpdate:open": X[3] || (X[3] = (Y) => o("update:open", Y)),
      onClose: X[4] || (X[4] = (Y) => o("close"))
    }, {
      actions: pe(() => [
        ae($e, {
          variant: "secondary",
          size: "sm",
          class: "flex-1",
          "full-width": "",
          label: e.clearLabel,
          "data-testid": "datepicker-dob-picker-clear",
          onClick: oe
        }, null, 8, ["label"])
      ]),
      default: pe(() => [
        g("p", hT, $(e.title), 1),
        g("div", bT, [
          g("div", {
            ref_key: "yearListRef",
            ref: I,
            role: "listbox",
            "aria-label": e.yearColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: X[0] || (X[0] = (Y) => B(Y, "year"))
          }, [
            (c(!0), p(Z, null, ke(L.value, (Y, ce) => (c(), te(Qo, {
              key: Y.value,
              type: "Wheel",
              state: q(Y, u.value),
              text: Y.label,
              role: "option",
              class: "snap-center",
              "aria-selected": Y.value === u.value ? "true" : void 0,
              tabindex: ce === T(O).focusedIndex.value ? 0 : -1,
              "aria-label": Y.label,
              onClick: (ne) => A(ce)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, pT),
          g("div", {
            ref_key: "monthListRef",
            ref: M,
            role: "listbox",
            "aria-label": e.monthColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: X[1] || (X[1] = (Y) => B(Y, "month"))
          }, [
            (c(!0), p(Z, null, ke(P.value, (Y, ce) => (c(), te(Qo, {
              key: Y.value,
              type: "Wheel",
              state: q(Y, f.value),
              text: Y.label,
              role: "option",
              class: "snap-center",
              "aria-selected": Y.value === f.value ? "true" : void 0,
              tabindex: ce === T(R).focusedIndex.value ? 0 : -1,
              "aria-label": e.monthLabels[Y.value],
              onClick: (ne) => j(ce)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, gT),
          g("div", {
            ref_key: "dayListRef",
            ref: D,
            role: "listbox",
            "aria-label": e.dayColumnLabel,
            class: "dob-wheel-column h-[108px] w-[57px] shrink-0 snap-y snap-mandatory overflow-y-auto scroll-smooth py-9",
            onKeydown: X[2] || (X[2] = (Y) => B(Y, "day"))
          }, [
            (c(!0), p(Z, null, ke(E.value, (Y, ce) => (c(), te(Qo, {
              key: Y.value,
              type: "Wheel",
              state: q(Y, h.value),
              text: Y.label,
              role: "option",
              class: "snap-center",
              "aria-selected": Y.value === h.value ? "true" : void 0,
              tabindex: ce === T(V).focusedIndex.value ? 0 : -1,
              "aria-label": Y.label,
              onClick: (ne) => _(ce)
            }, null, 8, ["state", "text", "aria-selected", "tabindex", "aria-label", "onClick"]))), 128))
          ], 40, mT)
        ])
      ]),
      _: 1
    }, 8, ["id", "open", "anchor-el", "dialog-label"]));
  }
}), CT = /* @__PURE__ */ He(wT, [["__scopeId", "data-v-f30f2f82"]]), ST = { class: "flex w-full items-center justify-between" }, $T = ["disabled"], IT = /* @__PURE__ */ ge({
  __name: "DatepickerControls",
  props: {
    label: {},
    previousLabel: {},
    nextLabel: {},
    labelDisabled: { type: Boolean, default: !1 },
    previousDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next", "drill-up"],
  setup(e, { emit: t }) {
    const n = t;
    return (r, o) => (c(), p("div", ST, [
      ae($e, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-left": "ri-arrow-left-line",
        "icon-alt": e.previousLabel,
        disabled: e.previousDisabled,
        "data-testid": "datepicker-controls-prev",
        onClick: o[0] || (o[0] = (a) => n("prev"))
      }, null, 8, ["icon-alt", "disabled"]),
      g("button", {
        type: "button",
        "aria-live": "polite",
        disabled: e.labelDisabled,
        class: "font-(--weight-semi-bold) text-(length:--size-m) leading-(--line-height-l) text-(--text-text-heading) dark:text-(--colors-text-white-default) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1 rounded-(--border-border-radius-rounded-sm) cursor-pointer disabled:cursor-not-allowed disabled:opacity-60",
        "data-testid": "datepicker-controls-label",
        onClick: o[1] || (o[1] = (a) => n("drill-up"))
      }, $(e.label), 9, $T),
      ae($e, {
        variant: "ghost",
        size: "xs",
        "icon-only": "",
        "icon-right": "ri-arrow-right-line",
        "icon-alt": e.nextLabel,
        disabled: e.nextDisabled,
        "data-testid": "datepicker-controls-next",
        onClick: o[2] || (o[2] = (a) => n("next"))
      }, null, 8, ["icon-alt", "disabled"])
    ]));
  }
});
function Ji(e) {
  return String(e).padStart(2, "0");
}
function ff(e, t, n) {
  const r = e * 12 + t + n;
  return { year: Math.floor(r / 12), month: (r % 12 + 12) % 12 };
}
function Dp(e, t, n) {
  return `${e}-${Ji(t + 1)}-${Ji(n)}`;
}
function Zi(e, t) {
  return `${e}-${Ji(t + 1)}`;
}
function Qn(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function ru(e, t, n) {
  const { selectedIso: r, todayIso: o, minIso: a, maxIso: l } = t, s = o.substring(0, e.length), i = r !== void 0 ? r.substring(0, e.length) : void 0;
  return a !== void 0 && Qn(e, a) < 0 || l !== void 0 && Qn(e, l) > 0 ? "Disabled" : i !== void 0 && e === i ? "Active" : e === s ? "Today" : n;
}
function TT(e, t, n) {
  const o = (new Date(e, t, 1).getDay() + 6) % 7, a = new Date(e, t, 1 - o), l = [];
  for (let s = 0; s < 42; s++) {
    const i = new Date(a);
    i.setDate(a.getDate() + s);
    const d = Dp(i.getFullYear(), i.getMonth(), i.getDate()), u = i.getMonth() === t && i.getFullYear() === e, f = ru(d, n, "Initial");
    l.push({ iso: d, label: String(i.getDate()), state: f, inMonth: u });
  }
  return l;
}
function LT(e, t, n) {
  return t.map((r, o) => {
    const a = Zi(e, o);
    return { iso: a, label: r, state: ru(a, n, "Initial"), inMonth: !0 };
  });
}
function MT(e, t) {
  return Array.from({ length: 12 }, (n, r) => {
    const o = e + r, a = String(o);
    return { iso: a, label: a, state: ru(a, t, "Initial"), inMonth: !0 };
  });
}
const ET = {
  key: 0,
  class: "flex w-[252px] flex-col"
}, AT = {
  role: "row",
  "data-testid": "datepicker-weekday-header-row",
  class: "mb-1.5 flex items-center"
}, Rp = /* @__PURE__ */ ge({
  __name: "DatepickerDropdownMenu",
  props: {
    open: { type: Boolean, default: !1 },
    modelValue: { default: void 0 },
    anchorEl: {},
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    todayButtonMode: { default: "highlight" },
    mode: { default: "day" },
    showTodayButton: { type: Boolean, default: !0 },
    showClearButton: { type: Boolean, default: !0 },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    dialogLabel: {},
    id: { default: void 0 },
    placement: { default: "bottom-start" },
    keepAnchorFocusable: { type: Boolean, default: !1 },
    autoFocusOnOpen: { type: Boolean, default: !0 }
  },
  emits: ["update:open", "update:modelValue", "select", "clear", "close"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n, a = N(/* @__PURE__ */ new Date()), l = y(() => {
      const z = a.value;
      return `${z.getFullYear()}-${String(z.getMonth() + 1).padStart(2, "0")}-${String(z.getDate()).padStart(2, "0")}`;
    });
    function s() {
      if (r.modelValue) {
        const [z, X, Y] = r.modelValue.split("-").map(Number);
        return { year: z, month: X - 1, day: Y };
      }
      return { year: a.value.getFullYear(), month: a.value.getMonth(), day: a.value.getDate() };
    }
    const i = s(), d = N(i.year), u = N(i.month), f = N(i.day), h = N(r.mode), b = N(a.value.getFullYear() - a.value.getFullYear() % 12), m = y(
      () => TT(d.value, u.value, {
        todayIso: l.value,
        selectedIso: r.modelValue,
        minIso: r.minDate,
        maxIso: r.maxDate
      })
    ), v = y(
      () => {
        var z, X;
        return LT(d.value, r.monthShortLabels, {
          todayIso: l.value,
          selectedIso: r.modelValue,
          minIso: (z = r.minDate) == null ? void 0 : z.slice(0, 7),
          maxIso: (X = r.maxDate) == null ? void 0 : X.slice(0, 7)
        });
      }
    ), x = y(
      () => {
        var z, X;
        return MT(b.value, {
          todayIso: l.value,
          selectedIso: r.modelValue,
          minIso: (z = r.minDate) == null ? void 0 : z.slice(0, 4),
          maxIso: (X = r.maxDate) == null ? void 0 : X.slice(0, 4)
        });
      }
    ), k = y(() => h.value === "month" ? v.value : h.value === "year" ? x.value : m.value), L = y(() => {
      const z = [];
      for (let X = 0; X < 6; X++)
        z.push(
          m.value.slice(X * 7, X * 7 + 7).map((Y, ce) => ({ cell: Y, index: X * 7 + ce }))
        );
      return z;
    }), P = y(() => h.value === "day" ? 7 : h.value === "month" ? 3 : 4), E = y(() => {
      const z = P.value, X = k.value, Y = [];
      for (let ce = 0; ce < X.length; ce += z)
        Y.push(X.slice(ce, ce + z).map((ne, ye) => ({ cell: ne, index: ce + ye })));
      return Y;
    }), O = N(null);
    function R(z) {
      return z.state === "Initial" && O.value === z.iso ? "Hover" : z.state;
    }
    function V(z) {
      const [X, Y] = z.iso.split("-").map(Number), ce = `${r.monthLabels[Y - 1]} ${z.label}, ${X}`;
      return z.state === "Disabled" ? `${ce}, ${r.unavailableLabel}` : ce;
    }
    function J(z) {
      const X = Number(z.iso.split("-")[1]), Y = r.monthLabels[X - 1];
      return z.state === "Disabled" ? `${Y}, ${r.unavailableLabel}` : Y;
    }
    const F = y(() => h.value === "month" ? String(d.value) : h.value === "year" ? `${b.value}-${b.value + 11}` : `${r.monthLabels[u.value]} ${d.value}`), A = y(() => r.mode !== "day" || h.value === "year"), j = y(() => {
      var X;
      if (h.value === "day") {
        if (r.minDate === void 0) return !1;
        const Y = (X = m.value[0]) == null ? void 0 : X.iso;
        return Y !== void 0 && Qn(Y, r.minDate) <= 0;
      }
      if (r.minDate === void 0) return !1;
      const z = Number(r.minDate.slice(0, 4));
      return h.value === "month" ? d.value <= z : b.value <= z;
    }), _ = y(() => {
      var X;
      if (h.value === "day") {
        if (r.maxDate === void 0) return !1;
        const Y = (X = m.value[41]) == null ? void 0 : X.iso;
        return Y !== void 0 && Qn(Y, r.maxDate) >= 0;
      }
      if (r.maxDate === void 0) return !1;
      const z = Number(r.maxDate.slice(0, 4));
      return h.value === "month" ? d.value >= z : b.value + 11 >= z;
    }), U = y(() => {
      var ne, ye;
      const z = r.mode === "month" ? 7 : r.mode === "year" ? 4 : 10, X = l.value.slice(0, z), Y = (ne = r.minDate) == null ? void 0 : ne.slice(0, z), ce = (ye = r.maxDate) == null ? void 0 : ye.slice(0, z);
      return Y !== void 0 && Qn(X, Y) < 0 || ce !== void 0 && Qn(X, ce) > 0;
    });
    async function W() {
      await Pe(), oe(se.value);
    }
    function K() {
      var z;
      return ((z = document.activeElement) == null ? void 0 : z.getAttribute("data-testid")) === "datepicker-cell";
    }
    async function le() {
      if (j.value) return;
      const z = K();
      if (h.value === "day") {
        const { year: X, month: Y } = ff(d.value, u.value, -1);
        d.value = X, u.value = Y;
      } else h.value === "month" ? d.value -= 1 : b.value -= 12;
      z && await W();
    }
    async function C() {
      if (_.value) return;
      const z = K();
      if (h.value === "day") {
        const { year: X, month: Y } = ff(d.value, u.value, 1);
        d.value = X, u.value = Y;
      } else h.value === "month" ? d.value += 1 : b.value += 12;
      z && await W();
    }
    async function B() {
      const z = K();
      if (h.value === "day")
        h.value = "month";
      else if (h.value === "month")
        b.value = d.value - d.value % 12, h.value = "year";
      else
        return;
      z && await W();
    }
    function I() {
      o("clear");
    }
    async function M() {
      if (!U.value) {
        if (r.mode === "month") {
          if (d.value = a.value.getFullYear(), r.todayButtonMode === "select") {
            D(Zi(a.value.getFullYear(), a.value.getMonth()));
            return;
          }
          await Pe(), oe(v.value.findIndex((z) => z.iso === l.value.slice(0, 7)));
          return;
        }
        if (r.mode === "year") {
          if (b.value = a.value.getFullYear() - a.value.getFullYear() % 12, r.todayButtonMode === "select") {
            D(String(a.value.getFullYear()));
            return;
          }
          await Pe(), oe(x.value.findIndex((z) => z.iso === l.value.slice(0, 4)));
          return;
        }
        if (h.value = "day", d.value = a.value.getFullYear(), u.value = a.value.getMonth(), r.todayButtonMode === "select") {
          o("update:modelValue", l.value), o("select", l.value), G();
          return;
        }
        await Pe(), oe(m.value.findIndex((z) => z.iso === l.value));
      }
    }
    function D(z) {
      o("update:modelValue", z), o("select", z), G();
    }
    async function re(z) {
      if (z.state !== "Disabled") {
        if (h.value === "year") {
          if (r.mode === "year") {
            D(z.iso);
            return;
          }
          d.value = Number(z.iso), h.value = "month", await W();
          return;
        }
        if (h.value === "month") {
          if (r.mode === "month") {
            D(z.iso);
            return;
          }
          u.value = Number(z.iso.slice(5)) - 1, h.value = "day", await W();
          return;
        }
        D(z.iso);
      }
    }
    const se = N(0);
    function de() {
      const z = k.value;
      let X;
      if (h.value === "day") {
        const ce = new Date(d.value, u.value + 1, 0).getDate();
        X = Dp(d.value, u.value, Math.min(f.value, ce));
      } else h.value === "month" ? X = Zi(d.value, u.value) : X = String(d.value);
      const Y = z.findIndex((ce) => ce.iso === X);
      se.value = Y >= 0 ? Y : Math.max(z.findIndex((ce) => ce.state !== "Disabled"), 0);
    }
    de(), we([d, u, h, b], de);
    const fe = N(null), q = N(null);
    function oe(z) {
      var X, Y;
      if (se.value = z, h.value === "day") {
        const ce = m.value[z];
        ce && (f.value = Number(ce.iso.slice(8, 10)));
      }
      (Y = (X = fe.value) == null ? void 0 : X.querySelectorAll('[data-testid="datepicker-cell"]')[z]) == null || Y.focus({ preventScroll: !0 });
    }
    function ue(z) {
      const X = k.value, Y = X.length, ce = se.value, ne = P.value, ye = ce - ce % ne;
      switch (z.key) {
        case "ArrowRight":
          z.preventDefault(), ce < Y - 1 && oe(ce + 1);
          break;
        case "ArrowLeft":
          z.preventDefault(), ce > 0 && oe(ce - 1);
          break;
        case "ArrowDown":
          z.preventDefault(), ce + ne < Y && oe(ce + ne);
          break;
        case "ArrowUp":
          z.preventDefault(), ce - ne >= 0 && oe(ce - ne);
          break;
        case "Home":
          z.preventDefault(), oe(ye);
          break;
        case "End":
          z.preventDefault(), oe(Math.min(ye + ne - 1, Y - 1));
          break;
        case "PageUp":
          h.value === "day" && (z.preventDefault(), le());
          break;
        case "PageDown":
          h.value === "day" && (z.preventDefault(), C());
          break;
        case "Enter":
        case " ":
          z.preventDefault(), re(X[ce]);
          break;
      }
    }
    function G() {
      o("update:open", !1), o("close");
    }
    we(
      () => r.open,
      (z) => {
        if (z) {
          a.value = /* @__PURE__ */ new Date(), h.value = r.mode;
          const X = s();
          d.value = X.year, u.value = X.month, f.value = X.day, b.value = X.year - X.year % 12, r.autoFocusOnOpen && Pe(() => oe(se.value));
        } else
          O.value = null;
      },
      { immediate: !0 }
    ), we(h, async () => {
      var z;
      await Pe(), (z = q.value) == null || z.updatePosition();
    });
    async function H() {
      const z = s();
      d.value = z.year, u.value = z.month, f.value = z.day, b.value = z.year - z.year % 12, await Pe(), oe(se.value);
    }
    return t({ focusGrid: H }), (z, X) => (c(), te(Ap, {
      id: e.id,
      ref_key: "panelComponent",
      ref: q,
      open: e.open,
      "anchor-el": e.anchorEl,
      "dialog-label": e.dialogLabel,
      "test-id": "datepicker-dropdown-menu",
      "width-class": "w-[292px]",
      placement: e.placement,
      "keep-anchor-focusable": e.keepAnchorFocusable,
      "onUpdate:open": X[2] || (X[2] = (Y) => o("update:open", Y)),
      onClose: X[3] || (X[3] = (Y) => o("close"))
    }, zn({
      default: pe(() => [
        g("div", {
          ref_key: "contentRef",
          ref: fe,
          class: "contents"
        }, [
          ae(IT, {
            label: F.value,
            "previous-label": e.previousLabel,
            "next-label": e.nextLabel,
            "label-disabled": A.value,
            "previous-disabled": j.value,
            "next-disabled": _.value,
            onPrev: le,
            onNext: C,
            onDrillUp: B
          }, null, 8, ["label", "previous-label", "next-label", "label-disabled", "previous-disabled", "next-disabled"]),
          h.value === "day" ? (c(), p("div", ET, [
            g("div", {
              role: "grid",
              class: "flex flex-col gap-0.5",
              onKeydown: ue
            }, [
              g("div", AT, [
                (c(!0), p(Z, null, ke(e.weekdayLabels, (Y, ce) => (c(), p("span", {
                  key: ce,
                  role: "columnheader",
                  "data-testid": "datepicker-weekday-header",
                  class: "w-9 flex-1 text-center text-(length:--size-sm) font-(--weight-medium) text-(--text-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                }, $(Y), 1))), 128))
              ]),
              (c(!0), p(Z, null, ke(L.value, (Y, ce) => (c(), p("div", {
                key: ce,
                role: "row",
                "data-testid": "datepicker-day-row",
                class: "flex items-center"
              }, [
                (c(!0), p(Z, null, ke(Y, ({ cell: ne, index: ye }) => (c(), te(Qo, {
                  key: ne.iso,
                  type: "Day",
                  state: R(ne),
                  text: ne.label,
                  muted: !ne.inMonth,
                  role: "gridcell",
                  tabindex: ye === se.value ? 0 : -1,
                  "aria-selected": ne.state === "Active" ? "true" : void 0,
                  "aria-label": V(ne),
                  onClick: (he) => re(ne),
                  onMouseover: (he) => O.value = ne.iso,
                  onMouseout: X[0] || (X[0] = (he) => O.value = null)
                }, null, 8, ["state", "text", "muted", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
              ]))), 128))
            ], 32)
          ])) : (c(), p("div", {
            key: 1,
            role: "grid",
            class: "flex w-[252px] flex-col gap-1.5",
            onKeydown: ue
          }, [
            (c(!0), p(Z, null, ke(E.value, (Y, ce) => (c(), p("div", {
              key: ce,
              role: "row",
              "data-testid": "datepicker-grid-row",
              class: "flex gap-1.5"
            }, [
              (c(!0), p(Z, null, ke(Y, ({ cell: ne, index: ye }) => (c(), te(Qo, {
                key: ne.iso,
                type: h.value === "month" ? "Month" : "Year",
                state: R(ne),
                text: ne.label,
                role: "gridcell",
                tabindex: ye === se.value ? 0 : -1,
                "aria-selected": ne.state === "Active" ? "true" : void 0,
                "aria-label": h.value === "month" ? J(ne) : ne.state === "Disabled" ? `${ne.label}, ${e.unavailableLabel}` : ne.label,
                onClick: (he) => re(ne),
                onMouseover: (he) => O.value = ne.iso,
                onMouseout: X[1] || (X[1] = (he) => O.value = null)
              }, null, 8, ["type", "state", "text", "tabindex", "aria-selected", "aria-label", "onClick", "onMouseover"]))), 128))
            ]))), 128))
          ], 32))
        ], 512)
      ]),
      _: 2
    }, [
      e.showClearButton || e.showTodayButton ? {
        name: "actions",
        fn: pe(() => [
          e.showClearButton ? (c(), te($e, {
            key: 0,
            variant: "secondary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.clearLabel,
            "data-testid": "datepicker-dropdown-menu-clear",
            onClick: I
          }, null, 8, ["label"])) : w("", !0),
          e.showTodayButton ? (c(), te($e, {
            key: 1,
            variant: "primary",
            size: "sm",
            class: "flex-1",
            "full-width": "",
            label: e.todayLabel,
            disabled: U.value,
            "data-testid": "datepicker-dropdown-menu-today",
            onClick: M
          }, null, 8, ["label", "disabled"])) : w("", !0)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "open", "anchor-el", "dialog-label", "placement", "keep-anchor-focusable"]));
  }
}), DT = {
  en: "mm/yyyy",
  fr: "mm/yyyy",
  nl: "mm-yyyy"
};
function RT(e) {
  return e ?? "";
}
function BT(e) {
  return /^\d{4}$/.test(e) ? e : void 0;
}
function Bp(e) {
  return e.replace(/[my]/g, "");
}
function OT(e, t) {
  if (!e) return "";
  const [n, r] = e.split("-");
  return `${r}${Bp(t)}${n}`;
}
function PT(e, t) {
  const n = Bp(t), [r, o] = e.split(n);
  if (!r || !o || !/^\d{2}$/.test(r) || !/^\d{4}$/.test(o)) return;
  const a = Number(r);
  if (!(a < 1 || a > 12))
    return `${o}-${r}`;
}
function En(e, t) {
  if (!e) return "";
  const [n, r, o] = e.split("-");
  return !n || !r || !o ? "" : t.replace(/y+/, n).replace(/m+/, r).replace(/d+/, o);
}
function zT(e) {
  const t = e.match(/([dmy])\1*|[^dmy]+/g) ?? [], n = [];
  let r = "^";
  for (const a of t)
    /^[dmy]+$/.test(a) ? (n.push({ field: a[0], length: a.length }), r += a.length > 1 ? `(\\d{${a.length}})` : "(\\d{1,2})") : r += a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  r += "$";
  const o = n.map((a) => a.field);
  if (o.filter((a) => a === "d").length === 1 && o.filter((a) => a === "m").length === 1 && o.filter((a) => a === "y").length === 1)
    return { tokens: n, regex: new RegExp(r) };
}
function Gr(e, t) {
  const n = zT(t);
  if (!n) return;
  const r = n.regex.exec(e);
  if (!r) return;
  let o, a, l;
  if (n.tokens.forEach((i, d) => {
    const u = Number(r[d + 1]);
    i.field === "d" ? o = u : i.field === "m" ? a = u : l = u;
  }), o === void 0 || a === void 0 || l === void 0 || a < 1 || a > 12) return;
  const s = new Date(l, a, 0).getDate();
  if (!(o < 1 || o > s))
    return `${String(l).padStart(4, "0")}-${String(a).padStart(2, "0")}-${String(o).padStart(2, "0")}`;
}
const NT = {
  fr: {
    weekdayLabels: ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."],
    monthLabels: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    monthShortLabels: [
      "janv.",
      "févr.",
      "mars",
      "avril",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    clearLabel: "Effacer",
    todayLabel: "Aujourd'hui",
    previousLabel: "Mois précédent",
    nextLabel: "Mois suivant",
    unavailableLabel: "Indisponible",
    dialogLabel: "Choisir une date"
  },
  nl: {
    weekdayLabels: ["ma", "di", "wo", "do", "vr", "za", "zo"],
    monthLabels: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    monthShortLabels: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    clearLabel: "Wissen",
    todayLabel: "Vandaag",
    previousLabel: "Vorige maand",
    nextLabel: "Volgende maand",
    unavailableLabel: "Niet beschikbaar",
    dialogLabel: "Kies een datum"
  }
}, VT = ["id", "for"], FT = { class: "flex items-center gap-0.5" }, HT = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)" }, WT = {
  key: 0,
  "aria-hidden": "true",
  class: "relative leading-5 font-medium"
}, jT = ["id"], UT = ["id", "name", "inputmode", "value", "placeholder", "disabled", "readonly", "autocomplete", "aria-labelledby", "aria-disabled", "aria-invalid", "aria-describedby", "aria-required", "aria-expanded", "aria-controls", "data-testid"], GT = ["id"], Yi = /* @__PURE__ */ ge({
  __name: "DatePickerInput",
  props: {
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    placeholder: { default: void 0 },
    format: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    autohide: { type: Boolean, default: !0 },
    buttons: { type: Boolean, default: !0 },
    orientation: { default: "auto" },
    weekStart: { default: 1 },
    language: { default: "en" },
    title: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    error: { default: void 0 },
    hint: { default: void 0 },
    showHint: { type: Boolean, default: !0 },
    labelInline: { type: Boolean, default: !1 },
    id: { default: void 0 },
    name: { default: void 0 },
    autocomplete: { default: void 0 },
    testId: { default: void 0 },
    maskInput: { type: Boolean, default: !0 },
    readonly: { type: Boolean, default: !1 },
    type: { default: "default" },
    dobLabels: { default: void 0 },
    dobDefaultDate: { default: void 0 },
    labels: { default: void 0 }
  },
  emits: ["update:modelValue", "changeDate", "show", "hide"],
  setup(e, { emit: t }) {
    var Fr;
    const n = {
      weekdayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      monthLabels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      monthShortLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      clearLabel: "Clear",
      todayLabel: "Today",
      previousLabel: "Previous month",
      nextLabel: "Next month",
      unavailableLabel: "Unavailable",
      dialogLabel: "Choose date"
    }, r = e, o = t, a = N(null);
    let l = null, s = null, i = 0;
    const d = N(!1), u = N(!1), f = N(r.modelValue), h = y(() => r.modelValue !== void 0 && r.modelValue !== null && r.modelValue.trim() !== ""), b = y(() => !!r.error), m = Ke(), v = y(() => r.id || m), x = y(() => r.label ? `${v.value}-label` : void 0), k = y(() => `${v.value}-error`), L = y(() => `${v.value}-hint`), P = y(() => r.language.slice(0, 2).toLowerCase()), E = {
      en: "mm/dd/yyyy",
      fr: "dd/mm/yyyy",
      nl: "dd-mm-yyyy"
    }, O = y(() => r.format !== void 0 ? r.format : E[P.value] ?? "dd/mm/yyyy"), R = y(
      () => r.labels ?? NT[P.value] ?? n
    );
    r.type === "dob" && (f.value = En(r.modelValue, O.value));
    const V = y(
      () => r.minDate ? Gr(r.minDate, O.value) ?? r.minDate : void 0
    ), J = y(
      () => r.maxDate ? Gr(r.maxDate, O.value) ?? r.maxDate : void 0
    ), F = y(
      () => r.maskInput ? Ip(O.value) : null
    ), A = {
      fr: { d: "j", y: "a" },
      // jour / année
      nl: { y: "j" }
      // jaar
    }, j = y(() => {
      const Me = A[P.value];
      return Me ? O.value.replace(/d+|m+|y+/g, (De) => {
        const dt = Me[De[0]];
        return dt ? dt.repeat(De.length) : De;
      }) : O.value;
    }), _ = y(() => {
      var De;
      const Me = (De = r.hint) == null ? void 0 : De.trim();
      return Me && Me.length > 0 ? Me : j.value;
    }), U = y(() => {
      var De;
      const Me = (De = r.placeholder) == null ? void 0 : De.trim();
      return Me && Me.length > 0 ? Me : j.value;
    }), W = y(() => {
      const Me = [];
      return r.showHint && _.value && Me.push(L.value), b.value && Me.push(k.value), Me.length > 0 ? Me.join(" ") : void 0;
    }), K = y(() => b.value ? "true" : void 0), le = y(() => {
      const Me = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (r.disabled)
        return `${Me} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (r.readonly) {
        const $t = d.value ? "shadow-[0px_0px_2px_var(--border-border-accent)] border-(--border-border-accent)" : "shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] border-(--border-border-base-soft) dark:border-(--border-border-base)";
        return `${Me} border-[1px] ${$t} bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) text-(--text-text-black-default) dark:text-(--text-text-white-default) cursor-default`;
      }
      if (b.value)
        return `${Me} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (d.value)
        return `${Me} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      if (u.value)
        return `${Me} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)`;
      const De = h.value ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)";
      return `${Me} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${De} dark:text-(--text-text-white-default)`;
    }), B = {
      sm: {
        container: "h-[32px] px-2 py-1.5 gap-2",
        text: "text-sm leading-5"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5"
      },
      lg: {
        container: "h-[48px] px-3.5 py-3 gap-2",
        text: "text-base leading-6"
      },
      xl: {
        container: "h-[52px] px-4 py-3.5 gap-2",
        text: "text-base leading-6"
      }
    }[r.size], I = y(() => r.fullWidth ? "w-full" : ""), M = y(() => r.fullWidth ? {} : { width: r.width }), D = y(() => {
      const Me = "relative flex pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter";
      return r.labelInline ? `${Me} flex-row items-center gap-2${r.fullWidth ? " w-full" : ""}` : `${Me} flex-col items-start gap-0.5${r.fullWidth ? " w-full" : ""}`;
    }), re = y(() => r.fullWidth || r.labelInline ? {} : { width: r.width }), se = () => {
      r.disabled || (u.value = !0);
    }, de = () => {
      u.value = !1;
    }, fe = () => {
      r.disabled || (d.value = !0);
    }, q = () => {
      if (d.value = !1, !a.value) return;
      const Me = r.type === "dob" ? En(r.modelValue, O.value) : r.modelValue;
      f.value = Me, l && (l.value = Me ?? "");
    };
    function oe(Me) {
      if (Me === "") {
        r.modelValue && o("update:modelValue", "");
        return;
      }
      const De = Gr(Me, O.value);
      De !== void 0 && De !== r.modelValue && o("update:modelValue", De);
    }
    const ue = () => {
      if (!s || !a.value || F.value === null) return;
      G();
      const Me = r.type === "dob" ? En(r.modelValue, O.value) || a.value.value : r.modelValue || a.value.value;
      l = s(a.value, { mask: F.value, lazy: !0 }), l.value = Me ?? "", l.on("accept", () => {
        if (!l) return;
        if (r.readonly || r.disabled) {
          const $t = r.type === "dob" ? En(r.modelValue, O.value) : r.modelValue ?? "";
          l.value = $t, f.value = $t;
          return;
        }
        const De = l.value;
        if (f.value = De, r.type === "dob") {
          oe(De);
          return;
        }
        (De === "" || Gr(De, O.value) !== void 0) && De !== r.modelValue && o("update:modelValue", De);
      });
    }, G = () => {
      l == null || l.destroy(), l = null;
    };
    Qe(async () => {
      if (a.value && F.value !== null) {
        const Me = ++i;
        if (s = (await import("./index-CZ98n4Cf.js")).default, !a.value || Me !== i) return;
        ue();
      }
    }), nt(() => {
      G();
    });
    const H = (Me) => {
      if (l) return;
      const De = Me.target.value;
      if (f.value = De, r.type === "dob") {
        oe(De);
        return;
      }
      o("update:modelValue", De);
    };
    we(
      () => r.modelValue,
      (Me) => {
        if (d.value) return;
        const De = r.type === "dob" ? En(Me, O.value) : Me;
        f.value = De, a.value && l && (l.value = De ?? "");
      }
    ), we(F, async (Me) => {
      const De = ++i;
      G(), Me !== null && (s || (s = (await import("./index-CZ98n4Cf.js")).default), De === i && ue());
    }), we([O, P], ([Me], [De]) => {
      if (r.type === "dob" && !d.value) {
        const dt = En(r.modelValue, Me);
        f.value = dt, l && (l.value = dt);
      }
      if (r.type === "default" && !d.value && Me !== De) {
        const dt = Gr(f.value, De);
        if (dt !== void 0) {
          const $t = En(dt, Me);
          f.value = $t, l && (l.value = $t);
        }
      }
    });
    const z = N(!1), X = N(!1), Y = y(() => `${v.value}-dob-dialog`), ce = N(null), ne = typeof process < "u" && ((Fr = process.env) == null ? void 0 : Fr.NODE_ENV) !== "production";
    function ye() {
      if (!(r.type !== "dob" || r.disabled || r.readonly) && !z.value) {
        if (!r.dobLabels) {
          ne && console.error(
            '[OPAL DatePickerInput] type="dob" requires the `dobLabels` prop (see DatepickerDobLabels) — the wheel picker was not opened.'
          );
          return;
        }
        z.value = !0, X.value = !0, o("show");
      }
    }
    function he(Me) {
      f.value = En(Me, O.value), l ? l.value = f.value : o("update:modelValue", Me), o("changeDate", Me);
    }
    function ie() {
      f.value = "", l ? l.value = "" : o("update:modelValue", ""), o("changeDate", "");
    }
    function me() {
      var Me;
      z.value = !1, o("hide"), (Me = a.value) == null || Me.focus();
    }
    const Q = N(!1), ee = N(!1), ve = y(() => `${v.value}-default-dialog`), Le = N(null), We = N(!0), qe = y(() => Gr(f.value, O.value) ?? ""), fn = y(() => {
      const Me = r.orientation.includes("right") ? "end" : "start";
      return `${r.orientation.includes("top") ? "top" : "bottom"}-${Me}`;
    });
    function hn() {
      r.type !== "default" || r.disabled || r.readonly || Q.value || (Q.value = !0, ee.value = !0, o("show"));
    }
    function Et(Me) {
      const De = En(Me, O.value);
      f.value = De, l ? l.value = De : o("update:modelValue", De), o("changeDate", De);
    }
    function At() {
      f.value = "", l ? l.value = "" : o("update:modelValue", ""), o("changeDate", "");
    }
    function In() {
      var Me;
      Q.value = !1, o("hide"), (Me = a.value) == null || Me.focus();
    }
    function bn() {
      r.type === "dob" ? ye() : hn();
    }
    let br = !1;
    function bt() {
      br = r.type === "dob" ? z.value : Q.value;
    }
    function Hn() {
      var De;
      if (r.disabled || r.readonly) return;
      const Me = br;
      br = !1, !Me && (We.value = !1, bn(), (De = a.value) == null || De.focus());
    }
    function Wn() {
      const Me = /* @__PURE__ */ new Date();
      return `${Me.getFullYear()}-${String(Me.getMonth() + 1).padStart(2, "0")}-${String(Me.getDate()).padStart(2, "0")}`;
    }
    function La(Me) {
      var De, dt;
      if (!(r.disabled || r.readonly)) {
        if (Me.key === "Enter") {
          z.value ? me() : Q.value && In();
          const $t = Wn(), $s = (V.value === void 0 || Qn($t, V.value) >= 0) && (J.value === void 0 || Qn($t, J.value) <= 0);
          (f.value ?? "").trim() === "" && $s && (r.type === "dob" ? he($t) : Et($t));
          return;
        }
        if (Me.key === "ArrowDown") {
          if (Me.preventDefault(), z.value) {
            (De = ce.value) == null || De.focusYearColumn();
            return;
          }
          if (Q.value) {
            (dt = Le.value) == null || dt.focusGrid();
            return;
          }
          We.value = !0, bn();
        }
      }
    }
    return (Me, De) => (c(), p("div", {
      class: S(D.value),
      style: Ae(re.value),
      "data-testid": "date-picker-wrapper"
    }, [
      e.label ? (c(), p("label", {
        key: 0,
        id: x.value,
        for: v.value,
        class: S([
          "flex items-center text-text-black-default dark:text-(--colors-text-white-default)",
          e.labelInline ? "shrink-0" : "order-1"
        ])
      }, [
        g("div", FT, [
          g("div", HT, $(e.label), 1),
          e.required ? (c(), p("span", WT, $(e.requiredIndicator), 1)) : w("", !0)
        ])
      ], 10, VT)) : w("", !0),
      g("div", {
        class: S(e.labelInline ? "flex flex-col gap-0.5" : "contents")
      }, [
        e.showHint && _.value ? (c(), p("div", {
          key: 0,
          id: L.value,
          class: "order-3 flex items-center gap-1 text-xs text-(--text-text-body)",
          "data-testid": "date-picker-hint"
        }, [
          De[2] || (De[2] = g("i", {
            "aria-hidden": "true",
            class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)"
          }, null, -1)),
          g("span", null, $(_.value), 1)
        ], 8, jT)) : w("", !0),
        g("div", {
          class: S([le.value, T(B).container, I.value, "order-2"]),
          style: Ae(M.value),
          "data-testid": "date-picker-container",
          onMouseenter: se,
          onMouseleave: de,
          onMousedown: bt,
          onClick: Hn
        }, [
          g("i", {
            "aria-hidden": "true",
            "data-testid": "date-picker-calendar-icon",
            class: S([
              "ri-calendar-line",
              T(B).text,
              e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
            ])
          }, null, 2),
          g("input", {
            id: v.value,
            ref_key: "inputRef",
            ref: a,
            name: e.name,
            type: "text",
            inputmode: F.value ? "numeric" : void 0,
            value: f.value,
            placeholder: U.value,
            disabled: e.disabled,
            readonly: e.readonly,
            autocomplete: e.autocomplete ?? "off",
            "aria-labelledby": x.value,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-invalid": K.value,
            "aria-describedby": W.value,
            "aria-required": e.required ? "true" : void 0,
            role: "combobox",
            "aria-haspopup": "dialog",
            "aria-expanded": e.type === "dob" ? z.value : Q.value,
            "aria-controls": e.type === "dob" ? X.value ? Y.value : void 0 : ee.value ? ve.value : void 0,
            "data-testid": e.testId ?? "date-picker-input",
            class: S([
              "flex-1 min-w-0 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 forced-colors:focus-visible:outline forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) pl-0",
              !e.disabled && !e.readonly && "cursor-text",
              T(B).text
            ]),
            onFocus: fe,
            onBlur: q,
            onInput: H,
            onKeydown: La
          }, null, 42, UT)
        ], 38),
        e.error ? (c(), p("div", {
          key: 1,
          id: k.value,
          class: "order-4 flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          De[3] || (De[3] = g("i", {
            "aria-hidden": "true",
            class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)"
          }, null, -1)),
          g("span", null, $(e.error), 1)
        ], 8, GT)) : w("", !0)
      ], 2),
      e.type === "dob" && a.value && X.value ? (c(), te(CT, Je({
        key: 1,
        ref_key: "dobPickerRef",
        ref: ce
      }, e.dobLabels, {
        id: Y.value,
        open: z.value,
        "model-value": e.modelValue,
        "anchor-el": a.value,
        "auto-focus-on-open": We.value,
        "min-date": V.value,
        "max-date": J.value,
        "default-date": e.dobDefaultDate,
        "onUpdate:open": De[0] || (De[0] = (dt) => z.value = dt),
        "onUpdate:modelValue": he,
        onClear: ie,
        onClose: me
      }), null, 16, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "default-date"])) : w("", !0),
      e.type === "default" && a.value && ee.value ? (c(), te(Rp, {
        key: 2,
        ref_key: "defaultDropdownMenuRef",
        ref: Le,
        id: ve.value,
        open: Q.value,
        "model-value": qe.value,
        "anchor-el": a.value,
        "keep-anchor-focusable": "",
        "auto-focus-on-open": We.value,
        "min-date": V.value,
        "max-date": J.value,
        "today-button-mode": "select",
        "show-today-button": e.buttons,
        "show-clear-button": e.buttons,
        placement: fn.value,
        "weekday-labels": R.value.weekdayLabels,
        "month-labels": R.value.monthLabels,
        "month-short-labels": R.value.monthShortLabels,
        "clear-label": R.value.clearLabel,
        "today-label": R.value.todayLabel,
        "previous-label": R.value.previousLabel,
        "next-label": R.value.nextLabel,
        "unavailable-label": R.value.unavailableLabel,
        "dialog-label": R.value.dialogLabel,
        "onUpdate:open": De[1] || (De[1] = (dt) => Q.value = dt),
        "onUpdate:modelValue": Et,
        onClear: At,
        onClose: In
      }, null, 8, ["id", "open", "model-value", "anchor-el", "auto-focus-on-open", "min-date", "max-date", "show-today-button", "show-clear-button", "placement", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : w("", !0)
    ], 6));
  }
}), qT = { class: "relative flex flex-col items-start gap-0.5 text-left text-(length:--size-m) font-inter" }, KT = ["id", "for"], JT = { class: "relative leading-(--line-height-l) font-(--weight-medium)" }, ZT = {
  key: 0,
  "aria-hidden": "true",
  class: "relative leading-(--line-height-l) font-(--weight-medium)"
}, YT = ["id", "inputmode", "value", "disabled", "aria-labelledby", "aria-required", "aria-expanded", "data-testid"], bV = /* @__PURE__ */ ge({
  __name: "YearMonthPickerInput",
  props: {
    type: {},
    modelValue: { default: "" },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    showTodayButton: { type: Boolean, default: !1 },
    todayButtonMode: { default: "highlight" },
    weekdayLabels: {},
    monthLabels: {},
    monthShortLabels: {},
    clearLabel: {},
    todayLabel: {},
    previousLabel: {},
    nextLabel: {},
    unavailableLabel: {},
    dialogLabel: {},
    testId: { default: void 0 }
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => n.language.slice(0, 2).toLowerCase()), a = y(() => DT[o.value] ?? "mm/yyyy"), l = y(() => n.type === "year" ? "yyyy" : a.value), s = y(() => Ip(l.value));
    function i(C) {
      return n.type === "year" ? RT(C) : OT(C, a.value);
    }
    function d(C) {
      return n.type === "year" ? BT(C) : PT(C, a.value);
    }
    const u = N(null), f = N(null), h = N(!1), b = N(!1), m = N(i(n.modelValue));
    let v = null, x = null, k = 0;
    function L() {
      v == null || v.destroy(), v = null;
    }
    function P() {
      !x || !u.value || s.value === null || (L(), v = x(u.value, { mask: s.value, lazy: !0 }), v.value = m.value, v.on("accept", () => {
        if (!v) return;
        const C = v.value;
        if (m.value = C, C === "") {
          n.modelValue !== "" && r("update:modelValue", "");
          return;
        }
        const B = d(C);
        B !== void 0 && B !== n.modelValue && r("update:modelValue", B);
      }));
    }
    Qe(async () => {
      if (!u.value || s.value === null) return;
      const C = ++k;
      x = (await import("./index-CZ98n4Cf.js")).default, !(!u.value || C !== k) && P();
    }), nt(() => {
      L();
    }), we(
      () => n.modelValue,
      (C) => {
        if (b.value) return;
        const B = i(C);
        m.value = B, v && (v.value = B);
      }
    ), we([s], async () => {
      const C = ++k;
      L(), s.value !== null && (x || (x = (await import("./index-CZ98n4Cf.js")).default), C === k && P());
    });
    function E() {
      n.disabled || (b.value = !0);
    }
    function O() {
      b.value = !1;
      const C = i(n.modelValue);
      m.value = C, v && (v.value = C);
    }
    function R(C) {
      if (v) return;
      const B = C.target.value;
      m.value = B;
      const I = d(B);
      I !== void 0 && r("update:modelValue", I);
    }
    function V() {
      n.disabled || (h.value = !0);
    }
    function J(C) {
      C.key !== "Enter" && C.key !== " " && C.key !== "ArrowDown" || (C.preventDefault(), V());
    }
    function F(C) {
      r("select", C);
    }
    function A() {
      var C;
      (C = u.value) == null || C.focus();
    }
    const _ = Ke(), U = y(() => n.label ? `${_}-label` : void 0), W = `${_}-dialog`, K = y(
      () => n.disabled ? "border-border-disabled-subtle bg-gainsboro-200 dark:border-(--colors-border-disabled-subtle) dark:bg-(--colors-background-disabled)" : "border-(--border-border-base-medium) bg-(--background-background-white) dark:border-(--border-border-base) dark:bg-(--background-background-black-default)"
    ), le = y(
      () => n.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
    );
    return (C, B) => (c(), p("div", qT, [
      e.label ? (c(), p("label", {
        key: 0,
        id: U.value,
        for: T(_),
        class: "flex items-center text-text-black-default dark:text-(--colors-text-white-default)"
      }, [
        g("span", JT, $(e.label), 1),
        e.required ? (c(), p("span", ZT, "*")) : w("", !0)
      ], 8, KT)) : w("", !0),
      g("div", {
        ref_key: "triggerRef",
        ref: f,
        class: S([
          "relative flex h-[36px] items-center gap-2 rounded-xl border-[1px] border-solid px-3 py-2",
          K.value
        ])
      }, [
        g("i", {
          "aria-hidden": "true",
          class: S(["ri-calendar-line text-sm", le.value])
        }, null, 2),
        g("input", {
          id: T(_),
          ref_key: "inputRef",
          ref: u,
          type: "text",
          inputmode: s.value ? "numeric" : void 0,
          value: m.value,
          disabled: e.disabled,
          "aria-labelledby": U.value,
          "aria-required": e.required ? "true" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": h.value,
          "aria-controls": W,
          "data-testid": e.testId ?? "year-month-picker-input",
          class: "min-w-0 flex-1 border-0 bg-transparent text-(length:--size-m) leading-(--line-height-l) outline-none placeholder:text-text-body-subtle focus:outline-none focus:ring-0",
          onFocus: E,
          onBlur: O,
          onInput: R,
          onClick: V,
          onKeydown: J
        }, null, 40, YT)
      ], 2),
      f.value ? (c(), te(Rp, {
        key: 1,
        open: h.value,
        "onUpdate:open": B[0] || (B[0] = (I) => h.value = I),
        id: W,
        "model-value": e.modelValue,
        "anchor-el": f.value,
        mode: e.type,
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "show-today-button": e.showTodayButton,
        "today-button-mode": e.todayButtonMode,
        "weekday-labels": e.weekdayLabels,
        "month-labels": e.monthLabels,
        "month-short-labels": e.monthShortLabels,
        "clear-label": e.clearLabel,
        "today-label": e.todayLabel,
        "previous-label": e.previousLabel,
        "next-label": e.nextLabel,
        "unavailable-label": e.unavailableLabel,
        "dialog-label": e.dialogLabel,
        "onUpdate:modelValue": B[1] || (B[1] = (I) => r("update:modelValue", I)),
        onSelect: F,
        onClear: B[2] || (B[2] = (I) => r("update:modelValue", "")),
        onClose: A
      }, null, 8, ["open", "model-value", "anchor-el", "mode", "min-date", "max-date", "show-today-button", "today-button-mode", "weekday-labels", "month-labels", "month-short-labels", "clear-label", "today-label", "previous-label", "next-label", "unavailable-label", "dialog-label"])) : w("", !0)
    ]));
  }
}), XT = {
  class: "flex flex-col gap-0.5 pb-0.5",
  "data-testid": "date-range-wrapper"
}, QT = {
  key: 0,
  class: "flex items-center text-text-black-default dark:text-(--colors-text-white-default)"
}, _T = { class: "flex items-center gap-0.5" }, e3 = { class: "relative text-sm leading-5 font-medium dark:text-(--colors-text-white-default)" }, t3 = {
  key: 0,
  class: "relative text-sm leading-5 font-medium"
}, n3 = ["value", "placeholder", "disabled"], r3 = {
  key: 0,
  class: "flex items-center text-text-black-default dark:text-(--colors-text-white-default)"
}, o3 = { class: "flex items-center gap-0.5" }, a3 = { class: "relative text-sm leading-5 font-medium dark:text-(--colors-text-white-default)" }, l3 = {
  key: 0,
  class: "relative text-sm leading-5 font-medium"
}, s3 = ["value", "placeholder", "disabled"], i3 = { class: "min-h-4.5 flex flex-col gap-px" }, d3 = {
  key: 0,
  class: "flex items-center gap-1 text-xs text-(--text-text-body)"
}, u3 = {
  key: 1,
  class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, c3 = /* @__PURE__ */ ge({
  __name: "DateRangePickerInput",
  props: {
    startDate: { default: "" },
    endDate: { default: "" },
    startLabel: { default: "From" },
    endLabel: { default: "To" },
    startPlaceholder: { default: "Select date start" },
    endPlaceholder: { default: "Select date end" },
    required: { type: Boolean, default: !1 },
    format: { default: "mm/dd/yyyy" },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    buttons: { type: Boolean, default: !0 },
    weekStart: { default: 1 },
    language: { default: "en" },
    disabled: { type: Boolean, default: !1 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 }
  },
  emits: ["update:startDate", "update:endDate", "changeDate"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(null), a = N(null), l = N(null);
    let s = null;
    const i = N(!1), d = N(!1), u = N(!1), f = N(!1), h = y(() => !!n.error), b = (F, A, j) => {
      const _ = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      return n.disabled ? `${_} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : h.value ? `${_} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : F || A ? `${_} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-(--text-text-black-default) dark:text-(--text-text-white-default)` : `${_} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base) ${j ? "text-(--text-text-black-default)" : "text-(--text-text-body-subtle)"} dark:text-(--text-text-white-default)`;
    }, m = y(
      () => b(i.value, d.value, !!n.startDate)
    ), v = y(
      () => b(u.value, f.value, !!n.endDate)
    ), k = {
      sm: { container: "h-[32px] px-2 py-1.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 py-3 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 py-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }[n.size], L = y(
      () => n.fullWidth ? "flex flex-col items-start gap-0.5 flex-1 min-w-0" : "flex flex-col items-start gap-0.5"
    ), P = y(() => n.fullWidth ? "w-full" : "w-[180px]"), E = y(
      () => n.fullWidth ? "flex flex-row gap-4 w-full" : "flex flex-row gap-4"
    );
    Qe(async () => {
      var j, _;
      if (!o.value) return;
      const { default: F } = await import("./DateRangePicker.esm-DCru_iTB.js");
      if (!o.value) return;
      const A = {
        format: n.format,
        todayBtn: n.buttons,
        clearBtn: n.buttons,
        todayBtnMode: 1,
        weekStart: n.weekStart,
        language: n.language,
        todayHighlight: !0,
        allowOneSidedRange: !0
      };
      n.minDate && (A.minDate = n.minDate), n.maxDate && (A.maxDate = n.maxDate), s = new F(o.value, A), n.startDate && s.datepickers[0].setDate(n.startDate), n.endDate && s.datepickers[1].setDate(n.endDate), (j = a.value) == null || j.addEventListener("changeDate", O), (_ = l.value) == null || _.addEventListener("changeDate", R);
    }), nt(() => {
      var F, A;
      (F = a.value) == null || F.removeEventListener("changeDate", O), (A = l.value) == null || A.removeEventListener("changeDate", R), s && (s.destroy(), s = null);
    });
    const O = () => {
      var A;
      if (!a.value) return;
      const F = a.value.value;
      r("update:startDate", F), r("changeDate", { startDate: F, endDate: ((A = l.value) == null ? void 0 : A.value) ?? "" });
    }, R = () => {
      var A;
      if (!l.value) return;
      const F = l.value.value;
      r("update:endDate", F), r("changeDate", { startDate: ((A = a.value) == null ? void 0 : A.value) ?? "", endDate: F });
    }, V = () => {
      var F;
      s && s.datepickers[0].setDate({ clear: !0 }), r("update:startDate", ""), r("changeDate", { startDate: "", endDate: ((F = l.value) == null ? void 0 : F.value) ?? "" });
    }, J = () => {
      var F;
      s && s.datepickers[1].setDate({ clear: !0 }), r("update:endDate", ""), r("changeDate", { startDate: ((F = a.value) == null ? void 0 : F.value) ?? "", endDate: "" });
    };
    return we(
      () => n.startDate,
      (F) => {
        !s || !a.value || F !== a.value.value && s.datepickers[0].setDate(F || { clear: !0 });
      }
    ), we(
      () => n.endDate,
      (F) => {
        !s || !l.value || F !== l.value.value && s.datepickers[1].setDate(F || { clear: !0 });
      }
    ), (F, A) => (c(), p("div", XT, [
      g("div", {
        ref_key: "rangeRef",
        ref: o,
        class: S(E.value),
        "date-rangepicker": ""
      }, [
        g("div", {
          class: S(L.value)
        }, [
          e.startLabel ? (c(), p("div", QT, [
            g("div", _T, [
              g("div", e3, $(e.startLabel), 1),
              e.required ? (c(), p("div", t3, " * ")) : w("", !0)
            ])
          ])) : w("", !0),
          g("div", {
            class: S([m.value, T(k).container, P.value]),
            "data-testid": "date-range-start-container",
            onMouseenter: A[2] || (A[2] = (j) => d.value = !e.disabled && !0),
            onMouseleave: A[3] || (A[3] = (j) => d.value = !1)
          }, [
            g("i", {
              class: S([
                "ri-calendar-line",
                T(k).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            g("input", {
              ref_key: "startInputRef",
              ref: a,
              name: "start",
              type: "text",
              value: e.startDate,
              placeholder: e.startPlaceholder,
              disabled: e.disabled,
              readonly: "",
              "data-testid": "date-range-start-input",
              class: S([
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) cursor-pointer min-w-0",
                T(k).text
              ]),
              onFocus: A[0] || (A[0] = (j) => i.value = !0),
              onBlur: A[1] || (A[1] = (j) => i.value = !1)
            }, null, 42, n3),
            e.disabled ? w("", !0) : (c(), p("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-start-clear",
              class: S([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.startDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": "Clear start date",
              onClick: Ie(V, ["stop"])
            }, [
              g("i", {
                class: S(["ri-close-line", T(k).icon])
              }, null, 2)
            ], 2))
          ], 34)
        ], 2),
        g("div", {
          class: S(L.value)
        }, [
          e.endLabel ? (c(), p("div", r3, [
            g("div", o3, [
              g("div", a3, $(e.endLabel), 1),
              e.required ? (c(), p("div", l3, " * ")) : w("", !0)
            ])
          ])) : w("", !0),
          g("div", {
            class: S([v.value, T(k).container, P.value]),
            "data-testid": "date-range-end-container",
            onMouseenter: A[6] || (A[6] = (j) => f.value = !e.disabled && !0),
            onMouseleave: A[7] || (A[7] = (j) => f.value = !1)
          }, [
            g("i", {
              class: S([
                "ri-calendar-line",
                T(k).icon,
                e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
              ])
            }, null, 2),
            g("input", {
              ref_key: "endInputRef",
              ref: l,
              name: "end",
              type: "text",
              value: e.endDate,
              placeholder: e.endPlaceholder,
              disabled: e.disabled,
              readonly: "",
              "data-testid": "date-range-end-input",
              class: S([
                "flex-1 relative bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 placeholder:text-text-body-subtle dark:placeholder:text-(--colors-text-white-secondary) cursor-pointer min-w-0",
                T(k).text
              ]),
              onFocus: A[4] || (A[4] = (j) => u.value = !0),
              onBlur: A[5] || (A[5] = (j) => u.value = !1)
            }, null, 42, s3),
            e.disabled ? w("", !0) : (c(), p("button", {
              key: 0,
              type: "button",
              "data-testid": "date-range-end-clear",
              class: S([
                "shrink-0 flex items-center justify-center text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default) bg-transparent border-0 p-0 transition-opacity",
                e.endDate ? "opacity-100 hover:opacity-70 cursor-pointer" : "hidden"
              ]),
              "aria-label": "Clear end date",
              onClick: Ie(J, ["stop"])
            }, [
              g("i", {
                class: S(["ri-close-line", T(k).icon])
              }, null, 2)
            ], 2))
          ], 34)
        ], 2)
      ], 2),
      g("div", i3, [
        e.hint ? (c(), p("div", d3, [
          A[8] || (A[8] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
          g("span", null, $(e.hint), 1)
        ])) : w("", !0),
        e.error ? (c(), p("div", u3, [
          A[9] || (A[9] = g("i", { class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)" }, null, -1)),
          g("span", null, $(e.error), 1)
        ])) : w("", !0)
      ])
    ]));
  }
}), f3 = ["id", "for"], h3 = { key: 0 }, b3 = { class: "flex w-full items-end gap-3" }, p3 = { class: "flex min-w-0 flex-1" }, g3 = ["id", "value", "name", "title", "placeholder", "disabled", "readonly", "required", "autocomplete", "aria-labelledby", "aria-invalid", "aria-describedby", "aria-required", "aria-disabled"], m3 = ["disabled"], v3 = { class: "min-h-4.5 flex flex-col gap-px" }, x3 = ["id"], y3 = ["id"], k3 = /* @__PURE__ */ ge({
  __name: "UrlInput",
  props: {
    modelValue: { default: "" },
    prefix: { default: void 0 },
    iconLeft: {},
    placeholder: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    name: { default: void 0 },
    id: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    hint: { default: void 0 },
    labelInline: { type: Boolean, default: !1 },
    autocomplete: { default: "off" },
    error: { default: void 0 },
    validator: { type: Function, default: void 0 },
    validateOnBlur: { type: Boolean, default: !0 },
    validateOnInput: { type: Boolean, default: !1 },
    invalidUrlMessage: { default: "Please enter a valid URL" },
    requiredMessage: { default: "URL is required" },
    buttonLabels: { default: () => ({
      label: "",
      labelWhenCopied: ""
    }) },
    resolvedUrl: { default: void 0 }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "clear", "validation-change"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n, a = N(!1), l = N(!1), s = N(!1), i = N(!1), d = N(void 0), u = (C) => {
      if (r.validator)
        return r.validator(C) ?? void 0;
      if (r.required && !C.trim())
        return r.requiredMessage;
      if (C.trim())
        try {
          const B = !r.prefix && /^https?:\/\/|^ftps?:\/\//i.test(C), M = new URL(B ? C : (r.prefix ?? "https://") + C).hostname.split("."), D = M[M.length - 1];
          if (M.length < 2 || D.length < 2)
            return r.invalidUrlMessage;
        } catch {
          return r.invalidUrlMessage;
        }
    }, f = () => {
      const C = u(r.modelValue ?? "");
      d.value = C, o("validation-change", !C, C);
    }, h = y(() => {
      if (r.error) return r.error;
      if (i.value && s.value) return d.value;
    }), b = y(
      () => i.value && s.value && !h.value && !!(r.modelValue ?? "").trim()
    ), m = y(() => r.disabled ? "disabled" : r.readonly ? "readonly" : h.value ? "error" : b.value ? "success" : a.value ? "focused" : l.value ? "hover" : "default"), v = {
      sm: { container: "h-[32px]", prefix: "px-2 text-xs", input: "py-1.5 text-xs" },
      md: { container: "h-[36px]", prefix: "px-3 text-sm", input: "py-2 text-sm" },
      lg: { container: "h-[48px]", prefix: "px-4 text-base", input: "py-3 text-base" },
      xl: { container: "h-[52px]", prefix: "px-5 text-base", input: "py-3.5 text-base" }
    }, x = y(() => v[r.size]), k = (C) => {
      const B = C.target;
      i.value = !0, o("update:modelValue", B.value), o("input", C), r.validateOnInput && f();
    }, L = (C) => {
      a.value = !0, o("focus", C);
    }, P = (C) => {
      a.value = !1, s.value = !0, o("blur", C), r.validateOnBlur && f();
    }, E = () => {
      o("update:modelValue", ""), o("clear");
    }, O = N("idle"), R = y(() => {
      if (r.resolvedUrl !== void 0) return r.resolvedUrl;
      const C = r.modelValue ?? "";
      return C.trim() ? !r.prefix && /^https?:\/\/|^ftps?:\/\//i.test(C) ? C : (r.prefix ?? "") + C : "";
    });
    async function V() {
      if (R.value)
        try {
          await navigator.clipboard.writeText(R.value), O.value = "copied", setTimeout(() => {
            O.value = "idle";
          }, 2e3);
        } catch (C) {
          console.error("Copy failed", C);
        }
    }
    const J = y(() => r.buttonLabels ? O.value === "copied" ? r.buttonLabels.labelWhenCopied : r.buttonLabels.label : ""), F = y(
      () => O.value === "copied" ? "ri-check-line" : "ri-file-copy-2-line"
    );
    we(
      () => r.modelValue,
      () => {
        s.value && (r.validateOnBlur || r.validateOnInput) && f();
      }
    ), we(
      () => r.error,
      (C) => {
        C && (d.value = void 0);
      }
    ), t({ validate: () => (s.value = !0, f(), !d.value), resetValidation: () => {
      s.value = !1, d.value = void 0;
    } });
    const _ = Ke(), U = y(() => r.id ?? `${_}-url`), W = y(() => r.label ? `${_}-label` : void 0), K = y(() => `${_}-error`), le = y(() => `${_}-hint`);
    return (C, B) => {
      var I;
      return c(), p("div", {
        class: S([
          e.labelInline ? "flex flex-row items-center gap-3" : "flex flex-col gap-0.5",
          "pb-0.5",
          e.fullWidth ? "w-full" : ""
        ]),
        style: Ae(e.fullWidth ? void 0 : { width: e.width })
      }, [
        e.label ? (c(), p("label", {
          key: 0,
          id: W.value,
          for: U.value,
          class: S([
            "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)",
            e.labelInline ? "whitespace-nowrap" : "block"
          ])
        }, [
          Ze($(e.label) + " ", 1),
          e.required ? (c(), p("span", h3, " * ")) : w("", !0)
        ], 10, f3)) : w("", !0),
        g("div", {
          class: S(e.fullWidth || e.labelInline ? "flex-1 w-full" : "")
        }, [
          g("div", b3, [
            g("div", p3, [
              g("div", {
                class: S([
                  "flex flex-1 items-center rounded-xl overflow-hidden border relative z-10",
                  ((I = e.buttonLabels) == null ? void 0 : I.label) && "rounded-r-none",
                  x.value.container,
                  // Border + shadow per state
                  m.value === "readonly" ? a.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : m.value === "error" ? "border-(--border-border-error-strong) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : m.value === "success" ? "border-(--border-border-success-strong) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : m.value === "focused" ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : m.value === "hover" ? "border-(--border-border-accent) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : "border-(--border-border-base-medium) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]",
                  // Background per state
                  m.value === "disabled" ? "bg-(--background-background-disabled)" : m.value === "readonly" ? "bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) cursor-default" : m.value === "focused" ? "bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)]" : "bg-(--background-background-white) dark:bg-(--background-background-black-default)"
                ]),
                onMouseenter: B[0] || (B[0] = (M) => !e.disabled && !e.readonly && (l.value = !0)),
                onMouseleave: B[1] || (B[1] = (M) => l.value = !1)
              }, [
                e.iconLeft ? (c(), p("i", {
                  key: 0,
                  class: S([
                    e.iconLeft,
                    "text-num-16 ps-3 transition-colors",
                    m.value === "error" ? "text-(--text-text-error-strong)" : m.value === "success" ? "text-(--text-text-success-strong)" : m.value === "focused" ? "text-(--border-border-accent)" : m.value === "disabled" ? "text-(--text-text-disabled-light)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
                  ])
                }, null, 2)) : w("", !0),
                e.prefix ? (c(), p("div", {
                  key: 1,
                  class: S([
                    "shrink-0 flex items-center font-medium border-r border-0 rounded-none select-none h-full ",
                    x.value.prefix,
                    // Text + divider colour per state — prefix blue on focus only
                    m.value === "error" ? "text-(--text-text-error-strong) border-(--border-border-error-strong)" : m.value === "success" ? "text-(--text-text-success-strong) border-(--border-border-success-strong)" : m.value === "focused" ? "text-(--border-border-accent) border-(--border-border-base-medium)" : m.value === "disabled" ? "text-(--text-text-disabled-light) border-(--border-border-disabled-subtle)" : (m.value === "hover", "text-(--text-text-body-subtle) border-(--border-border-base-medium)")
                  ])
                }, $(e.prefix), 3)) : w("", !0),
                g("input", {
                  id: U.value,
                  value: e.modelValue,
                  name: e.name,
                  title: R.value || void 0,
                  placeholder: e.placeholder,
                  disabled: e.disabled,
                  readonly: e.readonly,
                  required: e.required,
                  type: "url",
                  inputmode: "url",
                  autocomplete: e.autocomplete,
                  "aria-labelledby": W.value,
                  "aria-invalid": !!h.value,
                  "aria-describedby": h.value ? K.value : e.hint ? le.value : void 0,
                  "aria-required": e.required || void 0,
                  "aria-disabled": e.disabled || void 0,
                  class: S([
                    "flex-1 min-w-0 border-0 outline-none focus:outline-none focus:ring-0 bg-transparent pl-3 pr-2",
                    x.value.input,
                    m.value === "disabled" ? "text-(--text-text-disabled-light) placeholder:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default) placeholder:text-(--text-text-body-subtle)"
                  ]),
                  onInput: k,
                  onFocus: L,
                  onBlur: P
                }, null, 42, g3),
                e.modelValue && !e.readonly ? (c(), p("button", {
                  key: 2,
                  type: "button",
                  disabled: e.disabled,
                  tabindex: "-1",
                  "aria-label": "Clear",
                  class: S([
                    "shrink-0 flex items-center justify-center pr-2 focus:outline-none",
                    e.disabled ? "cursor-not-allowed" : "cursor-pointer"
                  ]),
                  onClick: E
                }, [
                  g("i", {
                    class: S([
                      "ri-close-line transition-colors",
                      m.value === "error" ? "text-(--text-text-error-strong)" : m.value === "success" ? "text-(--text-text-success-strong)" : m.value === "disabled" ? "text-(--text-text-disabled-light)" : m.value === "hover" ? "text-(--border-border-accent)" : "text-(--icons-icon-dark-default) dark:text-(--icons-icon-white-default)"
                    ])
                  }, null, 2)
                ], 10, m3)) : w("", !0)
              ], 34),
              e.buttonLabels.label ? (c(), te($e, {
                key: 0,
                variant: "secondary",
                "icon-left": F.value,
                label: J.value,
                "aria-label": J.value,
                disabled: e.disabled || !e.modelValue,
                class: "rounded-l-none py-0! h-auto! -ms-px [&&>div]:hidden [&&>div]:md:block [&&]:text-(--text-text-body-subtle) [&&]:border-(--border-border-base-medium) [&&]:dark:border-(--border-border-base-medium) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]",
                onClick: V
              }, null, 8, ["icon-left", "label", "aria-label", "disabled"])) : w("", !0)
            ]),
            be(C.$slots, "actions", {}, void 0, !0)
          ]),
          g("div", v3, [
            e.hint ? (c(), p("div", {
              key: 0,
              id: le.value,
              class: "flex items-center gap-1 text-xs text-(--text-text-body)"
            }, [
              B[2] || (B[2] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
              g("span", null, $(e.hint), 1)
            ], 8, x3)) : w("", !0),
            h.value ? (c(), p("div", {
              key: 1,
              id: K.value,
              role: "alert",
              class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)"
            }, [
              B[3] || (B[3] = g("i", { class: "ri-error-warning-fill" }, null, -1)),
              g("span", null, $(h.value), 1)
            ], 8, y3)) : w("", !0)
          ])
        ], 2)
      ], 6);
    };
  }
}), pV = /* @__PURE__ */ He(k3, [["__scopeId", "data-v-7c53938e"]]);
function Op(e, t) {
  const n = N(!1);
  let r = null;
  function o() {
    const a = e.value;
    n.value = !!a && a.scrollWidth > a.offsetWidth;
  }
  return we(
    e,
    (a) => {
      if (r == null || r.disconnect(), r = null, !a) {
        n.value = !1;
        return;
      }
      typeof ResizeObserver < "u" && (r = new ResizeObserver(o), r.observe(a)), o();
    },
    { flush: "post" }
  ), we(t, o, { flush: "post" }), Bt(() => {
    r == null || r.disconnect(), r = null;
  }), { isTruncated: n };
}
const Eo = /* @__PURE__ */ ge({
  __name: "TruncatedText",
  props: {
    text: {},
    textClass: { default: "" },
    position: { default: "top" },
    focusable: { type: Boolean, default: !0 }
  },
  setup(e, { expose: t }) {
    const n = e, r = N(null), { isTruncated: o } = Op(r, () => n.text);
    return t({ isTruncated: o }), (a, l) => (c(), te(Ye, {
      class: "w-full min-w-0",
      text: e.text,
      position: e.position,
      disabled: !T(o),
      tabindex: e.focusable && T(o) ? 0 : void 0
    }, {
      default: pe(() => [
        g("span", {
          ref_key: "textEl",
          ref: r,
          "data-testid": "truncated-text",
          class: S(["w-full min-w-0 truncate", e.textClass])
        }, $(e.text), 3)
      ]),
      _: 1
    }, 8, ["text", "position", "disabled", "tabindex"]));
  }
}), w3 = { class: "flex flex-col gap-0.5 pb-0.5" }, C3 = ["id"], S3 = { key: 0 }, $3 = ["id", "aria-expanded", "aria-labelledby", "aria-describedby", "aria-disabled", "aria-readonly", "aria-busy", "tabindex", "onClick", "onKeydown"], I3 = {
  key: 0,
  class: "flex-1 truncate text-(length:--size-m) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, T3 = {
  key: 0,
  class: "shrink-0"
}, L3 = ["aria-label"], M3 = { class: "min-h-4.5 flex flex-col gap-px" }, E3 = /* @__PURE__ */ ge({
  __name: "MultipleSelect",
  props: {
    options: {},
    modelValue: { default: () => [] },
    draft: { default: void 0 },
    label: { default: void 0 },
    required: { type: Boolean, default: !1 },
    helpTooltip: { default: void 0 },
    placeholder: {},
    confirmLabel: {},
    seeAllLabel: { default: void 0 },
    seeAllThreshold: { default: 20 },
    searchPlaceholder: {},
    selectAllLabel: {},
    clearAllLabel: {},
    emptyLabel: {},
    error: { default: void 0 },
    hint: { default: void 0 },
    async: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: void 0 },
    selectAllResolver: { type: Function, default: void 0 },
    chipTheme: { default: "grey" },
    totalCount: { default: void 0 },
    maxListHeight: { default: "252px" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:draft", "see-all", "search"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => n.async), a = Ke(), l = y(() => `${a}-input`), s = y(() => n.label ? `${a}-label` : void 0), i = `${a}-error`, d = `${a}-hint`, u = y(() => !!n.error), f = y(
      () => n.options.filter((H) => (n.modelValue ?? []).includes(H.id))
    ), h = N([...n.modelValue ?? []]), b = N(!1), m = N(!1), v = (H, z) => H.length === z.length && H.every((X, Y) => X === z[Y]);
    we(
      () => n.draft,
      (H) => {
        H && !v(H, h.value) && (h.value = [...H]);
      }
    ), we(h, (H) => {
      (!n.draft || !v(n.draft, H)) && r("update:draft", [...H]);
    });
    const x = () => {
      b.value = !0, h.value = [...n.modelValue ?? []];
    }, k = () => {
      b.value = !1, h.value = [...n.modelValue ?? []];
    }, L = () => {
      r("update:modelValue", [...h.value]);
    }, P = N(null), E = N(!1), O = () => {
      P.value && (E.value = P.value.scrollWidth > P.value.offsetWidth);
    }, R = N(null), V = N(1 / 0), J = N(void 0);
    let F = null;
    const A = y(() => {
      const H = V.value === 1 / 0 ? f.value.length : Math.min(V.value, f.value.length);
      return f.value.slice(0, H);
    }), j = y(
      () => Math.max(0, f.value.length - A.value.length)
    ), _ = async () => {
      V.value = 1 / 0, await Pe();
      const H = R.value;
      if (!H || f.value.length === 0) {
        V.value = f.value.length;
        return;
      }
      const z = Array.from(H.querySelectorAll("[data-badge-chip]"));
      if (!z.length) {
        V.value = f.value.length;
        return;
      }
      const X = H.getBoundingClientRect(), Y = 56, ce = 56, ne = X.right - Y;
      let ye = z.length;
      for (let he = 0; he < z.length; he++) {
        const ie = z[he].getBoundingClientRect().right;
        if ((he === z.length - 1 ? ie : ie + ce) > ne) {
          ye = he;
          break;
        }
      }
      V.value = Math.max(ye, 1);
    }, U = () => {
      R.value && (J.value = `${R.value.offsetWidth}px`);
    };
    Qe(() => {
      F = new ResizeObserver(() => {
        U(), _(), O();
      }), R.value && F.observe(R.value), U(), _(), O();
    }), nt(() => {
      F == null || F.disconnect(), clearTimeout(K);
    }), we(
      () => n.modelValue,
      (H) => {
        V.value = 1 / 0, _(), b.value || (h.value = [...H ?? []]);
      }
    );
    const W = N("");
    let K;
    we(W, (H) => {
      n.async && (clearTimeout(K), K = setTimeout(() => r("search", H), 300));
    });
    const le = N(!1), C = y(() => n.loading || le.value), B = y(
      () => n.loading ? n.loadingLabel ?? n.emptyLabel : n.emptyLabel
    ), I = y(() => n.options.filter((H) => !H.disabled)), M = y(
      () => I.value.length > 0 && I.value.every((H) => h.value.includes(H.id))
    ), D = y(
      () => !M.value && I.value.some((H) => h.value.includes(H.id))
    ), re = async () => {
      if (n.selectAllResolver) {
        le.value = !0;
        try {
          const H = await n.selectAllResolver(), z = new Set(H);
          if (H.length > 0 && H.every((Y) => h.value.includes(Y)))
            h.value = h.value.filter((Y) => !z.has(Y));
          else {
            const Y = new Set(h.value);
            H.forEach((ce) => Y.add(ce)), h.value = Array.from(Y);
          }
        } catch {
        } finally {
          le.value = !1;
        }
        return;
      }
      if (M.value)
        h.value = h.value.filter(
          (H) => !I.value.some((z) => z.id === H)
        );
      else {
        const H = new Set(h.value);
        I.value.forEach((z) => H.add(z.id)), h.value = Array.from(H);
      }
    }, se = (H) => {
      h.value.includes(H) ? h.value = h.value.filter((z) => z !== H) : h.value = [...h.value, H];
    }, de = (H) => {
      h.value = h.value.filter((z) => z !== H), r(
        "update:modelValue",
        (n.modelValue ?? []).filter((z) => z !== H)
      );
    }, fe = (H) => {
      H.stopPropagation(), h.value = [], r("update:modelValue", []);
    }, q = y(() => ({
      id: "__select-all__",
      label: n.selectAllLabel,
      hasCheckbox: !0,
      checked: M.value,
      indeterminate: D.value,
      onClick: re
    })), oe = y(() => [
      ...n.options.map((H) => ({
        id: H.id,
        label: H.label,
        hasCheckbox: !0,
        checked: h.value.includes(H.id),
        badgeTheme: H.badgeTheme ?? n.chipTheme,
        secondaryText: H.secondaryText,
        disabled: H.disabled,
        onClick: () => se(H.id)
      }))
    ]), ue = y(() => {
      const H = [], z = n.totalCount ?? n.options.length;
      return n.seeAllLabel && z > (n.seeAllThreshold ?? 20) && H.push({
        label: n.seeAllLabel,
        variant: "secondary",
        keepOpen: !0,
        onClick: () => r("see-all")
      }), H.push({ label: n.confirmLabel, variant: "primary", onClick: L }), H;
    }), G = (H, z, X) => {
      if (H.key === "Escape" && X) {
        H.stopPropagation(), H.preventDefault(), z();
        return;
      }
      if (H.key === "Backspace" && !n.disabled && !n.readonly && f.value.length > 0) {
        const Y = f.value[f.value.length - 1];
        h.value = h.value.filter((ce) => ce !== Y.id), r(
          "update:modelValue",
          (n.modelValue ?? []).filter((ce) => ce !== Y.id)
        );
      }
    };
    return (H, z) => (c(), p("div", w3, [
      e.label ? (c(), p("label", {
        key: 0,
        id: s.value,
        class: S(["flex items-center gap-1 leading-5 text-(length:--size-m) font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)", !e.disabled && "cursor-pointer"]),
        onClick: z[0] || (z[0] = Ie((X) => {
          var Y;
          return !e.disabled && ((Y = R.value) == null ? void 0 : Y.click());
        }, ["stop"]))
      }, [
        ae(T(Ye), {
          class: "min-w-0",
          text: e.label,
          position: "top",
          disabled: !E.value
        }, {
          default: pe(() => [
            g("span", {
              ref_key: "labelRef",
              ref: P,
              class: "truncate min-w-0 block"
            }, $(e.label), 513)
          ]),
          _: 1
        }, 8, ["text", "disabled"]),
        e.required ? (c(), p("span", S3, "*")) : w("", !0),
        e.helpTooltip ? (c(), te(T(Ye), {
          key: 1,
          text: e.helpTooltip,
          position: "top"
        }, {
          default: pe(() => [...z[4] || (z[4] = [
            g("span", { class: "ml-0.5 flex h-3.5 w-3.5 cursor-help items-center justify-center text-(--colors-text-body-subtle)" }, [
              g("i", { class: "ri-question-line text-sm leading-none" })
            ], -1)
          ])]),
          _: 1
        }, 8, ["text"])) : w("", !0)
      ], 10, C3)) : w("", !0),
      ae(T(au), {
        "search-query": W.value,
        "onUpdate:searchQuery": z[3] || (z[3] = (X) => W.value = X),
        items: oe.value,
        "sticky-item": q.value,
        "show-search": !0,
        "search-placeholder": e.searchPlaceholder,
        "empty-label": B.value,
        "disable-internal-search-filter": o.value,
        "max-list-height": e.maxListHeight,
        "checkbox-position": "left",
        "footer-buttons": ue.value,
        "menu-width": J.value,
        class: "w-full",
        onOpen: x,
        onClose: k
      }, {
        trigger: pe(({ toggle: X, isOpen: Y }) => [
          g("div", {
            id: l.value,
            ref_key: "tagInputRef",
            ref: R,
            role: "combobox",
            "aria-expanded": Y,
            "aria-haspopup": "listbox",
            "aria-labelledby": s.value,
            "aria-describedby": u.value ? i : e.hint ? d : void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-readonly": e.readonly ? "true" : void 0,
            "aria-busy": C.value ? "true" : void 0,
            tabindex: e.disabled ? -1 : 0,
            class: S(["flex h-9 w-full items-center gap-2 overflow-hidden rounded-xl border border-solid px-2.5 transition-colors focus:outline-none", [
              e.disabled ? "border-border-disabled-subtle bg-gainsboro-200 dark:border-(--colors-border-disabled-subtle) dark:bg-(--colors-background-disabled)" : e.readonly ? `cursor-default bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-disabled) ${m.value ? "border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "border-(--border-border-base-soft) dark:border-(--border-border-base)"}` : u.value ? `cursor-pointer bg-white dark:bg-(--colors-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)${m.value ? " shadow-[0px_0px_2px_var(--border-border-accent)]" : ""}` : Y || m.value ? "cursor-pointer bg-white dark:bg-(--colors-background-black-default) border-[1px] border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)]" : "cursor-pointer bg-white dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) hover:border-(--border-border-accent) dark:border-(--colors-border-base)"
            ]]),
            onClick: (ce) => !e.disabled && !e.readonly && X(),
            onKeydown: [
              (ce) => G(ce, X, Y),
              je(Ie((ce) => !e.disabled && !e.readonly && X(), ["prevent"]), ["enter"]),
              je(Ie((ce) => !e.disabled && !e.readonly && X(), ["prevent"]), ["space"])
            ],
            onFocus: z[1] || (z[1] = (ce) => m.value = !0),
            onBlur: z[2] || (z[2] = (ce) => m.value = !1)
          }, [
            f.value.length === 0 ? (c(), p("span", I3, $(e.placeholder), 1)) : w("", !0),
            f.value.length > 0 ? (c(), p(Z, { key: 1 }, [
              (c(!0), p(Z, null, ke(A.value, (ce) => (c(), p("div", {
                key: ce.id,
                "data-badge-chip": "",
                class: "shrink-0"
              }, [
                ae(T(pt), {
                  label: ce.label,
                  theme: e.disabled ? "disabled" : ce.badgeTheme ?? e.chipTheme,
                  "tooltip-text": ce.tooltipText,
                  size: "sm",
                  truncate: "",
                  "show-close-icon": !e.disabled && !e.readonly,
                  onClose: (ne) => de(ce.id)
                }, null, 8, ["label", "theme", "tooltip-text", "show-close-icon", "onClose"])
              ]))), 128)),
              j.value > 0 ? (c(), p("div", T3, [
                ae(T(pt), {
                  label: `+${j.value}`,
                  theme: e.disabled ? "disabled" : e.chipTheme,
                  size: "sm",
                  "show-close-icon": !1
                }, null, 8, ["label", "theme"])
              ])) : w("", !0),
              z[5] || (z[5] = g("div", { class: "flex-1" }, null, -1))
            ], 64)) : w("", !0),
            f.value.length > 0 && !e.disabled && !e.readonly ? (c(), p("button", {
              key: 2,
              type: "button",
              class: "shrink-0 flex h-4 w-4 items-center justify-center rounded text-(--colors-text-body-subtle) transition-colors hover:text-(--colors-text-black-default) dark:text-(--colors-text-white-secondary) dark:hover:text-(--colors-text-white-default)",
              "aria-label": e.clearAllLabel,
              onClick: Ie(fe, ["stop"])
            }, [...z[6] || (z[6] = [
              g("i", { class: "ri-close-line text-base leading-none" }, null, -1)
            ])], 8, L3)) : w("", !0),
            g("i", {
              class: S(["ri-arrow-down-s-line shrink-0 transition-transform duration-200 ease-in-out", e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default)"]),
              style: Ae({ transform: Y ? "rotate(180deg)" : "rotate(0deg)" })
            }, null, 6)
          ], 42, $3)
        ]),
        _: 1
      }, 8, ["search-query", "items", "sticky-item", "search-placeholder", "empty-label", "disable-internal-search-filter", "max-list-height", "footer-buttons", "menu-width"]),
      g("div", M3, [
        e.hint ? (c(), p("div", {
          key: 0,
          id: d,
          class: "flex items-center gap-1 text-xs text-(--text-text-body)"
        }, [
          z[7] || (z[7] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
          g("span", null, $(e.hint), 1)
        ])) : w("", !0),
        e.error ? (c(), p("div", {
          key: 1,
          id: i,
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          z[8] || (z[8] = g("i", { class: "ri-error-warning-fill" }, null, -1)),
          g("span", null, $(e.error), 1)
        ])) : w("", !0)
      ])
    ]));
  }
}), gV = /* @__PURE__ */ He(E3, [["__scopeId", "data-v-3ac6fc66"]]), A3 = ["role", "aria-label", "aria-hidden"], D3 = /* @__PURE__ */ ge({
  __name: "AvatarGroup",
  props: {
    avatars: {},
    size: { default: "md" },
    max: { default: 4 },
    ariaLabel: { default: void 0 },
    ringClass: { default: "ring-(--background-background-white)" }
  },
  setup(e) {
    const t = e, n = y(() => t.avatars.slice(0, t.max)), r = y(() => Math.max(t.avatars.length - t.max, 0)), o = y(() => (t.ariaLabel ?? "").trim().length > 0), a = {
      sm: "-ml-1.5 first:ml-0",
      md: "-ml-2 first:ml-0"
    }, l = {
      sm: "text-[8px]",
      md: "text-[10px]"
    };
    return (s, i) => (c(), p("div", {
      class: "flex items-center",
      role: o.value ? "img" : void 0,
      "aria-label": o.value ? e.ariaLabel : void 0,
      "aria-hidden": o.value ? void 0 : "true",
      "data-testid": "avatar-group"
    }, [
      (c(!0), p(Z, null, ke(n.value, (d, u) => (c(), te(Cn, {
        key: u,
        name: d.name,
        img: d.img,
        size: e.size,
        "avatar-style": "circle",
        presentational: !0,
        class: S(["ring-2", [e.ringClass, a[e.size]]]),
        "data-testid": "avatar-group-avatar",
        "aria-hidden": "true"
      }, null, 8, ["name", "img", "size", "class"]))), 128)),
      r.value > 0 ? (c(), te(vn, {
        key: 0,
        size: e.size,
        shape: "circle",
        variant: "filled",
        class: S(["ring-2", [e.ringClass, a[e.size]]]),
        "data-testid": "avatar-group-overflow",
        "aria-hidden": "true"
      }, {
        default: pe(() => [
          g("span", {
            class: S(["font-medium text-(--text-text-body-subtle)", l[e.size]])
          }, "+" + $(r.value), 3)
        ]),
        _: 1
      }, 8, ["size", "class"])) : w("", !0)
    ], 8, A3));
  }
}), Pp = {
  name: "sameWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  }
}, R3 = {
  key: 0,
  class: "flex items-center gap-1"
}, B3 = {
  key: 0,
  class: "ml-0.5"
}, O3 = ["aria-expanded", "aria-activedescendant", "aria-required", "aria-invalid", "aria-disabled", "aria-describedby", "disabled", "placeholder"], P3 = { class: "flex items-start justify-between min-h-4.5 gap-2" }, z3 = { class: "flex flex-col gap-px flex-1 min-w-0" }, N3 = { class: "p-2" }, V3 = {
  key: 0,
  class: "flex justify-center py-4"
}, F3 = {
  key: 1,
  class: "px-4 py-4 text-sm text-(--text-text-body-subtle)"
}, H3 = {
  key: 0,
  class: "px-3 pt-2 pb-1 text-sm font-semibold text-(--text-text-black-default) dark:text-(--text-text-white-default)"
}, W3 = ["id", "aria-selected", "aria-disabled", "onClick", "onMouseenter"], j3 = { class: "flex items-center gap-1.5 min-w-0 flex-1" }, U3 = { class: "flex flex-col min-w-0 flex-1" }, G3 = { class: "text-(--text-text-link) font-medium" }, q3 = {
  key: 0,
  class: "text-xs text-(--text-text-body-subtle) truncate"
}, K3 = ["innerHTML"], J3 = {
  key: 0,
  class: "px-3 py-4 border-t border-(--border-border-base-medium) dark:border-(--colors-border-base)"
}, mV = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "AutoComplete",
  props: {
    modelValue: {},
    label: {},
    required: { type: Boolean },
    requiredIndicator: { default: "*" },
    placeholder: {},
    iconLeft: { default: "ri-map-pin-2-line" },
    iconRight: { default: "ri-search-line" },
    options: {},
    loading: { type: Boolean },
    emptyLabel: {},
    resultsLabel: {},
    error: {},
    hint: {},
    disabled: { type: Boolean },
    fullWidth: { type: Boolean, default: !0 },
    showAddMoreDetails: { type: Boolean },
    addMoreDetailsLabel: {},
    labelTooltip: {},
    debounce: { default: 300 },
    minSearchLength: { default: 1 },
    maxVisibleOptions: { default: 5 },
    keepInputOnEdit: { type: Boolean },
    clearable: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "search", "select", "clear", "addMoreDetails", "blur"],
  setup(e, { expose: t, emit: n }) {
    var de, fe;
    const r = e, o = n, a = Ke(), l = `autocomplete-input-${a}`, s = `autocomplete-listbox-${a}`, i = `autocomplete-error-${a}`, d = `autocomplete-hint-${a}`, u = N(
      r.modelValue ? ((fe = (de = r.options) == null ? void 0 : de.find((q) => q.value === r.modelValue)) == null ? void 0 : fe.label) ?? r.modelValue : ""
    ), f = N(!1), h = N(!1), b = N(-1), m = N(), v = N(), x = N(), k = N(!1), L = N(!1);
    let P = null, E = null, O = !1;
    const R = y(
      () => f.value && u.value.length >= (r.minSearchLength ?? 1) && !r.disabled
    ), V = y(
      () => (r.options ?? []).slice(0, r.maxVisibleOptions).map((q) => ({
        ...q,
        parts: W(q.label, u.value)
      }))
    ), J = y(
      () => V.value.map((q, oe) => q.disabled ? -1 : oe).filter((q) => q !== -1)
    ), F = y(() => !!r.modelValue), A = y(
      () => r.clearable && !!u.value && !r.disabled && (h.value || f.value)
    ), j = y(() => r.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : f.value ? "text-(--border-border-accent)" : F.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), _ = y(() => r.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : h.value && !f.value ? "text-(--border-border-accent)" : F.value ? "text-(--text-text-black-default) dark:text-(--text-text-white-default)" : "text-(--text-text-body-subtle)"), U = y(() => {
      const q = "relative rounded-xl border-solid box-border flex items-center gap-2 px-3 h-9 font-inter";
      return r.disabled ? `${q} border-[1px] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)` : r.error ? `${q} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error)` : f.value ? `${q} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent)` : h.value ? `${q} border-[1px] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-accent)` : `${q} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] bg-(--background-background-white) dark:bg-(--background-background-black-default) border-(--border-border-base-medium) dark:border-(--border-border-base)`;
    });
    we(R, async (q) => {
      q ? (await Pe(), P = vo(m.value, x.value, {
        placement: "bottom-start",
        onFirstUpdate: () => {
          k.value = !0;
        },
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Pp
        ]
      })) : (P == null || P.destroy(), P = null, k.value = !1);
    }), we(k, async (q) => {
      q && (await Pe(), await (P == null ? void 0 : P.update()));
    }), we(
      [() => r.options, () => r.loading],
      async () => {
        var q;
        if (!f.value && r.modelValue) {
          const oe = (q = r.options) == null ? void 0 : q.find((ue) => ue.value === r.modelValue);
          oe && (u.value = oe.label);
        }
        b.value = -1, await Pe(), await (P == null ? void 0 : P.update());
      }
    ), we(
      () => r.modelValue,
      (q) => {
        var ue;
        if (!q) {
          O || (u.value = ""), O = !1;
          return;
        }
        const oe = (ue = r.options) == null ? void 0 : ue.find((G) => G.value === q);
        u.value = oe ? oe.label : q;
      },
      { immediate: !0 }
    ), Bt(() => {
      P == null || P.destroy(), P = null, E && clearTimeout(E);
    });
    function W(q, oe) {
      const ue = q.toLowerCase().indexOf(oe.toLowerCase());
      return ue === -1 || !oe ? { before: "", match: "", after: q } : {
        before: q.slice(0, ue),
        match: q.slice(ue, ue + oe.length),
        after: q.slice(ue + oe.length)
      };
    }
    const K = (q) => {
      f.value = !0, q.target.select();
    }, le = () => {
      r.disabled || (f.value = !0);
    }, C = () => {
      f.value = !1, o("blur");
    }, B = () => {
      r.modelValue && (r.keepInputOnEdit && (O = !0), o("update:modelValue", "")), L.value = !0, E && clearTimeout(E), E = setTimeout(() => {
        L.value = !1, o("search", u.value);
      }, r.debounce ?? 300);
    }, I = (q) => {
      q.disabled || (u.value = q.label, o("update:modelValue", q.value), o("select", q), f.value = !1);
    }, M = () => {
      u.value = "", o("update:modelValue", ""), o("clear");
    }, D = () => {
      f.value = !1;
    }, re = async () => {
      var q;
      await Pe(), (q = document.getElementById(`${s}-option-${b.value}`)) == null || q.scrollIntoView({ block: "nearest" });
    }, se = (q) => {
      if (!R.value) return;
      if (q.key === "Escape") {
        q.stopPropagation(), q.preventDefault(), D();
        return;
      }
      const oe = J.value;
      if (oe.length)
        switch (q.key) {
          case "ArrowDown": {
            q.preventDefault();
            const ue = oe.indexOf(b.value);
            b.value = oe[(ue + 1) % oe.length], re();
            break;
          }
          case "ArrowUp": {
            q.preventDefault();
            const ue = oe.indexOf(b.value);
            b.value = oe[(ue - 1 + oe.length) % oe.length], re();
            break;
          }
          case "Enter": {
            q.preventDefault(), b.value >= 0 && V.value[b.value] && I(V.value[b.value]);
            break;
          }
          case "Tab": {
            b.value >= 0 && V.value[b.value] && I(V.value[b.value]), D();
            break;
          }
        }
    };
    return t({ focus: () => {
      var q;
      return (q = v.value) == null ? void 0 : q.focus();
    } }), (q, oe) => (c(), p(Z, null, [
      g("div", {
        class: S(["font-inter text-sm flex flex-col gap-0.5 pb-0.5", e.fullWidth ? "w-full" : ""])
      }, [
        e.label ? (c(), p("div", R3, [
          g("label", {
            for: l,
            class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, [
            Ze($(e.label) + " ", 1),
            e.required ? (c(), p("span", B3, $(e.requiredIndicator), 1)) : w("", !0)
          ]),
          e.labelTooltip ? (c(), te(T(Ye), {
            key: 0,
            text: e.labelTooltip
          }, {
            default: pe(() => [...oe[7] || (oe[7] = [
              g("i", { class: "ri-question-line text-(--text-text-body-subtle) cursor-help text-sm" }, null, -1)
            ])]),
            _: 1
          }, 8, ["text"])) : w("", !0)
        ])) : w("", !0),
        g("div", {
          ref_key: "inputRef",
          ref: m,
          class: S(U.value),
          onMouseenter: oe[2] || (oe[2] = (ue) => h.value = !0),
          onMouseleave: oe[3] || (oe[3] = (ue) => h.value = !1)
        }, [
          e.iconLeft ? (c(), p("i", {
            key: 0,
            class: S([e.iconLeft, "shrink-0 text-base transition-colors", j.value])
          }, null, 2)) : w("", !0),
          Ar(g("input", Je(q.$attrs, {
            id: l,
            ref_key: "nativeInputRef",
            ref: v,
            "onUpdate:modelValue": oe[0] || (oe[0] = (ue) => u.value = ue),
            role: "combobox",
            "aria-expanded": R.value,
            "aria-autocomplete": "list",
            "aria-controls": s,
            "aria-activedescendant": b.value >= 0 ? `${s}-option-${b.value}` : void 0,
            "aria-haspopup": "listbox",
            "aria-required": e.required || void 0,
            "aria-invalid": !!e.error || void 0,
            "aria-disabled": e.disabled ? "true" : void 0,
            "aria-describedby": e.error ? i : e.hint ? d : void 0,
            autocomplete: "off",
            disabled: e.disabled,
            placeholder: e.placeholder,
            class: ["flex-1 min-w-0 truncate bg-transparent outline-none text-sm placeholder:text-(--text-text-body-subtle)", e.disabled ? "text-text-disabled dark:text-(--text-text-disabled-light)" : "text-(--text-text-black-default) dark:text-(--text-text-white-default)"],
            onInput: B,
            onFocus: K,
            onClick: le,
            onBlur: C,
            onKeydown: se
          }), null, 16, O3), [
            [hg, u.value]
          ]),
          A.value ? (c(), p("button", {
            key: 1,
            type: "button",
            class: S(["shrink-0 transition-colors cursor-pointer", _.value]),
            onMousedown: oe[1] || (oe[1] = Ie(() => {
            }, ["prevent"])),
            onClick: M
          }, [...oe[8] || (oe[8] = [
            g("i", { class: "ri-close-line text-base" }, null, -1)
          ])], 34)) : e.iconRight ? (c(), p("i", {
            key: 2,
            class: S([e.iconRight, "shrink-0 text-base transition-colors", _.value])
          }, null, 2)) : w("", !0)
        ], 34),
        g("div", P3, [
          g("div", z3, [
            e.hint ? (c(), p("div", {
              key: 0,
              id: d,
              class: "flex items-center gap-1 text-xs text-(--text-text-body)"
            }, [
              oe[9] || (oe[9] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
              g("span", null, $(e.hint), 1)
            ])) : w("", !0),
            e.error ? (c(), p("div", {
              key: 1,
              id: i,
              role: "alert",
              class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)"
            }, [
              oe[10] || (oe[10] = g("i", { class: "ri-error-warning-fill text-sm" }, null, -1)),
              g("span", null, $(e.error), 1)
            ])) : w("", !0)
          ]),
          e.showAddMoreDetails ? (c(), te(T($r), {
            key: 0,
            size: "s",
            "icon-right": "ri-pencil-line",
            class: "shrink-0 ml-2",
            onClick: oe[4] || (oe[4] = (ue) => o("addMoreDetails"))
          }, {
            default: pe(() => [
              Ze($(e.addMoreDetailsLabel ?? "Add more details"), 1)
            ]),
            _: 1
          })) : w("", !0)
        ])
      ], 2),
      (c(), te(cn, { to: "body" }, [
        R.value ? (c(), p("div", {
          key: 0,
          ref_key: "panelRef",
          ref: x,
          class: "fixed z-[200]",
          "data-focus-trap-allow-outside": "",
          onMousedown: oe[6] || (oe[6] = Ie(() => {
          }, ["prevent"]))
        }, [
          ae(ot, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: pe(() => [
              k.value ? (c(), p("div", {
                key: 0,
                id: s,
                role: "listbox",
                class: "w-full bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark) overflow-hidden flex flex-col"
              }, [
                g("div", N3, [
                  e.loading ? (c(), p("div", V3, [...oe[11] || (oe[11] = [
                    g("i", { class: "ri-loader-4-line animate-spin text-(--text-text-body-subtle)" }, null, -1)
                  ])])) : !V.value.length && !L.value && u.value.length >= (e.minSearchLength ?? 1) ? (c(), p("div", F3, $(e.emptyLabel ?? "No results"), 1)) : (c(), p(Z, { key: 2 }, [
                    e.resultsLabel ? (c(), p("p", H3, $(e.resultsLabel), 1)) : w("", !0),
                    (c(!0), p(Z, null, ke(V.value, (ue, G) => (c(), p("div", {
                      id: `${s}-option-${G}`,
                      key: ue.value,
                      role: "option",
                      "aria-selected": G === b.value,
                      "aria-disabled": ue.disabled ? "true" : void 0,
                      class: S([
                        "flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-colors",
                        ue.disabled ? "opacity-40 cursor-not-allowed" : G === b.value ? "bg-[#EEF2FF] dark:bg-(--colors-background-hover) cursor-pointer" : "hover:bg-[#EEF2FF] dark:hover:bg-(--colors-background-hover) cursor-pointer"
                      ]),
                      onMousedown: oe[5] || (oe[5] = Ie(() => {
                      }, ["prevent"])),
                      onClick: (H) => !ue.disabled && I(ue),
                      onMouseenter: (H) => !ue.disabled && (b.value = G)
                    }, [
                      g("span", j3, [
                        ue.image !== void 0 ? (c(), te(T(Cn), {
                          key: 0,
                          img: ue.image ?? void 0,
                          name: ue.label,
                          size: "sm",
                          logo: ue.logo ?? !1,
                          presentational: !0,
                          class: "border border-(--border-border-base-soft)"
                        }, null, 8, ["img", "name", "logo"])) : w("", !0),
                        g("span", U3, [
                          g("span", null, [
                            g("span", null, $(ue.parts.before), 1),
                            g("span", G3, $(ue.parts.match), 1),
                            g("span", null, $(ue.parts.after), 1)
                          ]),
                          ue.description ? (c(), p("span", q3, $(ue.description), 1)) : w("", !0)
                        ])
                      ]),
                      ue.badge ? (c(), p("span", {
                        key: 0,
                        class: S(["shrink-0 inline-flex items-center gap-1 text-xs font-medium px-1 py-0.5 rounded whitespace-nowrap", {
                          "bg-[#ffddc1] text-(--text-text-black-default) dark:bg-amber-900/30 dark:text-amber-300": ue.badgeVariant === "amber",
                          "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300": ue.badgeVariant === "green",
                          "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300": ue.badgeVariant === "red",
                          "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300": !ue.badgeVariant || ue.badgeVariant === "indigo"
                        }])
                      }, [
                        ue.badgeIconSvg ? (c(), p("span", {
                          key: 0,
                          class: "shrink-0 size-3 inline-flex items-center [&_svg]:size-3",
                          innerHTML: ue.badgeIconSvg
                        }, null, 8, K3)) : w("", !0),
                        Ze(" " + $(ue.badge), 1)
                      ], 2)) : w("", !0)
                    ], 42, W3))), 128))
                  ], 64))
                ]),
                q.$slots.footer ? (c(), p("div", J3, [
                  be(q.$slots, "footer", {
                    close: D,
                    searchQuery: u.value
                  })
                ])) : w("", !0)
              ])) : w("", !0)
            ]),
            _: 3
          })
        ], 544)) : w("", !0)
      ]))
    ], 64));
  }
}), Z3 = { class: "flex flex-col gap-0.5" }, Y3 = ["id"], X3 = ["id"], Q3 = { class: "modal-scrollbar border border-(--border-border-base-medium) dark:border-(--colors-border-base) rounded-xl p-1 overflow-y-auto max-h-135" }, _3 = {
  key: 0,
  class: "flex justify-center py-8"
}, eL = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, tL = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, nL = {
  key: 2,
  class: "flex flex-col items-center gap-2 py-8 text-center"
}, rL = { class: "text-sm text-(--text-text-body-subtle)" }, oL = ["aria-label"], aL = ["aria-selected", "onClick"], lL = { class: "flex items-center gap-1.5 min-w-0 flex-1" }, sL = { class: "flex flex-col min-w-0" }, iL = { class: "text-xs leading-5 font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" }, dL = {
  key: 0,
  class: "text-xs leading-5 text-(--text-text-body) dark:text-(--text-text-white-default)"
}, uL = {
  key: 0,
  class: "shrink-0 ml-2 flex items-center gap-1 px-1 py-0.5 rounded bg-(--colors-warning-100) dark:bg-amber-900/30 text-xs font-medium text-(--text-text-black-default) dark:text-amber-300 whitespace-nowrap"
}, cL = ["innerHTML"], vV = /* @__PURE__ */ ge({
  __name: "AutoCompleteAllResultsModal",
  props: {
    modelValue: { type: Boolean },
    options: {},
    title: {},
    subtitle: {},
    loading: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    loadErrorLabel: {},
    emptyLabel: {},
    closeLabel: {},
    selectLabel: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Ke(), a = Ke(), l = N(null);
    we(
      () => n.modelValue,
      (d) => {
        d && (l.value = null);
      }
    );
    function s(d) {
      var u;
      return ((u = d.meta) == null ? void 0 : u.uniqueKey) ?? d.value;
    }
    function i() {
      l.value && (r("confirm", l.value), r("update:modelValue", !1));
    }
    return (d, u) => (c(), te(T(Ta), {
      "model-value": e.modelValue,
      size: "lg",
      "show-close-button": !0,
      "footer-position": "split",
      "overlay-class": "!z-[300]",
      "content-class": "!max-h-[748px] p-2",
      "header-class": "pt-0!",
      "show-footer-border": !1,
      "show-header-border": !1,
      "aria-labelledby": T(o),
      "aria-describedby": e.subtitle ? T(a) : void 0,
      "onUpdate:modelValue": u[1] || (u[1] = (f) => d.$emit("update:modelValue", f))
    }, {
      header: pe(() => [
        g("div", Z3, [
          g("span", {
            id: T(o),
            class: "text-xl font-bold text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, $(e.title), 9, Y3),
          e.subtitle ? (c(), p("span", {
            key: 0,
            id: T(a),
            class: "text-base font-normal text-(--text-text-black-default) dark:text-(--text-text-white-default)"
          }, $(e.subtitle), 9, X3)) : w("", !0)
        ])
      ]),
      footer: pe(() => [
        ae(T($e), {
          variant: "secondary",
          label: e.closeLabel ?? "Close",
          onClick: u[0] || (u[0] = (f) => d.$emit("update:modelValue", !1))
        }, null, 8, ["label"]),
        ae(T($e), {
          variant: "primary",
          "icon-left": "ri-check-line",
          label: e.selectLabel ?? "Select",
          disabled: !l.value,
          onClick: i
        }, null, 8, ["label", "disabled"])
      ]),
      default: pe(() => [
        g("div", Q3, [
          e.loading ? (c(), p("div", _3, [...u[2] || (u[2] = [
            g("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1)
          ])])) : e.error ? (c(), p("div", eL, [
            u[3] || (u[3] = g("i", { class: "ri-error-warning-line text-2xl text-red-500" }, null, -1)),
            g("span", tL, $(e.loadErrorLabel ?? "Unable to load results."), 1)
          ])) : e.options.length ? (c(), p("div", {
            key: 3,
            role: "listbox",
            "aria-label": e.title,
            class: "flex flex-col gap-0.5"
          }, [
            (c(!0), p(Z, null, ke(e.options, (f) => (c(), p("button", {
              key: s(f),
              type: "button",
              role: "option",
              "aria-selected": !!l.value && s(l.value) === s(f),
              class: S([
                "flex items-center justify-between h-11.5 w-full p-2 rounded-lg cursor-pointer transition-colors text-left",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)",
                l.value && s(l.value) === s(f) ? "bg-(--colors-background-accent) dark:bg-indigo-950/20" : "bg-transparent hover:bg-(--colors-background-hover) dark:hover:bg-(--colors-background-hover)"
              ]),
              onClick: (h) => l.value = f
            }, [
              g("span", lL, [
                f.image !== void 0 ? (c(), te(T(Cn), {
                  key: 0,
                  as: "span",
                  img: f.image ?? void 0,
                  name: f.label,
                  size: "sm",
                  presentational: !0,
                  class: "border border-(--border-border-base-soft)"
                }, null, 8, ["img", "name"])) : w("", !0),
                g("span", sL, [
                  g("span", iL, $(f.label), 1),
                  f.description ? (c(), p("span", dL, $(f.description), 1)) : w("", !0)
                ])
              ]),
              f.badge ? (c(), p("span", uL, [
                f.badgeIconSvg ? (c(), p("span", {
                  key: 0,
                  class: "shrink-0 size-3 flex items-center [&_svg]:size-3",
                  innerHTML: f.badgeIconSvg
                }, null, 8, cL)) : w("", !0),
                Ze(" " + $(f.badge), 1)
              ])) : w("", !0)
            ], 10, aL))), 128))
          ], 8, oL)) : (c(), p("div", nL, [
            g("span", rL, $(e.emptyLabel ?? "No results to display."), 1)
          ]))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "aria-labelledby", "aria-describedby"]));
  }
}), fL = ["id", "for"], hL = { class: "flex items-center gap-0.5" }, bL = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-default)" }, pL = {
  key: 0,
  class: "relative leading-5 font-medium"
}, gL = ["id", "name", "value", "placeholder", "disabled", "required", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "aria-disabled", "aria-invalid", "aria-describedby", "aria-activedescendant"], mL = ["id", "aria-label"], vL = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 dark:text-(--colors-text-white-secondary)"
}, xL = ["id", "data-index", "aria-selected", "aria-disabled", "onMousedown", "onMouseenter"], yL = { class: "min-h-4.5 flex flex-col gap-px" }, kL = ["id"], wL = ["id"], CL = /* @__PURE__ */ ge({
  __name: "TimePickerInput",
  props: {
    modelValue: { default: void 0 },
    label: { default: void 0 },
    placeholder: { default: "HH:mm" },
    required: { type: Boolean, default: !1 },
    requiredIndicator: { default: "*" },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    hint: { default: void 0 },
    size: { default: "md" },
    fullWidth: { type: Boolean, default: !1 },
    width: { default: "384px" },
    minuteStep: { default: 15 },
    minTime: { default: void 0 },
    maxTime: { default: void 0 },
    name: { default: void 0 },
    id: { default: void 0 },
    groupPosition: { default: void 0 },
    ariaLabel: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = N(!1), l = N(""), s = N(-1), i = N(null), d = N(null), u = N(null);
    let f = null;
    const h = () => {
      !d.value || !i.value || (f == null || f.destroy(), f = vo(d.value, i.value, {
        strategy: "fixed",
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top-start"] } },
          { name: "preventOverflow", options: { padding: 8 } },
          Pp
        ]
      }));
    }, b = () => {
      f == null || f.destroy(), f = null;
    }, m = Ke(), v = y(() => n.id || m), x = y(() => n.label ? `${v.value}-label` : void 0), k = y(() => `${v.value}-error`), L = y(() => `${v.value}-hint`), P = y(() => `${v.value}-listbox`), E = y(() => !!n.error), O = y(() => {
      const G = [];
      return E.value ? G.push(k.value) : n.hint && G.push(L.value), G.length > 0 ? G.join(" ") : void 0;
    }), R = y(() => {
      const G = [], H = n.minuteStep;
      for (let z = 0; z < 24 * 60; z += H) {
        const X = Math.floor(z / 60).toString().padStart(2, "0"), Y = (z % 60).toString().padStart(2, "0");
        G.push(`${X}:${Y}`);
      }
      return G;
    }), V = y(() => {
      if (!l.value) return R.value;
      const G = l.value.replace(/[^0-9:]/g, "");
      return R.value.filter((H) => H.includes(G));
    });
    function J(G) {
      const [H, z] = G.split(":").map(Number);
      return H * 60 + z;
    }
    function F(G) {
      if (!n.minTime && !n.maxTime) return !1;
      const H = J(G), z = n.minTime ? J(n.minTime) : 0, X = n.maxTime ? J(n.maxTime) : 24 * 60 - 1;
      return H < z || H > X;
    }
    function A(G) {
      const H = G.findIndex((z) => !F(z));
      return H >= 0 ? H : 0;
    }
    function j(G, H, z) {
      let X = G;
      for (let Y = 0; Y < z.length; Y++) {
        if (X += H, X < 0 || X >= z.length) return G;
        if (!F(z[X])) return X;
      }
      return G;
    }
    const U = {
      sm: {
        container: "h-[36px] px-2.5 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      md: {
        container: "h-[36px] px-3 py-2 gap-2",
        text: "text-sm leading-5",
        icon: "h-4 w-4"
      },
      lg: {
        container: "h-[48px] px-3.5 gap-2",
        text: "text-base leading-6",
        icon: "h-5 w-5"
      }
    }[n.size], W = y(() => n.groupPosition === "start" ? "rounded-r-none! border-r-0!" : n.groupPosition === "end" ? "rounded-l-none!" : ""), K = y(() => {
      const G = "relative rounded-xl border-solid box-border flex items-center text-left font-inter";
      if (n.disabled)
        return `${G} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-gainsboro-200 dark:bg-(--colors-background-disabled) border-border-disabled-subtle dark:border-(--colors-border-disabled-subtle) text-text-disabled dark:text-(--colors-text-disabled)`;
      if (E.value)
        return `${G} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-white dark:bg-(--colors-background-black-default) border-(--border-border-error-strong) dark:border-(--border-border-error) text-text-black-default dark:text-(--colors-text-white-default)`;
      if (a.value)
        return `${G} border-[1px] shadow-[0px_0px_2px_var(--border-border-accent)] bg-(--background-background-selected) dark:bg-[rgba(255,255,255,0.05)] border-(--border-border-accent) text-text-black-default dark:text-(--colors-text-white-default)`;
      const z = n.modelValue !== void 0 && n.modelValue !== "" ? "text-text-black-default" : "text-text-body-subtle";
      return `${G} border-[1px] shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] bg-(--background-background-white) dark:bg-(--colors-background-black-default) border-(--border-border-base-medium) hover:border-(--border-border-accent) dark:border-(--colors-border-base) transition-colors ${z} dark:text-(--colors-text-white-default)`;
    }), le = y(() => n.fullWidth ? "w-full" : ""), C = y(() => n.fullWidth ? {} : { width: n.width }), B = y(() => `relative flex items-start pb-0.5 text-left text-sm text-text-black-default dark:text-(--colors-text-white-default) font-inter flex-col gap-0.5 ${n.fullWidth ? "w-full" : ""}`), I = y(() => n.fullWidth ? {} : { width: n.width }), M = () => {
      if (n.disabled) return;
      o.value = !0, l.value = "";
      const G = R.value.indexOf(n.modelValue || "");
      s.value = G >= 0 ? G : A(R.value), oe();
    }, D = () => {
      o.value = !1, l.value = "", s.value = -1;
    }, re = (G) => {
      var H;
      F(G) || (r("update:modelValue", G), r("change", G), D(), (H = d.value) == null || H.focus());
    }, se = (G) => {
      n.disabled || (a.value = !0, r("focus", G));
    }, de = (G) => {
      setTimeout(() => {
        var H;
        (H = u.value) != null && H.contains(document.activeElement) || (a.value = !1, D(), r("blur", G));
      }, 150);
    }, fe = (G) => {
      const H = G.target;
      l.value = H.value, o.value || M(), s.value = 0;
    }, q = (G) => {
      const H = V.value;
      switch (G.key) {
        case "ArrowDown":
          G.preventDefault(), o.value ? (s.value = j(s.value, 1, H), oe()) : M();
          break;
        case "ArrowUp":
          G.preventDefault(), o.value && (s.value = j(s.value, -1, H), oe());
          break;
        case "Enter":
          G.preventDefault(), o.value && s.value >= 0 && s.value < H.length ? re(H[s.value]) : o.value || M();
          break;
        case "Escape":
          o.value && (G.stopPropagation(), G.preventDefault(), D());
          break;
        case "Tab":
          D();
          break;
      }
    }, oe = () => {
      requestAnimationFrame(() => {
        var H;
        const G = (H = i.value) == null ? void 0 : H.querySelector(`[data-index="${s.value}"]`);
        G == null || G.scrollIntoView({ block: "nearest" });
      });
    }, ue = (G) => {
      u.value && !u.value.contains(G.target) && (D(), a.value = !1);
    };
    return Qe(() => {
      document.addEventListener("mousedown", ue);
    }), nt(() => {
      document.removeEventListener("mousedown", ue), b();
    }), we(o, async (G) => {
      G ? (await Pe(), h()) : b();
    }), we(l, () => {
      s.value = 0;
    }), (G, H) => (c(), p("div", {
      ref_key: "containerRef",
      ref: u,
      class: S(B.value),
      style: Ae(I.value)
    }, [
      e.label ? (c(), p("label", {
        key: 0,
        id: x.value,
        for: v.value,
        class: "flex items-center text-text-black-default dark:text-(--colors-text-white-default)"
      }, [
        g("div", hL, [
          g("div", bL, $(e.label), 1),
          e.required ? (c(), p("div", pL, $(e.requiredIndicator), 1)) : w("", !0)
        ])
      ], 8, fL)) : w("", !0),
      g("div", {
        class: S(["relative", le.value]),
        style: Ae(C.value)
      }, [
        g("div", {
          class: S([K.value, T(U).container, le.value, W.value]),
          style: Ae(C.value),
          onClick: M
        }, [
          g("i", {
            class: S(["ri-time-line flex-shrink-0", [
              T(U).icon,
              e.disabled ? "text-text-disabled dark:text-(--colors-text-disabled)" : a.value ? "text-[#7c86ff]" : "text-gray-400 dark:text-(--colors-text-white-secondary)"
            ]])
          }, null, 2),
          g("input", {
            id: v.value,
            ref_key: "inputRef",
            ref: d,
            type: "text",
            name: e.name,
            value: o.value ? l.value : e.modelValue || "",
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            autocomplete: "off",
            "data-testid": "time-picker-input",
            role: "combobox",
            "aria-expanded": o.value,
            "aria-controls": P.value,
            "aria-labelledby": x.value,
            "aria-label": e.ariaLabel,
            "aria-disabled": e.disabled ? "true" : "false",
            "aria-invalid": E.value ? "true" : void 0,
            "aria-describedby": O.value,
            "aria-activedescendant": o.value && s.value >= 0 ? `${v.value}-option-${s.value}` : void 0,
            class: S([
              "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 focus:border-0 w-full",
              T(U).text,
              !e.disabled && "cursor-text"
            ]),
            onFocus: se,
            onBlur: de,
            onInput: fe,
            onKeydown: q
          }, null, 42, gL)
        ], 6),
        Ar(g("div", {
          id: P.value,
          ref_key: "dropdownRef",
          ref: i,
          role: "listbox",
          "aria-label": e.label || e.ariaLabel || "Time selection",
          class: "fixed z-50 max-h-[200px] overflow-auto rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark)",
          "data-testid": "time-picker-dropdown"
        }, [
          V.value.length === 0 ? (c(), p("div", vL, " Aucun horaire disponible ")) : w("", !0),
          (c(!0), p(Z, null, ke(V.value, (z, X) => (c(), p("div", {
            id: `${v.value}-option-${X}`,
            key: z,
            "data-index": X,
            role: "option",
            "aria-selected": z === e.modelValue,
            "aria-disabled": F(z) ? "true" : void 0,
            class: S(["px-3 py-2 text-sm transition-colors", [
              F(z) ? "cursor-not-allowed text-text-disabled dark:text-(--colors-text-disabled)" : "cursor-pointer",
              !F(z) && z === e.modelValue ? "bg-[#7c86ff]/10 text-[#7c86ff] font-medium" : "",
              !F(z) && z !== e.modelValue && X === s.value ? "bg-gray-100 dark:bg-[rgba(255,255,255,0.08)] text-text-black-default dark:text-(--colors-text-white-default)" : "",
              !F(z) && z !== e.modelValue && X !== s.value ? "text-text-black-default dark:text-(--colors-text-white-default) hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)]" : ""
            ]]),
            onMousedown: Ie((Y) => re(z), ["prevent"]),
            onMouseenter: (Y) => !F(z) && (s.value = X)
          }, $(z), 43, xL))), 128))
        ], 8, mL), [
          [Af, o.value]
        ])
      ], 6),
      g("div", yL, [
        e.hint ? (c(), p("div", {
          key: 0,
          id: L.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-body)"
        }, [
          H[0] || (H[0] = g("i", { class: "ri-error-warning-fill text-sm text-(--colors-icon-dark-default)" }, null, -1)),
          g("span", null, $(e.hint), 1)
        ], 8, kL)) : w("", !0),
        e.error ? (c(), p("div", {
          key: 1,
          id: k.value,
          class: "flex items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
          role: "alert"
        }, [
          H[1] || (H[1] = g("i", { class: "ri-error-warning-fill text-(--text-text-error-strong) dark:text-(--text-text-error)" }, null, -1)),
          g("span", null, $(e.error), 1)
        ], 8, wL)) : w("", !0)
      ])
    ], 6));
  }
}), xV = /* @__PURE__ */ He(CL, [["__scopeId", "data-v-99d21de2"]]), SL = {
  "data-testid": "number-range-input",
  class: "flex flex-col gap-4 w-full"
}, $L = {
  key: 0,
  "data-testid": "number-range-slider",
  class: "relative w-full h-5"
}, IL = ["min", "max", "step", "value", "disabled", "aria-label"], TL = ["min", "max", "step", "value", "disabled", "aria-label"], LL = { class: "flex items-center gap-6 w-full" }, ML = { class: "flex-1 min-w-0" }, EL = ["value", "min", "max", "step", "placeholder", "disabled", "aria-label"], AL = { class: "shrink-0 font-medium text-(length:--size-m) leading-(--line-height-l) text-(--text-text-black-default) dark:text-(--colors-text-white-default)" }, DL = { class: "flex-1 min-w-0" }, RL = ["value", "min", "max", "step", "placeholder", "disabled", "aria-label"], BL = {
  key: 1,
  "data-testid": "number-range-hint",
  class: "text-(length:--size-xs) leading-(--line-height-s) text-(--text-text-body-subtle) dark:text-(--colors-text-body-subtle) m-0"
}, OL = /* @__PURE__ */ ge({
  __name: "NumberRangeInput",
  props: {
    minValue: { default: null },
    maxValue: { default: null },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 },
    minPlaceholder: { default: "0" },
    maxPlaceholder: { default: "" },
    separatorLabel: { default: "to" },
    showSlider: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    minAriaLabel: { default: "Minimum value" },
    maxAriaLabel: { default: "Maximum value" },
    clampInputToBounds: { type: Boolean, default: !0 },
    dataMin: { default: null },
    dataMax: { default: null },
    hintLabel: { default: "" }
  },
  emits: ["update:minValue", "update:maxValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = (P) => Math.max(n.min, Math.min(P, n.max)), a = N(o(n.minValue ?? n.min)), l = N(o(n.maxValue ?? n.max));
    we(
      () => n.minValue,
      (P) => {
        a.value = o(P ?? n.min);
      }
    ), we(
      () => n.maxValue,
      (P) => {
        l.value = o(P ?? n.max);
      }
    );
    const s = y(() => n.max - n.min || 1), i = y(() => (a.value - n.min) / s.value * 100), d = y(() => (l.value - n.min) / s.value * 100), u = y(() => ({
      left: `${i.value}%`,
      width: `${d.value - i.value}%`
    })), f = y(() => i.value > 50), h = y(
      () => n.dataMin != null && n.dataMax != null && n.dataMax > n.dataMin
    ), b = y(
      () => n.dataMin != null ? Math.max(0, Math.min(100, (n.dataMin - n.min) / s.value * 100)) : 0
    ), m = y(
      () => n.dataMax != null ? Math.max(0, Math.min(100, (n.dataMax - n.min) / s.value * 100)) : 100
    );
    function v(P) {
      const E = P.target, O = Number(E.value), R = Math.min(O, l.value - n.step);
      a.value = R, O !== R && (E.value = String(R)), r("update:minValue", R);
    }
    function x(P) {
      const E = P.target, O = Number(E.value), R = Math.max(O, a.value + n.step);
      l.value = R, O !== R && (E.value = String(R)), r("update:maxValue", R);
    }
    function k(P) {
      const E = P.target, O = E.value;
      if (O === "") {
        r("update:minValue", null);
        return;
      }
      const R = Number(O);
      if (Number.isFinite(R))
        if (a.value = o(R), n.clampInputToBounds) {
          const V = o(R);
          R !== V && (E.value = String(V)), r("update:minValue", V);
        } else
          r("update:minValue", R);
    }
    function L(P) {
      const E = P.target, O = E.value;
      if (O === "") {
        r("update:maxValue", null);
        return;
      }
      const R = Number(O);
      if (Number.isFinite(R))
        if (l.value = o(R), n.clampInputToBounds) {
          const V = o(R);
          R !== V && (E.value = String(V)), r("update:maxValue", V);
        } else
          r("update:maxValue", R);
    }
    return (P, E) => (c(), p("div", SL, [
      e.showSlider ? (c(), p("div", $L, [
        E[0] || (E[0] = g("div", { class: "absolute top-1/2 -translate-y-1/2 w-full h-2 rounded-(--border-border-radius-rounded-base) bg-(--background-background-gray)" }, null, -1)),
        h.value ? (c(), p(Z, { key: 0 }, [
          g("div", {
            "data-testid": "number-range-data-marker-min",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ae({ left: `${b.value}%` }),
            "aria-hidden": "true"
          }, null, 4),
          g("div", {
            "data-testid": "number-range-data-marker-max",
            class: "absolute top-1/2 -translate-y-1/2 h-3 w-px bg-(--border-border-base-soft) dark:bg-(--colors-border-base-soft) opacity-80 pointer-events-none",
            style: Ae({ left: `${m.value}%` }),
            "aria-hidden": "true"
          }, null, 4)
        ], 64)) : w("", !0),
        g("div", {
          class: "absolute top-1/2 -translate-y-1/2 h-2 rounded-(--border-border-radius-rounded-base)",
          style: Ae({ ...u.value, background: "linear-gradient(36deg, #716FF2 11%, #52DBF5 87%)" })
        }, null, 4),
        g("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: a.value,
          disabled: e.disabled,
          "aria-label": e.minAriaLabel,
          class: S(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", f.value ? "z-30" : "z-20"]),
          onInput: v
        }, null, 42, IL),
        g("input", {
          type: "range",
          min: e.min,
          max: e.max,
          step: e.step,
          value: l.value,
          disabled: e.disabled,
          "aria-label": e.maxAriaLabel,
          class: S(["range-thumb absolute top-0 left-0 w-full h-5 appearance-none bg-transparent pointer-events-none", f.value ? "z-20" : "z-30"]),
          onInput: x
        }, null, 42, TL)
      ])) : w("", !0),
      g("div", LL, [
        g("div", ML, [
          g("input", {
            type: "number",
            "data-testid": "number-range-min",
            value: e.minValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.minPlaceholder,
            disabled: e.disabled,
            "aria-label": e.minAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: k
          }, null, 40, EL)
        ]),
        g("span", AL, $(e.separatorLabel), 1),
        g("div", DL, [
          g("input", {
            type: "number",
            "data-testid": "number-range-max",
            value: e.maxValue ?? "",
            min: e.clampInputToBounds ? e.min : void 0,
            max: e.clampInputToBounds ? e.max : void 0,
            step: e.step,
            placeholder: e.maxPlaceholder,
            disabled: e.disabled,
            "aria-label": e.maxAriaLabel,
            class: "w-full bg-(--background-background-white) border border-solid border-(--border-border-base-soft) rounded-(--border-border-radius-rounded-l) px-3 py-2 text-(length:--size-m) font-inter leading-(--line-height-l) text-(--text-text-black-default) placeholder:text-(--text-text-body-subtle) outline-none focus:border-royalblue transition-colors disabled:opacity-50",
            onChange: L
          }, null, 40, RL)
        ])
      ]),
      e.hintLabel ? (c(), p("p", BL, $(e.hintLabel), 1)) : w("", !0)
    ]));
  }
}), zp = /* @__PURE__ */ He(OL, [["__scopeId", "data-v-3949cbdf"]]), PL = ["aria-checked", "disabled", "onKeydown"], zL = /* @__PURE__ */ ge({
  __name: "ToggleSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = () => {
      n.disabled || r("update:modelValue", !n.modelValue);
    };
    return (a, l) => (c(), p("button", {
      type: "button",
      role: "switch",
      "aria-checked": e.modelValue,
      disabled: e.disabled,
      class: S(["relative h-5 w-9 shrink-0 rounded-full border transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current", [
        e.modelValue ? "border-(--colors-border-black-default) bg-(--colors-background-black-default) dark:border-(--colors-border-white-default) dark:bg-white" : "border-(--colors-border-secondary-button) bg-(--colors-background-white-secondary) dark:bg-white/10",
        e.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      ]]),
      onClick: o,
      onKeydown: je(Ie(o, ["prevent"]), ["space"])
    }, [
      g("div", {
        class: S([
          "absolute top-px h-4 w-4 rounded-full shadow-sm transition-all duration-200",
          e.modelValue ? "start-[18px] bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-black-default)" : "start-px bg-(--colors-background-black-default) dark:bg-white"
        ])
      }, null, 2)
    ], 42, PL));
  }
}), NL = { class: "flex items-center gap-4 rounded-xl border border-(--colors-border-base-soft) bg-(--colors-background-white) px-4 py-3 shadow-[0px_1px_0.5px_0px_rgba(29,41,61,0.02)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)" }, VL = {
  key: 0,
  class: "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-(--colors-border-base-soft) bg-(--colors-background-tertiary) dark:bg-white/5"
}, FL = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, HL = { class: "truncate text-sm font-medium leading-5 text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, WL = {
  key: 0,
  class: "truncate text-sm font-normal leading-5 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, yV = /* @__PURE__ */ ge({
  __name: "ToggleInput",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    description: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = ht();
    return (n, r) => (c(), p("div", NL, [
      T(t)("icon") ? (c(), p("div", VL, [
        be(n.$slots, "icon")
      ])) : w("", !0),
      g("div", FL, [
        g("span", HL, $(e.label), 1),
        e.description ? (c(), p("span", WL, $(e.description), 1)) : w("", !0)
      ]),
      ae(zL, {
        "model-value": e.modelValue,
        disabled: e.disabled,
        "onUpdate:modelValue": r[0] || (r[0] = (o) => n.$emit("update:modelValue", o))
      }, null, 8, ["model-value", "disabled"])
    ]));
  }
}), jL = ["value", "placeholder", "title", "disabled"], UL = /* @__PURE__ */ ge({
  __name: "CollapsibleSearch",
  props: {
    modelValue: {},
    placeholder: { default: "Search..." },
    labels: { default: () => ({ closeSearch: "Clear search" }) },
    maxWidth: { default: "175px" },
    disabled: { type: Boolean, default: !1 },
    autoFocus: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "expand", "collapse", "clear"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(n.modelValue.length > 0), a = N(null);
    we(
      () => n.modelValue,
      (u) => {
        u.length > 0 && (o.value = !0);
      }
    );
    function l() {
      n.disabled || (o.value = !0, r("expand"), n.autoFocus && Pe(() => {
        var u;
        return (u = a.value) == null ? void 0 : u.focus();
      }));
    }
    function s() {
      n.modelValue.length > 0 || (o.value = !1, r("collapse"));
    }
    function i() {
      r("update:modelValue", ""), r("clear"), o.value = !1;
    }
    function d(u) {
      r("update:modelValue", u.target.value);
    }
    return (u, f) => o.value ? (c(), te(ot, {
      key: 1,
      "enter-active-class": "transition-all duration-200 ease-out",
      "enter-from-class": "opacity-0 w-0!",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-all duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0 w-0!"
    }, {
      default: pe(() => [
        g("div", {
          class: "flex items-center gap-1 overflow-hidden group w-(--cs-w)",
          style: Ae({ "--cs-w": e.maxWidth })
        }, [
          g("i", {
            class: S(["ri-search-line text-base shrink-0 transition-colors text-(--colors-text-body-subtle) group-hover:text-(--colors-text-hover) group-focus-within:text-(--colors-text-hover)", e.modelValue ? "text-(--colors-text-hover)" : ""]),
            "aria-hidden": "true"
          }, null, 2),
          g("input", {
            ref_key: "inputRef",
            ref: a,
            type: "text",
            "data-testid": "collapsible-search-input",
            value: e.modelValue,
            placeholder: e.placeholder,
            title: e.modelValue || void 0,
            disabled: e.disabled,
            class: "flex-1 min-w-0 bg-transparent border-0 outline-none focus:outline-none focus:ring-0 text-sm text-(--colors-text-black-default) dark:text-(--colors-text-white-default) placeholder:text-(--colors-text-body-subtle) text-ellipsis overflow-hidden",
            onInput: d,
            onBlur: s,
            onKeydown: je(i, ["escape"])
          }, null, 40, jL),
          ae($e, {
            variant: "tertiary",
            "icon-left": "ri-close-line",
            "icon-only": "",
            size: "sm",
            "aria-label": e.labels.closeSearch,
            "data-testid": "collapsible-search-clear",
            onClick: i
          }, null, 8, ["aria-label"])
        ], 4)
      ]),
      _: 1
    })) : (c(), te($e, {
      key: 0,
      variant: "tertiary",
      "icon-left": "ri-search-line",
      "icon-only": "",
      size: "xs",
      "aria-label": e.placeholder,
      disabled: e.disabled,
      "data-testid": "collapsible-search-toggle",
      onClick: l
    }, null, 8, ["aria-label", "disabled"]));
  }
}), GL = ["data-testid", "aria-label", "disabled", "onClick"], qL = ["id", "value", "placeholder", "aria-label", "aria-invalid", "aria-describedby", "disabled"], KL = ["id"], JL = /* @__PURE__ */ ge({
  __name: "TagInput",
  props: {
    modelValue: {},
    placeholder: { default: void 0 },
    ariaLabel: { default: void 0 },
    removeLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(""), a = Ke(), l = y(() => `${a}-error`);
    function s(h) {
      o.value = "";
      const b = h.split(",").map((v) => v.trim()).filter((v) => v.length > 0), m = [...n.modelValue];
      for (const v of b)
        m.includes(v) || m.push(v);
      m.length !== n.modelValue.length && r("update:modelValue", m);
    }
    function i(h) {
      const b = h.target.value;
      if (b.endsWith(",")) {
        s(b.slice(0, -1));
        return;
      }
      o.value = b;
    }
    function d(h) {
      h.preventDefault(), s(o.value);
    }
    function u() {
      o.value === "" && n.modelValue.length > 0 && r("update:modelValue", n.modelValue.slice(0, -1));
    }
    function f(h) {
      r("update:modelValue", n.modelValue.filter((b, m) => m !== h));
    }
    return (h, b) => (c(), p("div", {
      class: S(e.fullWidth ? "w-full" : "w-[384px]")
    }, [
      g("div", {
        class: S([
          "flex min-h-[36px] flex-wrap items-center gap-1 rounded-xl border border-solid bg-(--background-background-white) px-2 py-1 dark:bg-(--colors-background-black-default)",
          e.error ? "border-(--border-border-error-strong) dark:border-(--border-border-error)" : "border-(--colors-border-base-medium) dark:border-(--colors-border-base)",
          e.disabled ? "opacity-50" : ""
        ])
      }, [
        (c(!0), p(Z, null, ke(e.modelValue, (m, v) => (c(), p("span", {
          key: `${m}-${v}`,
          class: "inline-flex items-center gap-1 rounded-lg bg-(--colors-background-white-secondary) px-2 py-0.5 text-sm text-(--colors-text-body) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)"
        }, [
          Ze($(m) + " ", 1),
          g("button", {
            "data-testid": `tag-remove-${v}`,
            type: "button",
            class: "ri-close-line cursor-pointer border-0 bg-transparent p-0 text-(--colors-text-body-subtle)",
            "aria-label": `${e.removeLabel ?? ""} ${m}`.trim(),
            disabled: e.disabled,
            onClick: (x) => f(v)
          }, null, 8, GL)
        ]))), 128)),
        g("input", {
          id: T(a),
          value: o.value,
          type: "text",
          class: "min-w-[80px] flex-1 border-0 bg-transparent text-sm text-(--colors-text-body) outline-none dark:text-(--colors-text-white-default)",
          placeholder: e.placeholder,
          "aria-label": e.ariaLabel,
          "aria-invalid": e.error ? "true" : void 0,
          "aria-describedby": e.error ? l.value : void 0,
          disabled: e.disabled,
          onInput: i,
          onKeydown: [
            je(d, ["enter"]),
            je(u, ["delete"])
          ]
        }, null, 40, qL)
      ], 2),
      e.error ? (c(), p("p", {
        key: 0,
        id: l.value,
        class: "mt-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)"
      }, $(e.error), 9, KL)) : w("", !0)
    ], 2));
  }
}), ZL = {
  key: 0,
  class: "inline-flex flex-col gap-1"
}, YL = { class: "flex items-center justify-between px-2" }, XL = {
  key: 0,
  class: "px-px text-sm font-semibold leading-5 text-(--text-text-black-default)"
}, QL = {
  key: 1,
  class: "px-px text-sm font-semibold leading-5 text-(--text-text-black-default)"
}, _L = {
  key: 2,
  role: "tablist",
  class: "inline-flex items-center gap-px shadow-(--blur-shadow-xs)"
}, eM = {
  key: 3,
  class: "flex flex-col rounded-(--border-border-radius-rounded-base) border border-(--border-border-base-medium) bg-white"
}, tM = /* @__PURE__ */ ge({
  __name: "ButtonGroup",
  props: {
    variant: { default: "pill" },
    color: { default: "white" },
    size: { default: "sm" },
    labelLeft: {},
    labelRight: {}
  },
  setup(e) {
    const t = e, n = ur();
    Qe(() => {
      var d;
      const l = ((d = n.default) == null ? void 0 : d.call(n, {})) ?? [], s = t.variant === "tab" ? "tab" : "tertiary";
      l.some((u) => {
        var h;
        const f = (h = u.props) == null ? void 0 : h.variant;
        return f !== void 0 && f !== s;
      }) && console.warn(
        `[ButtonGroup] variant="${t.variant}" expects <Button variant="${s}"> children. Other button variants will not render the active state correctly.`
      );
    });
    const r = y(() => !!(t.labelLeft || t.labelRight)), o = y(
      () => !(t.variant === "pill" && t.color === "white" && t.size === "xs")
    ), a = y(() => [
      "inline-flex items-center pr-px",
      "border border-(--border-border-base-medium)",
      "rounded-(--border-border-radius-rounded-base)",
      o.value && "shadow-(--blur-shadow-xs)",
      t.color === "dark" ? ["bg-(--colors-white-50-opacity-light)", "button-group--dark"] : "bg-(--colors-white-50-opacity-medium)"
    ]);
    return (l, s) => e.variant === "pill" && r.value ? (c(), p("div", ZL, [
      g("div", YL, [
        e.labelLeft ? (c(), p("span", XL, $(e.labelLeft), 1)) : w("", !0),
        e.labelRight ? (c(), p("span", QL, $(e.labelRight), 1)) : w("", !0)
      ]),
      g("div", {
        role: "group",
        class: S(a.value)
      }, [
        be(l.$slots, "default", {}, void 0, !0)
      ], 2)
    ])) : e.variant === "pill" ? (c(), p("div", {
      key: 1,
      role: "group",
      class: S(a.value)
    }, [
      be(l.$slots, "default", {}, void 0, !0)
    ], 2)) : e.variant === "tab" ? (c(), p("div", _L, [
      be(l.$slots, "default", {}, void 0, !0)
    ])) : (c(), p("div", eM, [
      be(l.$slots, "default", {}, void 0, !0)
    ]));
  }
}), ou = /* @__PURE__ */ He(tM, [["__scopeId", "data-v-f4f2a2d5"]]);
function nM(e) {
  const t = N(null), n = N(null);
  function r(s) {
    t.value = s;
  }
  function o(s) {
    t.value !== s && (n.value = s);
  }
  function a(s) {
    const i = t.value;
    if (!i || i === s) return;
    const d = e.value.find((h) => h.id === i), u = e.value.find((h) => h.id === s);
    if (!d || !u || u.disabled) return;
    const f = d.order;
    d.order = u.order, u.order = f, t.value = null, n.value = null;
  }
  function l() {
    t.value = null, n.value = null;
  }
  return { draggedId: t, dragOverId: n, onDragStart: r, onDragOver: o, onDrop: a, onDragEnd: l };
}
const Np = {
  m: "320px",
  l: "498px",
  xl: "768px"
}, rM = ["aria-expanded"], oM = ["src"], aM = { class: "relative leading-5 dark:text-(--colors-text-white-default)" }, lM = ["src"], sM = ["aria-multiselectable"], iM = {
  key: 0,
  class: "flex items-center justify-between"
}, dM = {
  key: 0,
  class: "flex items-center gap-1.5 text-(length:--size-m) font-semibold text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
}, uM = ["src"], cM = { key: 1 }, fM = { key: 1 }, hM = {
  key: 2,
  class: "flex items-center gap-1.5 text-(length:--size-m) font-medium text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, bM = ["src"], pM = { key: 1 }, gM = {
  key: 2,
  class: "flex flex-col gap-1.5 filter-group-buttons"
}, mM = {
  key: 0,
  class: "text-(length:--size-sm) font-medium text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, vM = {
  key: 1,
  class: "mx-4 mt-3 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)"
}, xM = {
  key: 2,
  class: "flex flex-col gap-1 mx-4"
}, yM = ["tabindex", "aria-selected", "aria-disabled"], kM = {
  key: 0,
  class: "pointer-events-none flex shrink-0 items-center"
}, wM = { class: "me-auto text-(length:--size-m) font-medium leading-5" }, CM = {
  key: 1,
  class: "pointer-events-none flex shrink-0 items-center"
}, SM = {
  key: 0,
  class: "flex items-center justify-center px-4 py-6 text-(length:--size-m) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, $M = ["data-testid", "tabindex", "data-listbox-index", "aria-selected", "aria-disabled", "draggable", "onClick", "onKeydown", "onFocus", "onDragstart", "onDragover", "onDrop"], IM = {
  key: 0,
  class: "ri-draggable shrink-0 cursor-grab text-base leading-none text-(--colors-text-body-subtle)",
  "aria-hidden": "true"
}, TM = ["src"], LM = {
  key: 2,
  class: "pointer-events-none flex shrink-0 items-center"
}, MM = {
  key: 3,
  class: "flex shrink-0 items-center"
}, EM = {
  key: 4,
  class: "me-auto flex min-w-0 flex-col gap-0.5"
}, AM = {
  key: 1,
  class: "text-(length:--size-m) font-medium leading-5"
}, DM = { class: "truncate text-(length:--size-sm) leading-4 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)" }, RM = {
  key: 1,
  class: "me-auto text-(length:--size-m) font-medium leading-5"
}, BM = {
  key: 6,
  class: "shrink-0 text-(length:--size-m) font-medium leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, OM = {
  key: 7,
  class: "pointer-events-none flex shrink-0 items-center"
}, PM = ["onClick"], zM = {
  key: 4,
  class: "flex items-center justify-center px-4 py-6 text-(length:--size-m) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, NM = {
  key: 0,
  class: "mx-4 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)"
}, VM = {
  key: 1,
  class: "mx-4 mt-3 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)"
}, FM = { class: "flex flex-col gap-2 px-4 pb-4 pt-3" }, HM = {
  key: 0,
  class: "text-(length:--size-sm) font-medium text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, WM = {
  key: 1,
  class: "flex items-center gap-3"
}, jM = ["data-testid"], UM = ["onClick"], GM = ["src"], qM = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "FilterDropdown",
  props: {
    label: { default: "Filters" },
    triggerIconLeft: { default: void 0 },
    triggerIcon: { default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    size: { default: void 0 },
    menuWidth: { default: "auto" },
    menuAlign: { default: "left" },
    tab: { type: Boolean, default: !1 },
    headerLabelLeft: { default: void 0 },
    headerLabelRight: { default: void 0 },
    showSearch: { type: Boolean, default: !1 },
    searchQuery: { default: "" },
    searchPlaceholder: { default: "Search…" },
    groupButtons: { default: () => [] },
    groupButtonsLabel: { default: void 0 },
    activeGroupButton: { default: void 0 },
    items: { default: () => [] },
    maxListHeight: { default: void 0 },
    reserveListHeight: { type: Boolean, default: !1 },
    emptyLabel: { default: void 0 },
    checkboxPosition: { default: "right" },
    footerLabel: { default: void 0 },
    footerButtons: { default: () => [] },
    stickyItem: { default: void 0 },
    disableInternalSearchFilter: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    freezeOnOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:searchQuery", "update:activeGroupButton", "open", "close", "reorder"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n, { isOpen: a, dropdownRef: l, toggleDropdown: s, openDropdown: i, closeDropdown: d } = wa({
      defaultOpen: r.defaultOpen,
      ignoreSelectors: ['[data-testid="filter-dropdown-more-menu-backdrop"]', '[data-testid="filter-dropdown-more-menu"]']
    }), u = N(null), f = N(null), h = N(null);
    function b() {
      if (!r.freezeOnOpen) return;
      const ie = u.value ?? l.value;
      if (!ie) return;
      const me = ie.getBoundingClientRect();
      h.value = r.menuAlign === "right" ? { top: me.bottom + 4, right: Math.max(0, window.innerWidth - me.right) } : { top: me.bottom + 4, left: me.left };
    }
    const m = (ie) => {
      a.value && (ie.stopPropagation(), ie.preventDefault(), d(), Pe(() => {
        var me;
        return (me = u.value) == null ? void 0 : me.focus();
      }));
    }, v = (ie) => {
      var me;
      ie.disabled || ((me = ie.onClick) == null || me.call(ie), ie.keepOpen || (d(), Pe(() => {
        var Q;
        return (Q = u.value) == null ? void 0 : Q.focus();
      })));
    }, x = (ie) => !!ie && ie.startsWith("ri-"), k = y(() => {
      var Q, ee;
      let ie = r.items ?? [];
      r.activeGroupButton && ((Q = r.groupButtons) != null && Q.length) && (ie = ie.filter((ve) => !ve.group || ve.group === r.activeGroupButton));
      const me = (ee = r.searchQuery) == null ? void 0 : ee.trim().toLowerCase();
      return me && !r.disableInternalSearchFilter && (ie = ie.filter((ve) => ve.label.toLowerCase().includes(me))), ie;
    }), L = N([]);
    we(
      k,
      (ie) => {
        L.value = ie.map((me, Q) => ({ id: me.id, order: Q, disabled: me.disabled }));
      },
      { immediate: !0, deep: !1 }
    );
    const { onDragStart: P, onDragOver: E, onDrop: O, onDragEnd: R } = nM(L), V = y(() => {
      if (!r.reorderable) return k.value;
      const ie = new Map(k.value.map((me) => [me.id, me]));
      return [...L.value].sort((me, Q) => me.order - Q.order).map((me) => ie.get(me.id)).filter((me) => !!me);
    });
    function J(ie) {
      O(ie), o("reorder", [...L.value].sort((me, Q) => me.order - Q.order).map((me) => me.id));
    }
    const F = y(() => !!(r.headerLabelLeft || r.headerLabelRight)), A = y(() => r.showSearch), j = y(() => {
      var ie;
      return !!((ie = r.groupButtons) != null && ie.length);
    }), _ = y(() => F.value || A.value || j.value), U = y(() => !!r.stickyItem), W = y(
      () => {
        var ie, me, Q;
        return !!((ie = r.items) != null && ie.some((ee) => ee.hasCheckbox || ee.hasSwitch)) || !!((me = r.stickyItem) != null && me.hasCheckbox) || !!((Q = r.stickyItem) != null && Q.hasSwitch);
      }
    ), {
      focusedIndex: K,
      focusListboxOption: le,
      handleRovingKeydown: C,
      clampFocusedIndex: B,
      firstEnabledIndex: I,
      lastEnabledIndex: M
    } = cl();
    function D(ie) {
      return U.value ? ie + 1 : ie;
    }
    const re = y(
      () => V.value.length + (U.value ? 1 : 0)
    );
    function se(ie) {
      var me, Q, ee;
      return U.value ? ie === 0 ? !!((me = r.stickyItem) != null && me.disabled) : !!((Q = V.value[ie - 1]) != null && Q.disabled) : !!((ee = V.value[ie]) != null && ee.disabled);
    }
    function de(ie) {
      const me = ie.target;
      if (!(me instanceof HTMLTextAreaElement || me instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit", "reset"].includes(me.type))) {
        C(ie, re.value, f.value, se);
        return;
      }
      if (ie.key !== "ArrowDown" && ie.key !== "ArrowUp") return;
      const ee = re.value;
      if (!ee) return;
      ie.preventDefault();
      const ve = ie.key === "ArrowDown" ? I(ee, se) : M(ee, se);
      K.value = ve, le(f.value, ve);
    }
    we(re, (ie) => B(ie));
    const fe = y(() => k.value.length > 0), q = y(() => !fe.value && !!r.emptyLabel), oe = y(
      () => fe.value || !!r.maxListHeight && r.reserveListHeight
    ), ue = y(() => {
      var ie;
      return !!(r.footerLabel || (ie = r.footerButtons) != null && ie.length);
    }), G = N(null), H = N({ top: 0, right: 0 }), z = y(
      () => G.value ? (r.items ?? []).find((ie) => ie.id === G.value) : null
    ), X = (ie, me) => {
      if (ie.stopPropagation(), G.value === me) {
        G.value = null;
        return;
      }
      const ee = ie.currentTarget.getBoundingClientRect();
      H.value = {
        top: ee.bottom + 4,
        right: window.innerWidth - ee.right
      }, G.value = me;
    }, Y = () => {
      G.value = null;
    }, ce = (ie, me) => {
      var Q;
      ie.stopPropagation(), (Q = me.onClick) == null || Q.call(me), Y();
    };
    function ne() {
      i(), Pe(() => {
        const ie = f.value;
        if (!ie) return;
        (ie.querySelector('input:not([type="checkbox"])') ?? ie).focus();
      });
    }
    t({ openDropdown: ne, closeDropdown: d, isOpen: a }), we(a, (ie) => {
      ie ? (b(), o("open")) : (Y(), h.value = null, o("close"));
    });
    const ye = y(() => r.size ? { width: Np[r.size] } : r.menuWidth && r.menuWidth !== "auto" ? { width: r.menuWidth, maxWidth: "594px" } : { maxWidth: "594px" }), he = y(() => {
      if (!h.value) return ye.value;
      const ie = { position: "fixed", top: `${h.value.top}px` };
      return h.value.left !== void 0 ? ie.left = `${h.value.left}px` : h.value.right !== void 0 && (ie.right = `${h.value.right}px`), { ...ie, ...ye.value };
    });
    return (ie, me) => (c(), p(Z, null, [
      g("div", Je({
        ref_key: "dropdownRef",
        ref: l
      }, ie.$attrs, {
        class: ["relative dark:text-(--colors-text-white-default)", e.tab ? "flex h-full items-stretch" : "inline-block text-left"],
        onKeydown: je(m, ["escape"])
      }), [
        be(ie.$slots, "trigger", {
          toggle: T(s),
          isOpen: T(a)
        }, () => [
          g("button", {
            ref_key: "triggerRef",
            ref: u,
            type: "button",
            "data-testid": "filter-dropdown-trigger",
            class: S([
              "inline-flex cursor-pointer items-center gap-1.5 font-medium",
              e.tab ? "shrink-0 h-full rounded-tl-md rounded-tr-md border-t border-r border-b border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-sm text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10 transition-colors duration-200 px-3" : "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2 z-0 rounded-[9999px] border border-solid border-border-secondary-button bg-white px-3 py-2 text-(length:--size-m) transition-colors duration-300 hover:border-royalblue dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
            ]),
            "aria-expanded": T(a),
            "aria-haspopup": "listbox",
            onClick: me[0] || (me[0] = //@ts-ignore
            (...Q) => T(s) && T(s)(...Q))
          }, [
            e.triggerIconLeft ? (c(), p(Z, { key: 0 }, [
              x(e.triggerIconLeft) ? (c(), p("i", {
                key: 0,
                class: S([e.triggerIconLeft, "text-base leading-none"])
              }, null, 2)) : (c(), p("img", {
                key: 1,
                class: "h-4 w-4",
                src: e.triggerIconLeft,
                alt: ""
              }, null, 8, oM))
            ], 64)) : w("", !0),
            g("span", aM, $(e.label), 1),
            e.triggerIcon ? (c(), p(Z, { key: 1 }, [
              x(e.triggerIcon) ? (c(), p("i", {
                key: 0,
                class: S([
                  e.triggerIcon,
                  "text-base leading-none transition-transform duration-200 ease-in-out"
                ]),
                style: Ae({ transform: T(a) ? "rotate(180deg)" : "rotate(0deg)" })
              }, null, 6)) : (c(), p("img", {
                key: 1,
                class: "h-4 w-4 transition-transform duration-200 ease-in-out",
                style: Ae({ transform: T(a) ? "rotate(180deg)" : "rotate(0deg)" }),
                src: e.triggerIcon,
                alt: ""
              }, null, 12, lM))
            ], 64)) : (c(), p("svg", {
              key: 2,
              class: "h-4 w-4 transition-transform duration-200 ease-in-out",
              style: Ae({ transform: T(a) ? "rotate(180deg)" : "rotate(0deg)" }),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [...me[7] || (me[7] = [
              g("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ])], 4))
          ], 10, rM)
        ], !0),
        ae(ot, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: pe(() => {
            var Q;
            return [
              T(a) ? (c(), p("div", {
                key: 0,
                ref_key: "menuRef",
                ref: f,
                role: "listbox",
                "aria-multiselectable": W.value ? "true" : void 0,
                "data-testid": "filter-dropdown-menu",
                tabindex: "-1",
                class: S(["bg-white-50-opacity-bold border-border-base-soft z-50 flex min-w-[220px] flex-col rounded-(--border-border-radius-rounded-l) border border-solid shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)", h.value ? "" : ["absolute top-full mt-1", e.menuAlign === "right" ? "right-0" : "left-0"]]),
                style: Ae(he.value),
                onKeydown: de
              }, [
                _.value ? (c(), p("div", {
                  key: 0,
                  class: S([
                    "relative flex flex-col gap-3 px-4 pt-4",
                    // Same condition as the divider below: the band treatment applies whenever
                    // ANY content sits under the header — including the sticky row and the
                    // empty state, so an empty search keeps the elevation and the header
                    // doesn't reflow by 16px while typing.
                    U.value || oe.value || q.value || ue.value ? (
                      // Figma 'Dropdown header' band elevation above the list; `relative`
                      // keeps the shadow painting over the rows below. The clip-path lets
                      // only the DOWNWARD cast through — this panel has no overflow-hidden,
                      // so an unclipped shadow would bleed outside its rounded edges.
                      "pb-0 shadow-(--shadow-bottom-dropdown) dark:shadow-(--shadow-bottom-dropdown-dark) [clip-path:inset(0_0_-20px_0)]"
                    ) : "pb-4"
                  ])
                }, [
                  F.value ? (c(), p("div", iM, [
                    e.headerLabelLeft ? (c(), p("div", dM, [
                      e.headerLabelLeft.icon ? (c(), p(Z, { key: 0 }, [
                        x(e.headerLabelLeft.icon) ? (c(), p("i", {
                          key: 0,
                          class: S([e.headerLabelLeft.icon, "text-base leading-none"])
                        }, null, 2)) : (c(), p("img", {
                          key: 1,
                          class: "h-4 w-4",
                          src: e.headerLabelLeft.icon,
                          alt: ""
                        }, null, 8, uM))
                      ], 64)) : w("", !0),
                      e.headerLabelLeft.text ? (c(), p("span", cM, $(e.headerLabelLeft.text), 1)) : w("", !0)
                    ])) : (c(), p("div", fM)),
                    e.headerLabelRight ? (c(), p("div", hM, [
                      e.headerLabelRight.icon ? (c(), p(Z, { key: 0 }, [
                        x(e.headerLabelRight.icon) ? (c(), p("i", {
                          key: 0,
                          class: S([e.headerLabelRight.icon, "text-base leading-none"])
                        }, null, 2)) : (c(), p("img", {
                          key: 1,
                          class: "h-4 w-4",
                          src: e.headerLabelRight.icon,
                          alt: ""
                        }, null, 8, bM))
                      ], 64)) : w("", !0),
                      e.headerLabelRight.text ? (c(), p("span", pM, $(e.headerLabelRight.text), 1)) : w("", !0)
                    ])) : w("", !0)
                  ])) : w("", !0),
                  A.value ? (c(), te(T(Rr), {
                    key: 1,
                    "model-value": e.searchQuery,
                    placeholder: e.searchPlaceholder,
                    size: "sm",
                    "full-width": "",
                    rounded: "xl",
                    "onUpdate:modelValue": me[1] || (me[1] = (ee) => o("update:searchQuery", ee))
                  }, null, 8, ["model-value", "placeholder"])) : w("", !0),
                  j.value ? (c(), p("div", gM, [
                    e.groupButtonsLabel ? (c(), p("span", mM, $(e.groupButtonsLabel), 1)) : w("", !0),
                    ae(T(ou), {
                      class: "w-full gap-1 p-1",
                      color: "dark"
                    }, {
                      default: pe(() => [
                        (c(!0), p(Z, null, ke(e.groupButtons, (ee) => (c(), te(T($e), {
                          key: ee.value,
                          variant: "tertiary",
                          label: ee.label,
                          active: e.activeGroupButton === ee.value,
                          class: "flex-1 justify-center",
                          onClick: (ve) => o("update:activeGroupButton", ee.value)
                        }, null, 8, ["label", "active", "onClick"]))), 128))
                      ]),
                      _: 1
                    })
                  ])) : w("", !0)
                ], 2)) : w("", !0),
                _.value && (U.value || oe.value || q.value) ? (c(), p("div", vM)) : w("", !0),
                U.value ? (c(), p("div", xM, [
                  g("div", {
                    role: "option",
                    tabindex: T(K) === 0 ? 0 : -1,
                    "data-listbox-index": "0",
                    class: S(["flex w-full cursor-pointer items-center gap-1.5 py-4 text-(--colors-text-black-default) dark:text-(--colors-text-white-default) border-b border-(--color-border-base-soft) dark:border-(--colors-border-base) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", e.stickyItem.disabled ? "cursor-not-allowed opacity-40" : ""]),
                    "aria-selected": e.stickyItem.checked,
                    "aria-disabled": e.stickyItem.disabled ? "true" : void 0,
                    onClick: me[2] || (me[2] = (ee) => {
                      var ve, Le;
                      return !e.stickyItem.disabled && ((Le = (ve = e.stickyItem).onClick) == null ? void 0 : Le.call(ve));
                    }),
                    onKeydown: [
                      me[3] || (me[3] = je(Ie((ee) => {
                        var ve, Le;
                        return !e.stickyItem.disabled && ((Le = (ve = e.stickyItem).onClick) == null ? void 0 : Le.call(ve));
                      }, ["self", "prevent"]), ["enter"])),
                      me[4] || (me[4] = je(Ie((ee) => {
                        var ve, Le;
                        return !e.stickyItem.disabled && ((Le = (ve = e.stickyItem).onClick) == null ? void 0 : Le.call(ve));
                      }, ["self", "prevent"]), ["space"]))
                    ],
                    onFocus: me[5] || (me[5] = (ee) => K.value = 0)
                  }, [
                    e.stickyItem.hasCheckbox && e.checkboxPosition === "left" ? (c(), p("div", kM, [
                      ae(T(Xt), {
                        presentational: "",
                        "model-value": e.stickyItem.checked ?? !1,
                        indeterminate: e.stickyItem.indeterminate,
                        disabled: e.stickyItem.disabled
                      }, null, 8, ["model-value", "indeterminate", "disabled"])
                    ])) : w("", !0),
                    g("span", wM, $(e.stickyItem.label), 1),
                    e.stickyItem.hasCheckbox && e.checkboxPosition === "right" ? (c(), p("div", CM, [
                      ae(T(Xt), {
                        presentational: "",
                        "model-value": e.stickyItem.checked ?? !1,
                        indeterminate: e.stickyItem.indeterminate,
                        disabled: e.stickyItem.disabled
                      }, null, 8, ["model-value", "indeterminate", "disabled"])
                    ])) : w("", !0)
                  ], 42, yM)
                ])) : w("", !0),
                oe.value ? (c(), p("div", {
                  key: 3,
                  class: S(["flex flex-col gap-1 p-2", {
                    "overflow-y-auto": !!e.maxListHeight,
                    "items-center justify-center": e.reserveListHeight && !fe.value
                  }]),
                  style: Ae(e.maxListHeight ? { [e.reserveListHeight ? "height" : "maxHeight"]: e.maxListHeight } : {})
                }, [
                  fe.value ? (c(!0), p(Z, { key: 1 }, ke(V.value, (ee, ve) => {
                    var Le;
                    return c(), p("div", {
                      key: ee.id,
                      role: "option",
                      "data-testid": `filter-dropdown-item-${ee.id}`,
                      tabindex: T(K) === D(ve) ? 0 : -1,
                      "data-listbox-index": D(ve),
                      class: S(["filter-item-row group relative flex w-full cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2 text-(--colors-text-black-default) transition-colors hover:bg-(--colors-background-hover) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) dark:text-(--colors-text-white-default) dark:hover:bg-white/8 dark:hover:text-(--text-text-white-default)", ee.disabled ? "cursor-not-allowed opacity-40" : ""]),
                      "aria-selected": ee.checked || ee.switchChecked,
                      "aria-disabled": ee.disabled ? "true" : void 0,
                      draggable: e.reorderable && !ee.disabled,
                      onClick: (We) => {
                        var qe;
                        return !ee.disabled && ((qe = ee.onClick) == null ? void 0 : qe.call(ee));
                      },
                      onKeydown: [
                        je(Ie((We) => {
                          var qe;
                          return !ee.disabled && ((qe = ee.onClick) == null ? void 0 : qe.call(ee));
                        }, ["self", "prevent"]), ["enter"]),
                        je(Ie((We) => {
                          var qe;
                          return !ee.disabled && ((qe = ee.onClick) == null ? void 0 : qe.call(ee));
                        }, ["self", "prevent"]), ["space"])
                      ],
                      onFocus: (We) => K.value = D(ve),
                      onDragstart: (We) => e.reorderable && T(P)(ee.id),
                      onDragover: Ie((We) => e.reorderable && T(E)(ee.id), ["prevent"]),
                      onDrop: (We) => e.reorderable && J(ee.id),
                      onDragend: me[6] || (me[6] = (We) => e.reorderable && T(R)())
                    }, [
                      e.reorderable ? (c(), p("i", IM)) : w("", !0),
                      ee.icon ? (c(), p(Z, { key: 1 }, [
                        x(ee.icon) ? (c(), p("i", {
                          key: 0,
                          class: S([ee.icon, "shrink-0 text-base leading-none"])
                        }, null, 2)) : (c(), p("img", {
                          key: 1,
                          class: "h-4 w-4 shrink-0",
                          src: ee.icon,
                          alt: ""
                        }, null, 8, TM))
                      ], 64)) : w("", !0),
                      ee.hasCheckbox && e.checkboxPosition === "left" ? (c(), p("div", LM, [
                        ae(T(Xt), {
                          presentational: "",
                          "model-value": ee.checked ?? !1,
                          indeterminate: ee.indeterminate,
                          disabled: ee.disabled
                        }, null, 8, ["model-value", "indeterminate", "disabled"])
                      ])) : w("", !0),
                      ee.hasSwitch ? (c(), p("div", MM, [
                        g("div", {
                          class: S([
                            "relative h-5 w-9 rounded-full border transition-colors duration-200",
                            ee.switchChecked ? "border-(--colors-border-black-default) bg-(--colors-background-black-default) dark:border-(--colors-border-white-default) dark:bg-white" : "border-(--colors-border-secondary-button) bg-(--colors-background-white-secondary) dark:bg-white/10"
                          ])
                        }, [
                          g("div", {
                            class: S([
                              "absolute top-px h-4 w-4 rounded-full shadow-sm transition-transform duration-200",
                              ee.switchChecked ? "start-[18px] bg-(--colors-background-white-secondary-soft) dark:bg-(--colors-background-black-default)" : "start-px bg-(--colors-background-black-default) dark:bg-white"
                            ])
                          }, null, 2)
                        ], 2)
                      ])) : w("", !0),
                      ee.secondaryText ? (c(), p("div", EM, [
                        ee.badgeTheme ? (c(), te(T(pt), {
                          key: 0,
                          label: ee.label,
                          theme: ee.badgeTheme ?? "grey",
                          "show-close-icon": !1,
                          size: "sm"
                        }, null, 8, ["label", "theme"])) : (c(), p("span", AM, $(ee.label), 1)),
                        g("span", DM, $(ee.secondaryText), 1)
                      ])) : (c(), p(Z, { key: 5 }, [
                        ee.badgeTheme ? (c(), te(T(pt), {
                          key: 0,
                          label: ee.label,
                          theme: ee.badgeTheme ?? "grey",
                          "show-close-icon": !1,
                          size: "sm",
                          class: "me-auto"
                        }, null, 8, ["label", "theme"])) : (c(), p("span", RM, $(ee.label), 1))
                      ], 64)),
                      ee.count !== void 0 ? (c(), p("span", BM, "(" + $(ee.count) + ")", 1)) : w("", !0),
                      ee.hasCheckbox && e.checkboxPosition === "right" ? (c(), p("div", OM, [
                        ae(T(Xt), {
                          presentational: "",
                          "model-value": ee.checked ?? !1,
                          indeterminate: ee.indeterminate,
                          disabled: ee.disabled
                        }, null, 8, ["model-value", "indeterminate", "disabled"])
                      ])) : w("", !0),
                      (Le = ee.moreActions) != null && Le.length ? (c(), p("button", {
                        key: 8,
                        type: "button",
                        class: "shrink-0 flex items-center justify-center w-6 h-6 rounded text-(--colors-text-body) hover:bg-gainsboro dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10",
                        onClick: Ie((We) => X(We, ee.id), ["stop"])
                      }, [...me[8] || (me[8] = [
                        g("i", { class: "ri-more-fill text-base leading-none" }, null, -1)
                      ])], 8, PM)) : w("", !0)
                    ], 42, $M);
                  }), 128)) : (c(), p(Z, { key: 0 }, [
                    q.value ? (c(), p("div", SM, $(e.emptyLabel), 1)) : w("", !0)
                  ], 64))
                ], 6)) : w("", !0),
                q.value && !oe.value ? (c(), p("div", zM, $(e.emptyLabel), 1)) : w("", !0),
                ue.value ? (c(), p(Z, { key: 5 }, [
                  oe.value || q.value ? (c(), p("div", NM)) : _.value ? (c(), p("div", VM)) : w("", !0),
                  g("div", FM, [
                    e.footerLabel ? (c(), p("span", HM, $(e.footerLabel), 1)) : w("", !0),
                    (Q = e.footerButtons) != null && Q.length ? (c(), p("div", WM, [
                      (c(!0), p(Z, null, ke(e.footerButtons, (ee, ve) => (c(), p("div", {
                        key: ve,
                        "data-testid": `filter-footer-btn-${ve}`,
                        class: "flex-1"
                      }, [
                        ae(T($e), {
                          variant: ee.variant ?? "secondary",
                          label: ee.label,
                          disabled: ee.disabled,
                          size: "sm",
                          "full-width": "",
                          onClick: (Le) => v(ee)
                        }, null, 8, ["variant", "label", "disabled", "onClick"])
                      ], 8, jM))), 128))
                    ])) : w("", !0)
                  ])
                ], 64)) : w("", !0)
              ], 46, sM)) : w("", !0)
            ];
          }),
          _: 1
        })
      ], 16),
      (c(), te(cn, { to: "body" }, [
        G.value ? (c(), p("div", {
          key: 0,
          class: "fixed inset-0 z-[199]",
          "data-testid": "filter-dropdown-more-menu-backdrop",
          onClick: Ie(Y, ["stop"])
        })) : w("", !0),
        ae(ot, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: pe(() => [
            z.value ? (c(), p("div", {
              key: 0,
              class: "fixed z-[200] min-w-[160px] overflow-hidden rounded-(--border-border-radius-rounded-l) border border-solid border-border-base-soft bg-white-50-opacity-bold py-1 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
              "data-focus-trap-allow-outside": "",
              "data-testid": "filter-dropdown-more-menu",
              style: Ae({ top: H.value.top + "px", right: H.value.right + "px" })
            }, [
              (c(!0), p(Z, null, ke(z.value.moreActions, (Q) => (c(), p("button", {
                key: Q.label,
                type: "button",
                class: S([
                  "flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-(length:--size-m) font-medium transition-colors hover:bg-background-hover dark:hover:bg-white/8",
                  Q.variant === "danger" ? "text-red-500 dark:text-red-400" : "text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
                ]),
                onClick: Ie((ee) => ce(ee, Q), ["stop"])
              }, [
                Q.icon ? (c(), p(Z, { key: 0 }, [
                  x(Q.icon) ? (c(), p("i", {
                    key: 0,
                    class: S([Q.icon, "shrink-0 text-base leading-none"])
                  }, null, 2)) : (c(), p("img", {
                    key: 1,
                    class: "h-4 w-4 shrink-0",
                    src: Q.icon,
                    alt: ""
                  }, null, 8, GM))
                ], 64)) : w("", !0),
                g("span", null, $(Q.label), 1)
              ], 10, UM))), 128))
            ], 4)) : w("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), au = /* @__PURE__ */ He(qM, [["__scopeId", "data-v-dfb00172"]]), KM = ["aria-label"], JM = ["src"], ZM = { class: "leading-5 font-medium" }, kV = /* @__PURE__ */ ge({
  __name: "SortDropdown",
  props: {
    modelValue: {},
    options: {},
    ariaLabel: { default: void 0 },
    align: { default: "right" },
    triggerIconLeft: { default: "ri-filter-3-fill" },
    headerLabel: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(
      () => {
        var i;
        return ((i = n.options.find((d) => d.value === n.modelValue)) == null ? void 0 : i.label) ?? "";
      }
    ), a = y(() => n.options.length === 1), l = y(
      () => n.options.map((i) => ({
        label: i.label,
        active: i.value === n.modelValue,
        testId: `sort-option-${i.value}`,
        onClick: () => r("update:modelValue", i.value)
      }))
    ), s = (i) => !!i && i.startsWith("ri-");
    return (i, d) => a.value ? (c(), p("div", {
      key: 0,
      class: "inline-flex items-center gap-1.5 px-3 py-2 text-(length:--size-m) text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
      "aria-label": e.ariaLabel,
      "data-testid": "sort-dropdown-static"
    }, [
      e.triggerIconLeft ? (c(), p(Z, { key: 0 }, [
        s(e.triggerIconLeft) ? (c(), p("i", {
          key: 0,
          class: S([e.triggerIconLeft, "text-base leading-none"]),
          "aria-hidden": "true"
        }, null, 2)) : (c(), p("img", {
          key: 1,
          class: "relative h-4 w-4",
          src: e.triggerIconLeft,
          alt: ""
        }, null, 8, JM))
      ], 64)) : w("", !0),
      g("span", ZM, $(o.value), 1)
    ], 8, KM)) : (c(), te(kn, {
      key: 1,
      label: o.value,
      "trigger-icon-left": e.triggerIconLeft,
      "trigger-icon": "ri-arrow-down-s-line",
      items: l.value,
      "menu-align": e.align,
      "menu-header": e.headerLabel,
      "aria-label": e.ariaLabel,
      ghost: "",
      "data-testid": "sort-dropdown"
    }, null, 8, ["label", "trigger-icon-left", "items", "menu-align", "menu-header", "aria-label"]));
  }
}), YM = {
  role: "navigation",
  "aria-label": "Pagination",
  class: "relative w-full flex items-center text-left text-[12px] text-[#242424] dark:text-[var(--colors-text-white-default)] font-inter"
}, XM = ["disabled"], QM = {
  key: 0,
  class: "h-3.5 w-3.5 relative pagination-icon",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, _M = ["disabled", "onClick"], eE = {
  key: 2,
  class: "w-auto min-w-[80px] bg-white dark:bg-[var(--colors-background-black-default)] border-[#242424] dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex items-center justify-center py-[8px] px-[12px] ml-[-1px] relative"
}, tE = { class: "relative leading-[20px] font-medium text-[12px] text-[#242424] dark:text-[var(--colors-text-white-default)]" }, nE = ["disabled"], rE = {
  key: 1,
  class: "h-3.5 w-3.5 relative pagination-icon",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, oE = /* @__PURE__ */ ge({
  __name: "Pagination",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    totalItems: { default: 0 },
    itemsPerPage: { default: 10 },
    mode: { default: "icons-text" },
    showNavigation: { type: Boolean, default: !0 },
    maxVisiblePages: { default: 8 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["page-change"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => {
      const h = [], b = n.totalPages, m = n.currentPage, v = n.maxVisiblePages;
      if (b <= v)
        for (let x = 1; x <= b; x++)
          h.push(x);
      else if (m <= 4) {
        for (let x = 1; x <= v - 1; x++)
          h.push(x);
        h.push("ellipsis"), h.push(b);
      } else if (m >= b - 3) {
        h.push(1), h.push("ellipsis");
        for (let x = b - v + 2; x <= b; x++)
          h.push(x);
      } else {
        h.push(1), h.push("ellipsis");
        const x = Math.max(2, m - 2), k = Math.min(b - 1, m + 2);
        for (let L = x; L <= k; L++)
          h.push(L);
        h.push("ellipsis"), h.push(b);
      }
      return h;
    }), a = y(() => n.currentPage > 1 && !n.disabled), l = y(() => n.currentPage < n.totalPages && !n.disabled), s = (h) => {
      n.disabled || h < 1 || h > n.totalPages || h !== n.currentPage && r("page-change", h);
    }, i = () => {
      a.value && s(n.currentPage - 1);
    }, d = () => {
      l.value && s(n.currentPage + 1);
    }, u = y(() => {
      const h = n.mode === "text-only" || n.mode === "icons-text";
      return `${`group self-stretch ${h ? "w-auto min-w-[80px]" : "w-8"} ${h ? "py-[8px] px-[12px]" : ""} bg-white dark:bg-[var(--colors-background-black-default)] border-[#242424] dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex items-center justify-center transition-colors duration-200 text-[#242424] dark:text-[var(--colors-text-white-default)]`} ${n.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-[#E5E7EB] dark:hover:bg-[var(--colors-background-hover)]"}`;
    }), f = (h) => {
      const b = "group w-9 border-[#242424] dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex items-center justify-center py-[8px] px-[12px] ml-[-1px] relative text-[12px] leading-[20px] font-medium transition-colors duration-200", m = h === n.currentPage ? "bg-[#242424] dark:bg-white text-[#F2F0F0] dark:text-[#242424]" : "bg-white dark:bg-[var(--colors-background-black-default)] text-[#242424] dark:text-[var(--colors-text-white-default)] cursor-pointer hover:bg-[#E5E7EB] dark:hover:bg-[var(--colors-background-hover)]", v = n.disabled ? "opacity-50 cursor-not-allowed" : "";
      return `${b} ${m} ${v}`;
    };
    return (h, b) => (c(), p("nav", YM, [
      e.showNavigation ? (c(), p("button", {
        key: 0,
        type: "button",
        "data-testid": "pagination-previous",
        disabled: !a.value,
        class: S([
          u.value,
          (e.mode === "icons-only" || e.mode === "icons-text" || e.mode === "compact", "rounded-tl-[9999px] rounded-tr-none rounded-br-none rounded-bl-[9999px]")
        ]),
        onClick: i
      }, [
        e.mode === "icons-only" || e.mode === "icons-text" || e.mode === "compact" ? (c(), p("svg", QM, [...b[0] || (b[0] = [
          g("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 19l-7-7 7-7"
          }, null, -1)
        ])])) : w("", !0),
        e.mode === "text-only" || e.mode === "icons-text" ? (c(), p("span", {
          key: 1,
          class: S(["relative leading-[20px] font-medium group-hover:text-text-black-default dark:group-hover:text-text-black-default", e.mode === "icons-text" ? "ml-1" : ""])
        }, $(e.previousLabel), 3)) : w("", !0)
      ], 10, XM)) : w("", !0),
      e.mode !== "compact" ? (c(!0), p(Z, { key: 1 }, ke(o.value, (m, v) => (c(), p("button", {
        key: `page-${v}`,
        type: "button",
        "data-testid": "pagination-page",
        disabled: e.disabled || m === "ellipsis" || m === e.currentPage,
        class: S(f(typeof m == "number" ? m : 0)),
        onClick: (x) => typeof m == "number" && s(m)
      }, [
        g("div", {
          class: S([
            "relative leading-[20px] font-medium",
            m !== e.currentPage ? "group-hover:text-text-black-default dark:group-hover:text-text-black-default" : ""
          ])
        }, $(m === "ellipsis" ? "..." : m), 3)
      ], 10, _M))), 128)) : (c(), p("div", eE, [
        g("div", tE, $(e.currentPage) + " / " + $(e.totalPages), 1)
      ])),
      e.showNavigation ? (c(), p("button", {
        key: 3,
        type: "button",
        "data-testid": "pagination-next",
        disabled: !l.value,
        class: S([
          u.value,
          (e.mode === "icons-only" || e.mode === "icons-text" || e.mode === "compact", "rounded-tl-none rounded-tr-[9999px] rounded-br-[9999px] rounded-bl-none ml-[-1px]")
        ]),
        onClick: d
      }, [
        e.mode === "text-only" || e.mode === "icons-text" ? (c(), p("span", {
          key: 0,
          class: S(["relative leading-[20px] font-medium group-hover:text-text-black-default dark:group-hover:text-text-black-default", e.mode === "icons-text" ? "mr-1" : ""])
        }, $(e.nextLabel), 3)) : w("", !0),
        e.mode === "icons-only" || e.mode === "icons-text" || e.mode === "compact" ? (c(), p("svg", rE, [...b[1] || (b[1] = [
          g("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5l7 7-7 7"
          }, null, -1)
        ])])) : w("", !0)
      ], 10, nE)) : w("", !0)
    ]));
  }
}), aE = /* @__PURE__ */ He(oE, [["__scopeId", "data-v-e6488c3d"]]), lE = {
  class: "grid grid-cols-3 items-center text-sm",
  "data-testid": "pager-nav"
}, sE = { class: "col-start-1 flex items-center gap-3" }, iE = {
  key: 0,
  class: "flex items-center gap-3"
}, dE = ["for"], uE = ["id", "disabled", "aria-expanded", "aria-controls"], cE = ["id", "aria-labelledby"], fE = ["aria-selected", "onClick", "onKeydown"], hE = {
  key: 1,
  class: "font-normal text-(--text-text-body) dark:text-(--text-text-white-secondary)"
}, bE = { class: "flex items-center gap-1.5" }, pE = {
  key: 0,
  class: "select-none"
}, gE = {
  key: 1,
  class: "col-start-3 flex items-center justify-end gap-2"
}, mE = ["for"], vE = ["id", "max", "disabled"], wV = /* @__PURE__ */ ge({
  __name: "Pager",
  props: {
    currentPage: { default: 1 },
    totalPages: { default: 1 },
    totalItems: { default: 0 },
    itemsPerPage: { default: 10 },
    previousLabel: { default: "Previous" },
    nextLabel: { default: "Next" },
    disabled: { type: Boolean, default: !1 },
    rowsPerPageOptions: { default: () => [10, 30, 50] },
    rowsPerPageLabel: { default: "Rows per page" },
    showRowsPerPage: { type: Boolean, default: !0 },
    showItemsCount: { type: Boolean, default: !1 },
    itemsCountSeparator: { default: "of" },
    itemsCountFormat: { type: Function, default: void 0 },
    maxVisiblePages: { default: 5 },
    alwaysShowPages: { type: Boolean, default: !1 },
    pageAlign: { default: "center" },
    showGoToPage: { type: Boolean, default: !1 },
    goToPageLabel: { default: "Go to page" },
    goLabel: { default: "Go" }
  },
  emits: ["page-change", "items-per-page-change"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => {
      const W = n.totalPages, K = n.currentPage, le = Math.max(5, n.maxVisiblePages);
      if (W <= le)
        return Array.from({ length: W }, (I, M) => M + 1);
      const C = Math.floor((le - 5) / 2);
      if (K <= C + 2)
        return [...Array.from({ length: le - 2 }, (M, D) => D + 1), "ellipsis-end", W];
      if (K >= W - C - 1) {
        const I = W - le + 3;
        return [1, "ellipsis-start", ...Array.from({ length: le - 2 }, (D, re) => I + re)];
      }
      return [1, "ellipsis-start", ...Array.from({ length: C * 2 + 1 }, (I, M) => K - C + M), "ellipsis-end", W];
    }), a = y(() => n.currentPage > 1 && !n.disabled), l = y(() => n.currentPage < n.totalPages && !n.disabled), s = y(() => {
      if (n.totalItems === 0) return `0 ${n.itemsCountSeparator} 0`;
      const W = (n.currentPage - 1) * n.itemsPerPage + 1, K = Math.min(n.currentPage * n.itemsPerPage, n.totalItems);
      return n.itemsCountFormat ? n.itemsCountFormat(W, K, n.totalItems) : `${W}-${K} ${n.itemsCountSeparator} ${n.totalItems}`;
    }), i = y(
      () => n.rowsPerPageOptions.map((W) => ({
        value: String(W),
        label: String(W)
      }))
    ), d = (W) => {
      n.disabled || W < 1 || W > n.totalPages || W !== n.currentPage && r("page-change", W);
    }, u = () => {
      a.value && d(n.currentPage - 1);
    }, f = () => {
      l.value && d(n.currentPage + 1);
    }, h = (W) => {
      r("items-per-page-change", Number(W));
    }, b = Ke(), m = Ke(), v = ur(), x = (W) => {
      const K = v[W];
      return K && K({}).length;
    }, k = N(""), L = N(!1);
    let P = null;
    const E = y(() => n.disabled || n.totalPages === 0), O = () => {
      P && (clearTimeout(P), P = null), L.value = !1;
    }, R = () => {
      P && (clearTimeout(P), P = null);
      const W = parseInt(k.value, 10);
      if (isNaN(W) || W < 1 || W > n.totalPages) {
        L.value = !0, P = setTimeout(() => {
          k.value = "", L.value = !1, P = null;
        }, 1500);
        return;
      }
      L.value = !1, d(W), k.value = "";
    };
    Bt(() => {
      P && clearTimeout(P), document.removeEventListener("click", j);
    });
    const V = N(!1), J = N(null);
    function F() {
      n.disabled || (V.value = !V.value);
    }
    function A(W) {
      V.value = !1, h(W);
    }
    function j(W) {
      V.value && J.value && !J.value.contains(W.target) && (V.value = !1);
    }
    function _(W) {
      W.key !== "Escape" || !V.value || (W.stopPropagation(), W.preventDefault(), V.value = !1);
    }
    we(V, (W) => {
      W ? document.addEventListener("click", j) : document.removeEventListener("click", j);
    });
    const U = y(() => n.alwaysShowPages || n.totalPages > 1);
    return (W, K) => (c(), p("nav", lE, [
      g("div", sE, [
        x("info") ? be(W.$slots, "info", { key: 0 }) : w("", !0),
        e.showRowsPerPage || e.showItemsCount ? (c(), p(Z, { key: 1 }, [
          e.showRowsPerPage ? (c(), p("div", iE, [
            g("label", {
              for: T(b),
              class: "font-normal text-(--text-text-body) dark:text-(--text-text-white-secondary) whitespace-nowrap"
            }, $(e.rowsPerPageLabel), 9, dE),
            g("div", {
              ref_key: "rowsMenuRef",
              ref: J,
              class: "relative",
              onKeydown: _
            }, [
              g("button", {
                id: T(b),
                type: "button",
                disabled: e.disabled,
                "aria-haspopup": "listbox",
                "aria-expanded": V.value,
                "aria-controls": `${T(b)}-listbox`,
                class: "flex items-center gap-2 bg-transparent dark:bg-(--colors-background-black-default) border border-(--border-border-base-medium) text-(--text-text-body-subtle) dark:text-(--text-text-white-default) text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-(--colors-border-hover) py-1.5 pl-3.5 pr-2 disabled:opacity-50",
                "data-testid": "pager-rows-trigger",
                onClick: F
              }, [
                Ze($(e.itemsPerPage) + " ", 1),
                K[1] || (K[1] = g("i", { class: "ri-arrow-up-s-line text-base leading-none" }, null, -1))
              ], 8, uE),
              V.value ? (c(), p("ul", {
                key: 0,
                id: `${T(b)}-listbox`,
                role: "listbox",
                "aria-labelledby": T(b),
                class: "absolute bottom-full left-0 mb-1 z-30 min-w-full rounded-lg border border-(--colors-border-base-medium) dark:border-(--colors-border-base) bg-white-50-opacity-bold dark:bg-(--colors-background-black-default) py-1 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:shadow-(--blur-shadow-m-dark)",
                "data-testid": "pager-rows-menu"
              }, [
                (c(!0), p(Z, null, ke(i.value, (le) => (c(), p("li", {
                  key: le.value,
                  role: "option",
                  "aria-selected": String(e.itemsPerPage) === le.value,
                  tabindex: "0",
                  class: S([
                    "cursor-pointer px-3 py-1.5 text-sm hover:bg-(--colors-background-hover) text-(--text-text-body) dark:text-(--text-text-white-default)",
                    String(e.itemsPerPage) === le.value ? "font-semibold" : ""
                  ]),
                  onClick: (C) => A(le.value),
                  onKeydown: [
                    je(Ie((C) => A(le.value), ["prevent"]), ["enter"]),
                    je(Ie((C) => A(le.value), ["prevent"]), ["space"])
                  ]
                }, $(le.label), 43, fE))), 128))
              ], 8, cE)) : w("", !0)
            ], 544)
          ])) : w("", !0),
          e.showItemsCount ? (c(), p("div", hE, $(s.value), 1)) : w("", !0)
        ], 64)) : w("", !0)
      ]),
      U.value ? (c(), p("div", {
        key: 0,
        class: S([
          "flex items-center gap-4",
          e.pageAlign === "end" ? "col-start-3 justify-end" : "col-start-2 justify-center"
        ])
      }, [
        ae(T($e), {
          variant: "secondary",
          size: "sm",
          "icon-only": "",
          "icon-left": "ri-arrow-left-s-line",
          disabled: !a.value,
          "aria-label": e.previousLabel,
          "data-testid": "pager-previous",
          class: "shrink-0",
          onClick: u
        }, null, 8, ["disabled", "aria-label"]),
        g("div", bE, [
          (c(!0), p(Z, null, ke(o.value, (le) => (c(), p(Z, { key: le }, [
            String(le).startsWith("ellipsis") ? (c(), p("span", pE, " ... ")) : (c(), te(T($e), {
              key: 1,
              variant: le === e.currentPage ? "primary" : "secondary",
              label: String(le),
              size: "sm",
              disabled: e.disabled,
              "aria-current": le === e.currentPage ? "page" : void 0,
              "data-testid": "pager-page",
              class: "min-w-9! justify-center! py-1.75! shrink-0",
              onClick: (C) => d(le)
            }, null, 8, ["variant", "label", "disabled", "aria-current", "onClick"]))
          ], 64))), 128))
        ]),
        ae(T($e), {
          variant: "secondary",
          size: "sm",
          "icon-only": "",
          "icon-right": "ri-arrow-right-s-line",
          disabled: !l.value,
          "aria-label": e.nextLabel,
          "data-testid": "pager-next",
          class: "shrink-0",
          onClick: f
        }, null, 8, ["disabled", "aria-label"])
      ], 2)) : w("", !0),
      e.showGoToPage ? (c(), p("div", gE, [
        g("label", {
          for: T(m),
          class: "font-normal text-(--text-text-body) dark:text-(--text-text-white-secondary) whitespace-nowrap"
        }, $(e.goToPageLabel), 9, mE),
        Ar(g("input", {
          id: T(m),
          "onUpdate:modelValue": K[0] || (K[0] = (le) => k.value = le),
          type: "number",
          min: "1",
          max: e.totalPages,
          disabled: E.value,
          "data-testid": "pager-go-to-page",
          class: S([
            "w-16 rounded-md border bg-transparent py-1.5 pl-2 pr-1 text-sm text-(--text-text-body-subtle) dark:text-(--text-text-white-default) focus:outline-none focus:ring-1 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            L.value ? "border-red-500 focus:border-red-500 focus:ring-red-500" : "border-(--border-border-base-medium) focus:border-primary-500 focus:ring-primary-500"
          ]),
          onInput: O,
          onKeydown: je(R, ["enter"])
        }, null, 42, vE), [
          [dl, k.value]
        ]),
        ae(T($e), {
          variant: "primary",
          size: "sm",
          label: e.goLabel,
          disabled: E.value,
          "data-testid": "pager-go-button",
          onClick: R
        }, null, 8, ["label", "disabled"])
      ])) : w("", !0)
    ]));
  }
});
function CV(e, t) {
  return {
    result: e.data.map(t),
    currentPage: e.pagination.page,
    pageSize: e.pagination.perPage,
    totalItems: e.pagination.totalItems,
    totalPages: e.pagination.totalPages
  };
}
const ko = Symbol("tableQuery"), ws = Symbol("tableViews"), xE = Symbol(
  "tableColumnSettings"
), Vp = Symbol("tablePermissions"), Fp = Symbol("tableLabels"), yE = ["title", "data-testid", "data-active", "onClick"], kE = { class: "truncate min-w-0" }, hf = "ri-arrow-down-s-line", wE = "ri-information-line", CE = 4, SE = /* @__PURE__ */ ge({
  __name: "TableViewTabs",
  props: {
    tabDropdowns: { default: () => [] },
    overflowLabel: { default: "lists" }
  },
  emits: ["tab-requested", "tab-reordered"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = un(ko), a = un(ws), l = N(null), s = N(null), i = N(null), d = N(/* @__PURE__ */ new Map()), u = N([]), f = /* @__PURE__ */ new Map();
    let h = 0;
    const b = y(() => (a == null ? void 0 : a.presetViews.value) ?? []), m = y(() => (o == null ? void 0 : o.state.activeViewId) ?? null), v = y(() => n.tabDropdowns), x = y(
      () => {
        var C;
        return ((C = v.value.find((B) => B.overflowLabel)) == null ? void 0 : C.overflowLabel) ?? n.overflowLabel;
      }
    ), k = y(
      () => {
        var C;
        return (C = v.value.find((B) => B.overflowInfoTooltip)) == null ? void 0 : C.overflowInfoTooltip;
      }
    ), L = N(
      n.tabDropdowns.reduce((C, B, I) => {
        var M, D;
        return (D = (M = B.groupButtons) == null ? void 0 : M[0]) != null && D.value && (C[I] = B.groupButtons[0].value), C;
      }, {})
    ), P = (C, B) => {
      L.value[C] = B;
    }, E = N({}), O = (C, B) => {
      E.value[C] = B;
    }, R = N({}), V = (C, B) => {
      const I = R.value[C] ?? [];
      I.indexOf(B) >= 0 ? R.value[C] = I.filter((D) => D !== B) : R.value[C] = [...I, B];
    }, J = y(
      () => v.value.map(
        (C, B) => {
          if (!C.showHeader) return { left: void 0, right: void 0 };
          const I = C.controlledSelection ? C.items.filter((D) => D.switchChecked).length : (R.value[B] ?? []).length, M = C.selectedCountSuffix ?? "selected";
          return {
            left: { text: C.label },
            right: { text: `${I}/${C.items.length} ${M}` }
          };
        }
      )
    ), F = y(
      () => v.value.map(
        (C, B) => C.items.map((I) => C.controlledSelection ? {
          id: I.id,
          label: I.label,
          group: I.group,
          hasSwitch: !0,
          switchChecked: I.switchChecked === !0,
          disabled: I.disabled === !0,
          onClick: I.onClick,
          moreActions: I.moreActions
        } : {
          id: I.id,
          label: I.label,
          group: I.group,
          hasSwitch: !0,
          switchChecked: (R.value[B] ?? []).includes(I.id),
          onClick: () => V(B, I.id),
          moreActions: I.moreActions
        })
      )
    ), A = y(
      () => v.value.map(
        (C, B) => (C.footerButtons ?? []).map((I) => C.controlledSelection ? {
          label: I.label,
          variant: I.variant,
          keepOpen: I.keepOpen,
          disabled: I.disabled,
          onClick: () => {
            var M;
            return (M = I.onClick) == null ? void 0 : M.call(I, []);
          }
        } : {
          label: I.label,
          variant: I.variant,
          keepOpen: I.keepOpen,
          onClick: () => {
            var re;
            const M = R.value[B] ?? [], D = C.items.filter((se) => M.includes(se.id));
            r("tab-requested", B, D), (re = I.onClick) == null || re.call(I, D), R.value = { ...R.value, [B]: [] };
          }
        })
      )
    ), j = y(
      () => b.value.filter((C) => u.value.includes(C.id)).map((C) => ({
        label: C.label,
        active: m.value === C.id,
        onClick: () => o == null ? void 0 : o.setView(C.id)
      }))
    );
    let _ = 0;
    function U() {
      return typeof window > "u" ? 0.72 : window.innerWidth >= 1920 ? 0.8 : 0.72;
    }
    function W() {
      var ce;
      if (_ >= CE) return;
      const C = l.value, B = s.value;
      if (!C || !B) {
        u.value = [];
        return;
      }
      const I = C.getBoundingClientRect().width;
      if (I <= 0) return;
      let M = !1;
      for (const ne of b.value) {
        if (f.has(ne.id)) continue;
        const ye = d.value.get(ne.id);
        if (ye) {
          const he = ye.getBoundingClientRect().width;
          he > 0 ? f.set(ne.id, he) : M = !0;
        } else
          M = !0;
      }
      if (M) {
        u.value = [], _++, Pe(W);
        return;
      }
      const D = ((ce = i.value) == null ? void 0 : ce.$el) ?? null;
      let re = 0;
      for (let ne = 0; ne < C.children.length; ne++) {
        const ye = C.children[ne];
        ye !== B && (D && (ye === D || ye.contains(D)) || (re += ye.getBoundingClientRect().width));
      }
      const se = (typeof window < "u" ? window.innerWidth : I) * U(), de = Math.min(I, se), fe = Math.floor(de - re);
      let q = 0;
      for (const ne of b.value)
        q += f.get(ne.id) ?? 0;
      if (q <= fe - 1) {
        const ne = JSON.stringify(u.value);
        u.value = [], JSON.stringify([]) !== ne ? (_++, Pe(W)) : _ = 0;
        return;
      }
      if (h === 0 && D) {
        const ne = D.getBoundingClientRect().width;
        ne > 0 && (h = ne);
      }
      const oe = Math.floor(de - re - h), ue = [], G = [];
      let H = 0;
      for (const ne of b.value) {
        const ye = f.get(ne.id) ?? 0;
        H + ye > oe - 1 ? ue.push(ne.id) : (G.push(ne.id), H += ye);
      }
      const z = m.value;
      if (z && ue.includes(z)) {
        const ne = f.get(z) ?? 0;
        for (; G.length > 0 && H + ne > oe - 1; ) {
          const ye = G.pop();
          H -= f.get(ye) ?? 0, ue.push(ye);
        }
        (H + ne <= oe - 1 || G.length === 0) && (ue.splice(ue.indexOf(z), 1), G.push(z));
      }
      const X = JSON.stringify(u.value), Y = JSON.stringify(ue);
      u.value = ue, X !== Y ? (_++, Pe(W)) : _ = 0;
    }
    function K() {
      _ = 0, Pe(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(W);
        });
      });
    }
    let le = null;
    return Qe(() => {
      K(), le = new ResizeObserver(() => {
        h = 0, K();
      }), l.value && le.observe(l.value);
    }), nt(() => le == null ? void 0 : le.disconnect()), we(
      b,
      (C, B) => {
        const I = new Map((B ?? []).map((D) => [D.id, D.label]));
        for (const D of C)
          I.has(D.id) && I.get(D.id) !== D.label && f.delete(D.id);
        const M = new Set(C.map((D) => D.id));
        for (const [D] of f)
          M.has(D) || f.delete(D);
        h = 0, K();
      },
      { deep: !0 }
    ), we(m, () => {
      K();
    }), (C, B) => (c(), p("div", {
      ref_key: "outerRef",
      ref: l,
      class: "flex items-stretch min-w-0 flex-1"
    }, [
      g("div", {
        ref_key: "containerRef",
        ref: s,
        "data-testid": "tab-container",
        class: "flex items-stretch min-w-0 overflow-hidden"
      }, [
        (c(!0), p(Z, null, ke(b.value, (I) => Ar((c(), p("button", {
          key: I.id,
          ref_for: !0,
          ref: (M) => {
            M && d.value.set(I.id, M);
          },
          type: "button",
          title: I.label,
          "data-testid": `table-view-tab-${I.id}`,
          "data-active": m.value === I.id ? "true" : "false",
          class: S([
            "shrink-0 px-3 flex items-center text-sm font-medium transition-colors duration-200 rounded-tl-md rounded-tr-md max-w-[233px] overflow-hidden",
            m.value === I.id ? "tab-active tab-active--has-left -mb-px text-gray-900 dark:text-white" : "border-t border-r border-b border-l border-(--border-border-tab) bg-(--colors-background-white-tertiary) text-(--colors-text-black-default) hover:bg-whitesmoke dark:bg-white/5 dark:text-(--colors-text-white-secondary) dark:hover:bg-white/10"
          ]),
          onClick: (M) => {
            var D;
            return (D = T(o)) == null ? void 0 : D.setView(I.id);
          }
        }, [
          g("span", kE, $(I.label), 1)
        ], 10, yE)), [
          [Af, !u.value.includes(I.id)]
        ])), 128))
      ], 512),
      u.value.length > 0 ? (c(), te(T(kn), {
        key: 0,
        ref_key: "overflowDropdownRef",
        ref: i,
        class: "shrink-0",
        label: `+${u.value.length} ${x.value}`,
        items: j.value,
        "trigger-icon-info": k.value ? wE : void 0,
        "trigger-icon-info-tooltip": k.value,
        "trigger-icon": hf,
        "menu-align": "left",
        "menu-width": "220px",
        tab: !0
      }, null, 8, ["label", "items", "trigger-icon-info", "trigger-icon-info-tooltip"])) : w("", !0),
      (c(!0), p(Z, null, ke(v.value, (I, M) => (c(), p("div", {
        key: M,
        class: "flex items-center gap-1 shrink-0"
      }, [
        ae(T(au), {
          class: "shrink-0",
          label: I.label,
          "trigger-icon-left": I.iconLeft,
          "trigger-icon": hf,
          tab: !0,
          "header-label-left": J.value[M].left,
          "header-label-right": J.value[M].right,
          "show-search": I.showSearch,
          "search-query": E.value[M] ?? "",
          "search-placeholder": I.searchPlaceholder,
          "group-buttons": I.groupButtons,
          "active-group-button": L.value[M],
          items: F.value[M],
          "footer-buttons": A.value[M],
          reorderable: I.reorderable === !0,
          "freeze-on-open": !0,
          "menu-align": "left",
          size: I.size ?? "m",
          "max-list-height": "280px",
          "reserve-list-height": I.reserveListHeight !== !1,
          "empty-label": I.emptyLabel,
          "onUpdate:searchQuery": (D) => O(M, D),
          "onUpdate:activeGroupButton": (D) => P(M, D),
          onReorder: (D) => r("tab-reordered", M, D)
        }, null, 8, ["label", "trigger-icon-left", "header-label-left", "header-label-right", "show-search", "search-query", "search-placeholder", "group-buttons", "active-group-button", "items", "footer-buttons", "reorderable", "size", "reserve-list-height", "empty-label", "onUpdate:searchQuery", "onUpdate:activeGroupButton", "onReorder"])
      ]))), 128))
    ], 512));
  }
}), $E = /* @__PURE__ */ He(SE, [["__scopeId", "data-v-c8a4dd35"]]), Hp = {
  filterButton: "Filter",
  eraseAll: "Erase all",
  hideFilters: (e) => `Hide filters (${e})`,
  showFilters: (e) => `Show filters (${e})`,
  saveView: "Save",
  shareView: "Share",
  closeSearch: "Close search",
  removeFilter: (e) => `Remove ${e} filter`,
  renameView: "Rename view",
  setAsDefault: "Set as default",
  deleteView: "Delete view",
  manageViews: "Manage views",
  viewSettingsLabel: "View settings",
  viewModeTable: "Table",
  viewModeBoard: "Board",
  viewModeCalendar: "Calendar",
  viewModeGantt: "Gantt"
};
function Cs() {
  return un(
    Fp,
    y(() => Hp)
  );
}
const IE = /* @__PURE__ */ ge({
  __name: "TableSearch",
  props: {
    placeholder: { default: "Search..." }
  },
  setup(e) {
    const t = un(ko), n = Cs();
    function r(o) {
      t == null || t.setSearch(o);
    }
    return (o, a) => {
      var l;
      return c(), te(UL, {
        "model-value": ((l = T(t)) == null ? void 0 : l.state.search) ?? "",
        placeholder: e.placeholder,
        labels: { closeSearch: T(n).closeSearch },
        "onUpdate:modelValue": r
      }, null, 8, ["model-value", "placeholder", "labels"]);
    };
  }
}), TE = {
  key: 0,
  class: "inline-flex items-center px-3 py-2 text-(length:--size-m) leading-[20px] font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
  "data-testid": "table-view-selector-static"
}, LE = /* @__PURE__ */ ge({
  __name: "TableViewSelector",
  emits: ["rename-view", "delete-view", "set-default"],
  setup(e, { emit: t }) {
    const n = t, r = un(ko), o = un(ws), a = Cs(), l = y(
      () => o == null ? void 0 : o.views.value.find((d) => d.id === (r == null ? void 0 : r.state.activeViewId))
    ), s = y(() => !!(l.value && !l.value.isPreset)), i = y(() => s.value ? [
      { label: a.value.renameView, onClick: () => n("rename-view", l.value.id) },
      {
        label: a.value.setAsDefault,
        hasDividerAfter: !0,
        onClick: () => {
          o == null || o.setDefault(l.value.id), n("set-default", l.value.id);
        }
      },
      { label: a.value.deleteView, onClick: () => n("delete-view", l.value.id) }
    ] : []);
    return (d, u) => s.value ? (c(), te(T(kn), {
      key: 1,
      label: T(a).viewModeTable,
      items: i.value,
      "trigger-icon": "ri-arrow-down-s-line",
      "menu-align": "right",
      "menu-width": "180px",
      ghost: !0
    }, null, 8, ["label", "items"])) : (c(), p("div", TE, $(T(a).viewModeTable), 1));
  }
}), ME = { class: "relative flex h-9 items-stretch border-gainsboro dark:border-(--colors-border-base)" }, EE = { class: "flex items-stretch w-[73%] min-w-0" }, AE = {
  key: 1,
  class: "flex-1"
}, Wp = /* @__PURE__ */ ge({
  __name: "TableTopbar",
  props: {
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "tab-requested", "tab-reordered"],
  setup(e, { emit: t }) {
    const n = t, r = un(ws), o = y(() => ((r == null ? void 0 : r.presetViews.value.length) ?? 0) > 0);
    return (a, l) => (c(), p("div", ME, [
      g("div", EE, [
        o.value ? (c(), te($E, {
          key: 0,
          "tab-dropdowns": e.tabDropdowns,
          onTabRequested: l[0] || (l[0] = (s, i) => n("tab-requested", s, i)),
          onTabReordered: l[1] || (l[1] = (s, i) => n("tab-reordered", s, i))
        }, null, 8, ["tab-dropdowns"])) : (c(), p("div", AE))
      ]),
      g("div", {
        class: S(["flex items-center justify-end gap-1 w-[27%] px-4 py-1", o.value ? "border-gainsboro dark:border-(--colors-border-base)" : ""])
      }, [
        e.showSearch ? (c(), te(IE, {
          key: 0,
          placeholder: e.searchPlaceholder
        }, null, 8, ["placeholder"])) : w("", !0),
        e.showViewSelector ? (c(), te(LE, {
          key: 1,
          onRenameView: l[2] || (l[2] = (s) => n("rename-view", s)),
          onDeleteView: l[3] || (l[3] = (s) => n("delete-view", s)),
          onSetDefault: l[4] || (l[4] = (s) => n("set-default", s))
        })) : w("", !0)
      ], 2)
    ]));
  }
}), DE = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M14%2014V20L10%2022V14L4%205V3H20V5L14%2014ZM6.4037%205L12%2013.3944L17.5963%205H6.4037Z'/%3e%3c/svg%3e", RE = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17.8827%2019.2968C16.1814%2020.3755%2014.1638%2021.0002%2012.0003%2021.0002C6.60812%2021.0002%202.12215%2017.1204%201.18164%2012.0002C1.61832%209.62282%202.81932%207.5129%204.52047%205.93457L1.39366%202.80777L2.80788%201.39355L22.6069%2021.1925L21.1927%2022.6068L17.8827%2019.2968ZM5.9356%207.3497C4.60673%208.56015%203.6378%2010.1672%203.22278%2012.0002C4.14022%2016.0521%207.7646%2019.0002%2012.0003%2019.0002C13.5997%2019.0002%2015.112%2018.5798%2016.4243%2017.8384L14.396%2015.8101C13.7023%2016.2472%2012.8808%2016.5002%2012.0003%2016.5002C9.51498%2016.5002%207.50026%2014.4854%207.50026%2012.0002C7.50026%2011.1196%207.75317%2010.2981%208.19031%209.60442L5.9356%207.3497ZM12.9139%2014.328L9.67246%2011.0866C9.5613%2011.3696%209.50026%2011.6777%209.50026%2012.0002C9.50026%2013.3809%2010.6196%2014.5002%2012.0003%2014.5002C12.3227%2014.5002%2012.6309%2014.4391%2012.9139%2014.328ZM20.8068%2016.5925L19.376%2015.1617C20.0319%2014.2268%2020.5154%2013.1586%2020.7777%2012.0002C19.8603%207.94818%2016.2359%205.00016%2012.0003%205.00016C11.1544%205.00016%2010.3329%205.11773%209.55249%205.33818L7.97446%203.76015C9.22127%203.26959%2010.5793%203.00016%2012.0003%203.00016C17.3924%203.00016%2021.8784%206.87992%2022.8189%2012.0002C22.5067%2013.6998%2021.8038%2015.2628%2020.8068%2016.5925ZM11.7229%207.50857C11.8146%207.50299%2011.9071%207.50016%2012.0003%207.50016C14.4855%207.50016%2016.5003%209.51488%2016.5003%2012.0002C16.5003%2012.0933%2016.4974%2012.1858%2016.4919%2012.2775L11.7229%207.50857Z'/%3e%3c/svg%3e", BE = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.0003%203C17.3924%203%2021.8784%206.87976%2022.8189%2012C21.8784%2017.1202%2017.3924%2021%2012.0003%2021C6.60812%2021%202.12215%2017.1202%201.18164%2012C2.12215%206.87976%206.60812%203%2012.0003%203ZM12.0003%2019C16.2359%2019%2019.8603%2016.052%2020.7777%2012C19.8603%207.94803%2016.2359%205%2012.0003%205C7.7646%205%204.14022%207.94803%203.22278%2012C4.14022%2016.052%207.7646%2019%2012.0003%2019ZM12.0003%2016.5C9.51498%2016.5%207.50026%2014.4853%207.50026%2012C7.50026%209.51472%209.51498%207.5%2012.0003%207.5C14.4855%207.5%2016.5003%209.51472%2016.5003%2012C16.5003%2014.4853%2014.4855%2016.5%2012.0003%2016.5ZM12.0003%2014.5C13.381%2014.5%2014.5003%2013.3807%2014.5003%2012C14.5003%2010.6193%2013.381%209.5%2012.0003%209.5C10.6196%209.5%209.50026%2010.6193%209.50026%2012C9.50026%2013.3807%2010.6196%2014.5%2012.0003%2014.5Z'/%3e%3c/svg%3e", OE = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4%203H18L20.7071%205.70711C20.8946%205.89464%2021%206.149%2021%206.41421V20C21%2020.5523%2020.5523%2021%2020%2021H4C3.44772%2021%203%2020.5523%203%2020V4C3%203.44772%203.44772%203%204%203ZM7%204V9H16V4H7ZM6%2012V19H18V12H6ZM13%205H15V8H13V5Z'/%3e%3c/svg%3e", no = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2013.1714L16.9497%208.22168L18.3639%209.63589L11.9999%2015.9999L5.63599%209.63589L7.0502%208.22168L11.9999%2013.1714Z'/%3e%3c/svg%3e", sl = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9999%2010.8284L7.0502%2015.7782L5.63599%2014.364L11.9999%208L18.3639%2014.364L16.9497%2015.7782L11.9999%2010.8284Z'/%3e%3c/svg%3e", jp = /* @__PURE__ */ ge({
  __name: "TableControls",
  props: {
    isFilterPanelOpen: { type: Boolean, default: !1 },
    isFilterBarVisible: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["toggle-filter-panel", "toggle-filter-bar", "save-view", "share-view"],
  setup(e, { emit: t }) {
    const n = t, r = un(ko), o = un(Vp), a = Cs(), l = y(() => (r == null ? void 0 : r.hasActiveFilters.value) ?? !1), s = y(() => (r == null ? void 0 : r.activeFilterCount.value) ?? 0);
    function i() {
      r == null || r.clearAllFilters();
    }
    return (d, u) => {
      var f, h;
      return c(), p("div", {
        class: S([
          "flex items-center gap-3 p-3 bg-white dark:bg-(--colors-background-black-default) rounded-tr-[12px]",
          e.bordered && "border-b border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
        ])
      }, [
        e.showFilter ? (c(), p(Z, { key: 0 }, [
          d.$slots.filter ? be(d.$slots, "filter", { key: 0 }) : (c(), te(T($e), {
            key: 1,
            variant: "tertiary",
            "icon-left": T(DE),
            "icon-right": T(no),
            size: "sm",
            active: e.isFilterPanelOpen,
            onClick: u[0] || (u[0] = (b) => n("toggle-filter-panel"))
          }, {
            default: pe(() => [
              Ze($(T(a).filterButton), 1)
            ]),
            _: 1
          }, 8, ["icon-left", "icon-right", "active"]))
        ], 64)) : w("", !0),
        l.value ? (c(), p("button", {
          key: 1,
          type: "button",
          class: "shrink-0 text-sm font-medium text-blue-600 underline cursor-pointer hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors",
          onClick: i
        }, $(T(a).eraseAll), 1)) : w("", !0),
        l.value ? (c(), te(T($e), {
          key: 2,
          variant: "tertiary",
          "icon-left": e.isFilterBarVisible ? T(RE) : T(BE),
          "icon-right": e.isFilterBarVisible ? T(sl) : T(no),
          size: "sm",
          onClick: u[1] || (u[1] = (b) => {
            var m;
            (m = b.currentTarget) == null || m.blur(), n("toggle-filter-bar");
          })
        }, {
          default: pe(() => [
            Ze($(e.isFilterBarVisible ? T(a).hideFilters(s.value) : T(a).showFilters(s.value)), 1)
          ]),
          _: 1
        }, 8, ["icon-left", "icon-right"])) : w("", !0),
        be(d.$slots, "controls-info"),
        u[4] || (u[4] = g("div", { class: "flex-1" }, null, -1)),
        be(d.$slots, "controls-actions"),
        ((f = T(o)) == null ? void 0 : f.canSaveView) !== !1 ? (c(), te(T($e), {
          key: 3,
          variant: "secondary",
          label: T(a).saveView,
          "icon-left": T(OE),
          "icon-right": T(no),
          size: "sm",
          disabled: !l.value,
          onClick: u[2] || (u[2] = (b) => n("save-view"))
        }, null, 8, ["label", "icon-left", "icon-right", "disabled"])) : w("", !0),
        ((h = T(o)) == null ? void 0 : h.canShareView) !== !1 ? (c(), te(T($e), {
          key: 4,
          variant: "secondary",
          label: T(a).shareView,
          size: "sm",
          onClick: u[3] || (u[3] = (b) => n("share-view"))
        }, null, 8, ["label"])) : w("", !0)
      ], 2);
    };
  }
}), PE = { class: "pill-gradient relative inline-flex shrink-0 items-stretch rounded-full p-px" }, zE = { class: "flex items-stretch rounded-full bg-white dark:bg-(--colors-background-black-default)" }, NE = { class: "whitespace-nowrap text-sm font-medium text-slategray dark:text-(--colors-text-white-secondary)" }, VE = ["title"], FE = {
  key: 1,
  class: "ml-0.5 whitespace-nowrap text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
}, HE = ["aria-label"], WE = /* @__PURE__ */ ge({
  __name: "FilterPill",
  props: {
    pill: {}
  },
  emits: ["remove", "edit"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Cs(), a = y(
      () => n.pill.value.type === "in" ? n.pill.value.values.length : null
    ), l = y(() => a.value !== null && a.value > 1);
    function s() {
      r("edit", n.pill.key);
    }
    return (i, d) => (c(), p("div", PE, [
      g("div", zE, [
        g("button", {
          type: "button",
          class: "inline-flex cursor-pointer items-center gap-1 py-1 pl-3 pr-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1 rounded-l-full",
          onClick: Ie(s, ["stop"])
        }, [
          g("span", NE, $(e.pill.label), 1),
          l.value ? (c(), p("span", FE, " (" + $(a.value) + ") ", 1)) : (c(), p(Z, { key: 0 }, [
            d[1] || (d[1] = g("span", { class: "text-sm text-slategray dark:text-(--colors-text-white-secondary)" }, " : ", -1)),
            g("span", {
              class: "max-w-50 truncate text-sm font-medium text-(--colors-text-black-default) dark:text-(--colors-text-white-default)",
              title: e.pill.valueLabel
            }, $(e.pill.valueLabel), 9, VE)
          ], 64)),
          d[2] || (d[2] = g("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "ml-0.5 h-3 w-3 shrink-0 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            g("path", { d: "M6 9l6 6 6-6" })
          ], -1))
        ]),
        d[4] || (d[4] = g("div", { class: "my-1.5 w-px bg-gainsboro dark:bg-(--colors-border-base)" }, null, -1)),
        g("button", {
          type: "button",
          class: "inline-flex w-7 cursor-pointer items-center justify-center rounded-r-full transition-colors duration-150 hover:bg-gray-100 dark:hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-1",
          "aria-label": T(o).removeFilter(e.pill.label),
          onClick: d[0] || (d[0] = Ie((u) => r("remove", e.pill.key), ["stop"]))
        }, [...d[3] || (d[3] = [
          g("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            class: "h-2.5 w-2.5 text-slategray dark:text-(--colors-text-white-secondary)"
          }, [
            g("path", { d: "M18 6 6 18M6 6l12 12" })
          ], -1)
        ])], 8, HE)
      ])
    ]));
  }
}), jE = /* @__PURE__ */ He(WE, [["__scopeId", "data-v-760a98cd"]]), UE = { class: "flex items-center gap-2 flex-1 flex-wrap" }, Up = /* @__PURE__ */ ge({
  __name: "TableFilterBar",
  props: {
    bordered: { type: Boolean, default: !0 }
  },
  emits: ["edit-filter"],
  setup(e, { emit: t }) {
    const n = t, r = un(ko), o = y(() => (r == null ? void 0 : r.activeFilterPills.value) ?? []);
    function a(l) {
      r == null || r.removeFilter(l);
    }
    return (l, s) => (c(), te(ot, {
      "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
      "enter-from-class": "max-h-0",
      "enter-to-class": "max-h-60",
      "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
      "leave-from-class": "max-h-60",
      "leave-to-class": "max-h-0"
    }, {
      default: pe(() => [
        o.value.length > 0 ? (c(), p("div", {
          key: 0,
          class: S([
            "flex items-start gap-2 px-4 py-2 bg-white dark:bg-(--colors-background-black-default)",
            e.bordered && "border-b border-gainsboro dark:border-(--colors-border-base)"
          ])
        }, [
          g("div", UE, [
            (c(!0), p(Z, null, ke(o.value, (i) => (c(), te(jE, {
              key: i.key,
              pill: i,
              onRemove: a,
              onEdit: s[0] || (s[0] = (d) => n("edit-filter", d))
            }, null, 8, ["pill"]))), 128))
          ])
        ], 2)) : w("", !0)
      ]),
      _: 1
    }));
  }
}), GE = {
  "data-testid": "table-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, qE = {
  key: 0,
  class: "flex border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, KE = /* @__PURE__ */ ge({
  __name: "TableSkeleton",
  props: {
    columns: { default: 5 },
    rows: { default: 10 },
    showHeader: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = [85, 45, 30, 65, 40, 55, 35, 75];
    function n(r, o) {
      return `${t[(r + o) % t.length]}%`;
    }
    return (r, o) => (c(), p("div", GE, [
      e.showHeader ? (c(), p("div", qE, [
        (c(!0), p(Z, null, ke(e.columns, (a) => (c(), p("div", {
          key: `skeleton-header-${a}`,
          class: "flex-1 h-11 px-5 flex items-center"
        }, [...o[0] || (o[0] = [
          g("div", { class: "skeleton h-2.5 w-full max-w-[140px] rounded-full" }, null, -1)
        ])]))), 128))
      ])) : w("", !0),
      (c(!0), p(Z, null, ke(e.rows, (a) => (c(), p("div", {
        key: `skeleton-row-${a}`,
        class: "flex border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base) last:border-b-0"
      }, [
        (c(!0), p(Z, null, ke(e.columns, (l) => (c(), p("div", {
          key: `skeleton-cell-${a}-${l}`,
          class: "flex-1 h-14 px-5 flex items-center"
        }, [
          g("div", {
            class: "skeleton h-2.5 rounded-full",
            style: Ae({ width: n(a, l) })
          }, null, 4)
        ]))), 128))
      ]))), 128))
    ]));
  }
}), JE = { class: "flex items-center gap-1.5 justify-center" }, ZE = ["src"], YE = ["src"], XE = { class: "self-stretch flex flex-col items-start gap-2" }, QE = {
  key: 0,
  class: "self-stretch flex flex-col items-start"
}, _E = ["onClick"], eA = ["src"], tA = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, nA = {
  key: 2,
  class: "relative leading-num-24 font-medium"
}, rA = ["src"], oA = ["onClick"], aA = { class: "flex-1 flex items-center py-num-0 pl-0.5 pr-num-0 shrink-0 relative z-10" }, lA = { class: "relative leading-num-24 font-medium" }, sA = ["onClick"], iA = ["src"], dA = {
  key: 1,
  class: "h-5 w-5 relative flex-shrink-0"
}, uA = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10"
}, cA = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-colors-text-black-default relative z-10"
}, fA = { class: "relative leading-5 font-medium z-10" }, hA = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cline x1=%2218%22 y1=%226%22 x2=%226%22 y2=%2218%22/%3E%3Cline x1=%226%22 y1=%226%22 x2=%2218%22 y2=%2218%22/%3E%3C/svg%3E", bA = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%229 18 15 12 9 6%22/%3E%3C/svg%3E", pA = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%226 9 12 15 18 9%22/%3E%3C/svg%3E", gA = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%23242424%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3E%3Cpolyline points=%2218 15 12 9 6 15%22/%3E%3C/svg%3E", mA = /* @__PURE__ */ ge({
  __name: "MainDrawer",
  props: {
    logoIcon: { default: "/logo-eudonet.svg" },
    logoText: { default: void 0 },
    closeIcon: { default: void 0 },
    items: { default: () => [
      {
        label: "Overview",
        children: []
      },
      {
        label: "Pages",
        children: []
      },
      {
        label: "Ecommerce",
        icon: void 0,
        children: [
          { label: "All products" },
          { label: "Billing", active: !0 },
          { label: "Invoice" },
          { label: "Transactions" }
        ]
      },
      {
        label: "Messages",
        badge: 4,
        children: []
      },
      {
        label: "Users",
        children: []
      },
      {
        label: "Support",
        children: []
      }
    ] },
    modelValue: { type: Boolean, default: !0 },
    width: { default: "100%" }
  },
  emits: ["update:modelValue", "close", "item-click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N({
      Ecommerce: !0
    }), a = N(!1), l = y(() => n.items), s = (v) => {
      o.value[v] = !o.value[v];
    }, i = (v) => o.value[v] === !0, d = (v) => {
      v.children && v.children.length > 0 && !a.value && s(v.label), v.onClick && v.onClick(), r("item-click", v);
    }, u = () => {
      const v = !a.value;
      a.value = v, v && Object.keys(o.value).forEach((x) => {
        o.value[x] = !1;
      });
    }, f = y(() => a.value ? "/logo-eudonet-small.svg" : n.logoIcon || "/logo-eudonet.svg"), h = (v) => {
      const x = 'self-stretch flex items-center py-num-6 pl-8 pr-num-8 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300 relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
      return v.active ? `${x} h-9 rounded-[48px] bg-white overflow-visible before:opacity-100 after:opacity-100` : `${x} rounded-num-12 hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden before:opacity-0 after:opacity-0`;
    }, b = (v) => {
      const x = "self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent transition-[background,border-color] duration-300";
      return v.active ? `${x} relative before:content-[""] before:absolute before:inset-[-1px] before:rounded-[48px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 before:opacity-100 after:content-[""] after:absolute after:inset-0 after:rounded-[48px] after:bg-white after:transition-opacity after:duration-300 after:z-[1] after:opacity-100 bg-white overflow-visible` : `${x} hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden`;
    }, m = () => 'h-[22px] w-[22px] rounded-[9999px] relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-[9999px] before:[background:linear-gradient(90deg,_#716ff2,_#52DBF5)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-[9999px] after:bg-white after:transition-opacity after:duration-300 after:z-[1]';
    return (v, x) => e.modelValue ? (c(), p("div", {
      key: 0,
      role: "dialog",
      class: S(["drawer h-[1184px] relative bg-white flex flex-col items-start box-border gap-5 text-left text-num-16 text-colors-text-body font-inter transition-all duration-300", { "w-20 p-2 overflow-visible": a.value, "p-5 overflow-hidden": !a.value }]),
      style: Ae(a.value ? { width: "80px" } : { width: e.width })
    }, [
      g("div", {
        class: S([
          "self-stretch border-colors-border-black-default border-solid border-b-[1px] pt-num-0 px-num-0 relative",
          a.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-4"
        ])
      }, [
        g("div", JE, [
          f.value ? (c(), p("img", {
            key: 0,
            class: "h-[30px] w-auto relative",
            src: f.value,
            alt: "Eudonet"
          }, null, 8, ZE)) : w("", !0),
          e.logoText && !a.value ? (c(), p("img", {
            key: 1,
            class: "h-[30px] w-[73.8px] relative",
            src: e.logoText,
            alt: "Eudonet"
          }, null, 8, YE)) : w("", !0)
        ]),
        a.value ? (c(), te(T($e), {
          key: 1,
          variant: "tertiary",
          "icon-left": bA,
          "icon-only": "",
          size: "md",
          "icon-alt": "Expand",
          class: "drawer-expand-button flex-shrink-0",
          onClick: u
        })) : (c(), te(T($e), {
          key: 0,
          variant: "tertiary",
          "icon-left": e.closeIcon || hA,
          "icon-only": "",
          size: "md",
          "icon-alt": "Close",
          class: "drawer-close-button flex-shrink-0",
          onClick: u
        }, null, 8, ["icon-left"]))
      ], 2),
      g("div", XE, [
        (c(!0), p(Z, null, ke(l.value, (k, L) => (c(), p(Z, { key: L }, [
          k.children && k.children.length > 0 ? (c(), p("div", QE, [
            g("button", {
              type: "button",
              class: S(["self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border-[1px] border-transparent hover:bg-aliceblue hover:border-[rgba(255,255,255,0.2)] hover:overflow-hidden transition-[background,border-color] duration-300", { "justify-center": a.value }]),
              onClick: (P) => d(k)
            }, [
              g("div", {
                class: S(["flex-1 flex items-center gap-1.5", { "justify-center": a.value }])
              }, [
                k.icon ? (c(), p("img", {
                  key: 0,
                  class: "h-5 w-5 relative flex-shrink-0",
                  src: k.icon,
                  alt: ""
                }, null, 8, eA)) : (c(), p("div", tA)),
                a.value ? w("", !0) : (c(), p("div", nA, $(k.label), 1))
              ], 2),
              a.value ? w("", !0) : (c(), p("img", {
                key: 0,
                class: "h-4 w-4 relative transition-transform duration-200",
                src: i(k.label) ? gA : pA,
                alt: ""
              }, null, 8, rA))
            ], 10, _E),
            ae(ta, {
              name: "submenu",
              tag: "div",
              class: S([
                "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                { "submenu-open": i(k.label) }
              ])
            }, {
              default: pe(() => [
                (c(!0), p(Z, null, ke(i(k.label) ? k.children : [], (P, E) => (c(), p("button", {
                  key: `${k.label}-${E}`,
                  type: "button",
                  class: S(h(P)),
                  onClick: (O) => d(P)
                }, [
                  g("div", aA, [
                    g("div", lA, $(P.label), 1)
                  ])
                ], 10, oA))), 128))
              ]),
              _: 2
            }, 1032, ["class"])
          ])) : (c(), p("button", {
            key: 1,
            type: "button",
            class: S([b(k), { "justify-center": a.value }]),
            onClick: (P) => d(k)
          }, [
            g("div", {
              class: S(["flex-1 flex items-center gap-1.5 relative z-10", { "justify-center": a.value }])
            }, [
              k.icon ? (c(), p("img", {
                key: 0,
                class: "h-5 w-5 relative flex-shrink-0 z-10",
                src: k.icon,
                alt: ""
              }, null, 8, iA)) : (c(), p("div", dA)),
              a.value ? w("", !0) : (c(), p("div", uA, $(k.label), 1))
            ], 2),
            k.badge && !a.value ? (c(), p("div", cA, [
              g("div", {
                class: S(m())
              }, [
                g("div", fA, $(k.badge), 1)
              ], 2)
            ])) : w("", !0)
          ], 10, sA))
        ], 64))), 128))
      ])
    ], 6)) : w("", !0);
  }
}), SV = /* @__PURE__ */ He(mA, [["__scopeId", "data-v-34e7e349"]]), vA = ["aria-label", "aria-labelledby"], xA = {
  key: 0,
  "data-testid": "drawer-header",
  class: "flex shrink-0 items-center justify-between px-5 py-5 border-b border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, yA = { class: "flex-1 min-w-0" }, kA = { class: "sr-only" }, wA = {
  key: 1,
  "data-testid": "drawer-subheader",
  class: "shrink-0 px-5 pt-5 pb-3"
}, CA = {
  "data-testid": "drawer-content",
  class: "flex-1 overflow-y-auto px-5 py-5"
}, SA = {
  key: 2,
  "data-testid": "drawer-footer",
  class: "flex shrink-0 items-center justify-end gap-2 px-5 py-5 border-t border-(--colors-border-base-medium) dark:border-(--colors-border-base)"
}, $A = /* @__PURE__ */ ge({
  __name: "Drawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: { default: void 0 },
    position: { default: "right" },
    size: { default: "md" },
    showCloseButton: { type: Boolean, default: !0 },
    dismissable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    backdropClass: { default: void 0 },
    panelClass: { default: void 0 },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaCloseLabel: { default: "Close drawer" },
    variant: { default: "default" }
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    let n = 0;
    const r = e, o = ur(), a = (O) => {
      const R = o[O];
      return !!(R && R({}).length);
    }, l = y(
      () => r.showCloseButton || !!r.title || a("header")
    ), s = y(() => a("footer")), i = t, d = `drawer-${++n}`, u = `${d}-title`, f = Symbol("opal-drawer"), h = () => {
      i("update:modelValue", !1), i("close");
    }, b = () => {
      r.dismissable && h();
    }, m = (O) => {
      O.key !== "Escape" || !r.closeOnEscape || !r.modelValue || nu(f) && (O.defaultPrevented || (O.preventDefault(), h()));
    };
    we(
      () => r.modelValue,
      (O) => {
        document.body.style.overflow = O ? "hidden" : "", O ? rs(f) : ma(f);
      }
    ), Qe(() => {
      document.addEventListener("keydown", m), r.modelValue && (document.body.style.overflow = "hidden", rs(f));
    }), nt(() => {
      document.removeEventListener("keydown", m), ma(f), document.body.style.overflow = "";
    });
    const v = {
      sm: "w-64",
      md: "w-80",
      lg: "w-96",
      xl: "w-[512px]"
    }, x = y(() => v[r.size]), k = y(
      () => r.position === "left" ? "left-0 border-r" : "right-0 border-l"
    ), L = y(() => `drawer-slide-${r.position}`), P = y(
      () => r.ariaLabelledby ?? (r.title ? u : void 0)
    ), E = N(null);
    return ks({
      active: oo(r, "modelValue"),
      container: E
    }), (O, R) => (c(), te(cn, { to: "body" }, [
      ae(ot, { name: "drawer-fade" }, {
        default: pe(() => [
          e.modelValue && e.showBackdrop ? (c(), p("div", {
            key: 0,
            "data-testid": "drawer-backdrop",
            class: S(["fixed inset-0 z-40 bg-black/50 dark:bg-black/70", e.backdropClass]),
            onClick: b
          }, null, 2)) : w("", !0)
        ]),
        _: 1
      }),
      ae(ot, { name: L.value }, {
        default: pe(() => [
          e.modelValue ? (c(), p("div", {
            key: 0,
            id: d,
            ref_key: "panelRef",
            ref: E,
            "data-testid": "drawer-panel",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": e.ariaLabel,
            "aria-labelledby": P.value,
            class: S([
              "fixed inset-y-0 z-50 flex flex-col",
              "bg-white dark:bg-(--colors-background-black-default)",
              "border-(--colors-border-base-soft) dark:border-(--colors-border-base)",
              e.variant === "column" ? "shadow-[-1px_0px_4px_0px_#CECECE]" : "shadow-lg",
              x.value,
              k.value,
              e.panelClass
            ])
          }, [
            l.value ? (c(), p("div", xA, [
              g("div", yA, [
                be(O.$slots, "header", {}, () => [
                  e.title ? (c(), p("h5", {
                    key: 0,
                    id: u,
                    class: "text-sm font-semibold uppercase text-(--colors-text-body-subtle) dark:text-gray-400 truncate"
                  }, $(e.title), 1)) : w("", !0)
                ], !0)
              ]),
              e.showCloseButton ? (c(), p("button", {
                key: 0,
                "data-testid": "drawer-close-button",
                type: "button",
                class: "ms-2 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-transparent text-sm text-(--colors-text-body-subtle) hover:bg-(--colors-background-hover) hover:text-(--colors-text-heading) dark:hover:bg-gray-600 dark:hover:text-white transition-colors duration-200",
                onClick: h
              }, [
                R[0] || (R[0] = g("i", { class: "ri-close-line text-lg" }, null, -1)),
                g("span", kA, $(e.ariaCloseLabel), 1)
              ])) : w("", !0)
            ])) : w("", !0),
            a("subheader") ? (c(), p("div", wA, [
              be(O.$slots, "subheader", {}, void 0, !0)
            ])) : w("", !0),
            g("div", CA, [
              be(O.$slots, "default", {}, void 0, !0)
            ]),
            s.value ? (c(), p("div", SA, [
              be(O.$slots, "footer", {}, void 0, !0)
            ])) : w("", !0)
          ], 10, vA)) : w("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), IA = /* @__PURE__ */ He($A, [["__scopeId", "data-v-8ae1d93a"]]);
function lu(e) {
  return y(() => {
    const t = e(), n = [
      `flex items-center rounded-xl border border-solid w-full transition-colors duration-200 ${t.padding}`,
      t.gap
    ];
    return t.minHeight && n.push(t.minHeight), t.alwaysClasses && n.push(t.alwaysClasses), t.disabled ? (n.push("bg-(--background-background-disabled) cursor-default"), n.push(t.border ? "border-(--border-border-disabled)" : "border-transparent"), n) : (t.selected ? n.push("bg-(--background-background-accent) border-(--border-border-accent)") : (n.push("bg-(--background-background-white) hover:bg-(--background-background-hover)"), n.push(
      t.border ? "border-(--border-border-base-medium) hover:border-(--border-border-hover)" : "border-transparent"
    )), t.restingClasses && n.push(t.restingClasses), t.grabbed && n.push("ring-2 ring-(--border-border-accent)"), n);
  });
}
const TA = {
  key: 0,
  class: "min-w-0 flex-1"
}, LA = ["aria-label"], MA = /* @__PURE__ */ ge({
  __name: "EditableTitle",
  props: {
    modelValue: {},
    editable: { type: Boolean, default: !0 },
    showPen: { type: Boolean, default: !0 },
    size: { default: "md" },
    placeholder: { default: void 0 },
    maxlength: { default: void 0 },
    error: { default: void 0 },
    editLabel: {},
    saveLabel: {},
    penVariant: { default: "secondary" },
    inputWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    warnPattern: { default: void 0 },
    warnLabel: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 }
  },
  emits: ["save", "cancel", "edit-start", "edit-end"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = {
      sm: { text: "text-sm font-semibold leading-5", input: "sm", button: "xs" },
      md: { text: "text-lg font-semibold leading-7", input: "md", button: "sm" },
      lg: { text: "text-[28px] font-bold leading-[34px]", input: "lg", button: "lg" }
    }, a = y(() => o[n.size]), l = N(!1), s = N(""), i = N(null), d = y(
      () => n.maxWidth && !l.value ? { maxWidth: n.maxWidth } : void 0
    ), u = N(null), f = N(!1);
    let h = null;
    function b() {
      const E = u.value;
      f.value = !!E && E.scrollWidth > E.offsetWidth;
    }
    we(
      u,
      (E) => {
        h == null || h.disconnect(), h = null, E && typeof ResizeObserver < "u" && (h = new ResizeObserver(b), h.observe(E)), b();
      },
      { flush: "post" }
    ), we(
      () => [n.modelValue, n.maxWidth],
      () => void Pe(b)
    ), Bt(() => h == null ? void 0 : h.disconnect());
    const m = y(() => !!n.warnPattern && n.warnPattern.test(s.value));
    function v() {
      var R;
      const E = (R = i.value) == null ? void 0 : R.$el, O = E == null ? void 0 : E.querySelector("input");
      O == null || O.focus(), O == null || O.select();
    }
    async function x() {
      n.editable && (s.value = n.modelValue, l.value = !0, await Pe(), v());
    }
    function k() {
      l.value = !1, r("cancel");
    }
    function L() {
      const E = s.value.trim();
      if (E.length === 0 || E === n.modelValue) {
        k();
        return;
      }
      r("save", E), l.value = !1;
    }
    function P(E) {
      E.key === "Enter" ? (E.preventDefault(), L()) : E.key === "Escape" && (E.preventDefault(), k());
    }
    return we(
      () => n.error,
      async (E) => {
        E && !l.value && (l.value = !0, await Pe(), v());
      }
    ), we(l, (E) => {
      r(E ? "edit-start" : "edit-end");
    }), we(
      () => n.autoEdit,
      (E) => {
        E && n.editable && !l.value && x();
      },
      { immediate: !0 }
    ), (E, O) => (c(), p("div", {
      class: "inline-flex min-w-0 items-center gap-3",
      style: Ae(d.value),
      "data-testid": "editable-title"
    }, [
      l.value ? (c(), p(Z, { key: 1 }, [
        ae(er, {
          ref_key: "inputRef",
          ref: i,
          modelValue: s.value,
          "onUpdate:modelValue": O[0] || (O[0] = (R) => s.value = R),
          size: a.value.input,
          placeholder: e.placeholder,
          maxlength: e.maxlength,
          "aria-label": e.editLabel,
          "full-width": !e.inputWidth,
          width: e.inputWidth,
          "data-testid": "editable-title-input",
          onKeydown: P
        }, zn({ _: 2 }, [
          m.value ? {
            name: "iconRight",
            fn: pe(() => [
              ae(Ye, {
                text: e.warnLabel ?? "",
                disabled: !e.warnLabel,
                position: "bottom"
              }, {
                default: pe(() => [
                  g("i", {
                    class: S(["ri-error-warning-fill text-(--icons-icon-warning)", a.value.input === "sm" ? "text-sm" : "text-base"]),
                    role: "img",
                    "aria-label": e.warnLabel,
                    "data-testid": "editable-title-warning"
                  }, null, 10, LA)
                ]),
                _: 1
              }, 8, ["text", "disabled"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["modelValue", "size", "placeholder", "maxlength", "aria-label", "full-width", "width"]),
        ae($e, {
          variant: "secondary",
          size: a.value.button,
          "icon-only": "",
          "icon-left": "ri-save-3-fill",
          "icon-alt": e.saveLabel,
          "aria-label": e.saveLabel,
          "data-testid": "editable-title-save",
          onMousedown: O[1] || (O[1] = Ie(() => {
          }, ["prevent"])),
          onClick: L
        }, null, 8, ["size", "icon-alt", "aria-label"])
      ], 64)) : (c(), p(Z, { key: 0 }, [
        e.maxWidth ? (c(), p("div", TA, [
          ae(Ye, {
            text: e.modelValue,
            disabled: !f.value,
            position: "bottom",
            tabindex: f.value ? 0 : void 0,
            style: { display: "block", width: "100%" }
          }, {
            default: pe(() => [
              g("span", {
                ref_key: "displayRef",
                ref: u,
                class: S([a.value.text, "block truncate text-(--text-text-black-default)"]),
                "data-testid": "editable-title-text"
              }, $(e.modelValue), 3)
            ]),
            _: 1
          }, 8, ["text", "disabled", "tabindex"])
        ])) : (c(), p("span", {
          key: 1,
          class: S([a.value.text, "truncate text-(--text-text-black-default)"]),
          "data-testid": "editable-title-text"
        }, $(e.modelValue), 3)),
        e.editable && e.showPen ? (c(), te($e, {
          key: 2,
          variant: e.penVariant,
          size: a.value.button,
          "icon-only": "",
          "icon-left": "ri-pencil-line",
          "icon-alt": e.editLabel,
          "aria-label": e.editLabel,
          "data-testid": "editable-title-edit",
          onClick: x
        }, null, 8, ["variant", "size", "icon-alt", "aria-label"])) : w("", !0)
      ], 64))
    ], 4));
  }
}), EA = /* @__PURE__ */ He(MA, [["__scopeId", "data-v-f55a88ed"]]), AA = ["aria-disabled"], DA = { class: "flex flex-1 min-w-0 items-center gap-2" }, RA = { class: "flex-1 min-w-0 flex flex-col gap-0" }, BA = { class: "flex flex-1 min-w-0 items-center gap-2" }, OA = { class: "flex flex-1 min-w-0 flex-col gap-0" }, PA = {
  key: 0,
  class: "w-full min-w-0 truncate text-xs leading-[14px] text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, zA = { class: "flex flex-1 min-w-0 items-center gap-2" }, NA = ["aria-label", "aria-pressed", "disabled"], VA = { class: "flex flex-1 min-w-0 flex-col gap-0" }, FA = {
  key: 1,
  class: "w-full min-w-0 truncate text-sm font-semibold leading-5 text-(--text-text-heading)",
  "data-testid": "list-item-title"
}, HA = {
  key: 0,
  class: "w-full min-w-0 truncate text-xs leading-[14px] text-(--text-text-body)",
  "data-testid": "list-item-subtitle"
}, WA = ["aria-label", "aria-pressed", "disabled"], jA = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "ListItemCard",
  props: {
    type: { default: "default" },
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    reorderable: { type: Boolean, default: void 0 },
    dragHandleLabel: { default: void 0 },
    grabbed: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !1 },
    showEdit: { type: Boolean, default: !1 },
    editLabel: { default: void 0 },
    saveLabel: { default: void 0 },
    maxlength: { default: void 0 },
    editError: { default: void 0 },
    autoEdit: { type: Boolean, default: !1 },
    editInputWidth: { default: void 0 },
    selected: { type: Boolean, default: !1 }
  },
  emits: ["rename", "grab", "grab-cancel", "select"],
  setup(e, { emit: t }) {
    const n = ["draggable-edit", "draggable-collapsed"], r = e, o = t, a = ht(), l = N(!1), s = y(() => n.includes(r.type)), i = N(null), { isTruncated: d } = Op(i, () => r.label), u = y(
      () => r.type === "draggable-collapsed" ? {
        role: "button",
        tabindex: r.disabled ? void 0 : 0,
        "aria-pressed": r.selected || void 0
      } : {}
    ), f = y(() => !s.value || r.reorderable === !1 ? !1 : r.reorderable === !0 ? !0 : !r.disabled), h = {
      default: { padding: "p-4", gap: "gap-6" },
      "card-item": { padding: "p-3.5", gap: "gap-6", minHeight: "min-h-[74px]" },
      "draggable-edit": { padding: "p-3.5", gap: "gap-6", minHeight: "min-h-[74px]" },
      "draggable-collapsed": { padding: "p-3.5", gap: "gap-3", minHeight: "min-h-14" }
    }, b = lu(() => {
      const E = h[r.type];
      return {
        padding: E.padding,
        gap: E.gap,
        minHeight: E.minHeight,
        disabled: r.disabled,
        border: r.border,
        // selected wins over the resting border (collapsed palette pick); grabbed is the
        // keyboard-grabbed accent ring (Rule n°4 feedback) — both are no-ops outside their own type.
        selected: r.selected,
        grabbed: r.grabbed
      };
    }), m = y(
      () => r.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    );
    function v() {
      f.value && o("grab");
    }
    function x() {
      o("grab-cancel");
    }
    function k(E) {
      o("rename", E);
    }
    function L() {
      r.disabled || r.type !== "draggable-collapsed" || o("select");
    }
    function P(E) {
      r.type !== "draggable-collapsed" || r.disabled || (E.key === "Enter" || E.key === " ") && (E.preventDefault(), o("select"));
    }
    return (E, O) => (c(), p("div", Je({ ...E.$attrs, ...u.value }, {
      class: T(b),
      "aria-disabled": e.disabled || void 0,
      onClick: L,
      onKeydown: P
    }), [
      e.type === "default" ? (c(), p(Z, { key: 0 }, [
        g("div", DA, [
          T(a)("icon") || T(a)("leading") ? (c(), p("div", {
            key: 0,
            class: S(["shrink-0 w-8 h-6 flex items-center justify-center", { "opacity-40": e.disabled }])
          }, [
            be(E.$slots, "leading", {}, () => [
              be(E.$slots, "icon")
            ])
          ], 2)) : w("", !0),
          g("div", RA, [
            g("p", {
              class: S(["font-bold text-base leading-6 w-full truncate", m.value])
            }, $(e.label), 3),
            e.subtitle ? (c(), p("p", {
              key: 0,
              class: S(["text-sm leading-5 w-full", m.value])
            }, $(e.subtitle), 3)) : w("", !0)
          ])
        ]),
        be(E.$slots, "badge"),
        be(E.$slots, "actions")
      ], 64)) : e.type === "card-item" ? (c(), p(Z, { key: 1 }, [
        g("div", BA, [
          be(E.$slots, "leading"),
          g("div", OA, [
            ae(Ye, {
              class: "w-full min-w-0",
              text: e.label,
              disabled: !T(d),
              position: "top",
              tabindex: T(d) ? 0 : void 0
            }, {
              default: pe(() => [
                g("p", {
                  ref_key: "titleEl",
                  ref: i,
                  class: "w-full min-w-0 truncate text-sm font-semibold leading-5 text-(--text-text-heading)",
                  "data-testid": "list-item-title"
                }, $(e.label), 513)
              ]),
              _: 1
            }, 8, ["text", "disabled", "tabindex"]),
            be(E.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), p("p", PA, $(e.subtitle), 1)) : w("", !0)
            ])
          ])
        ]),
        be(E.$slots, "badge"),
        be(E.$slots, "actions")
      ], 64)) : e.type === "draggable-edit" ? (c(), p(Z, { key: 2 }, [
        g("div", zA, [
          g("button", {
            type: "button",
            class: S(["ri-draggable shrink-0 rounded p-0 text-2xl leading-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
              f.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
              e.grabbed ? "text-(--text-text-accent)" : ""
            ]]),
            "aria-label": e.dragHandleLabel,
            "aria-roledescription": "draggable",
            "aria-pressed": e.grabbed || void 0,
            disabled: e.disabled || !f.value,
            "data-testid": "list-item-drag-handle",
            onClick: v,
            onKeydown: je(x, ["esc"])
          }, null, 42, NA),
          be(E.$slots, "leading"),
          g("div", VA, [
            e.editable ? (c(), te(EA, {
              key: 0,
              "model-value": e.label,
              editable: !e.disabled,
              "show-pen": e.showEdit && !e.disabled,
              size: "sm",
              "pen-variant": "tertiary",
              maxlength: e.maxlength,
              error: e.editError,
              "auto-edit": e.autoEdit,
              "input-width": e.editInputWidth,
              "edit-label": e.editLabel ?? "",
              "save-label": e.saveLabel ?? "",
              class: "w-full min-w-0",
              onSave: k,
              onEditStart: O[0] || (O[0] = (R) => l.value = !0),
              onEditEnd: O[1] || (O[1] = (R) => l.value = !1)
            }, null, 8, ["model-value", "editable", "show-pen", "maxlength", "error", "auto-edit", "input-width", "edit-label", "save-label"])) : (c(), p("p", FA, $(e.label), 1)),
            be(E.$slots, "subtitle", {}, () => [
              e.subtitle ? (c(), p("p", HA, $(e.subtitle), 1)) : w("", !0)
            ])
          ])
        ]),
        l.value ? w("", !0) : (c(), p(Z, { key: 0 }, [
          be(E.$slots, "badge"),
          be(E.$slots, "actions")
        ], 64))
      ], 64)) : (c(), p(Z, { key: 3 }, [
        g("button", {
          type: "button",
          class: S(["ri-draggable shrink-0 rounded p-0 text-2xl leading-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent)", [
            f.value ? "cursor-grab text-(--icons-icon-dark-default)" : "opacity-40 cursor-default",
            e.grabbed ? "text-(--text-text-accent)" : ""
          ]]),
          "aria-label": e.dragHandleLabel,
          "aria-roledescription": "draggable",
          "aria-pressed": e.grabbed || void 0,
          disabled: e.disabled || !f.value,
          "data-testid": "list-item-drag-handle",
          onClick: Ie(v, ["stop"]),
          onKeydown: je(x, ["esc"])
        }, null, 42, WA),
        be(E.$slots, "leading"),
        g("span", {
          class: S(["flex-1 min-w-0 truncate text-sm font-medium", e.disabled ? "text-(--text-text-disabled-strong)" : e.selected ? "text-(--text-text-accent)" : "text-(--text-text-black-default)"]),
          "data-testid": "list-item-label"
        }, $(e.label), 3),
        be(E.$slots, "badge"),
        be(E.$slots, "actions")
      ], 64))
    ], 16, AA));
  }
}), UA = { class: "draggable-badge" }, GA = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "DraggableListItem",
  props: {
    reorderable: { type: Boolean, default: void 0 },
    type: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    dragHandleLabel: {},
    grabbed: { type: Boolean },
    editable: { type: Boolean },
    showEdit: { type: Boolean },
    editLabel: {},
    saveLabel: {},
    maxlength: {},
    editError: {},
    autoEdit: { type: Boolean },
    editInputWidth: {},
    selected: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ht(), r = y(() => t.reorderable === !1 ? !1 : t.reorderable === !0 ? !0 : !t.disabled);
    return (o, a) => (c(), te(jA, Je(o.$attrs, {
      label: t.label,
      subtitle: t.subtitle,
      disabled: t.disabled,
      border: t.border,
      draggable: r.value ? "true" : "false"
    }), zn({
      icon: pe(() => [
        g("i", {
          class: S(["ri-draggable text-2xl leading-none select-none text-(--icons-icon-base)", r.value ? "cursor-grab" : "opacity-40"]),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      _: 2
    }, [
      T(n)("badge") ? {
        name: "badge",
        fn: pe(() => [
          g("div", UA, [
            be(o.$slots, "badge", {}, void 0, !0)
          ])
        ]),
        key: "0"
      } : void 0,
      T(n)("actions") ? {
        name: "actions",
        fn: pe(() => [
          be(o.$slots, "actions", {}, void 0, !0)
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["label", "subtitle", "disabled", "border", "draggable"]));
  }
}), qA = /* @__PURE__ */ He(GA, [["__scopeId", "data-v-7caff764"]]), _o = 3, KA = {
  class: "sr-only",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true",
  "data-testid": "faceted-reorder-live"
}, JA = { class: "flex items-start justify-between pt-5 px-5 pb-4 border-b border-(--colors-border-base-medium)" }, ZA = { class: "flex flex-col gap-0.5" }, YA = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-black-default) font-inter" }, XA = { class: "text-base font-normal leading-6 text-(--colors-text-black-default) font-inter" }, QA = { class: "sr-only" }, _A = { class: "flex flex-col gap-3 px-5 py-4" }, eD = { class: "shadow-(--blur-shadow-xs)" }, tD = ["aria-label"], nD = ["id", "aria-selected", "aria-controls", "tabindex"], rD = ["id", "aria-selected", "aria-controls", "tabindex"], oD = ["id", "aria-labelledby"], aD = { key: "visible" }, lD = ["aria-labelledby"], sD = ["id"], iD = { class: "flex flex-col gap-4" }, dD = { class: "shrink-0 w-4.5" }, uD = ["for"], cD = { class: "flex items-center gap-3 shrink-0" }, fD = ["aria-labelledby", "aria-label"], hD = ["id"], bD = { class: "flex flex-col gap-4" }, pD = { class: "shrink-0 w-4.5" }, gD = ["for"], mD = { class: "flex items-center gap-3 shrink-0" }, vD = ["disabled", "aria-label", "aria-pressed", "onClick"], xD = {
  key: 1,
  class: "flex items-center justify-center py-8 text-sm text-(--colors-text-body-subtle) font-inter"
}, yD = { key: "order" }, kD = {
  key: 0,
  class: "flex items-center gap-1.5 text-xs text-(--colors-text-body-subtle) mb-2 font-inter"
}, wD = ["aria-label"], CD = ["aria-label"], SD = ["disabled", "aria-label", "aria-pressed", "onClick"], $D = {
  key: 1,
  class: "flex items-center justify-center py-8 text-sm text-(--colors-text-body-subtle) font-inter"
}, ID = { class: "flex items-center justify-between w-full" }, TD = { class: "flex items-center gap-4" }, LD = /* @__PURE__ */ ge({
  __name: "FacetedSearchDrawer",
  props: {
    modelValue: { type: Boolean },
    columns: {},
    defaultColumns: { default: () => [] },
    columnOrder: { default: () => [] },
    labels: { default: () => ({}) }
  },
  emits: ["update:modelValue", "save", "reset"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = {
      fige: "Pinned",
      "actif-indigo": "Active",
      "actif-orange": "Active",
      fixe: "Fixed"
    }, l = y(() => ({
      title: n.labels.title ?? "Customize columns",
      subtitle: n.labels.subtitle ?? ((Q, ee) => `${Q} of ${ee} selected`),
      searchPlaceholder: n.labels.searchPlaceholder ?? "Search a column",
      visibleTab: n.labels.visibleTab ?? "Visible",
      orderTab: n.labels.orderTab ?? "Order",
      defaultColumnHeader: n.labels.defaultColumnHeader ?? "Default fixed column",
      pinnedBadge: n.labels.pinnedBadge ?? "Pinned",
      resetLabel: n.labels.resetLabel ?? "Reset columns",
      cancelLabel: n.labels.cancelLabel ?? "Cancel",
      saveLabel: n.labels.saveLabel ?? "Save",
      closeAriaLabel: n.labels.closeAriaLabel ?? "Close",
      emptySearchText: n.labels.emptySearchText ?? "No columns found",
      emptyOrderText: n.labels.emptyOrderText ?? "No visible columns",
      orderSearchHint: n.labels.orderSearchHint ?? "Showing filtered results. Drag to reorder within visible columns.",
      pinTooltip: n.labels.pinTooltip ?? "Locked column",
      pinAriaLabelPinned: n.labels.pinAriaLabelPinned ?? "Unfreeze column",
      pinAriaLabelUnpinned: n.labels.pinAriaLabelUnpinned ?? "Freeze column",
      pinLimitTooltip: n.labels.pinLimitTooltip ?? `You can freeze up to ${_o} columns. Unfreeze a column to freeze another.`,
      badgeLabels: {
        ...a,
        ...n.labels.badgeLabels ?? {}
      },
      reorderMoved: n.labels.reorderMoved ?? ((Q, ee, ve) => `${Q} moved to position ${ee} of ${ve}`),
      reorderPickedUp: n.labels.reorderPickedUp ?? ((Q) => `${Q} picked up. Use arrow keys to move, space to drop, escape to cancel.`),
      reorderCancelled: n.labels.reorderCancelled ?? ((Q) => `${Q} reorder cancelled`),
      orderListLabel: n.labels.orderListLabel ?? "Column order"
    })), s = N(null), i = N([]), d = N(""), u = N("visible"), f = N(null), h = N(null), b = N(null), m = N(null);
    let v = null;
    const x = Ke();
    function k(Q) {
      return `${x}-section-${Q.replace(/\s+/g, "-").toLowerCase() || "ungrouped"}`;
    }
    function L(Q) {
      return `${x}-column-${Q.replace(/\s+/g, "-")}`;
    }
    const P = N("");
    function E(Q, ee, ve) {
      P.value = l.value.reorderMoved(Q, ee, ve);
    }
    function O(Q) {
      return Q.map((ee) => ({
        ...ee,
        visible: ee.disabled || ee.alwaysVisible ? !0 : ee.visible
      }));
    }
    function R() {
      const Q = O(n.columns);
      if (n.columnOrder.length > 0) {
        const ee = new Map(n.columnOrder.map((ve, Le) => [ve, Le]));
        Q.sort((ve, Le) => (ee.get(ve.key) ?? 1 / 0) - (ee.get(Le.key) ?? 1 / 0));
      }
      i.value = ue(Q);
    }
    we(
      () => n.modelValue,
      (Q) => {
        Q && (R(), d.value = "", u.value = "visible", m.value = null, v = null, o.value = !1);
      },
      { immediate: !0 }
    ), we(
      () => n.modelValue ? `${n.columnOrder.join("|")}::${n.columns.map((Q) => Q.key).join("|")}` : null,
      (Q) => {
        Q !== null && m.value === null && R();
      }
    );
    const V = {
      fige: "bg-white ring-1 ring-(--colors-border-base-soft) text-(--colors-text-black-default)",
      "actif-indigo": "bg-(--colors-indigo-100) text-(--colors-text-black-default)",
      "actif-orange": "bg-(--colors-warning-100) text-(--colors-text-black-default)",
      fixe: "bg-(--colors-indigo-100) text-(--colors-text-black-default)"
    };
    function J(Q) {
      return V[Q];
    }
    function F(Q) {
      return Q.badge ? l.value.badgeLabels[Q.badge] : Q.pinned || B(Q) ? l.value.pinnedBadge : "";
    }
    const A = y(() => i.value.filter((Q) => Q.visible).length), j = y(() => i.value.length), _ = y(
      () => l.value.subtitle(A.value, j.value)
    ), U = y(() => {
      const Q = d.value.toLowerCase().trim();
      return Q ? i.value.filter((ee) => ee.label.toLowerCase().includes(Q)) : i.value;
    }), W = y(
      () => U.value.filter((Q) => Q.alwaysVisible || Q.disabled)
    ), K = y(
      () => U.value.filter((Q) => !Q.alwaysVisible && !Q.disabled)
    ), le = y(() => {
      const Q = [], ee = /* @__PURE__ */ new Map(), ve = [];
      for (const Le of K.value)
        Le.group ? (ee.has(Le.group) || ee.set(Le.group, []), ee.get(Le.group).push(Le)) : ve.push(Le);
      for (const [Le, We] of ee)
        Q.push({ name: Le, items: We });
      return ve.length > 0 && Q.push({ name: "", items: ve }), Q;
    }), C = y(() => {
      const Q = d.value.toLowerCase().trim(), ee = i.value.filter((ve) => ve.visible);
      return Q ? ee.filter((ve) => ve.label.toLowerCase().includes(Q)) : ee;
    });
    function B(Q) {
      return !!(Q.disabled || Q.alwaysVisible);
    }
    const I = y(
      () => i.value.filter((Q) => Q.visible && (B(Q) || Q.pinned)).length
    ), M = y(() => I.value >= _o);
    function D(Q) {
      return !Q.visible || B(Q) ? !1 : Q.pinned || !M.value;
    }
    function re(Q) {
      return Q.pinned ? l.value.pinAriaLabelPinned : l.value.pinAriaLabelUnpinned;
    }
    function se(Q) {
      return Q.visible && !Q.pinned && M.value ? l.value.pinLimitTooltip : re(Q);
    }
    function de(Q) {
      return !B(Q);
    }
    function fe(Q) {
      return B(Q) ? "locked" : Q.pinned ? "pinned" : "regular";
    }
    function q(Q, ee) {
      return fe(Q) === fe(ee);
    }
    function oe(Q) {
      const ee = [], ve = [], Le = [];
      for (const We of Q)
        B(We) ? ee.push(We) : We.pinned ? ve.push(We) : Le.push(We);
      return [...ee, ...ve, ...Le];
    }
    function ue(Q = i.value) {
      const ee = [], ve = [];
      for (const Le of Q)
        (Le.visible ? ee : ve).push(Le);
      return [...oe(ee), ...ve];
    }
    function G(Q) {
      B(Q) || (Q.visible = !Q.visible, Q.visible || (Q.pinned = !1));
    }
    function H(Q) {
      D(Q) && (Q.pinned = !Q.pinned, i.value = ue());
    }
    function z() {
      r("update:modelValue", !1);
    }
    function X() {
      o.value && r("reset"), r(
        "save",
        i.value.map((Q) => ({ ...Q }))
      ), r("update:modelValue", !1);
    }
    function Y() {
      i.value = ue(O(n.defaultColumns)), o.value = !0;
    }
    function ce(Q, ee) {
      f.value = Q, ee.dataTransfer && (ee.dataTransfer.effectAllowed = "move");
    }
    function ne(Q) {
      const ee = C.value[Q], ve = f.value !== null ? C.value[f.value] : null;
      if (!ee || !de(ee)) {
        h.value = null;
        return;
      }
      if (ve && !q(ve, ee)) {
        h.value = null;
        return;
      }
      h.value = Q;
    }
    function ye(Q) {
      if (f.value === null || f.value === Q) {
        f.value = null, h.value = null;
        return;
      }
      const ee = C.value[f.value], ve = C.value[Q];
      if (!ee || !ve || !de(ee) || !de(ve) || !q(ee, ve)) {
        f.value = null, h.value = null;
        return;
      }
      const Le = ee.key, We = ve.key, qe = [...i.value], fn = qe.findIndex((At) => At.key === Le), hn = qe.findIndex((At) => At.key === We), [Et] = qe.splice(fn, 1);
      qe.splice(hn, 0, Et), f.value = null, h.value = null, requestAnimationFrame(() => {
        i.value = ue(qe);
        const At = i.value.findIndex((bn) => bn.key === Le) + 1, In = i.value.filter((bn) => bn.visible).length;
        E(ee.label, At, In);
      });
    }
    function he() {
      f.value = null, h.value = null;
    }
    function ie(Q, ee) {
      const ve = C.value[Q];
      if (!ve) return;
      if (ee.key === "Escape" && m.value !== null) {
        ee.preventDefault(), v && (i.value = v), m.value = null, v = null, P.value = l.value.reorderCancelled(ve.label);
        return;
      }
      if (ee.key === " " || ee.key === "Enter") {
        if (m.value === null) {
          if (!de(ve)) return;
          ee.preventDefault(), m.value = Q, v = i.value.map((Wn) => ({ ...Wn })), P.value = l.value.reorderPickedUp(ve.label);
          return;
        }
        ee.preventDefault();
        const bt = C.value[m.value], Hn = C.value.length;
        E((bt == null ? void 0 : bt.label) ?? ve.label, m.value + 1, Hn), m.value = null, v = null;
        return;
      }
      if (m.value === null || ee.key !== "ArrowUp" && ee.key !== "ArrowDown") return;
      const Le = m.value, We = C.value[Le];
      if (!We) return;
      let qe = ee.key === "ArrowUp" ? Le - 1 : Le + 1;
      for (; qe >= 0 && qe < C.value.length && (!de(C.value[qe]) || !q(We, C.value[qe])); )
        qe += ee.key === "ArrowUp" ? -1 : 1;
      if (qe < 0 || qe >= C.value.length) return;
      ee.preventDefault();
      const fn = C.value[Le].key, hn = C.value[qe].key, Et = [...i.value], At = Et.findIndex((bt) => bt.key === fn), In = Et.findIndex((bt) => bt.key === hn), [bn] = Et.splice(At, 1);
      Et.splice(In, 0, bn), i.value = ue(Et), m.value = qe, b.value = qe;
      const br = i.value.filter((bt) => bt.visible).length;
      E(ve.label, qe + 1, br), requestAnimationFrame(() => {
        var Hn, Wn;
        const bt = (Hn = s.value) == null ? void 0 : Hn.querySelectorAll("[role='listitem']");
        (Wn = bt == null ? void 0 : bt[qe]) == null || Wn.focus();
      });
    }
    function me(Q) {
      Q.key !== "ArrowLeft" && Q.key !== "ArrowRight" || (Q.preventDefault(), u.value = u.value === "visible" ? "order" : "visible");
    }
    return (Q, ee) => (c(), te(T(IA), {
      "model-value": e.modelValue,
      position: "right",
      size: "xl",
      variant: "column",
      "show-close-button": !1,
      dismissable: !0,
      "aria-label": l.value.title,
      "onUpdate:modelValue": ee[3] || (ee[3] = (ve) => r("update:modelValue", ve))
    }, {
      footer: pe(() => [
        g("div", ID, [
          ae(T($e), {
            label: l.value.resetLabel,
            variant: "tertiary",
            size: "sm",
            "icon-left": "ri-restart-line",
            onClick: Y
          }, null, 8, ["label"]),
          g("div", TD, [
            ae(T($e), {
              label: l.value.cancelLabel,
              variant: "secondary",
              size: "sm",
              onClick: z
            }, null, 8, ["label"]),
            ae(T($e), {
              label: l.value.saveLabel,
              variant: "primary",
              size: "sm",
              onClick: X
            }, null, 8, ["label"])
          ])
        ])
      ]),
      default: pe(() => [
        g("div", {
          ref_key: "drawerContainerRef",
          ref: s,
          class: "flex flex-col h-full -mx-5 -my-5 gap-1"
        }, [
          g("div", KA, $(P.value), 1),
          g("div", JA, [
            g("div", ZA, [
              g("h3", YA, $(l.value.title), 1),
              g("p", XA, $(_.value), 1)
            ]),
            g("button", {
              type: "button",
              class: "inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-transparent text-sm text-(--colors-text-body-subtle) hover:bg-(--colors-background-hover) hover:text-(--colors-text-heading) transition-colors duration-200",
              onClick: z
            }, [
              ee[4] || (ee[4] = g("i", { class: "ri-close-line text-xl" }, null, -1)),
              g("span", QA, $(l.value.closeAriaLabel), 1)
            ])
          ]),
          g("div", _A, [
            g("div", eD, [
              ae(T(Rr), {
                modelValue: d.value,
                "onUpdate:modelValue": ee[0] || (ee[0] = (ve) => d.value = ve),
                placeholder: l.value.searchPlaceholder,
                size: "sm",
                "full-width": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            g("div", {
              class: "flex w-full bg-(--colors-white-50-opacity-light) border border-(--colors-border-base-medium) rounded-3xl p-px shadow-(--blur-shadow-xs)",
              role: "tablist",
              "aria-label": l.value.title,
              onKeydown: me
            }, [
              g("button", {
                id: `${T(x)}-tab-visible`,
                type: "button",
                role: "tab",
                "aria-selected": u.value === "visible",
                "aria-controls": `${T(x)}-panel-body`,
                tabindex: u.value === "visible" ? 0 : -1,
                class: S([
                  "flex-1 px-3 py-2 text-sm font-medium font-inter rounded-3xl transition-colors duration-200 -mr-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                  u.value === "visible" ? "bg-(--colors-background-black-default) border border-mediumslateblue text-(--colors-text-white-default)" : "bg-transparent border border-transparent text-(--colors-text-black-default) hover:bg-(--colors-background-hover)"
                ]),
                onClick: ee[1] || (ee[1] = (ve) => u.value = "visible")
              }, $(l.value.visibleTab), 11, nD),
              g("button", {
                id: `${T(x)}-tab-order`,
                type: "button",
                role: "tab",
                "aria-selected": u.value === "order",
                "aria-controls": `${T(x)}-panel-body`,
                tabindex: u.value === "order" ? 0 : -1,
                class: S([
                  "flex-1 px-3 py-2 text-sm font-medium font-inter rounded-3xl transition-colors duration-200 -mr-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                  u.value === "order" ? "bg-(--colors-background-black-default) border border-mediumslateblue text-(--colors-text-white-default)" : "bg-transparent border border-transparent text-(--colors-text-black-default) hover:bg-(--colors-background-hover)"
                ]),
                onClick: ee[2] || (ee[2] = (ve) => u.value = "order")
              }, $(l.value.orderTab), 11, rD)
            ], 40, tD)
          ]),
          g("div", {
            id: `${T(x)}-panel-body`,
            class: "flex-1 overflow-y-auto px-5 pb-1",
            role: "tabpanel",
            "aria-labelledby": `${T(x)}-tab-${u.value}`
          }, [
            ae(ot, {
              name: "faceted-tab-fade",
              mode: "out-in"
            }, {
              default: pe(() => [
                u.value === "visible" ? (c(), p("div", aD, [
                  W.value.length > 0 ? (c(), p("div", {
                    key: 0,
                    class: "mb-8",
                    role: "group",
                    "aria-labelledby": k("default-fixed")
                  }, [
                    g("div", {
                      id: k("default-fixed"),
                      class: "text-lg font-bold leading-6 text-(--colors-text-heading) mb-4 font-inter"
                    }, $(l.value.defaultColumnHeader), 9, sD),
                    g("div", iD, [
                      (c(!0), p(Z, null, ke(W.value, (ve) => (c(), p("div", {
                        key: ve.key,
                        class: "flex items-center gap-2.5 p-px"
                      }, [
                        g("div", dD, [
                          ae(T(Xt), {
                            id: L(ve.key),
                            "model-value": !0,
                            disabled: !0,
                            variant: "light"
                          }, null, 8, ["id"])
                        ]),
                        g("label", {
                          for: L(ve.key),
                          class: "flex-1 min-w-0 text-sm font-medium font-inter truncate cursor-not-allowed text-(--colors-text-body-subtle)"
                        }, $(ve.label), 9, uD),
                        g("div", cD, [
                          g("span", {
                            class: S(["inline-flex items-center px-1 py-0.5 rounded text-xs font-medium leading-5 font-inter", J(ve.badge ?? "fige")])
                          }, $(F(ve)), 3),
                          ee[5] || (ee[5] = g("i", {
                            class: "ri-pushpin-2-fill text-2xl leading-none text-(--colors-text-body-subtle)",
                            "aria-hidden": "true"
                          }, null, -1))
                        ])
                      ]))), 128))
                    ])
                  ], 8, lD)) : w("", !0),
                  (c(!0), p(Z, null, ke(le.value, (ve) => (c(), p("div", {
                    key: ve.name,
                    class: "mb-8 last:mb-0",
                    role: "group",
                    "aria-labelledby": ve.name ? k(ve.name) : void 0,
                    "aria-label": ve.name ? void 0 : l.value.visibleTab
                  }, [
                    ve.name ? (c(), p("div", {
                      key: 0,
                      id: k(ve.name),
                      class: "text-lg font-bold leading-6 text-(--colors-text-heading) mb-4 font-inter"
                    }, $(ve.name), 9, hD)) : w("", !0),
                    g("div", bD, [
                      (c(!0), p(Z, null, ke(ve.items, (Le) => (c(), p("div", {
                        key: Le.key,
                        class: "flex items-center gap-2.5 p-px"
                      }, [
                        g("div", pD, [
                          ae(T(Xt), {
                            id: L(Le.key),
                            "model-value": Le.visible,
                            variant: "default",
                            "onUpdate:modelValue": (We) => G(Le)
                          }, null, 8, ["id", "model-value", "onUpdate:modelValue"])
                        ]),
                        g("label", {
                          for: L(Le.key),
                          class: "flex-1 min-w-0 text-sm font-medium font-inter truncate text-(--colors-text-heading) cursor-pointer"
                        }, $(Le.label), 9, gD),
                        g("div", mD, [
                          Le.pinned || Le.badge ? (c(), p("span", {
                            key: 0,
                            class: S(["inline-flex items-center px-1 py-0.5 rounded text-xs font-medium leading-5 font-inter", J(Le.badge ?? "fige")])
                          }, $(F(Le)), 3)) : w("", !0),
                          ae(T(Ye), {
                            text: se(Le),
                            position: "top",
                            tabindex: D(Le) ? void 0 : 0
                          }, {
                            default: pe(() => [
                              g("button", {
                                type: "button",
                                class: S([
                                  "inline-flex items-center justify-center size-6 rounded transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                                  Le.pinned ? "text-(--colors-text-black-default)" : "text-(--colors-text-body-subtle) hover:text-(--colors-text-black-default)"
                                ]),
                                disabled: !D(Le),
                                "aria-label": re(Le),
                                "aria-pressed": Le.pinned,
                                onClick: Ie((We) => H(Le), ["stop"])
                              }, [
                                g("i", {
                                  class: S([Le.pinned ? "ri-pushpin-2-fill" : "ri-pushpin-2-line", "text-2xl leading-none"])
                                }, null, 2)
                              ], 10, vD)
                            ]),
                            _: 2
                          }, 1032, ["text", "tabindex"])
                        ])
                      ]))), 128))
                    ])
                  ], 8, fD))), 128)),
                  U.value.length === 0 ? (c(), p("div", xD, $(l.value.emptySearchText), 1)) : w("", !0)
                ])) : u.value === "order" ? (c(), p("div", yD, [
                  d.value.trim() && C.value.length > 0 ? (c(), p("div", kD, [
                    ee[6] || (ee[6] = g("i", { class: "ri-information-line text-sm shrink-0" }, null, -1)),
                    g("span", null, $(l.value.orderSearchHint), 1)
                  ])) : w("", !0),
                  g("div", {
                    class: "flex flex-col gap-3",
                    role: "list",
                    "aria-label": l.value.orderListLabel
                  }, [
                    (c(!0), p(Z, null, ke(C.value, (ve, Le) => (c(), te(qA, {
                      key: ve.key,
                      label: ve.label,
                      disabled: ve.disabled || ve.alwaysVisible,
                      reorderable: de(ve),
                      class: S([
                        "transition-all duration-150 ease-out rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-1",
                        h.value === Le && f.value !== Le ? "ring-2 ring-(--border-border-hover) rounded-xl" : "",
                        f.value === Le ? "opacity-40" : "",
                        m.value === Le ? "ring-2 ring-(--border-border-accent) rounded-xl" : ""
                      ]),
                      role: "listitem",
                      "aria-roledescription": de(ve) ? "sortable" : void 0,
                      "data-picked-up": m.value === Le ? "true" : void 0,
                      tabindex: "0",
                      onDragstart: (We) => ce(Le, We),
                      onDragover: Ie((We) => ne(Le), ["prevent"]),
                      onDragend: he,
                      onDrop: Ie((We) => ye(Le), ["prevent"]),
                      onKeydown: (We) => ie(Le, We)
                    }, {
                      badge: pe(() => [
                        ve.pinned || ve.badge ? (c(), p("span", {
                          key: 0,
                          class: S(["shrink-0 inline-flex items-center px-1 py-0.5 rounded text-xs font-medium leading-5 font-inter", J(ve.badge ?? "fige")])
                        }, $(F(ve)), 3)) : w("", !0)
                      ]),
                      actions: pe(() => [
                        ve.disabled || ve.alwaysVisible ? (c(), te(T(Ye), {
                          key: 0,
                          text: l.value.pinTooltip,
                          position: "top"
                        }, {
                          default: pe(() => [
                            g("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center",
                              disabled: "",
                              "aria-label": l.value.pinTooltip
                            }, [...ee[7] || (ee[7] = [
                              g("i", { class: "ri-pushpin-2-fill text-2xl leading-none text-(--colors-text-body-subtle)" }, null, -1)
                            ])], 8, CD)
                          ]),
                          _: 1
                        }, 8, ["text"])) : (c(), te(T(Ye), {
                          key: 1,
                          text: se(ve),
                          position: "top",
                          tabindex: D(ve) ? void 0 : 0
                        }, {
                          default: pe(() => [
                            g("button", {
                              type: "button",
                              class: "shrink-0 size-6 flex items-center justify-center rounded transition-colors duration-150 hover:bg-(--colors-background-hover) disabled:cursor-not-allowed disabled:hover:bg-transparent",
                              disabled: !D(ve),
                              "aria-label": re(ve),
                              "aria-pressed": ve.pinned,
                              onClick: Ie((We) => H(ve), ["stop"])
                            }, [
                              g("i", {
                                class: S([
                                  ve.pinned ? "ri-pushpin-2-fill text-(--colors-text-black-default)" : "ri-pushpin-2-line text-(--colors-text-body-subtle)",
                                  "text-2xl leading-none"
                                ])
                              }, null, 2)
                            ], 8, SD)
                          ]),
                          _: 2
                        }, 1032, ["text", "tabindex"]))
                      ]),
                      _: 2
                    }, 1032, ["label", "disabled", "reorderable", "class", "aria-roledescription", "data-picked-up", "onDragstart", "onDragover", "onDrop", "onKeydown"]))), 128))
                  ], 8, wD),
                  C.value.length === 0 ? (c(), p("div", $D, $(l.value.emptyOrderText), 1)) : w("", !0)
                ])) : w("", !0)
              ]),
              _: 1
            })
          ], 8, oD)
        ], 512)
      ]),
      _: 1
    }, 8, ["model-value", "aria-label"]));
  }
}), MD = /* @__PURE__ */ He(LD, [["__scopeId", "data-v-59b80a2f"]]);
function $V(e = {}) {
  const { defaultOpen: t = !1, onClose: n } = e, r = N(t);
  return { isOpen: r, open: () => {
    r.value = !0;
  }, close: () => {
    r.value = !1, n == null || n();
  }, toggle: () => {
    r.value = !r.value;
  } };
}
const ED = ["aria-busy"], AD = {
  key: 0,
  class: "border-b border-(--colors-border-base-soft) dark:border-(--colors-border-base)"
}, DD = { class: "flex-1 overflow-x-hidden min-h-0" }, RD = {
  key: 1,
  class: "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) px-5 py-3 bg-white dark:bg-(--colors-background-black-default) rounded-b-xl"
}, BD = {
  key: 0,
  "data-testid": "table-skeleton-footer",
  "aria-hidden": "true",
  class: "flex items-center justify-between h-7"
}, OD = { class: "flex items-center gap-2.5" }, IV = /* @__PURE__ */ ge({
  __name: "TableShell",
  props: {
    query: {},
    views: { default: void 0 },
    permissions: { default: () => ({}) },
    labels: {},
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] },
    columnSettings: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    skeletonColumns: { default: void 0 },
    skeletonRows: { default: void 0 },
    bordered: { type: Boolean, default: !1 }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "edit-filter", "tab-requested", "tab-reordered"],
  setup(e, { expose: t, emit: n }) {
    const r = ht(), o = e, a = n;
    qr(ko, o.query), o.views && qr(ws, o.views), o.columnSettings && qr(xE, o.columnSettings);
    const l = y(() => o.permissions ?? {});
    qr(Vp, l.value);
    const s = y(() => ({ ...Hp, ...o.labels }));
    qr(Fp, s);
    const i = N(!1), d = N(!0);
    function u() {
      i.value = !i.value, a("toggle-filter-panel");
    }
    function f() {
      d.value = !d.value;
    }
    t({ toggleFilterPanel: u });
    const h = y(
      () => o.skeletonColumns ?? (o.columnSettings && o.columnSettings.settingsItems.value.filter((v) => v.visible).length || void 0) ?? 5
    ), b = y(() => o.skeletonRows ?? o.query.state.pageSize), m = y(
      () => {
        var v, x;
        return o.showControls && (o.showFilter || ((v = o.permissions) == null ? void 0 : v.canSaveView) !== !1 || ((x = o.permissions) == null ? void 0 : x.canShareView) !== !1 || r("controls-info") || r("controls-actions") || r("filter"));
      }
    );
    return (v, x) => (c(), p(Z, null, [
      g("div", {
        "data-table-shell-root": "",
        class: "w-full flex flex-col flex-1 min-h-0",
        "aria-busy": e.loading || void 0
      }, [
        e.showTopbar ? (c(), te(Wp, {
          key: 0,
          "search-placeholder": e.searchPlaceholder,
          "show-search": e.showSearch,
          "show-view-selector": e.showViewSelector,
          "tab-dropdowns": e.tabDropdowns,
          onRenameView: x[0] || (x[0] = (k) => a("rename-view", k)),
          onDeleteView: x[1] || (x[1] = (k) => a("delete-view", k)),
          onSetDefault: x[2] || (x[2] = (k) => a("set-default", k)),
          onTabRequested: x[3] || (x[3] = (k, L) => a("tab-requested", k, L)),
          onTabReordered: x[4] || (x[4] = (k, L) => a("tab-reordered", k, L))
        }, null, 8, ["search-placeholder", "show-search", "show-view-selector", "tab-dropdowns"])) : w("", !0),
        g("div", {
          class: S([
            "flex flex-col flex-1 min-h-0 bg-white dark:bg-(--colors-background-black-default) shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] overflow-hidden",
            e.showTopbar ? m.value ? "rounded-b-xl rounded-tr-xl" : "rounded-b-xl" : "rounded-xl",
            // -mt-px pulls this card up 1px over the tabs row above so its own top border sits
            // underneath the tabs' bottom edge instead of showing as a seam; pt-px compensates
            // so the card's own content doesn't shift up with it.
            e.bordered && "border border-(--colors-border-base-soft) dark:border-(--colors-border-base) -mt-px pt-px"
          ])
        }, [
          m.value ? (c(), te(jp, {
            key: 0,
            "is-filter-panel-open": i.value,
            "is-filter-bar-visible": d.value,
            "show-filter": e.showFilter,
            bordered: !e.bordered,
            onToggleFilterPanel: u,
            onToggleFilterBar: f,
            onSaveView: x[5] || (x[5] = (k) => a("save-view")),
            onShareView: x[6] || (x[6] = (k) => a("share-view"))
          }, zn({ _: 2 }, [
            v.$slots.filter ? {
              name: "filter",
              fn: pe(() => [
                be(v.$slots, "filter")
              ]),
              key: "0"
            } : void 0,
            v.$slots["controls-info"] ? {
              name: "controls-info",
              fn: pe(() => [
                be(v.$slots, "controls-info")
              ]),
              key: "1"
            } : void 0,
            v.$slots["controls-actions"] ? {
              name: "controls-actions",
              fn: pe(() => [
                be(v.$slots, "controls-actions")
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter", "bordered"])) : w("", !0),
          ae(ot, {
            "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0 opacity-0",
            "enter-to-class": "max-h-[600px] opacity-100",
            "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[600px] opacity-100",
            "leave-to-class": "max-h-0 opacity-0"
          }, {
            default: pe(() => [
              i.value ? (c(), p("div", AD, [
                be(v.$slots, "filter-panel", {
                  close: () => i.value = !1
                })
              ])) : w("", !0)
            ]),
            _: 3
          }),
          ae(ot, {
            "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
            "enter-from-class": "max-h-0",
            "enter-to-class": "max-h-[100px]",
            "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
            "leave-from-class": "max-h-[100px]",
            "leave-to-class": "max-h-0"
          }, {
            default: pe(() => [
              d.value ? (c(), te(Up, {
                key: 0,
                bordered: !e.bordered,
                onEditFilter: x[7] || (x[7] = (k) => a("edit-filter", k))
              }, null, 8, ["bordered"])) : w("", !0)
            ]),
            _: 1
          }),
          g("div", DD, [
            e.loading ? (c(), te(KE, {
              key: 0,
              columns: h.value,
              rows: b.value
            }, null, 8, ["columns", "rows"])) : be(v.$slots, "table", { key: 1 })
          ]),
          e.loading || T(r)("pagination") ? (c(), p("div", RD, [
            e.loading ? (c(), p("div", BD, [
              x[9] || (x[9] = g("div", { class: "flex items-center gap-3" }, [
                g("div", { class: "skeleton h-1.5 w-36 rounded-full" }),
                g("div", { class: "skeleton h-1.5 w-11 rounded-full" })
              ], -1)),
              g("div", OD, [
                (c(), p(Z, null, ke(5, (k) => g("div", {
                  key: `skeleton-page-${k}`,
                  class: "skeleton size-7 rounded-md"
                })), 64))
              ])
            ])) : be(v.$slots, "pagination", { key: 1 })
          ])) : w("", !0)
        ], 2)
      ], 8, ED),
      e.columnSettings ? (c(), te(T(MD), {
        key: 0,
        modelValue: e.columnSettings.drawerOpen.value,
        "onUpdate:modelValue": x[8] || (x[8] = (k) => e.columnSettings.drawerOpen.value = k),
        columns: e.columnSettings.settingsItems.value,
        "default-columns": e.columnSettings.defaultSettingsItems.value,
        "column-order": e.columnSettings.order.value,
        labels: e.columnSettings.labels.value,
        onSave: e.columnSettings.handleSave,
        onReset: e.columnSettings.handleReset
      }, null, 8, ["modelValue", "columns", "default-columns", "column-order", "labels", "onSave", "onReset"])) : w("", !0)
    ], 64));
  }
}), PD = { class: "flex flex-col" }, zD = {
  key: 0,
  class: "border-b border-gainsboro dark:border-(--colors-border-base)"
}, TV = /* @__PURE__ */ ge({
  __name: "TableHeader",
  props: {
    showTopbar: { type: Boolean, default: !0 },
    showControls: { type: Boolean, default: !0 },
    showFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { default: "Search..." },
    showSearch: { type: Boolean, default: !0 },
    showViewSelector: { type: Boolean, default: !1 },
    tabDropdowns: { default: () => [] }
  },
  emits: ["rename-view", "delete-view", "set-default", "save-view", "share-view", "toggle-filter-panel", "edit-filter", "tab-requested"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = N(!1), a = N(!0);
    function l() {
      o.value = !o.value, r("toggle-filter-panel");
    }
    function s() {
      a.value = !a.value;
    }
    return t({ toggleFilterPanel: l }), (i, d) => (c(), p("div", PD, [
      e.showTopbar ? (c(), te(Wp, {
        key: 0,
        "search-placeholder": e.searchPlaceholder,
        "show-search": e.showSearch,
        "show-view-selector": e.showViewSelector,
        "tab-dropdowns": e.tabDropdowns,
        onRenameView: d[0] || (d[0] = (u) => r("rename-view", u)),
        onDeleteView: d[1] || (d[1] = (u) => r("delete-view", u)),
        onSetDefault: d[2] || (d[2] = (u) => r("set-default", u)),
        onTabRequested: d[3] || (d[3] = (u, f) => r("tab-requested", u, f))
      }, null, 8, ["search-placeholder", "show-search", "show-view-selector", "tab-dropdowns"])) : w("", !0),
      e.showControls ? (c(), te(jp, {
        key: 1,
        "is-filter-panel-open": o.value,
        "is-filter-bar-visible": a.value,
        "show-filter": e.showFilter,
        onToggleFilterPanel: l,
        onToggleFilterBar: s,
        onSaveView: d[4] || (d[4] = (u) => r("save-view")),
        onShareView: d[5] || (d[5] = (u) => r("share-view"))
      }, zn({ _: 2 }, [
        i.$slots.filter ? {
          name: "filter",
          fn: pe(() => [
            be(i.$slots, "filter")
          ]),
          key: "0"
        } : void 0,
        i.$slots["controls-info"] ? {
          name: "controls-info",
          fn: pe(() => [
            be(i.$slots, "controls-info")
          ]),
          key: "1"
        } : void 0,
        i.$slots["controls-actions"] ? {
          name: "controls-actions",
          fn: pe(() => [
            be(i.$slots, "controls-actions")
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["is-filter-panel-open", "is-filter-bar-visible", "show-filter"])) : w("", !0),
      ae(ot, {
        "enter-active-class": "transition-all duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0 opacity-0",
        "enter-to-class": "max-h-[600px] opacity-100",
        "leave-active-class": "transition-all duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[600px] opacity-100",
        "leave-to-class": "max-h-0 opacity-0"
      }, {
        default: pe(() => [
          o.value ? (c(), p("div", zD, [
            be(i.$slots, "filter-panel", {
              close: () => o.value = !1
            })
          ])) : w("", !0)
        ]),
        _: 3
      }),
      ae(ot, {
        "enter-active-class": "transition-[max-height] duration-200 ease-out overflow-hidden",
        "enter-from-class": "max-h-0",
        "enter-to-class": "max-h-[100px]",
        "leave-active-class": "transition-[max-height] duration-150 ease-in overflow-hidden",
        "leave-from-class": "max-h-[100px]",
        "leave-to-class": "max-h-0"
      }, {
        default: pe(() => [
          a.value ? (c(), te(Up, {
            key: 0,
            onEditFilter: d[6] || (d[6] = (u) => r("edit-filter", u))
          })) : w("", !0)
        ]),
        _: 1
      })
    ]));
  }
});
function LV(e = {}) {
  const { initialViewMode: t, filterLabels: n, filterItems: r, filterFieldConfigs: o, ...a } = e, l = N(t ?? "table"), s = ro({
    search: "",
    filters: {},
    sort: null,
    activeViewId: null,
    page: 1,
    pageSize: 10,
    ...a
  }), i = y(() => Object.keys(s.filters).length > 0), d = y(() => Object.keys(s.filters).length), u = y(() => {
    const R = yt(n), V = yt(r), J = yt(o);
    return Object.entries(s.filters).map(([F, A]) => {
      const j = {
        key: F,
        label: (R == null ? void 0 : R[F]) ?? F,
        valueLabel: ND(A, V == null ? void 0 : V[F]),
        value: A
      };
      V != null && V[F] && (j.items = V[F]);
      const _ = J == null ? void 0 : J[F];
      return _ && (_.placeholder && (j.placeholder = _.placeholder), _.rangeConfig && (j.rangeConfig = _.rangeConfig), _.dateRangeConfig && (j.dateRangeConfig = _.dateRangeConfig)), j;
    });
  });
  function f(R, V) {
    s.filters[R] = V, s.page = 1;
  }
  function h(R) {
    delete s.filters[R], s.page = 1;
  }
  function b() {
    s.filters = {}, s.page = 1;
  }
  function m(R) {
    s.search = R, s.page = 1;
  }
  function v(R, V) {
    s.sort = { column: R, direction: V };
  }
  function x() {
    s.sort = null;
  }
  function k(R) {
    s.page = R;
  }
  function L(R) {
    s.pageSize = R, s.page = 1;
  }
  function P(R) {
    s.activeViewId = R, s.page = 1;
  }
  function E(R) {
    l.value = R;
  }
  function O(R) {
    Object.assign(s, R);
  }
  return {
    state: s,
    viewMode: l,
    hasActiveFilters: i,
    activeFilterCount: d,
    activeFilterPills: u,
    setFilter: f,
    removeFilter: h,
    clearAllFilters: b,
    setSearch: m,
    setSort: v,
    clearSort: x,
    setPage: k,
    setPageSize: L,
    setView: P,
    setViewMode: E,
    patch: O
  };
}
function ND(e, t) {
  switch (e.type) {
    case "equals":
      return String(e.value);
    case "in": {
      const n = (r) => {
        var o;
        return ((o = t == null ? void 0 : t.find((a) => a.id === r)) == null ? void 0 : o.label) ?? r;
      };
      return e.values.length === 1 ? n(e.values[0]) : `${n(e.values[0])} (${e.values.length})`;
    }
    case "range":
      return e.min != null && e.max != null ? `${e.min} – ${e.max}` : e.min != null ? `≥ ${e.min}` : e.max != null ? `≤ ${e.max}` : "";
    case "dateRange":
      return e.from && e.to ? `${e.from} – ${e.to}` : e.from ? `≥ ${e.from}` : e.to ? `≤ ${e.to}` : "";
    case "boolean":
      return e.value ? "Yes" : "No";
  }
}
function MV(e = {}) {
  const t = N(e.initialViews ?? []), n = y(() => t.value.filter((d) => d.isPreset)), r = y(() => t.value.filter((d) => !d.isPreset));
  function o(d) {
    t.value.push(d);
  }
  function a(d, u) {
    const f = t.value.findIndex((h) => h.id === d);
    f !== -1 && (t.value[f] = { ...t.value[f], ...u });
  }
  function l(d) {
    t.value = t.value.filter((u) => u.id !== d);
  }
  function s(d) {
    t.value.forEach((u) => {
      u.isDefault = u.id === d;
    });
  }
  function i(d) {
    const u = new Map(d.map((b, m) => [b, m])), f = t.value.filter((b) => b.isPreset).sort(
      (b, m) => (u.get(b.id) ?? Number.MAX_SAFE_INTEGER) - (u.get(m.id) ?? Number.MAX_SAFE_INTEGER)
    ), h = t.value.filter((b) => !b.isPreset);
    t.value = [...f, ...h];
  }
  return {
    views: t,
    presetViews: n,
    savedViews: r,
    addView: o,
    updateView: a,
    removeView: l,
    setDefault: s,
    reorderViews: i
  };
}
const bf = 10, VD = 30, FD = 900;
function EV() {
  function e() {
    return typeof window > "u" ? bf : window.innerHeight >= FD ? VD : bf;
  }
  const t = N(e());
  function n() {
    t.value = e();
  }
  return Qe(() => {
    t.value = e(), window.addEventListener("resize", n, { passive: !0 });
  }), nt(() => {
    window.removeEventListener("resize", n);
  }), { pageSize: t };
}
function AV(e) {
  const { defaultVisibility: t, defaultOrder: n = [] } = e, r = e.defaultPinning ?? {
    left: yt(e.columns).filter((W) => W.pinned).map((W) => W.key),
    right: []
  }, o = y(
    () => new Set(
      yt(e.columns).filter((W) => W.disabled || W.alwaysVisible).map((W) => W.key)
    )
  ), a = y(() => [...o.value]), l = (W) => o.value.has(W), s = ro(
    t ?? Object.fromEntries(yt(e.columns).map((W) => [W.key, W.visible ?? !0]))
  ), i = Array.from(/* @__PURE__ */ new Set([...a.value, ...r.left])), d = N({
    left: i,
    right: [...r.right]
  }), u = N([...n]), f = N(!1), h = (W) => {
    var K;
    return ((K = d.value.left) == null ? void 0 : K.includes(W)) ?? !1;
  }, b = y(
    () => yt(e.columns).filter((W) => (l(W.key) || (s[W.key] ?? !0)) && (l(W.key) || h(W.key))).length
  ), m = y(() => b.value >= _o);
  function v(W) {
    return h(W) || !m.value;
  }
  const x = y(() => yt(e.columns).map((W) => ({
    ...W,
    visible: s[W.key] ?? !0,
    pinned: h(W.key)
  }))), k = y(() => {
    const W = t ?? Object.fromEntries(yt(e.columns).map((le) => [le.key, le.visible ?? !0])), K = new Set(r.left);
    return yt(e.columns).map((le) => ({
      ...le,
      visible: W[le.key] ?? !0,
      pinned: K.has(le.key)
    }));
  }), L = y(() => yt(e.labels) ?? {});
  function P() {
    f.value = !0;
  }
  function E() {
    f.value = !1;
  }
  function O(W) {
    for (const D of W)
      s[D.key] = l(D.key) ? !0 : D.visible;
    const K = [], le = [], C = [], B = [];
    for (const D of W)
      l(D.key) ? K.push(D.key) : D.visible ? D.pinned ? le.push(D.key) : C.push(D.key) : B.push(D.key);
    u.value = [...K, ...le, ...C, ...B, ...e.trailingColumns ?? []];
    const I = new Set(yt(e.columns).map((D) => D.key)), M = (d.value.left ?? []).filter((D) => !I.has(D));
    d.value = {
      left: [...M, ...K, ...le],
      right: [...d.value.right ?? []]
    };
  }
  function R() {
    const W = t ?? Object.fromEntries(yt(e.columns).map((le) => [le.key, le.visible ?? !0]));
    Object.keys(s).forEach((le) => {
      s[le] = l(le) ? !0 : W[le] ?? !0;
    }), u.value = [...n];
    const K = Array.from(/* @__PURE__ */ new Set([...a.value, ...r.left]));
    d.value = { left: K, right: [...r.right] };
  }
  function V() {
    return u.value.length > 0 ? [...u.value] : [...yt(e.columns).map((W) => W.key), ...e.trailingColumns ?? []];
  }
  function J(W) {
    if (h(W) || !v(W)) return;
    const K = [...d.value.left ?? [], W];
    d.value = { ...d.value, left: K };
    const le = new Set(K), C = V().filter((I) => I !== W);
    let B = -1;
    for (let I = 0; I < C.length; I++)
      le.has(C[I]) && (B = I);
    C.splice(B + 1, 0, W), u.value = C;
  }
  function F(W) {
    l(W) || (d.value = {
      ...d.value,
      left: (d.value.left ?? []).filter((K) => K !== W)
    });
  }
  function A(W, K) {
    if (W.length !== K.length) return !1;
    for (let le = 0; le < W.length; le++) if (W[le] !== K[le]) return !1;
    return !0;
  }
  function j(W) {
    const K = e.trailingColumns ?? [], le = new Set(K), C = W.filter((D) => !le.has(D)), B = [...C, ...K];
    A(B, u.value) || (u.value = B);
    const I = new Set(d.value.left ?? []), M = C.filter((D) => I.has(D));
    A(M, d.value.left ?? []) || (d.value = { ...d.value, left: M });
  }
  function _(W) {
    const K = new Set(yt(e.columns).map((D) => D.key)), le = W.filter((D) => K.has(D));
    if (le.length <= _o) return W;
    const C = le.filter((D) => l(D)), B = le.filter((D) => !l(D)), I = Math.max(0, _o - C.length), M = /* @__PURE__ */ new Set([...C, ...B.slice(0, I)]);
    return W.filter((D) => !K.has(D) || M.has(D));
  }
  function U(W) {
    const K = _(W.left ?? []), le = W.right ?? [], C = d.value.left ?? [], B = d.value.right ?? [];
    A(K, C) && A(le, B) || (d.value = { left: [...K], right: [...le] });
  }
  return {
    // State
    visibility: s,
    pinning: d,
    order: u,
    drawerOpen: f,
    // Computed
    settingsItems: x,
    defaultSettingsItems: k,
    labels: L,
    isPinned: h,
    isFrozenLimitReached: m,
    canPinColumn: v,
    // Actions
    openDrawer: P,
    closeDrawer: E,
    handleSave: O,
    handleReset: R,
    pinColumn: J,
    unpinColumn: F,
    setOrder: j,
    setPinning: U
  };
}
const HD = ["aria-expanded", "aria-controls"], WD = ["src"], jD = { class: "relative leading-5 dark:text-(--colors-text-white-default)" }, UD = ["id", "aria-label"], GD = { class: "relative flex flex-col gap-3 px-4 pt-4 pb-0 shadow-(--shadow-bottom-dropdown) dark:shadow-(--shadow-bottom-dropdown-dark) [clip-path:inset(0_0_-20px_0)]" }, qD = {
  key: 0,
  class: "flex flex-col gap-1.5 filter-group-buttons"
}, KD = ["aria-label"], JD = ["aria-disabled", "tabindex", "data-listbox-index", "onClick", "onKeydown", "onFocus"], ZD = ["src"], YD = {
  key: 1,
  class: "shrink-0 w-4 h-4"
}, XD = {
  key: 1,
  "data-testid": "filter-no-results",
  class: "px-4 py-3 text-(length:--size-m) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, QD = {
  key: 1,
  "data-testid": "filter-no-fields"
}, _D = { class: "flex flex-col gap-2 px-4 pb-4 pt-3" }, eR = {
  key: 0,
  class: "text-(length:--size-sm) font-medium text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, tR = {
  class: "w-full",
  "data-testid": "create-advanced-filter-btn"
}, nR = {
  class: "w-full",
  "data-testid": "view-advanced-filters-btn"
}, rR = { class: "flex items-center justify-between gap-2" }, oR = {
  key: 0,
  class: "shrink-0 text-(length:--size-m) font-medium text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, aR = {
  key: 0,
  class: "mx-4 mt-3 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)"
}, lR = ["aria-multiselectable", "aria-label"], sR = ["aria-selected", "tabindex", "onKeydown"], iR = { class: "pointer-events-none flex shrink-0 items-center" }, dR = {
  key: 0,
  class: "shrink-0 text-(length:--size-m) font-medium leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, uR = ["aria-selected", "tabindex", "data-listbox-index", "onClick", "onKeydown", "onFocus"], cR = { class: "pointer-events-none flex shrink-0 items-center" }, fR = {
  key: 0,
  class: "shrink-0 text-(length:--size-m) font-medium leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, hR = {
  key: 1,
  class: "px-2 py-1 text-(length:--size-m) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, bR = {
  key: 1,
  "data-testid": "filter-step-text",
  class: "flex flex-col gap-3 px-4 pt-4"
}, pR = ["for"], gR = { "data-testid": "filter-text-validate-error" }, mR = ["aria-labelledby"], vR = ["id"], xR = {
  key: 0,
  class: "text-(length:--size-s) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, yR = {
  key: 3,
  "data-testid": "filter-step-date-range",
  class: "flex flex-col gap-4 px-4 pt-4"
}, kR = { class: "text-(length:--size-m) font-semibold text-(--colors-text-black-default) dark:text-(--colors-text-white-default)" }, wR = { class: "flex items-end gap-4" }, CR = { class: "flex-1 min-w-0 flex flex-col gap-0.5" }, SR = ["for"], $R = { class: "flex-1 min-w-0 flex flex-col gap-0.5" }, IR = ["for"], TR = {
  key: 0,
  class: "text-(length:--size-sm) text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, LR = { class: "flex items-center gap-3 px-4 pb-4 pt-3" }, MR = {
  class: "flex-1",
  "data-testid": "filter-back-btn"
}, ER = {
  class: "flex-1",
  "data-testid": "filter-apply-btn"
}, AR = 4, ni = 16, DR = /* @__PURE__ */ ge({
  __name: "TableFilterSelector",
  props: {
    fields: {},
    fieldGroups: { default: () => [] },
    triggerLabel: { default: "Filter" },
    triggerIconLeft: { default: void 0 },
    activeCount: { default: 0 },
    step1SearchPlaceholder: { default: "Search a filter…" },
    step1FooterLabel: { default: "Rechercher par :" },
    advancedFiltersLabel: { default: "Filters avancées" },
    advancedFiltersIcon: { default: "ri-equalizer-line" },
    viewAdvancedLabel: { default: "" },
    createAdvancedLabel: { default: "" },
    advancedDisabled: { type: Boolean, default: !1 },
    advancedDisabledTooltip: { default: "" },
    backLabel: { default: "← Back" },
    confirmLabel: { default: "Confirm" },
    closeOnConfirm: { type: Boolean, default: !1 },
    dateRangeErrorLabel: { default: 'The "From" date must be before or equal to the "To" date.' },
    noResultsLabel: { default: "No results for" },
    noFieldResultsLabel: { default: "No field matches your search" },
    selectedCountLabel: { type: Function, default: (e, t) => `${e} of ${t} selected` },
    noFieldsLabel: { default: "" },
    activeFilters: { default: () => ({}) },
    fieldsSelectable: { type: Boolean, default: !0 }
  },
  emits: ["apply", "apply-filter", "remove-filter", "advanced-filters", "view-advanced-filters", "create-advanced-filter"],
  setup(e, { expose: t, emit: n }) {
    var bu, pu;
    const r = e, o = n, a = N(null), { isOpen: l, dropdownRef: s, toggleDropdown: i, openDropdown: d, closeDropdown: u } = wa({
      onClose: ug,
      ignoreSelectors: [
        '[data-testid="datepicker-dropdown-menu"]',
        '[data-testid="datepicker-dob-picker"]',
        '[data-testid="filter-selector-menu"]'
      ]
    }), f = N({}), h = { width: Np.l }, b = N(null), m = N(null);
    function v() {
      var xe, Te;
      (Te = (xe = m.value) == null ? void 0 : xe.querySelector('input[type="search"]')) == null || Te.focus();
    }
    function x() {
      var gu, mu;
      const xe = (gu = a.value) == null ? void 0 : gu.getBoundingClientRect();
      if (!xe) return;
      const Te = typeof window < "u" ? window.innerWidth : xe.right, ze = ((mu = m.value) == null ? void 0 : mu.offsetWidth) ?? 0, Dt = xe.left + xe.width / 2 > Te / 2 ? xe.right - ze : xe.left, rn = Math.max(ni, Te - ni - ze);
      f.value = {
        position: "fixed",
        top: `${xe.bottom + AR}px`,
        left: `${Math.max(ni, Math.min(Dt, rn))}px`,
        zIndex: "50"
      };
    }
    function k() {
      typeof window > "u" || (window.addEventListener("scroll", x, !0), window.addEventListener("resize", x));
    }
    function L() {
      typeof window > "u" || (window.removeEventListener("scroll", x, !0), window.removeEventListener("resize", x));
    }
    we(l, (xe) => {
      xe ? Pe(() => {
        if (x(), k(), b.value) {
          Fr(b.value), b.value = null;
          return;
        }
        v(), bt();
      }) : L();
    }), Bt(L);
    function P(xe) {
      !l.value && (xe.key === "ArrowDown" || xe.key === "ArrowUp") && (xe.preventDefault(), d());
    }
    function E(xe) {
      if (l.value) {
        Fr(xe);
        return;
      }
      b.value = xe, setTimeout(i, 0);
    }
    t({ openDropdown: d, closeDropdown: u, openForField: E, triggerEl: a });
    function O(xe) {
      l.value && (xe.stopPropagation(), xe.preventDefault(), R.value === "value" ? De() : (u(), Pe(() => {
        var Te;
        return (Te = a.value) == null ? void 0 : Te.focus();
      })));
    }
    const R = N("field"), V = N(""), J = N(((pu = (bu = r.fieldGroups) == null ? void 0 : bu[0]) == null ? void 0 : pu.value) ?? "");
    we(
      () => r.fieldGroups,
      (xe) => {
        xe != null && xe.length && (xe.some((Te) => Te.value === J.value) || (J.value = xe[0].value));
      },
      { immediate: !0 }
    );
    const F = N(null), A = N(""), j = N(/* @__PURE__ */ new Set()), _ = N(""), U = N(null), W = N(null), K = N(""), le = N(""), C = y(
      () => F.value != null ? r.fields.find((xe) => xe.key === F.value) ?? null : null
    );
    function B(xe, Te) {
      if (!xe) return null;
      const ze = xe.split(/[/\\\-.]/), mt = Te.toLowerCase().split(/[/\\\-.]/), Be = {};
      return mt.forEach((Dt, rn) => {
        Be[Dt] = parseInt(ze[rn], 10);
      }), isNaN(Be.yyyy) || isNaN(Be.mm) || isNaN(Be.dd) ? null : new Date(Be.yyyy, (Be.mm || 1) - 1, Be.dd || 1);
    }
    const I = y(() => {
      var xe;
      return (xe = C.value) != null && xe.maxLength ? _.value.length <= C.value.maxLength : !0;
    }), M = y(() => {
      var ze, mt;
      if (((ze = C.value) == null ? void 0 : ze.type) !== "text") return null;
      const xe = (mt = C.value) == null ? void 0 : mt.validate;
      if (!xe) return null;
      const Te = _.value.trim();
      return Te.length === 0 ? null : xe(Te);
    }), D = y(() => {
      const xe = C.value;
      if (!(!xe || xe.type !== "text")) {
        if (xe.maxLength && _.value.length > xe.maxLength)
          return xe.maxLengthErrorLabel ?? `Maximum ${xe.maxLength} characters`;
        if (M.value) return M.value;
      }
    }), re = Ke(), se = y(() => `${re}-text`), de = y(() => `${re}-range-group`), fe = y(() => `${re}-date-from`), q = y(() => `${re}-date-to`), oe = y(() => U.value == null || W.value == null ? !0 : U.value <= W.value), ue = y(() => {
      var mt;
      if (!K.value || !le.value) return !0;
      const xe = ((mt = C.value) == null ? void 0 : mt.dateFormat) ?? "dd/mm/yyyy", Te = B(K.value, xe), ze = B(le.value, xe);
      return !Te || !ze ? !0 : Te <= ze;
    }), G = y(() => {
      var xe;
      return ((xe = C.value) == null ? void 0 : xe.type) ?? "list";
    }), H = y(() => {
      let xe = r.fields;
      J.value && (xe = xe.filter((ze) => !ze.group || ze.group === J.value));
      const Te = V.value.trim().toLowerCase();
      return Te && (xe = xe.filter((ze) => ze.label.toLowerCase().includes(Te))), xe;
    }), z = y(() => !!r.advancedFiltersLabel), X = y(() => !!r.viewAdvancedLabel && !!r.createAdvancedLabel), Y = y(() => {
      if (!C.value || G.value !== "list") return [];
      const xe = C.value.items ?? [], Te = A.value.trim().toLowerCase();
      return Te ? xe.filter((ze) => ze.label.toLowerCase().includes(Te)) : xe;
    }), ce = y(() => {
      var xe;
      return (((xe = C.value) == null ? void 0 : xe.items) ?? []).length;
    }), ne = y(() => {
      var ze;
      const xe = ((ze = C.value) == null ? void 0 : ze.items) ?? [];
      return xe.some((mt) => typeof mt.count == "number") ? xe.reduce((mt, Be) => mt + (typeof Be.count == "number" ? Be.count : 0), 0) : ce.value;
    }), ye = y(
      () => {
        var xe;
        return (((xe = C.value) == null ? void 0 : xe.items) ?? []).filter((Te) => j.value.has(Te.id)).length;
      }
    ), he = y(
      () => ye.value === ce.value && ce.value > 0
    ), ie = y(
      () => ye.value > 0 && ye.value < ce.value
    ), me = N(null), Q = N(null), {
      focusedIndex: ee,
      handleRovingKeydown: ve,
      clampFocusedIndex: Le,
      focusListboxOption: We
    } = cl(), {
      focusedIndex: qe,
      handleRovingKeydown: fn,
      clampFocusedIndex: hn,
      focusListboxOption: Et
    } = cl(), At = y(
      () => {
        var xe, Te;
        return !((xe = C.value) != null && xe.single) && !A.value && (((Te = C.value) == null ? void 0 : Te.items) ?? []).length > 0;
      }
    ), In = y(
      () => (At.value ? 1 : 0) + Y.value.length
    );
    we(
      () => H.value.length,
      (xe) => Le(xe)
    ), we(
      () => In.value,
      (xe) => hn(xe)
    );
    function bn() {
      ee.value = 0, Pe(() => {
        We(me.value, 0), bt();
      });
    }
    we(R, (xe) => {
      xe === "field" && bn();
    });
    function br() {
      qe.value = 0, Pe(() => {
        Et(Q.value, 0), bt();
      });
    }
    function bt() {
      var xe, Te, ze;
      (xe = m.value) != null && xe.contains(document.activeElement) || (ze = (Te = m.value) == null ? void 0 : Te.querySelector('input:not([type="hidden"]):not([type="range"]), textarea, button')) == null || ze.focus();
    }
    function Hn(xe) {
      ve(xe, H.value.length, me.value);
    }
    function Wn(xe) {
      fn(xe, In.value, Q.value);
    }
    const La = y(
      () => ye.value > 0 ? r.selectedCountLabel(ye.value, ce.value) : ""
    );
    function Fr(xe) {
      var mt, Be;
      const Te = F.value === xe;
      F.value = xe, A.value = "";
      const ze = (mt = r.activeFilters) == null ? void 0 : mt[xe];
      ze ? (ze.type === "in" ? j.value = new Set(ze.values) : j.value = /* @__PURE__ */ new Set(), _.value = ze.type === "equals" ? String(ze.value) : "", U.value = ze.type === "range" ? ze.min : null, W.value = ze.type === "range" ? ze.max : null, K.value = ze.type === "dateRange" ? ze.from ?? "" : "", le.value = ze.type === "dateRange" ? ze.to ?? "" : "") : (j.value = /* @__PURE__ */ new Set(), _.value = "", U.value = null, W.value = null, K.value = "", le.value = ""), R.value = "value", (!Te || !((Be = m.value) != null && Be.contains(document.activeElement))) && br();
    }
    function Me(xe) {
      r.fieldsSelectable && Fr(xe);
    }
    function De() {
      R.value = "field", F.value = null;
    }
    function dt(xe) {
      var ze;
      if ((ze = C.value) != null && ze.single) {
        j.value = j.value.has(xe) ? /* @__PURE__ */ new Set() : /* @__PURE__ */ new Set([xe]);
        return;
      }
      const Te = new Set(j.value);
      Te.has(xe) ? Te.delete(xe) : Te.add(xe), j.value = Te;
    }
    function $t() {
      var xe;
      he.value ? j.value = /* @__PURE__ */ new Set() : j.value = new Set((((xe = C.value) == null ? void 0 : xe.items) ?? []).map((Te) => Te.id));
    }
    function $s() {
      const xe = F.value, Te = G.value;
      if (Te === "list")
        o("apply", xe, [...j.value]);
      else if (Te === "text") {
        if (M.value)
          return;
        _.value.trim() ? o("apply-filter", xe, { type: "equals", value: _.value.trim() }) : o("remove-filter", xe);
      } else Te === "range" ? U.value != null || W.value != null ? o("apply-filter", xe, { type: "range", min: U.value, max: W.value }) : o("remove-filter", xe) : Te === "dateRange" && (K.value || le.value ? o("apply-filter", xe, {
        type: "dateRange",
        from: K.value || null,
        to: le.value || null
      }) : o("remove-filter", xe));
      r.closeOnConfirm ? (u(), Pe(() => {
        var ze;
        return (ze = a.value) == null ? void 0 : ze.focus();
      })) : De();
    }
    function fu() {
      o("advanced-filters"), u();
    }
    function ig() {
      r.advancedDisabled || (o("view-advanced-filters"), u());
    }
    function dg() {
      r.advancedDisabled || (o("create-advanced-filter"), u());
    }
    function ug() {
      var xe, Te;
      R.value = "field", F.value = null, V.value = "", J.value = ((Te = (xe = r.fieldGroups) == null ? void 0 : xe[0]) == null ? void 0 : Te.value) ?? "", A.value = "", j.value = /* @__PURE__ */ new Set(), _.value = "", U.value = null, W.value = null, K.value = "", le.value = "";
    }
    const hu = (xe) => !!xe && xe.startsWith("ri-");
    return (xe, Te) => (c(), p("div", {
      ref_key: "dropdownRef",
      ref: s,
      class: "relative inline-block text-left dark:text-(--colors-text-white-default)",
      onKeydown: je(O, ["escape"])
    }, [
      g("button", {
        ref_key: "triggerRef",
        ref: a,
        type: "button",
        "data-testid": "filter-selector-trigger",
        class: S([
          "inline-flex cursor-pointer items-center gap-1.5 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:ring-offset-2 rounded-[9999px] border border-solid px-3 py-2 text-(length:--size-m) transition-colors duration-300",
          T(l) ? "border-royalblue bg-royalblue/10 text-(--colors-text-black-default) dark:border-royalblue dark:text-(--colors-text-white-default) dark:bg-royalblue/10" : "border-border-secondary-button bg-white hover:border-royalblue dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)"
        ]),
        "aria-expanded": T(l),
        "aria-controls": T(l) ? T(re) : void 0,
        "aria-haspopup": "dialog",
        onClick: Te[0] || (Te[0] = //@ts-ignore
        (...ze) => T(i) && T(i)(...ze)),
        onKeydown: P
      }, [
        e.triggerIconLeft ? (c(), p(Z, { key: 0 }, [
          hu(e.triggerIconLeft) ? (c(), p("i", {
            key: 0,
            class: S([e.triggerIconLeft, "text-base leading-none"])
          }, null, 2)) : (c(), p("img", {
            key: 1,
            class: "h-4 w-4",
            src: e.triggerIconLeft,
            alt: ""
          }, null, 8, WD))
        ], 64)) : w("", !0),
        g("span", jD, $(e.triggerLabel), 1),
        e.activeCount > 0 ? (c(), te(pt, {
          key: 1,
          "data-testid": "filter-active-badge",
          theme: "active",
          size: "sm",
          "badge-style": "circle",
          "text-only": "",
          value: e.activeCount
        }, null, 8, ["value"])) : w("", !0),
        (c(), p("svg", {
          class: "h-4 w-4 transition-transform duration-200 ease-in-out",
          style: Ae({ transform: T(l) ? "rotate(180deg)" : "rotate(0deg)" }),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, [...Te[9] || (Te[9] = [
          g("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 9l-7 7-7-7"
          }, null, -1)
        ])], 4))
      ], 42, HD),
      (c(), te(cn, { to: "body" }, [
        ae(ot, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: pe(() => {
            var ze, mt;
            return [
              T(l) ? (c(), p("div", {
                key: 0,
                id: T(re),
                ref_key: "panelRef",
                ref: m,
                role: "dialog",
                "aria-label": e.triggerLabel,
                "data-testid": "filter-selector-menu",
                "data-focus-trap-allow-outside": "",
                style: Ae([h, f.value]),
                class: "flex max-w-[calc(100vw-2rem)] flex-col rounded-(--border-border-radius-rounded-l) border border-solid bg-white-50-opacity-bold border-border-base-soft shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
                onKeydown: je(O, ["escape"])
              }, [
                R.value === "field" ? (c(), p(Z, { key: 0 }, [
                  g("div", GD, [
                    ae(T(Rr), {
                      modelValue: V.value,
                      "onUpdate:modelValue": Te[1] || (Te[1] = (Be) => V.value = Be),
                      placeholder: e.step1SearchPlaceholder,
                      size: "sm",
                      "full-width": "",
                      rounded: "xl"
                    }, null, 8, ["modelValue", "placeholder"]),
                    (ze = e.fieldGroups) != null && ze.length ? (c(), p("div", qD, [
                      ae(T(ou), {
                        class: "w-full gap-1 p-1",
                        color: "dark"
                      }, {
                        default: pe(() => [
                          (c(!0), p(Z, null, ke(e.fieldGroups, (Be) => (c(), te(T($e), {
                            key: Be.value,
                            variant: "tertiary",
                            active: J.value === Be.value,
                            "data-testid": "field-group-btn",
                            class: "min-w-0 flex-1 justify-center",
                            onClick: (Dt) => J.value = Be.value
                          }, {
                            default: pe(() => [
                              ae(Eo, {
                                text: Be.label,
                                focusable: !1,
                                position: "bottom"
                              }, null, 8, ["text"])
                            ]),
                            _: 2
                          }, 1032, ["active", "onClick"]))), 128))
                        ]),
                        _: 1
                      })
                    ])) : w("", !0)
                  ]),
                  Te[11] || (Te[11] = g("div", { class: "mx-4 mt-3 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)),
                  H.value.length ? (c(), p("div", {
                    key: 0,
                    ref_key: "step1ListboxRef",
                    ref: me,
                    role: "listbox",
                    "aria-label": e.step1SearchPlaceholder,
                    class: "flex flex-col gap-0.5 p-2 max-h-[280px] overflow-y-auto",
                    onKeydown: Hn
                  }, [
                    (c(!0), p(Z, null, ke(H.value, (Be, Dt) => (c(), p("div", {
                      key: Be.key,
                      role: "option",
                      "aria-selected": !1,
                      "aria-disabled": e.fieldsSelectable ? void 0 : !0,
                      tabindex: Dt === T(ee) ? 0 : -1,
                      "data-listbox-index": Dt,
                      class: S([
                        "flex w-full items-center gap-2 rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-(--colors-text-black-default) transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) dark:text-(--colors-text-white-default)",
                        e.fieldsSelectable ? "cursor-pointer hover:bg-(--colors-background-hover) dark:hover:bg-white/8" : "cursor-default"
                      ]),
                      onClick: Ie((rn) => Me(Be.key), ["stop"]),
                      onKeydown: [
                        je(Ie((rn) => Me(Be.key), ["prevent"]), ["enter"]),
                        je(Ie((rn) => Me(Be.key), ["prevent"]), ["space"])
                      ],
                      onFocus: (rn) => ee.value = Dt
                    }, [
                      Be.icon ? (c(), p(Z, { key: 0 }, [
                        hu(Be.icon) ? (c(), p("i", {
                          key: 0,
                          class: S([
                            Be.icon,
                            "shrink-0 text-base leading-none text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                          ])
                        }, null, 2)) : (c(), p("img", {
                          key: 1,
                          class: "h-4 w-4 shrink-0 opacity-50",
                          src: Be.icon,
                          alt: ""
                        }, null, 8, ZD))
                      ], 64)) : (c(), p("span", YD)),
                      ae(Eo, {
                        class: "flex-1",
                        text: Be.label,
                        focusable: !1,
                        "text-class": "text-(length:--size-m) font-medium leading-5"
                      }, null, 8, ["text"])
                    ], 42, JD))), 128))
                  ], 40, KD)) : (c(), p("div", XD, [
                    V.value ? (c(), p(Z, { key: 0 }, [
                      Ze($(e.noFieldResultsLabel), 1)
                    ], 64)) : e.noFieldsLabel ? (c(), p("span", QD, $(e.noFieldsLabel), 1)) : w("", !0)
                  ])),
                  X.value || z.value ? (c(), p(Z, { key: 2 }, [
                    Te[10] || (Te[10] = g("div", { class: "mx-4 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)),
                    g("div", _D, [
                      e.step1FooterLabel ? (c(), p("span", eR, $(e.step1FooterLabel), 1)) : w("", !0),
                      X.value ? (c(), p(Z, { key: 1 }, [
                        ae(Ye, {
                          text: e.advancedDisabledTooltip,
                          disabled: !e.advancedDisabled,
                          tabindex: e.advancedDisabled ? 0 : void 0
                        }, {
                          default: pe(() => [
                            g("div", tR, [
                              ae(T($e), {
                                variant: "primary",
                                label: e.createAdvancedLabel,
                                "icon-left": "ri-add-line",
                                size: "sm",
                                "full-width": "",
                                disabled: e.advancedDisabled,
                                onClick: dg
                              }, null, 8, ["label", "disabled"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["text", "disabled", "tabindex"]),
                        ae(Ye, {
                          text: e.advancedDisabledTooltip,
                          disabled: !e.advancedDisabled,
                          tabindex: e.advancedDisabled ? 0 : void 0
                        }, {
                          default: pe(() => [
                            g("div", nR, [
                              ae(T($e), {
                                variant: "secondary",
                                label: e.viewAdvancedLabel,
                                "icon-left": e.advancedFiltersIcon,
                                size: "sm",
                                "full-width": "",
                                disabled: e.advancedDisabled,
                                onClick: ig
                              }, null, 8, ["label", "icon-left", "disabled"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["text", "disabled", "tabindex"])
                      ], 64)) : (c(), te(T($e), {
                        key: 2,
                        variant: "secondary",
                        label: e.advancedFiltersLabel,
                        "icon-left": e.advancedFiltersIcon,
                        "data-testid": "advanced-filters-btn",
                        size: "sm",
                        "full-width": "",
                        onClick: fu
                      }, null, 8, ["label", "icon-left"]))
                    ])
                  ], 64)) : w("", !0)
                ], 64)) : w("", !0),
                R.value === "value" && C.value ? (c(), p(Z, { key: 1 }, [
                  G.value === "list" ? (c(), p(Z, { key: 0 }, [
                    g("div", {
                      "data-testid": "filter-step-list",
                      class: S(["flex flex-col gap-3 px-4 pt-4", Y.value.length ? "pb-0" : "pb-4"])
                    }, [
                      g("div", rR, [
                        ae(Eo, {
                          class: "min-w-0 flex-1",
                          text: C.value.label,
                          "text-class": "text-(length:--size-m) font-semibold text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
                        }, null, 8, ["text"]),
                        La.value ? (c(), p("span", oR, $(La.value), 1)) : w("", !0)
                      ]),
                      ae(T(Rr), {
                        modelValue: A.value,
                        "onUpdate:modelValue": Te[2] || (Te[2] = (Be) => A.value = Be),
                        placeholder: C.value.step2SearchPlaceholder ?? "Search…",
                        size: "sm",
                        "full-width": "",
                        rounded: "xl"
                      }, null, 8, ["modelValue", "placeholder"])
                    ], 2),
                    Y.value.length || !A.value ? (c(), p("div", aR)) : w("", !0),
                    Y.value.length || !A.value ? (c(), p("div", {
                      key: 1,
                      ref_key: "step2ListboxRef",
                      ref: Q,
                      role: "listbox",
                      "aria-multiselectable": !((mt = C.value) != null && mt.single),
                      "aria-label": C.value.label,
                      class: "flex flex-col gap-1 p-2 max-h-[240px] overflow-y-auto",
                      onKeydown: Wn
                    }, [
                      At.value ? (c(), p("div", {
                        key: 0,
                        role: "option",
                        "aria-selected": he.value,
                        tabindex: T(qe) === 0 ? 0 : -1,
                        "data-listbox-index": "0",
                        class: "flex w-full cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2 text-(--colors-text-black-default) transition-colors hover:bg-(--colors-background-hover) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) dark:text-(--colors-text-white-default) dark:hover:bg-white/8",
                        onClick: $t,
                        onKeydown: [
                          je(Ie($t, ["prevent"]), ["enter"]),
                          je(Ie($t, ["prevent"]), ["space"])
                        ],
                        onFocus: Te[3] || (Te[3] = (Be) => qe.value = 0)
                      }, [
                        g("div", iR, [
                          ae(T(Xt), {
                            "model-value": he.value,
                            indeterminate: ie.value,
                            presentational: ""
                          }, null, 8, ["model-value", "indeterminate"])
                        ]),
                        ae(Eo, {
                          class: "me-auto flex-1",
                          text: C.value.selectAllLabel ?? "Select all",
                          focusable: !1,
                          "text-class": "text-(length:--size-m) font-medium leading-5"
                        }, null, 8, ["text"]),
                        ne.value > 0 ? (c(), p("span", dR, "(" + $(ne.value) + ")", 1)) : w("", !0)
                      ], 40, sR)) : w("", !0),
                      (c(!0), p(Z, null, ke(Y.value, (Be, Dt) => (c(), p("div", {
                        key: Be.id,
                        role: "option",
                        "aria-selected": j.value.has(Be.id),
                        tabindex: T(qe) === (At.value ? Dt + 1 : Dt) ? 0 : -1,
                        "data-listbox-index": At.value ? Dt + 1 : Dt,
                        class: "flex w-full cursor-pointer items-center gap-1.5 rounded-(--border-border-radius-rounded-sm) p-2 text-(--colors-text-black-default) transition-colors hover:bg-(--colors-background-hover) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) dark:text-(--colors-text-white-default) dark:hover:bg-white/8",
                        onClick: (rn) => dt(Be.id),
                        onKeydown: [
                          je(Ie((rn) => dt(Be.id), ["prevent"]), ["enter"]),
                          je(Ie((rn) => dt(Be.id), ["prevent"]), ["space"])
                        ],
                        onFocus: (rn) => qe.value = At.value ? Dt + 1 : Dt
                      }, [
                        g("div", cR, [
                          ae(T(Xt), {
                            "model-value": j.value.has(Be.id),
                            presentational: ""
                          }, null, 8, ["model-value"])
                        ]),
                        ae(Eo, {
                          class: "me-auto flex-1",
                          text: Be.label,
                          focusable: !1,
                          "text-class": "text-(length:--size-m) font-medium leading-5"
                        }, null, 8, ["text"]),
                        Be.count !== void 0 ? (c(), p("span", fR, "(" + $(Be.count) + ")", 1)) : w("", !0)
                      ], 40, uR))), 128)),
                      Y.value.length === 0 && A.value ? (c(), p("div", hR, $(e.noResultsLabel) + ' "' + $(A.value) + '". ', 1)) : w("", !0)
                    ], 40, lR)) : w("", !0)
                  ], 64)) : G.value === "text" ? (c(), p("div", bR, [
                    g("label", {
                      for: se.value,
                      class: "text-(length:--size-m) font-semibold text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
                    }, $(C.value.label), 9, pR),
                    g("div", gR, [
                      ae(T(er), {
                        id: se.value,
                        modelValue: _.value,
                        "onUpdate:modelValue": Te[4] || (Te[4] = (Be) => _.value = Be),
                        placeholder: C.value.placeholder ?? "",
                        error: D.value,
                        size: "sm",
                        "full-width": ""
                      }, null, 8, ["id", "modelValue", "placeholder", "error"])
                    ])
                  ])) : G.value === "range" ? (c(), p("div", {
                    key: 2,
                    "data-testid": "filter-step-range",
                    class: "flex flex-col gap-4 px-4 pt-4",
                    role: "group",
                    "aria-labelledby": de.value
                  }, [
                    g("span", {
                      id: de.value,
                      class: "text-(length:--size-m) font-semibold text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
                    }, $(C.value.label), 9, vR),
                    ae(T(zp), {
                      "min-value": U.value,
                      "onUpdate:minValue": Te[5] || (Te[5] = (Be) => U.value = Be),
                      "max-value": W.value,
                      "onUpdate:maxValue": Te[6] || (Te[6] = (Be) => W.value = Be),
                      min: C.value.rangeMin ?? 0,
                      max: C.value.rangeMax ?? 1e4,
                      step: C.value.rangeStep ?? 1,
                      "separator-label": C.value.rangeSeparatorLabel ?? "to",
                      "clamp-input-to-bounds": C.value.rangeClampInputToBounds ?? !0,
                      "data-min": C.value.rangeDataMin ?? null,
                      "data-max": C.value.rangeDataMax ?? null,
                      "hint-label": C.value.rangeHintLabel ?? ""
                    }, null, 8, ["min-value", "max-value", "min", "max", "step", "separator-label", "clamp-input-to-bounds", "data-min", "data-max", "hint-label"]),
                    oe.value ? w("", !0) : (c(), p("p", xR, $(C.value.rangeErrorLabel ?? "Min value must be less than or equal to max value"), 1))
                  ], 8, mR)) : G.value === "dateRange" ? (c(), p("div", yR, [
                    g("span", kR, $(C.value.label), 1),
                    g("div", wR, [
                      g("div", CR, [
                        g("label", {
                          for: fe.value,
                          class: "px-px text-(length:--size-m) font-medium leading-5 text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
                        }, $(C.value.dateFromLabel ?? "From"), 9, SR),
                        ae(T(Yi), {
                          id: fe.value,
                          modelValue: K.value,
                          "onUpdate:modelValue": Te[7] || (Te[7] = (Be) => K.value = Be),
                          placeholder: C.value.datePlaceholder ?? "dd/mm/yyyy",
                          format: C.value.dateFormat ?? "dd/mm/yyyy",
                          size: "sm",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "placeholder", "format"])
                      ]),
                      g("div", $R, [
                        g("label", {
                          for: q.value,
                          class: "px-px text-(length:--size-m) font-medium leading-5 text-(--colors-text-black-default) dark:text-(--colors-text-white-default)"
                        }, $(C.value.dateToLabel ?? "To"), 9, IR),
                        ae(T(Yi), {
                          id: q.value,
                          modelValue: le.value,
                          "onUpdate:modelValue": Te[8] || (Te[8] = (Be) => le.value = Be),
                          placeholder: C.value.datePlaceholder ?? "dd/mm/yyyy",
                          format: C.value.dateFormat ?? "dd/mm/yyyy",
                          size: "sm",
                          "full-width": ""
                        }, null, 8, ["id", "modelValue", "placeholder", "format"])
                      ])
                    ]),
                    ue.value ? w("", !0) : (c(), p("p", TR, $(e.dateRangeErrorLabel), 1))
                  ])) : w("", !0),
                  Te[12] || (Te[12] = g("div", { class: "mx-4 mt-3 border-t border-(--color-border-base-soft) dark:border-(--colors-border-base)" }, null, -1)),
                  g("div", LR, [
                    g("div", MR, [
                      ae(T($e), {
                        variant: "secondary",
                        label: e.backLabel,
                        size: "sm",
                        "full-width": "",
                        onClick: Ie(De, ["stop"])
                      }, null, 8, ["label"])
                    ]),
                    g("div", ER, [
                      ae(T($e), {
                        variant: "primary",
                        label: e.confirmLabel,
                        size: "sm",
                        "full-width": "",
                        disabled: G.value === "text" && (!I.value || !!M.value) || G.value === "dateRange" && !ue.value || G.value === "range" && !oe.value,
                        onClick: $s
                      }, null, 8, ["label", "disabled"])
                    ])
                  ])
                ], 64)) : w("", !0)
              ], 44, UD)) : w("", !0)
            ];
          }),
          _: 1
        })
      ]))
    ], 544));
  }
}), DV = /* @__PURE__ */ He(DR, [["__scopeId", "data-v-40dc736a"]]), RR = /* @__PURE__ */ ge({
  __name: "TablePanel",
  props: {
    roundTop: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", {
      class: S([
        "min-w-0 border border-(--border-border-base-soft) overflow-x-auto shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]",
        e.roundTop ? "rounded-xl" : "rounded-b-xl"
      ])
    }, [
      be(t.$slots, "default")
    ], 2));
  }
}), BR = {
  key: 0,
  class: "border-b border-(--border-border-base-soft)"
}, OR = {
  key: 1,
  "data-testid": "records-table-header",
  class: "flex items-center justify-between gap-4 px-3 py-3 border-b border-(--border-border-base-soft)"
}, PR = { class: "flex items-center gap-2.5 min-w-0" }, zR = {
  key: 0,
  class: "shrink-0 size-12 flex items-center justify-center bg-white border border-(--border-border-base-medium) rounded-lg"
}, NR = { class: "flex flex-col gap-px min-w-0" }, VR = {
  key: 0,
  class: "text-base font-medium leading-6 text-(--text-text-heading) truncate"
}, FR = {
  key: 1,
  class: "text-base font-normal leading-6 text-(--text-text-body) truncate"
}, HR = {
  key: 0,
  "data-testid": "records-table-actions",
  class: "flex items-center gap-2 shrink-0"
}, WR = ["onClick"], jR = { class: "flex items-center gap-1" }, UR = {
  key: 0,
  class: "ri-expand-up-down-line text-xs"
}, GR = { key: 0 }, qR = ["colspan"], pf = "sticky right-0 z-10 shadow-[inset_1px_0_0_var(--border-border-base-soft),-2px_0_4px_-2px_rgba(0,0,0,0.06)]", KR = "[transform:translateZ(0)]", RV = /* @__PURE__ */ ge({
  __name: "RecordsTable",
  props: {
    columns: {},
    data: {},
    emptyText: { default: "" },
    tableClass: {},
    title: {},
    subtitle: {},
    icon: {},
    minWidth: {},
    layout: { default: "fixed" }
  },
  setup(e) {
    const t = e, n = ht(), r = N(null), o = N("asc"), a = (s) => {
      r.value === s ? o.value = o.value === "asc" ? "desc" : "asc" : (r.value = s, o.value = "asc");
    }, l = y(() => {
      if (!r.value) return t.data;
      const s = t.columns.find((i) => i.id === r.value);
      return s != null && s.sortable ? [...t.data].sort((i, d) => {
        const u = s.sortBy(i), f = s.sortBy(d), h = String(u).localeCompare(String(f), void 0, { numeric: !0 });
        return o.value === "asc" ? h : -h;
      }) : t.data;
    });
    return (s, i) => (c(), te(RR, null, {
      default: pe(() => [
        g("div", {
          style: Ae(e.minWidth ? { minWidth: `max(100%, ${e.minWidth}px)` } : void 0)
        }, [
          T(n)("header") ? (c(), p("div", BR, [
            be(s.$slots, "header")
          ])) : e.title || e.subtitle || e.icon || T(n)("actions") ? (c(), p("div", OR, [
            g("div", PR, [
              e.icon ? (c(), p("div", zR, [
                g("i", {
                  class: S([e.icon, "text-[length:var(--size-5xl)] leading-none text-(--text-text-body)"]),
                  "aria-hidden": "true"
                }, null, 2)
              ])) : w("", !0),
              g("div", NR, [
                e.title ? (c(), p("span", VR, $(e.title), 1)) : w("", !0),
                e.subtitle ? (c(), p("span", FR, $(e.subtitle), 1)) : w("", !0)
              ])
            ]),
            T(n)("actions") ? (c(), p("div", HR, [
              be(s.$slots, "actions")
            ])) : w("", !0)
          ])) : w("", !0),
          g("table", {
            class: S(["w-full", e.layout === "auto" ? "table-auto" : "table-fixed", e.tableClass])
          }, [
            g("thead", null, [
              g("tr", null, [
                (c(!0), p(Z, null, ke(e.columns, (d) => (c(), p("th", {
                  key: d.id,
                  class: S([
                    "h-11 px-5 overflow-hidden text-left text-sm font-medium text-(--text-text-body) border-b border-(--border-border-base-medium) bg-white",
                    d.width,
                    d.sortable && "cursor-pointer select-none",
                    d.sticky && [pf, KR]
                  ]),
                  onClick: (u) => d.sortable ? a(d.id) : void 0
                }, [
                  g("div", jR, [
                    Ze($(d.header) + " ", 1),
                    d.sortable ? (c(), p("i", UR)) : w("", !0)
                  ])
                ], 10, WR))), 128))
              ])
            ]),
            g("tbody", null, [
              l.value.length ? w("", !0) : (c(), p("tr", GR, [
                g("td", {
                  colspan: e.columns.length,
                  class: "h-14 px-5 text-sm text-center text-(--text-text-body)"
                }, $(e.emptyText), 9, qR)
              ])),
              (c(!0), p(Z, null, ke(l.value, (d, u) => (c(), p("tr", {
                key: u,
                class: "border-b border-(--border-border-base-soft) last:border-b-0"
              }, [
                (c(!0), p(Z, null, ke(e.columns, (f, h) => (c(), p("td", {
                  key: f.id,
                  class: S([
                    "h-14 px-5 overflow-hidden",
                    h === 0 && e.layout === "fixed" && "max-w-0",
                    f.sticky && ["bg-white", pf]
                  ])
                }, [
                  (c(), te(Wt(() => f.cell(d))))
                ], 2))), 128))
              ]))), 128))
            ])
          ], 2)
        ], 4)
      ]),
      _: 3
    }));
  }
}), JR = { class: "w-full relative shadow-[0px_1px_0.5px_0.05px_rgba(29,_41,_61,_0.02)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-t-[0px] rounded-b-3xl bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border flex flex-col items-start text-left text-[14px] text-gray-200 dark:text-[var(--colors-text-white-default)] font-inter" }, ZR = {
  key: 0,
  style: { width: "256px" }
}, YR = { class: "flex items-center justify-end gap-3 flex-shrink-0" }, XR = {
  key: 0,
  class: "skeleton h-9 w-32"
}, QR = {
  key: 1,
  class: "skeleton h-9 w-20"
}, _R = { class: "self-stretch overflow-x-auto" }, eB = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, tB = {
  key: 0,
  class: "flex flex-col items-start"
}, nB = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, rB = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, oB = ["data-testid"], aB = { class: "flex items-center justify-end gap-3 text-gray-200 dark:text-[var(--colors-text-white-default)] flex-shrink-0" }, lB = { class: "self-stretch overflow-x-auto" }, sB = {
  class: "flex items-start",
  style: { width: "100%", "min-width": "max-content", "min-height": "324px" }
}, iB = {
  key: 0,
  class: "flex flex-col items-start"
}, dB = { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, uB = { class: "flex items-center" }, cB = ["onClick"], fB = { class: "flex items-center gap-1 min-w-0" }, hB = ["title"], bB = ["src"], pB = ["onMousedown"], gB = { class: "flex-1 relative leading-[20px] overflow-hidden text-ellipsis whitespace-nowrap" }, mB = { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-[14px] text-(--colors-text-body) dark:text-(--colors-text-white-default)" }, vB = { class: "flex items-center gap-1" }, xB = { class: "relative leading-[20px] font-medium" }, yB = {
  key: 2,
  class: "flex-1 bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start min-w-0",
  style: { "min-width": "0" }
}, kB = {
  key: 0,
  class: "self-stretch rounded-t-[0px] rounded-b-[12px] bg-white dark:bg-[var(--colors-background-black-default)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] flex items-center justify-between p-[20px] gap-5"
}, wB = { class: "relative leading-[20px] dark:text-[var(--colors-text-white-default)]" }, CB = { class: "flex justify-end" }, SB = /* @__PURE__ */ ge({
  __name: "Table",
  props: {
    columns: {},
    rows: {},
    showCheckbox: { type: Boolean, default: !0 },
    title: { default: "Transactions" },
    searchPlaceholder: { default: "Search for transaction" },
    showSearch: { type: Boolean, default: !0 },
    showFilters: { type: Boolean, default: !0 },
    showAddButton: { type: Boolean, default: !0 },
    addButtonLabel: { default: "Add transaction" },
    showActions: { type: Boolean, default: !0 },
    rowActions: { type: [Array, Function], default: () => [
      { label: "Actions", icon: void 0, onClick: () => {
      } },
      { label: "Delete", icon: void 0, onClick: () => {
      }, isDelete: !0 }
    ] },
    enablePagination: { type: Boolean, default: !0 },
    itemsPerPage: { default: 10 },
    totalItems: { default: 1e3 },
    currentPage: { default: 1 },
    searchIcon: { default: void 0 },
    filtersIcon: { default: void 0 },
    actionsIcon: { default: void 0 },
    addButtonIconLeft: { default: void 0 },
    filterItems: { default: () => [
      { label: "All", onClick: () => {
      } },
      { label: "Completed", onClick: () => {
      } },
      { label: "Pending", onClick: () => {
      } },
      { label: "Failed", onClick: () => {
      } }
    ] },
    filterSections: { default: () => [] },
    headerActionsItems: { default: () => [
      { label: "Export CSV", onClick: () => {
      } },
      { label: "Export Excel", onClick: () => {
      } },
      { label: "Print", onClick: () => {
      } }
    ] },
    filtersLabel: { default: "Filters" },
    actionsLabel: { default: "Actions" },
    actionsColumnLabel: { default: "Actions" },
    filterResetLabel: { default: "Reset" },
    filterApplyLabel: { default: "Apply" },
    filterMenuWidth: { default: "280px" },
    paginationText: { type: Function, default: (e, t, n) => `Showing ${e}-${t} of ${n}` },
    wrap: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    serverSideSearch: { type: Boolean, default: !1 },
    serverSidePagination: { type: Boolean, default: !1 },
    searchDataTestId: { default: void 0 }
  },
  emits: ["search", "filter", "filter-apply", "filter-reset", "filter-change", "add", "action", "page-change", "selection-change"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => [
      {
        label: n.filterResetLabel,
        variant: "secondary",
        onClick: () => r("filter-reset"),
        keepOpen: !0
      },
      {
        label: n.filterApplyLabel,
        variant: "primary",
        onClick: () => {
          var B;
          const C = {};
          (B = n.filterSections) == null || B.forEach((I) => {
            C[I.id] = I.checked ?? I.switchChecked ?? !1;
          }), r("filter-apply", C);
        }
      }
    ]), a = N(""), l = N(/* @__PURE__ */ new Set()), s = N(null), i = N("asc"), d = N(n.currentPage);
    we(
      () => n.currentPage,
      (C) => {
        n.serverSidePagination && C !== void 0 && (d.value = C);
      }
    );
    const u = N({}), f = N(!1), h = N(null), b = N(0), m = N(0), v = () => {
      const C = {};
      return n.columns.forEach((B) => {
        if (B.width) {
          const I = parseFloat(B.width);
          B.width.includes("px") ? C[B.key] = I : n.wrap || (C[B.key] = 200);
        } else n.wrap || (C[B.key] = 200);
      }), n.showActions && !n.wrap && (C.__actions__ = 150), C;
    };
    Object.keys(u.value).length === 0 && (u.value = v());
    const x = (C) => u.value[C] ? `${u.value[C]}px` : "200px", k = (C, B) => {
      if (f.value = !0, h.value = C, b.value = B.clientX, u.value[C])
        m.value = u.value[C];
      else {
        const M = B.target.closest(".bg-white.flex.flex-col");
        M ? m.value = M.offsetWidth : m.value = 200;
      }
      document.body.classList.add("resizing"), document.addEventListener("mousemove", L), document.addEventListener("mouseup", P), B.preventDefault(), B.stopPropagation();
    }, L = (C) => {
      if (!f.value || !h.value) return;
      const B = C.clientX - b.value, I = m.value + B;
      I >= 50 && I <= 1e3 && (u.value[h.value] = I);
    }, P = () => {
      f.value = !1, h.value = null, document.body.classList.remove("resizing"), document.removeEventListener("mousemove", L), document.removeEventListener("mouseup", P);
    };
    we(
      () => n.columns,
      () => {
        if (n.wrap) {
          const C = v();
          Object.keys(C).forEach((B) => {
            u.value[B] === void 0 && C[B] !== void 0 && (u.value[B] = C[B]);
          });
        } else {
          const C = n.columns.every((I) => u.value[I.key] !== void 0), B = !n.showActions || u.value.__actions__ !== void 0;
          if (!C || !B) {
            const I = v();
            Object.keys(I).forEach((M) => {
              u.value[M] === void 0 && I[M] !== void 0 && (u.value[M] = I[M]);
            });
          }
        }
      },
      { deep: !0 }
    ), we(
      () => n.wrap,
      () => {
        u.value = v();
      }
    );
    const E = y(() => {
      let C = n.rows;
      if (a.value && n.showSearch && !n.serverSideSearch && (C = C.filter(
        (B) => JSON.stringify(B).toLowerCase().includes(a.value.toLowerCase())
      )), s.value && (C = [...C].sort((B, I) => {
        const M = B[s.value], D = I[s.value];
        return M == null && D == null ? 0 : M == null ? 1 : D == null ? -1 : M < D ? i.value === "asc" ? -1 : 1 : M > D ? i.value === "asc" ? 1 : -1 : 0;
      })), n.enablePagination && !n.serverSidePagination) {
        const B = (d.value - 1) * n.itemsPerPage, I = B + n.itemsPerPage;
        return C.slice(B, I);
      }
      return C;
    }), O = y(() => {
      if (!n.enablePagination) return 1;
      if (n.serverSidePagination) return Math.ceil((n.totalItems ?? 0) / n.itemsPerPage);
      if (n.serverSideSearch) return Math.ceil(n.rows.length / n.itemsPerPage);
      const C = n.rows.filter(
        (B) => !a.value || JSON.stringify(B).toLowerCase().includes(a.value.toLowerCase())
      );
      return Math.ceil(C.length / n.itemsPerPage);
    }), R = (C) => {
      d.value = 1, r("search", C);
    }, V = (C) => {
      C.sortable && (s.value === C.key ? i.value = i.value === "asc" ? "desc" : "asc" : (s.value = C.key, i.value = "asc"));
    }, J = (C) => {
      C ? E.value.forEach((B) => {
        l.value.add(B.id);
      }) : E.value.forEach((B) => {
        l.value.delete(B.id);
      }), r(
        "selection-change",
        Array.from(l.value).map((B) => n.rows.find((I) => I.id === B))
      );
    }, F = (C) => {
      l.value.has(C.id) ? l.value.delete(C.id) : l.value.add(C.id), r(
        "selection-change",
        Array.from(l.value).map((B) => n.rows.find((I) => I.id === B))
      );
    }, A = (C) => {
      d.value = C, r("page-change", C);
    }, j = (C, B) => {
      C.onClick(B), r("action", C, B);
    }, _ = (C) => l.value.has(C.id), U = (C) => typeof n.rowActions == "function" ? n.rowActions(C) : n.rowActions || [], W = y(() => E.value.length === 0 ? !1 : E.value.every((C) => l.value.has(C.id))), K = (C, B) => B.render ? B.render(C[B.key], C) : C[B.key], le = (C) => {
      const B = [70, 85, 60, 90, 75, 80, 65, 95];
      return `${B[C % B.length]}%`;
    };
    return (C, B) => (c(), p("div", JR, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        g("div", {
          class: S(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), p("div", ZR, [...B[4] || (B[4] = [
            g("div", { class: "skeleton h-10 w-full" }, null, -1)
          ])])) : w("", !0),
          g("div", YR, [
            e.showAddButton ? (c(), p("div", XR)) : w("", !0),
            e.showFilters ? (c(), p("div", QR)) : w("", !0),
            B[5] || (B[5] = g("div", { class: "skeleton h-9 w-20" }, null, -1))
          ])
        ], 2),
        g("div", _R, [
          g("div", eB, [
            e.showCheckbox ? (c(), p("div", tB, [
              B[7] || (B[7] = g("div", { class: "w-14 h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-center justify-center py-0 px-[20px]" }, [
                g("div", { class: "skeleton h-4 w-4" })
              ], -1)),
              (c(!0), p(Z, null, ke(e.itemsPerPage, (I) => (c(), p("div", {
                key: `skeleton-checkbox-${I}`,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [...B[6] || (B[6] = [
                g("div", { class: "skeleton h-4 w-4" }, null, -1)
              ])]))), 128))
            ])) : w("", !0),
            (c(!0), p(Z, null, ke(e.columns, (I, M) => (c(), p("div", {
              key: `skeleton-col-${M}`,
              style: Ae(
                e.wrap ? u.value[I.key] ? { width: `${u.value[I.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: I.width ? "0 0 auto" : "1 1 0%",
                  width: I.width || "auto"
                } : { width: x(I.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative"
            }, [
              B[8] || (B[8] = g("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                g("div", { class: "skeleton h-5 w-24" })
              ], -1)),
              (c(!0), p(Z, null, ke(e.itemsPerPage, (D) => (c(), p("div", {
                key: `skeleton-row-${M}-${D}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px]"
              }, [
                g("div", {
                  class: "skeleton h-5",
                  style: Ae({ width: le(D - 1) })
                }, null, 4)
              ]))), 128))
            ], 4))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), p("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
              style: Ae(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: x("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              B[10] || (B[10] = g("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px]" }, [
                g("div", { class: "skeleton h-5 w-16" })
              ], -1)),
              (c(!0), p(Z, null, ke(e.itemsPerPage, (I) => (c(), p("div", {
                key: `skeleton-actions-${I}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [...B[9] || (B[9] = [
                g("div", { class: "skeleton h-8 w-20" }, null, -1)
              ])]))), 128))
            ], 4)) : w("", !0),
            e.wrap ? w("", !0) : (c(), p("div", nB, [
              B[11] || (B[11] = g("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), p(Z, null, ke(e.itemsPerPage, (I) => (c(), p("div", {
                key: `skeleton-spacer-${I}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), p("div", rB, [...B[12] || (B[12] = [
          g("div", { class: "skeleton h-5 w-32" }, null, -1),
          g("div", { class: "skeleton h-9 w-48" }, null, -1)
        ])])) : w("", !0)
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("div", {
          class: S(["self-stretch rounded-t-[12px] rounded-b-[0px] bg-white dark:bg-[var(--colors-background-black-default)] flex items-center p-[20px] gap-5 text-slategray dark:text-[var(--colors-text-white-default)]", e.showSearch ? "justify-between" : "justify-end"])
        }, [
          e.showSearch ? (c(), p("div", {
            key: 0,
            style: { width: "256px" },
            "data-testid": e.searchDataTestId
          }, [
            ae(T(Rr), {
              modelValue: a.value,
              "onUpdate:modelValue": [
                B[0] || (B[0] = (I) => a.value = I),
                B[1] || (B[1] = (I) => R(I))
              ],
              placeholder: e.searchPlaceholder,
              "icon-left": e.searchIcon,
              size: "md",
              width: "256px"
            }, null, 8, ["modelValue", "placeholder", "icon-left"])
          ], 8, oB)) : w("", !0),
          g("div", aB, [
            e.showAddButton ? (c(), te(T($e), {
              key: 0,
              variant: "primary",
              label: e.addButtonLabel,
              "icon-left": e.addButtonIconLeft,
              size: "sm",
              class: "flex-shrink-0 whitespace-nowrap",
              onClick: B[2] || (B[2] = () => C.$emit("add"))
            }, null, 8, ["label", "icon-left"])) : w("", !0),
            e.showFilters && e.filterSections && e.filterSections.length > 0 ? (c(), te(T(au), {
              key: 1,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterSections,
              "menu-width": e.filterMenuWidth,
              "menu-align": "right",
              "footer-buttons": o.value
            }, null, 8, ["label", "trigger-icon-left", "items", "menu-width", "footer-buttons"])) : e.showFilters && (!e.filterSections || e.filterSections.length === 0) ? (c(), te(T(kn), {
              key: 2,
              label: e.filtersLabel,
              "trigger-icon-left": e.filtersIcon,
              items: e.filterItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon-left", "items"])) : w("", !0),
            e.headerActionsItems && e.headerActionsItems.length > 0 ? (c(), te(T(kn), {
              key: 3,
              label: e.actionsLabel,
              "trigger-icon": e.actionsIcon,
              items: e.headerActionsItems,
              "menu-width": "180px",
              "menu-align": "right"
            }, null, 8, ["label", "trigger-icon", "items"])) : w("", !0)
          ])
        ], 2),
        g("div", lB, [
          g("div", sB, [
            e.showCheckbox ? (c(), p("div", iB, [
              g("div", dB, [
                g("div", uB, [
                  ae(T(Xt), {
                    "model-value": W.value,
                    "onUpdate:modelValue": J
                  }, null, 8, ["model-value"])
                ])
              ]),
              (c(!0), p(Z, null, ke(E.value, (I) => (c(), p("div", {
                key: I.id,
                class: "w-14 h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center justify-center py-0 px-[20px]"
              }, [
                ae(T(Xt), {
                  "model-value": _(I),
                  "onUpdate:modelValue": () => F(I)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]))), 128))
            ])) : w("", !0),
            (c(!0), p(Z, null, ke(e.columns, (I, M) => (c(), p("div", {
              key: M,
              style: Ae(
                e.wrap ? u.value[I.key] ? { width: `${u.value[I.key]}px`, minWidth: "50px", flexShrink: 0 } : {
                  minWidth: "50px",
                  flex: I.width ? "0 0 auto" : "1 1 0%",
                  width: I.width || "auto"
                } : { width: x(I.key), minWidth: "50px", flexShrink: 0 }
              ),
              class: S([
                "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start relative",
                e.wrap && !I.width && !u.value[I.key] ? "min-w-0" : ""
              ])
            }, [
              g("div", {
                class: S(["self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border flex flex-col items-start justify-center py-0 px-[20px] text-(--colors-text-body) dark:text-(--colors-text-white-default) cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] transition-colors duration-200", { "opacity-50": !I.sortable }]),
                onClick: (D) => V(I)
              }, [
                g("div", fB, [
                  g("div", {
                    class: "relative leading-[20px] font-medium overflow-hidden text-ellipsis whitespace-nowrap",
                    title: I.label
                  }, $(I.label), 9, hB),
                  I.sortable && s.value === I.key ? (c(), p("img", {
                    key: 0,
                    class: "h-3.5 w-3.5 relative table-sort-icon",
                    style: Ae({
                      transform: i.value === "asc" ? "rotate(0deg)" : "rotate(180deg)"
                    }),
                    src: s.value === I.key ? "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22%3E%3Cpath d=%22M19 9l-7 7-7-7%22/%3E%3C/svg%3E" : "",
                    alt: ""
                  }, null, 12, bB)) : w("", !0)
                ])
              ], 10, cB),
              g("div", {
                class: S(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && h.value === I.key }]),
                onMousedown: (D) => k(I.key, D)
              }, null, 42, pB),
              (c(!0), p(Z, null, ke(E.value, (D) => (c(), p("div", {
                key: D.id,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border overflow-hidden shrink-0 flex items-center py-0 px-[20px] text-text-body dark:text-[var(--colors-text-white-default)]"
              }, [
                g("div", gB, [
                  be(C.$slots, `cell-${I.key}`, {
                    value: D[I.key],
                    row: D,
                    column: I
                  }, () => [
                    Ze($(K(D, I)), 1)
                  ], !0)
                ])
              ]))), 128))
            ], 6))), 128)),
            e.showActions && e.rowActions && e.rowActions.length > 0 ? (c(), p("div", {
              key: 1,
              class: "bg-white dark:bg-[var(--colors-background-black-default)] flex flex-col items-start text-[12px] text-text-body dark:text-[var(--colors-text-white-default)] relative",
              style: Ae(
                e.wrap ? u.value.__actions__ ? { width: `${u.value.__actions__}px`, minWidth: "50px", flexShrink: 0 } : { minWidth: "50px", flex: "0 0 auto", width: "auto" } : { width: x("__actions__"), minWidth: "50px", flexShrink: 0 }
              )
            }, [
              g("div", mB, [
                g("div", vB, [
                  g("div", xB, $(e.actionsColumnLabel), 1)
                ])
              ]),
              g("div", {
                class: S(["absolute top-0 right-0 w-1 h-full cursor-col-resize z-0 hover:bg-blue-500 transition-colors", { "bg-blue-500": f.value && h.value === "__actions__" }]),
                onMousedown: B[3] || (B[3] = (I) => k("__actions__", I))
              }, null, 34),
              (c(!0), p(Z, null, ke(E.value, (I) => (c(), p("div", {
                key: `actions-${I.id}`,
                class: "h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border flex items-center py-0 px-[20px] gap-2",
                style: { width: "100%" }
              }, [
                U(I).filter((M) => !M.isDelete).length > 0 ? (c(), te(T(kn), {
                  key: 0,
                  label: e.actionsColumnLabel,
                  items: U(I).filter((M) => !M.isDelete).map((M) => ({
                    label: M.label,
                    icon: M.icon,
                    testId: M.testId,
                    onClick: () => j(M, I)
                  })),
                  "menu-width": "150px"
                }, null, 8, ["label", "items"])) : w("", !0),
                (c(!0), p(Z, null, ke(U(I).filter((M) => M.isDelete), (M) => (c(), te(T($e), {
                  key: M.label,
                  variant: "error",
                  label: M.label,
                  "icon-left": M.icon,
                  size: "xs",
                  onClick: () => j(M, I)
                }, null, 8, ["label", "icon-left", "onClick"]))), 128))
              ]))), 128))
            ], 4)) : w("", !0),
            e.wrap ? w("", !0) : (c(), p("div", yB, [
              B[13] || (B[13] = g("div", { class: "self-stretch h-11 bg-whitesmoke-100 dark:bg-[rgba(255,255,255,0.05)] border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-t-[1px] border-b-[1px] box-border" }, null, -1)),
              (c(!0), p(Z, null, ke(E.value, (I) => (c(), p("div", {
                key: `spacer-${I.id}`,
                class: "self-stretch h-14 border-gainsboro dark:border-[var(--colors-border-base)] border-solid border-b-[1px] box-border"
              }))), 128))
            ]))
          ])
        ]),
        e.enablePagination ? (c(), p("div", kB, [
          g("div", wB, $(e.paginationText(
            (d.value - 1) * e.itemsPerPage + 1,
            Math.min(d.value * e.itemsPerPage, e.totalItems),
            e.totalItems
          )), 1),
          g("div", CB, [
            ae(T(aE), {
              "current-page": d.value,
              "total-pages": O.value,
              "total-items": e.totalItems,
              "items-per-page": e.itemsPerPage,
              mode: "icons-only",
              "max-visible-pages": 8,
              onPageChange: A
            }, null, 8, ["current-page", "total-pages", "total-items", "items-per-page"])
          ])
        ])) : w("", !0)
      ], 64))
    ]));
  }
}), BV = /* @__PURE__ */ He(SB, [["__scopeId", "data-v-b930c981"]]), $B = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M10.8284%2012.0007L15.7782%2016.9504L14.364%2018.3646L8%2012.0007L14.364%205.63672L15.7782%207.05093L10.8284%2012.0007Z'/%3e%3c/svg%3e", IB = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.1717%2012.0007L8.22192%207.05093L9.63614%205.63672L16.0001%2012.0007L9.63614%2018.3646L8.22192%2016.9504L13.1717%2012.0007Z'/%3e%3c/svg%3e", TB = ["data-theme", "data-collapsed", "aria-label"], LB = { class: "flex items-center sidebar-logo" }, MB = ["src"], EB = {
  key: 0,
  class: "h-7.5 border-border-base-medium border-solid border-l box-border flex items-center justify-center py-num-0 pl-3 pr-num-0"
}, AB = { class: "relative leading-5.5 font-semibold dark:text-(--colors-text-white-secondary)" }, DB = ["aria-label", "aria-expanded"], RB = ["src"], BB = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, OB = ["src"], PB = {
  key: 0,
  class: "self-stretch border-border-base-soft border-solid border-b flex flex-col items-start pt-num-0 px-num-0 pb-4 shrink-0"
}, zB = ["data-active", "aria-label", "aria-expanded", "aria-controls", "aria-current", "disabled"], NB = ["src"], VB = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, FB = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary)"
}, HB = {
  key: 0,
  class: "flex items-center gap-1.5 text-center text-[12px] text-text-black-default dark:text-(--colors-text-white-secondary) relative z-10"
}, WB = { class: "relative leading-5 font-medium z-10 dark:text-(--colors-text-white-secondary)" }, jB = ["src"], UB = ["data-active", "aria-current", "aria-disabled", "disabled", "onClick"], GB = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, qB = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary)" }, KB = { class: "self-stretch flex flex-col items-start gap-2 shrink-0 text-text-black-default dark:text-(--colors-text-white-secondary)" }, JB = {
  key: 0,
  class: "self-stretch border-t border-border-base-soft my-1 sidebar-divider",
  "aria-hidden": "true"
}, ZB = {
  key: 1,
  class: "self-stretch flex flex-col items-start"
}, YB = ["data-active", "data-opened", "data-testid", "aria-label", "aria-expanded", "aria-controls", "aria-current", "aria-disabled", "disabled", "onClick"], XB = ["src"], QB = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, _B = {
  key: 2,
  class: "relative leading-num-24 font-medium dark:text-(--colors-text-white-secondary) truncate"
}, eO = ["src"], tO = ["data-active", "data-testid", "aria-current", "aria-disabled", "disabled", "onClick"], nO = { class: "flex-1 flex items-center justify-start py-num-0 pl-num-2 pr-num-0 shrink-0 relative z-10 text-left min-w-0" }, rO = { class: "relative leading-num-24 font-medium text-left dark:text-(--colors-text-white-secondary) truncate" }, oO = ["data-active", "data-testid", "aria-label", "aria-current", "aria-disabled", "disabled", "onClick"], aO = ["src"], lO = {
  key: 1,
  class: "h-5 w-5 relative shrink-0",
  "aria-hidden": "true"
}, sO = {
  key: 2,
  class: "relative leading-num-24 font-medium z-10 dark:text-(--colors-text-white-secondary) truncate"
}, iO = {
  key: 0,
  class: "self-stretch shrink-0 flex flex-col items-center relative z-10 sidebar-scroll-indicator"
}, dO = ["src"], uO = { class: "self-stretch border-border-base-soft border-solid border-t shrink-0 pt-4 text-[12px] relative z-10" }, cO = { key: 0 }, fO = ["href"], hO = {
  key: 1,
  class: "relative leading-5 font-medium mb-1 sidebar-footer-a11y"
}, bO = { class: "relative leading-5 font-medium dark:text-(--colors-text-white-secondary)" }, pO = /* @__PURE__ */ ge({
  __name: "Sidebar",
  props: {
    companyIcon: { default: "/logo-eudonet-small.svg" },
    companyName: { default: "Eudonet" },
    items: { default: () => [] },
    modelValue: { type: Boolean, default: !0 },
    collapsed: { type: Boolean, default: void 0 },
    width: { default: "239px" },
    collapsedWidth: { default: "80px" },
    theme: { default: "light" },
    footerText: { default: "Powered by Eudonet" },
    ariaLabel: {},
    accessibilityText: { default: "" },
    accessibilityLink: { default: void 0 },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 }
  },
  emits: ["update:modelValue", "update:collapsed", "item-click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = N({}), l = () => {
      Object.keys(a.value).forEach((I) => {
        a.value[I] = !1;
      });
    };
    we(
      () => n.collapsed,
      (I, M) => {
        I !== void 0 && (o.value = I, I ? l() : M === !0 && !Object.values(a.value).some(Boolean) && x());
      },
      { immediate: !0 }
    );
    const s = () => {
      const I = !o.value;
      o.value = I, r("update:collapsed", I), I ? l() : x();
    }, i = N(
      typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1
    );
    Qe(() => {
      if (typeof window > "u") return;
      const I = window.matchMedia("(prefers-color-scheme: dark)"), M = (D) => {
        i.value = D.matches;
      };
      I.addEventListener("change", M), nt(() => I.removeEventListener("change", M));
    });
    const d = y(
      () => n.theme === "auto" ? i.value : n.theme === "dark"
    ), u = y(() => d.value ? "sidebar-dark" : "sidebar-light"), f = y(() => {
      const I = {};
      return n.backgroundColor && (I["--sidebar-bg"] = n.backgroundColor), n.textColor && (I["--sidebar-text"] = n.textColor), n.borderColor && (I["--sidebar-border"] = n.borderColor), n.accentColor && (I["--sidebar-accent"] = n.accentColor), n.hoverBackgroundColor && (I["--sidebar-hover-bg"] = n.hoverBackgroundColor), I.width = o.value ? n.collapsedWidth : n.width, I;
    }), h = (I) => I.key ?? I.label, b = y(() => n.items.find((I) => I.key === "bookmarks")), m = y(
      () => b.value ? h(b.value) : "bookmarks"
    ), v = y(() => n.items.filter((I) => I.key !== "bookmarks")), x = () => {
      n.items.forEach((I) => {
        var M;
        (M = I.children) != null && M.some((D) => D.active) && (a.value[h(I)] = !0);
      });
    };
    Qe(() => {
      o.value || x();
    });
    const k = (I) => a.value[I] === !0, L = (I) => {
      const M = !a.value[I];
      M && Object.keys(a.value).forEach((D) => {
        D !== I && (a.value[D] = !1);
      }), a.value[I] = M;
    }, P = N(null), E = N(!1), O = N(!1), R = () => {
      const I = P.value;
      I && (E.value = I.scrollTop > 4, O.value = I.scrollTop + I.clientHeight < I.scrollHeight - 4);
    }, V = () => {
      const I = P.value;
      I && I.scrollBy({ top: -100, behavior: "smooth" });
    }, J = () => {
      const I = P.value;
      I && I.scrollBy({ top: 100, behavior: "smooth" });
    };
    let F = null, A = null;
    Qe(() => {
      setTimeout(() => {
        R();
        const I = P.value;
        I && (A = new ResizeObserver(() => R()), A.observe(I), F = new MutationObserver(() => R()), F.observe(I, { childList: !0, subtree: !0 }));
      }, 0);
    }), nt(() => {
      A == null || A.disconnect(), A = null, F == null || F.disconnect(), F = null;
    }), we(
      a,
      () => {
        Pe(R), setTimeout(R, 100), setTimeout(R, 200), setTimeout(R, 350);
      },
      { deep: !0 }
    );
    const j = (I) => {
      if (I.disabled) return;
      const M = I.children !== void 0 && I.children.length > 0;
      o.value ? (o.value = !1, r("update:collapsed", !1), M ? L(h(I)) : x()) : M && L(h(I)), I.onClick && I.onClick(), r("item-click", I);
    }, _ = (I) => {
      var M;
      return I.active === !0 || o.value && (((M = I.children) == null ? void 0 : M.some((D) => D.active)) ?? !1);
    }, U = ur(), W = y(() => !!U.logo), K = y(
      () => o.value ? "/logo-eudonet-small.svg" : n.companyIcon
    ), le = (I) => {
      const M = "group self-stretch flex items-center justify-start py-num-6 pl-num-32 pr-num-8 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 relative text-left sidebar-child-item";
      return I.disabled ? `${M} opacity-50 cursor-not-allowed` : I.active ? `${M} rounded-[48px] overflow-visible sidebar-item-active` : `${M} rounded-num-12 sidebar-item-hover`;
    }, C = (I) => {
      const M = "group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-simple-item";
      return I.disabled ? `${M} opacity-50 cursor-not-allowed` : I.active ? `${M} relative overflow-visible sidebar-item-active` : `${M} sidebar-item-hover`;
    }, B = () => 'h-5.5 w-5.5 rounded-full relative flex items-center justify-center overflow-visible before:opacity-100 after:opacity-100 before:content-[""] before:absolute before:inset-[-1px] before:rounded-full before:[background:var(--sidebar-accent)] before:transition-opacity before:duration-300 before:z-0 after:content-[""] after:absolute after:inset-0 after:rounded-full after:transition-opacity after:duration-300 after:z-[1] sidebar-badge';
    return (I, M) => e.modelValue ? (c(), p("nav", {
      key: 0,
      class: S(["h-full relative shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-tl-none rounded-tr-3xl rounded-b-none box-border flex flex-col items-start text-left text-[18px] font-inter transition-all duration-300 sidebar-container", [u.value, { "sidebar-collapsed": o.value }, o.value ? "p-2" : "p-5"]]),
      "data-theme": d.value ? "dark" : "light",
      "data-collapsed": o.value ? "true" : "false",
      style: Ae(f.value),
      "aria-label": e.ariaLabel ?? "Main navigation"
    }, [
      g("div", {
        class: S([
          "self-stretch border-border-base-soft border-solid border-b pt-num-0 px-num-0 relative z-[2] shrink-0",
          o.value ? "flex flex-col items-center gap-2 overflow-visible pb-2" : "flex items-center justify-between gap-5 pb-5"
        ])
      }, [
        g("div", {
          class: S(["flex items-center gap-3", [{ "justify-center": o.value }, { "flex-1": !o.value }]])
        }, [
          g("div", LB, [
            W.value ? be(I.$slots, "logo", {
              key: 0,
              collapsed: o.value
            }, void 0, !0) : K.value ? (c(), p("img", {
              key: 1,
              class: "h-7 w-7 relative",
              src: K.value,
              alt: "Company logo"
            }, null, 8, MB)) : w("", !0)
          ]),
          o.value ? w("", !0) : (c(), p("div", EB, [
            g("div", AB, $(e.companyName), 1)
          ]))
        ], 2),
        g("button", {
          type: "button",
          class: "sidebar-toggle-button shrink-0 h-6 w-6 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center cursor-pointer hover:border-gray-300 transition-colors duration-200",
          "aria-label": o.value ? "Expand sidebar" : "Collapse sidebar",
          "aria-expanded": !o.value,
          onClick: s
        }, [
          g("img", {
            src: o.value ? T(IB) : T($B),
            class: "h-4 w-4 relative sidebar-toggle-icon",
            alt: "",
            "aria-hidden": "true"
          }, null, 8, RB)
        ], 8, DB)
      ], 2),
      ae(ot, { name: "fade" }, {
        default: pe(() => [
          E.value ? (c(), p("div", BB, [
            g("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll up",
              onClick: V
            }, [
              g("img", {
                src: T(sl),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, OB)
            ]),
            M[1] || (M[1] = g("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1))
          ])) : w("", !0)
        ]),
        _: 1
      }),
      g("div", {
        ref_key: "scrollAreaRef",
        ref: P,
        class: "flex-1 min-h-0 overflow-y-auto self-stretch flex flex-col gap-4 py-4 text-num-16 dark:text-(--colors-text-white-secondary) sidebar-scroll-area relative z-[2]",
        onScroll: R
      }, [
        b.value ? (c(), p("div", PB, [
          ae(Ye, {
            text: b.value.label,
            position: "right",
            disabled: !o.value,
            class: "self-stretch flex-col"
          }, {
            default: pe(() => {
              var D;
              return [
                g("button", {
                  type: "button",
                  class: S(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                    { "justify-center": o.value },
                    { "sidebar-item-active": _(b.value) },
                    { "opacity-50 cursor-not-allowed": b.value.disabled }
                  ]]),
                  "data-active": _(b.value) ? "true" : "false",
                  "aria-label": o.value ? b.value.label : void 0,
                  "aria-expanded": k(m.value),
                  "aria-controls": (D = b.value.children) != null && D.length ? "sidebar-submenu-bookmarks" : void 0,
                  "aria-current": b.value.active ? "page" : void 0,
                  disabled: b.value.disabled,
                  onClick: M[0] || (M[0] = (re) => j(b.value))
                }, [
                  g("div", {
                    class: S(["flex-1 flex items-center gap-1.5", { "justify-center": o.value }])
                  }, [
                    b.value.icon ? (c(), p("img", {
                      key: 0,
                      class: "h-5 w-5 relative shrink-0",
                      src: b.value.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, NB)) : (c(), p("div", VB)),
                    o.value ? w("", !0) : (c(), p("div", FB, $(b.value.label), 1))
                  ], 2),
                  o.value ? w("", !0) : (c(), p("div", HB, [
                    g("div", {
                      class: S(B())
                    }, [
                      g("div", WB, $(b.value.badge ?? 0), 1)
                    ], 2),
                    g("img", {
                      class: "h-4 w-4 relative z-10 transition-transform duration-200",
                      src: k(m.value) ? T(sl) : T(no),
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, jB)
                  ]))
                ], 10, zB)
              ];
            }),
            _: 1
          }, 8, ["text", "disabled"]),
          b.value.children && b.value.children.length > 0 ? (c(), te(ta, {
            key: 0,
            id: "sidebar-submenu-bookmarks",
            name: "submenu",
            tag: "div",
            role: "region",
            "aria-label": `${b.value.label} submenu`,
            class: S([
              "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
              { "submenu-open": k(m.value) }
            ])
          }, {
            default: pe(() => [
              (c(!0), p(Z, null, ke(k(m.value) ? b.value.children : [], (D) => (c(), p("button", {
                key: h(D),
                type: "button",
                class: S(le(D)),
                "data-active": D.active ? "true" : "false",
                "aria-current": D.active ? "page" : void 0,
                "aria-disabled": D.disabled ? "true" : void 0,
                disabled: D.disabled,
                onClick: (re) => j(D)
              }, [
                g("div", GB, [
                  g("div", qB, $(D.label), 1)
                ])
              ], 10, UB))), 128))
            ]),
            _: 1
          }, 8, ["aria-label", "class"])) : w("", !0)
        ])) : w("", !0),
        g("div", KB, [
          (c(!0), p(Z, null, ke(v.value, (D) => (c(), p(Z, {
            key: h(D)
          }, [
            D.divider ? (c(), p("hr", JB)) : w("", !0),
            D.children !== void 0 ? (c(), p("div", ZB, [
              ae(Ye, {
                text: D.label,
                position: "right",
                disabled: !o.value,
                class: "self-stretch flex-col"
              }, {
                default: pe(() => {
                  var re;
                  return [
                    g("button", {
                      type: "button",
                      class: S(["group self-stretch rounded-num-12 flex items-center justify-between py-num-6 px-num-8 gap-0 cursor-pointer border-solid border border-transparent transition-[background,border-color] duration-300 sidebar-section-header", [
                        { "justify-center": o.value },
                        { "sidebar-item-active": _(D) },
                        {
                          "sidebar-item-opened": (k(h(D)) || ((re = D.children) == null ? void 0 : re.some((se) => se.active))) && !D.active
                        },
                        { "opacity-50 cursor-not-allowed": D.disabled }
                      ]]),
                      "data-active": _(D) ? "true" : "false",
                      "data-opened": k(h(D)) ? "true" : "false",
                      "data-testid": D.testId,
                      "aria-label": o.value ? D.label : void 0,
                      "aria-expanded": k(h(D)),
                      "aria-controls": `sidebar-submenu-${h(D)}`,
                      "aria-current": D.active ? "page" : void 0,
                      "aria-disabled": D.disabled ? "true" : void 0,
                      disabled: D.disabled,
                      onClick: (se) => j(D)
                    }, [
                      g("div", {
                        class: S(["flex-1 flex items-center gap-1.5 min-w-0", { "justify-center": o.value }])
                      }, [
                        D.icon ? (c(), p("img", {
                          key: 0,
                          class: "h-5 w-5 relative shrink-0",
                          src: D.icon,
                          alt: "",
                          "aria-hidden": "true"
                        }, null, 8, XB)) : (c(), p("div", QB)),
                        o.value ? w("", !0) : (c(), p("div", _B, $(D.label), 1))
                      ], 2),
                      !o.value && D.children.length > 0 ? (c(), p("img", {
                        key: 0,
                        class: "h-4 w-4 relative transition-transform duration-200 shrink-0",
                        src: k(h(D)) ? T(sl) : T(no),
                        alt: "",
                        "aria-hidden": "true"
                      }, null, 8, eO)) : w("", !0)
                    ], 10, YB)
                  ];
                }),
                _: 2
              }, 1032, ["text", "disabled"]),
              ae(ta, {
                id: `sidebar-submenu-${h(D)}`,
                name: "submenu",
                tag: "div",
                role: "region",
                "aria-label": `${D.label} submenu`,
                class: S([
                  "self-stretch flex flex-col items-start gap-2 submenu-wrapper",
                  { "submenu-open": k(h(D)) }
                ])
              }, {
                default: pe(() => [
                  (c(!0), p(Z, null, ke(k(h(D)) ? D.children : [], (re) => (c(), p("button", {
                    key: h(re),
                    type: "button",
                    class: S(le(re)),
                    "data-active": re.active ? "true" : "false",
                    "data-testid": re.testId,
                    "aria-current": re.active ? "page" : void 0,
                    "aria-disabled": re.disabled ? "true" : void 0,
                    disabled: re.disabled,
                    onClick: (se) => j(re)
                  }, [
                    g("div", nO, [
                      g("div", rO, $(re.label), 1)
                    ])
                  ], 10, tO))), 128))
                ]),
                _: 2
              }, 1032, ["id", "aria-label", "class"])
            ])) : (c(), te(Ye, {
              key: 2,
              text: D.label,
              position: "right",
              disabled: !o.value,
              class: "self-stretch flex-col"
            }, {
              default: pe(() => [
                g("button", {
                  type: "button",
                  class: S([C(D), { "justify-center": o.value }]),
                  "data-active": D.active ? "true" : "false",
                  "data-testid": D.testId,
                  "aria-label": o.value ? D.label : void 0,
                  "aria-current": D.active ? "page" : void 0,
                  "aria-disabled": D.disabled ? "true" : void 0,
                  disabled: D.disabled,
                  onClick: (re) => j(D)
                }, [
                  g("div", {
                    class: S(["flex-1 flex items-center gap-1.5 relative z-10 min-w-0", { "justify-center": o.value }])
                  }, [
                    D.icon ? (c(), p("img", {
                      key: 0,
                      class: "h-5 w-5 relative z-10 shrink-0",
                      src: D.icon,
                      alt: "",
                      "aria-hidden": "true"
                    }, null, 8, aO)) : (c(), p("div", lO)),
                    o.value ? w("", !0) : (c(), p("div", sO, $(D.label), 1))
                  ], 2)
                ], 10, oO)
              ]),
              _: 2
            }, 1032, ["text", "disabled"]))
          ], 64))), 128))
        ])
      ], 544),
      ae(ot, { name: "fade" }, {
        default: pe(() => [
          O.value ? (c(), p("div", iO, [
            M[2] || (M[2] = g("div", { class: "flex h-px justify-center items-center shrink-0 self-stretch sidebar-scroll-divider" }, null, -1)),
            g("button", {
              type: "button",
              class: "flex w-9 h-9 p-0 justify-center items-center shrink-0 rounded-full cursor-pointer bg-transparent border-none sidebar-scroll-btn",
              "aria-label": "Scroll down",
              onClick: J
            }, [
              g("img", {
                src: T(no),
                class: "h-4 w-4 sidebar-scroll-icon",
                alt: "",
                "aria-hidden": "true"
              }, null, 8, dO)
            ])
          ])) : w("", !0)
        ]),
        _: 1
      }),
      g("div", uO, [
        o.value ? w("", !0) : (c(), p("div", cO, [
          be(I.$slots, "footer", {}, () => [
            e.accessibilityText && e.accessibilityLink ? (c(), p("a", {
              key: 0,
              href: e.accessibilityLink,
              class: "block relative leading-5 font-medium mb-1 underline sidebar-footer-a11y-link"
            }, $(e.accessibilityText), 9, fO)) : e.accessibilityText ? (c(), p("div", hO, $(e.accessibilityText), 1)) : w("", !0),
            g("div", bO, $(e.footerText), 1)
          ], !0)
        ]))
      ])
    ], 14, TB)) : w("", !0);
  }
}), OV = /* @__PURE__ */ He(pO, [["__scopeId", "data-v-0fb03d0f"]]), gO = { class: "px-4 pt-5 pb-4" }, mO = { class: "text-lg font-semibold secondary-sidebar-title" }, vO = { class: "flex flex-col gap-8 px-4 pb-5" }, xO = { class: "text-xs font-medium uppercase tracking-wider secondary-sidebar-group-header" }, yO = ["data-active", "data-testid", "onClick"], kO = { class: "text-sm font-medium secondary-sidebar-item-text" }, wO = /* @__PURE__ */ ge({
  __name: "SecondarySidebar",
  props: {
    title: { default: "Settings" },
    groups: { default: () => [
      {
        label: "Profile management",
        items: [
          { label: "Profile" },
          { label: "Security information", active: !0 },
          { label: "Permissions" },
          { label: "Notification settings" }
        ]
      },
      {
        label: "Organisation management",
        items: [
          { label: "Global settings" },
          { label: "Users" },
          { label: "Security" },
          { label: "Configuration" },
          { label: "IA" },
          { label: "Billing & Plan" }
        ]
      },
      {
        label: "Module management",
        items: [{ label: "Global settings" }, { label: "Contact" }, { label: "Security" }]
      }
    ] },
    theme: { default: "light" },
    width: { default: "248px" },
    backgroundColor: { default: void 0 },
    textColor: { default: void 0 },
    borderColor: { default: void 0 },
    accentColor: { default: void 0 },
    hoverBackgroundColor: { default: void 0 },
    groupHeaderColor: { default: void 0 }
  },
  emits: ["item-click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(() => n.theme === "auto" ? typeof window < "u" ? window.matchMedia("(prefers-color-scheme: dark)").matches : !1 : n.theme === "dark"), a = y(() => o.value ? "secondary-sidebar-dark" : "secondary-sidebar-light"), l = y(() => {
      const d = {};
      return n.backgroundColor && (d["--secondary-sidebar-bg"] = n.backgroundColor), n.textColor && (d["--secondary-sidebar-text"] = n.textColor), n.borderColor && (d["--secondary-sidebar-border"] = n.borderColor), n.accentColor && (d["--secondary-sidebar-accent"] = n.accentColor), n.hoverBackgroundColor && (d["--secondary-sidebar-hover-bg"] = n.hoverBackgroundColor), n.groupHeaderColor && (d["--secondary-sidebar-group-header"] = n.groupHeaderColor), d.width = n.width || "248px", d;
    }), s = (d, u) => {
      d.onClick && d.onClick(), r("item-click", d, u);
    }, i = (d) => {
      const u = "w-full text-left py-2 cursor-pointer transition-all duration-200 secondary-sidebar-item";
      return d.active ? `${u} secondary-sidebar-item-active` : `${u} secondary-sidebar-item-hover`;
    };
    return (d, u) => (c(), p("aside", {
      class: S(["h-full flex flex-col box-border overflow-y-auto overflow-x-hidden secondary-sidebar-container", a.value]),
      style: Ae(l.value)
    }, [
      g("div", gO, [
        g("h2", mO, $(e.title), 1)
      ]),
      g("div", vO, [
        (c(!0), p(Z, null, ke(e.groups, (f, h) => (c(), p("div", {
          key: h,
          class: "flex flex-col gap-1"
        }, [
          g("div", xO, $(f.label), 1),
          (c(!0), p(Z, null, ke(f.items, (b, m) => (c(), p("button", {
            key: `${h}-${m}`,
            type: "button",
            class: S(i(b)),
            "data-active": b.active ? "true" : "false",
            "data-testid": b.testId,
            onClick: (v) => s(b, f)
          }, [
            g("span", kO, $(b.label), 1)
          ], 10, yO))), 128))
        ]))), 128))
      ])
    ], 6));
  }
}), PV = /* @__PURE__ */ He(wO, [["__scopeId", "data-v-6d2b14a8"]]), CO = { class: "flex items-center justify-between gap-5 self-stretch" }, SO = { class: "flex items-center gap-4" }, $O = { class: "shrink-0" }, IO = { class: "flex items-center" }, TO = { class: "flex items-center justify-end gap-2" }, LO = /* @__PURE__ */ ge({
  __name: "Navbar",
  props: {
    searchPlaceholder: { default: "Search by : company, contact, référence N°, event..." },
    searchIcon: { default: void 0 },
    filterIcon: { default: void 0 },
    actions: { default: () => [
      { icon: void 0, alt: "Action 1" },
      { icon: void 0, alt: "Action 2" },
      { icon: void 0, alt: "Action 3" },
      { icon: void 0, alt: "Action 4" }
    ] },
    avatar: { default: void 0 },
    searchWidth: { default: "487px" },
    searchSize: { default: "md" },
    searchValue: { default: "" },
    searchDisabled: { type: Boolean, default: !1 },
    avatarDropdownItems: { default: void 0 },
    avatarDropdownWidth: { default: "288px" },
    avatarDropdownAriaLabel: { default: void 0 },
    isScrolled: { type: Boolean, default: !1 }
  },
  emits: ["action-click", "update:searchValue", "search-click", "filter-click", "avatar-dropdown-item-click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(n.searchValue || "");
    we(
      () => n.searchValue,
      (l) => {
        o.value = l || "";
      }
    ), we(o, (l) => {
      r("update:searchValue", l);
    });
    const a = (l, s) => {
      l.onClick && l.onClick(), r("action-click", l, s);
    };
    return (l, s) => (c(), p("nav", {
      class: S(["border-border-base-soft text-text-secondary-disabled font-inter relative box-border flex w-full flex-col items-start justify-center border-b border-solid px-4 text-left text-sm transition-all duration-300", e.isScrolled ? "py-3" : "py-4"])
    }, [
      g("div", CO, [
        g("div", SO, [
          g("div", $O, [
            ae(Rr, {
              modelValue: o.value,
              "onUpdate:modelValue": s[0] || (s[0] = (i) => o.value = i),
              placeholder: e.searchPlaceholder,
              "icon-left": e.searchIcon,
              width: e.searchWidth,
              size: e.searchSize,
              disabled: e.searchDisabled,
              rounded: "full"
            }, null, 8, ["modelValue", "placeholder", "icon-left", "width", "size", "disabled"])
          ]),
          e.filterIcon ? (c(), te(T($e), {
            key: 0,
            variant: "primary",
            "icon-left": e.filterIcon,
            "icon-only": "",
            size: "md",
            "icon-alt": "Filter icon",
            class: "filter-button",
            onClick: s[1] || (s[1] = () => l.$emit("filter-click"))
          }, null, 8, ["icon-left"])) : w("", !0)
        ]),
        g("div", IO, [
          g("div", TO, [
            (c(!0), p(Z, null, ke(e.actions, (i, d) => (c(), p(Z, { key: d }, [
              i.icon ? (c(), te(T($e), {
                key: 0,
                variant: "secondary",
                "icon-left": i.icon,
                "icon-only": "",
                size: "md",
                "icon-alt": i.alt || "Action icon",
                onClick: (u) => a(i, d)
              }, null, 8, ["icon-left", "icon-alt", "onClick"])) : w("", !0)
            ], 64))), 128)),
            e.avatar && !e.avatarDropdownItems ? (c(), te(Cn, {
              key: 0,
              name: e.avatar.name,
              img: e.avatar.img
            }, null, 8, ["name", "img"])) : w("", !0),
            e.avatar && e.avatarDropdownItems ? (c(), te(kn, {
              key: 1,
              avatar: e.avatar,
              items: e.avatarDropdownItems,
              "menu-align": "right",
              "menu-width": e.avatarDropdownWidth,
              "aria-label": e.avatarDropdownAriaLabel
            }, null, 8, ["avatar", "items", "menu-width", "aria-label"])) : w("", !0)
          ])
        ])
      ])
    ], 2));
  }
}), zV = /* @__PURE__ */ He(LO, [["__scopeId", "data-v-a24c2a75"]]), MO = /* @__PURE__ */ ge({
  __name: "SpeedDial",
  props: {
    primaryIcon: {},
    primaryIconAlt: { default: "" },
    items: {},
    size: { default: "md" },
    orientation: { default: "vertical" },
    direction: { default: "top" },
    open: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "item-click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(n.open);
    we(
      () => n.open,
      (b) => {
        o.value = b;
      }
    );
    const a = (b) => {
      o.value = b, r("update:open", b);
    }, l = () => {
      a(!o.value);
    }, s = (b, m) => {
      b.onClick && b.onClick(m), r("item-click", b, m);
    }, i = y(() => {
      const b = "relative w-full flex p-2.5 box-border gap-2";
      return n.orientation === "horizontal" ? n.direction === "left" ? `${b} flex-row items-center` : `${b} flex-row-reverse items-center` : n.direction === "top" ? `${b} flex-col-reverse items-end` : `${b} flex-col items-end`;
    }), d = y(() => ({
      position: "relative"
    })), u = y(() => {
      const b = "flex items-center";
      return n.orientation === "horizontal" ? `${b} flex-row` : `${b} flex-col`;
    }), f = y(() => (n.orientation === "horizontal", "gap-2")), h = y(() => n.direction);
    return (b, m) => (c(), p("div", {
      class: S([i.value, "speed-dial-container"])
    }, [
      ae(ta, {
        name: `speed-dial-${h.value}`,
        tag: "div",
        class: S([[u.value, f.value], "relative"]),
        style: Ae(d.value)
      }, {
        default: pe(() => [
          (c(!0), p(Z, null, ke(o.value ? e.items : [], (v, x) => (c(), te(T($e), {
            key: `speed-dial-item-${x}`,
            variant: "secondary",
            "icon-left": v.icon,
            "icon-only": "",
            "icon-alt": v.iconAlt,
            size: e.size,
            style: Ae({
              "--index": x
            }),
            class: "relative",
            onClick: (k) => s(v, k)
          }, null, 8, ["icon-left", "icon-alt", "size", "style", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["name", "class", "style"]),
      ae(T($e), {
        variant: "primary",
        "icon-left": e.primaryIcon,
        "icon-only": "",
        "icon-alt": e.primaryIconAlt,
        size: e.size,
        class: "relative z-20 speed-dial-primary-button",
        onClick: l
      }, null, 8, ["icon-left", "icon-alt", "size"])
    ], 2));
  }
}), NV = /* @__PURE__ */ He(MO, [["__scopeId", "data-v-3affb618"]]), EO = {
  role: "list",
  class: "w-full h-[500px] relative shadow-[0px_1px_2px_rgba(29,_41,_61,_0.05)] dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)] rounded-xl bg-[#fff] dark:bg-[var(--colors-background-black-default)] border-border-base-soft dark:border-[var(--colors-border-base)] border-solid border-[1px] box-border overflow-hidden flex flex-col items-start p-6 gap-6 text-left text-[20px] text-text-black-default dark:text-[var(--colors-text-white-default)] font-inter"
}, AO = { class: "self-stretch flex-1 flex flex-col items-start overflow-y-auto overflow-x-hidden min-h-0" }, DO = { class: "self-stretch flex items-center justify-center gap-2.5" }, RO = { class: "flex-1 relative leading-num-24 dark:text-[var(--colors-text-white-default)]" }, BO = { class: "self-stretch flex-1 flex flex-col items-start text-num-16 text-text-body dark:text-[var(--colors-text-white-secondary)] overflow-y-auto overflow-x-hidden min-h-0" }, OO = ["onClick"], PO = { class: "flex items-center gap-2" }, zO = ["src", "alt"], NO = {
  key: 1,
  class: "h-8 w-8 relative rounded-num-100 flex items-center justify-center bg-background-gray dark:bg-[var(--colors-background-gray)]"
}, VO = ["src", "alt"], FO = { class: "flex flex-col items-start justify-center gap-px" }, HO = { class: "relative leading-num-24 font-medium dark:text-[var(--colors-text-white-default)] dark:group-hover:text-black" }, WO = { class: "relative text-num-14 leading-num-20 text-text-body-subtle dark:text-[var(--colors-text-white-secondary)] dark:group-hover:text-black" }, jO = {
  key: 0,
  class: "relative leading-num-24 font-medium text-text-black-default dark:text-[var(--colors-text-white-default)] dark:group-hover:text-black"
}, VV = /* @__PURE__ */ ge({
  __name: "List",
  props: {
    title: { default: "Latest customers" },
    viewAllLabel: { default: "View all" },
    items: { default: () => [] },
    height: { default: "530px" },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["view-all-click", "item-click"],
  setup(e, { emit: t }) {
    const n = t, r = () => {
      n("view-all-click");
    }, o = (a, l) => {
      n("item-click", a, l);
    };
    return (a, l) => (c(), p("div", EO, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        l[1] || (l[1] = g("div", { class: "self-stretch flex items-center justify-center gap-2.5" }, [
          g("div", { class: "skeleton h-6 flex-1" }),
          g("div", { class: "skeleton h-5 w-16" })
        ], -1)),
        g("div", AO, [
          (c(), p(Z, null, ke(5, (s) => g("div", {
            key: s,
            class: S(["self-stretch flex items-center justify-between pt-num-16 px-num-0 pb-num-16 gap-5 flex-shrink-0", {
              "border-border-base-soft dark:border-[var(--colors-border-base)] border-solid border-b-[1px]": s < 5,
              "rounded-md": s === 5
            }])
          }, [...l[0] || (l[0] = [
            mo('<div class="flex items-center gap-2"><div class="skeleton h-8 w-8 rounded-num-100"></div><div class="flex flex-col items-start justify-center gap-px"><div class="skeleton h-6 w-32"></div><div class="skeleton h-5 w-24"></div></div></div><div class="skeleton h-6 w-16"></div>', 2)
          ])], 2)), 64))
        ])
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("div", DO, [
          g("b", RO, $(e.title), 1),
          e.viewAllLabel ? (c(), te(T($e), {
            key: 0,
            variant: "tertiary",
            label: e.viewAllLabel,
            size: "sm",
            onClick: r
          }, null, 8, ["label"])) : w("", !0)
        ]),
        g("div", BO, [
          (c(!0), p(Z, null, ke(e.items, (s, i) => (c(), p("div", {
            key: s.id || i,
            "data-testid": "list-item",
            class: S(["group self-stretch flex items-center justify-between pt-num-16 px-2 pb-num-16 gap-5 cursor-pointer hover:bg-background-hover dark:hover:bg-[var(--colors-background-hover)] transition-colors duration-300 rounded-md -mx-2 flex-shrink-0", {
              "border-border-base-soft dark:border-[var(--colors-border-base)] border-solid border-b-[1px]": i < e.items.length - 1,
              "rounded-md": i === e.items.length - 1
            }]),
            onClick: (d) => o(s, i)
          }, [
            g("div", PO, [
              s.avatar ? (c(), p("img", {
                key: 0,
                src: s.avatar,
                alt: s.avatarAlt || s.name,
                class: "h-8 w-8 relative rounded-num-100 object-cover"
              }, null, 8, zO)) : s.avatarIcon ? (c(), p("div", NO, [
                g("img", {
                  src: s.avatarIcon,
                  alt: s.avatarAlt || s.name,
                  class: "w-5 h-5"
                }, null, 8, VO)
              ])) : w("", !0),
              g("div", FO, [
                g("div", HO, $(s.name), 1),
                g("div", WO, $(s.helperText), 1)
              ])
            ]),
            s.value ? (c(), p("div", jO, $(s.value), 1)) : w("", !0)
          ], 10, OO))), 128))
        ])
      ], 64))
    ]));
  }
}), UO = ["aria-level"], GO = {
  class: "text-xs leading-5 font-medium text-(--text-text-body-subtle)",
  "data-testid": "date-group-header-label"
}, FV = /* @__PURE__ */ ge({
  __name: "DateGroupHeader",
  props: {
    label: {},
    count: {},
    ariaLevel: { default: 3 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", {
      class: "flex w-fit items-center gap-2.5 rounded-md bg-(--background-background-white-tertiary) px-4 py-1",
      role: "heading",
      "aria-level": e.ariaLevel
    }, [
      g("span", GO, $(e.label), 1),
      ae(pt, {
        theme: "gradient-light",
        size: "sm",
        "badge-style": "circle",
        "text-only": "",
        value: e.count,
        "data-testid": "date-group-header-count"
      }, null, 8, ["value"])
    ], 8, UO));
  }
}), qO = ["aria-disabled"], KO = {
  class: "flex flex-1 min-w-0 flex-col gap-3 sm:flex-row sm:items-start",
  "data-testid": "list-item-interaction-row"
}, JO = { class: "flex flex-1 min-w-0 items-center gap-5" }, ZO = { class: "flex flex-1 min-w-0 flex-col gap-1" }, YO = { class: "flex items-center gap-1.5" }, XO = {
  key: 1,
  "data-testid": "list-item-interaction-meta"
}, QO = {
  key: 2,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, _O = {
  key: 0,
  class: "flex shrink-0 flex-col items-stretch gap-2 sm:flex-row sm:items-center",
  "data-testid": "list-item-trailing-actions"
}, HV = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "InteractionListItem",
  props: {
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    kind: { default: void 0 },
    typeLabel: { default: "" },
    date: { default: void 0 },
    time: { default: void 0 },
    dotTheme: { default: "green" },
    struckThrough: { type: Boolean, default: !1 },
    people: { default: void 0 },
    peopleLabel: { default: void 0 },
    attachmentLabel: { default: void 0 }
  },
  setup(e) {
    const t = {
      call: "ri-phone-fill",
      email: "ri-mail-line",
      "face-to-face": "ri-user-line",
      event: "ri-group-2-line",
      meeting: "ri-calendar-2-line"
    }, n = e, r = ht(), o = lu(() => ({
      padding: "p-4",
      gap: "gap-3",
      disabled: n.disabled,
      border: n.border,
      alwaysClasses: "group min-w-64"
    })), a = y(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
    ), l = y(
      () => n.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), s = y(() => [n.date, n.time].filter(Boolean).join(" · ")), i = y(() => n.kind ? t[n.kind] : void 0), d = y(
      () => n.disabled ? "ring-(--background-background-disabled)" : "ring-(--background-background-white) group-hover:ring-(--background-background-hover)"
    );
    return we(
      () => {
        var u;
        return [((u = n.people) == null ? void 0 : u.length) ?? 0, n.peopleLabel];
      },
      ([u, f]) => {
        u > 0 && !(f != null && f.trim()) && console.warn(
          "[InteractionListItem] `people` is set without `peopleLabel` — the avatar group has no accessible name for assistive tech (WCAG 1.1.1). Pass a pre-formatted `peopleLabel`."
        );
      },
      { immediate: !0 }
    ), (u, f) => {
      var h;
      return c(), p("div", Je(u.$attrs, {
        class: T(o),
        "aria-disabled": e.disabled || void 0
      }), [
        g("div", KO, [
          i.value ? (c(), te(vn, {
            key: 0,
            size: "md",
            shape: "square",
            variant: "outlined",
            color: e.disabled ? "disabled" : "white",
            content: i.value,
            "content-type": "icon",
            class: "shrink-0"
          }, null, 8, ["color", "content"])) : w("", !0),
          g("div", JO, [
            g("div", ZO, [
              g("div", YO, [
                ae(pt, {
                  type: "with-dot",
                  theme: e.dotTheme,
                  label: e.typeLabel,
                  size: "lg",
                  "data-testid": "list-item-interaction-type-label"
                }, null, 8, ["theme", "label"]),
                s.value ? (c(), p("span", {
                  key: 0,
                  class: S(["text-sm", a.value]),
                  "data-testid": "list-item-interaction-date-time"
                }, $(s.value), 3)) : w("", !0)
              ]),
              g("p", {
                class: S(["w-full min-w-0 wrap-break-word text-base font-bold leading-5", [l.value, e.struckThrough ? "line-through" : ""]]),
                "data-testid": "list-item-title"
              }, $(e.label), 3),
              e.subtitle ? (c(), p("p", {
                key: 0,
                class: S(["w-full min-w-0 wrap-break-word text-sm leading-5", a.value]),
                "data-testid": "list-item-subtitle"
              }, $(e.subtitle), 3)) : w("", !0),
              T(r)("interaction-meta") ? (c(), p("div", XO, [
                be(u.$slots, "interaction-meta")
              ])) : w("", !0),
              (h = e.people) != null && h.length ? (c(), p("div", QO, [
                ae(D3, {
                  avatars: e.people,
                  "ring-class": d.value,
                  size: "sm"
                }, null, 8, ["avatars", "ring-class"]),
                g("span", {
                  class: S(["text-xs font-medium", a.value]),
                  "data-testid": "list-item-person-name"
                }, $(e.peopleLabel), 3),
                e.attachmentLabel ? (c(), p(Z, { key: 0 }, [
                  g("span", {
                    class: S(["text-sm", a.value]),
                    "aria-hidden": "true"
                  }, "·", 2),
                  g("i", {
                    class: S(["ri-attachment-2 shrink-0 text-xs leading-none", a.value]),
                    "aria-hidden": "true"
                  }, null, 2),
                  g("span", {
                    class: S(["text-xs font-medium", a.value]),
                    "data-testid": "list-item-attachment-label"
                  }, $(e.attachmentLabel), 3)
                ], 64)) : w("", !0)
              ])) : w("", !0)
            ]),
            T(r)("cta") || T(r)("actions") ? (c(), p("div", _O, [
              be(u.$slots, "cta"),
              be(u.$slots, "actions")
            ])) : w("", !0)
          ])
        ])
      ], 16, qO);
    };
  }
}), e6 = ["aria-disabled"], t6 = {
  class: "flex flex-1 min-w-0 flex-col gap-2 py-3.5 pl-6 md:flex-row md:items-center md:gap-0 md:py-0 md:pl-0",
  "data-testid": "list-item-content-row"
}, n6 = { class: "flex items-center self-stretch shrink-0" }, r6 = {
  key: 0,
  class: "flex items-center self-stretch shrink-0 overflow-hidden md:px-5 w-[150px]",
  "data-testid": "list-item-meta-badge"
}, o6 = { class: "flex flex-1 min-w-0 flex-col gap-0.5 md:px-6 md:py-3.5" }, a6 = { class: "flex flex-col gap-2 md:flex-row md:items-center" }, l6 = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, s6 = {
  key: 1,
  class: "flex items-center justify-end gap-4 shrink-0",
  "data-testid": "list-item-trailing-actions"
}, i6 = { class: "flex flex-1 min-w-0 flex-col gap-3 py-4" }, d6 = { class: "flex flex-col gap-0.5 min-w-0" }, u6 = { class: "flex items-center justify-between gap-2" }, c6 = {
  key: 1,
  class: "flex items-center gap-1.5",
  "data-testid": "list-item-person"
}, f6 = {
  key: 1,
  class: "flex items-start gap-3",
  "data-testid": "list-item-cta"
}, WV = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "MeetingListItem",
  props: {
    layout: {},
    label: {},
    subtitle: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !0 },
    time: { default: void 0 },
    statusTheme: { default: "green" },
    statusLabel: { default: "" },
    struckThrough: { type: Boolean, default: !1 },
    metaBadge: { default: void 0 },
    personName: { default: void 0 },
    personAvatarUrl: { default: void 0 },
    date: { default: void 0 },
    urgencyLabel: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ht(), r = {
      long: { padding: "pl-0 pr-6 py-0", gap: "gap-6", minHeight: "min-h-[100px]" },
      short: { padding: "pl-0 pr-4 py-0", gap: "gap-4" }
    }, o = lu(() => {
      const d = r[t.layout];
      return {
        padding: d.padding,
        gap: d.gap,
        minHeight: d.minHeight,
        disabled: t.disabled,
        border: t.border,
        alwaysClasses: "overflow-hidden min-w-64",
        restingClasses: "shadow-(--blur-shadow-s)"
      };
    }), a = y(
      () => t.disabled ? "text-(--text-text-disabled-strong)" : "text-(--text-text-heading)"
    ), l = {
      green: "bg-(--components-badges-dot-success)",
      active: "bg-(--components-badges-background-badge-indigo-strong-bg)",
      red: "bg-(--components-badges-dot-error)",
      disabled: "bg-(--border-border-secondary-button)",
      orange: "bg-(--components-badges-dot-orange)"
    }, s = y(() => l[t.statusTheme]), i = y(() => [t.date, t.time].filter(Boolean).join(" · "));
    return (d, u) => (c(), p("div", Je(d.$attrs, {
      class: T(o),
      "aria-disabled": e.disabled || void 0
    }), [
      e.layout === "long" ? (c(), p(Z, { key: 0 }, [
        g("div", {
          class: S(["w-[5px] self-stretch shrink-0", s.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        g("div", t6, [
          g("div", n6, [
            g("p", {
              class: S(["whitespace-nowrap text-base font-bold leading-6", a.value]),
              "data-testid": "list-item-time"
            }, $(e.time), 3)
          ]),
          e.metaBadge ? (c(), p("div", r6, [
            ae(pt, {
              label: e.metaBadge.label,
              theme: e.metaBadge.theme ?? "cyan",
              size: "sm",
              "show-left-icon": !1,
              "show-close-icon": !1
            }, null, 8, ["label", "theme"])
          ])) : w("", !0),
          g("div", o6, [
            ae(pt, {
              type: "with-dot",
              theme: e.statusTheme,
              label: e.statusLabel,
              size: "sm",
              "data-testid": "list-item-status-badge"
            }, null, 8, ["theme", "label"]),
            g("p", {
              class: S(["w-full min-w-0 break-words text-base font-bold leading-6", [a.value, e.struckThrough ? "line-through" : ""]]),
              "data-testid": "list-item-title"
            }, $(e.label), 3),
            g("div", a6, [
              e.subtitle ? (c(), p("p", {
                key: 0,
                class: S(["md:shrink-0 md:whitespace-nowrap text-sm leading-5", a.value]),
                "data-testid": "list-item-subtitle"
              }, $(e.subtitle), 3)) : w("", !0),
              e.personName ? (c(), p("div", l6, [
                ae(Cn, {
                  name: e.personName,
                  img: e.personAvatarUrl,
                  size: "sm",
                  presentational: !0,
                  class: S({ "opacity-70": e.disabled })
                }, null, 8, ["name", "img", "class"]),
                g("span", {
                  class: S(["text-xs font-medium", a.value])
                }, $(e.personName), 3)
              ])) : w("", !0)
            ])
          ]),
          T(n)("cta") || T(n)("actions") ? (c(), p("div", s6, [
            be(d.$slots, "cta"),
            be(d.$slots, "actions")
          ])) : w("", !0)
        ])
      ], 64)) : (c(), p(Z, { key: 1 }, [
        g("div", {
          class: S(["w-[5px] self-stretch shrink-0", s.value]),
          "aria-hidden": "true",
          "data-testid": "list-item-accent-bar"
        }, null, 2),
        g("div", i6, [
          g("div", d6, [
            g("div", u6, [
              g("p", {
                class: S(["whitespace-nowrap text-sm font-semibold leading-5", a.value]),
                "data-testid": "list-item-date-time"
              }, $(i.value), 3),
              ae(pt, {
                type: "with-dot",
                theme: e.statusTheme,
                label: e.statusLabel,
                size: "sm",
                "data-testid": "list-item-status-badge"
              }, null, 8, ["theme", "label"])
            ]),
            g("p", {
              class: S(["w-full min-w-0 break-words text-base font-bold leading-6", [a.value, e.struckThrough ? "line-through" : ""]]),
              "data-testid": "list-item-title"
            }, $(e.label), 3),
            e.subtitle ? (c(), p("p", {
              key: 0,
              class: S(["w-full min-w-0 break-words text-sm leading-5", a.value]),
              "data-testid": "list-item-subtitle"
            }, $(e.subtitle), 3)) : w("", !0),
            e.personName ? (c(), p("div", c6, [
              ae(Cn, {
                name: e.personName,
                img: e.personAvatarUrl,
                size: "sm",
                presentational: !0,
                class: S({ "opacity-70": e.disabled })
              }, null, 8, ["name", "img", "class"]),
              g("span", {
                class: S(["text-xs font-medium", a.value])
              }, $(e.personName), 3)
            ])) : w("", !0)
          ]),
          e.urgencyLabel ? (c(), te(pt, {
            key: 0,
            theme: "red",
            size: "xs",
            label: e.urgencyLabel,
            "show-close-icon": !1,
            "data-testid": "list-item-urgency-badge"
          }, {
            "left-icon": pe(() => [...u[0] || (u[0] = [
              g("i", { class: "ri-alert-line text-[10px] leading-none" }, null, -1)
            ])]),
            _: 1
          }, 8, ["label"])) : w("", !0),
          T(n)("cta") ? (c(), p("div", f6, [
            be(d.$slots, "cta")
          ])) : w("", !0)
        ])
      ], 64))
    ], 16, e6));
  }
}), Ga = N([]);
function h6() {
  function e(n) {
    const r = crypto.randomUUID(), o = {
      id: r,
      dismissible: !0,
      ariaClose: "Close",
      ...n
    };
    return Ga.value.push(o), n.duration && setTimeout(() => t(r), n.duration), r;
  }
  function t(n) {
    Ga.value = Ga.value.filter((r) => r.id !== n);
  }
  return {
    toasts: Ga,
    showToast: e,
    removeToast: t
  };
}
const b6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z"/></svg>', Gp = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"/></svg>', p6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"/></svg>', g6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"/></svg>', m6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M8.68637 4.00008L11.293 1.39348C11.6835 1.00295 12.3167 1.00295 12.7072 1.39348L15.3138 4.00008H19.0001C19.5524 4.00008 20.0001 4.4478 20.0001 5.00008V8.68637L22.6067 11.293C22.9972 11.6835 22.9972 12.3167 22.6067 12.7072L20.0001 15.3138V19.0001C20.0001 19.5524 19.5524 20.0001 19.0001 20.0001H15.3138L12.7072 22.6067C12.3167 22.9972 11.6835 22.9972 11.293 22.6067L8.68637 20.0001H5.00008C4.4478 20.0001 4.00008 19.5524 4.00008 19.0001V15.3138L1.39348 12.7072C1.00295 12.3167 1.00295 11.6835 1.39348 11.293L4.00008 8.68637V5.00008C4.00008 4.4478 4.4478 4.00008 5.00008 4.00008H8.68637ZM6.00008 6.00008V9.5148L3.5148 12.0001L6.00008 14.4854V18.0001H9.5148L12.0001 20.4854L14.4854 18.0001H18.0001V14.4854L20.4854 12.0001L18.0001 9.5148V6.00008H14.4854L12.0001 3.5148L9.5148 6.00008H6.00008ZM12.0001 16.0001C9.79094 16.0001 8.00008 14.2092 8.00008 12.0001C8.00008 9.79094 9.79094 8.00008 12.0001 8.00008C14.2092 8.00008 16.0001 9.79094 16.0001 12.0001C16.0001 14.2092 14.2092 16.0001 12.0001 16.0001ZM12.0001 14.0001C13.1047 14.0001 14.0001 13.1047 14.0001 12.0001C14.0001 10.8955 13.1047 10.0001 12.0001 10.0001C10.8955 10.0001 10.0001 10.8955 10.0001 12.0001C10.0001 13.1047 10.8955 14.0001 12.0001 14.0001Z"/></svg>', v6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M21 3C21.5523 3 22 3.44772 22 4V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5V4C2 3.44772 2.44772 3 3 3H21ZM8 15V17H0V15H8ZM5 10V12H0V10H5ZM19.5659 5H4.43414L12 11.8093L19.5659 5Z"/></svg>', x6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"/></svg>', y6 = ["aria-live"], k6 = ["innerHTML"], w6 = {
  key: 0,
  class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold)"
}, C6 = {
  key: 1,
  class: "mt-3.5 grid grid-cols-2 gap-3"
}, S6 = ["aria-label"], $6 = { class: "sr-only" }, I6 = ["innerHTML"], T6 = {
  key: 1,
  class: "absolute bottom-0 left-0 h-1 w-full bg-(--background-background-black-default)"
}, L6 = /* @__PURE__ */ ge({
  __name: "ToastItem",
  props: {
    toast: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y(
      () => ["error", "warning"].includes(n.toast.status) ? "assertive" : "polite"
    ), a = {
      success: {
        border: "",
        iconWrapperClasses: "",
        iconSize: "h-5 w-5 text-(--icons-icon-success)",
        icon: g6
      },
      info: {
        border: "",
        iconWrapperClasses: "",
        // border-info resolves to the same indigo in both palettes — the per-theme
        // icons-icon-info light value lacks contrast on the always-dark card.
        iconSize: "h-5 w-5 text-(--border-border-info)",
        icon: p6
      },
      warning: {
        border: "",
        iconWrapperClasses: "",
        iconSize: "h-5 w-5 text-(--icons-icon-warning)",
        icon: b6
      },
      error: {
        border: "",
        iconWrapperClasses: "",
        // text-error-subtle resolves to the same red in both palettes — the per-theme
        // icons-icon-error light value lacks contrast on the always-dark card.
        iconSize: "h-5 w-5 text-(--text-text-error-subtle)",
        icon: Gp
      },
      notification: {
        border: "",
        iconWrapperClasses: "h-9 w-9 rounded-sm bg-(--background-background-success)",
        iconSize: "h-5 w-5 text-(--icons-icon-success)",
        icon: m6
      },
      mail: {
        border: "",
        iconWrapperClasses: "h-9 w-9 rounded-lg border border-(--border-border-base-soft) bg-(--background-background-white)",
        iconSize: "h-5 w-5 text-(--text-text-black-default)",
        icon: v6
      },
      interactive: {
        border: "",
        iconWrapperClasses: "h-9 w-9 rounded-lg border border-(--border-border-base-soft) bg-(--background-background-white)",
        iconSize: "h-5 w-5 text-(--text-text-black-default)",
        icon: x6
      }
    }, l = y(() => a[n.toast.status]), s = y(
      () => n.toast.title != null ? "items-start" : "items-center"
    ), i = y(() => n.toast.duration ?? 0), d = y(() => n.toast.showProgress === !0 && !!i.value);
    function u(f) {
      f == null || f(), r("close");
    }
    return (f, h) => (c(), p("div", {
      class: S(["relative flex w-full overflow-hidden rounded-lg border border-(--border-border-base-medium) bg-(--background-background-black-default) p-4 text-(--text-text-white-default) shadow-(--blur-shadow-m)", [l.value.border, s.value]]),
      role: "alert",
      "aria-live": o.value,
      "aria-atomic": "true"
    }, [
      g("div", {
        class: S(["inline-flex shrink-0 items-center justify-center", [l.value.iconWrapperClasses, n.toast.title != null ? "mt-1" : null]]),
        "aria-hidden": "true"
      }, [
        g("div", {
          class: S([l.value.iconSize]),
          innerHTML: l.value.icon
        }, null, 10, k6)
      ], 2),
      g("div", {
        class: S(["ms-3 flex-1 text-(length:--size-m) leading-(--line-height-m)", [s.value]])
      }, [
        e.toast.title ? (c(), p("div", w6, $(e.toast.title), 1)) : w("", !0),
        g("div", null, $(e.toast.message), 1),
        e.toast.primaryAction ? (c(), p("div", C6, [
          e.toast.secondaryAction ? (c(), te(T($e), {
            key: 0,
            variant: "secondary",
            label: e.toast.secondaryAction.label,
            "full-width": !0,
            size: "sm",
            onClick: h[0] || (h[0] = (b) => u(e.toast.secondaryAction.onClick))
          }, null, 8, ["label"])) : w("", !0),
          e.toast.primaryAction ? (c(), te(T($e), {
            key: 1,
            variant: "primary",
            label: e.toast.primaryAction.label,
            "icon-left": e.toast.primaryAction.icon || void 0,
            "full-width": !0,
            size: "sm",
            onClick: h[1] || (h[1] = (b) => u(e.toast.primaryAction.onClick))
          }, null, 8, ["label", "icon-left"])) : w("", !0)
        ])) : w("", !0)
      ], 2),
      e.toast.dismissible ? (c(), p("button", {
        key: 0,
        type: "button",
        class: "ms-auto flex h-8 w-8 items-center justify-center rounded hover:bg-(--components-button-primary-button-primary-hover)",
        "aria-label": n.toast.ariaClose,
        onClick: h[2] || (h[2] = (b) => r("close"))
      }, [
        g("span", $6, $(n.toast.ariaClose), 1),
        g("div", {
          class: "h-4 w-4 text-(--text-text-white-default)",
          innerHTML: T(sd)
        }, null, 8, I6)
      ], 8, S6)) : w("", !0),
      d.value ? (c(), p("div", T6, [
        g("div", {
          class: "h-full bg-(--border-border-info)",
          style: Ae({ animation: `toast-progress ${i.value}ms linear forwards` })
        }, null, 4)
      ])) : w("", !0)
    ], 10, y6));
  }
}), M6 = {
  class: "fixed right-4 z-[500] w-96",
  style: { top: "var(--toast-container-top, 1rem)" }
}, jV = /* @__PURE__ */ ge({
  __name: "ToastContainer",
  setup(e) {
    const { toasts: t, removeToast: n } = h6();
    return (r, o) => (c(), p("div", M6, [
      ae(ta, {
        name: "toast",
        tag: "div",
        class: "flex flex-col gap-3"
      }, {
        default: pe(() => [
          (c(!0), p(Z, null, ke(T(t), (a) => (c(), te(L6, {
            key: a.id,
            toast: a,
            onClose: (l) => T(n)(a.id)
          }, null, 8, ["toast", "onClose"]))), 128))
        ]),
        _: 1
      })
    ]));
  }
}), E6 = { key: 0 }, A6 = {
  key: 0,
  "data-testid": "form-error-summary-inline",
  class: "inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-[var(--colors-background-error)] border border-solid border-[var(--colors-border-error-subtle)] text-sm text-[var(--colors-text-heading)] font-medium"
}, D6 = ["innerHTML"], R6 = ["innerHTML"], B6 = {
  key: 0,
  "data-testid": "form-error-summary-menu",
  class: "absolute left-0 top-[calc(100%+4px)] z-50 min-w-56 rounded-xl border border-solid border-(--colors-border-error-subtle) bg-white-50-opacity-bold p-3 shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)"
}, O6 = {
  key: 0,
  "data-testid": "form-error-summary-list-heading",
  class: "mb-2 text-xs font-semibold text-[var(--colors-text-body)] dark:text-(--colors-text-white-secondary)"
}, P6 = { class: "flex flex-col gap-1" }, z6 = ["onClick"], N6 = ["innerHTML"], UV = /* @__PURE__ */ ge({
  __name: "FormErrorSummary",
  props: {
    errors: {},
    mode: { default: "inline" },
    heading: { default: void 0 },
    triggerLabel: { default: void 0 },
    listHeading: { default: void 0 }
  },
  emits: ["navigateToField"],
  setup(e, { emit: t }) {
    const n = t, { isOpen: r, dropdownRef: o, toggleDropdown: a, closeDropdown: l } = wa(), s = y(
      () => Gp.replace("<svg", '<svg width="16" height="16" style="display: block;"')
    ), i = y(
      () => sd.replace("<svg", '<svg width="12" height="12" style="display: block;"')
    ), d = (u) => {
      l(), n("navigateToField", u);
    };
    return (u, f) => e.errors.length > 0 ? (c(), p("div", E6, [
      e.mode === "inline" ? (c(), p("div", A6, [
        g("span", {
          class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-[#D92D20]",
          innerHTML: s.value
        }, null, 8, D6),
        g("span", null, $(e.heading), 1)
      ])) : (c(), p("div", {
        key: 1,
        ref_key: "dropdownRef",
        ref: o,
        class: "relative inline-block"
      }, [
        g("button", {
          type: "button",
          "data-testid": "form-error-summary-trigger",
          class: "inline-flex items-center gap-1.5 rounded-full border border-solid border-[var(--colors-border-error-subtle)] bg-[var(--colors-background-error)] px-3 py-1.5 text-sm font-medium text-[var(--colors-text-heading)] cursor-pointer transition-opacity hover:opacity-80",
          onClick: f[0] || (f[0] = //@ts-ignore
          (...h) => T(a) && T(a)(...h))
        }, [
          g("span", {
            class: "h-4 w-4 flex-shrink-0 inline-flex items-center justify-center text-[#D92D20]",
            innerHTML: s.value
          }, null, 8, R6),
          g("span", null, $(e.triggerLabel), 1),
          (c(), p("svg", {
            class: "h-4 w-4 transition-transform duration-200",
            style: Ae({ transform: T(r) ? "rotate(180deg)" : "rotate(0deg)" }),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [...f[1] || (f[1] = [
            g("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ])], 4))
        ]),
        ae(ot, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: pe(() => [
            T(r) ? (c(), p("div", B6, [
              e.listHeading ? (c(), p("p", O6, $(e.listHeading), 1)) : w("", !0),
              g("ul", P6, [
                (c(!0), p(Z, null, ke(e.errors, (h) => (c(), p("li", {
                  key: h.key
                }, [
                  g("button", {
                    type: "button",
                    "data-testid": "form-error-summary-item",
                    class: "inline-flex w-full items-center gap-1.5 rounded-lg px-2 py-1 text-sm text-[var(--colors-text-body)] cursor-pointer transition-colors hover:bg-[var(--colors-background-error)] dark:text-(--colors-text-white-secondary) dark:hover:bg-white/8",
                    onClick: (b) => d(h.key)
                  }, [
                    g("span", {
                      class: "h-3 w-3 flex-shrink-0 inline-flex items-center justify-center text-[#D92D20]",
                      innerHTML: i.value
                    }, null, 8, N6),
                    g("span", null, $(h.label), 1)
                  ], 8, z6)
                ]))), 128))
              ])
            ])) : w("", !0)
          ]),
          _: 1
        })
      ], 512))
    ])) : w("", !0);
  }
}), V6 = ["id"], GV = /* @__PURE__ */ ge({
  __name: "DynamicFormField",
  props: {
    field: {},
    modelValue: {},
    error: {}
  },
  emits: ["update:modelValue", "country-change", "blur"],
  setup(e) {
    return (t, n) => (c(), p("div", {
      id: `field-${e.field.key}`
    }, [
      e.field.type === "email" ? (c(), te(JI, {
        key: 0,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        hint: e.field.hint,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": n[0] || (n[0] = (r) => t.$emit("update:modelValue", r)),
        onBlur: n[1] || (n[1] = (r) => t.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "hint", "placeholder", "error"])) : e.field.type === "text" ? (c(), te(er, {
        key: 1,
        "model-value": e.modelValue,
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        size: e.field.size,
        "full-width": !0,
        placeholder: e.field.placeholder ?? "",
        error: e.error,
        "onUpdate:modelValue": n[2] || (n[2] = (r) => t.$emit("update:modelValue", r)),
        onBlur: n[3] || (n[3] = (r) => t.$emit("blur"))
      }, null, 8, ["model-value", "label", "required", "readonly", "size", "placeholder", "error"])) : e.field.type === "phone" ? (c(), te($4, {
        key: 2,
        "model-value": e.modelValue,
        label: e.field.label,
        readonly: e.field.readonly,
        "show-country-selector": e.field.showCountrySelector,
        countries: e.field.countries,
        "full-width": !0,
        size: e.field.size,
        error: e.error,
        "onUpdate:modelValue": n[4] || (n[4] = (r) => t.$emit("update:modelValue", r)),
        onBlur: n[5] || (n[5] = (r) => t.$emit("blur")),
        onCountryChange: n[6] || (n[6] = (r, o) => t.$emit("country-change", { dialCode: r.dialCode, nationalNumber: o }))
      }, null, 8, ["model-value", "label", "readonly", "show-country-selector", "countries", "size", "error"])) : e.field.type === "select" ? (c(), te(el, {
        key: 3,
        "model-value": e.modelValue,
        options: e.field.options || [],
        label: e.field.label,
        required: e.field.required,
        readonly: e.field.readonly,
        "full-width": !0,
        hint: e.field.hint,
        error: e.error,
        "onUpdate:modelValue": n[7] || (n[7] = (r) => t.$emit("update:modelValue", r)),
        onBlur: n[8] || (n[8] = (r) => t.$emit("blur"))
      }, null, 8, ["model-value", "options", "label", "required", "readonly", "hint", "error"])) : w("", !0)
    ], 8, V6));
  }
}), F6 = '<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7 19V13H17V19H19V7.82843L16.1716 5H5V19H7ZM4 3H17L21 7V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM9 15V19H15V15H9Z"/></svg>', H6 = { class: "inline-flex items-center gap-1.5" }, W6 = ["innerHTML"], qV = /* @__PURE__ */ ge({
  __name: "FormSaveButton",
  props: {
    enabled: { type: Boolean },
    saving: { type: Boolean },
    saveLabel: {},
    savingLabel: {}
  },
  emits: ["save"],
  setup(e) {
    const t = F6.replace(
      "<svg",
      '<svg width="16" height="16" style="display: block;"'
    );
    return (n, r) => (c(), te($e, {
      variant: "primary",
      "aria-disabled": !e.enabled,
      loading: e.saving,
      onClick: r[0] || (r[0] = (o) => n.$emit("save"))
    }, {
      default: pe(() => [
        g("span", H6, [
          e.saving ? w("", !0) : (c(), p("span", {
            key: 0,
            class: "h-4 w-4 shrink-0 inline-flex items-center justify-center",
            innerHTML: T(t)
          }, null, 8, W6)),
          Ze(" " + $(e.saving ? e.savingLabel : e.saveLabel), 1)
        ])
      ]),
      _: 1
    }, 8, ["aria-disabled", "loading"]));
  }
}), j6 = { class: "flex flex-col items-center gap-2" }, U6 = { class: "text-lg font-semibold text-(--colors-text-black-default)" }, G6 = { class: "text-center text-base font-normal leading-6 text-(--colors-text-black-default)" }, q6 = /* @__PURE__ */ ge({
  __name: "UnsavedChangesModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    stayLabel: {},
    leaveLabel: {},
    saveLabel: {},
    saveDisabled: { type: Boolean }
  },
  emits: ["update:modelValue", "stay", "leave", "discard", "save"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y({
      get: () => n.modelValue,
      set: (d) => r("update:modelValue", d)
    });
    function a() {
      r("update:modelValue", !1), r("stay");
    }
    function l() {
      r("update:modelValue", !1), r("leave");
    }
    function s() {
      r("update:modelValue", !1), r("discard");
    }
    function i() {
      n.saveDisabled || r("save");
    }
    return (d, u) => (c(), te(Ta, {
      modelValue: o.value,
      "onUpdate:modelValue": u[0] || (u[0] = (f) => o.value = f),
      size: "sm",
      dismissable: !1,
      "close-on-escape": !0,
      "header-position": "center",
      "footer-position": "right",
      "overlay-class": "!z-[400]",
      onClose: a
    }, {
      header: pe(() => [
        g("div", j6, [
          u[1] || (u[1] = g("div", {
            "data-testid": "unsaved-icon-shape",
            class: "flex items-center justify-center w-12 h-12 rounded-lg bg-(--colors-background-white) border border-(--border-border-base-soft)"
          }, [
            g("svg", {
              class: "h-7 w-7",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              "aria-hidden": "true"
            }, [
              g("path", {
                d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z",
                fill: "var(--colors-icon-info)"
              })
            ])
          ], -1)),
          g("h3", U6, $(e.title), 1)
        ])
      ]),
      footer: pe(() => [
        e.saveLabel ? (c(), p(Z, { key: 0 }, [
          ae($e, {
            variant: "secondary",
            class: "whitespace-nowrap",
            label: e.leaveLabel,
            "data-testid": "unsaved-discard",
            onClick: s
          }, null, 8, ["label"]),
          ae($e, {
            variant: "primary",
            class: "whitespace-nowrap",
            label: e.saveLabel,
            disabled: e.saveDisabled,
            "data-testid": "unsaved-save",
            onClick: i
          }, null, 8, ["label", "disabled"])
        ], 64)) : (c(), p(Z, { key: 1 }, [
          ae($e, {
            variant: "tertiary",
            class: "whitespace-nowrap",
            label: e.leaveLabel,
            "data-testid": "unsaved-leave",
            onClick: l
          }, null, 8, ["label"]),
          ae($e, {
            variant: "primary",
            class: "whitespace-nowrap",
            label: e.stayLabel,
            "data-testid": "unsaved-stay",
            onClick: a
          }, null, 8, ["label"])
        ], 64))
      ]),
      default: pe(() => [
        g("p", G6, $(e.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), K6 = {
  class: "flex flex-col items-center gap-2 text-center",
  "data-testid": "confirm-delete-modal-body"
}, J6 = { class: "flex items-center justify-center w-12 h-12 rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800" }, Z6 = { class: "text-xl font-bold text-gray-900 dark:text-white leading-6" }, Y6 = { class: "text-base text-gray-700 dark:text-gray-300 leading-6" }, KV = /* @__PURE__ */ ge({
  __name: "ConfirmDeleteModal",
  props: {
    modelValue: { type: Boolean },
    title: {},
    subtitle: {},
    confirmLabel: {},
    cancelLabel: {},
    icon: { default: "ri-delete-bin-6-line" },
    confirmDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = y({
      get: () => n.modelValue,
      set: (s) => r("update:modelValue", s)
    });
    function a() {
      n.confirmDisabled || (r("update:modelValue", !1), r("confirm"));
    }
    function l() {
      r("update:modelValue", !1), r("cancel");
    }
    return (s, i) => (c(), te(Ta, {
      modelValue: o.value,
      "onUpdate:modelValue": i[0] || (i[0] = (d) => o.value = d),
      size: "xs",
      dismissable: !1,
      "close-on-escape": !0,
      "show-header": !1,
      "footer-position": "center",
      onClose: l
    }, {
      footer: pe(() => [
        ae($e, {
          variant: "secondary",
          size: "md",
          label: e.cancelLabel,
          "data-testid": "confirm-delete-modal-cancel",
          onClick: l
        }, null, 8, ["label"]),
        ae($e, {
          variant: "error",
          size: "md",
          label: e.confirmLabel,
          disabled: e.confirmDisabled,
          "icon-left": "ri-delete-bin-6-line",
          "data-testid": "confirm-delete-modal-confirm",
          onClick: a
        }, null, 8, ["label", "disabled"])
      ]),
      default: pe(() => [
        g("div", K6, [
          g("div", J6, [
            g("i", {
              class: S([e.icon, "text-2xl text-gray-700 dark:text-gray-200"]),
              "aria-hidden": "true",
              "data-testid": "confirm-delete-modal-icon"
            }, null, 2)
          ]),
          g("h2", Z6, $(e.title), 1),
          g("p", Y6, $(e.subtitle), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), X6 = /* @__PURE__ */ ge({
  __name: "DataTableContainer",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    tableWidth: {}
  },
  setup(e) {
    const t = e;
    return (n, r) => (c(), p("table", {
      "data-slot": "table",
      class: S([
        "min-w-full table-fixed border-spacing-0 text-sm text-left text-text-black-default",
        t.class
      ]),
      style: Ae(e.tableWidth ? { width: e.tableWidth } : void 0)
    }, [
      be(n.$slots, "default")
    ], 6));
  }
}), Q6 = /* @__PURE__ */ ge({
  __name: "DataTableBody",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const t = e;
    return (n, r) => (c(), p("tbody", {
      "data-slot": "table-body",
      class: S(["", t.class])
    }, [
      be(n.$slots, "default")
    ], 2));
  }
}), JV = /* @__PURE__ */ ge({
  __name: "DataTableCaption",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const t = e;
    return (n, r) => (c(), p("caption", {
      "data-slot": "table-caption",
      class: S(["text-muted-foreground mt-4 text-sm", t.class])
    }, [
      be(n.$slots, "default")
    ], 2));
  }
}), Xi = /* @__PURE__ */ ge({
  __name: "DataTableCell",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    noTruncate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = N(null);
    function r() {
      var a;
      const o = n.value;
      o && (o.scrollWidth > o.clientWidth ? o.title = ((a = o.textContent) == null ? void 0 : a.trim()) ?? "" : o.title = "");
    }
    return (o, a) => (c(), p("td", {
      "data-slot": "table-cell",
      class: S([
        "leading-5 font-medium text-sm p-3 h-12 align-middle [&:has([type=checkbox])]:pr-0 [&:has([type=checkbox])]:max-w-none",
        e.noTruncate ? "overflow-visible" : "overflow-hidden max-w-0",
        t.class
      ])
    }, [
      e.noTruncate ? be(o.$slots, "default", { key: 1 }) : (c(), p("div", {
        key: 0,
        ref_key: "truncateRef",
        ref: n,
        class: "truncate",
        onMouseenter: r
      }, [
        be(o.$slots, "default")
      ], 544))
    ], 2));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function _6(e) {
  return Qa(e) ? ro(new Proxy({}, {
    get(t, n, r) {
      return T(Reflect.get(e.value, n, r));
    },
    set(t, n, r) {
      return Qa(e.value[n]) && !Qa(r) ? e.value[n].value = r : e.value[n] = r, !0;
    },
    deleteProperty(t, n) {
      return Reflect.deleteProperty(e.value, n);
    },
    has(t, n) {
      return Reflect.has(e.value, n);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  })) : ro(e);
}
function eP(e) {
  return _6(y(e));
}
function tP(e, ...t) {
  const n = t.flat(), r = n[0];
  return eP(() => Object.fromEntries(typeof r == "function" ? Object.entries(vu(e)).filter(([o, a]) => !r(yt(a), o)) : Object.entries(vu(e)).filter((o) => !n.includes(o[0]))));
}
const il = /* @__PURE__ */ ge({
  __name: "DataTableRow",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const t = e;
    return (n, r) => (c(), p("tr", {
      "data-slot": "table-row",
      class: S([
        "bg-white dark:bg-(--colors-background-black-default) border-b border-border-base-soft dark:border-(--colors-border-base) hover:bg-(--background-background-hover) dark:hover:bg-(--color-dark-bg-tertiary)",
        t.class
      ])
    }, [
      be(n.$slots, "default")
    ], 2));
  }
}), nP = { class: "flex items-center justify-center py-10" }, ZV = /* @__PURE__ */ ge({
  __name: "DataTableEmpty",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    colspan: { default: 1 }
  },
  setup(e) {
    const t = e, n = tP(t, "class");
    return (r, o) => (c(), te(il, null, {
      default: pe(() => [
        ae(Xi, Je({
          class: ["p-4 whitespace-nowrap align-middle text-sm text-foreground", t.class]
        }, T(n)), {
          default: pe(() => [
            g("div", nP, [
              be(r.$slots, "default")
            ])
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), YV = /* @__PURE__ */ ge({
  __name: "DataTableFooter",
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(e) {
    const t = e;
    return (n, r) => (c(), p("tfoot", {
      "data-slot": "table-footer",
      class: S(["", t.class])
    }, [
      be(n.$slots, "default")
    ], 2));
  }
}), rP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.5%207C9.32843%207%2010%206.32843%2010%205.5C10%204.67157%209.32843%204%208.5%204C7.67157%204%207%204.67157%207%205.5C7%206.32843%207.67157%207%208.5%207ZM8.5%2013.5C9.32843%2013.5%2010%2012.8284%2010%2012C10%2011.1716%209.32843%2010.5%208.5%2010.5C7.67157%2010.5%207%2011.1716%207%2012C7%2012.8284%207.67157%2013.5%208.5%2013.5ZM10%2018.5C10%2019.3284%209.32843%2020%208.5%2020C7.67157%2020%207%2019.3284%207%2018.5C7%2017.6716%207.67157%2017%208.5%2017C9.32843%2017%2010%2017.6716%2010%2018.5ZM15.5%207C16.3284%207%2017%206.32843%2017%205.5C17%204.67157%2016.3284%204%2015.5%204C14.6716%204%2014%204.67157%2014%205.5C14%206.32843%2014.6716%207%2015.5%207ZM17%2012C17%2012.8284%2016.3284%2013.5%2015.5%2013.5C14.6716%2013.5%2014%2012.8284%2014%2012C14%2011.1716%2014.6716%2010.5%2015.5%2010.5C16.3284%2010.5%2017%2011.1716%2017%2012ZM15.5%2020C16.3284%2020%2017%2019.3284%2017%2018.5C17%2017.6716%2016.3284%2017%2015.5%2017C14.6716%2017%2014%2017.6716%2014%2018.5C14%2019.3284%2014.6716%2020%2015.5%2020Z'/%3e%3c/svg%3e", oP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18%203V5H17V11L19%2014V16H13V23H11V16H5V14L7%2011V5H6V3H18Z'/%3e%3c/svg%3e", aP = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18%209%2012%203%206%209H18ZM18%2015%2012%2021%206%2015H18Z'/%3e%3c/svg%3e", lP = { class: "flex items-center gap-1 min-w-0" }, sP = ["src", "data-drag-handle", "draggable"], iP = {
  key: 1,
  class: "me-auto min-w-0"
}, dP = ["src"], uP = {
  key: 4,
  ref: "menuRef",
  class: "relative shrink-0"
}, cP = /* @__PURE__ */ ge({
  __name: "DataTableHead",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isDraggable: { type: Boolean, default: !1 },
    isPinned: { type: Boolean, default: !1 },
    isLastPinned: { type: Boolean, default: !1 },
    isLocked: { type: Boolean, default: !1 },
    isPinIconVisible: { type: Boolean, default: !0 },
    headerMenuItems: { default: void 0 },
    isCustomHeader: { type: Boolean, default: !1 },
    isResizingActive: { type: Boolean, default: !1 },
    isResizable: { type: Boolean, default: !0 },
    menuAriaLabel: { default: "Column menu" }
  },
  emits: ["resize-start", "resize-auto", "drag-handle-start"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    let o = 0;
    function a(d) {
      const u = Date.now();
      if (u - o < 300) {
        o = 0, r("resize-auto");
        return;
      }
      o = u, r("resize-start", d);
    }
    const l = y(() => {
      if (n.headerMenuItems)
        return n.headerMenuItems.map((d, u, f) => {
          const h = f[u + 1];
          return {
            label: d.label,
            icon: d.icon,
            onClick: d.onClick,
            disabled: d.disabled,
            hasDividerAfter: (h == null ? void 0 : h.dividerBefore) === !0
          };
        });
    }), s = N(null);
    function i() {
      var u;
      const d = s.value;
      d && (d.scrollWidth > d.clientWidth ? d.title = ((u = d.textContent) == null ? void 0 : u.trim()) ?? "" : d.title = "");
    }
    return (d, u) => (c(), p("th", {
      "data-slot": "table-head",
      scope: "col",
      class: S([
        "relative h-10 px-3 min-w-32.5 text-left align-middle font-semibold whitespace-nowrap text-(--text-text-heading) dark:text-(--colors-text-white-default) [&:has([type=checkbox])]:min-w-auto [&:has([type=checkbox])]:w-10 [&:has([type=checkbox])]:pr-0 [&_button]:border-0 [&>div>div>button]:p-0 [&_[data-testid=dropdown-trigger]>div]:p-0 [&_[data-testid=dropdown-trigger]>div>div]:truncate [&_[data-testid=dropdown-trigger]>div>div]:min-w-0 [&_[data-testid=dropdown-trigger]>div>div]:flex-1",
        e.isPinned ? "bg-white dark:bg-(--colors-background-black-default) z-20" : "z-0",
        n.class
      ])
    }, [
      g("div", lP, [
        e.isDraggable || e.isLocked ? (c(), p("img", {
          key: 0,
          class: S([
            "size-3.5 shrink-0 dark:invert",
            e.isLocked ? "opacity-40 cursor-not-allowed" : "cursor-grab"
          ]),
          src: T(rP),
          alt: "",
          "data-drag-handle": e.isLocked ? "false" : "true",
          draggable: e.isLocked ? "false" : "true",
          onDragstart: u[0] || (u[0] = Ie((f) => !e.isLocked && r("drag-handle-start", f), ["stop"]))
        }, null, 42, sP)) : w("", !0),
        e.isCustomHeader ? (c(), p("div", iP, [
          be(d.$slots, "default")
        ])) : (c(), p("div", {
          key: 2,
          ref_key: "headerTextRef",
          ref: s,
          class: "truncate me-auto min-w-0",
          onMouseenter: i
        }, [
          be(d.$slots, "default")
        ], 544)),
        e.isPinned && e.isPinIconVisible ? (c(), p("img", {
          key: 3,
          class: S(["size-3.5 shrink-0 ms-auto dark:invert", e.isLocked ? "opacity-40" : ""]),
          src: T(oP),
          alt: ""
        }, null, 10, dP)) : w("", !0),
        e.headerMenuItems ? (c(), p("div", uP, [
          ae(kn, {
            "trigger-icon": T(aP),
            label: "",
            "aria-label": e.menuAriaLabel,
            "menu-align": "right",
            class: "[&_button>div_div]:hidden [&_button]:border-0 [&_button>div]:px-0 [&_button]:min-w-6 [&_button]:min-h-6 [&_button]:justify-center [&_button>div]:justify-center [&_img]:dark:invert",
            items: l.value
          }, null, 8, ["trigger-icon", "aria-label", "items"])
        ], 512)) : w("", !0)
      ]),
      e.isResizable ? (c(), p("div", {
        key: 0,
        class: S(["absolute top-0 right-0 w-0.5 h-full cursor-col-resize z-10 bg-(--background-background-gray)/40 hover:bg-blue-400 hover:opacity-50 transition-colors", { "bg-blue-500 opacity-50": e.isResizingActive }]),
        onMousedown: u[1] || (u[1] = Ie((f) => a(f), ["stop", "prevent"])),
        onClick: u[2] || (u[2] = Ie(() => {
        }, ["stop", "prevent"]))
      }, null, 34)) : w("", !0)
    ], 2));
  }
}), fP = /* @__PURE__ */ ge({
  __name: "DataTableHeader",
  props: {
    class: { type: [Boolean, null, String, Object, Array] },
    isSticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, r) => (c(), p("thead", {
      "data-slot": "table-header",
      class: S([
        "shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] [&_tr:hover]:bg-transparent",
        t.isSticky && "sticky top-0 z-30 bg-white dark:bg-(--colors-background-black-default)",
        t.class
      ])
    }, [
      be(n.$slots, "default")
    ], 2));
  }
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function _n(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qt(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: _n(n, r[e])
    }));
  };
}
function Ss(e) {
  return e instanceof Function;
}
function hP(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function bP(e, t) {
  const n = [], r = (o) => {
    o.forEach((a) => {
      n.push(a);
      const l = t(a);
      l != null && l.length && r(l);
    });
  };
  return r(e), n;
}
function Ne(e, t, n) {
  let r = [], o;
  return (a) => {
    let l;
    n.key && n.debug && (l = Date.now());
    const s = e(a);
    if (!(s.length !== r.length || s.some((u, f) => r[f] !== u)))
      return o;
    r = s;
    let d;
    if (n.key && n.debug && (d = Date.now()), o = t(...s), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - l) * 100) / 100, f = Math.round((Date.now() - d) * 100) / 100, h = f / 16, b = (m, v) => {
        for (m = String(m); m.length < v; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${b(f, 5)} /${b(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * h, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function Ve(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function pP(e, t, n, r) {
  const o = () => {
    var l;
    return (l = a.getValue()) != null ? l : e.options.renderFallbackValue;
  }, a = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: Ne(() => [e, n, t, a], (l, s, i, d) => ({
      table: l,
      column: s,
      row: i,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), Ve(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((l) => {
    l.createCell == null || l.createCell(a, n, t, e);
  }, {}), a;
}
function gP(e, t, n, r) {
  var o, a;
  const s = {
    ...e._getDefaultColumnDef(),
    ...t
  }, i = s.accessorKey;
  let d = (o = (a = s.id) != null ? a : i ? typeof String.prototype.replaceAll == "function" ? i.replaceAll(".", "_") : i.replace(/\./g, "_") : void 0) != null ? o : typeof s.header == "string" ? s.header : void 0, u;
  if (s.accessorFn ? u = s.accessorFn : i && (i.includes(".") ? u = (h) => {
    let b = h;
    for (const v of i.split(".")) {
      var m;
      b = (m = b) == null ? void 0 : m[v], process.env.NODE_ENV !== "production" && b === void 0 && console.warn(`"${v}" in deeply nested key "${i}" returned undefined.`);
    }
    return b;
  } : u = (h) => h[s.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(d)}`,
    accessorFn: u,
    parent: r,
    depth: n,
    columnDef: s,
    columns: [],
    getFlatColumns: Ne(() => [!0], () => {
      var h;
      return [f, ...(h = f.columns) == null ? void 0 : h.flatMap((b) => b.getFlatColumns())];
    }, Ve(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Ne(() => [e._getOrderColumnsFn()], (h) => {
      var b;
      if ((b = f.columns) != null && b.length) {
        let m = f.columns.flatMap((v) => v.getLeafColumns());
        return h(m);
      }
      return [f];
    }, Ve(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const h of e._features)
    h.createColumn == null || h.createColumn(f, e);
  return f;
}
const It = "debugHeaders";
function gf(e, t, n) {
  var r;
  let a = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const l = [], s = (i) => {
        i.subHeaders && i.subHeaders.length && i.subHeaders.map(s), l.push(i);
      };
      return s(a), l;
    },
    getContext: () => ({
      table: e,
      header: a,
      column: t
    })
  };
  return e._features.forEach((l) => {
    l.createHeader == null || l.createHeader(a, e);
  }), a;
}
const mP = {
  createTable: (e) => {
    e.getHeaderGroups = Ne(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var a, l;
      const s = (a = r == null ? void 0 : r.map((f) => n.find((h) => h.id === f)).filter(Boolean)) != null ? a : [], i = (l = o == null ? void 0 : o.map((f) => n.find((h) => h.id === f)).filter(Boolean)) != null ? l : [], d = n.filter((f) => !(r != null && r.includes(f.id)) && !(o != null && o.includes(f.id)));
      return qa(t, [...s, ...d, ...i], e);
    }, Ve(e.options, It, "getHeaderGroups")), e.getCenterHeaderGroups = Ne(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((a) => !(r != null && r.includes(a.id)) && !(o != null && o.includes(a.id))), qa(t, n, e, "center")), Ve(e.options, It, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Ne(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((l) => n.find((s) => s.id === l)).filter(Boolean)) != null ? o : [];
      return qa(t, a, e, "left");
    }, Ve(e.options, It, "getLeftHeaderGroups")), e.getRightHeaderGroups = Ne(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((l) => n.find((s) => s.id === l)).filter(Boolean)) != null ? o : [];
      return qa(t, a, e, "right");
    }, Ve(e.options, It, "getRightHeaderGroups")), e.getFooterGroups = Ne(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Ve(e.options, It, "getFooterGroups")), e.getLeftFooterGroups = Ne(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Ve(e.options, It, "getLeftFooterGroups")), e.getCenterFooterGroups = Ne(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Ve(e.options, It, "getCenterFooterGroups")), e.getRightFooterGroups = Ne(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Ve(e.options, It, "getRightFooterGroups")), e.getFlatHeaders = Ne(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ve(e.options, It, "getFlatHeaders")), e.getLeftFlatHeaders = Ne(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ve(e.options, It, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Ne(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ve(e.options, It, "getCenterFlatHeaders")), e.getRightFlatHeaders = Ne(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ve(e.options, It, "getRightFlatHeaders")), e.getCenterLeafHeaders = Ne(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ve(e.options, It, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Ne(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ve(e.options, It, "getLeftLeafHeaders")), e.getRightLeafHeaders = Ne(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ve(e.options, It, "getRightLeafHeaders")), e.getLeafHeaders = Ne(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, a, l, s, i, d;
      return [...(o = (a = t[0]) == null ? void 0 : a.headers) != null ? o : [], ...(l = (s = n[0]) == null ? void 0 : s.headers) != null ? l : [], ...(i = (d = r[0]) == null ? void 0 : d.headers) != null ? i : []].map((u) => u.getLeafHeaders()).flat();
    }, Ve(e.options, It, "getLeafHeaders"));
  }
};
function qa(e, t, n, r) {
  var o, a;
  let l = 0;
  const s = function(h, b) {
    b === void 0 && (b = 1), l = Math.max(l, b), h.filter((m) => m.getIsVisible()).forEach((m) => {
      var v;
      (v = m.columns) != null && v.length && s(m.columns, b + 1);
    }, 0);
  };
  s(e);
  let i = [];
  const d = (h, b) => {
    const m = {
      depth: b,
      id: [r, `${b}`].filter(Boolean).join("_"),
      headers: []
    }, v = [];
    h.forEach((x) => {
      const k = [...v].reverse()[0], L = x.column.depth === m.depth;
      let P, E = !1;
      if (L && x.column.parent ? P = x.column.parent : (P = x.column, E = !0), k && (k == null ? void 0 : k.column) === P)
        k.subHeaders.push(x);
      else {
        const O = gf(n, P, {
          id: [r, b, P.id, x == null ? void 0 : x.id].filter(Boolean).join("_"),
          isPlaceholder: E,
          placeholderId: E ? `${v.filter((R) => R.column === P).length}` : void 0,
          depth: b,
          index: v.length
        });
        O.subHeaders.push(x), v.push(O);
      }
      m.headers.push(x), x.headerGroup = m;
    }), i.push(m), b > 0 && d(v, b - 1);
  }, u = t.map((h, b) => gf(n, h, {
    depth: l,
    index: b
  }));
  d(u, l - 1), i.reverse();
  const f = (h) => h.filter((m) => m.column.getIsVisible()).map((m) => {
    let v = 0, x = 0, k = [0];
    m.subHeaders && m.subHeaders.length ? (k = [], f(m.subHeaders).forEach((P) => {
      let {
        colSpan: E,
        rowSpan: O
      } = P;
      v += E, k.push(O);
    })) : v = 1;
    const L = Math.min(...k);
    return x = x + L, m.colSpan = v, m.rowSpan = x, {
      colSpan: v,
      rowSpan: x
    };
  });
  return f((o = (a = i[0]) == null ? void 0 : a.headers) != null ? o : []), i;
}
const vP = (e, t, n, r, o, a, l) => {
  let s = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: l,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (i) => {
      if (s._valuesCache.hasOwnProperty(i))
        return s._valuesCache[i];
      const d = e.getColumn(i);
      if (d != null && d.accessorFn)
        return s._valuesCache[i] = d.accessorFn(s.original, r), s._valuesCache[i];
    },
    getUniqueValues: (i) => {
      if (s._uniqueValuesCache.hasOwnProperty(i))
        return s._uniqueValuesCache[i];
      const d = e.getColumn(i);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (s._uniqueValuesCache[i] = d.columnDef.getUniqueValues(s.original, r), s._uniqueValuesCache[i]) : (s._uniqueValuesCache[i] = [s.getValue(i)], s._uniqueValuesCache[i]);
    },
    renderValue: (i) => {
      var d;
      return (d = s.getValue(i)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => bP(s.subRows, (i) => i.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let i = [], d = s;
      for (; ; ) {
        const u = d.getParentRow();
        if (!u) break;
        i.push(u), d = u;
      }
      return i.reverse();
    },
    getAllCells: Ne(() => [e.getAllLeafColumns()], (i) => i.map((d) => pP(e, s, d, d.id)), Ve(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Ne(() => [s.getAllCells()], (i) => i.reduce((d, u) => (d[u.column.id] = u, d), {}), Ve(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let i = 0; i < e._features.length; i++) {
    const d = e._features[i];
    d == null || d.createRow == null || d.createRow(s, e);
  }
  return s;
}, xP = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, qp = (e, t, n) => {
  var r, o;
  const a = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(a));
};
qp.autoRemove = (e) => dn(e);
const Kp = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
Kp.autoRemove = (e) => dn(e);
const Jp = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
Jp.autoRemove = (e) => dn(e);
const Zp = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
Zp.autoRemove = (e) => dn(e);
const Yp = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
Yp.autoRemove = (e) => dn(e) || !(e != null && e.length);
const Xp = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
Xp.autoRemove = (e) => dn(e) || !(e != null && e.length);
const Qp = (e, t, n) => e.getValue(t) === n;
Qp.autoRemove = (e) => dn(e);
const _p = (e, t, n) => e.getValue(t) == n;
_p.autoRemove = (e) => dn(e);
const su = (e, t, n) => {
  let [r, o] = n;
  const a = e.getValue(t);
  return a >= r && a <= o;
};
su.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, a = t === null || Number.isNaN(r) ? -1 / 0 : r, l = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (a > l) {
    const s = a;
    a = l, l = s;
  }
  return [a, l];
};
su.autoRemove = (e) => dn(e) || dn(e[0]) && dn(e[1]);
const Rn = {
  includesString: qp,
  includesStringSensitive: Kp,
  equalsString: Jp,
  arrIncludes: Zp,
  arrIncludesAll: Yp,
  arrIncludesSome: Xp,
  equals: Qp,
  weakEquals: _p,
  inNumberRange: su
};
function dn(e) {
  return e == null || e === "";
}
const yP = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: qt("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? Rn.includesString : typeof r == "number" ? Rn.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Rn.equals : Array.isArray(r) ? Rn.arrIncludes : Rn.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return Ss(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : Rn[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), a = r == null ? void 0 : r.find((u) => u.id === e.id), l = _n(n, a ? a.value : void 0);
        if (mf(o, l, e)) {
          var s;
          return (s = r == null ? void 0 : r.filter((u) => u.id !== e.id)) != null ? s : [];
        }
        const i = {
          id: e.id,
          value: l
        };
        if (a) {
          var d;
          return (d = r == null ? void 0 : r.map((u) => u.id === e.id ? i : u)) != null ? d : [];
        }
        return r != null && r.length ? [...r, i] : [i];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var a;
        return (a = _n(t, o)) == null ? void 0 : a.filter((l) => {
          const s = n.find((i) => i.id === l.id);
          if (s) {
            const i = s.getFilterFn();
            if (mf(i, l.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function mf(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const kP = (e, t, n) => n.reduce((r, o) => {
  const a = o.getValue(e);
  return r + (typeof a == "number" ? a : 0);
}, 0), wP = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r > a || r === void 0 && a >= a) && (r = a);
  }), r;
}, CP = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r < a || r === void 0 && a >= a) && (r = a);
  }), r;
}, SP = (e, t, n) => {
  let r, o;
  return n.forEach((a) => {
    const l = a.getValue(e);
    l != null && (r === void 0 ? l >= l && (r = o = l) : (r > l && (r = l), o < l && (o = l)));
  }), [r, o];
}, $P = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let a = o.getValue(e);
    a != null && (a = +a) >= a && (++n, r += a);
  }), n) return r / n;
}, IP = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((a) => a.getValue(e));
  if (!hP(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((a, l) => a - l);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, TP = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), LP = (e, t) => new Set(t.map((n) => n.getValue(e))).size, MP = (e, t) => t.length, ri = {
  sum: kP,
  min: wP,
  max: CP,
  extent: SP,
  mean: $P,
  median: IP,
  unique: TP,
  uniqueCount: LP,
  count: MP
}, EP = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: qt("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return ri.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return ri.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Ss(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : ri[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function AP(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((a) => !t.includes(a.id));
  return n === "remove" ? r : [...t.map((a) => e.find((l) => l.id === a)).filter(Boolean), ...r];
}
const DP = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: qt("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Ne((n) => [ea(t, n)], (n) => n.findIndex((r) => r.id === e.id), Ve(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = ea(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = ea(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Ne(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let a = [];
      if (!(t != null && t.length))
        a = o;
      else {
        const l = [...t], s = [...o];
        for (; s.length && l.length; ) {
          const i = l.shift(), d = s.findIndex((u) => u.id === i);
          d > -1 && a.push(s.splice(d, 1)[0]);
        }
        a = [...a, ...s];
      }
      return AP(a, n, r);
    }, Ve(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, oi = () => ({
  left: [],
  right: []
}), RP = {
  getInitialState: (e) => ({
    columnPinning: oi(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: qt("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var a, l;
        if (n === "right") {
          var s, i;
          return {
            left: ((s = o == null ? void 0 : o.left) != null ? s : []).filter((f) => !(r != null && r.includes(f))),
            right: [...((i = o == null ? void 0 : o.right) != null ? i : []).filter((f) => !(r != null && r.includes(f))), ...r]
          };
        }
        if (n === "left") {
          var d, u;
          return {
            left: [...((d = o == null ? void 0 : o.left) != null ? d : []).filter((f) => !(r != null && r.includes(f))), ...r],
            right: ((u = o == null ? void 0 : o.right) != null ? u : []).filter((f) => !(r != null && r.includes(f)))
          };
        }
        return {
          left: ((a = o == null ? void 0 : o.left) != null ? a : []).filter((f) => !(r != null && r.includes(f))),
          right: ((l = o == null ? void 0 : o.right) != null ? l : []).filter((f) => !(r != null && r.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, a, l;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((a = (l = t.options.enableColumnPinning) != null ? l : t.options.enablePinning) != null ? a : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((s) => s.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, a = n.some((s) => r == null ? void 0 : r.includes(s)), l = n.some((s) => o == null ? void 0 : o.includes(s));
      return a ? "left" : l ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Ne(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const a = [...r ?? [], ...o ?? []];
      return n.filter((l) => !a.includes(l.column.id));
    }, Ve(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Ne(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((a) => n.find((l) => l.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), Ve(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Ne(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((a) => n.find((l) => l.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), Ve(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? oi() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : oi());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, a;
        return !!((o = r.left) != null && o.length || (a = r.right) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Ne(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Ve(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Ne(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), Ve(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Ne(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((a) => !o.includes(a.id));
    }, Ve(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function BP(e) {
  return e || (typeof document < "u" ? document : null);
}
const Ka = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, ai = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), OP = {
  getDefaultColumnDef: () => Ka,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: ai(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: qt("columnSizing", e),
    onColumnSizingInfoChange: qt("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const a = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : Ka.minSize, (r = a ?? e.columnDef.size) != null ? r : Ka.size), (o = e.columnDef.maxSize) != null ? o : Ka.maxSize);
    }, e.getStart = Ne((n) => [n, ea(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, a) => o + a.getSize(), 0), Ve(t.options, "debugColumns", "getStart")), e.getAfter = Ne((n) => [n, ea(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, a) => o + a.getSize(), 0), Ve(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var a;
          n += (a = o.column.getSize()) != null ? a : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (a) => {
        if (!r || !o || (a.persist == null || a.persist(), li(a) && a.touches && a.touches.length > 1))
          return;
        const l = e.getSize(), s = e ? e.getLeafHeaders().map((k) => [k.column.id, k.column.getSize()]) : [[r.id, r.getSize()]], i = li(a) ? Math.round(a.touches[0].clientX) : a.clientX, d = {}, u = (k, L) => {
          typeof L == "number" && (t.setColumnSizingInfo((P) => {
            var E, O;
            const R = t.options.columnResizeDirection === "rtl" ? -1 : 1, V = (L - ((E = P == null ? void 0 : P.startOffset) != null ? E : 0)) * R, J = Math.max(V / ((O = P == null ? void 0 : P.startSize) != null ? O : 0), -0.999999);
            return P.columnSizingStart.forEach((F) => {
              let [A, j] = F;
              d[A] = Math.round(Math.max(j + j * J, 0) * 100) / 100;
            }), {
              ...P,
              deltaOffset: V,
              deltaPercentage: J
            };
          }), (t.options.columnResizeMode === "onChange" || k === "end") && t.setColumnSizing((P) => ({
            ...P,
            ...d
          })));
        }, f = (k) => u("move", k), h = (k) => {
          u("end", k), t.setColumnSizingInfo((L) => ({
            ...L,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, b = BP(n), m = {
          moveHandler: (k) => f(k.clientX),
          upHandler: (k) => {
            b == null || b.removeEventListener("mousemove", m.moveHandler), b == null || b.removeEventListener("mouseup", m.upHandler), h(k.clientX);
          }
        }, v = {
          moveHandler: (k) => (k.cancelable && (k.preventDefault(), k.stopPropagation()), f(k.touches[0].clientX), !1),
          upHandler: (k) => {
            var L;
            b == null || b.removeEventListener("touchmove", v.moveHandler), b == null || b.removeEventListener("touchend", v.upHandler), k.cancelable && (k.preventDefault(), k.stopPropagation()), h((L = k.touches[0]) == null ? void 0 : L.clientX);
          }
        }, x = PP() ? {
          passive: !1
        } : !1;
        li(a) ? (b == null || b.addEventListener("touchmove", v.moveHandler, x), b == null || b.addEventListener("touchend", v.upHandler, x)) : (b == null || b.addEventListener("mousemove", m.moveHandler, x), b == null || b.addEventListener("mouseup", m.upHandler, x)), t.setColumnSizingInfo((k) => ({
          ...k,
          startOffset: i,
          startSize: l,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? ai() : (n = e.initialState.columnSizingInfo) != null ? n : ai());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let Ja = null;
function PP() {
  if (typeof Ja == "boolean") return Ja;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return Ja = e, Ja;
}
function li(e) {
  return e.type === "touchstart";
}
const zP = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: qt("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((a) => a.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Ne(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Ve(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Ne(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], Ve(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Ne(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), Ve(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, a) => ({
        ...o,
        [a.id]: n || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function ea(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const NP = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, VP = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: qt("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, a;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((a = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? a : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Rn.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return Ss(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : Rn[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, FP = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: qt("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, a;
      e.setExpanded(r ? {} : (o = (a = e.initialState) == null ? void 0 : a.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((a) => {
        const l = a.split(".");
        r = Math.max(r, l.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const a = r === !0 ? !0 : !!(r != null && r[e.id]);
        let l = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((s) => {
          l[s] = !0;
        }) : l = r, n = (o = n) != null ? o : !a, !a && n)
          return {
            ...l,
            [e.id]: !0
          };
        if (a && !n) {
          const {
            [e.id]: s,
            ...i
          } = l;
          return i;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, Qi = 0, _i = 10, si = () => ({
  pageIndex: Qi,
  pageSize: _i
}), HP = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...si(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: qt("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (a) => _n(r, a);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? si() : (o = e.initialState.pagination) != null ? o : si());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let a = _n(r, o.pageIndex);
        const l = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, l)), {
          ...o,
          pageIndex: a
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, a;
      e.setPageIndex(r ? Qi : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? o : Qi);
    }, e.resetPageSize = (r) => {
      var o, a;
      e.setPageSize(r ? _i : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? o : _i);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const a = Math.max(1, _n(r, o.pageSize)), l = o.pageSize * o.pageIndex, s = Math.floor(l / a);
        return {
          ...o,
          pageIndex: s,
          pageSize: a
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var a;
      let l = _n(r, (a = e.options.pageCount) != null ? a : -1);
      return typeof l == "number" && (l = Math.max(-1, l)), {
        ...o,
        pageCount: l
      };
    }), e.getPageOptions = Ne(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((a, l) => l)), o;
    }, Ve(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, ii = () => ({
  top: [],
  bottom: []
}), WP = {
  getInitialState: (e) => ({
    rowPinning: ii(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: qt("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const a = r ? e.getLeafRows().map((i) => {
        let {
          id: d
        } = i;
        return d;
      }) : [], l = o ? e.getParentRows().map((i) => {
        let {
          id: d
        } = i;
        return d;
      }) : [], s = /* @__PURE__ */ new Set([...l, e.id, ...a]);
      t.setRowPinning((i) => {
        var d, u;
        if (n === "bottom") {
          var f, h;
          return {
            top: ((f = i == null ? void 0 : i.top) != null ? f : []).filter((v) => !(s != null && s.has(v))),
            bottom: [...((h = i == null ? void 0 : i.bottom) != null ? h : []).filter((v) => !(s != null && s.has(v))), ...Array.from(s)]
          };
        }
        if (n === "top") {
          var b, m;
          return {
            top: [...((b = i == null ? void 0 : i.top) != null ? b : []).filter((v) => !(s != null && s.has(v))), ...Array.from(s)],
            bottom: ((m = i == null ? void 0 : i.bottom) != null ? m : []).filter((v) => !(s != null && s.has(v)))
          };
        }
        return {
          top: ((d = i == null ? void 0 : i.top) != null ? d : []).filter((v) => !(s != null && s.has(v))),
          bottom: ((u = i == null ? void 0 : i.bottom) != null ? u : []).filter((v) => !(s != null && s.has(v)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, a = n.some((s) => r == null ? void 0 : r.includes(s)), l = n.some((s) => o == null ? void 0 : o.includes(s));
      return a ? "top" : l ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o) return -1;
      const a = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((l) => {
        let {
          id: s
        } = l;
        return s;
      });
      return (r = a == null ? void 0 : a.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? ii() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : ii());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, a;
        return !!((o = r.top) != null && o.length || (a = r.bottom) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((l) => {
          const s = e.getRow(l, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((l) => t.find((s) => s.id === l))
      )).filter(Boolean).map((l) => ({
        ...l,
        position: r
      }));
    }, e.getTopRows = Ne(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Ve(e.options, "debugRows", "getTopRows")), e.getBottomRows = Ne(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Ve(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Ne(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((a) => !o.has(a.id));
    }, Ve(e.options, "debugRows", "getCenterRows"));
  }
}, jP = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: qt("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((a) => {
          a.getCanSelect() && (r[a.id] = !0);
        }) : o.forEach((a) => {
          delete r[a.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((a) => {
        ed(o, a.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Ne(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? di(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ve(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Ne(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? di(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ve(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Ne(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? di(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ve(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((a) => {
        var l;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return a;
        const s = {
          ...a
        };
        return ed(s, e.id, n, (l = r == null ? void 0 : r.selectChildren) != null ? l : !0, t), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return iu(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return td(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return td(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, ed = (e, t, n, r, o) => {
  var a;
  const l = o.getRow(t, !0);
  n ? (l.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), l.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = l.subRows) != null && a.length && l.getCanSelectSubRows() && l.subRows.forEach((s) => ed(e, s.id, n, r, o));
};
function di(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, a = function(l, s) {
    return l.map((i) => {
      var d;
      const u = iu(i, n);
      if (u && (r.push(i), o[i.id] = i), (d = i.subRows) != null && d.length && (i = {
        ...i,
        subRows: a(i.subRows)
      }), u)
        return i;
    }).filter(Boolean);
  };
  return {
    rows: a(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function iu(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function td(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let o = !0, a = !1;
  return e.subRows.forEach((l) => {
    if (!(a && !o) && (l.getCanSelect() && (iu(l, t) ? a = !0 : o = !1), l.subRows && l.subRows.length)) {
      const s = td(l, t);
      s === "all" ? a = !0 : (s === "some" && (a = !0), o = !1);
    }
  }), o ? "all" : a ? "some" : !1;
}
const nd = /([0-9]+)/gm, UP = (e, t, n) => eg(dr(e.getValue(n)).toLowerCase(), dr(t.getValue(n)).toLowerCase()), GP = (e, t, n) => eg(dr(e.getValue(n)), dr(t.getValue(n))), qP = (e, t, n) => du(dr(e.getValue(n)).toLowerCase(), dr(t.getValue(n)).toLowerCase()), KP = (e, t, n) => du(dr(e.getValue(n)), dr(t.getValue(n))), JP = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, ZP = (e, t, n) => du(e.getValue(n), t.getValue(n));
function du(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function dr(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function eg(e, t) {
  const n = e.split(nd).filter(Boolean), r = t.split(nd).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), a = r.shift(), l = parseInt(o, 10), s = parseInt(a, 10), i = [l, s].sort();
    if (isNaN(i[0])) {
      if (o > a)
        return 1;
      if (a > o)
        return -1;
      continue;
    }
    if (isNaN(i[1]))
      return isNaN(l) ? -1 : 1;
    if (l > s)
      return 1;
    if (s > l)
      return -1;
  }
  return n.length - r.length;
}
const Ao = {
  alphanumeric: UP,
  alphanumericCaseSensitive: GP,
  text: qP,
  textCaseSensitive: KP,
  datetime: JP,
  basic: ZP
}, YP = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: qt("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const a = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return Ao.datetime;
        if (typeof a == "string" && (r = !0, a.split(nd).length > 1))
          return Ao.alphanumeric;
      }
      return r ? Ao.text : Ao.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return Ss(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : Ao[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), a = typeof n < "u" && n !== null;
      t.setSorting((l) => {
        const s = l == null ? void 0 : l.find((b) => b.id === e.id), i = l == null ? void 0 : l.findIndex((b) => b.id === e.id);
        let d = [], u, f = a ? n : o === "desc";
        if (l != null && l.length && e.getCanMultiSort() && r ? s ? u = "toggle" : u = "add" : l != null && l.length && i !== l.length - 1 ? u = "replace" : s ? u = "toggle" : u = "replace", u === "toggle" && (a || o || (u = "remove")), u === "add") {
          var h;
          d = [...l, {
            id: e.id,
            desc: f
          }], d.splice(0, d.length - ((h = t.options.maxMultiSortColCount) != null ? h : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? d = l.map((b) => b.id === e.id ? {
          ...b,
          desc: f
        } : b) : u === "remove" ? d = l.filter((b) => b.id !== e.id) : d = [{
          id: e.id,
          desc: f
        }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const a = e.getFirstSortDir(), l = e.getIsSorted();
      return l ? l !== a && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : l === "desc" ? "asc" : "desc" : a;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, XP = [
  mP,
  zP,
  DP,
  RP,
  xP,
  yP,
  NP,
  //depends on ColumnFaceting
  VP,
  //depends on ColumnFiltering
  YP,
  EP,
  //depends on RowSorting
  FP,
  HP,
  WP,
  jP,
  OP
];
function QP(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...XP, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const a = o._features.reduce((h, b) => Object.assign(h, b.getDefaultOptions == null ? void 0 : b.getDefaultOptions(o)), {}), l = (h) => o.options.mergeOptions ? o.options.mergeOptions(a, h) : {
    ...a,
    ...h
  };
  let i = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((h) => {
    var b;
    i = (b = h.getInitialState == null ? void 0 : h.getInitialState(i)) != null ? b : i;
  });
  const d = [];
  let u = !1;
  const f = {
    _features: r,
    options: {
      ...a,
      ...e
    },
    initialState: i,
    _queue: (h) => {
      d.push(h), u || (u = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        u = !1;
      }).catch((b) => setTimeout(() => {
        throw b;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (h) => {
      const b = _n(h, o.options);
      o.options = l(b);
    },
    getState: () => o.options.state,
    setState: (h) => {
      o.options.onStateChange == null || o.options.onStateChange(h);
    },
    _getRowId: (h, b, m) => {
      var v;
      return (v = o.options.getRowId == null ? void 0 : o.options.getRowId(h, b, m)) != null ? v : `${m ? [m.id, b].join(".") : b}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (h, b) => {
      let m = (b ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[h];
      if (!m && (m = o.getCoreRowModel().rowsById[h], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${h}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: Ne(() => [o.options.defaultColumn], (h) => {
      var b;
      return h = (b = h) != null ? b : {}, {
        header: (m) => {
          const v = m.header.column.columnDef;
          return v.accessorKey ? v.accessorKey : v.accessorFn ? v.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var v, x;
          return (v = (x = m.renderValue()) == null || x.toString == null ? void 0 : x.toString()) != null ? v : null;
        },
        ...o._features.reduce((m, v) => Object.assign(m, v.getDefaultColumnDef == null ? void 0 : v.getDefaultColumnDef()), {}),
        ...h
      };
    }, Ve(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: Ne(() => [o._getColumnDefs()], (h) => {
      const b = function(m, v, x) {
        return x === void 0 && (x = 0), m.map((k) => {
          const L = gP(o, k, x, v), P = k;
          return L.columns = P.columns ? b(P.columns, L, x + 1) : [], L;
        });
      };
      return b(h);
    }, Ve(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Ne(() => [o.getAllColumns()], (h) => h.flatMap((b) => b.getFlatColumns()), Ve(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Ne(() => [o.getAllFlatColumns()], (h) => h.reduce((b, m) => (b[m.id] = m, b), {}), Ve(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Ne(() => [o.getAllColumns(), o._getOrderColumnsFn()], (h, b) => {
      let m = h.flatMap((v) => v.getLeafColumns());
      return b(m);
    }, Ve(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (h) => {
      const b = o._getAllFlatColumnsById()[h];
      return process.env.NODE_ENV !== "production" && !b && console.error(`[Table] Column with id '${h}' does not exist.`), b;
    }
  };
  Object.assign(o, f);
  for (let h = 0; h < o._features.length; h++) {
    const b = o._features[h];
    b == null || b.createTable == null || b.createTable(o);
  }
  return o;
}
function _P() {
  return (e) => Ne(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, a, l) {
      a === void 0 && (a = 0);
      const s = [];
      for (let d = 0; d < o.length; d++) {
        const u = vP(e, e._getRowId(o[d], d, l), o[d], d, a, void 0, l == null ? void 0 : l.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, s.push(u), e.options.getSubRows) {
          var i;
          u.originalSubRows = e.options.getSubRows(o[d], d), (i = u.originalSubRows) != null && i.length && (u.subRows = r(u.originalSubRows, a + 1, u));
        }
      }
      return s;
    };
    return n.rows = r(t), n;
  }, Ve(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Za() {
  return !0;
}
const e8 = Symbol("merge-proxy"), t8 = {
  get(e, t, n) {
    return t === e8 ? n : e.get(t);
  },
  has(e, t) {
    return e.has(t);
  },
  set: Za,
  deleteProperty: Za,
  getOwnPropertyDescriptor(e, t) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(t);
      },
      set: Za,
      deleteProperty: Za
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function ui(e) {
  return "value" in e ? e.value : e;
}
function No() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return new Proxy({
    get(r) {
      for (let o = t.length - 1; o >= 0; o--) {
        const a = ui(t[o])[r];
        if (a !== void 0) return a;
      }
    },
    has(r) {
      for (let o = t.length - 1; o >= 0; o--)
        if (r in ui(t[o])) return !0;
      return !1;
    },
    keys() {
      const r = [];
      for (let o = 0; o < t.length; o++) r.push(...Object.keys(ui(t[o])));
      return [...Array.from(new Set(r))];
    }
  }, t8);
}
const vf = ge({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? xa(e.render, e.props) : e.render
});
function xf(e) {
  return No(e, {
    data: T(e.data)
  });
}
function n8(e) {
  const t = Qa(e.data), n = No({
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    mergeOptions(a, l) {
      return t ? {
        ...a,
        ...l
      } : No(a, l);
    }
  }, t ? xf(e) : e), r = QP(n);
  if (t) {
    const a = ld(e.data);
    we(a, () => {
      r.setState((l) => ({
        ...l,
        data: a.value
      }));
    }, {
      immediate: !0
    });
  }
  const o = N(r.initialState);
  return Ef(() => {
    r.setOptions((a) => {
      var l;
      const s = new Proxy({}, {
        get: (i, d) => o.value[d]
      });
      return No(a, t ? xf(e) : e, {
        // merge the initialState and `options.state`
        // create a new proxy on each `setOptions` call
        // and get the value from state on each property access
        state: No(s, (l = e.state) != null ? l : {}),
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: (i) => {
          i instanceof Function ? o.value = i(o.value) : o.value = i, e.onStateChange == null || e.onStateChange(i);
        }
      });
    });
  }), r;
}
const r8 = "data:image/svg+xml,%3csvg%20viewBox='0%200%2024%2024'%20fill='currentColor'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.21232%2014.0601C1.91928%2012.6755%201.93115%2011.2743%202.21316%209.94038C3.32308%2010.0711%204.29187%209.7035%204.60865%208.93871C4.92544%208.17392%204.50032%207.22896%203.62307%206.53655C4.3669%205.3939%205.34931%204.39471%206.53554%203.62289C7.228%204.50059%208.17324%204.92601%208.93822%204.60914C9.7032%204.29227%2010.0708%203.32308%209.93979%202.21281C11.3243%201.91977%2012.7255%201.93164%2014.0595%202.21364C13.9288%203.32356%2014.2964%204.29235%2015.0612%204.60914C15.8259%204.92593%2016.7709%204.5008%2017.4633%203.62356C18.606%204.36739%2019.6052%205.3498%2020.377%206.53602C19.4993%207.22849%2019.0739%208.17373%2019.3907%208.93871C19.7076%209.70369%2020.6768%2010.0713%2021.7871%209.94028C22.0801%2011.3248%2022.0682%2012.726%2021.7862%2014.06C20.6763%2013.9293%2019.7075%2014.2969%2019.3907%2015.0616C19.0739%2015.8264%2019.4991%2016.7714%2020.3763%2017.4638C19.6325%2018.6064%2018.6501%2019.6056%2017.4638%2020.3775C16.7714%2019.4998%2015.8261%2019.0743%2015.0612%2019.3912C14.2962%2019.7081%2013.9286%2020.6773%2014.0596%2021.7875C12.675%2022.0806%2011.2738%2022.0687%209.93989%2021.7867C10.0706%2020.6768%209.70301%2019.708%208.93822%2019.3912C8.17343%2019.0744%207.22848%2019.4995%206.53606%2020.3768C5.39341%2019.633%204.39422%2018.6506%203.62241%2017.4643C4.5001%2016.7719%204.92552%2015.8266%204.60865%2015.0616C4.29179%2014.2967%203.32259%2013.9291%202.21232%2014.0601ZM3.99975%2012.2104C5.09956%2012.5148%206.00718%2013.2117%206.45641%2014.2963C6.90564%2015.3808%206.75667%2016.5154%206.19421%2017.5083C6.29077%2017.61%206.38998%2017.7092%206.49173%2017.8056C7.4846%2017.2432%208.61912%2017.0943%209.70359%2017.5435C10.7881%2017.9927%2011.485%2018.9002%2011.7894%2019.9999C11.9295%2020.0037%2012.0697%2020.0038%2012.2099%2020.0001C12.5143%2018.9003%2013.2112%2017.9927%2014.2958%2017.5435C15.3803%2017.0942%2016.5149%2017.2432%2017.5078%2017.8057C17.6096%2017.7091%2017.7087%2017.6099%2017.8051%2017.5081C17.2427%2016.5153%2017.0938%2015.3807%2017.543%2014.2963C17.9922%2013.2118%2018.8997%2012.5149%2019.9994%2012.2105C20.0032%2012.0704%2020.0033%2011.9301%2019.9996%2011.7899C18.8998%2011.4856%2017.9922%2010.7886%2017.543%209.70407C17.0937%208.61953%2017.2427%207.48494%2017.8052%206.49204C17.7086%206.39031%2017.6094%206.2912%2017.5076%206.19479C16.5148%206.75717%2015.3803%206.9061%2014.2958%206.4569C13.2113%206.0077%2012.5144%205.10016%2012.21%204.00044C12.0699%203.99666%2011.9297%203.99659%2011.7894%204.00024C11.4851%205.10005%2010.7881%206.00767%209.70359%206.4569C8.61904%206.90613%207.48446%206.75715%206.49155%206.1947C6.38982%206.29126%206.29071%206.39047%206.19431%206.49222C6.75668%207.48509%206.90561%208.61961%206.45641%209.70407C6.00721%2010.7885%205.09967%2011.4855%203.99995%2011.7899C3.99617%2011.93%203.9961%2012.0702%203.99975%2012.2104ZM11.9997%2015.0002C10.3428%2015.0002%208.99969%2013.657%208.99969%2012.0002C8.99969%2010.3433%2010.3428%209.00018%2011.9997%209.00018C13.6565%209.00018%2014.9997%2010.3433%2014.9997%2012.0002C14.9997%2013.657%2013.6565%2015.0002%2011.9997%2015.0002ZM11.9997%2013.0002C12.552%2013.0002%2012.9997%2012.5525%2012.9997%2012.0002C12.9997%2011.4479%2012.552%2011.0002%2011.9997%2011.0002C11.4474%2011.0002%2010.9997%2011.4479%2010.9997%2012.0002C10.9997%2012.5525%2011.4474%2013.0002%2011.9997%2013.0002Z'/%3e%3c/svg%3e";
function o8(e) {
  return e.map((t) => {
    const n = typeof t.header == "function" ? (o) => t.header({
      table: {
        getIsAllPageRowsSelected: () => o.table.getIsAllPageRowsSelected(),
        getIsSomePageRowsSelected: () => o.table.getIsSomePageRowsSelected(),
        toggleAllPageRowsSelected: (a) => o.table.toggleAllPageRowsSelected(a)
      }
    }) : t.header, r = {
      id: t.id,
      header: n,
      enableSorting: t.sortable,
      enableResizing: t.resizable,
      enablePinning: t.enablePinning ?? !1,
      meta: {
        enableColumnDragging: t.draggable,
        headerMenuItems: t.headerMenuItems,
        isCustomHeader: t.customHeader,
        noTruncate: t.noTruncate,
        locked: t.locked,
        showPinIcon: t.showPinIcon ?? !0
      }
    };
    return t.width !== void 0 && (r.size = t.width), t.minWidth !== void 0 && (r.minSize = t.minWidth), t.maxWidth !== void 0 && (r.maxSize = t.maxWidth), t.cell && (r.cell = (o) => t.cell({
      row: {
        original: o.row.original,
        getValue: (a) => o.row.getValue(a),
        id: o.row.id,
        getIsSelected: () => o.row.getIsSelected(),
        toggleSelected: (a) => o.row.toggleSelected(a)
      },
      getValue: () => o.getValue()
    })), t.key ? { ...r, accessorKey: t.key } : r;
  });
}
const a8 = { key: 0 }, l8 = {
  key: 1,
  class: "sticky right-0 z-30 w-10 p-0 bg-white dark:bg-(--colors-background-black-default)"
}, s8 = ["aria-label"], i8 = ["src"], d8 = { key: 0 }, u8 = {
  key: 1,
  "aria-hidden": "true"
}, c8 = 40, f8 = /* @__PURE__ */ ge({
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    hasSettings: { type: Boolean },
    columnVisibility: {},
    columnOrder: {},
    stickyHeader: { type: Boolean },
    maxHeight: {},
    emptyText: {},
    settingsAriaLabel: {},
    columnPinning: {},
    columnSizing: {}
  },
  emits: ["settings-click", "pin-column", "update:columnOrder", "update:columnPinning", "update:columnSizing"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n, a = N(r.columnOrder ?? []);
    we(
      () => r.columnOrder,
      (M) => {
        M && (a.value = M);
      }
    );
    const l = N({}), s = N(r.columnPinning ?? { left: [], right: [] }), i = N(null), d = N(null), u = N(0), f = y(() => r.hasSettings ? c8 : 0), h = N({}), b = N({}), m = /* @__PURE__ */ new Set(), x = N({ ...{
      startOffset: null,
      startSize: null,
      deltaOffset: null,
      deltaPercentage: null,
      isResizingColumn: !1,
      columnSizingStart: []
    } }), k = N(!1), L = n8({
      get data() {
        return r.data;
      },
      get columns() {
        return o8(r.columns);
      },
      columnResizeMode: "onChange",
      enableRowSelection: !0,
      enableColumnPinning: !0,
      defaultColumn: {
        minSize: 130
      },
      state: {
        get columnOrder() {
          return a.value;
        },
        get columnVisibility() {
          return r.columnVisibility ?? {};
        },
        get columnSizing() {
          return h.value;
        },
        get columnSizingInfo() {
          return x.value;
        },
        get columnPinning() {
          return s.value;
        },
        get rowSelection() {
          return l.value;
        }
      },
      onColumnOrderChange: (M) => {
        const D = typeof M == "function" ? M(a.value) : M;
        a.value = D, o("update:columnOrder", D);
      },
      onColumnSizingChange: (M) => {
        h.value = typeof M == "function" ? M(h.value) : M;
      },
      onColumnSizingInfoChange: (M) => {
        x.value = typeof M == "function" ? M(x.value) : M;
      },
      onColumnPinningChange: (M) => {
        const D = typeof M == "function" ? M(s.value) : M, re = s.value, se = (D.left ?? []).length === (re.left ?? []).length && (D.left ?? []).every((fe, q) => fe === (re.left ?? [])[q]), de = (D.right ?? []).length === (re.right ?? []).length && (D.right ?? []).every((fe, q) => fe === (re.right ?? [])[q]);
        se && de || (s.value = D, o("update:columnPinning", D));
      },
      onRowSelectionChange: (M) => {
        l.value = typeof M == "function" ? M(l.value) : M;
      },
      getCoreRowModel: _P()
    }), P = y(() => ({
      allSelected: L.getIsAllPageRowsSelected(),
      someSelected: L.getIsSomePageRowsSelected(),
      toggleAll: (M) => L.toggleAllPageRowsSelected(M),
      isSelected: (M) => {
        var D;
        return ((D = L.getRowModel().rows.find((re) => re.original === M)) == null ? void 0 : D.getIsSelected()) ?? !1;
      },
      toggleRow: (M, D) => {
        var re;
        return (re = L.getRowModel().rows.find((se) => se.original === M)) == null ? void 0 : re.toggleSelected(D);
      }
    }));
    function E(M, D = "left") {
      const re = L.getColumn(M);
      re && (re.pin(D), o("pin-column", M, D));
    }
    function O(M) {
      E(M, !1);
    }
    function R(M) {
      a.value = M;
    }
    we(
      () => r.columnPinning,
      (M) => {
        if (!M) return;
        const D = M.left ?? [], re = M.right ?? [], se = s.value, de = D.length === (se.left ?? []).length && D.every((q, oe) => q === (se.left ?? [])[oe]), fe = re.length === (se.right ?? []).length && re.every((q, oe) => q === (se.right ?? [])[oe]);
        de && fe || (s.value = { left: [...D], right: [...re] });
      },
      { deep: !0 }
    ), t({ selection: P, pinColumn: E, unpinColumn: O, setColumnOrder: R });
    function V() {
      var se, de;
      if (!d.value || Object.keys(h.value).length > 0) return;
      const M = Array.from(d.value.querySelectorAll("thead th")), D = ((se = L.getHeaderGroups()[0]) == null ? void 0 : se.headers) ?? [], re = {};
      if (D.forEach((fe, q) => {
        const oe = M[q];
        if (oe) {
          const ue = fe.column.columnDef.maxSize;
          re[fe.column.id] = ue !== void 0 ? Math.min(oe.offsetWidth, ue) : oe.offsetWidth;
        }
      }), Object.keys(re).length > 0) {
        const fe = d.value.clientWidth, q = fe - f.value, ue = Object.values(re).reduce((G, H) => G + H, 0) - q;
        if (ue !== 0) {
          const G = (de = [...D].reverse().find((H) => H.column.columnDef.maxSize === void 0)) == null ? void 0 : de.column.id;
          G !== void 0 && (re[G] = Math.max(130, re[G] - ue));
        }
        L.setColumnSizing(re), u.value = fe, b.value = { ...re }, k.value = !0, J();
      }
    }
    function J() {
      if (!k.value) return;
      const M = r.columnSizing ?? {}, D = Object.keys(M);
      if (D.length === 0) {
        m.size > 0 && (h.value = { ...b.value }, m.clear());
        return;
      }
      const re = new Set(L.getAllLeafColumns().map((q) => q.id)), se = {};
      for (const q of D) {
        const oe = M[q];
        re.has(q) && typeof oe == "number" && oe > 0 && (se[q] = oe);
      }
      const de = Object.keys(se);
      de.length === m.size && de.every((q) => h.value[q] === se[q]) || (h.value = { ...b.value, ...se }, m.clear(), de.forEach((q) => m.add(q)));
    }
    function F() {
      const M = {};
      m.forEach((D) => {
        const re = h.value[D];
        typeof re == "number" && (M[D] = re);
      }), o("update:columnSizing", M);
    }
    we(
      () => x.value.isResizingColumn,
      (M, D) => {
        D && !M && (m.add(D), F());
      }
    ), we(() => r.columnSizing, J, { deep: !0 });
    function A(M) {
      var oe;
      if (!k.value) return;
      const D = M - u.value;
      if (D === 0) return;
      const se = (((oe = L.getHeaderGroups()[0]) == null ? void 0 : oe.headers) ?? []).filter(
        (ue) => ue.column.columnDef.maxSize === void 0 || ue.column.columnDef.maxSize >= Number.MAX_SAFE_INTEGER
      );
      if (se.length === 0) return;
      const de = { ...h.value }, fe = se.reduce(
        (ue, G) => ue + (de[G.column.id] ?? G.column.getSize()),
        0
      );
      let q = D;
      se.forEach((ue, G) => {
        const H = de[ue.column.id] ?? ue.column.getSize(), z = ue.column.columnDef.minSize ?? 130, X = G === se.length - 1 ? q : Math.round(D * (H / fe));
        de[ue.column.id] = Math.max(z, H + X), q -= X;
      }), h.value = de, u.value = M;
    }
    let j = null;
    Qe(() => {
      Pe(() => {
        d.value && (j = new ResizeObserver((M) => {
          var re, se;
          const D = ((re = M[0]) == null ? void 0 : re.contentRect.width) ?? ((se = d.value) == null ? void 0 : se.clientWidth) ?? 0;
          k.value ? A(Math.round(D)) : D > 0 && V();
        }), j.observe(d.value), d.value.clientWidth > 0 && V());
      });
    }), nt(() => {
      j == null || j.disconnect(), j = null;
    });
    const _ = y(() => {
      if (k.value)
        return `${L.getTotalSize() + f.value}px`;
    }), U = y(() => k.value ? L.getTotalSize() + f.value < u.value : !1);
    function W(M) {
      var re;
      const D = L.getColumn(M);
      ((re = D == null ? void 0 : D.columnDef.meta) == null ? void 0 : re.locked) !== !0 && (i.value = M);
    }
    function K(M) {
      var D;
      return ((D = M.columnDef.meta) == null ? void 0 : D.locked) === !0 ? "locked" : M.getIsPinned() === "left" ? "pinned" : "regular";
    }
    function le(M) {
      return (D) => {
        if (D.preventDefault(), !i.value) return;
        const re = L.getVisibleLeafColumns().map((z) => z.id), se = re.indexOf(i.value), de = re.indexOf(M);
        if (de === 0 || se === -1 || de === -1) return;
        const fe = L.getColumn(i.value), q = L.getColumn(M);
        if (!fe || !q) {
          i.value = null;
          return;
        }
        const oe = K(fe), ue = K(q);
        if (oe === "locked" || ue === "locked" || oe !== ue) {
          i.value = null;
          return;
        }
        if (oe === "pinned" && ue === "pinned") {
          const z = [...L.getState().columnPinning.left ?? []], X = z.indexOf(i.value), Y = z.indexOf(M);
          if (X !== -1 && Y !== -1 && X !== Y) {
            const [ce] = z.splice(X, 1);
            z.splice(Y, 0, ce), L.setColumnPinning({
              left: z,
              right: L.getState().columnPinning.right ?? []
            });
          }
        }
        const G = [...re], [H] = G.splice(se, 1);
        G.splice(de, 0, H), L.setColumnOrder(G), i.value = null;
      };
    }
    function C(M) {
      const D = M.style.width, re = M.style.maxWidth;
      M.style.width = "max-content", M.style.maxWidth = "none";
      const se = M.scrollWidth;
      return M.style.width = D, M.style.maxWidth = re, se;
    }
    function B(M) {
      var Y, ce, ne;
      if (!d.value) return;
      const D = (Y = L.getHeaderGroups()[0]) == null ? void 0 : Y.headers.findIndex((ye) => ye.column.id === M);
      if (D === void 0 || D < 0) return;
      const se = Array.from(d.value.querySelectorAll("thead th"))[D], de = se == null ? void 0 : se.querySelector(".truncate, [data-slot]"), fe = de ? C(de) : (se == null ? void 0 : se.scrollWidth) ?? 0, q = d.value.querySelectorAll("tbody tr");
      let oe = 0;
      q.forEach((ye) => {
        const ie = ye.querySelectorAll("td")[D];
        if (ie) {
          const me = ie.querySelector(".truncate");
          oe = Math.max(oe, me ? C(me) : ie.scrollWidth);
        }
      });
      const ue = (ne = (ce = L.getHeaderGroups()[0]) == null ? void 0 : ce.headers[D]) == null ? void 0 : ne.column, G = (ue == null ? void 0 : ue.columnDef.minSize) ?? 130, H = (ue == null ? void 0 : ue.columnDef.maxSize) ?? 1e3, z = Math.min(
        H,
        Math.max(G, Math.max(fe, oe) + 24)
      ), X = { ...h.value, [M]: z };
      L.setColumnSizing(X), m.add(M), F();
    }
    function I(M) {
      const D = M.getIsPinned();
      if (!D)
        return k.value ? { width: `${M.getSize()}px` } : void 0;
      const re = {
        position: "sticky",
        zIndex: "10"
      };
      return D === "left" && (re.left = `${M.getStart("left")}px`), k.value && (re.width = `${M.getSize()}px`), re;
    }
    return (M, D) => (c(), p("div", {
      class: S(["relative border-x border-(--colors-border-base-soft) dark:border-(--colors-border-base)", { "h-full flex flex-col": e.stickyHeader && !e.maxHeight }])
    }, [
      g("div", {
        ref_key: "containerRef",
        ref: d,
        role: "region",
        "aria-label": "Data table",
        "data-testid": "data-table-container",
        class: S(["relative overflow-x-auto text-(--text-text-heading)", { "overflow-y-auto flex-1 min-h-0": e.stickyHeader && !e.maxHeight }]),
        style: Ae({ scrollbarGutter: "stable", ...e.maxHeight ? { maxHeight: e.maxHeight, overflowY: "auto" } : {} })
      }, [
        ae(T(X6), { "table-width": _.value }, {
          default: pe(() => [
            ae(T(fP), {
              "is-sticky": e.stickyHeader || !!e.maxHeight
            }, {
              default: pe(() => [
                (c(!0), p(Z, null, ke(T(L).getHeaderGroups(), (re) => (c(), te(T(il), {
                  key: re.id
                }, {
                  default: pe(() => [
                    (c(!0), p(Z, null, ke(re.headers, (se) => {
                      var de, fe, q, oe, ue;
                      return c(), te(T(cP), {
                        key: se.id,
                        style: Ae(I(se.column)),
                        "is-pinned": se.column.getIsPinned() === "left",
                        "is-last-pinned": se.column.getIsLastColumn("left"),
                        "header-menu-items": (de = se.column.columnDef.meta) == null ? void 0 : de.headerMenuItems,
                        "is-custom-header": (fe = se.column.columnDef.meta) == null ? void 0 : fe.isCustomHeader,
                        "is-draggable": ((q = se.column.columnDef.meta) == null ? void 0 : q.enableColumnDragging) === !0,
                        "is-locked": ((oe = se.column.columnDef.meta) == null ? void 0 : oe.locked) === !0,
                        "is-pin-icon-visible": ((ue = se.column.columnDef.meta) == null ? void 0 : ue.showPinIcon) !== !1,
                        "is-resizable": se.column.getCanResize(),
                        "is-resizing-active": se.column.getIsResizing(),
                        class: "header-cell",
                        onDragHandleStart: (G) => W(se.column.id),
                        onDragover: D[0] || (D[0] = Ie(() => {
                        }, ["prevent"])),
                        onDrop: (G) => le(se.column.id)(G),
                        onResizeStart: (G) => se.getResizeHandler()(G),
                        onResizeAuto: (G) => B(se.column.id)
                      }, {
                        default: pe(() => [
                          se.isPlaceholder ? w("", !0) : (c(), te(T(vf), {
                            key: 0,
                            render: se.column.columnDef.header,
                            props: se.getContext()
                          }, null, 8, ["render", "props"]))
                        ]),
                        _: 2
                      }, 1032, ["style", "is-pinned", "is-last-pinned", "header-menu-items", "is-custom-header", "is-draggable", "is-locked", "is-pin-icon-visible", "is-resizable", "is-resizing-active", "onDragHandleStart", "onDrop", "onResizeStart", "onResizeAuto"]);
                    }), 128)),
                    U.value ? (c(), p("th", a8)) : w("", !0),
                    e.hasSettings ? (c(), p("th", l8, [
                      g("button", {
                        "data-testid": "data-settings",
                        "aria-label": e.settingsAriaLabel ?? "Column settings",
                        class: "data-settings-btn flex items-center justify-center w-10 h-10 p-0 cursor-pointer focus-visible:ring-2 focus-visible:ring-royalblue focus-visible:outline-none transition-colors",
                        onClick: D[1] || (D[1] = (se) => o("settings-click"))
                      }, [
                        g("img", {
                          class: "size-5",
                          src: T(r8),
                          alt: ""
                        }, null, 8, i8)
                      ], 8, s8)
                    ])) : w("", !0)
                  ]),
                  _: 2
                }, 1024))), 128))
              ]),
              _: 1
            }, 8, ["is-sticky"]),
            ae(T(Q6), null, {
              default: pe(() => {
                var re;
                return [
                  (re = T(L).getRowModel().rows) != null && re.length ? (c(!0), p(Z, { key: 0 }, ke(T(L).getRowModel().rows, (se) => (c(), te(T(il), {
                    key: se.id,
                    "data-state": se.getIsSelected() ? "selected" : void 0
                  }, {
                    default: pe(() => [
                      (c(!0), p(Z, null, ke(se.getVisibleCells(), (de) => {
                        var fe;
                        return c(), te(T(Xi), {
                          key: de.id,
                          "no-truncate": (fe = de.column.columnDef.meta) == null ? void 0 : fe.noTruncate,
                          style: Ae(I(de.column)),
                          class: S([
                            de.column.getIsPinned() === "left" ? "sticky z-10 bg-white dark:bg-(--colors-background-black-default) pinned-cell" : "",
                            de.column.getIsLastColumn("left") ? "pinned-cell-last" : ""
                          ])
                        }, {
                          default: pe(() => [
                            ae(T(vf), {
                              render: de.column.columnDef.cell ?? de.getValue,
                              props: de.getContext()
                            }, null, 8, ["render", "props"])
                          ]),
                          _: 2
                        }, 1032, ["no-truncate", "style", "class"]);
                      }), 128)),
                      U.value ? (c(), p("td", d8)) : w("", !0),
                      e.hasSettings ? (c(), p("td", u8)) : w("", !0)
                    ]),
                    _: 2
                  }, 1032, ["data-state"]))), 128)) : (c(), te(T(il), {
                    key: 1,
                    class: "border-b-0! hover:bg-white! dark:hover:bg-(--colors-background-black-default)!"
                  }, {
                    default: pe(() => [
                      ae(T(Xi), {
                        colspan: e.columns.length + 1,
                        class: "h-24 text-center"
                      }, {
                        default: pe(() => [
                          Ze($(e.emptyText ?? "No results."), 1)
                        ]),
                        _: 1
                      }, 8, ["colspan"])
                    ]),
                    _: 1
                  }))
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["table-width"])
      ], 6)
    ], 2));
  }
}), XV = /* @__PURE__ */ He(f8, [["__scopeId", "data-v-50cdd477"]]);
function QV(e, t, n) {
  return (r) => {
    const a = (e() || "").replace(/\D/g, ""), l = t() || "", s = XI[l], i = tu(a, (s == null ? void 0 : s.hasTrunkZero) ?? !1);
    if (!i) return;
    const d = (s == null ? void 0 : s.min) ?? 6, u = (s == null ? void 0 : s.max) ?? 1 / 0, f = (s == null ? void 0 : s.name) ?? l, h = (s == null ? void 0 : s.placeholder) ?? Xr.placeholder;
    if (i.length < d)
      return n({ count: d, country: f, example: h });
    if (i.length > u)
      return n({ count: u, country: f, example: h });
  };
}
function yf(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : !1;
}
function h8(e) {
  const t = typeof e == "string" ? { requiredMessage: e } : e, { requiredMessage: n, watchData: r } = t, o = typeof n == "function" ? n : () => n, a = N(/* @__PURE__ */ new Map()), l = y(() => Array.from(a.value.values())), s = y(() => a.value.size), i = y(() => a.value.size > 0);
  function d(v, x) {
    if (v.required && yf(x))
      return o();
    if (v.validate)
      return v.validate(x);
  }
  function u(v, x) {
    const k = /* @__PURE__ */ new Map();
    for (const L of v) {
      const P = d(L, x[L.key]);
      P && k.set(L.key, {
        key: L.key,
        label: L.label,
        message: P
      });
    }
    return a.value = k, k.size === 0;
  }
  function f(v, x) {
    const k = d(v, x);
    if (k) {
      const L = new Map(a.value);
      return L.set(v.key, { key: v.key, label: v.label, message: k }), a.value = L, !1;
    } else
      return b(v.key), !0;
  }
  function h(v) {
    var x;
    return (x = a.value.get(v)) == null ? void 0 : x.message;
  }
  function b(v) {
    if (a.value.has(v)) {
      const x = new Map(a.value);
      x.delete(v), a.value = x;
    }
  }
  function m() {
    a.value = /* @__PURE__ */ new Map();
  }
  return r && we(
    () => r,
    () => {
      if (i.value)
        for (const v of [...l.value]) {
          const x = r[v.key];
          yf(x) || b(v.key);
        }
    },
    { deep: !0 }
  ), {
    errors: a,
    errorList: l,
    errorCount: s,
    hasErrors: i,
    validateAll: u,
    validateField: d,
    validateAndSetField: f,
    getFieldError: h,
    clearFieldError: b,
    clearAllErrors: m
  };
}
function b8(e) {
  const t = N(!1);
  async function n() {
    var r, o;
    if (e.validate()) {
      t.value = !0;
      try {
        await e.save(), (r = e.onSuccess) == null || r.call(e);
      } catch (a) {
        (o = e.onError) == null || o.call(e, a);
      } finally {
        t.value = !1;
      }
    }
  }
  return { isSaving: t, handleSubmit: n };
}
function Qr(e) {
  if (e === null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(Qr);
  const t = {};
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = Qr(e[n]));
  return t;
}
function rd(e, t) {
  if (e === t) return !0;
  if (e === null || t === null) return e === t;
  if (typeof e != typeof t) return !1;
  if (typeof e != "object") return e === t;
  if (Array.isArray(e) && Array.isArray(t))
    return e.length !== t.length ? !1 : e.every((o, a) => rd(o, t[a]));
  if (Array.isArray(e) || Array.isArray(t)) return !1;
  const n = Object.keys(e), r = Object.keys(t);
  return n.length !== r.length ? !1 : n.every(
    (o) => rd(e[o], t[o])
  );
}
function p8(e) {
  const { data: t, enableBeforeUnload: n = !0, beforeUnloadMessage: r } = e, o = N(null), a = N(!1), l = y(() => a.value ? !0 : o.value === null ? !1 : !rd(t, o.value));
  function s() {
    o.value = Qr(t), a.value = !1;
  }
  function i() {
    o.value = Qr(t), a.value = !1;
  }
  function d() {
    o.value !== null && Object.assign(t, Qr(o.value)), a.value = !1;
  }
  function u() {
    return Qr(o.value);
  }
  function f(b) {
    a.value = b;
  }
  function h(b) {
    if (l.value) {
      b.preventDefault();
      const m = r ? r() : "";
      return b.returnValue = m, m;
    }
  }
  return Qe(() => {
    s(), n && window.addEventListener("beforeunload", h);
  }), nt(() => {
    n && window.removeEventListener("beforeunload", h);
  }), {
    isDirty: l,
    markAsSaved: i,
    resetToOriginal: d,
    getOriginalData: u,
    setDirty: f
  };
}
function _V(e) {
  const t = p8({
    data: e.data,
    enableBeforeUnload: e.enableBeforeUnload,
    beforeUnloadMessage: e.beforeUnloadMessage
  }), n = h8({
    requiredMessage: e.requiredMessage,
    watchData: e.data
  }), r = b8({
    validate: () => n.validateAll(e.fields(), e.data),
    save: e.save,
    onSuccess: () => {
      var o;
      n.clearAllErrors(), t.markAsSaved(), (o = e.onSuccess) == null || o.call(e);
    },
    onError: e.onError
  });
  return {
    // Dirty state
    isDirty: t.isDirty,
    markAsSaved: t.markAsSaved,
    resetToOriginal: t.resetToOriginal,
    setDirty: t.setDirty,
    // Validation
    errorList: n.errorList,
    errorCount: n.errorCount,
    hasErrors: n.hasErrors,
    getFieldError: n.getFieldError,
    clearFieldError: n.clearFieldError,
    clearAllErrors: n.clearAllErrors,
    // Submit
    isSaving: r.isSaving,
    handleSubmit: r.handleSubmit
  };
}
function g8(e) {
  const t = N(!1);
  if (typeof window > "u") return t;
  const n = window.matchMedia(e), r = () => {
    t.value = n.matches;
  };
  return Mf() && (Qe(() => {
    r(), n.addEventListener("change", r);
  }), nt(() => {
    n.removeEventListener("change", r);
  })), t;
}
const m8 = {
  key: 0,
  class: "p-3"
}, v8 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4" }, x8 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }, y8 = {
  key: 0,
  class: "flex items-center space-x-4"
}, k8 = {
  key: 1,
  class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 shrink-0"
}, w8 = {
  key: 0,
  class: "flex flex-wrap"
}, C8 = { class: "relative" }, S8 = { class: "flex-1 min-h-0 flex flex-col" }, $8 = {
  key: 1,
  class: "border-t border-gainsboro dark:border-(--colors-border-base) p-5"
}, eF = /* @__PURE__ */ ge({
  __name: "DataTableWrapper",
  props: {
    bordered: { type: Boolean }
  },
  setup(e) {
    const t = ht();
    return (n, r) => (c(), p("div", {
      class: S([
        "relative bg-white rounded-xl flex-1 flex flex-col min-h-0",
        e.bordered ? "border border-(--border-border-base-soft) overflow-hidden shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)]" : "border-l border-border-base-soft has-[>div:nth-child(2)>[role=data-settings]]:rounded-tr-none"
      ])
    }, [
      r[0] || (r[0] = g("div", { class: "absolute bottom-0 left-1.5 right-0 h-px bg-linear-to-r from-(--background-background-gray) to-transparent" }, null, -1)),
      T(t)("filters") || T(t)("actions") ? (c(), p("div", m8, [
        g("div", v8, [
          g("div", x8, [
            T(t)("filters") ? (c(), p("div", y8, [
              be(n.$slots, "filters")
            ])) : w("", !0),
            T(t)("actions") ? (c(), p("div", k8, [
              be(n.$slots, "actions")
            ])) : w("", !0)
          ]),
          T(t)("filter-items") ? (c(), p("div", w8, [
            be(n.$slots, "filter-items")
          ])) : w("", !0)
        ])
      ])) : w("", !0),
      g("div", C8, [
        g("div", {
          class: S(["absolute top-0 right-0 h-0.5 bg-border-base-soft", T(t)("filters") ? "left-0" : "left-1.5"])
        }, null, 2)
      ]),
      g("div", S8, [
        be(n.$slots, "table")
      ]),
      T(t)("pager") ? (c(), p("div", $8, [
        be(n.$slots, "pager")
      ])) : w("", !0)
    ], 2));
  }
}), I8 = {
  key: 0,
  role: "menu",
  "data-testid": "card-actions-menu",
  class: "absolute right-0 top-10 z-50 min-w-160px rounded-xl border border-(--border-border-base-soft) bg-white py-1 shadow-[0_4px_16px_rgba(0,0,0,0.12)]"
}, T8 = ["onClick"], L8 = {
  key: 0,
  class: "skeleton w-full h-192px rounded-t-3xl"
}, M8 = {
  key: 1,
  class: "skeleton h-9 w-9 rounded-full shrink-0 m-6"
}, E8 = ["src", "alt"], A8 = { class: "h-9 w-9 rounded-full border border-(--border-border-base-soft) flex items-center justify-center bg-white" }, D8 = { class: "flex flex-col flex-1" }, R8 = {
  key: 0,
  class: "self-start bg-(--background-background-white-tertiary) text-xs font-medium px-1 py-0.5 rounded text-(--text-text-black-default)"
}, B8 = {
  key: 1,
  class: "text-2xl font-bold text-(--text-text-heading) dark:text-(--colors-text-white-default) m-0"
}, O8 = {
  key: 2,
  class: "text-base text-(--text-text-body) dark:text-(--colors-text-white-secondary) m-0"
}, tF = /* @__PURE__ */ ge({
  __name: "Card",
  props: {
    layout: { default: "classic" },
    headerType: { default: "icon" },
    imageSrc: { default: void 0 },
    imageAlt: { default: "" },
    badge: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    primaryLabel: { default: void 0 },
    secondaryLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    actions: { default: void 0 }
  },
  emits: ["primary-click", "secondary-click"],
  setup(e, { emit: t }) {
    const n = t, {
      isOpen: r,
      dropdownRef: o,
      toggleDropdown: a,
      closeDropdown: l
    } = wa(), s = (d) => {
      var u;
      (u = d.onClick) == null || u.call(d), l();
    }, i = (d) => {
      o.value = d;
    };
    return (d, u) => (c(), p("div", {
      "data-testid": "card",
      class: S([
        "relative overflow-hidden rounded-3xl border border-(--border-border-base-medium) bg-white dark:bg-(--colors-background-black-default) shadow-[0px_0px_4px_rgba(0,0,0,0.1)]",
        e.layout === "aligned" ? "flex flex-row items-center" : "flex flex-col"
      ])
    }, [
      !e.loading && e.actions && e.actions.length ? (c(), p("div", {
        key: 0,
        ref: i,
        class: "absolute top-3 right-3 z-10",
        "data-testid": "card-actions"
      }, [
        g("button", {
          type: "button",
          "data-testid": "card-actions-trigger",
          class: "h-8 w-8 rounded-full border border-(--border-border-base-soft) bg-white flex items-center justify-center cursor-pointer hover:bg-(--background-background-white-tertiary) transition-colors",
          onClick: u[0] || (u[0] = //@ts-ignore
          (...f) => T(a) && T(a)(...f))
        }, [...u[3] || (u[3] = [
          g("i", { class: "ri-more-line text-sm text-(--text-text-body)" }, null, -1)
        ])]),
        ae(ot, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-out",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: pe(() => [
            T(r) ? (c(), p("div", I8, [
              (c(!0), p(Z, null, ke(e.actions, (f) => (c(), p("button", {
                key: f.label,
                type: "button",
                role: "menuitem",
                "data-testid": "card-action-item",
                class: S([
                  "w-full text-left px-4 py-2 text-sm hover:bg-(--background-background-white-tertiary) transition-colors flex items-center gap-2",
                  f.class || "text-(--text-text-black-default)"
                ]),
                onClick: (h) => s(f)
              }, [
                f.icon ? (c(), p("i", {
                  key: 0,
                  class: S(f.icon)
                }, null, 2)) : w("", !0),
                Ze(" " + $(f.label), 1)
              ], 10, T8))), 128))
            ])) : w("", !0)
          ]),
          _: 1
        })
      ])) : w("", !0),
      e.loading ? (c(), p(Z, { key: 1 }, [
        e.layout !== "aligned" ? (c(), p("div", L8)) : (c(), p("div", M8)),
        u[4] || (u[4] = mo('<div class="flex flex-col gap-3 px-6 pb-6 pt-4 flex-1"><div class="skeleton h-5 w-16 rounded"></div><div class="skeleton h-8 w-3/4 rounded"></div><div class="skeleton h-4 w-full rounded"></div><div class="skeleton h-4 w-2/3 rounded"></div><div class="flex gap-2 pt-2"><div class="skeleton h-9 w-24 rounded-full"></div><div class="skeleton h-9 w-24 rounded-full"></div></div></div>', 1))
      ], 64)) : (c(), p(Z, { key: 2 }, [
        be(d.$slots, "header", {}, () => [
          e.headerType === "image" ? (c(), p("div", {
            key: 0,
            class: S(e.layout === "aligned" ? "p-6 shrink-0" : "p-6")
          }, [
            e.imageSrc ? (c(), p("img", {
              key: 0,
              src: e.imageSrc,
              alt: e.imageAlt,
              class: S(
                e.layout === "aligned" ? "h-48 w-48 object-cover rounded-xl" : "w-full h-48 object-cover rounded-xl"
              )
            }, null, 10, E8)) : w("", !0)
          ], 2)) : (c(), p("div", {
            key: 1,
            class: S(e.layout === "aligned" ? "pl-6 shrink-0" : "pt-6 pb-6 px-6")
          }, [
            g("div", A8, [
              be(d.$slots, "icon")
            ])
          ], 2))
        ]),
        g("div", D8, [
          be(d.$slots, "default", {}, () => [
            g("div", {
              class: S(["flex flex-col gap-3", e.layout === "aligned" ? "p-6" : "px-6 pb-6"])
            }, [
              e.badge ? (c(), p("span", R8, $(e.badge), 1)) : w("", !0),
              e.title ? (c(), p("p", B8, $(e.title), 1)) : w("", !0),
              e.description ? (c(), p("p", O8, $(e.description), 1)) : w("", !0)
            ], 2)
          ])
        ]),
        be(d.$slots, "footer", {}, () => [
          e.primaryLabel || e.secondaryLabel ? (c(), p("div", {
            key: 0,
            class: S([
              e.layout === "aligned" ? "px-6 flex flex-col gap-4 items-start shrink-0" : "px-6 pb-6 flex items-center gap-4"
            ])
          }, [
            e.primaryLabel ? (c(), te($e, {
              key: 0,
              variant: "primary",
              size: "xs",
              label: e.primaryLabel,
              onClick: u[1] || (u[1] = (f) => n("primary-click"))
            }, null, 8, ["label"])) : w("", !0),
            e.secondaryLabel ? (c(), te($e, {
              key: 1,
              variant: "secondary",
              size: "xs",
              label: e.secondaryLabel,
              onClick: u[2] || (u[2] = (f) => n("secondary-click"))
            }, null, 8, ["label"])) : w("", !0)
          ], 2)) : w("", !0)
        ])
      ], 64))
    ], 2));
  }
}), P8 = ["aria-checked", "aria-disabled"], z8 = { class: "flex flex-col gap-1.5" }, nF = /* @__PURE__ */ ge({
  __name: "CardSelectable",
  props: {
    icon: { default: void 0 },
    title: { default: void 0 },
    description: { default: void 0 },
    selected: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    iconVariant: { default: "default" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    function o(a) {
      n.disabled || r("click", a);
    }
    return (a, l) => (c(), p("button", {
      type: "button",
      "data-testid": "card-selectable",
      "aria-checked": e.selected,
      "aria-disabled": e.disabled || void 0,
      class: S([
        "relative flex flex-col gap-3 p-6 rounded-xl border text-left w-full",
        "transition-colors duration-120 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-hover)",
        // Disabled wins over selected (a disabled card can't be the chosen option). Use the DS
        // disabled surface (grey fill + border) rather than a flat opacity so the disabled state
        // reads clearly against the enabled cards (OP-6222).
        e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled) cursor-not-allowed pointer-events-none" : e.selected ? "bg-(--background-background-hover) border-(--border-border-hover) shadow-[0px_0px_2px_var(--border-border-hover)] cursor-pointer" : "bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-hover) active:bg-(--background-background-hover) cursor-pointer"
      ]),
      onClick: o
    }, [
      be(a.$slots, "default", {}, () => [
        g("div", {
          class: S([
            "h-9 w-9 flex items-center justify-center rounded-lg border shrink-0",
            e.disabled ? "bg-(--colors-background-disabled) border-(--colors-border-disabled)" : e.iconVariant === "accent" ? "bg-(--background-background-white) border-(--border-border-hover) shadow-[0px_0px_1px_var(--background-background-hover)]" : "bg-(--background-background-white) border-(--border-border-base-medium)"
          ])
        }, [
          g("i", {
            class: S([e.icon, "text-[20px]", e.disabled ? "text-(--colors-icon-disabled)" : "text-(--icons-icon-accent)"]),
            "aria-hidden": "true"
          }, null, 2)
        ], 2),
        g("div", z8, [
          g("span", {
            class: S(["text-lg font-semibold", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-heading)"])
          }, $(e.title), 3),
          e.description ? (c(), p("span", {
            key: 0,
            class: S(["text-sm", e.disabled ? "text-(--colors-text-disabled)" : "text-(--text-text-body)"])
          }, $(e.description), 3)) : w("", !0)
        ])
      ])
    ], 10, P8));
  }
}), N8 = {
  "data-testid": "page-header",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6 sm:mb-8"
}, V8 = { class: "shrink-0" }, F8 = {
  "data-testid": "page-header-title",
  class: "text-2xl sm:text-3xl font-bold text-gray-900"
}, H8 = {
  key: 0,
  "data-testid": "page-header-subtitle",
  class: "text-sm sm:text-base text-gray-600 mt-1"
}, W8 = {
  key: 0,
  "data-testid": "page-header-actions",
  class: "flex items-center gap-3 shrink-0"
}, rF = /* @__PURE__ */ ge({
  __name: "PageHeader",
  props: {
    title: {},
    subtitle: { default: void 0 }
  },
  setup(e) {
    const t = ht();
    return (n, r) => (c(), p("div", N8, [
      g("div", V8, [
        g("h1", F8, $(e.title), 1),
        e.subtitle ? (c(), p("p", H8, $(e.subtitle), 1)) : w("", !0)
      ]),
      T(t)("actions") ? (c(), p("div", W8, [
        be(n.$slots, "actions")
      ])) : w("", !0)
    ]));
  }
}), j8 = {
  key: 0,
  class: "flex"
}, U8 = { class: "flex flex-wrap md:flex-nowrap items-start gap-2" }, G8 = { class: "flex-1" }, q8 = { class: "leading-8.5 text-[1.75rem] font-bold mb-1" }, K8 = {
  key: 0,
  class: "flex gap-1.5"
}, J8 = {
  key: 1,
  class: "flex flex-wrap gap-4 w-full md:w-auto justify-end"
}, Z8 = {
  key: 1,
  class: "flex gap-1.5"
}, Y8 = {
  key: 1,
  class: "flex flex-wrap gap-4 py-4"
}, X8 = {
  key: 0,
  class: "self-center overflow-y-auto me-auto"
}, oF = /* @__PURE__ */ ge({
  __name: "DetailHeaderWrapper",
  props: {
    title: {}
  },
  setup(e) {
    const t = ur(), n = (r) => !!t[r];
    return (r, o) => (c(), p("header", null, [
      n("topbar") ? (c(), p("div", j8, [
        be(r.$slots, "topbar")
      ])) : w("", !0),
      g("div", U8, [
        n("avatar") ? be(r.$slots, "avatar", { key: 0 }) : w("", !0),
        g("div", G8, [
          g("h1", q8, $(e.title) + " ", 1),
          n("facets") ? (c(), p("div", K8, [
            be(r.$slots, "facets")
          ])) : w("", !0)
        ]),
        n("actions") || n("nav-actions") ? (c(), p("div", J8, [
          n("actions") ? be(r.$slots, "actions", { key: 0 }) : w("", !0),
          n("nav-actions") ? (c(), p("div", Z8, [
            be(r.$slots, "nav-actions")
          ])) : w("", !0)
        ])) : w("", !0)
      ]),
      n("tabs") || n("save") ? (c(), p("div", Y8, [
        n("tabs") ? (c(), p("div", X8, [
          be(r.$slots, "tabs")
        ])) : w("", !0),
        n("save") ? be(r.$slots, "save", { key: 1 }) : w("", !0)
      ])) : w("", !0)
    ]));
  }
}), aF = /* @__PURE__ */ ge({
  __name: "Masonry",
  props: {
    gapX: { default: 20 },
    gapY: { default: 20 },
    breakpoint: { default: 640 },
    useViewport: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ur(), r = N([]), o = N(null), a = N([]), l = N(0), s = N(2), i = y(
      () => {
        var x;
        return (((x = n.default) == null ? void 0 : x.call(n)) ?? []).filter(
          (k) => k.type !== Lf
        );
      }
    );
    function d() {
      const x = r.value;
      if (!x.length) return;
      const k = s.value, L = Array(k).fill(0), P = [];
      for (const E of x) {
        const O = L.indexOf(Math.min(...L));
        P.push({ col: O, top: L[O] }), L[O] += E.offsetHeight + t.gapY;
      }
      a.value = P, l.value = Math.max(...L) - t.gapY;
    }
    function u(x) {
      const k = a.value[x];
      if (!k) return { visibility: "hidden" };
      const L = s.value;
      if (L === 1)
        return { top: `${k.top}px`, left: "0", width: "100%" };
      const P = 100 / L, E = t.gapX * (L - 1) / L;
      return {
        top: `${k.top}px`,
        left: k.col === 0 ? "0" : `calc(${k.col * P}% + ${k.col * t.gapX / L}px)`,
        width: `calc(${P}% - ${E}px)`
      };
    }
    let f, h, b;
    function m() {
      b !== void 0 && cancelAnimationFrame(b), b = requestAnimationFrame(() => {
        b = void 0, d();
      });
    }
    function v(x) {
      s.value = x.matches ? 1 : 2, m();
    }
    return Qe(async () => {
      await Pe(), t.useViewport ? (h = window.matchMedia(`(max-width: ${t.breakpoint}px)`), s.value = h.matches ? 1 : 2, h.addEventListener("change", v), d(), f = new ResizeObserver(m), r.value.forEach((x) => f.observe(x))) : (f = new ResizeObserver(() => {
        var k;
        const x = ((k = o.value) == null ? void 0 : k.offsetWidth) ?? 0;
        s.value = x < t.breakpoint ? 1 : 2, m();
      }), r.value.forEach((x) => f.observe(x)), o.value && f.observe(o.value));
    }), nt(() => {
      b !== void 0 && cancelAnimationFrame(b), f == null || f.disconnect(), h == null || h.removeEventListener("change", v);
    }), (x, k) => (c(), p("div", {
      ref_key: "containerRef",
      ref: o,
      class: "relative w-full",
      style: Ae({ height: `${l.value}px` })
    }, [
      (c(!0), p(Z, null, ke(i.value, (L, P) => (c(), p("div", {
        key: P,
        ref_for: !0,
        ref_key: "itemRefs",
        ref: r,
        class: "absolute",
        style: Ae(u(P))
      }, [
        (c(), te(Wt(L)))
      ], 4))), 128))
    ], 4));
  }
}), Q8 = { class: "group-hover:underline" }, lF = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "InlineLink",
  props: {
    as: {},
    iconLeft: {}
  },
  setup(e) {
    return (t, n) => (c(), te(Wt(e.as), Je(t.$attrs, { class: "flex items-center px-3 py-2 gap-1.5 group leading-5 text-sm text-(--text-text-black-default)" }), {
      default: pe(() => [
        e.iconLeft ? (c(), p("i", {
          key: 0,
          class: S(["text-current", e.iconLeft])
        }, null, 2)) : w("", !0),
        g("span", Q8, [
          be(t.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), _8 = ["aria-labelledby", "aria-busy"], e9 = {
  key: 0,
  class: "flex flex-col space-y-5"
}, t9 = {
  key: 0,
  class: "flex items-center gap-2"
}, n9 = {
  key: 0,
  class: "flex items-center gap-2 shrink-0"
}, r9 = {
  key: 1,
  class: "flex-1 min-w-0 flex flex-col gap-2"
}, o9 = ["id"], a9 = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)",
  "data-testid": "widget-shell-subtitle"
}, l9 = {
  key: 2,
  class: "flex items-center gap-3 shrink-0 ms-auto",
  "data-testid": "widget-shell-actions"
}, s9 = {
  key: 0,
  class: "flex items-center gap-1.5"
}, i9 = {
  key: 1,
  class: "flex items-center gap-1.5"
}, d9 = {
  key: 0,
  class: "flex-1 min-w-0 leading-6.5 text-num-16 font-medium truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, u9 = {
  key: 1,
  class: "flex items-center ms-auto shrink-0"
}, c9 = {
  key: 1,
  "data-testid": "widget-shell-footer"
}, sF = /* @__PURE__ */ ge({
  __name: "WidgetShell",
  props: {
    header: {},
    subtitle: {},
    subheader: {},
    loading: { type: Boolean },
    flush: { type: Boolean },
    stretch: { type: Boolean },
    rounded: {},
    bordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = {
      xs: "rounded-(--border-border-radius-rounded-xs)",
      sm: "rounded-(--border-border-radius-rounded-sm)",
      m: "rounded-(--border-border-radius-rounded-l)",
      l: "rounded-(--border-border-radius-rounded-base)",
      xl: "rounded-(--border-border-radius-rounded-xl)",
      "2xl": "rounded-(--border-border-radius-rounded-xxl)"
    }, n = e, r = y(() => t[n.rounded ?? "m"]), o = Ke(), a = ad(), l = y(
      () => !n.flush && n.header && !a["aria-label"] ? o : void 0
    ), s = ht(), i = y(
      () => !!(n.header || n.subtitle || n.subheader) || s("before-actions") || s("actions") || s("nav-actions") || s("sub-info") || s("sub-actions")
    );
    return (d, u) => (c(), p("section", {
      "aria-labelledby": l.value,
      "aria-busy": e.loading || void 0,
      "data-testid": "widget-shell",
      class: S([
        r.value,
        e.bordered !== !1 ? "border border-(--border-border-base-soft) bg-(--colors-background-white) shadow-(--blur-shadow-s) break-inside-avoid" : void 0,
        e.bordered !== !1 ? "dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-[0px_0px_4px_rgba(255,255,255,0.1)]" : void 0,
        e.flush ? "overflow-hidden" : "p-6 space-y-6",
        e.stretch ? "flex flex-col flex-1" : "inline-block w-full"
      ])
    }, [
      e.flush ? be(d.$slots, "default", { key: 0 }) : (c(), p(Z, { key: 1 }, [
        i.value ? (c(), p("div", e9, [
          e.header || e.subtitle || T(s)("before-actions") || T(s)("actions") || T(s)("nav-actions") ? (c(), p("div", t9, [
            T(s)("before-actions") ? (c(), p("div", n9, [
              be(d.$slots, "before-actions")
            ])) : w("", !0),
            e.header || e.subtitle ? (c(), p("div", r9, [
              e.header ? (c(), p("h2", {
                key: 0,
                id: T(o),
                class: "min-w-0 leading-6.5 text-[1.375rem] font-bold truncate text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
              }, $(e.header), 9, o9)) : w("", !0),
              e.subtitle ? (c(), p("p", a9, $(e.subtitle), 1)) : w("", !0)
            ])) : w("", !0),
            T(s)("actions") || T(s)("nav-actions") ? (c(), p("div", l9, [
              be(d.$slots, "actions"),
              T(s)("nav-actions") ? (c(), p("div", s9, [
                be(d.$slots, "nav-actions")
              ])) : w("", !0)
            ])) : w("", !0)
          ])) : w("", !0),
          e.subheader || T(s)("sub-info") || T(s)("sub-actions") ? (c(), p("div", i9, [
            e.subheader ? (c(), p("h3", d9, $(e.subheader), 1)) : w("", !0),
            be(d.$slots, "sub-info"),
            T(s)("sub-actions") ? (c(), p("div", u9, [
              be(d.$slots, "sub-actions")
            ])) : w("", !0)
          ])) : w("", !0)
        ])) : w("", !0),
        g("div", {
          class: S(e.stretch ? "flex-1 flex flex-col" : "")
        }, [
          be(d.$slots, "default")
        ], 2),
        T(s)("footer") ? (c(), p("div", c9, [
          be(d.$slots, "footer")
        ])) : w("", !0)
      ], 64))
    ], 10, _8));
  }
}), f9 = { class: "flex flex-col min-h-0 h-full rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-medium) bg-white shadow-[0px_0px_4px_rgba(0,0,0,0.1)] overflow-hidden" }, iF = /* @__PURE__ */ ge({
  __name: "WidgetBlock",
  props: {
    headerBordered: { type: Boolean, default: !0 },
    footerBordered: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = ht();
    return (n, r) => (c(), p("div", f9, [
      T(t)("header") ? (c(), p("div", {
        key: 0,
        "data-testid": "widget-block-header",
        class: S(["sticky top-0 z-10 bg-white px-6 py-5", e.headerBordered ? "border-b border-(--border-border-base-soft)" : ""])
      }, [
        be(n.$slots, "header")
      ], 2)) : w("", !0),
      g("div", {
        "data-testid": "widget-block-main",
        class: S([
          "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-6 pb-6",
          T(t)("header") && !e.headerBordered ? "pt-0" : "pt-6"
        ])
      }, [
        be(n.$slots, "default")
      ], 2),
      T(t)("footer") ? (c(), p("div", {
        key: 1,
        "data-testid": "widget-block-footer",
        class: S(["px-6 py-4", e.footerBordered ? "border-t border-(--border-border-base-soft)" : ""])
      }, [
        be(n.$slots, "footer")
      ], 2)) : w("", !0)
    ]));
  }
}), h9 = {
  key: 0,
  class: "flex flex-col gap-1",
  "data-testid": "widget-section-header"
}, b9 = {
  key: 0,
  class: "text-lg font-semibold text-(--colors-text-black-default) m-0"
}, p9 = {
  key: 0,
  class: "text-sm text-(--text-text-body) m-0"
}, dF = /* @__PURE__ */ ge({
  __name: "WidgetSection",
  props: {
    title: {},
    subtitle: {},
    bordered: { type: Boolean, default: !0 },
    padded: { type: Boolean, default: !0 },
    gap: { default: "md" }
  },
  setup(e) {
    const t = e, n = ht(), r = y(
      () => !!t.title || !!t.subtitle || n("title") || n("subtitle")
    ), o = y(
      () => ({ sm: "gap-3", md: "gap-4", lg: "gap-5" })[t.gap]
    );
    return (a, l) => (c(), p("section", {
      class: S([
        "flex flex-col",
        o.value,
        e.bordered && "rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft)",
        e.padded && "p-6"
      ]),
      "data-testid": "widget-section"
    }, [
      r.value ? (c(), p("header", h9, [
        be(a.$slots, "title", {}, () => [
          e.title ? (c(), p("h3", b9, $(e.title), 1)) : w("", !0)
        ]),
        be(a.$slots, "subtitle", {}, () => [
          e.subtitle ? (c(), p("p", p9, $(e.subtitle), 1)) : w("", !0)
        ])
      ])) : w("", !0),
      be(a.$slots, "default")
    ], 2));
  }
}), g9 = {
  "data-testid": "cta-widget",
  class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 rounded-(--border-border-radius-rounded-l) border border-(--border-border-base-soft) shadow-[0px_0px_4px_rgba(0,0,0,0.1)] bg-white p-6",
  style: { "background-image": "var(--gradient-cta-widget)" }
}, m9 = { class: "flex flex-col gap-1.5 min-w-0" }, v9 = { class: "flex items-center gap-1.5" }, x9 = { class: "text-(length:--size-l) leading-(--line-height-l) font-(--weight-bold) text-(--text-text-black-default)" }, y9 = { class: "text-(length:--size-sm) leading-(--line-height-l) font-(--weight-regular) text-(--text-text-heading)" }, k9 = { class: "flex flex-col items-stretch sm:items-center sm:shrink-0" }, uF = /* @__PURE__ */ ge({
  __name: "CtaWidget",
  props: {
    title: { default: "" },
    titleIcon: { default: void 0 },
    description: { default: "" },
    ctaLabel: { default: "" },
    ctaIcon: { default: "ri-add-line" },
    ctaDisabled: { type: Boolean, default: !1 }
  },
  emits: ["cta-click"],
  setup(e, { emit: t }) {
    const n = t;
    return (r, o) => (c(), p("div", g9, [
      g("div", m9, [
        g("div", v9, [
          e.titleIcon ? (c(), p("i", {
            key: 0,
            class: S([e.titleIcon, "text-(length:--size-l) text-(--text-text-black-default)"]),
            "aria-hidden": "true"
          }, null, 2)) : w("", !0),
          g("p", x9, [
            be(r.$slots, "title", {}, () => [
              Ze($(e.title), 1)
            ])
          ])
        ]),
        g("p", y9, [
          be(r.$slots, "description", {}, () => [
            Ze($(e.description), 1)
          ])
        ])
      ]),
      g("div", k9, [
        be(r.$slots, "actions", {}, () => [
          e.ctaLabel ? (c(), te($e, {
            key: 0,
            variant: "primary",
            size: "xl",
            "icon-left": e.ctaIcon,
            label: e.ctaLabel,
            disabled: e.ctaDisabled,
            onClick: o[0] || (o[0] = (a) => n("cta-click", a))
          }, null, 8, ["icon-left", "label", "disabled"])) : w("", !0)
        ])
      ])
    ]));
  }
}), w9 = ["aria-describedby", "aria-haspopup", "aria-expanded", "aria-controls"], C9 = ["id", "role", "aria-label"], S9 = { class: "popover-inner" }, $9 = {
  key: 0,
  class: "popover-header px-3 py-1.5 text-sm font-medium"
}, I9 = { class: "popover-body p-3 text-sm" }, T9 = /* @__PURE__ */ ge({
  inheritAttrs: !1,
  __name: "Popover",
  props: {
    position: { default: "bottom" },
    delay: { default: 400 },
    disabled: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    accessibleName: { default: void 0 }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = ht(), a = y(() => o("header")), l = a, s = y(
      () => a.value && n.position === "bottom" ? "var(--colors-background-white-secondary)" : "var(--colors-white-50-opacity-bold)"
    ), i = Ke(), d = N(null), u = N(null), f = N(!1), h = y(() => n.open !== void 0), b = y(() => h.value ? n.open === !0 : f.value);
    let m = null, v = null, x = null;
    we(b, async (F) => {
      F ? (await Pe(), d.value && u.value && (m = vo(d.value, u.value, {
        placement: n.position,
        modifiers: [
          { name: "offset", options: { offset: [0, 10] } },
          // Targeted by class, NOT by the conventional `[data-popper-arrow]` attribute: Flowbite
          // ships global `@layer base` rules on that exact attribute selector — an 8×8 `::before`
          // with `transform: rotate(45deg)`, plus a 9×9 `::after` — which fight our 40×10 DS
          // caret and would rotate its clip-path triangle. Dropping the attribute removes the
          // whole conflict instead of out-specifying it declaration by declaration.
          { name: "arrow", options: { element: ".popover-arrow", padding: 12 } },
          { name: "flip" },
          { name: "preventOverflow", options: { padding: 8 } }
        ]
      }))) : (m == null || m.destroy(), m = null);
    });
    const k = () => {
      v && (clearTimeout(v), v = null);
    }, L = () => {
      x && (clearTimeout(x), x = null);
    }, P = () => {
      if (h.value) {
        r("update:open", !1);
        return;
      }
      f.value = !1;
    }, E = () => {
      n.disabled || h.value || (L(), !v && (v = setTimeout(() => {
        f.value = !0, v = null;
      }, n.delay)));
    }, O = () => {
      h.value || (k(), x = setTimeout(P, 100));
    }, R = (F) => {
      var A;
      (A = u.value) != null && A.contains(F.relatedTarget) || O();
    }, V = (F) => {
      h.value || !b.value || (F.stopPropagation(), F.preventDefault(), P());
    }, J = (F) => {
      F.key === "Escape" && V(F);
    };
    return Bt(() => {
      k(), L(), m == null || m.destroy();
    }), (F, A) => (c(), p(Z, null, [
      g("div", Je({
        ref_key: "triggerRef",
        ref: d,
        class: "inline-flex"
      }, F.$attrs, {
        "aria-describedby": !T(l) && b.value ? T(i) : void 0,
        "aria-haspopup": T(l) ? "dialog" : void 0,
        "aria-expanded": T(l) ? b.value : void 0,
        "aria-controls": T(l) && b.value ? T(i) : void 0,
        onMouseenter: E,
        onMouseleave: O,
        onFocusin: E,
        onFocusout: R,
        onKeydown: je(V, ["escape"])
      }), [
        be(F.$slots, "trigger", {}, void 0, !0)
      ], 16, w9),
      (c(), te(cn, { to: "body" }, [
        ae(ot, { name: "popover" }, {
          default: pe(() => [
            b.value ? (c(), p("div", {
              key: 0,
              id: T(i),
              ref_key: "bubbleRef",
              ref: u,
              role: T(l) ? "dialog" : "tooltip",
              "aria-label": n.accessibleName,
              class: "popover absolute z-9999",
              "data-focus-trap-allow-outside": "",
              onMouseenter: L,
              onMouseleave: O,
              onKeydown: J
            }, [
              g("div", S9, [
                a.value ? (c(), p("div", $9, [
                  be(F.$slots, "header", {}, void 0, !0)
                ])) : w("", !0),
                g("div", I9, [
                  be(F.$slots, "default", {}, void 0, !0)
                ])
              ]),
              g("div", {
                class: "popover-arrow",
                "aria-hidden": "true",
                style: Ae({ "--arrow-bg": s.value })
              }, null, 4)
            ], 40, C9)) : w("", !0)
          ]),
          _: 3
        })
      ]))
    ], 64));
  }
}), cF = /* @__PURE__ */ He(T9, [["__scopeId", "data-v-2c7af1cb"]]), L9 = ["aria-expanded", "aria-controls", "disabled"], M9 = { class: "flex-shrink-0" }, E9 = {
  key: 0,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-[#009966] border border-gray-200",
  "data-testid": "collapsible-section-validated"
}, A9 = {
  key: 1,
  class: "flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 dark:bg-[rgba(255,255,255,0.08)]"
}, D9 = { class: "flex-1 min-w-0" }, R9 = { class: "text-base font-semibold text-text-black-default dark:text-(--colors-text-white-default)" }, B9 = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-(--colors-text-white-secondary) mt-0.5 truncate"
}, O9 = { class: "flex-shrink-0" }, P9 = ["id", "inert", "aria-hidden"], z9 = { class: "px-14 py-5" }, N9 = ["disabled"], V9 = {
  key: 0,
  class: "ri-loader-4-line animate-spin text-sm"
}, F9 = {
  key: 1,
  class: "ri-check-line text-sm"
}, H9 = ["disabled"], W9 = /* @__PURE__ */ ge({
  __name: "CollapsibleSection",
  props: {
    title: {},
    subtitle: { default: void 0 },
    icon: { default: void 0 },
    expanded: { type: Boolean, default: !1 },
    validated: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showActions: { type: Boolean, default: !0 },
    validateDisabled: { type: Boolean, default: !1 },
    cancelDisabled: { type: Boolean, default: !1 },
    validateLoading: { type: Boolean, default: !1 },
    warning: { default: void 0 },
    validateLabel: { default: "Validate" },
    cancelLabel: { default: "Cancel" },
    actionsAlignment: { default: "start" }
  },
  emits: ["update:expanded", "validate", "cancel"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(!1), a = N(null), l = N(null), s = N(null), i = N(null), d = () => {
      var x, k;
      (x = l.value) == null || x.focus(), document.activeElement !== l.value && ((k = a.value) == null || k.focus());
    };
    we(
      () => n.expanded,
      (x) => {
        var k;
        x || (o.value = !1, (k = s.value) != null && k.contains(document.activeElement) && d());
      }
    ), we(
      () => n.validateDisabled || n.validateLoading,
      (x) => {
        x && i.value && document.activeElement === i.value && d();
      }
    );
    const u = (x) => {
      x.propertyName === "max-height" && n.expanded && (o.value = !0);
    }, f = Ke(), h = y(() => `${f}-content`), b = () => {
      n.disabled || r("update:expanded", !n.expanded);
    }, m = () => {
      r("validate");
    }, v = () => {
      r("cancel");
    };
    return (x, k) => (c(), p("div", {
      ref_key: "rootRef",
      ref: a,
      class: S(["rounded-xl border border-solid border-lightgray dark:border-(--colors-border-base) bg-white dark:bg-(--colors-background-black-default) overflow-hidden", { "opacity-60 cursor-not-allowed": e.disabled }]),
      "data-testid": "collapsible-section",
      tabindex: "-1"
    }, [
      g("button", {
        ref_key: "headerRef",
        ref: l,
        type: "button",
        class: S(["flex w-full items-center gap-6 px-6 py-5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--border-border-hover)", [
          e.expanded ? "bg-gray-50 dark:bg-[rgba(255,255,255,0.03)]" : "",
          e.disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.03)]"
        ]]),
        "aria-expanded": e.expanded,
        "aria-controls": h.value,
        disabled: e.disabled,
        "data-testid": "collapsible-section-header",
        onClick: b
      }, [
        g("div", M9, [
          e.validated ? (c(), p("div", E9, [...k[0] || (k[0] = [
            g("i", { class: "ri-check-fill text-white text-sm" }, null, -1)
          ])])) : e.icon ? (c(), p("div", A9, [
            g("i", {
              class: S([e.icon, "text-gray-500 dark:text-(--colors-text-white-secondary) text-base"])
            }, null, 2)
          ])) : w("", !0)
        ]),
        g("div", D9, [
          g("div", R9, $(e.title), 1),
          e.subtitle ? (c(), p("div", B9, $(e.subtitle), 1)) : w("", !0)
        ]),
        g("div", O9, [
          g("i", {
            class: S(["text-xl text-gray-400 dark:text-(--colors-text-white-secondary) transition-transform duration-200", e.expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"])
          }, null, 2)
        ])
      ], 10, L9),
      g("div", {
        id: h.value,
        ref_key: "contentRef",
        ref: s,
        class: S(["collapsible-content", {
          "collapsible-content--expanded": e.expanded,
          "collapsible-content--open": o.value
        }]),
        role: "region",
        inert: !e.expanded || void 0,
        "aria-hidden": !e.expanded,
        onTransitionend: u
      }, [
        g("div", z9, [
          be(x.$slots, "default", {}, void 0, !0),
          e.showActions ? (c(), p("div", {
            key: 0,
            class: S(["flex items-center gap-3 mt-4", e.actionsAlignment === "end" ? "flex-row-reverse" : ""])
          }, [
            be(x.$slots, "actions", {
              validate: m,
              cancel: v
            }, () => [
              g("button", {
                ref_key: "validateRef",
                ref: i,
                type: "button",
                class: S([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-white border border-[#6a7282] transition-colors",
                  e.validateDisabled || e.validateLoading ? "bg-[#242424] opacity-50 cursor-not-allowed" : "bg-[#242424] hover:bg-[#3a3a3a] cursor-pointer"
                ]),
                disabled: e.validateDisabled || e.validateLoading,
                "data-testid": "collapsible-section-validate",
                onClick: Ie(m, ["stop"])
              }, [
                e.validateLoading ? (c(), p("i", V9)) : (c(), p("i", F9)),
                Ze(" " + $(e.validateLabel), 1)
              ], 10, N9),
              g("button", {
                type: "button",
                class: S([
                  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium text-text-black-default dark:text-(--colors-text-white-default) bg-white dark:bg-(--colors-background-black-default) border border-solid border-[#919191] dark:border-(--colors-border-base) transition-colors",
                  e.cancelDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50 dark:hover:bg-[rgba(255,255,255,0.05)] cursor-pointer"
                ]),
                disabled: e.cancelDisabled,
                "data-testid": "collapsible-section-cancel",
                onClick: Ie(v, ["stop"])
              }, $(e.cancelLabel), 11, H9)
            ], !0)
          ], 2)) : w("", !0),
          e.warning ? (c(), te(T(as), {
            key: 1,
            color: "danger",
            heading: e.warning,
            class: "mt-4",
            "data-testid": "collapsible-section-warning"
          }, null, 8, ["heading"])) : w("", !0)
        ])
      ], 42, P9)
    ], 2));
  }
}), fF = /* @__PURE__ */ He(W9, [["__scopeId", "data-v-fb7f3a92"]]), j9 = ["aria-label"], U9 = { class: "flex w-full flex-col items-center gap-5" }, G9 = { class: "flex w-full flex-col items-center gap-3.5" }, q9 = {
  key: 0,
  class: "max-w-full truncate rounded border border-(--colors-border-base-soft) bg-white px-1 py-0.5 text-xs font-medium leading-5 text-(--colors-text-black-default) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)"
}, K9 = { class: "flex w-full flex-col items-center gap-2.5 text-center" }, J9 = { class: "min-h-[48px] w-full text-xl font-bold leading-6 text-(--colors-text-heading) line-clamp-2 dark:text-(--colors-text-white-default)" }, Z9 = { class: "min-h-[20px] w-full truncate text-sm leading-5 text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)" }, hF = /* @__PURE__ */ ge({
  __name: "ProfileCard",
  props: {
    name: { default: void 0 },
    role: { default: void 0 },
    email: { default: void 0 },
    avatarUrl: { default: void 0 },
    buttonLabel: { default: void 0 },
    loading: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    return (t, n) => (c(), p("article", {
      class: "flex w-full flex-col items-center gap-6",
      "aria-label": e.name
    }, [
      e.loading ? (c(), p(Z, { key: 0 }, [
        n[1] || (n[1] = mo('<div class="h-16 w-16 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-5"><div class="flex w-full flex-col items-center gap-3.5"><div class="h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="flex w-full flex-col items-center gap-2"><div class="h-6 w-4/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div><div class="h-5 w-3/5 animate-pulse rounded bg-(--colors-border-base-soft)"></div></div></div><div class="h-7 w-32 animate-pulse rounded-full bg-(--colors-border-base-soft)"></div></div>', 2))
      ], 64)) : (c(), p(Z, { key: 1 }, [
        ae(Cn, {
          name: e.name ?? "",
          img: e.avatarUrl,
          size: "2xl",
          "avatar-style": "square"
        }, null, 8, ["name", "img"]),
        g("div", U9, [
          g("div", G9, [
            e.role ? (c(), p("span", q9, $(e.role), 1)) : w("", !0),
            g("div", K9, [
              g("p", J9, $(e.name), 1),
              g("p", Z9, $(e.email), 1)
            ])
          ]),
          ae($e, {
            variant: "secondary",
            size: "xs",
            label: e.buttonLabel,
            "icon-right": "ri-external-link-line",
            "aria-label": `${e.buttonLabel}: ${e.name}`,
            onClick: n[0] || (n[0] = (r) => t.$emit("click"))
          }, null, 8, ["label", "aria-label"])
        ])
      ], 64))
    ], 8, j9));
  }
}), Y9 = ["aria-label"], X9 = { class: "flex w-full items-center" }, Q9 = ["aria-label"], _9 = { class: "px-5 flex justify-center w-full" }, ez = { class: "flex w-full items-center" }, tz = { class: "flex flex-col items-center gap-0.5 text-center w-full px-5" }, nz = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, rz = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, oz = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, az = ["aria-label"], lz = { class: "flex flex-col items-center" }, sz = ["aria-label"], iz = { class: "flex flex-col items-center" }, dz = { class: "flex flex-col gap-1 pb-8 pt-0.5" }, uz = { class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)" }, cz = {
  key: 0,
  class: "text-lg font-semibold leading-[22px] text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
}, fz = {
  key: 1,
  class: "text-base leading-6 text-(--colors-text-body) dark:text-(--colors-text-white-secondary)"
}, bF = /* @__PURE__ */ ge({
  __name: "Timeline",
  props: {
    items: { default: () => [] },
    orientation: { default: "auto" },
    ariaLabel: { default: "Timeline" },
    loading: { type: Boolean, default: !1 },
    loadingCount: { default: 3 },
    itemMinWidth: { default: "160px" },
    showItemIcons: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = g8("(min-width: 768px)"), r = [
      "green",
      "violet",
      "yellow",
      "indigo",
      "cyan",
      "orange",
      "red",
      "purple",
      "grey"
    ], o = (s, i) => s.badgeTheme ?? r[i % r.length], a = y(() => t.orientation === "horizontal" ? !0 : t.orientation === "vertical" ? !1 : n.value), l = y(() => Array.from({ length: t.loadingCount }));
    return (s, i) => a.value ? (c(), p("ol", {
      key: 0,
      "aria-label": e.ariaLabel,
      class: "flex w-full items-start overflow-x-auto pb-3"
    }, [
      e.loading ? (c(!0), p(Z, { key: 0 }, ke(l.value, (d, u) => (c(), p("li", {
        key: u,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ae({ minWidth: e.itemMinWidth })
      }, [
        i[1] || (i[1] = g("div", { class: "px-5 flex justify-center w-full" }, [
          g("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1)),
        g("div", X9, [
          g("div", {
            class: S(["flex-1 h-px", u === 0 ? "invisible" : "bg-(--colors-border-base-soft)"])
          }, null, 2),
          i[0] || (i[0] = g("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          g("div", {
            class: S([
              "flex-1 h-px",
              u === l.value.length - 1 ? "invisible" : "bg-(--colors-border-base-soft)"
            ])
          }, null, 2)
        ]),
        i[2] || (i[2] = g("div", { class: "flex flex-col items-center gap-2 w-full px-5" }, [
          g("div", { class: "h-5 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          g("div", { class: "h-4 w-20 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ], 4))), 128)) : (c(!0), p(Z, { key: 1 }, ke(e.items, (d, u) => (c(), p("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-1 flex-col items-center gap-4",
        style: Ae({ minWidth: e.itemMinWidth })
      }, [
        g("div", _9, [
          ae(pt, {
            label: d.date,
            theme: o(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "whitespace-nowrap"
          }, zn({ _: 2 }, [
            e.showItemIcons ? {
              name: "left-icon",
              fn: pe(() => [
                g("i", {
                  class: S([d.icon ?? "ri-calendar-line", "text-[12px] leading-none"])
                }, null, 2)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["label", "theme", "show-left-icon"])
        ]),
        g("div", ez, [
          g("div", {
            class: S(["flex-1 h-px bg-(--colors-border-base-medium)", u === 0 ? "invisible" : ""])
          }, null, 2),
          i[3] || (i[3] = g("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          g("div", {
            class: S([
              "flex-1 h-px bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        g("div", tz, [
          g("p", nz, $(d.title), 1),
          d.subtitle ? (c(), p("p", rz, $(d.subtitle), 1)) : w("", !0),
          d.description ? (c(), p("p", oz, $(d.description), 1)) : w("", !0)
        ])
      ], 12, Q9))), 128))
    ], 8, Y9)) : (c(), p("ol", {
      key: 1,
      "aria-label": e.ariaLabel,
      class: "flex flex-col"
    }, [
      e.loading ? (c(!0), p(Z, { key: 0 }, ke(l.value, (d, u) => (c(), p("li", {
        key: u,
        class: "flex flex-row gap-4"
      }, [
        g("div", lz, [
          g("div", {
            class: S([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === 0 ? "invisible" : "animate-pulse"
            ])
          }, null, 2),
          i[4] || (i[4] = g("div", { class: "h-3 w-3 shrink-0 animate-pulse rounded-full bg-(--colors-border-base-soft)" }, null, -1)),
          g("div", {
            class: S([
              "w-px flex-1 bg-(--colors-border-base-soft)",
              u === l.value.length - 1 ? "invisible" : "animate-pulse"
            ])
          }, null, 2)
        ]),
        i[5] || (i[5] = g("div", { class: "flex flex-col gap-2 pb-8 pt-0.5" }, [
          g("div", { class: "h-6 w-24 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          g("div", { class: "h-5 w-36 animate-pulse rounded bg-(--colors-border-base-soft)" }),
          g("div", { class: "h-4 w-28 animate-pulse rounded bg-(--colors-border-base-soft)" })
        ], -1))
      ]))), 128)) : (c(!0), p(Z, { key: 1 }, ke(e.items, (d, u) => (c(), p("li", {
        key: u,
        "aria-label": `${d.title}, ${d.date}`,
        class: "flex flex-row gap-4"
      }, [
        g("div", iz, [
          g("div", {
            class: S([
              "w-px h-[9px] shrink-0 bg-(--colors-border-base-medium)",
              u === 0 ? "invisible" : ""
            ])
          }, null, 2),
          i[6] || (i[6] = g("div", { class: "h-3 w-3 shrink-0 rounded-full border-2 border-white bg-(--icons-icon-disabled-light) dark:border-(--colors-border-base) z-10" }, null, -1)),
          g("div", {
            class: S([
              "w-px flex-1 bg-(--colors-border-base-medium)",
              u === e.items.length - 1 ? "invisible" : ""
            ])
          }, null, 2)
        ]),
        g("div", dz, [
          ae(pt, {
            label: d.date,
            theme: o(d, u),
            "show-close-icon": !1,
            "show-left-icon": e.showItemIcons,
            size: "sm",
            class: "self-start"
          }, zn({ _: 2 }, [
            e.showItemIcons ? {
              name: "left-icon",
              fn: pe(() => [
                g("i", {
                  class: S([d.icon ?? "ri-calendar-line", "text-[12px] leading-none"])
                }, null, 2)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["label", "theme", "show-left-icon"]),
          g("p", uz, $(d.title), 1),
          d.subtitle ? (c(), p("p", cz, $(d.subtitle), 1)) : w("", !0),
          d.description ? (c(), p("p", fz, $(d.description), 1)) : w("", !0)
        ])
      ], 8, sz))), 128))
    ], 8, az));
  }
}), hz = ["id", "data-testid", "aria-selected", "aria-disabled", "aria-controls", "tabindex", "onClick"], bz = {
  key: 0,
  class: "ri-lock-line",
  "aria-hidden": "true"
}, pF = /* @__PURE__ */ ge({
  __name: "NavTabs",
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t;
    function o(l) {
      l.locked || r("update:modelValue", l.key);
    }
    function a(l) {
      var f;
      const s = Array.from(
        l.currentTarget.querySelectorAll("[role=tab]")
      ), i = document.activeElement, d = i ? s.indexOf(i) : -1;
      let u = null;
      switch (l.key) {
        case "ArrowRight":
          u = d < 0 ? 0 : (d + 1) % s.length;
          break;
        case "ArrowLeft":
          u = d <= 0 ? s.length - 1 : d - 1;
          break;
        case "Home":
          u = 0;
          break;
        case "End":
          u = s.length - 1;
          break;
        case "Enter":
        case " ":
          if (i && i.getAttribute("aria-disabled") !== "true") {
            const h = n.tabs[d];
            h && r("update:modelValue", h.key);
          }
          l.preventDefault();
          return;
        default:
          return;
      }
      u !== null && (l.preventDefault(), (f = s[u]) == null || f.focus());
    }
    return (l, s) => (c(), p("div", {
      role: "tablist",
      "aria-orientation": "horizontal",
      class: "flex items-end gap-6 w-fit border-b border-(--border-border-base-soft)",
      onKeydown: a
    }, [
      (c(!0), p(Z, null, ke(e.tabs, (i) => (c(), te(Ye, {
        key: i.key,
        text: i.lockTooltip ?? "",
        disabled: !i.locked || !i.lockTooltip,
        position: "bottom"
      }, {
        default: pe(() => [
          g("button", {
            type: "button",
            role: "tab",
            id: i.id,
            "data-testid": `nav-tab-${i.key}`,
            "aria-selected": i.key === e.modelValue,
            "aria-disabled": i.locked ? "true" : void 0,
            "aria-controls": i.panelId,
            tabindex: i.key === e.modelValue ? 0 : -1,
            class: S([
              "inline-flex items-center gap-1.5 pt-3 pb-3.5 -mb-px border-b text-sm font-medium transition-colors",
              i.locked ? "border-transparent text-(--text-text-disabled-light) cursor-not-allowed" : i.key === e.modelValue ? "border-solid [border-image:var(--gradient-brand-horizontal)_1] text-(--text-text-accent)" : "border-transparent text-(--text-text-disabled-strong) hover:text-(--text-text-accent)"
            ]),
            onClick: (d) => o(i)
          }, [
            i.locked ? (c(), p("i", bz)) : i.icon ? (c(), p("i", {
              key: 1,
              class: S(i.icon),
              "aria-hidden": "true"
            }, null, 2)) : w("", !0),
            g("span", null, $(i.label), 1)
          ], 10, hz)
        ]),
        _: 2
      }, 1032, ["text", "disabled"]))), 128))
    ], 32));
  }
}), pz = ["data-testid", "aria-current", "aria-disabled", "onClick"], gz = ["data-testid", "aria-expanded", "aria-disabled", "onClick"], mz = { class: "flex items-center gap-1.5 truncate" }, vz = { class: "truncate" }, xz = ["data-testid", "aria-current", "aria-disabled", "onClick"], yz = { class: "pl-0.5" }, gF = /* @__PURE__ */ ge({
  __name: "StepperWizardSidenav",
  props: {
    groups: {},
    currentStepId: {},
    showStatusIcons: { type: Boolean },
    showPhaseIcons: { type: Boolean }
  },
  emits: ["step-click", "group-toggle"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = ro({});
    function a() {
      for (const b of n.groups)
        b.steps.length > 0 && (o[b.id] = b.defaultExpanded ?? !0);
    }
    a(), we(
      () => n.groups,
      (b) => {
        for (const m of b)
          m.steps.length > 0 && !(m.id in o) && (o[m.id] = m.defaultExpanded ?? !0);
      },
      { deep: !1 }
    );
    const l = y(() => {
      var b;
      if (n.currentStepId)
        return (b = n.groups.find(
          (m) => m.steps.some((v) => v.id === n.currentStepId)
        )) == null ? void 0 : b.id;
    });
    we(
      l,
      (b) => {
        b && (o[b] = !0);
      },
      { immediate: !0 }
    );
    function s(b, m) {
      return m != null && m.disabled ? "disabled" : b.id === n.currentStepId ? "current" : b.state ?? "upcoming";
    }
    function i(b) {
      return b.startsWith("ri-");
    }
    function d(b) {
      switch (b) {
        case "done":
          return "ri-checkbox-circle-fill";
        case "current":
          return "ri-checkbox-circle-line";
        case "disabled":
          return "ri-checkbox-blank-circle-line";
        case "upcoming":
        default:
          return "ri-checkbox-blank-circle-line";
      }
    }
    function u(b) {
      r("step-click", b);
    }
    function f(b) {
      if (l.value === b) return;
      const m = !o[b];
      o[b] = m, r("group-toggle", b, m);
    }
    function h(b, m) {
      m != null && m.disabled || b.state !== "disabled" && (b.id, n.currentStepId, r("step-click", b.id));
    }
    return (b, m) => (c(), p("nav", {
      role: "navigation",
      class: S(["flex flex-col gap-5 py-5 w-full min-w-72", b.$attrs.class])
    }, [
      (c(!0), p(Z, null, ke(e.groups, (v) => (c(), p("div", {
        key: v.id,
        class: "flex flex-col gap-0.5 pr-1.5"
      }, [
        v.steps.length === 0 ? (c(), te(Ye, {
          key: 0,
          class: "w-full",
          text: v.lockTooltip ?? "",
          disabled: !v.disabled || !v.lockTooltip,
          position: "bottom"
        }, {
          default: pe(() => [
            g("button", {
              type: "button",
              "data-testid": `sw-step-${v.id}`,
              "aria-current": v.id === e.currentStepId ? "step" : void 0,
              "aria-disabled": v.disabled ? "true" : void 0,
              class: S([
                "flex items-center h-9 py-3.5 px-1.5 rounded-(--border-border-radius-rounded-base)",
                "text-base font-medium leading-6 w-full text-left gap-1.5",
                v.disabled ? "text-(--text-text-disabled-light) cursor-not-allowed" : [
                  "hover:bg-(--background-background-selected) transition-colors",
                  v.id === e.currentStepId ? "text-(--text-text-accent)" : "text-(--text-text-body)"
                ]
              ]),
              onClick: (x) => !v.disabled && u(v.id)
            }, [
              e.showPhaseIcons && v.icon ? (c(), p(Z, { key: 0 }, [
                i(v.icon) ? (c(), p("i", {
                  key: 0,
                  class: S([v.icon, "text-xl shrink-0", v.disabled ? "opacity-50" : ""]),
                  "aria-hidden": "true"
                }, null, 2)) : (c(), p("span", {
                  key: 1,
                  class: S(["text-xl leading-none shrink-0", v.disabled ? "opacity-50" : ""]),
                  "aria-hidden": "true"
                }, $(v.icon), 3))
              ], 64)) : w("", !0),
              g("span", null, $(v.label), 1)
            ], 10, pz)
          ]),
          _: 2
        }, 1032, ["text", "disabled"])) : (c(), p(Z, { key: 1 }, [
          ae(Ye, {
            class: "w-full",
            text: v.lockTooltip ?? "",
            disabled: !v.disabled || !v.lockTooltip,
            position: "bottom"
          }, {
            default: pe(() => [
              g("button", {
                type: "button",
                "data-testid": `sw-group-${v.id}`,
                "aria-expanded": o[v.id],
                "aria-disabled": v.disabled ? "true" : void 0,
                class: S([
                  "flex items-center justify-between h-9 py-3.5 px-1.5 rounded-(--border-border-radius-rounded-base)",
                  "text-base font-medium leading-6 w-full text-left gap-1.5",
                  v.disabled ? "text-(--text-text-disabled-light) cursor-not-allowed" : "text-(--text-text-body) hover:bg-(--background-background-selected) transition-colors"
                ]),
                onClick: (x) => !v.disabled && f(v.id)
              }, [
                g("span", mz, [
                  e.showPhaseIcons && v.icon ? (c(), p(Z, { key: 0 }, [
                    i(v.icon) ? (c(), p("i", {
                      key: 0,
                      class: S([v.icon, "text-xl shrink-0", v.disabled ? "opacity-50" : ""]),
                      "aria-hidden": "true"
                    }, null, 2)) : (c(), p("span", {
                      key: 1,
                      class: S(["text-xl leading-none shrink-0", v.disabled ? "opacity-50" : ""]),
                      "aria-hidden": "true"
                    }, $(v.icon), 3))
                  ], 64)) : w("", !0),
                  g("span", vz, $(v.label), 1)
                ]),
                g("i", {
                  class: S([
                    "ri-arrow-down-s-line text-base shrink-0 transition-transform",
                    o[v.id] ? "-rotate-180" : ""
                  ]),
                  "aria-hidden": "true"
                }, null, 2)
              ], 10, gz)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]),
          o[v.id] ? (c(!0), p(Z, { key: 0 }, ke(v.steps, (x) => (c(), te(Ye, {
            key: x.id,
            class: "w-full",
            text: x.lockTooltip ?? "",
            disabled: s(x, v) !== "disabled" || !x.lockTooltip,
            position: "bottom"
          }, {
            default: pe(() => [
              g("button", {
                type: "button",
                "data-testid": `sw-step-${x.id}`,
                "aria-current": s(x, v) === "current" ? "step" : void 0,
                "aria-disabled": s(x, v) === "disabled" ? "true" : void 0,
                class: S([
                  "flex items-center h-9 py-3.5 px-1.5 rounded-(--border-border-radius-rounded-base)",
                  "text-base font-medium leading-6 w-full text-left gap-1.5 pl-3",
                  s(x, v) === "disabled" ? "text-(--text-text-disabled-strong) cursor-not-allowed" : "hover:bg-(--background-background-selected) transition-colors",
                  s(x, v) === "current" ? "text-(--text-text-accent)" : s(x, v) === "disabled" ? "text-(--text-text-disabled-strong)" : "text-(--text-text-body)"
                ]),
                onClick: (k) => h(x, v)
              }, [
                e.showStatusIcons ? (c(), p("i", {
                  key: 0,
                  class: S([d(s(x, v)), "text-xl shrink-0"]),
                  "aria-hidden": "true"
                }, null, 2)) : w("", !0),
                g("span", yz, $(x.label), 1)
              ], 10, xz)
            ]),
            _: 2
          }, 1032, ["text", "disabled"]))), 128)) : w("", !0)
        ], 64))
      ]))), 128))
    ], 2));
  }
}), kz = {
  "data-testid": "segmented-pager",
  role: "group",
  class: "inline-flex items-center shadow-(--blur-shadow-xs)"
}, wz = ["disabled"], Cz = ["disabled"], kf = "relative inline-flex h-10 items-center justify-center gap-1.5 border border-solid px-4 py-2.5 text-sm font-medium leading-5 transition-colors bg-white border-gray-200 text-gray-300 cursor-pointer enabled:z-10 hover:enabled:z-20 hover:enabled:border-royalblue focus:outline-none focus-visible:z-20 focus-visible:border-royalblue disabled:cursor-not-allowed disabled:bg-background-disabled disabled:border-lightgray disabled:text-darkgray", mF = /* @__PURE__ */ ge({
  __name: "SegmentedPager",
  props: {
    prevLabel: {},
    nextLabel: {},
    prevDisabled: { type: Boolean, default: !1 },
    nextDisabled: { type: Boolean, default: !1 }
  },
  emits: ["prev", "next"],
  setup(e, { emit: t }) {
    const n = t;
    return (r, o) => (c(), p("div", kz, [
      g("button", {
        type: "button",
        "data-testid": "segmented-pager-prev",
        disabled: e.prevDisabled,
        class: S([kf, "rounded-l-full -mr-px"]),
        onClick: o[0] || (o[0] = (a) => n("prev"))
      }, [
        o[2] || (o[2] = g("i", {
          class: "ri-arrow-left-s-line text-base leading-none",
          "aria-hidden": "true"
        }, null, -1)),
        g("span", null, $(e.prevLabel), 1)
      ], 10, wz),
      g("button", {
        type: "button",
        "data-testid": "segmented-pager-next",
        disabled: e.nextDisabled,
        class: S([kf, "rounded-r-full"]),
        onClick: o[1] || (o[1] = (a) => n("next"))
      }, [
        g("span", null, $(e.nextLabel), 1),
        o[3] || (o[3] = g("i", {
          class: "ri-arrow-right-s-line text-base leading-none",
          "aria-hidden": "true"
        }, null, -1))
      ], 10, Cz)
    ]));
  }
}), Sz = {
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, $z = {
  key: 0,
  "data-testid": "actions-status",
  role: "status",
  "aria-live": "polite",
  class: "sr-only"
}, Iz = ["aria-label"], Tz = { class: "inline-flex items-center gap-3.5 shrink-0 ml-[50px]" }, Lz = {
  key: 0,
  "data-testid": "actions-loading",
  class: "flex items-center gap-2 px-2 shrink-0",
  "aria-hidden": "true"
}, Mz = ["inert"], Ez = { class: "hidden sm:inline" }, ci = 640, wf = 560, Az = 960, fi = 20, Dz = "__untagged__", Rz = /* @__PURE__ */ ge({
  __name: "FloatActionBar",
  props: {
    selectionCount: {},
    allPagesSelected: { type: Boolean },
    totalAcrossAllPages: {},
    actions: {},
    maxVisibleActions: { default: 4 },
    isLoading: { type: Boolean, default: !1 },
    actionsLoading: { type: Boolean, default: !1 },
    actionsError: { type: Boolean, default: !1 },
    moduleLabels: { default: void 0 },
    ariaLabel: {},
    selectedItemLabel: {},
    selectedItemsLabel: {},
    selectAllPagesLabel: {},
    moreLabel: {},
    moreActionsTitle: {},
    totalUnavailableLabel: {},
    selectionClearedLabel: {},
    actionsLoadingLabel: { default: void 0 }
  },
  emits: ["dismiss", "action-click", "select-all-pages"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = {
      primary: "primary",
      secondary: "secondary",
      text: "tertiary",
      destructive: "error-text"
    };
    function a(ne) {
      return ne.variant ? o[ne.variant] : ne.destructive ? "error-text" : "tertiary";
    }
    function l(ne) {
      return ne.variant === "destructive" || ne.destructive === !0;
    }
    function s(ne) {
      return ne.disabled ? ne.disabledReason : void 0;
    }
    const i = y(() => n.actions.some((ne) => ne.order !== void 0) ? n.actions.map((ne, ye) => ({ action: ne, index: ye })).sort(
      (ne, ye) => (ne.action.order ?? Number.MAX_SAFE_INTEGER) - (ye.action.order ?? Number.MAX_SAFE_INTEGER) || ne.index - ye.index
    ).map((ne) => ne.action) : n.actions), d = y(
      () => n.actionsLoading || n.actionsError ? [] : i.value
    ), u = y(
      () => d.value.filter((ne) => ne.placement !== "overflow")
    ), f = N(typeof window < "u" ? window.innerWidth : 1024);
    function h() {
      f.value = window.innerWidth, C.value !== null && (C.value = re(C.value)), requestAnimationFrame(k);
    }
    Qe(() => window.addEventListener("resize", h)), nt(() => window.removeEventListener("resize", h));
    const b = N(null), m = N([]), v = N(n.actions.length);
    function x(ne) {
      return (ye) => {
        m.value[ne] = ye instanceof HTMLElement ? ye : null;
      };
    }
    function k() {
      const ne = b.value;
      if (!ne) {
        v.value = u.value.length;
        return;
      }
      const ye = ne.getBoundingClientRect().right, he = m.value.findIndex(
        (ie) => ie && ie.getBoundingClientRect().right > ye + 1
      );
      v.value = he === -1 ? u.value.length : he;
    }
    let L = null;
    we(
      b,
      (ne) => {
        L == null || L.disconnect(), ne && (L ?? (L = new ResizeObserver(() => requestAnimationFrame(k))), L.observe(ne), requestAnimationFrame(k));
      },
      { flush: "post", immediate: !0 }
    ), nt(() => L == null ? void 0 : L.disconnect());
    const P = y(
      () => u.value.map((ne) => `${ne.id}${ne.label}${ne.icon ?? ""}`).join("\0")
    );
    we(P, () => requestAnimationFrame(k));
    const E = y(() => f.value < ci ? 0 : Math.min(v.value, n.maxVisibleActions));
    function O(ne) {
      return ne >= n.maxVisibleActions || f.value < ci ? "hidden" : ne >= E.value ? "invisible" : "";
    }
    const R = y(() => {
      const ne = new Set(
        u.value.slice(0, E.value).map((ye) => ye.id)
      );
      return d.value.filter((ye) => !ne.has(ye.id));
    }), V = y(() => R.value.length > 0);
    we(
      () => R.value.length,
      (ne) => {
        ne > fi && console.warn(
          `[FloatActionBar] More menu has ${ne} actions; only the first ${fi} are rendered.`
        );
      },
      { immediate: !0 }
    );
    const J = y(
      () => R.value.slice(0, fi)
    );
    function F(ne) {
      return {
        label: ne.label,
        icon: ne.icon,
        danger: l(ne),
        disabled: ne.disabled || n.isLoading,
        loading: ne.loading,
        // Keeps the disabled reason keyboard-reachable inside the menu: DropdownItemButton
        // switches to aria-disabled (focusable) whenever an item carries a tooltip (R74).
        tooltip: s(ne),
        testId: "megamenu-nav-link",
        onClick: () => r("action-click", ne.id, U.value)
      };
    }
    const A = y(
      () => J.value.map(F)
    ), j = y(() => {
      const ne = [
        ...new Set(
          J.value.map((ie) => ie.module).filter((ie) => !!ie)
        )
      ], ye = J.value.filter((ie) => !ie.module);
      if (ne.length + (ye.length > 0 ? 1 : 0) < 2) return;
      const he = ne.map((ie) => {
        var me;
        return {
          key: ie,
          // No fallback to the raw key: it is an identifier, and rendering it would ship
          // untranslated text to fr/nl users (R29). A heading-less column is the safe default.
          label: (me = n.moduleLabels) == null ? void 0 : me[ie],
          items: J.value.filter((Q) => Q.module === ie).map(F)
        };
      });
      return ye.length > 0 && he.push({ key: Dz, items: ye.map(F) }), he;
    }), _ = y(() => {
      const ne = f.value < Az ? 2 : 4;
      return j.value ? ne : ne === 2 ? 2 : R.value.length > 10 ? 4 : 2;
    }), U = y(() => ({
      selectedCount: n.selectionCount,
      allPagesSelected: n.allPagesSelected,
      totalCount: n.totalAcrossAllPages
    })), W = y(
      () => n.allPagesSelected && n.totalAcrossAllPages !== void 0 ? n.totalAcrossAllPages : n.selectionCount
    ), K = y(
      () => W.value === 1 ? n.selectedItemLabel : n.selectedItemsLabel
    ), le = N(null), C = N(null), B = N(!1);
    let I = 0, M = 0;
    function D() {
      var ne;
      return ((ne = le.value) == null ? void 0 : ne.offsetWidth) ?? 0;
    }
    function re(ne) {
      return Math.max(16, Math.min(ne, window.innerWidth - D() - 16));
    }
    function se(ne) {
      le.value && (B.value = !0, I = ne.clientX, M = C.value ?? (window.innerWidth - D()) / 2, ne.preventDefault());
    }
    function de(ne) {
      B.value && (C.value = re(M + (ne.clientX - I)));
    }
    function fe() {
      B.value = !1;
    }
    Qe(() => {
      window.addEventListener("mousemove", de), window.addEventListener("mouseup", fe);
    }), nt(() => {
      window.removeEventListener("mousemove", de), window.removeEventListener("mouseup", fe);
    });
    const q = N(null), oe = N(null), ue = N([]);
    function G(ne) {
      return (ye) => {
        ue.value[ne] = ye ?? null;
      };
    }
    function H() {
      var ne;
      return (ne = oe.value) != null && ne.isVisible ? oe.value : ue.value.find((ye) => ye == null ? void 0 : ye.isVisible) ?? null;
    }
    function z(ne) {
      var he, ie;
      if (ne.key !== "Escape" || (he = q.value) != null && he.isOpen) return;
      const ye = H();
      if (ye) {
        ne.stopPropagation(), ne.preventDefault(), ye.hide();
        return;
      }
      X.value && (ne.preventDefault(), ne.target instanceof Node && ((ie = le.value) != null && ie.contains(ne.target)) && ne.stopPropagation(), r("dismiss"));
    }
    Qe(() => window.addEventListener("keydown", z, !0)), nt(() => window.removeEventListener("keydown", z, !0));
    const X = y(() => n.selectionCount > 0);
    let Y = null;
    we(X, (ne) => {
      var ye;
      if (ne) {
        Y = document.activeElement instanceof HTMLElement && document.activeElement !== document.body ? document.activeElement : null;
        return;
      }
      (ye = le.value) != null && ye.contains(document.activeElement) && Y && document.contains(Y) && Y.focus();
    });
    const ce = N("");
    return we(
      () => [n.selectionCount, n.allPagesSelected, n.totalAcrossAllPages],
      ([ne], ye) => {
        const he = ye == null ? void 0 : ye[0];
        ne > 0 ? ce.value = `${W.value} ${K.value}` : he !== void 0 && he > 0 && (ce.value = n.selectionClearedLabel);
      },
      { immediate: !0 }
    ), (ne, ye) => (c(), p(Z, null, [
      g("span", Sz, $(ce.value), 1),
      e.actionsLoadingLabel ? (c(), p("span", $z, $(e.actionsLoading ? e.actionsLoadingLabel : ""), 1)) : w("", !0),
      ae(ot, {
        name: "float-bar",
        appear: ""
      }, {
        default: pe(() => [
          e.selectionCount > 0 ? (c(), p("div", {
            key: 0,
            ref_key: "barRef",
            ref: le,
            "data-testid": "float-action-bar",
            role: "toolbar",
            "aria-label": e.ariaLabel,
            class: "inline-flex items-center gap-3.5 p-1.5 rounded-full overflow-hidden z-40 bg-(--background-background-black-default) shadow-(--shadow-float-bar)",
            style: Ae({
              position: "fixed",
              bottom: "24px",
              left: C.value !== null ? `${C.value}px` : "16px",
              right: C.value !== null ? void 0 : "16px",
              width: C.value !== null ? void 0 : "fit-content",
              margin: C.value !== null ? void 0 : "0 auto",
              maxWidth: "calc(100vw - 32px)",
              cursor: B.value ? "grabbing" : void 0
            })
          }, [
            g("button", {
              "data-testid": "drag-handle",
              tabindex: "-1",
              "aria-hidden": "true",
              class: "absolute left-1.5 top-1/2 -translate-y-1/2 flex items-center justify-center size-9 rounded-full bg-transparent border-none cursor-grab focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-(--border-border-accent)",
              onMousedown: se,
              onClick: ye[0] || (ye[0] = Ie(() => {
              }, ["prevent"]))
            }, [...ye[3] || (ye[3] = [
              g("i", {
                class: "ri-draggable text-[20px] leading-none text-(--icons-icon-white-default)",
                "aria-hidden": "true"
              }, null, -1)
            ])], 32),
            g("div", Tz, [
              ae($e, {
                "data-testid": "selection-count",
                variant: "secondary",
                size: "xxs",
                label: f.value >= wf ? `${W.value} ${K.value}` : `${W.value}`,
                "icon-right": "ri-close-line",
                "aria-label": `${W.value} ${K.value}`,
                class: "shrink-0",
                onClick: ye[1] || (ye[1] = (he) => r("dismiss"))
              }, null, 8, ["label", "aria-label"]),
              ae(Ye, {
                ref_key: "selectAllTooltipRef",
                ref: oe,
                text: e.totalUnavailableLabel,
                disabled: e.totalAcrossAllPages !== void 0,
                tabindex: e.totalAcrossAllPages === void 0 ? 0 : void 0
              }, {
                default: pe(() => [
                  ae(Xt, {
                    variant: "dark",
                    "model-value": e.allPagesSelected,
                    label: f.value >= wf ? e.selectAllPagesLabel : "",
                    "aria-label": e.selectAllPagesLabel,
                    disabled: e.totalAcrossAllPages === void 0,
                    class: "px-1 shrink-0 w-auto!",
                    "onUpdate:modelValue": ye[2] || (ye[2] = (he) => r("select-all-pages", he))
                  }, null, 8, ["model-value", "label", "aria-label", "disabled"])
                ]),
                _: 1
              }, 8, ["text", "disabled", "tabindex"]),
              ye[4] || (ye[4] = g("span", {
                class: "hidden sm:block w-px h-4 shrink-0 opacity-30 bg-(--text-text-white-default)",
                "aria-hidden": "true"
              }, null, -1))
            ]),
            g("div", {
              ref_key: "btnAreaRef",
              ref: b,
              "data-testid": "action-buttons-area",
              class: "dark flex items-center overflow-hidden min-w-0"
            }, [
              e.actionsLoading ? (c(), p("div", Lz, [...ye[5] || (ye[5] = [
                g("i", { class: "ri-loader-4-line animate-spin text-base leading-none text-(--icons-icon-white-default)" }, null, -1),
                g("span", { class: "h-2 w-16 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1),
                g("span", { class: "h-2 w-10 rounded-full bg-(--text-text-white-default) opacity-30" }, null, -1)
              ])])) : w("", !0),
              (c(!0), p(Z, null, ke(u.value, (he, ie) => (c(), p("div", {
                key: he.id,
                ref_for: !0,
                ref: x(ie),
                class: S(["shrink-0", O(ie)]),
                inert: ie >= E.value || void 0
              }, [
                ae(Ye, {
                  ref_for: !0,
                  ref: G(ie),
                  text: s(he) ?? "",
                  disabled: !s(he),
                  tabindex: s(he) ? 0 : void 0
                }, {
                  default: pe(() => [
                    ae($e, {
                      "data-testid": `action-btn-${he.id}`,
                      variant: a(he),
                      size: "xxs",
                      "icon-left": he.icon,
                      "icon-only": f.value < ci,
                      loading: he.loading,
                      disabled: he.disabled || e.isLoading,
                      "aria-label": he.label,
                      onClick: (me) => r("action-click", he.id, U.value)
                    }, {
                      default: pe(() => [
                        g("span", Ez, $(he.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "variant", "icon-left", "icon-only", "loading", "disabled", "aria-label", "onClick"])
                  ]),
                  _: 2
                }, 1032, ["text", "disabled", "tabindex"])
              ], 10, Mz))), 128))
            ], 512),
            V.value ? (c(), te(kn, {
              key: 0,
              ref_key: "dropdownRef",
              ref: q,
              class: "shrink-0",
              "menu-item-variant": "nav",
              items: A.value,
              groups: j.value,
              columns: _.value,
              "menu-header": e.moreActionsTitle,
              closeable: "",
              "close-label": e.moreLabel,
              "menu-align": "right",
              "menu-offset": 10
            }, {
              trigger: pe(({ toggle: he, isOpen: ie }) => [
                ae($e, {
                  "data-testid": "more-btn",
                  variant: "secondary",
                  size: "xxs",
                  "icon-left": "ri-more-line",
                  label: e.moreLabel,
                  "aria-expanded": ie,
                  "aria-haspopup": "menu",
                  class: "shrink-0",
                  onClick: he
                }, null, 8, ["label", "aria-expanded", "onClick"])
              ]),
              _: 1
            }, 8, ["items", "groups", "columns", "menu-header", "close-label"])) : w("", !0)
          ], 12, Iz)) : w("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), vF = /* @__PURE__ */ He(Rz, [["__scopeId", "data-v-ce74bc96"]]);
function xF(e, t = {}) {
  const n = ld([]), r = N(!1), o = N(!1), a = N(null), l = N(void 0);
  let s = 0;
  async function i() {
    const d = ++s;
    r.value = !0, o.value = !1, a.value = null, n.value = [];
    try {
      const u = await e();
      if (d !== s) return;
      n.value = (u == null ? void 0 : u.actions) ?? [], l.value = u == null ? void 0 : u.version;
    } catch (u) {
      if (d !== s) return;
      o.value = !0, a.value = u, n.value = [];
    } finally {
      d === s && (r.value = !1);
    }
  }
  return t.immediate !== !1 && i(), { actions: n, isLoading: r, hasError: o, error: a, version: l, load: i };
}
const Bz = {
  "data-testid": "field-skeleton",
  "aria-hidden": "true",
  class: "w-full"
}, Oz = {
  key: 0,
  class: "flex items-center gap-2"
}, Pz = {
  key: 0,
  class: "h-5 pb-0.5 flex items-center"
}, zz = /* @__PURE__ */ ge({
  __name: "FieldSkeleton",
  props: {
    variant: { default: "input" },
    size: { default: "md" },
    showLabel: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = {
      sm: "h-[32px]",
      md: "h-[36px]",
      lg: "h-[48px]",
      xl: "h-[52px]"
    };
    return (n, r) => (c(), p("div", Bz, [
      e.variant === "checkbox" || e.variant === "toggle" ? (c(), p("div", Oz, [
        g("div", {
          class: S([
            "skeleton shrink-0",
            e.variant === "toggle" ? "h-5 w-9 rounded-full" : "size-4 rounded"
          ])
        }, null, 2),
        r[0] || (r[0] = g("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1))
      ])) : (c(), p(Z, { key: 1 }, [
        e.showLabel ? (c(), p("div", Pz, [...r[1] || (r[1] = [
          g("div", { class: "skeleton h-2.5 w-24 rounded-full" }, null, -1)
        ])])) : w("", !0),
        g("div", {
          class: S([
            "skeleton w-full rounded-xl",
            e.variant === "textarea" ? "h-24" : t[e.size]
          ])
        }, null, 2)
      ], 64))
    ]));
  }
}), yF = /* @__PURE__ */ ge({
  __name: "FormSkeleton",
  props: {
    fields: { default: 6 },
    columns: { default: 2 },
    size: { default: "md" },
    showLabels: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => (c(), p("div", {
      "data-testid": "form-skeleton",
      "aria-hidden": "true",
      class: S(["grid gap-x-5 gap-y-4", e.columns === 2 ? "grid-cols-2" : "grid-cols-1"])
    }, [
      (c(!0), p(Z, null, ke(e.fields, (r) => (c(), te(zz, {
        key: `form-skeleton-field-${r}`,
        size: e.size,
        "show-label": e.showLabels
      }, null, 8, ["size", "show-label"]))), 128))
    ], 2));
  }
}), Nz = ["aria-label"], Vz = {
  key: 1,
  role: "list",
  class: "stepper-navigation-scroll flex items-center gap-2 sm:gap-(--spacing-5) overflow-x-auto"
}, Fz = ["aria-label"], Hz = {
  key: 0,
  "aria-hidden": "true",
  class: "flex-1 border-t-(length:--border-border-width-border-md) border-(--border-border-base-soft)"
}, Wz = {
  key: 2,
  role: "list",
  class: "stepper-navigation-scroll overflow-x-auto"
}, jz = { class: "relative flex w-max min-w-full items-center justify-between gap-2" }, Uz = ["aria-label"], Gz = ["aria-label"], qz = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Kz = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, Jz = {
  key: 4,
  role: "list",
  class: "flex flex-col items-start"
}, Zz = ["aria-label"], Yz = { class: "flex items-center gap-(--spacing-3)" }, Xz = { class: "flex flex-col items-start gap-(--spacing-0.5)" }, Qz = {
  key: 0,
  "aria-hidden": "true",
  class: "text-(length:--size-m) leading-(--line-height-l) text-(--text-text-body) whitespace-nowrap"
}, _z = {
  key: 5,
  role: "list",
  class: "stepper-navigation-scroll flex flex-col items-start gap-(--spacing-4) w-full overflow-x-auto"
}, eN = ["aria-label"], tN = {
  "aria-hidden": "true",
  class: "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap"
}, nN = {
  "aria-hidden": "true",
  class: "flex-1 font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl)"
}, rN = /* @__PURE__ */ ge({
  __name: "StepperNavigation",
  props: {
    steps: {},
    type: { default: "default" },
    labels: {},
    breakpoint: { default: "auto" }
  },
  emits: ["step-click"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = /* @__PURE__ */ new Set([
      "completed",
      "active",
      "error"
    ]);
    function a(K) {
      return o.has(K);
    }
    function l(K, le, C) {
      const B = n.labels.state[K.state];
      return `${K.label}, ${n.labels.step} ${le + 1} ${n.labels.of} ${C}, ${B}`;
    }
    function s(K) {
      r("step-click", K.id);
    }
    function i(K, le) {
      const C = a(K.state);
      return {
        type: C ? "button" : void 0,
        "data-testid": `stepper-navigation-step-${K.id}`,
        "aria-current": K.state === "active" ? "step" : void 0,
        "aria-disabled": C ? void 0 : "true",
        "aria-label": l(K, le, n.steps.length),
        onClick: C ? () => s(K) : void 0
      };
    }
    function d(K) {
      return a(K) ? "cursor-pointer focus:outline-none focus-visible:shadow-[0_0_2px_2px_var(--background-background-hover)]" : "";
    }
    const u = {
      upcoming: { variant: "outlined", color: "black", contentType: "text" },
      active: { variant: "outlined", color: "gradient", contentType: "text" },
      completed: { variant: "filled", color: "success", contentType: "icon" },
      error: { variant: "filled", color: "error", contentType: "icon" },
      disabled: { variant: "outlined", color: "disabled", contentType: "text" }
    }, f = {
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    function h(K, le) {
      return { ...u[K.state], content: f[K.state] ?? String(le + 1) };
    }
    function b(K, le) {
      const C = u[K.state], B = f[K.state];
      return B ? { ...C, content: B, contentType: "icon" } : K.icon ? { ...C, content: K.icon, contentType: "icon" } : { ...C, content: String(le + 1), contentType: "text" };
    }
    const m = {
      auto: "gap-2 sm:gap-(--spacing-4)",
      mobile: "gap-2",
      desktop: "gap-(--spacing-4)"
    }, v = {
      auto: "gap-1.5 sm:gap-(--spacing-2)",
      mobile: "gap-1.5",
      desktop: "gap-(--spacing-2)"
    }, x = {
      auto: "text-(length:--size-m) sm:text-(length:--size-l) leading-(--line-height-l) sm:leading-(--line-height-xxl)",
      mobile: "text-(length:--size-m) leading-(--line-height-l)",
      desktop: "text-(length:--size-l) leading-(--line-height-xxl)"
    }, k = y(() => n.type === "defaultVertical" ? "flex-col" : ""), L = y(() => n.breakpoint !== "mobile"), P = y(() => n.breakpoint !== "desktop"), E = {
      auto: "flex-col gap-(--spacing-5) w-fit sm:w-auto sm:flex-row sm:items-center sm:gap-(--spacing-5) sm:overflow-x-auto",
      mobile: "flex-col gap-(--spacing-5) w-fit",
      desktop: "flex-row items-center gap-(--spacing-5) overflow-x-auto"
    }, O = {
      auto: "sm:w-36",
      mobile: "",
      desktop: "w-36"
    }, R = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, V = {
      upcoming: "bg-(--background-background-white) border border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-white) border border-(--border-border-success-strong)",
      error: "bg-(--background-background-white) border border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white) border border-(--border-border-disabled-subtle)"
    }, J = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-disabled-light)"
    }, F = {
      upcoming: "text-(--text-text-black-default)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-body)",
      error: "text-(--text-text-body)",
      disabled: "text-(--text-text-disabled-light)"
    }, A = {
      auto: "h-14 sm:h-10",
      mobile: "h-14",
      desktop: "h-10"
    }, j = {
      auto: "top-9 sm:top-11",
      mobile: "top-9",
      desktop: "top-11"
    }, _ = {
      upcoming: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)",
      active: "bg-(--background-background-white) stepper-navigation-gradient-border",
      completed: "bg-(--background-background-success) border-(--border-border-success)",
      error: "bg-(--background-background-error) border-(--border-border-error-strong)",
      disabled: "bg-(--background-background-white-secondary-soft) border-(--border-border-base-soft)"
    }, U = {
      upcoming: "text-(--text-text-body)",
      active: "text-(--text-text-accent)",
      completed: "text-(--text-text-success)",
      error: "text-(--text-text-error-strong)",
      disabled: "text-(--text-text-body)"
    }, W = {
      active: "ri-arrow-right-line",
      completed: "ri-check-line",
      error: "ri-close-line"
    };
    return (K, le) => e.type === "default" || e.type === "defaultVertical" ? (c(), p("div", {
      key: 0,
      role: "list",
      class: S(["stepper-navigation-scroll flex items-center overflow-x-auto", m[e.breakpoint]])
    }, [
      (c(!0), p(Z, null, ke(e.steps, (C, B) => (c(), p(Z, {
        key: C.id
      }, [
        g("span", {
          role: "listitem",
          "aria-label": l(C, B, e.steps.length),
          class: "contents"
        }, [
          (c(), te(Wt(a(C.state) ? "button" : "span"), Je({ ref_for: !0 }, i(C, B), {
            class: [
              "flex items-center shrink-0",
              k.value,
              v[e.breakpoint],
              d(C.state)
            ]
          }), {
            default: pe(() => [
              ae(vn, Je({
                shape: "circle",
                size: "sm"
              }, { ref_for: !0 }, h(C, B)), null, 16),
              g("span", {
                "aria-hidden": "true",
                class: S([
                  "font-(--weight-medium) whitespace-nowrap",
                  x[e.breakpoint],
                  R[C.state]
                ])
              }, $(C.label), 3)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Nz),
        B < e.steps.length - 1 && L.value ? (c(), p("span", {
          key: 0,
          "aria-hidden": "true",
          class: S([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t border-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0),
        B < e.steps.length - 1 && P.value ? (c(), p("span", {
          key: 1,
          "aria-hidden": "true",
          class: S([
            e.breakpoint === "auto" ? "sm:hidden" : "",
            "flex h-4 w-[3.5px] shrink-0 items-center justify-center"
          ])
        }, [...le[0] || (le[0] = [
          g("span", { class: "h-4 w-px rotate-[10.98deg] skew-x-[1.87deg] bg-(--border-border-base-soft)" }, null, -1)
        ])], 2)) : w("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "onlyIcons" ? (c(), p("div", Vz, [
      (c(!0), p(Z, null, ke(e.steps, (C, B) => (c(), p(Z, {
        key: C.id
      }, [
        g("span", {
          role: "listitem",
          "aria-label": l(C, B, e.steps.length),
          class: "contents"
        }, [
          (c(), te(Wt(a(C.state) ? "button" : "span"), Je({ ref_for: !0 }, i(C, B), {
            class: ["flex items-center shrink-0", d(C.state)]
          }), {
            default: pe(() => [
              ae(vn, Je({
                shape: "circle",
                size: "md"
              }, { ref_for: !0 }, b(C, B)), null, 16)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Fz),
        B < e.steps.length - 1 ? (c(), p("span", Hz)) : w("", !0)
      ], 64))), 128))
    ])) : e.type === "withDots" ? (c(), p("div", Wz, [
      g("div", jz, [
        g("span", {
          "aria-hidden": "true",
          class: S([
            "absolute inset-x-0 h-0 border-t-(length:--border-border-width-border-md) border-(--border-border-base-soft)",
            j[e.breakpoint]
          ])
        }, null, 2),
        (c(!0), p(Z, null, ke(e.steps, (C, B) => (c(), p("span", {
          key: C.id,
          role: "listitem",
          "aria-label": l(C, B, e.steps.length),
          class: "contents"
        }, [
          (c(), te(Wt(a(C.state) ? "button" : "span"), Je({ ref_for: !0 }, i(C, B), {
            class: [
              "relative flex flex-col items-center gap-(--spacing-3)",
              d(C.state)
            ]
          }), {
            default: pe(() => [
              g("span", {
                "aria-hidden": "true",
                class: S([
                  "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                  J[C.state]
                ])
              }, $(C.label), 3),
              g("span", {
                "aria-hidden": "true",
                class: S(["h-4 w-4 rounded-full", V[C.state]])
              }, null, 2)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Uz))), 128))
      ])
    ])) : e.type === "iconsAndText" ? (c(), p("div", {
      key: 3,
      role: "list",
      class: S(["stepper-navigation-scroll flex", E[e.breakpoint]])
    }, [
      (c(!0), p(Z, null, ke(e.steps, (C, B) => (c(), p(Z, {
        key: C.id
      }, [
        g("span", {
          role: "listitem",
          "aria-label": l(C, B, e.steps.length),
          class: "contents"
        }, [
          (c(), te(Wt(a(C.state) ? "button" : "span"), Je({ ref_for: !0 }, i(C, B), {
            class: [
              "flex items-center gap-(--spacing-3) text-left shrink-0",
              B === 0 ? "" : O[e.breakpoint],
              d(C.state)
            ]
          }), {
            default: pe(() => [
              g("span", {
                class: S(e.breakpoint === "auto" ? "hidden sm:contents" : "contents")
              }, [
                L.value ? (c(), te(vn, Je({
                  key: 0,
                  shape: "circle",
                  size: "sm"
                }, { ref_for: !0 }, b(C, B)), null, 16)) : w("", !0)
              ], 2),
              g("span", {
                class: S(e.breakpoint === "auto" ? "contents sm:hidden" : "contents")
              }, [
                P.value ? (c(), te(vn, Je({
                  key: 0,
                  shape: "circle",
                  size: "md"
                }, { ref_for: !0 }, b(C, B)), null, 16)) : w("", !0)
              ], 2),
              g("span", qz, [
                g("span", {
                  "aria-hidden": "true",
                  class: S([
                    "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                    R[C.state]
                  ])
                }, $(C.label), 3),
                C.helperText ? (c(), p("span", Kz, $(C.helperText), 1)) : w("", !0)
              ])
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Gz),
        B < e.steps.length - 1 && L.value ? (c(), p("span", {
          key: 0,
          "aria-hidden": "true",
          class: S([
            e.breakpoint === "auto" ? "hidden sm:block" : "",
            "flex-1 border-t-(length:--border-border-width-border-md) border-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0),
        B < e.steps.length - 1 && P.value ? (c(), p("span", {
          key: 1,
          "aria-hidden": "true",
          class: S([
            e.breakpoint === "auto" ? "block sm:hidden" : "",
            "self-center h-6 w-(--border-border-width-border-md) bg-(--border-border-base-soft)"
          ])
        }, null, 2)) : w("", !0)
      ], 64))), 128))
    ], 2)) : e.type === "vertical" ? (c(), p("div", Jz, [
      (c(!0), p(Z, null, ke(e.steps, (C, B) => (c(), p(Z, {
        key: C.id
      }, [
        g("span", {
          role: "listitem",
          "aria-label": l(C, B, e.steps.length),
          class: "contents"
        }, [
          (c(), te(Wt(a(C.state) ? "button" : "span"), Je({ ref_for: !0 }, i(C, B), {
            class: ["flex items-center justify-between w-full text-left", d(C.state)]
          }), {
            default: pe(() => [
              g("span", Yz, [
                ae(vn, Je({
                  shape: "circle",
                  size: "md"
                }, { ref_for: !0 }, h(C, B)), null, 16),
                g("span", Xz, [
                  g("span", {
                    "aria-hidden": "true",
                    class: S([
                      "font-(--weight-medium) text-(length:--size-l) leading-(--line-height-xxl) whitespace-nowrap",
                      F[C.state]
                    ])
                  }, $(C.label), 3),
                  C.helperText ? (c(), p("span", Qz, $(C.helperText), 1)) : w("", !0)
                ])
              ]),
              L.value ? (c(), p("i", {
                key: 0,
                "aria-hidden": "true",
                class: S([e.breakpoint === "auto" ? "hidden sm:block" : "", "ri-arrow-right-s-line text-base shrink-0"])
              }, null, 2)) : w("", !0)
            ]),
            _: 2
          }, 1040, ["class"]))
        ], 8, Zz),
        B < e.steps.length - 1 ? (c(), p("span", {
          key: 0,
          "aria-hidden": "true",
          class: S(["ml-[17.5px] w-px bg-(--border-border-base-soft)", A[e.breakpoint]])
        }, null, 2)) : w("", !0)
      ], 64))), 128))
    ])) : e.type === "cards" ? (c(), p("div", _z, [
      (c(!0), p(Z, null, ke(e.steps, (C, B) => (c(), p("span", {
        key: C.id,
        role: "listitem",
        "aria-label": l(C, B, e.steps.length),
        class: "contents"
      }, [
        (c(), te(Wt(a(C.state) ? "button" : "span"), Je({ ref_for: !0 }, i(C, B), {
          class: [
            "flex items-center gap-(--spacing-2) w-full min-w-40 p-(--spacing-4) rounded-(--border-border-radius-rounded-l) border border-solid text-left",
            _[C.state],
            U[C.state],
            d(C.state)
          ]
        }), {
          default: pe(() => [
            g("span", tN, $(B + 1), 1),
            g("span", nN, $(C.label), 1),
            W[C.state] ? (c(), p("i", {
              key: 0,
              "aria-hidden": "true",
              class: S([W[C.state], "text-xl leading-none shrink-0"])
            }, null, 2)) : w("", !0)
          ]),
          _: 2
        }, 1040, ["class"]))
      ], 8, eN))), 128))
    ])) : w("", !0);
  }
}), kF = /* @__PURE__ */ He(rN, [["__scopeId", "data-v-4e758e76"]]);
function tg(e) {
  return "conditions" in e;
}
function uu(e) {
  return e.kind === "group";
}
const oN = /* @__PURE__ */ new Set(["isNull", "isNotNull"]), aN = /* @__PURE__ */ new Set(["in", "notIn", "between"]);
function va(e) {
  return oN.has(e);
}
function cu(e) {
  return aN.has(e);
}
function lN(e) {
  return !e.field || !e.op ? !1 : va(e.op) ? !0 : cu(e.op) ? e.op === "between" ? e.values.length === 2 && e.values.every((t) => t !== "") : e.values.length > 0 : e.value !== null && e.value !== "";
}
function Ya(e) {
  return ng(e);
}
function ng(e) {
  const t = [];
  for (const n of e.children)
    if (uu(n)) {
      const r = ng(n);
      r.conditions.length > 0 && t.push(r);
    } else lN(n) && t.push(sN(n));
  return { operator: e.operator, conditions: t };
}
function sN(e) {
  const t = {
    field: e.field,
    op: e.op
  };
  return va(e.op) || (cu(e.op) ? t.values = [...e.values] : t.value = e.value), t;
}
function Cf(e, t) {
  return tg(e) ? {
    _id: t(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((n) => od(n, t))
  } : {
    _id: t(),
    kind: "group",
    operator: "and",
    children: [od(e, t)]
  };
}
function od(e, t) {
  return tg(e) ? {
    _id: t(),
    kind: "group",
    operator: e.operator,
    children: e.conditions.map((n) => od(n, t))
  } : {
    _id: t(),
    kind: "criterion",
    field: e.field,
    op: e.op,
    value: e.value ?? null,
    values: e.values ? [...e.values] : []
  };
}
const iN = /* @__PURE__ */ new Set(["lastNDays", "nextNDays"]);
function dN(e) {
  return e.field === null && e.op === null;
}
function uN(e, t) {
  if (e === "DateTime") {
    const o = Date.parse(String(t[0])), a = Date.parse(String(t[1]));
    return Number.isNaN(o) || Number.isNaN(a) ? null : [o, a];
  }
  const n = Number(t[0]), r = Number(t[1]);
  return Number.isNaN(n) || Number.isNaN(r) ? null : [n, r];
}
function cN(e, t) {
  if (dN(e))
    return [];
  const n = e.field ? t.find((o) => o.path === e.field) : void 0;
  if (e.field && !n)
    return ["fieldOrphan"];
  if (!e.field || !e.op || !n)
    return ["valueRequired"];
  const r = [];
  if (n.operators.includes(e.op) || r.push("operatorIllegal"), va(e.op))
    return r;
  if (iN.has(e.op)) {
    const o = Number(e.value);
    return (e.value === null || e.value === "" || !Number.isInteger(o) || o < 1) && r.push("daysInvalid"), r;
  }
  if (e.op === "between") {
    if (e.values.length !== 2 || e.values.some((a) => a === ""))
      return r.push("valueRequired"), r;
    const o = uN(n.type, e.values);
    return (o === null || o[0] > o[1]) && r.push("rangeInvalid"), r;
  }
  return cu(e.op) ? (e.values.length === 0 && r.push("valueRequired"), r) : e.value === null || e.value === "" ? (r.push("valueRequired"), r) : (n.type === "Number" || n.type === "Decimal" ? (typeof e.value != "number" || Number.isNaN(e.value)) && r.push("valueInvalid") : n.type === "DateTime" && Number.isNaN(Date.parse(String(e.value))) && r.push("valueInvalid"), r);
}
function Sf(e, t) {
  const n = /* @__PURE__ */ new Map(), r = (o) => {
    for (const a of o.children)
      if (uu(a))
        r(a);
      else {
        const l = cN(a, t);
        l.length > 0 && n.set(a._id, l);
      }
  };
  return r(e), n;
}
let $f = 0;
function _r() {
  return $f += 1, `afb-${$f}`;
}
function If() {
  return { _id: _r(), kind: "group", operator: "and", children: [] };
}
function Tf() {
  return { _id: _r(), kind: "criterion", field: null, op: null, value: null, values: [] };
}
function Xa(e) {
  const t = (n) => n.kind === "group" ? {
    _id: n._id,
    kind: "group",
    operator: n.operator,
    children: n.children.map(t)
  } : {
    _id: n._id,
    kind: "criterion",
    field: n.field,
    op: n.op,
    value: n.value,
    values: [...n.values]
  };
  return t(e);
}
function rg(e, t) {
  if (e.kind !== t.kind)
    return !1;
  if (e.kind === "group" && t.kind === "group")
    return e.operator === t.operator && e.children.length === t.children.length && e.children.every((o, a) => rg(o, t.children[a]));
  const n = e, r = t;
  return n.field === r.field && n.op === r.op && n.value === r.value && n.values.length === r.values.length && n.values.every((o, a) => o === r.values[a]);
}
function fN(e, t) {
  const n = N(e ? Cf(e, _r) : If()), r = N(Xa(n.value)), o = N(/* @__PURE__ */ new Map()), a = y(() => o.value.size > 0), l = y(() => yt(t) ?? []), s = y(
    () => Sf(n.value, l.value).size === 0
  ), i = y(
    () => !rg(n.value, r.value)
  );
  function d(R) {
    R.children.push(Tf());
  }
  function u(R) {
    R.children.push({ _id: _r(), kind: "group", operator: "and", children: [Tf()] });
  }
  function f(R) {
    const V = [R._id];
    if (R.kind === "group")
      for (const J of R.children)
        V.push(...f(J));
    return V;
  }
  function h(R, V) {
    const J = R.children.find((A) => A._id === V), F = J ? f(J) : [V];
    R.children = R.children.filter((A) => A._id !== V);
    for (const A of F)
      L(A);
  }
  function b(R, V) {
    R.operator = V;
  }
  function m(R) {
    return R.children.length >= 2;
  }
  function v(R) {
    const V = (J, F) => {
      if (J._id === R._id)
        return F;
      if (J.kind === "group")
        for (const A of J.children) {
          const j = V(A, F + 1);
          if (j !== null)
            return j;
        }
      return null;
    };
    return V(n.value, 1) ?? 1;
  }
  function x(R, V) {
    return v(R) < V;
  }
  function k(R) {
    return o.value = Sf(n.value, R), o.value.size === 0;
  }
  function L(R) {
    if (o.value.has(R)) {
      const V = new Map(o.value);
      V.delete(R), o.value = V;
    }
  }
  function P() {
    r.value = Xa(n.value);
  }
  function E() {
    n.value = Xa(r.value), o.value = /* @__PURE__ */ new Map();
  }
  function O(R) {
    n.value = R ? Cf(R, _r) : If(), r.value = Xa(n.value), o.value = /* @__PURE__ */ new Map();
  }
  return {
    root: n,
    addCriterion: d,
    addGroup: u,
    removeNode: h,
    setConjunction: b,
    showConjunction: m,
    depthOf: v,
    canNest: x,
    snapshot: P,
    reset: E,
    reseed: O,
    newId: _r,
    errors: o,
    hasErrors: a,
    isValidLive: s,
    isDirty: i,
    validate: k,
    clearNodeErrors: L
  };
}
function og(e) {
  const t = fN(e.modelValue(), e.fields);
  function n() {
    t.root.value.children.length === 0 && (t.addCriterion(t.root.value), t.snapshot());
  }
  n(), Qe(() => {
    t.snapshot();
  });
  function r(u) {
    t.reseed(u), n();
  }
  we(
    t.root,
    () => {
      e.emitUpdate(Ya(t.root.value));
    },
    { deep: !0 }
  );
  const o = y(
    () => Ya(t.root.value).conditions.length > 0
  ), a = y(
    () => !e.busy() && o.value && t.isValidLive.value
  ), l = y(() => a.value || e.busy() ? null : o.value ? e.labels().saveDisabledInvalid ?? null : e.labels().saveDisabledEmpty ?? null);
  function s() {
    e.busy() || t.validate(e.fields()) && e.emitApply(Ya(t.root.value));
  }
  function i() {
    e.busy() || (t.reset(), e.emitReset());
  }
  function d() {
    a.value && e.emitSave(Ya(t.root.value));
  }
  return {
    builder: t,
    hasCompleteCriterion: o,
    canSave: a,
    saveDisabledReason: l,
    onApply: s,
    onReset: i,
    onSave: d,
    reseedFrom: r
  };
}
const ag = '[data-testid="filter-field-select-panel"]', hN = ["disabled", "aria-expanded"], bN = {
  key: 0,
  "data-testid": "filter-field-select-trigger-label",
  class: "sr-only"
}, pN = {
  key: 0,
  class: "flex min-h-4.5 items-center gap-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
  role: "alert"
}, gN = ["aria-label"], mN = { class: "relative flex flex-col gap-3 border-b border-solid border-(--color-border-base-soft) px-3 pt-4 pb-4 shadow-(--shadow-bottom-dropdown) dark:border-(--colors-border-base) dark:shadow-(--shadow-bottom-dropdown-dark)" }, vN = {
  key: 0,
  class: "field-select-group-tabs flex flex-col gap-1.5"
}, xN = { class: "text-(length:--size-m) leading-5 font-medium text-(--colors-text-body) dark:text-(--colors-text-white-secondary)" }, yN = {
  "aria-live": "polite",
  role: "status",
  class: "sr-only"
}, kN = ["aria-label"], wN = ["aria-selected", "tabindex", "data-listbox-index", "onClick", "onKeydown", "onFocus"], CN = ["src"], SN = {
  key: 1,
  class: "h-4 w-4 shrink-0",
  "aria-hidden": "true"
}, $N = { class: "text-(length:--size-m) leading-5" }, IN = {
  key: 1,
  "data-testid": "filter-field-select-empty",
  class: "px-4 py-3 text-(length:--size-m) text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
}, TN = /* @__PURE__ */ ge({
  __name: "FilterFieldSelect",
  props: {
    fields: {},
    groups: { default: () => [] },
    modelValue: { default: "" },
    placeholder: {},
    searchPlaceholder: {},
    groupsLabel: {},
    noResultsLabel: {},
    noFieldsLabel: {},
    emptyGroupLabel: {},
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    error: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = N(null), a = N(null), l = N(""), s = N(""), i = N(0), { isOpen: d, dropdownRef: u, toggleDropdown: f, closeDropdown: h } = wa({
      onClose: b,
      // The panel is teleported to <body>, so every click inside it reads as an
      // "outside" click to useDropdown unless it is explicitly ignored. The selector is
      // shared with the consumers that must ignore it too.
      ignoreSelectors: [ag]
    });
    function b() {
      l.value = "", s.value = "", i.value = 0;
    }
    function m() {
      var q, oe;
      (oe = (q = a.value) == null ? void 0 : q.querySelector('input[type="search"]')) == null || oe.focus();
    }
    const v = N({}), x = 4, k = 8, L = 240;
    function P() {
      var ye;
      const q = (ye = o.value) == null ? void 0 : ye.getBoundingClientRect();
      if (!q) return;
      const oe = typeof window < "u" ? window.innerWidth : q.right, ue = typeof window < "u" ? window.innerHeight : q.bottom, z = q.left + q.width / 2 > oe / 2 ? { right: `${oe - q.right}px` } : { left: `${q.left}px` }, X = ue - q.bottom - x - k, Y = q.top - x - k, ce = X < L && Y > X, ne = ce ? { bottom: `${ue - q.top + x}px` } : { top: `${q.bottom + x}px` };
      v.value = {
        position: "fixed",
        ...z,
        ...ne,
        maxHeight: `${Math.max(ce ? Y : X, 0)}px`,
        zIndex: "50"
      };
    }
    function E() {
      typeof window > "u" || (window.addEventListener("scroll", P, !0), window.addEventListener("resize", P));
    }
    function O() {
      typeof window > "u" || (window.removeEventListener("scroll", P, !0), window.removeEventListener("resize", P));
    }
    we(d, (q) => {
      q ? Pe(() => {
        P(), E(), m();
      }) : O();
    }), Bt(O);
    const R = y(
      () => n.modelValue ? n.fields.find((q) => q.path === n.modelValue) ?? null : null
    ), V = y(() => {
      let oe = (n.groups ?? []).length ? n.fields.filter((G) => G.group === s.value) : n.fields;
      const ue = fl(l.value.trim());
      return ue && (oe = oe.filter((G) => fl(G.label).includes(ue))), oe;
    }), J = y(
      () => !l.value.trim() && (n.groups ?? []).length > 0 && !n.fields.some((q) => q.group === s.value)
    ), F = y(() => l.value.trim() ? n.noResultsLabel : n.fields.length === 0 ? n.noFieldsLabel : J.value ? n.emptyGroupLabel : n.noResultsLabel);
    function A() {
      var ue, G;
      const q = n.groups ?? [], oe = (ue = R.value) == null ? void 0 : ue.group;
      return oe && q.some((H) => H.value === oe) ? oe : ((G = q[0]) == null ? void 0 : G.value) ?? "";
    }
    function j() {
      l.value = "", s.value = A(), i.value = Math.max(
        0,
        V.value.findIndex((q) => q.path === n.modelValue)
      ), f();
    }
    function _() {
      if (!n.disabled) {
        if (d.value) {
          h();
          return;
        }
        j();
      }
    }
    function U(q) {
      n.disabled || d.value || q.key !== "ArrowDown" && q.key !== "ArrowUp" || (q.preventDefault(), j());
    }
    function W(q) {
      s.value = q, i.value = 0;
    }
    function K(q) {
      r("update:modelValue", q), h(), Pe(() => {
        var oe;
        return (oe = o.value) == null ? void 0 : oe.focus();
      });
    }
    function le(q) {
      d.value && (q.stopPropagation(), q.preventDefault(), h(), Pe(() => {
        var oe;
        return (oe = o.value) == null ? void 0 : oe.focus();
      }));
    }
    const C = N(null);
    we(
      () => V.value.length,
      (q) => {
        i.value = Math.min(i.value, Math.max(0, q - 1));
      }
    );
    function B(q) {
      var oe, ue;
      (ue = (oe = C.value) == null ? void 0 : oe.querySelector(`[data-listbox-index="${q}"]`)) == null || ue.focus();
    }
    function I(q) {
      if (q.key !== "ArrowDown" && q.key !== "ArrowUp") return;
      const oe = V.value.length;
      if (!oe) return;
      q.preventDefault();
      const ue = V.value.findIndex((H) => H.path === n.modelValue), G = ue >= 0 ? ue : q.key === "ArrowDown" ? 0 : oe - 1;
      i.value = G, B(G);
    }
    function M(q) {
      const oe = V.value.length;
      if (oe === 0) return;
      let ue = i.value;
      switch (q.key) {
        case "ArrowDown":
          ue = (ue + 1) % oe;
          break;
        case "ArrowUp":
          ue = (ue - 1 + oe) % oe;
          break;
        case "Home":
          ue = 0;
          break;
        case "End":
          ue = oe - 1;
          break;
        default:
          return;
      }
      q.preventDefault(), q.stopPropagation(), i.value = ue, Pe(() => B(ue));
    }
    const D = {
      sm: { container: "h-[36px] px-2.5 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      md: { container: "h-[36px] px-3 py-2 gap-2", text: "text-sm leading-5", icon: "h-4 w-4" },
      lg: { container: "h-[48px] px-3.5 gap-2", text: "text-base leading-6", icon: "h-5 w-5" },
      xl: { container: "h-[52px] px-4 gap-2", text: "text-base leading-6", icon: "h-5 w-5" }
    }, re = y(() => D[n.size]), se = y(() => !!n.error), de = y(() => {
      const q = "relative flex items-center w-full rounded-xl border border-solid box-border text-left font-inter transition-colors select-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) focus-visible:ring-offset-2";
      return n.disabled ? `${q} cursor-not-allowed bg-gainsboro-200 border-border-disabled-subtle text-text-disabled dark:bg-(--colors-background-disabled) dark:border-(--colors-border-disabled-subtle) dark:text-(--colors-text-disabled)` : se.value ? `${q} cursor-pointer bg-white border-(--border-border-error-strong) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--border-border-error) dark:text-(--colors-text-white-default)` : d.value ? `${q} cursor-pointer bg-(--background-background-selected) border-(--border-border-accent) shadow-[0px_0px_2px_var(--border-border-accent)] text-text-black-default dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)` : `${q} cursor-pointer bg-(--background-background-white) border-(--border-border-base-medium) hover:border-(--border-border-accent) text-text-black-default dark:bg-(--colors-background-black-default) dark:border-(--colors-border-base) dark:text-(--colors-text-white-default)`;
    }), fe = (q) => !!q && q.startsWith("ri-");
    return (q, oe) => {
      var ue;
      return c(), p("div", {
        ref_key: "dropdownRef",
        ref: u,
        class: S(["relative text-left", e.fullWidth ? "w-full" : "inline-block"]),
        onKeydown: je(le, ["escape"])
      }, [
        g("button", {
          ref_key: "triggerRef",
          ref: o,
          type: "button",
          "data-testid": "filter-field-select-trigger",
          class: S([de.value, re.value.container]),
          disabled: e.disabled,
          "aria-expanded": T(d),
          "aria-haspopup": "listbox",
          onClick: _,
          onKeydown: U
        }, [
          R.value ? (c(), p("span", bN, $(e.placeholder), 1)) : w("", !0),
          g("span", {
            class: S(["flex-1 truncate", [
              re.value.text,
              e.disabled ? "" : R.value ? "text-text-black-default dark:text-(--colors-text-white-default)" : "text-text-body-subtle dark:text-(--colors-text-white-secondary)"
            ]])
          }, $(((ue = R.value) == null ? void 0 : ue.label) ?? e.placeholder), 3),
          g("i", {
            class: S(["ri-arrow-down-s-line shrink-0 text-base leading-none transition-transform duration-200 ease-in-out", [
              re.value.icon,
              e.disabled ? "text-text-disabled" : "text-text-body-subtle",
              T(d) ? "rotate-180" : "rotate-0"
            ]]),
            "aria-hidden": "true"
          }, null, 2)
        ], 42, hN),
        e.error ? (c(), p("p", pN, [
          oe[1] || (oe[1] = g("i", {
            class: "ri-error-warning-fill",
            "aria-hidden": "true"
          }, null, -1)),
          g("span", null, $(e.error), 1)
        ])) : w("", !0),
        (c(), te(cn, { to: "body" }, [
          ae(ot, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: pe(() => [
              T(d) ? (c(), p("div", {
                key: 0,
                ref_key: "panelRef",
                ref: a,
                role: "group",
                "aria-label": e.placeholder,
                "data-testid": "filter-field-select-panel",
                "data-focus-trap-allow-outside": "",
                style: Ae(v.value),
                class: "flex w-[370px] flex-col overflow-hidden rounded-(--border-border-radius-rounded-l) border border-solid border-border-base-soft bg-white-50-opacity-bold shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
                onKeydown: je(le, ["escape"])
              }, [
                g("div", mN, [
                  ae(Rr, {
                    modelValue: l.value,
                    "onUpdate:modelValue": oe[0] || (oe[0] = (G) => l.value = G),
                    placeholder: e.searchPlaceholder,
                    size: "sm",
                    "full-width": "",
                    rounded: "xl",
                    onKeydown: I
                  }, null, 8, ["modelValue", "placeholder"]),
                  e.groups.length ? (c(), p("div", vN, [
                    g("span", xN, $(e.groupsLabel), 1),
                    ae(ou, {
                      class: "w-full gap-1 p-1",
                      color: "dark"
                    }, {
                      default: pe(() => [
                        (c(!0), p(Z, null, ke(e.groups, (G) => (c(), te($e, {
                          key: G.value,
                          variant: "tertiary",
                          label: G.label,
                          active: s.value === G.value,
                          "aria-pressed": s.value === G.value,
                          "data-testid": "field-select-group-btn",
                          class: "flex-1 justify-center",
                          onClick: (H) => W(G.value)
                        }, null, 8, ["label", "active", "aria-pressed", "onClick"]))), 128))
                      ]),
                      _: 1
                    })
                  ])) : w("", !0)
                ]),
                g("span", yN, $(V.value.length ? String(V.value.length) : F.value), 1),
                V.value.length ? (c(), p("div", {
                  key: 0,
                  ref_key: "listboxRef",
                  ref: C,
                  role: "listbox",
                  "aria-label": e.searchPlaceholder,
                  class: "flex max-h-[280px] min-h-0 flex-col gap-0.5 overflow-y-auto p-2",
                  onKeydown: M
                }, [
                  (c(!0), p(Z, null, ke(V.value, (G, H) => (c(), p("div", {
                    key: G.path,
                    role: "option",
                    "aria-selected": G.path === e.modelValue,
                    tabindex: H === i.value ? 0 : -1,
                    "data-listbox-index": H,
                    class: S([
                      "flex w-full cursor-pointer items-center gap-2 rounded-(--border-border-radius-rounded-sm) px-2 py-1.5 text-(--colors-text-black-default) transition-colors hover:bg-(--colors-background-hover) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--border-border-accent) dark:text-(--colors-text-white-default) dark:hover:bg-white/8",
                      G.path === e.modelValue ? "bg-(--colors-background-hover) font-medium dark:bg-white/8" : ""
                    ]),
                    onClick: Ie((z) => K(G.path), ["stop"]),
                    onKeydown: [
                      je(Ie((z) => K(G.path), ["prevent"]), ["enter"]),
                      je(Ie((z) => K(G.path), ["prevent"]), ["space"])
                    ],
                    onFocus: (z) => i.value = H
                  }, [
                    G.icon ? (c(), p(Z, { key: 0 }, [
                      fe(G.icon) ? (c(), p("i", {
                        key: 0,
                        class: S([
                          G.icon,
                          "shrink-0 text-base leading-none text-(--colors-text-body-subtle) dark:text-(--colors-text-white-secondary)"
                        ]),
                        "aria-hidden": "true"
                      }, null, 2)) : (c(), p("img", {
                        key: 1,
                        class: "h-4 w-4 shrink-0 opacity-50",
                        src: G.icon,
                        alt: ""
                      }, null, 8, CN))
                    ], 64)) : (c(), p("span", SN)),
                    g("span", $N, $(G.label), 1)
                  ], 42, wN))), 128))
                ], 40, kN)) : (c(), p("div", IN, $(F.value), 1))
              ], 44, gN)) : w("", !0)
            ]),
            _: 1
          })
        ]))
      ], 34);
    };
  }
}), LN = /* @__PURE__ */ He(TN, [["__scopeId", "data-v-03fdac35"]]), MN = ["aria-label"], EN = { class: "flex flex-wrap items-start gap-3 py-1" }, AN = { class: "w-[100px] shrink-0" }, DN = ["aria-label"], RN = {
  key: 1,
  class: "flex h-[36px] w-full items-center rounded-xl border border-solid border-(--colors-border-base-medium) bg-(--background-background-white) px-2.5 text-sm font-medium text-(--colors-text-body) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:text-(--colors-text-white-default)",
  "aria-hidden": "true"
}, BN = { class: "min-w-0 flex-1" }, ON = {
  key: 4,
  class: "flex items-center gap-2"
}, PN = { class: "shrink-0 text-sm text-(--colors-text-body)" }, zN = ["data-testid"], NN = { class: "flex items-start gap-3" }, VN = { class: "flex flex-wrap items-center gap-3 pt-1" }, FN = /* @__PURE__ */ ge({
  __name: "CriteriaGroup",
  props: {
    group: {},
    fields: {},
    labels: {},
    maxDepth: {},
    builder: {},
    depth: {},
    fieldGroups: {}
  },
  setup(e) {
    const t = e;
    function n(A) {
      return A ? t.fields.find((j) => j.path === A) : void 0;
    }
    function r(A, j) {
      const _ = A.type === "DateTime" ? t.labels.dateOperatorLabels : A.type === "String" ? t.labels.stringOperatorLabels : A.type === "Enum" || A.type === "Guid" ? t.labels.listOperatorLabels : void 0;
      return (_ == null ? void 0 : _[j]) ?? t.labels.operatorLabels[j] ?? j;
    }
    function o(A) {
      const j = n(A.field);
      return j ? j.operators.map((_) => ({
        value: _,
        label: r(j, _)
      })) : [];
    }
    function a(A) {
      var _;
      if (A.field && !n(A.field))
        return "orphan";
      if (!A.field || !A.op)
        return "placeholder";
      if (va(A.op))
        return "none";
      const j = (_ = n(A.field)) == null ? void 0 : _.type;
      return A.op === "lastNDays" || A.op === "nextNDays" ? "days" : A.op === "between" ? j === "DateTime" ? "dateRange" : "numberRange" : A.op === "in" || A.op === "notIn" ? "tags" : j === "Bool" ? "bool" : j === "Number" || j === "Decimal" ? "number" : j === "DateTime" ? "date" : "text";
    }
    function l(A) {
      const j = a(A);
      return j === "dateRange" || j === "numberRange" || j === "tags";
    }
    const s = y(() => [
      { value: "and", label: t.labels.and },
      { value: "or", label: t.labels.or }
    ]);
    function i(A, j) {
      t.builder.clearNodeErrors(A._id), A.field = j || null, A.op = null, A.value = null, A.values = [];
    }
    function d(A) {
      return !A || va(A) ? "none" : A === "between" ? "between" : A === "in" || A === "notIn" ? "set" : A === "lastNDays" || A === "nextNDays" ? "days" : "scalar";
    }
    function u(A, j) {
      t.builder.clearNodeErrors(A._id);
      const _ = A.op;
      A.op = j || null, d(A.op) !== d(_) && (A.value = null, A.values = []);
    }
    function f(A, j) {
      var U;
      t.builder.clearNodeErrors(A._id);
      const _ = (U = n(A.field)) == null ? void 0 : U.type;
      if (_ === "Number" || _ === "Decimal") {
        A.value = j === "" ? null : Number(j);
        return;
      }
      A.value = j === "" ? null : j;
    }
    function h(A, j) {
      t.builder.clearNodeErrors(A._id), A.value = j === "" ? null : Number(j);
    }
    function b(A, j, _) {
      t.builder.clearNodeErrors(A._id);
      const U = [A.values[0] ?? "", A.values[1] ?? ""];
      U[j] = _ === null ? "" : _, A.values = U;
    }
    function m(A, j) {
      var U;
      t.builder.clearNodeErrors(A._id);
      const _ = (U = n(A.field)) == null ? void 0 : U.type;
      if (_ === "Number" || _ === "Decimal") {
        A.values = j.map(Number).filter((W) => Number.isFinite(W));
        return;
      }
      A.values = [...j];
    }
    function v(A, j) {
      t.builder.clearNodeErrors(A._id), A.value = j === "" ? null : j === "true";
    }
    function x(A) {
      return A.value === null || A.value === void 0 ? "" : String(A.value);
    }
    function k(A) {
      return uu(A);
    }
    const L = {
      valueRequired: "errorValueRequired",
      valueInvalid: "errorValueInvalid",
      rangeInvalid: "errorRangeInvalid",
      daysInvalid: "errorDaysInvalid",
      operatorIllegal: "errorOperatorIllegal",
      fieldOrphan: "errorFieldOrphan"
    };
    function P(A) {
      const j = t.builder.errors.value.get(A._id);
      return j != null && j.length ? t.labels[L[j[0]]] : null;
    }
    function E() {
      t.builder.addCriterion(t.group);
    }
    function O() {
      t.builder.addGroup(t.group);
    }
    function R(A) {
      t.builder.removeNode(t.group, A);
    }
    function V(A) {
      t.builder.setConjunction(t.group, A);
    }
    const J = y(() => t.builder.canNest(t.group, t.maxDepth)), F = y(
      () => t.group.operator === "or" ? t.labels.or : t.labels.and
    );
    return (A, j) => {
      const _ = bg("CriteriaGroup", !0);
      return c(), p("div", {
        class: S([
          "flex flex-col gap-2",
          // The root level sits directly on the modal body (no card, per Figma);
          // only nested groups get a neutral-gray bordered card so they read as a
          // sub-scope. The lavender accent card was a divergence from the design.
          e.depth > 1 ? "rounded-xl border border-solid border-(--colors-border-base-soft) bg-(--colors-background-white-secondary) p-4 dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)" : ""
        ]),
        role: "group",
        "aria-label": e.labels.title
      }, [
        (c(!0), p(Z, null, ke(e.group.children, (U, W) => (c(), p(Z, {
          key: U._id
        }, [
          g("div", EN, [
            g("div", AN, [
              W === 1 ? (c(), p("div", {
                key: 0,
                role: "group",
                "aria-label": `${e.labels.and} / ${e.labels.or}`
              }, [
                ae(el, {
                  "data-testid": "afb-conjunction",
                  "model-value": e.group.operator,
                  options: s.value,
                  placeholder: e.labels.and,
                  "aria-label": `${e.labels.and} / ${e.labels.or}`,
                  size: "sm",
                  "full-width": "",
                  "onUpdate:modelValue": V
                }, null, 8, ["model-value", "options", "placeholder", "aria-label"])
              ], 8, DN)) : W >= 2 ? (c(), p("span", RN, $(F.value), 1)) : w("", !0)
            ]),
            k(U) ? (c(), p(Z, { key: 0 }, [
              ae(_, {
                class: "min-w-0 flex-1",
                group: U,
                fields: e.fields,
                labels: e.labels,
                "max-depth": e.maxDepth,
                builder: e.builder,
                depth: e.depth + 1,
                "field-groups": e.fieldGroups
              }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "depth", "field-groups"]),
              ae($e, {
                "data-testid": `afb-remove-${W}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                "icon-alt": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (K) => R(U._id)
              }, null, 8, ["data-testid", "aria-label", "icon-alt", "onClick"])
            ], 64)) : a(U) === "orphan" ? (c(), p(Z, { key: 1 }, [
              g("div", BN, [
                ae(er, {
                  "model-value": U.field ?? "",
                  disabled: "",
                  "full-width": "",
                  error: e.labels.errorFieldOrphan
                }, null, 8, ["model-value", "error"])
              ]),
              ae($e, {
                "data-testid": `afb-remove-${W}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                "icon-alt": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (K) => R(U._id)
              }, null, 8, ["data-testid", "aria-label", "icon-alt", "onClick"])
            ], 64)) : (c(), p(Z, { key: 2 }, [
              ae(LN, {
                "data-testid": `afb-field-${W}`,
                class: "min-w-0 flex-1",
                "model-value": U.field ?? "",
                fields: e.fields,
                groups: e.fieldGroups,
                placeholder: e.labels.fieldPlaceholder,
                "search-placeholder": e.labels.fieldSearchPlaceholder,
                "groups-label": e.labels.fieldGroupsLabel,
                "no-results-label": e.labels.fieldNoResults,
                "no-fields-label": e.labels.fieldNoFields,
                "empty-group-label": e.labels.fieldEmptyGroup,
                "full-width": "",
                "onUpdate:modelValue": (K) => i(U, K)
              }, null, 8, ["data-testid", "model-value", "fields", "groups", "placeholder", "search-placeholder", "groups-label", "no-results-label", "no-fields-label", "empty-group-label", "onUpdate:modelValue"]),
              ae(el, {
                "data-testid": `afb-operator-${W}`,
                class: "min-w-0 flex-1",
                "model-value": U.op ?? "",
                options: o(U),
                placeholder: e.labels.operatorPlaceholder,
                "aria-label": e.labels.operatorPlaceholder,
                disabled: !U.field,
                "full-width": "",
                "onUpdate:modelValue": (K) => u(U, K)
              }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "disabled", "onUpdate:modelValue"]),
              g("div", {
                class: S(l(U) ? "order-last basis-full min-w-0 pl-[112px]" : "min-w-0 flex-1")
              }, [
                a(U) === "placeholder" ? (c(), te(er, {
                  key: 0,
                  "model-value": "",
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  disabled: "",
                  "full-width": ""
                }, null, 8, ["placeholder", "aria-label"])) : a(U) === "bool" ? (c(), te(el, {
                  key: 1,
                  "data-testid": `afb-value-${W}`,
                  "model-value": U.value === null ? "" : String(U.value),
                  options: [
                    { value: "true", label: e.labels.boolTrue },
                    { value: "false", label: e.labels.boolFalse }
                  ],
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (K) => v(U, K)
                }, null, 8, ["data-testid", "model-value", "options", "placeholder", "aria-label", "onUpdate:modelValue"])) : a(U) === "numberRange" ? (c(), te(zp, {
                  key: 2,
                  "data-testid": `afb-value-${W}`,
                  "min-value": U.values[0] === void 0 || U.values[0] === "" ? null : Number(U.values[0]),
                  "max-value": U.values[1] === void 0 || U.values[1] === "" ? null : Number(U.values[1]),
                  "show-slider": !1,
                  "clamp-input-to-bounds": !1,
                  "min-placeholder": e.labels.rangeFrom,
                  "max-placeholder": e.labels.rangeTo,
                  "min-aria-label": e.labels.rangeFrom,
                  "max-aria-label": e.labels.rangeTo,
                  "separator-label": e.labels.rangeTo,
                  "onUpdate:minValue": (K) => b(U, 0, K),
                  "onUpdate:maxValue": (K) => b(U, 1, K)
                }, null, 8, ["data-testid", "min-value", "max-value", "min-placeholder", "max-placeholder", "min-aria-label", "max-aria-label", "separator-label", "onUpdate:minValue", "onUpdate:maxValue"])) : a(U) === "dateRange" ? (c(), te(c3, {
                  key: 3,
                  "data-testid": `afb-value-${W}`,
                  "start-date": String(U.values[0] ?? ""),
                  "end-date": String(U.values[1] ?? ""),
                  "start-placeholder": e.labels.rangeFrom,
                  "end-placeholder": e.labels.rangeTo,
                  "start-label": "",
                  "end-label": "",
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:startDate": (K) => b(U, 0, K),
                  "onUpdate:endDate": (K) => b(U, 1, K)
                }, null, 8, ["data-testid", "start-date", "end-date", "start-placeholder", "end-placeholder", "language", "onUpdate:startDate", "onUpdate:endDate"])) : a(U) === "days" ? (c(), p("div", ON, [
                  ae(Lu, {
                    "data-testid": `afb-value-${W}`,
                    "model-value": x(U),
                    placeholder: e.labels.valuePlaceholder,
                    "aria-label": e.labels.valuePlaceholder,
                    "full-width": "",
                    "onUpdate:modelValue": (K) => h(U, K)
                  }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"]),
                  g("span", PN, $(e.labels.daysSuffix), 1)
                ])) : a(U) === "tags" ? (c(), te(JL, {
                  key: 5,
                  "data-testid": `afb-value-${W}`,
                  "model-value": U.values.map(String),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "remove-label": e.labels.removeValue,
                  "full-width": "",
                  "onUpdate:modelValue": (K) => m(U, K)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "remove-label", "onUpdate:modelValue"])) : a(U) === "number" ? (c(), te(Lu, {
                  key: 6,
                  "data-testid": `afb-value-${W}`,
                  "model-value": x(U),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (K) => f(U, K)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : a(U) === "date" ? (c(), te(Yi, {
                  key: 7,
                  "data-testid": `afb-value-${W}`,
                  "model-value": x(U),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  language: e.labels.dateLocale ?? "en",
                  format: "yyyy-mm-dd",
                  "full-width": "",
                  "onUpdate:modelValue": (K) => f(U, K)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "language", "onUpdate:modelValue"])) : a(U) === "text" ? (c(), te(er, {
                  key: 8,
                  "data-testid": `afb-value-${W}`,
                  "model-value": x(U),
                  placeholder: e.labels.valuePlaceholder,
                  "aria-label": e.labels.valuePlaceholder,
                  "full-width": "",
                  "onUpdate:modelValue": (K) => f(U, K)
                }, null, 8, ["data-testid", "model-value", "placeholder", "aria-label", "onUpdate:modelValue"])) : w("", !0)
              ], 2),
              ae($e, {
                "data-testid": `afb-remove-${W}`,
                variant: "text",
                "icon-only": "",
                "icon-left": "ri-delete-bin-6-line",
                size: "sm",
                "aria-label": e.labels.removeCriterion,
                "icon-alt": e.labels.removeCriterion,
                class: "shrink-0 mt-1",
                onClick: (K) => R(U._id)
              }, null, 8, ["data-testid", "aria-label", "icon-alt", "onClick"])
            ], 64))
          ]),
          !k(U) && P(U) ? (c(), p("p", {
            key: 0,
            "data-testid": `afb-error-${W}`,
            class: "ml-[112px] -mt-1 text-xs text-(--text-text-error-strong) dark:text-(--text-text-error)",
            role: "status"
          }, $(P(U)), 9, zN)) : w("", !0)
        ], 64))), 128)),
        g("div", NN, [
          j[0] || (j[0] = g("div", {
            class: "w-[100px] shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          g("div", VN, [
            ae($r, {
              "data-testid": "afb-add-criterion",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: E
            }, {
              default: pe(() => [
                Ze($(e.labels.addCriterion), 1)
              ]),
              _: 1
            }),
            J.value ? (c(), te($r, {
              key: 0,
              "data-testid": "afb-add-group",
              "icon-left": "ri-add-line",
              size: "l",
              onClick: O
            }, {
              default: pe(() => [
                Ze($(e.labels.addGroup), 1)
              ]),
              _: 1
            })) : w("", !0)
          ])
        ])
      ], 10, MN);
    };
  }
}), HN = /* @__PURE__ */ He(FN, [["__scopeId", "data-v-ac079c36"]]), WN = {
  "data-testid": "afb-body",
  class: "flex flex-col gap-6"
}, lg = /* @__PURE__ */ ge({
  __name: "AdvancedFilterBody",
  props: {
    builder: {},
    fields: {},
    labels: {},
    maxDepth: { default: 2 },
    fieldGroups: {},
    showInfoAlert: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => (c(), p(Z, null, [
      e.builder.hasErrors.value ? (c(), te(as, {
        key: 0,
        "data-testid": "afb-error-alert",
        color: "danger",
        surface: "card",
        layout: "inline",
        heading: e.labels.errorAlert,
        class: "w-full max-w-none!",
        role: "alert",
        "aria-live": "assertive"
      }, null, 8, ["heading"])) : w("", !0),
      e.showInfoAlert ? (c(), te(as, {
        key: 1,
        color: "info",
        surface: "card",
        layout: "inline",
        heading: e.labels.alert,
        class: "w-full max-w-none!"
      }, null, 8, ["heading"])) : w("", !0),
      g("div", WN, [
        ae(HN, {
          group: e.builder.root.value,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          builder: e.builder,
          depth: 1,
          "field-groups": e.fieldGroups
        }, null, 8, ["group", "fields", "labels", "max-depth", "builder", "field-groups"])
      ])
    ], 64));
  }
}), jN = { class: "flex items-center gap-3" }, sg = /* @__PURE__ */ ge({
  __name: "AdvancedFilterFooter",
  props: {
    labels: {},
    busy: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 },
    showSave: { type: Boolean, default: !1 },
    canSave: { type: Boolean },
    saveDisabledReason: {}
  },
  emits: ["reset", "cancel", "save", "apply"],
  setup(e, { emit: t }) {
    const n = t;
    return (r, o) => (c(), p(Z, null, [
      ae($e, {
        "data-testid": "afb-reset",
        variant: "secondary",
        size: "md",
        label: e.labels.reset,
        disabled: e.busy,
        "icon-left": "ri-refresh-line",
        onClick: o[0] || (o[0] = (a) => n("reset"))
      }, null, 8, ["label", "disabled"]),
      g("div", jN, [
        e.showCancel ? (c(), te($e, {
          key: 0,
          "data-testid": "afb-cancel",
          variant: "secondary",
          size: "md",
          label: e.labels.cancel,
          disabled: e.busy,
          onClick: o[1] || (o[1] = (a) => n("cancel"))
        }, null, 8, ["label", "disabled"])) : w("", !0),
        e.showSave ? (c(), te(Ye, {
          key: 1,
          text: e.saveDisabledReason ?? "",
          disabled: e.saveDisabledReason === null,
          tabindex: e.saveDisabledReason ? 0 : void 0,
          "data-testid": "afb-save-tooltip",
          position: "top"
        }, {
          default: pe(() => [
            ae($e, {
              "data-testid": "afb-save",
              variant: "secondary",
              size: "md",
              label: e.labels.save,
              disabled: !e.canSave,
              "icon-left": "ri-save-3-fill",
              onClick: o[2] || (o[2] = (a) => n("save"))
            }, null, 8, ["label", "disabled"])
          ]),
          _: 1
        }, 8, ["text", "disabled", "tabindex"])) : w("", !0),
        ae($e, {
          "data-testid": "afb-apply",
          variant: "primary",
          size: "md",
          label: e.labels.apply,
          disabled: e.busy,
          loading: e.busy,
          "icon-left": "ri-check-line",
          onClick: o[3] || (o[3] = (a) => n("apply"))
        }, null, 8, ["label", "disabled", "loading"])
      ])
    ], 64));
  }
}), UN = { class: "flex w-full flex-col items-center gap-2 text-center" }, GN = ["id"], wF = /* @__PURE__ */ ge({
  __name: "AdvancedFilterBuilder",
  props: {
    modelValue: {},
    fields: {},
    fieldGroups: {},
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    labels: {},
    showSave: { type: Boolean, default: !1 },
    showCancel: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "apply", "reset", "cancel", "close", "save"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = og({
      modelValue: () => n.modelValue,
      fields: () => n.fields,
      busy: () => n.busy,
      labels: () => n.labels,
      emitUpdate: (d) => r("update:modelValue", d),
      emitApply: (d) => r("apply", d),
      emitReset: () => r("reset"),
      emitSave: (d) => r("save", d)
    }), a = Ke(), l = N(!0);
    function s() {
      n.busy || r("cancel");
    }
    function i() {
      l.value = !1, r("close");
    }
    return (d, u) => (c(), te(Ta, {
      modelValue: l.value,
      "onUpdate:modelValue": u[0] || (u[0] = (f) => l.value = f),
      size: "lg",
      "footer-position": "split",
      "show-header-border": !1,
      "aria-labelledby": T(a),
      onClose: i
    }, {
      header: pe(() => [
        g("div", UN, [
          u[1] || (u[1] = g("span", {
            class: "flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-solid border-(--colors-border-base-soft) bg-(--background-background-white) dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default)",
            "aria-hidden": "true"
          }, [
            g("i", { class: "ri-shuffle-line text-2xl text-(--colors-text-heading)" })
          ], -1)),
          g("h2", {
            id: T(a),
            "data-testid": "afb-title",
            class: "text-xl font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
          }, $(e.labels.title), 9, GN)
        ])
      ]),
      footer: pe(() => [
        ae(sg, {
          labels: e.labels,
          busy: e.busy,
          "show-cancel": e.showCancel,
          "show-save": e.showSave,
          "can-save": T(o).canSave.value,
          "save-disabled-reason": T(o).saveDisabledReason.value,
          onReset: T(o).onReset,
          onCancel: s,
          onSave: T(o).onSave,
          onApply: T(o).onApply
        }, null, 8, ["labels", "busy", "show-cancel", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
      ]),
      default: pe(() => [
        ae(lg, {
          builder: T(o).builder,
          fields: e.fields,
          labels: e.labels,
          "max-depth": e.maxDepth,
          "field-groups": e.fieldGroups,
          "show-info-alert": ""
        }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
      ]),
      _: 1
    }, 8, ["modelValue", "aria-labelledby"]));
  }
}), qN = ["aria-labelledby"], KN = { class: "flex shrink-0 items-center justify-between gap-4 px-3 pt-4 pb-2" }, JN = { class: "flex items-center gap-2" }, ZN = ["id"], YN = {
  "data-testid": "afp-scroll",
  class: "flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-3 py-2"
}, XN = { class: "flex shrink-0 items-center justify-between gap-3 px-3 pt-2 pb-4" }, CF = /* @__PURE__ */ ge({
  __name: "AdvancedFilterPopover",
  props: {
    open: { type: Boolean },
    anchorEl: {},
    modelValue: {},
    fields: {},
    fieldGroups: {},
    maxDepth: { default: 2 },
    busy: { type: Boolean, default: !1 },
    showSave: { type: Boolean, default: !1 },
    labels: {}
  },
  emits: ["update:open", "update:modelValue", "apply", "reset", "save", "view-all"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n, a = og({
      modelValue: () => r.modelValue,
      fields: () => r.fields,
      busy: () => r.busy,
      labels: () => r.labels,
      emitUpdate: (U) => o("update:modelValue", U),
      emitApply: (U) => o("apply", U),
      emitReset: () => o("reset"),
      emitSave: (U) => o("save", U)
    }), l = Ke(), s = N(null);
    ks({
      active: oo(r, "open"),
      container: s,
      // AC 10 — restore focus to the STABLE "Filtrer" trigger, not whatever had focus when the
      // panel opened: the opening click can come from a transient, self-closing control (e.g.
      // TableFilterSelector's own step-1 "Créer un filtre avancé"/"Voir tous les filtres
      // avancés" items — TableFilterSelector.vue's handleCreateAdvanced/handleViewAdvanced emit
      // then immediately closeDropdown(), unmounting the very button that was just clicked).
      // useFocusTrap's default previousActive-based restore captures that transient node's live
      // reference at open time, but by close time it's detached from the document — `.focus()`
      // on a detached node is a silent no-op, so focus fell back to `<body>`. `anchorEl` is
      // already the stable anchor this popover receives for positioning; reusing it here covers
      // both the direct-anchorEl-click case and the transient-control case identically.
      restoreFocusTo: () => r.anchorEl
    });
    const i = [
      ag,
      '[data-testid="dropdown-menu"]',
      ".datepicker",
      '[data-testid="datepicker-dropdown-menu"]',
      '[role="tooltip"]',
      '[role="dialog"]',
      '[data-testid="modal-backdrop"]'
    ], d = 996, u = 588, f = 8, h = 4, b = N({});
    function m() {
      var M;
      const U = (M = r.anchorEl) == null ? void 0 : M.getBoundingClientRect();
      if (!U) return;
      const W = window.innerWidth, K = window.innerHeight, le = Math.min(d, W - 2 * f), C = U.bottom + h, B = Math.min(
        Math.max(f, U.left),
        Math.max(f, W - le - f)
      ), I = Math.min(u, K - C - f);
      b.value = {
        position: "fixed",
        top: `${C}px`,
        left: `${B}px`,
        width: `${le}px`,
        maxHeight: `${I}px`,
        zIndex: "50"
      };
    }
    function v() {
      window.addEventListener("scroll", m, !0), window.addEventListener("resize", m);
    }
    function x() {
      window.removeEventListener("scroll", m, !0), window.removeEventListener("resize", m);
    }
    let k = r.modelValue;
    we(
      () => r.open,
      (U) => {
        if (U) {
          const W = r.modelValue !== k, K = a.builder.isDirty.value;
          (W || K) && (a.reseedFrom(r.modelValue), k = r.modelValue), Pe(() => {
            m(), v();
          });
        } else
          x();
      },
      { immediate: !0 }
    ), Bt(x);
    const L = N(!1), P = N(null);
    let E = !1;
    function O() {
      if (!a.builder.isDirty.value) {
        F();
        return;
      }
      L.value = !0;
    }
    function R() {
      P.value = () => o("view-all"), O();
    }
    function V(U) {
      P.value = U, O();
    }
    function J() {
      Pe(() => {
        var U;
        return (U = r.anchorEl) == null ? void 0 : U.focus();
      });
    }
    function F() {
      if (L.value = !1, a.builder.reset(), o("update:open", !1), P.value) {
        E = !0;
        const U = P.value;
        P.value = null, U();
      } else
        J();
    }
    function A() {
      L.value = !1, P.value = null;
    }
    function j() {
      if (a.builder.reset(), E) {
        E = !1;
        return;
      }
      J();
    }
    t({ requestCloseThen: V, discard: j });
    function _(U) {
      r.open && (U.stopPropagation(), U.preventDefault(), O());
    }
    return pd(s, O, {
      isActive: () => r.open,
      ignoreSelectors: i
    }), (U, W) => (c(), te(cn, { to: "body" }, [
      e.open ? (c(), p("div", {
        key: 0,
        ref_key: "panelRef",
        ref: s,
        role: "dialog",
        "aria-labelledby": T(l),
        "data-testid": "afp-panel",
        style: Ae(b.value),
        class: "flex flex-col rounded-(--border-border-radius-rounded-l) border border-solid border-border-base-soft bg-white-50-opacity-bold shadow-(--blur-shadow-m) [backdrop-filter:blur(4px)] dark:border-(--colors-border-base) dark:bg-(--colors-background-black-default) dark:shadow-(--blur-shadow-m-dark)",
        onKeydown: je(_, ["escape"])
      }, [
        g("div", KN, [
          g("div", JN, [
            W[1] || (W[1] = g("i", {
              class: "ri-shuffle-line text-lg text-(--colors-text-heading) dark:text-(--colors-text-white-default)",
              "aria-hidden": "true"
            }, null, -1)),
            g("h2", {
              id: T(l),
              "data-testid": "afp-title",
              class: "text-base font-bold text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
            }, $(e.labels.title), 9, ZN)
          ]),
          ae($r, {
            "data-testid": "afp-view-all",
            size: "l",
            onClick: R
          }, {
            default: pe(() => [
              Ze($(e.labels.viewAllFilters), 1)
            ]),
            _: 1
          })
        ]),
        g("div", YN, [
          ae(lg, {
            builder: T(a).builder,
            fields: e.fields,
            labels: e.labels,
            "max-depth": e.maxDepth,
            "field-groups": e.fieldGroups,
            "show-info-alert": !1
          }, null, 8, ["builder", "fields", "labels", "max-depth", "field-groups"])
        ]),
        g("div", XN, [
          ae(sg, {
            labels: e.labels,
            busy: e.busy,
            "show-cancel": !1,
            "show-save": e.showSave,
            "can-save": T(a).canSave.value,
            "save-disabled-reason": T(a).saveDisabledReason.value,
            onReset: T(a).onReset,
            onSave: T(a).onSave,
            onApply: T(a).onApply
          }, null, 8, ["labels", "busy", "show-save", "can-save", "save-disabled-reason", "onReset", "onSave", "onApply"])
        ]),
        L.value ? (c(), te(q6, {
          key: 0,
          "model-value": L.value,
          title: e.labels.confirmCloseTitle,
          message: e.labels.confirmCloseMessage,
          "stay-label": e.labels.confirmCloseStay,
          "leave-label": e.labels.confirmCloseLeave,
          "onUpdate:modelValue": W[0] || (W[0] = (K) => L.value = K),
          onStay: A,
          onLeave: F
        }, null, 8, ["model-value", "title", "message", "stay-label", "leave-label"])) : w("", !0)
      ], 44, qN)) : w("", !0)
    ]));
  }
}), SF = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Indigo.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Indigo.50}",
  "Background-background-disabled-strong": "{Colors.Gray.300}",
  "Background-background-disabled": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.100}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.600}",
  "Text-text-disabled-strong": "{Colors.Gray.500}",
  "Text-text-disabled-light": "{Colors.Gray.400}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Indigo.700}",
  "Text-Text-hover": "{Colors.Indigo.500}",
  "Text-Text-info": "{Colors.Indigo.600}",
  "Text-Text-accent": "{Colors.Indigo.600}",
  "Icons-icon-black": "{black}",
  "Icons-icon-white": "{white}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.100}",
  "Icons-icon-disabled-strong": "{Colors.Gray.500}",
  "Icons-icon-disabled-light": "{Colors.Gray.400}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-link": "{Colors.Indigo.700}",
  "Icons-icon-success": "{Colors.Success.600}",
  "Icons-icon-success-subtle": "{Colors.Success.500}",
  "Icons-icon-warning": "{Colors.Warning.600}",
  "Icons-icon-error": "{Colors.Error.700}",
  "Icons-icon-info": "{Colors.Indigo.600}",
  "Icons-icon-hover": "{Colors.Indigo.500}",
  "Icons-icon-accent": "{Colors.Indigo.600}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.600}",
  "Components-Button-button-disabled": "{Colors.Gray.200-opacity-bold}",
  "Components-Button-Primary-button-primary": "{Colors.Primary.800-base}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{white}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.400}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.50}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Indigo.50}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.100}",
  "Components-Button-Tab-button-tab": "{white}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{white}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.50}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.700}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.800}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.800}",
  "Components-Button-Functional-Desctructive error-button-error": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-button-error-hover": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-button-error-focused": "{Colors.Error.900}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.600}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.900}",
  "Components-Badges-Background-badge-disabled-bg": "{Colors.Gray.300}",
  "Components-Badges-Background-badge-gray-bg": "{Colors.Gray.500}",
  "Components-Badges-Background-badge-error-bg": "{Colors.Error.100}",
  "Components-Badges-Background-badge-error-strong-bg": "{Colors.Error.500}",
  "Components-Badges-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badges-Background-badge-orange-strong-bg": "{Colors.Warning.500}",
  "Components-Badges-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badges-Background-badge-yellow-strong-bg": "{Colors.Yellow.300}",
  "Components-Badges-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badges-Background-badge-green-strong-bg": "{Colors.Success.500}",
  "Components-Badges-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badges-Background-badge-indigo-medium-bg": "{Colors.Indigo.300}",
  "Components-Badges-Background-badge-indigo-strong-bg": "{Colors.Indigo.600}",
  "Components-Badges-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badges-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badges-Background-badge-violet-strong-bg": "{Colors.Violet.400}",
  "Components-Badges-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badges-Background-badge-purple-strong-bg": "{Colors.Purple.400}",
  "Components-Badges-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badges-Background-badge-neutral-strong-bg": "{Colors.Neutral.400}",
  "Components-Badges-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badges-Background-badge-cyan-strong-bg": "{Colors.Cyan.500}",
  "Components-Badges-Background-badge-white-bg": "{white}",
  "Components-Badges-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badges-Icon-badge-disabled-icon": "{Colors.Gray.500}",
  "Components-Badges-Icon-badge-indigo-icon": "{Colors.Indigo.700}",
  "Components-Badges-Icon-badge-black-icon": "{black}",
  "Components-Badges-Icon-badge-white-icon": "{white}",
  "Components-Badges-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badges-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badges-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badges-Text-badge-disabled-strong-text": "{Colors.Gray.500}",
  "Components-Badges-Text-badge-indigo-text": "{Colors.Indigo.700}",
  "Components-Badges-Text-badge-white-bg": "{white}",
  "Components-Badges-Text-badge-white-default-text": "{Colors.Neutral.050}",
  "Components-Badges-Text-badge-black": "{black}",
  "Components-Badges-Text-badge-black-default-text": "{Colors.Primary.800-base}",
  "Components-Badges-Text-badge-body-text": "{Colors.Gray.700}",
  "Components-Badges-Border-badge-disabled-border": "{Colors.Gray.300}",
  "Components-Badges-Border-badge-indigo-border": "{Colors.Indigo.400}",
  "Components-Badges-Border-badge-white-border": "{white}",
  "Components-Badges-Border-badge-white-default-border": "{Colors.Neutral.400}",
  "Components-Badges-Border-badge-base-soft-border": "{Colors.Gray.200}",
  "Components-Badges-Border-badge-black-border": "{black}",
  "Components-Badges-Border-badge-dark-default-border": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.100}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.500}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.700}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-icon": "{Colors.Indigo.600}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.600}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.600}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.500}",
  "Components-Icon shape-Icon-iconshape-green-icon 2": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.600}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.500}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.600}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-cyan-icon": "{Colors.Cyan.500}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Indigo.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.300}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.500}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-primary-button-hover 2": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.400}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.400}",
  "Border-border-accent": "{Colors.Indigo.400}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Indigo.400}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info": "{Colors.Indigo.400}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.600}",
  "Border-border-success": "{Colors.Success.400}",
  "Border-border-success-sublte": "{Colors.Success.200}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.600}",
  "Border-border-error-subtle": "{Colors.Error.200}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, $F = {
  "Background-background-black-default": "{Colors.Primary.800-base}",
  "Background-background-white": "{white}",
  "Background-background-white-secondary": "{Colors.Neutral.100}",
  "Background-background-white-secondary-soft": "{Colors.Neutral.050}",
  "Background-background-white-tertiary": "{Colors.Gray.100}",
  "Background-background-selected": "{Colors.Gray.050}",
  "Background-background-info": "{Colors.Indigo.50}",
  "Background-background-success": "{Colors.Success.50}",
  "Background-background-warning": "{Colors.Warning.50}",
  "Background-background-error": "{Colors.Error.50}",
  "Background-background-hover": "{Colors.Indigo.50}",
  "Background-background-accent": "{Colors.Indigo.50}",
  "Background-background-disabled-strong": "{Colors.Gray.400}",
  "Background-background-disabled": "{Colors.Gray.200-opacity-medium}",
  "Background-background-disabled-subtle": "{Colors.Gray.050}",
  "Background-background-gray": "{Colors.Gray.200}",
  "Background-background-ia": "{Colors.Purple.50}",
  "Text-text-white-default": "{Colors.Neutral.050}",
  "Text-text-white-secondary": "{Colors.Neutral.050}",
  "Text-text-black-default": "{Colors.Primary.800-base}",
  "Text-text-heading": "{Colors.Primary.800-base}",
  "Text-text-body": "{Colors.Gray.700}",
  "Text-text-body-subtle": "{Colors.Gray.600}",
  "Text-text-disabled-strong": "{Colors.Gray.500}",
  "Text-text-disabled-light": "{Colors.Gray.300}",
  "Text-text-success-strong": "{Colors.Success.700}",
  "Text-text-success": "{Colors.Success.600}",
  "Text-text-success-subtle": "{Colors.Success.500}",
  "Text-text-warning": "{Colors.Warning.600}",
  "Text-Text-error-strong": "{Colors.Error.700}",
  "Text-Text-error": "{Colors.Error.600}",
  "Text-Text-error-subtle": "{Colors.Error.500}",
  "Text-Text-link": "{Colors.Indigo.400}",
  "Text-Text-hover": "{Colors.Indigo.500}",
  "Text-Text-info": "{Colors.Indigo.600}",
  "Text-Text-accent": "{Colors.Indigo.500}",
  "Icons-icon-black": "{Colors.Primary.800-base}",
  "Icons-icon-white": "{Colors.Primary.800-base}",
  "Icons-icon-dark-default": "{Colors.Primary.800-base}",
  "Icons-icon-white-default": "{Colors.Neutral.050}",
  "Icons-icon-disabled-strong": "{Colors.Gray.500}",
  "Icons-icon-disabled-light": "{Colors.Gray.300}",
  "Icons-icon-base": "{Colors.Gray.500}",
  "Icons-icon-link": "{Colors.Indigo.400}",
  "Icons-icon-success": "{Colors.Success.400}",
  "Icons-icon-success-subtle": "{Colors.Success.500}",
  "Icons-icon-warning": "{Colors.Warning.300}",
  "Icons-icon-error": "{Colors.Error.500}",
  "Icons-icon-info": "{Colors.Indigo.400}",
  "Icons-icon-hover": "{Colors.Indigo.500}",
  "Icons-icon-accent": "{Colors.Indigo.500}",
  "Icons-icon-ia": "{Colors.Purple.600}",
  "Icons-icon-cyan": "{Colors.Cyan.600}",
  "Components-Button-button-disabled": "{Colors.Gray.200-opacity-bold}",
  "Components-Button-Primary-button-primary": "{Colors.Black opacity.50-opacity-bold}",
  "Components-Button-Primary-button-primary-hover": "{Colors.Gray.500}",
  "Components-Button-Secondary-button-secondary": "{Colors.Neutral.050}",
  "Components-Button-Secondary-button-secondary-hover": "{Colors.Primary.800-opacity-bold}",
  "Components-Button-Secondary-button-secondary-focused": "{Colors.Indigo.500}",
  "Components-Button-Tertiary-button-tertiary-hover": "{Colors.Indigo.500}",
  "Components-Button-Tertiary-button-tertiary-focused": "{Colors.Black opacity.50-opacity-bold}",
  "Components-Button-Tab-button-tab-default": "{Colors.Gray.200-opacity-medium}",
  "Components-Button-Tab-button-tab": "{Colors.Neutral.050}",
  "Components-Button-Tab-button-tab-hover": "{Colors.Indigo.400}",
  "Components-Button-Tab-button-tab-active": "{Colors.Gray.050}",
  "Components-Button-Text-button-text": "{Colors.Primary.800-base}",
  "Components-Button-Text-button-text-hover": "{Colors.Indigo.700}",
  "Components-Button-Ghost-button-ghost-hover": "{Colors.Indigo.400}",
  "Components-Button-Functional-Success-button-success": "{Colors.Success.200}",
  "Components-Button-Functional-Success-button-success-hover": "{Colors.Success.500}",
  "Components-Button-Functional-Success-button-success-focused": "{Colors.Success.600}",
  "Components-Button-Functional-Desctructive error-button-error": "{Colors.Error.500}",
  "Components-Button-Functional-Desctructive error-button-error-hover": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-button-error-focused": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-icon": "{Colors.Error.500}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-hover-icon": "{Colors.Error.700}",
  "Components-Button-Functional-Desctructive error-Icons-button-error-focused-icon": "{Colors.Error.700}",
  "Components-Badges-Background-badge-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badges-Background-badge-gray-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Badges-Background-badge-error-bg": "{Colors.Error.100}",
  "Components-Badges-Background-badge-error-strong-bg": "{Colors.Error.100}",
  "Components-Badges-Background-badge-orange-bg": "{Colors.Warning.100}",
  "Components-Badges-Background-badge-orange-strong-bg": "{Colors.Warning.100}",
  "Components-Badges-Background-badge-yellow-bg": "{Colors.Yellow.100}",
  "Components-Badges-Background-badge-yellow-strong-bg": "{Colors.Yellow.100}",
  "Components-Badges-Background-badge-green-bg": "{Colors.Success.100}",
  "Components-Badges-Background-badge-green-strong-bg": "{Colors.Success.100}",
  "Components-Badges-Background-badge-indigo-soft-bg": "{Colors.Indigo.100}",
  "Components-Badges-Background-badge-indigo-medium-bg": "{Colors.Indigo.100}",
  "Components-Badges-Background-badge-indigo-strong-bg": "{Colors.Indigo.500}",
  "Components-Badges-Background-badge-accent-bg": "{Colors.Indigo.80-opacity}",
  "Components-Badges-Background-badge-violet-bg": "{Colors.Violet.200}",
  "Components-Badges-Background-badge-violet-strong-bg": "{Colors.Violet.200}",
  "Components-Badges-Background-badge-purple-bg": "{Colors.Purple.100}",
  "Components-Badges-Background-badge-purple-strong-bg": "{Colors.Purple.100}",
  "Components-Badges-Background-badge-neutral-bg": "{Colors.Neutral.200}",
  "Components-Badges-Background-badge-neutral-strong-bg": "{Colors.Neutral.200}",
  "Components-Badges-Background-badge-cyan-bg": "{Colors.Cyan.100}",
  "Components-Badges-Background-badge-cyan-strong-bg": "{Colors.Cyan.100}",
  "Components-Badges-Background-badge-white-bg": "{white}",
  "Components-Badges-Background-badge-dark-bg": "{Colors.Neutral.700}",
  "Components-Badges-Icon-badge-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Badges-Icon-badge-indigo-icon": "{Colors.Indigo.100}",
  "Components-Badges-Icon-badge-black-icon": "{black}",
  "Components-Badges-Icon-badge-white-icon": "{white}",
  "Components-Badges-Icon-badge-white-default-icon": "{Colors.Neutral.100}",
  "Components-Badges-Icon-badge-dark-icon": "{Colors.Neutral.700}",
  "Components-Badges-Icon-badge-black-default-icon": "{Colors.Primary.800-base}",
  "Components-Badges-Text-badge-disabled-strong-text": "{Colors.Gray.200-opacity-medium}",
  "Components-Badges-Text-badge-indigo-text": "{Colors.Indigo.100}",
  "Components-Badges-Text-badge-white-bg": "{white}",
  "Components-Badges-Text-badge-white-default-text": "{white}",
  "Components-Badges-Text-badge-black": "{Colors.Neutral.700}",
  "Components-Badges-Text-badge-black-default-text": "{Colors.Neutral.700}",
  "Components-Badges-Text-badge-body-text": "{Colors.Neutral.700}",
  "Components-Badges-Border-badge-disabled-border": "{Colors.Gray.200-opacity-medium}",
  "Components-Badges-Border-badge-indigo-border": "{Colors.Indigo.100}",
  "Components-Badges-Border-badge-white-border": "{white}",
  "Components-Badges-Border-badge-white-default-border": "{white}",
  "Components-Badges-Border-badge-base-soft-border": "{white}",
  "Components-Badges-Border-badge-black-border": "{Colors.Neutral.700}",
  "Components-Badges-Border-badge-dark-default-border": "{Colors.Neutral.700}",
  "Components-Icon shape-Background-iconshape-disabled-bg": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Background-iconshape-red-bg": "{Colors.Error.100}",
  "Components-Icon shape-Background-iconshape-orange-bg": "{Colors.Warning.100}",
  "Components-Icon shape-Background-iconshape-yellow-bg": "{Colors.Yellow.100}",
  "Components-Icon shape-Background-iconshape-green-bg": "{Colors.Success.100}",
  "Components-Icon shape-Background-iconshape-indigo-bg": "{Colors.Indigo.100}",
  "Components-Icon shape-Background-iconshape-violet-bg": "{Colors.Violet.100}",
  "Components-Icon shape-Background-iconshape-purple-bg": "{Colors.Purple.100}",
  "Components-Icon shape-Background-iconshape-neutral-bg": "{Colors.Neutral.200}",
  "Components-Icon shape-Background-iconshape-cyan-bg": "{Colors.Cyan.100}",
  "Components-Icon shape-Background-iconshape-black-bg": "{black}",
  "Components-Icon shape-Background-iconshape-black-default-bg": "{Colors.Primary.800-base}",
  "Components-Icon shape-Background-iconshape-white-bg": "{white}",
  "Components-Icon shape-Background-iconshape-success-bg": "{Colors.Success.600}",
  "Components-Icon shape-Background-iconshape-error-bg": "{Colors.Error.500}",
  "Components-Icon shape-Background-iconshape-accent-bg": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-black-icon": "{black}",
  "Components-Icon shape-Icon-iconshape-white-icon": "{white}",
  "Components-Icon shape-Icon-iconshape-white-default-icon": "{Colors.Neutral.100}",
  "Components-Icon shape-Icon-iconshape-disabled-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-disabled-strong-icon": "{Colors.Gray.200-opacity-medium}",
  "Components-Icon shape-Icon-iconshape-success-icon": "{Colors.Success.600}",
  "Components-Icon shape-Icon-iconshape-red-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-error-icon": "{Colors.Error.500}",
  "Components-Icon shape-Icon-iconshape-brand-icon": "{Colors.Primary.800-base}",
  "Components-Icon shape-Icon-iconshape-accent-icon": "{Colors.Indigo.50}",
  "Components-Icon shape-Icon-iconshape-orange-icon": "{Colors.Warning.100}",
  "Components-Icon shape-Icon-iconshape-yellow-icon": "{Colors.Yellow.100}",
  "Components-Icon shape-Icon-iconshape-green-icon": "{Colors.Success.100}",
  "Components-Icon shape-Icon-iconshape-green-icon 2": "{Colors.Success.100}",
  "Components-Icon shape-Icon-iconshape-indigo-icon": "{Colors.Indigo.100}",
  "Components-Icon shape-Icon-iconshape-violet-icon": "{Colors.Violet.100}",
  "Components-Icon shape-Icon-iconshape-purple-icon": "{Colors.Purple.100}",
  "Components-Icon shape-Icon-iconshape-neutral-icon": "{Colors.Neutral.200}",
  "Components-Icon shape-Icon-iconshape-cyan-icon": "{Colors.Cyan.100}",
  "Components-Icon shape-Border-iconshape-disabled-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-default-border": "{Colors.Gray.300}",
  "Components-Icon shape-Border-iconshape-accent-border": "{Colors.Indigo.400}",
  "Border-border-black-default": "{Colors.Primary.800-base}",
  "Border-border-white-default": "{Colors.Neutral.400}",
  "Border-border-base": "{Colors.Gray.500}",
  "Border-border-base-medium": "{Colors.Gray.300}",
  "Border-border-base-soft": "{Colors.Gray.200}",
  "Border-border-disabled": "{Colors.Gray.200}",
  "Border-border-disabled-subtle": "{Colors.Gray.200}",
  "Border-border-primary-button": "{Colors.Gray.500}",
  "Border-border-primary-button-hover": "{Colors.Indigo.100}",
  "Border-border-primary-button-hover 2": "{Colors.Indigo.100}",
  "Border-border-secondary-button": "{Colors.Neutral.300}",
  "Border-border-secondary-button-hover": "{Colors.Indigo.400}",
  "Border-border-secondary-button-focus": "{Colors.Cyan.500}",
  "Border-border-tertiary-hover": "{Colors.White opacity.50-opacity-medium}",
  "Border-border-tab": "{white}",
  "Border-border-tab-hover": "{Colors.Indigo.400}",
  "Border-border-tab-hover 2": "{Colors.Indigo.400}",
  "Border-border-accent": "{Colors.Indigo.500}",
  "Border-border-accent-subtle": "{Colors.Indigo.200}",
  "Border-border-hover": "{Colors.Indigo.400}",
  "Border-border-info-strong": "{Colors.Indigo.700}",
  "Border-border-info": "{Colors.Indigo.400}",
  "Border-border-info-subtle": "{Colors.Indigo.200}",
  "Border-border-success-strong": "{Colors.Success.600}",
  "Border-border-success": "{Colors.Success.400}",
  "Border-border-success-sublte": "{Colors.Success.200}",
  "Border-border-error-strong": "{Colors.Error.700}",
  "Border-border-error": "{Colors.Error.500}",
  "Border-border-error-subtle": "{Colors.Error.300}",
  "Border-border-warning": "{Colors.Warning.500}",
  "Border-border-warning-subtle": "{Colors.Warning.200}",
  "Border-border-ia": "{Colors.Purple.200}",
  "Border-border-accessibility": "{Colors.Neutral.400}",
  "Border-border-white-full": "{white}"
}, IF = {
  "spacing-0": "{number.0}",
  "spacing-1": "{number.1}",
  "spacing-2": "{number.2}",
  "spacing-3": "{number.3}",
  "spacing-4": "{number.4}",
  "spacing-5": "{number.5}",
  "spacing-6": "{number.6}",
  "spacing-8": "{number.8}",
  "spacing-10": "{number.10}",
  "spacing-12": "{number.12}",
  "spacing-14": "{number.14}",
  "spacing-16": "{number.16}",
  "spacing-20": "{number.20}",
  "spacing-24": "{number.24}",
  "spacing-px": "{number.px}",
  "spacing-0.5": "{number.0.5}",
  "spacing-1.5": "{number.1.5}",
  "spacing-3.5": "{number.3.5}",
  "border-border-radius-rounded-0": "{border.border-radius.rounded-0}",
  "border-border-radius-rounded-xxs": "{border.border-radius.rounded-sm}",
  "border-border-radius-rounded-xs": "{border.border-radius.rounded}",
  "border-border-radius-rounded-sm": "{border.border-radius.rounded-lg}",
  "border-border-radius-rounded-l": "{border.border-radius.rounded-xl}",
  "border-border-radius-rounded-base": "{border.border-radius.rounded-3xl}",
  "border-border-radius-rounded-xl": "{border.border-radius.rounded-4xl}",
  "border-border-radius-rounded-xxl": "{border.border-radius.rounded-5xl}",
  "border-border-radius-rounded-full": "{border.border-radius.rounded-full}",
  "border-border-width-border-0": "{border.border-width.border-0}",
  "border-border-width-border": "{border.border-width.border}",
  "border-border-width-border-md": "{border.border-width.border-2}",
  "border-border-width-border-lg": "{border.border-width.border-4}",
  "border-border-width-border-xl": "{border.border-width.border-8}",
  "border-border-width-border-xl 2": "{border.border-width.border-8}",
  "border-border-width-border-xl 3": "{border.border-width.border-8}"
}, TF = {
  "Family-heading": "inter",
  "Family-text": "inter",
  "Size-xs": 10,
  "Size-sm": 12,
  "Size-m": 14,
  "Size-l": 16,
  "Size-xl": 18,
  "Size-xxl": 20,
  "Size-3xl": 22,
  "Size-4xl": 24,
  "Size-5xl": 28,
  "Size-6xl": 36,
  "Size-7xl": 40,
  "Size-8xl": 48,
  "Size-9xl": 52,
  "Weight-thin": 100,
  "Weight-extra-light": 200,
  "Weight-light": 300,
  "Weight-regular": 400,
  "Weight-medium": 500,
  "Weight-semi-bold": 600,
  "Weight-bold": 700,
  "Weight-extra-bold": 800,
  "Weight-black": 900,
  "Line-height-xs": 12,
  "Line-height-s": 14,
  "Line-height-m": 18,
  "Line-height-l": 20,
  "Line-height-xl": 22,
  "Line-height-xxl": 24,
  "Line-height-3xl": 26,
  "Line-height-4xl": 29,
  "Line-height-5xl": 34,
  "Line-height-6xl": 43,
  "Letter-spacing-Letter-spacing": 0,
  "Letter-case-case-original": "none",
  "Letter-case-case-upper": "uppercase",
  "Letter-case-case-lower": "lowercase",
  "Letter-case-case-title": "capitalize",
  "Letter-case-case-smallcaps": "smallcaps"
}, LF = {
  "Grid-grid-columns-l": "{number.2}",
  "Grid-grid-columns-m": "{number.1}",
  "Grid-grid-columns-xs": "{number.px}",
  "Grid-margin-4xl": "{number.24}",
  "Grid-margin-l": "{number.24}",
  "Grid-gutter": "{number.5}",
  "Grid-Sidebar-sidebar-open": 317,
  "Grid-Sidebar-sidebar-close": 158,
  "Grid-Sidebar-sidebar-toolbox": 279,
  "Grid-Container-cont-size": 1563,
  "Grid-Container-cont-size-navclosed": 1762,
  "Grid-Container-cont-size-toolbox": 1664,
  "Grid-Navbar-navbar-size": 1601,
  "Grid-Navbar-navbarclosed-size": 1762,
  "Breakpoints-width-XL": 1440,
  "Breakpoints-width-XXL": 1920
};
export {
  Df as ACCORDION_CONTEXT_KEY,
  _N as Accordion,
  eV as AccordionItem,
  lg as AdvancedFilterBody,
  wF as AdvancedFilterBuilder,
  sg as AdvancedFilterFooter,
  CF as AdvancedFilterPopover,
  as as Alert,
  mV as AutoComplete,
  vV as AutoCompleteAllResultsModal,
  Cn as Avatar,
  D3 as AvatarGroup,
  pt as Badge,
  $e as Button,
  ou as ButtonGroup,
  $r as ButtonLink,
  tF as Card,
  nF as CardSelectable,
  Xt as Checkbox,
  oV as CheckboxForm,
  UL as CollapsibleSearch,
  fF as CollapsibleSection,
  KV as ConfirmDeleteModal,
  HN as CriteriaGroup,
  uF as CtaWidget,
  of as DEFAULT_COUNTRY,
  Xr as DEFAULT_PHONE_FORMAT,
  Hp as DEFAULT_TABLE_LABELS,
  XV as DataTable,
  Q6 as DataTableBody,
  JV as DataTableCaption,
  Xi as DataTableCell,
  X6 as DataTableContainer,
  ZV as DataTableEmpty,
  YV as DataTableFooter,
  cP as DataTableHead,
  fP as DataTableHeader,
  il as DataTableRow,
  eF as DataTableWrapper,
  FV as DateGroupHeader,
  Yi as DatePickerInput,
  c3 as DateRangePickerInput,
  Qo as DatepickerCell,
  IT as DatepickerControls,
  CT as DatepickerDobPicker,
  Rp as DatepickerDropdownMenu,
  Ap as DatepickerPanel,
  oF as DetailHeaderWrapper,
  qA as DraggableListItem,
  IA as Drawer,
  kn as Dropdown,
  Hr as DropdownItemButton,
  GV as DynamicFormField,
  EA as EditableTitle,
  JI as EmailInput,
  ag as FILTER_FIELD_SELECT_PANEL_SELECTOR,
  _o as FROZEN_COLUMN_LIMIT,
  MD as FacetedSearchDrawer,
  zz as FieldSkeleton,
  gk as FileUploadInput,
  au as FilterDropdown,
  LN as FilterFieldSelect,
  jE as FilterPill,
  vF as FloatActionBar,
  UV as FormErrorSummary,
  qV as FormSaveButton,
  yF as FormSkeleton,
  vn as IconShape,
  aV as ImageInput,
  hV as ImageUploadInput,
  lF as InlineLink,
  HV as InteractionListItem,
  VV as List,
  jA as ListItemCard,
  SV as MainDrawer,
  fV as MaskedInput,
  aF as Masonry,
  WV as MeetingListItem,
  nx as MetricCardAction,
  Is as MetricCardProgress,
  rv as MetricCardSimple,
  Sv as MetricCardWithBadge,
  zv as MetricCardWithChart,
  uv as MetricCardWithIcon,
  vv as MetricCardWithTrend,
  nV as MetricCardsDemo,
  Ta as Modal,
  gV as MultipleSelect,
  pF as NavTabs,
  zV as Navbar,
  Lu as NumberInput,
  zp as NumberRangeInput,
  xn as PHONE_FORMATS,
  XI as PHONE_FORMATS_BY_DIAL_CODE,
  rF as PageHeader,
  wV as Pager,
  aE as Pagination,
  cV as PhoneDisplay,
  $4 as PhoneInput,
  cF as Popover,
  hF as ProfileCard,
  W0 as RadioButton,
  rV as RadioForm,
  RV as RecordsTable,
  iV as RichTextEditor,
  Rr as SearchInput,
  PV as SecondarySidebar,
  mF as SegmentedPager,
  el as SelectInput,
  OV as Sidebar,
  kV as SortDropdown,
  NV as SpeedDial,
  kF as StepperNavigation,
  gF as StepperWizardSidenav,
  xE as TABLE_COLUMN_SETTINGS_KEY,
  Fp as TABLE_LABELS_KEY,
  Vp as TABLE_PERMISSIONS_KEY,
  ko as TABLE_QUERY_KEY,
  ws as TABLE_VIEWS_KEY,
  BV as Table,
  jp as TableControls,
  Up as TableFilterBar,
  DV as TableFilterSelector,
  TV as TableHeader,
  RR as TablePanel,
  IV as TableShell,
  KE as TableSkeleton,
  Wp as TableTopbar,
  JL as TagInput,
  er as TextInput,
  lV as Textarea,
  xV as TimePickerInput,
  bF as Timeline,
  jV as ToastContainer,
  L6 as ToastItem,
  yV as ToggleInput,
  zL as ToggleSwitch,
  Ye as Tooltip,
  Eo as TruncatedText,
  q6 as UnsavedChangesModal,
  pV as UrlInput,
  tV as WeekNavigator,
  iF as WidgetBlock,
  dF as WidgetSection,
  sF as WidgetShell,
  bV as YearMonthPickerInput,
  $F as colorsDark,
  SF as colorsLight,
  QV as createPhoneValidator,
  Ip as datePatternFromFormat,
  Lp as deleteAcrossSeparator,
  ZI as digitMaskFromPattern,
  ga as formatGroupedDigits,
  QI as formatPhoneForDisplay,
  Ki as groupMaskFromPlaceholder,
  To as groupPreservingTrunkZero,
  uu as isDraftGroup,
  tg as isGroupNode,
  cu as isMultiValue,
  va as isValueless,
  CV as mapApiPaginated,
  rf as maskGroupedInput,
  Tp as maskLiveInput,
  Cf as parse,
  LF as semanticBreakpoints,
  IF as semanticSpacing,
  TF as semanticTypography,
  Ya as serialize,
  tu as significantDigitCount,
  af as stripTrunkZero,
  uV as toE164,
  og as useAdvancedFilterActions,
  AV as useColumnSettings,
  fN as useCriteriaBuilder,
  p8 as useDirtyState,
  $V as useDrawer,
  wa as useDropdown,
  xF as useFloatActionBarActions,
  ks as useFocusTrap,
  _V as useForm,
  b8 as useFormSubmit,
  h8 as useFormValidation,
  ht as useHasSlot,
  lu as useListRowSurface,
  g8 as useMediaQuery,
  EV as useResponsivePageSize,
  cl as useRovingListbox,
  nM as useSortable,
  Cs as useTableLabels,
  LV as useTableQuery,
  MV as useTableViews,
  h6 as useToast,
  Op as useTruncationDetector,
  dV as withHeuristicTrunkZero
};
